module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'πρέσα λιθογραφίας',
        classes: 'lith_tooltip'
      }),
      expression: "{ content: 'πρέσα λιθογραφίας', classes: 'lith_tooltip' }"
    }],
    class: _vm.litho_class,
    attrs: {
      "id": "pagos_lithografia"
    },
    on: {
      "mouseenter": _vm.startAnimation
    }
  }, [_c('g', {
    attrs: {
      "id": "l_back"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "101.7",
      "y": "597.2",
      "width": "348.4",
      "height": "11.34"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-8",
    attrs: {
      "x": "101.7",
      "y": "599.5",
      "width": "348.4",
      "height": "28.74"
    }
  })]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "468.6 781.4 464.1 784.3 464.1 549.1 468.6 549.1 468.6 781.4"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-8",
    attrs: {
      "x": "443.7",
      "y": "549.1",
      "width": "20.5",
      "height": "219.03"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-8",
    attrs: {
      "points": "464.2 784.4 453.5 784.4 443.7 767.9 464.2 767.9 464.2 784.4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-24",
    attrs: {
      "cx": "454.9",
      "cy": "766.2",
      "r": "4.9"
    }
  })]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-65",
    attrs: {
      "points": "478.3 551.1 464.7 551.1 402.7 584.4 420.9 592.1"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-8",
    attrs: {
      "points": "33.8 644.3 104.5 606.7 104.5 629.4 33.8 669.7"
    }
  }), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "cls-24",
    attrs: {
      "points": "104.3 793.5 109.8 790.4 118.6 774 113 774.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "114 777.1 118.5 774.1 118.5 566.4 114 566.4 114 777.1"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "93.5",
      "y": "566.4",
      "width": "20.5",
      "height": "210.98"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "93.5 793.6 104.3 793.6 114 777.2 93.5 777.2 93.5 793.6"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-24",
    attrs: {
      "cx": "102.8",
      "cy": "775.4",
      "r": "4.9"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "cls-24",
    attrs: {
      "points": "104.3 793.5 109.8 790.4 118.6 774 113 774.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "114 777.1 118.5 773.6 118.5 542.5 114 542.5 114 777.1"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-8",
    attrs: {
      "x": "93.5",
      "y": "542.5",
      "width": "20.5",
      "height": "234.89"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-8",
    attrs: {
      "points": "93.5 793.6 104.3 793.6 114 777.2 93.5 777.2 93.5 793.6"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-24",
    attrs: {
      "cx": "102.8",
      "cy": "775.4",
      "r": "4.9"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "81.7",
      "y": "526.2",
      "width": "407",
      "height": "25.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "488.6 526.4 81.7 526.4 90 521.8 496.6 521.8 488.6 526.4"
    }
  })]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "27.2 587.6 93.9 551.7 98.5 551.8 34.3 587.5 27.2 587.6"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-24",
    attrs: {
      "points": "34.4 587.5 34.4 598.1 98.6 564 98.5 551.8"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-69",
    attrs: {
      "x": "27.2",
      "y": "587.6",
      "width": "7.2",
      "height": "10.49"
    }
  })]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-67",
    attrs: {
      "points": "404.8 646 465 606.7 465 629.4 406.6 670.5"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-24",
    attrs: {
      "points": "404.5 624.6 491.8 572 491.9 541.4 408.1 589.3"
    }
  }), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "253.4 442.1 231.5 447.4 231.5 527.3 253.4 530.5 253.4 442.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "256.9 447.4 252.8 447.4 252.8 526.6 256.9 521.6 256.9 447.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "298.9 446.9 277.8 446.9 277.8 526.5 298.9 528.7 298.9 446.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "303.2 445.9 298.9 447.2 298.9 526.6 303.3 522.4 303.2 445.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "289 429.8 241.2 429.8 231.5 447.4 298.8 447.4 289 429.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "289 429.8 298.9 447.6 303.2 445.9 292.5 427.8 289 429.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "241.2 429.8 289 429.8 292.5 427.8 244.6 427.8 241.2 429.8"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "496.6 521.8 496.4 547 488.8 552.2 488.8 526.5 496.6 521.8"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_surface"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-89",
    attrs: {
      "cx": "420.2",
      "cy": "584.5",
      "r": "8.5"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-89",
    attrs: {
      "points": "495.2 549.2 425 592.2 416.8 583.6 424.4 569.2 490 536.5 494.3 542.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-214",
    attrs: {
      "points": "494.3 542.3 424.2 584.3 416.8 583.6 424.4 569.2 490 536.5 494.3 542.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-164",
    attrs: {
      "points": "490 536.5 210.7 536 138.9 577 423.3 577.3 490 536.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "409.9 562.1 476.3 524.8 482.4 524.8 417 562 409.9 562.1"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-24",
    attrs: {
      "points": "417.1 562 417.1 572.6 482.4 535.1 482.4 524.9"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-69",
    attrs: {
      "x": "409.9",
      "y": "562.1",
      "width": "7.2",
      "height": "10.49"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "143 562.1 209.4 524.8 215.5 524.8 150.1 562 143 562.1"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-24",
    attrs: {
      "points": "150.2 562 150.2 572.6 215.5 535.1 215.5 524.9"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-69",
    attrs: {
      "x": "143",
      "y": "562.1",
      "width": "7.2",
      "height": "10.49"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-215",
    attrs: {
      "points": "430.7 588 429.7 596.2 494.6 556.5 495.2 549.2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-24",
    attrs: {
      "cx": "409.3",
      "cy": "594.5",
      "r": "4.6"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-215",
    attrs: {
      "x": "137.8",
      "y": "577.2",
      "width": "293",
      "height": "19.16",
      "rx": "1.9",
      "ry": "1.9"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-214",
    attrs: {
      "points": "423.3 577.3 426.8 583.1 434 579.3 434.5 573.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-89",
    attrs: {
      "points": "426.8 583.1 427.6 589.9 434.9 585.5 435.3 577.7"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_stone"
    }
  }, [_c('g', [_c('path', {
    staticClass: "cls-15",
    attrs: {
      "d": "M298.4,562.7H388l27.3-18.9,7-7.7-.7-21H336.9s-50.4,21-49,23.8,0,18.2,0,18.2l4.2,5.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-216",
    attrs: {
      "d": "M298.4,562.7H388l34.3-26.6-.7-21-39.9,24.5-87.5.7s-7.7-4.2-6.3-1.4,0,18.2,0,18.2l4.2,5.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-163",
    attrs: {
      "d": "M384,555.1l4,7.5,27.3-18.9,7-7.7,1.5-7.5-.8-6.2-1.4-7.3-39.9,24.5h0c-1.5,2.8,1,7.5,1,7.5v6"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-217"
  }, [_c('g', {
    staticClass: "cls-218"
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-219",
    attrs: {
      "d": "M285.4,499.2l-3.7,6.4-1.6,10.1.8,9.3v3.9l-.4,6.8.4,7.8.2,8.9s-1,6-.6,8.6,1.9,10.5,1.9,11.3-.4,11.9-.4,11.9l1.2,6.8,2.9,3.7,8.5,1.8h7.4l9.3-.6,12.1.2h15l8.8-.8h24.4l11.4.8s6.6-1.2,7.4-1.2l14,1.2s6.8.4,7.6,0,8.4-1.6,8.4-1.6l5.2-6.5-1-2.5.4-6.2v-7a50.4,50.4,0,0,0,.4-5.6c0-2.5-1.6-8-1.6-10.3s.6-7,.6-7l.2-8.6V529.4l.8-3.9v-3.1a41.3,41.3,0,0,0-.8-4.9,6.4,6.4,0,0,1,.2-2.3v-7.8l-.8-2.7-2.1-1.6s-.2-1.2-.8-1.4a11.9,11.9,0,0,1-1.9-1l-5.6-2.5-3.5.2h-2.5l-5.7.6H389l-2.3.4h-5.1L375,498c-.6-.2-7.1.2-7.1.2l-5.6.2-3.7.8-8.6,1-3.5-.4-6.6-.6L329.8,498l-4.3,1c-.6.2-4.7.6-4.7.6l-7-.6h-1.6l-2.5-.2h-4.1l-4.9-.6-3.9,1.2-4.1-1.2-2-5.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-220",
    attrs: {
      "d": "M424.5,585.6l.4-6.2v-7a50.4,50.4,0,0,0,.4-5.6c0-2.5-1.6-8-1.6-10.3s.6-7,.6-7l.2-8.6V529.4l.8-3.9v-3.1a41.3,41.3,0,0,0-.8-4.9,6.4,6.4,0,0,1,.2-2.3v-7.8l-.8-2.7-2.1-1.6s-.2-1.2-.8-1.4a11.9,11.9,0,0,1-1.9-1l-5.6-2.5-3.5.2h-2.5l-5.7.6H389l-2.3.4h-5.1L375,498c-.6-.2-7.1.2-7.1.2l-5.6.2-3.7.8-8.6,1-3.5-.4-6.6-.6L329.8,498l-4.3,1c-.6.2-4.7.6-4.7.6l-7-.6h-3.2l-2,3.5L307,512.4l.8,9.3v3.9l-.4,6.8.4,7.8.2,8.9s-4.1,7.5-3.7,10.1-4,26.1-4,27-8.5,2.7-8.5,2.7l-3.2,3.7-2.5,2.2,8.5,1.8h7.4l9.3-.6,12.1.2h15l8.7-.5h18.7l5.9-.3,11.4.8s6.6-1.2,7.4-1.2l14,1.2s6.8.4,7.6,0,8.4-1.6,8.4-1.6l5.2-6.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-221",
    attrs: {
      "points": "280.6 532.2 281.5 530.9 283.1 528.8 284.5 529.4 285.6 529.1 287.3 536.3 283.7 533.9 280.6 535.9 280.6 532.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-222",
    attrs: {
      "points": "281.3 551 282.7 545.9 284.5 544.9 284.9 548.3 284.8 554.1 285.8 556.8 282.3 553 281.3 551"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-221",
    attrs: {
      "points": "281.4 562.1 283.8 563.9 285.2 569.7 283 574.5 282.3 576.2 282.3 572 281 563.7 281.4 562.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-221",
    attrs: {
      "points": "283 590.6 281.9 584.6 286.1 587.4 288.3 584.5 287.9 587.7 285.9 590.8 290.9 595.7 286 594.7 283 590.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-223",
    attrs: {
      "points": "291.2 588.2 293.2 591.4 299 590.4 291.2 588.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-222",
    attrs: {
      "points": "281.6 506.6 283.7 505.3 285.8 502.9 285.3 508.5 285.8 514.6 282.9 511.7 280.1 515.6 281.6 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "353.3 595.2 364.6 593.1 371.5 595.4 361.5 595.5 353.3 595.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "387.5 589.7 389.3 591.8 387.1 594.3 383.9 595.9 390.3 595 395.1 595.2 394.7 593.6 391.6 591.3 391.2 589.4 387.5 589.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "405.2 596.2 407.4 594.3 412.1 592.1 415 590.2 418 593.1 415.1 595.5 411.4 596.3 407.6 596.2 405.2 596.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "422.2 589.1 422 592.2 425.4 588.2 422.2 589.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "349.9 592.5 352.8 590.1 354.9 588.9 362.7 589.2 360.2 591.6 354.3 593.7 351.5 595.2 348.9 595.3 349.9 592.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-225",
    attrs: {
      "points": "306.4 590.2 310.1 592.3 312.7 594.5 315.8 596.2 318.8 596.3 317.3 592.4 318.6 591.2 319.4 589.6 311.6 590 306.4 590.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-225",
    attrs: {
      "points": "331.8 590.1 335.1 591.9 335.1 595.2 339.1 594.1 340.9 591.2 337.8 589.4 331.8 590.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-225",
    attrs: {
      "points": "371.2 589.8 374.4 591.6 374.4 595 378.4 593.8 380.2 591 377.2 589.2 371.2 589.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "298.1 596.2 303.5 593.9 312.7 594.5 318.6 591.2 327.1 594.8 329.7 596 318.7 596 310.6 595.8 306.2 596.2 298.1 596.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "329.2 589.9 340.9 591.2 346.3 589.7 337.1 589.3 329.2 589.9"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-226"
  }, [_c('g', [_c('use', {
    attrs: {
      "transform": "translate(273.9 472.1) scale(0.13)",
      "xlink:href": "#image-3"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "306.6",
      "y": "528.2",
      "width": "50.6",
      "height": "22.41"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.7,529.6c.1.1,0,.2.1.3a.4.4,0,0,1-.4.2h-.1C310.4,529.9,310.5,529.7,310.7,529.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.8,535.9c.1,0,0,.1,0,.2h-.2C306.6,535.9,306.7,535.9,306.8,535.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,534.8l.3.2a.7.7,0,0,1-.4.7h-.2c-.1-.2-.1-.5,0-.7S309.7,535.1,309.7,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.5,538h0c.1,0,0,.2.1.3l.2-.2c.1,0,0,.1,0,.2h.9v.2h.3c-.3.2.1.3.1.5s-.1.3-.3.4l.3.3H309a.1.1,0,0,0,.1.2c-.1,0-.1.2-.1.2s.5-.1.7.1.1.3.2.5-.3.3-.5.3-.4-.1-.5-.4l-.2.2c.1.1.3,0,.3.2l-.7.2h0c-.3-.2-.7.1-.9,0a1.9,1.9,0,0,1-.6-1c.3-.1,0-.4,0-.5s.2.1.2-.1-.3.1-.3-.2.1-.7.2-.9.4,0,.4-.3,0-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.9,538c.1,0,.1.1.1.2s-.2.2-.3.2a.3.3,0,0,1-.1-.3C311.6,537.9,311.8,538,311.9,538Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.3,540.6l.3.2c0,.2,0,.3-.1.4s-.3.1-.4-.1A.3.3,0,0,1,310.3,540.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.5,535.5c.3,0,.2.3.3.4s.2.4-.1.5h-.3c.2-.3-.5-.3-.3-.6S315.3,535.6,315.5,535.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.7,537.7a.2.2,0,0,1,.1.3c0,.1-.2.1-.3.1a.2.2,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313,539c.1.1,0,.1.1.2s-.2.1-.2.1V539Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.1,538.1a.4.4,0,0,1,.1.3c-.1,0-.3.2-.4,0s0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,539.4h.3c0,.2.2.2.3.3s-.1.3-.1.4a.6.6,0,0,1-.8-.1c0-.2-.2-.5.1-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.7,541.8h.4c.1.2,0,.6,0,.7s-.5-.1-.5.2a.5.5,0,0,1-.6-.1c-.2-.4.6-.5.3-.9S311.5,542,311.7,541.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.4,538.4l.2.3-.2.2c-.1-.1-.3-.1-.3-.3A.2.2,0,0,1,314.4,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.4,538.6c0,.2-.2.2-.3.3h-.2a.3.3,0,0,1,.1-.3C315.1,538.4,315.2,538.6,315.4,538.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.3,537c.2,0,.1.2.1.3h-.3C316.9,537.1,317.1,536.9,317.3,537Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.5,540.3a.1.1,0,0,1-.1.2v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.2,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323,536.9c.1.2,0,.6.3.5s.6.1.9,0,.1.3.2.3h.1c0,.1,0,.5.2.7a4.8,4.8,0,0,0-.3.8h.1c-.2,0-.5.1-.7.2h0c-.2.2-.4.1-.6,0s-.1.1-.1.2-.1-.4-.3-.3l-.2.2c0-.1.2-.2.1-.3h-.2c.1-.2-.3-.4-.1-.7s.1-.3.1-.4h.2c0-.2.1-.4.2-.5h.1C323.2,537.4,322.9,537.1,323,536.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.8,537.3h0v-.2C322.8,537.2,322.8,537.3,322.8,537.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.3,538.4s0,.1,0,.1S322.3,538.4,322.3,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,545.1c-.1.2-.2,0-.2,0S313.9,545,313.9,545.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.5,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.5,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.2,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.1,538.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.3,538.7c.1-.2.3,0,.5-.1s-.1.2,0,.2.1-.1.2,0-.2.2-.2.3h.1c-.2.1-.5.3-.8.1s0-.3-.1-.4S326.2,538.6,326.3,538.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.1,541.5a.1.1,0,0,1,.1.2C324,541.7,323.9,541.5,324.1,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,537.7s.1,0,.1.1-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.5,540.2c0-.2.5-.2.5-.6s0,.3-.1.3.3.3.6.2a2.3,2.3,0,0,0,.1.7.4.4,0,0,0-.3.3h.1c-.2,0-.4,0-.5.2h0c-.1-.1,0-.1,0-.2s-.2-.1-.2,0-.2-.3-.4-.4S330.2,540.1,330.5,540.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330,541.2h-.1a.1.1,0,0,1,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "331.6 540 331.6 540 331.6 539.9 331.6 540"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "331.6 541.1 331.6 541.1 331.6 541.1 331.6 541.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.6,540.7c.1,0,0,.2,0,.2S332.6,540.8,332.6,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.3,541.4c0-.1,0-.1,0-.2s.2-.2.3-.3.6-.1.9,0h0c.1.3.4.2.6.4s0,.2.1.2.3-.1.4-.1h-.2c0,.1-.1.2,0,.3h0a.3.3,0,0,0,.2.3c-.3.1-.3.4-.5.7h.1c-.1-.1-.2,0-.3,0s-.5.1-.6.3-.4-.1-.6-.2h0c-.4-.1-.5-.6-.8-.8s0-.4.3-.5v-.2C332.2,541.4,332.2,541.6,332.3,541.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.4,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.7,540.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "328 548.2 328 548.2 328.1 548.3 328.1 548.3 328 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.9,547.3h-.1C328.8,547.4,328.8,547.3,328.9,547.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.8,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335,541.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "334.7 541.6 334.7 541.6 334.7 541.6 334.7 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.9,540.4c.1.1,0,.1-.1.1S335.8,540.4,335.9,540.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "335.5 541.1 335.3 541.2 335.4 541.1 335.5 541.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.4,543.5c.2,0,.2.1.3.2s-.2.2,0,.3-.4.1-.5-.1S336.2,543.4,336.4,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.3,542.9c-.1-.2.2-.1.1-.2s.4,0,.6-.3.2.2.2,0,.3.4.3.6-.3.2-.2.4-.4,0-.4.2l-.6-.4c-.1-.1.1-.4-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.5,550l.2.3c0,.2-.2.1-.2.3s-.4,0-.5-.2,0-.2,0-.3S332.4,550.1,332.5,550Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "338.6 542.4 338.5 542.5 338.6 542.4 338.6 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.5,547.6v.2c0,.2-.1.3-.3.3s-.2,0-.3-.1,0-.2,0-.3S335.4,547.5,335.5,547.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.9,546.4c.1-.1.2-.2.3-.2s.2.1.3.3-.3.2-.4.4l-.3-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.4,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.7,550.1c.1,0,.3.2.1.3s-.2.1-.3.1a.3.3,0,0,1-.1-.4C334.5,550.1,334.6,550,334.7,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.6,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,543.8c-.1.1-.1.2-.3.2s-.1-.2-.1-.3S340.9,543.6,340.9,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.6,541.3c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C318.3,541.7,318.4,541.2,318.6,541.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344,540h0l.3-.4h0l.7-.3c.4.1.7.5,1.1.6s-.1,0-.2.2-.1.3.1.2l-.2.4h.1c-.2.1-.3.1-.3.3h.3c-.3-.1-.5.2-.8.1h0c-.2,0-.2-.3-.4-.1h0l-.7-.5C343.7,540.7,343.9,540.4,344,540Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.3,544.9h.1a.1.1,0,0,1-.2,0C340.1,545,340.3,544.9,340.3,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,544.3c.1,0,0,.1,0,.1a.1.1,0,0,1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.4,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,542.3c0,.1-.1.1-.2.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 540.1 345.9 540.1 346 540.1 346 540.1 345.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "344.9 541.7 344.8 541.5 344.9 541.6 344.9 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,539.9a.1.1,0,0,1,0,.1A.1.1,0,0,1,346.4,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,540.8c0,.1.1,0,.1,0s-.2-.1-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,537.9c.3.2.6-.1.8.1h-.1c.4-.1.2.4.5.3h-.1c0,.1.1.1.2.2h-.2a.7.7,0,0,1-.1.5h0a.6.6,0,0,1-.3.3h.1c-.2-.2-.7.1-1-.2s-.2-.1-.3-.2-.1-.2-.1-.3A1.1,1.1,0,0,1,353.1,537.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.3,546c.1,0,.1.1.1.2s-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.7,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.9,544.5h.2c-.2.1-.1.2-.3.4s-.3,0-.4-.2a.3.3,0,0,1,0-.3C344.7,544.5,344.9,544.3,344.9,544.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "354.2 537.6 354.2 537.6 354.2 537.6 354.2 537.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "344.9 544.4 344.9 544.4 344.9 544.4 344.9 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "356.9 530.2 356.8 530.3 356.9 530.2 356.9 530.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.7,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.2,538.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "354.6 537.8 354.5 537.9 354.5 537.9 354.6 537.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,537.8s0,0,0,.1S354.8,537.8,354.9,537.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.2,539.3H354C354.1,539.2,354.2,539.1,354.2,539.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.8,538.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "354.4 538.8 354.4 538.9 354.3 538.9 354.4 538.8 354.4 538.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.8,545.3c.1.2-.2.2-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.1,545.1c0,.1-.2.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346,545.6c0,.1-.1,0-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.9,546.9c-.2,0-.2.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.9,547.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "346 547 345.9 547.1 346 547 346 547"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "346 547.1 346 547.2 346 547.1 346 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.9,547h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,539.4h.1c-.1.2-.3.1-.4,0S357,539.4,357.1,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.6,543.3h-.1C354.4,543.2,354.6,543.1,354.6,543.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "356.4 542 356.2 541.9 356.4 541.9 356.4 542"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "290",
      "y": "495.2",
      "width": "50.6",
      "height": "22.41"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294.1,496.6c.1.1,0,.2.1.3a.4.4,0,0,1-.4.2h-.1C293.8,496.9,293.9,496.6,294.1,496.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M290.1,502.9c.1,0,0,.1,0,.2H290C290,502.9,290.1,502.9,290.1,502.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.1,501.8l.3.2a.7.7,0,0,1-.4.7h-.2c-.1-.2-.1-.5,0-.7S293.1,502,293.1,501.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M290.9,505h0c.1,0,0,.2.1.3l.2-.2c.1,0,0,.1,0,.2h.9v.2h.3c-.3.2.1.3.1.5s-.1.3-.3.4l.3.3h-.1a.1.1,0,0,0,.1.2c-.1,0-.1.2-.1.2s.5-.1.7.1.1.3.2.5-.3.3-.5.3-.4-.1-.5-.4l-.2.2c.1.1.3,0,.3.2l-.7.2h0c-.3-.2-.7.1-.9,0a1.9,1.9,0,0,1-.6-.9c.3-.1,0-.4,0-.5s.2.1.2-.1-.3.1-.3-.2.1-.7.2-.9.4,0,.4-.3,0-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.3,505c.1,0,.1.1.1.2s-.2.2-.3.2a.3.3,0,0,1-.1-.3C295,504.9,295.2,504.9,295.3,505Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.7,507.6l.3.2c0,.2,0,.3-.1.4s-.3.1-.4-.1A.3.3,0,0,1,293.7,507.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.9,502.5c.3,0,.2.3.3.4s.2.4-.1.5h-.3c.2-.3-.5-.3-.3-.6S298.7,502.6,298.9,502.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.1,504.7a.2.2,0,0,1,.1.3c0,.1-.2.1-.3.1a.2.2,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.3,506c.1.1,0,.1.1.2s-.2.1-.2.1V506Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.5,505.1a.4.4,0,0,1,.1.3c-.1,0-.3.2-.4,0s0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.7,506.4h.3c0,.2.2.2.3.3s-.1.3-.1.4a.6.6,0,0,1-.8-.1c0-.2-.2-.5.1-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295,508.8h.4c.1.2,0,.6,0,.7s-.5-.1-.5.2a.5.5,0,0,1-.6-.1c-.2-.4.6-.5.3-.9S294.9,508.9,295,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.8,505.4l.2.3-.2.2c-.1-.1-.3-.1-.3-.3A.2.2,0,0,1,297.8,505.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.8,505.6c0,.2-.2.2-.3.3h-.2a.3.3,0,0,1,.1-.3C298.5,505.4,298.6,505.6,298.8,505.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.7,504c.2,0,.1.2.1.3h-.3C300.3,504.1,300.5,503.9,300.7,504Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.9,507.2c.1.1,0,.2-.1.2v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.6,495.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.4,503.9c.1.2,0,.6.3.5s.6.1.9,0,.1.3.2.3h.1c0,.1,0,.5.2.7a4.7,4.7,0,0,0-.3.8h.1c-.2,0-.5.1-.7.2h0c-.2.2-.4.1-.6,0s-.1.1-.1.2-.1-.4-.3-.3l-.2.2c0-.1.2-.2.1-.3H306c.1-.2-.3-.4-.1-.7s.1-.3.1-.4h.2c0-.2.1-.4.2-.5h.1C306.6,504.4,306.3,504.1,306.4,503.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.2,504.3h0v-.2C306.2,504.2,306.2,504.3,306.2,504.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.7,505.4s0,.1,0,.1S305.7,505.4,305.7,505.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.3,512.1c-.1.2-.2,0-.2,0S297.3,512,297.3,512.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.9,505.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,504.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.6,504.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,505.7c.1-.2.3,0,.5-.1s-.1.2,0,.2.1-.1.2,0-.2.2-.2.3h.1c-.3.1-.5.3-.8.1s0-.3-.1-.4S309.6,505.6,309.7,505.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.5,508.4a.1.1,0,0,1,.1.2C307.4,508.7,307.3,508.5,307.5,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,504.7s.1,0,.1.1-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,507.2c0-.2.5-.2.5-.6s0,.3-.1.3.3.3.6.2a2.3,2.3,0,0,0,.1.7.4.4,0,0,0-.3.3h.1c-.2,0-.4,0-.5.2h0c-.1-.1,0-.1,0-.2s-.2-.1-.2,0-.2-.3-.4-.4S313.6,507.1,313.9,507.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.4,508.2h-.1a.1.1,0,0,1,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "315 507 314.9 507 315 506.9 315 507"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "315 508.1 314.9 508.1 315 508.1 315 508.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316,507.7c.1,0,0,.2,0,.2S316,507.8,316,507.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.7,508.4c0-.1,0-.1,0-.2s.2-.2.3-.3.6-.1.9,0h0c.1.3.4.2.6.4s0,.2.1.2.3-.1.4-.1h-.2c0,.1-.1.2,0,.3h0a.3.3,0,0,0,.2.3c-.3.1-.3.4-.5.7h.1c-.1-.1-.2,0-.3,0s-.5.1-.6.3-.4-.1-.6-.2h0c-.4-.1-.5-.6-.8-.8s0-.4.3-.5v-.2C315.6,508.3,315.6,508.5,315.7,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.8,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.1,507.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "311.4 515.2 311.4 515.2 311.5 515.3 311.5 515.3 311.4 515.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.3,514.3h-.1C312.1,514.4,312.2,514.3,312.3,514.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.2,507.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.4,508.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "318.1 508.6 318.1 508.6 318.1 508.6 318.1 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.3,507.4c.1.1,0,.1-.1.1S319.2,507.4,319.3,507.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "318.9 508.1 318.7 508.1 318.8 508.1 318.9 508.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.8,510.4c.2,0,.2.1.3.2s-.2.2,0,.3-.4.1-.5-.1S319.6,510.4,319.8,510.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M320.7,509.8c-.1-.2.2-.1.1-.2s.4,0,.6-.3.2.2.2,0,.3.4.3.6-.3.2-.2.4-.4,0-.4.2l-.6-.4c-.1-.1.1-.4-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.9,517l.2.3c0,.2-.2.1-.2.3s-.4,0-.5-.2,0-.2,0-.3S315.8,517.1,315.9,517Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "322 509.4 321.9 509.5 322 509.4 322 509.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.9,514.6v.2c0,.2-.1.3-.3.3s-.2,0-.3-.1,0-.2,0-.3S318.7,514.5,318.9,514.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M320.3,513.3c.1-.1.2-.2.3-.2s.2.1.3.3-.3.2-.4.4l-.3-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.8,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.1,517c.1,0,.3.2.1.3h-.3a.3.3,0,0,1-.1-.4C317.9,517.1,318,517,318.1,517Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.9,509.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,510.7c-.1.1-.1.2-.3.2s-.1-.2-.1-.3S324.3,510.6,324.3,510.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,508.3c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4H304c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a3.9,3.9,0,0,0,.2-.9C301.7,508.7,301.8,508.1,302,508.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.6,509.7c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1H301a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C300.3,510.2,300.5,509.6,300.6,509.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.9,515c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4H308c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C305.6,515.4,305.8,514.8,305.9,515Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.7,518.8c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1H300a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C299.4,519.2,299.5,518.7,299.7,518.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309,528.8c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C308.8,529.2,308.9,528.7,309,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,507h0l.3-.4h0l.7-.3c.4.1.7.5,1.1.6s-.1,0-.2.1-.1.3.1.2l-.2.4h.1c-.2.1-.3.1-.3.3h.3c-.3-.1-.5.2-.8.1h0c-.2,0-.2-.3-.4-.1h0l-.7-.5C327.1,507.6,327.3,507.3,327.4,507Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.7,511.9h.1a.1.1,0,0,1-.2,0C323.5,512,323.6,511.9,323.7,511.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,511.3c.1,0,0,.1,0,.1a.1.1,0,0,1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.2,509.3c0,.1-.1.1-.2.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.3 507.1 329.3 507 329.4 507.1 329.4 507.1 329.3 507.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "328.3 508.7 328.1 508.5 328.3 508.6 328.3 508.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,506.9s0,.1,0,.1A.1.1,0,0,1,329.8,506.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,507.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,507.8c0,.1.1,0,.1,0s-.2-.1-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.5,504.9c.3.2.6-.1.8.1h-.1c.4-.1.2.4.5.3h-.1c0,.1.1.1.2.2h-.2a.7.7,0,0,1-.1.5h0a.6.6,0,0,1-.3.3h.1c-.2-.2-.7.1-1-.2s-.2-.1-.3-.2-.1-.2-.1-.3A1.1,1.1,0,0,1,336.5,504.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.7,513c.1,0,.1.1.1.2s-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.6,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.1,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.4,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.3,511.5h.2c-.2.1-.1.2-.3.4s-.3,0-.4-.2a.3.3,0,0,1,0-.3C328.1,511.5,328.3,511.3,328.3,511.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "337.6 504.6 337.6 504.6 337.6 504.6 337.6 504.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "328.3 511.4 328.3 511.4 328.3 511.4 328.3 511.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "340.3 497.2 340.2 497.3 340.3 497.2 340.3 497.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,512.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.6,505.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "338 504.8 337.9 504.8 337.9 504.8 338 504.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.3,504.7s0,0,0,.1S338.2,504.8,338.3,504.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.7,505.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.6,506.2h-.2C337.4,506.2,337.6,506.1,337.6,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.2,505.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "337.8 505.8 337.8 505.9 337.7 505.8 337.8 505.8 337.8 505.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.2,512.3c.1.2-.2.2-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.5,512c0,.1-.2.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.4,512.6c0,.1-.1,0-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.3,513.9c-.1,0-.2.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.2,514.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.4 514 329.3 514 329.4 514 329.4 514"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.4 514.1 329.3 514.2 329.4 514.1 329.4 514.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.3,514h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.5,506.4h.1c-.1.2-.3.1-.4,0S340.4,506.4,340.5,506.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338,510.2h-.1C337.8,510.2,338,510.1,338,510.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "339.8 509 339.6 508.9 339.8 508.9 339.8 509"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "363.3",
      "y": "519.7",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-270.4 424.7) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375,518.7c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C374.6,518.7,374.8,518.6,375,518.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.3,522.1v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.7,522.8c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S369.5,523,369.7,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.8,524.5h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5H366c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5H365c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.4s.1.2.2,0-.2,0,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.1,526.8c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S368.1,526.7,368.1,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365,528.3c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S364.9,528.1,365,528.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.2,526.5c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S372.1,526.4,372.2,526.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.4,527.5a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.8,528.2v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.1,528.1l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,369.1,528.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.6,528.8c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.5,530.1v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S364.3,530.2,364.5,530.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.1,528.5v.4h-.3a.6.6,0,0,1,.1-.4C368.8,528.4,369,528.4,369.1,528.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.4,529.2c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C369.4,528.8,369.3,529.1,369.4,529.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.9,528.7c0,.1-.1.2-.2.3s-.2,0-.2-.1S371.8,528.6,371.9,528.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.5,531.3c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.9,531.7c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C374.6,532.2,374.7,531.9,374.9,531.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.5,532h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.3,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.8,534.2c-.2.1-.1-.1-.1-.1S362.9,534.1,362.8,534.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.4,532.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.9,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.1,535.1c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S375.1,535,375.1,535.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.5,536.4s0,.2-.1.2S371.3,536.3,371.5,536.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.5,534.8a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376,538.7c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S375.9,538.4,376,538.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.8,539.3h-.1v-.2A.1.1,0,0,1,374.8,539.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "376.8 539.1 376.8 539 376.8 539 376.8 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "375.8 540.1 375.8 540 375.8 540 375.8 540.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.7,540.2c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.9,540.7v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1H377l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C375.9,540.6,375.7,540.8,375.9,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.1,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.3,540.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "367.5 544.5 367.5 544.5 367.5 544.7 367.5 544.7 367.5 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.8,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.5,542h-.2C377.4,541.9,377.5,541.9,377.5,542Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "377 542.2 377 542.1 377 542.1 377 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.7,541.7c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "377.8 542.1 377.7 542.1 377.8 542.1 377.8 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.2,544.7c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S376.2,544.6,376.2,544.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.3,544.7c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.5,5.5,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.3,548.5v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C368.1,548.3,368.2,548.5,368.3,548.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "378.3 545 378.2 545 378.3 544.9 378.3 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372,548v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C371.9,547.8,372,547.8,372,548Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.9,547.6h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M382.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.4,549.7a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S369.4,549.6,369.4,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.9,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.4,547.4c-.1,0-.3.1-.3,0s.1-.2.2-.3S378.5,547.2,378.4,547.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.7,533.3l.4-.2c0,.1-.1.2-.1.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6H367a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C368.2,533.5,368.7,533.1,368.7,533.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.3,545.7h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.3-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.7,6.7,0,0,1,.1-.8C382.6,546.1,383,545.9,383.3,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377,548.1v.2c-.1.1-.2,0-.2-.1S377,548.1,377,548.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.8,547.9h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381.2,547.6c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384.3 546.7 384.3 546.7 384.3 546.9 384.3 546.9 384.3 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "382.3 547.7 382.4 547.4 382.4 547.6 382.3 547.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.7,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.3,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.9,547.7c-.1.1,0,.1,0,.1s-.1-.2-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.1,548.6c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,390.1,548.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.1,550.1c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.3,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.3,549.8h0S380.3,549.8,380.3,549.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.8,550.2v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C379.7,550,380,550,379.8,550.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391 549 390.9 549 391 549 391 549"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "379.9 550.1 379.9 550.1 379.9 550.1 379.9 550.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "399 543.8 398.9 543.8 399 543.8 399 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.2,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.5,549.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391 549.4 390.9 549.3 390.9 549.4 391 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.2,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.9,550.1c-.1,0,0,0,0-.1S389.9,550.1,389.9,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.5,550.4c0-.1-.1,0-.1-.1S389.6,550.3,389.5,550.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.6,549.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "390 550.2 389.9 550.2 389.9 550.1 390 550.1 390 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.6,551.4c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380,551.3c-.1.1-.2,0-.1-.1S380,551.2,380,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.4,551.8c-.1.1-.1,0-.1-.1S379.4,551.7,379.4,551.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.2,552.9c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378,553h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "378.1 553 378.1 553 378.1 553 378.1 553"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "378.1 553.1 378 553.2 378.1 553.1 378.1 553.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.7,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.9,552.1v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,390.9,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.1,554.3H386C386,554.1,386.3,554.1,386.1,554.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "388.2 554 388.2 553.9 388.2 554 388.2 554"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "295.9",
      "y": "550.9",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-312.2 386.2) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.6,549.9c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C307.2,550,307.5,549.9,307.6,549.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.9,553.4v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302.4,554c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S302.2,554.3,302.4,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.4,555.8h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2,0,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.7,558.1c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S300.7,558,300.7,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.6,559.6c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S297.5,559.4,297.6,559.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.9,557.7c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S304.7,557.7,304.9,557.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,558.7a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.4,559.5v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.8,559.3l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,301.8,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.2,560.1c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.2,561.4v.3c-.1.3-.5.5-.6.6s-.2-.3-.5-.1-.3-.2-.2-.4.8-.1.9-.6S297,561.4,297.2,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.7,559.8v.4h-.3a.6.6,0,0,1,.1-.4C301.5,559.7,301.7,559.7,301.7,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,560.4c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C302.1,560.1,301.9,560.4,302,560.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.5,560c0,.1-.1.2-.2.3s-.2,0-.2-.1S304.5,559.8,304.5,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.2,562.6c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.7,558.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.6,563c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C307.3,563.5,307.4,563.1,307.6,563Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.2,563.3h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.9,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.4,565.5c-.2.1-.1-.1-.1-.1S295.5,565.4,295.4,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.7,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.1,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.6,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.6,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.8,566.4c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S307.8,566.2,307.8,566.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.1,567.7s0,.2-.1.2S304,567.6,304.1,567.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.2,566.1a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.7,569.9c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S308.6,569.7,308.7,569.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.5,570.6h-.1v-.2A.1.1,0,0,1,307.5,570.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "309.4 570.4 309.4 570.3 309.5 570.3 309.4 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "308.4 571.3 308.4 571.3 308.5 571.3 308.4 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.3,571.5c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,572v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C308.5,571.9,308.3,572.1,308.5,572Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.9,572.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "300.2 575.8 300.2 575.8 300.1 575.9 300.1 575.9 300.2 575.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.4,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.6,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.1,573.3h-.2C310,573.2,310.1,573.2,310.1,573.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "309.6 573.5 309.6 573.4 309.6 573.4 309.6 573.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.3,573c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.5 573.4 310.4 573.4 310.4 573.4 310.5 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.9,576c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S308.8,575.9,308.9,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.9,576c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.4,5.4,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.9,579.8v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C300.8,579.6,300.8,579.8,300.9,579.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "311 576.3 310.9 576.2 311 576.2 311 576.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.7,579.2v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C304.5,579.1,304.7,579.1,304.7,579.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.5,578.9h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.3,575.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,581a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S302,580.9,302,581Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.5,577.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311,578.7c-.1,0-.3.1-.3,0s.1-.2.2-.3S311.1,578.5,311,578.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.3,564.6l.4-.2c0,.1-.1.2,0,.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C300.8,564.8,301.4,564.4,301.3,564.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316,577h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.3-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.5,6.5,0,0,1,.1-.8C315.3,577.4,315.6,577.2,316,577Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.6,579.4v.2c-.1.1-.2,0-.2-.1S309.6,579.4,309.6,579.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.5,579.2h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,578.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,578.9c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317 578 317 578 317 578.1 316.9 578.1 317 578"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "315 579 315.1 578.7 315 578.9 315 579"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.4,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317,578.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.5,578.9c-.1.1,0,.1,0,.1s-.1-.2-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.8,579.9c0,.3.4.2.4.5H323c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,322.8,579.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,581.4c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.7,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.9,580.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313,581.1h0S313,581.1,313,581.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.5,581.5v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C312.4,581.3,312.7,581.3,312.5,581.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.6 580.3 323.6 580.3 323.6 580.2 323.6 580.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "312.5 581.4 312.5 581.4 312.6 581.4 312.5 581.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "331.7 575.1 331.6 575.1 331.7 575.1 331.7 575.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.8,581.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.2,580.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.6 580.7 323.5 580.6 323.6 580.6 323.6 580.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.8,580.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.5,581.4c-.1,0,0,0,0-.1S322.5,581.4,322.5,581.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.1,581.7c0-.1-.1,0-.1-.1S322.2,581.5,322.1,581.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.3,581.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "322.6 581.4 322.5 581.5 322.5 581.4 322.6 581.4 322.6 581.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.3,582.7c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.6,582.6c-.1.1-.2,0-.1-.1S312.6,582.5,312.6,582.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312,583.1c-.1.1-.1,0-.1-.1S312,582.9,312,583.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.9,584.2c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.6,584.3s-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.8 584.3 310.7 584.3 310.8 584.3 310.8 584.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.7 584.4 310.6 584.4 310.7 584.4 310.7 584.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.3,584.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.5,583.4v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,323.5,583.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.8,585.5h-.1C318.7,585.4,318.9,585.4,318.8,585.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "320.8 585.3 320.8 585.2 320.9 585.3 320.8 585.3"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "395.5",
      "y": "553.3",
      "width": "38.1",
      "height": "28.41",
      "transform": "translate(-269.7 728.1) rotate(-67.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M432.1,557.6c-.2,0-.2-.1-.4,0s-.2-.3-.1-.4h.2C431.9,557.3,432.1,557.5,432.1,557.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426,551.8h-.1A.1.1,0,0,1,426,551.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426.3,554.4H426a1,1,0,0,1-.7-.6h.2a1.3,1.3,0,0,1,.8.4C426.6,554.3,426.1,554.3,426.3,554.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423.2,551.3H423l.2.2H423c0,.3-.3.3-.3.6l-.2-.2-.3.2c-.1-.3-.4-.1-.6-.2l-.4-.4h-.7c0-.1-.2-.1-.3-.2s0,.4-.3.5h-.6c0-.2-.2-.4-.2-.5s.3-.3.6-.1l-.2-.3c-.2,0-.1.2-.3.1a1.6,1.6,0,0,1,0-.5h-.2c.3-.1.1-.6.3-.6a2.8,2.8,0,0,1,1.3,0c.1.2.4.2.6.3s-.1.1,0,.2,0-.2.4-.1.8.4,1,.6-.1.3.3.4.1,0,.2,0S423.3,551.3,423.2,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422,554.3h-.3c-.2-.1-.2-.2-.1-.3h.4C422.2,554.2,422.1,554.3,422,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.4,552h-.3l-.4-.3c0-.1-.1-.3.2-.3S419.5,551.8,419.4,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423.9,558.1c-.1.2-.4,0-.6,0s-.5,0-.6-.3,0-.1.1-.1.5-.2.8.1S423.8,557.9,423.9,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.8,555.8h-.4a.2.2,0,0,1,0-.3h.4C421.9,555.6,421.8,555.7,421.8,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.5,554.6h-.2c-.1-.1,0-.1,0-.2h.2C420.6,554.5,420.6,554.5,420.5,554.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.2,555.8h-.4c0-.1-.1-.3.1-.3h.3A.2.2,0,0,1,421.2,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.9,554.6c-.1,0-.1.1-.1.2h-.5c0-.2-.3-.2-.4-.3s0-.5.4-.5.7.1.6.4S419.8,554.5,419.9,554.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.6,552.3l-.2.2-.8-.3c0-.1.2-.3-.1-.5s.1-.3.3-.3.4.6.9.6S417.5,552.1,417.6,552.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.7,555.9h-.4l-.2-.3h.4C420.7,555.7,420.8,555.8,420.7,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.3,556.4c-.3-.1-.2-.2-.3-.4h.2l.3.2C420.6,556.3,420.3,556.3,420.3,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.6,558.6c-.1.1-.2,0-.3-.1s0-.2.1-.2S421.8,558.5,421.6,558.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,556.4c-.1,0-.3-.1-.2-.2h.3C418,556.3,418.1,556.4,418,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M428.4,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420,562.5c-.3,0-.8-.3-.7,0s-.3.4-.3.6-.3-.1-.4,0h.1c-.1,0-.5-.3-.8-.2l-.8-.6c-.1,0,0,.1-.1.1s0-.4,0-.6h-.1c-.1-.2.1-.3.2-.4s-.1-.1-.2-.2.5.1.5-.1l-.2-.2c.2.1.2.2.4.2h.2c.2.2.6,0,.8.2s.3.2.5.2h-.2a1.2,1.2,0,0,1,.6.4h-.1C419.4,562.4,419.8,562.4,420,562.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.6,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.5,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.1,552.2c-.2-.1,0-.1.1-.1S413.3,552.3,413.1,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.9,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.1,563.4s-.1-.1,0-.1S419.1,563.4,419.1,563.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.1,564h0S419.1,564,419.1,564Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.9,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,564c.2.2-.1.2,0,.4s-.2-.2-.3-.1.1.1,0,.1-.2-.3-.3-.3h-.1c-.1-.2-.2-.5.1-.6s.3.1.5.1S417.1,563.9,416.9,564Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.4,561.1h-.2C414.1,560.9,414.4,560.9,414.4,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.7,565.2h-.2c-.1-.1,0-.1.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414,566.2c.3.1.1.4.5.6s-.3-.1-.3-.2-.4.1-.4.3l-.8-.3a.5.5,0,0,0-.2-.4h-.1c0-.2.1-.2-.1-.4h.2c0-.1.1-.1,0-.2s.5,0,.6-.1S414.2,566,414,566.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413,565.3c-.1,0-.1-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "413.9 567 413.9 567 413.9 567 413.9 567"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "412.6 566.5 412.6 566.4 412.6 566.5 412.6 566.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.8,567.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412,566.8h.2c-.2.1.2.2.2.4s-.1.4-.2.7h.1c-.3-.1-.4.1-.6.2s-.2-.1-.3,0a.3.3,0,0,1,0,.4v-.2l-.4-.2s0,.1-.1.1a.1.1,0,0,1,0-.1c-.2-.1-.3,0-.4,0s-.4-.4-.6-.6h-.1c.1,0,.1-.2.1-.2s.1-.4-.2-.6.3-.2.4-.3h0c.3-.2.9,0,1.2-.1s.4.2.5.4h.3C412.1,566.7,411.9,566.6,412,566.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.4,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.5,568.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.3 560.5 405.4 560.5 405.2 560.5 405.2 560.5 405.3 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.2,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.4,568.8c-.1-.1.1-.1,0-.2S411.5,568.7,411.4,568.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "411.1 568.4 411.1 568.3 411.1 568.4 411.1 568.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.1,569.8c-.1,0-.1-.1-.1-.1S412.2,569.8,412.1,569.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "411.4 569.1 411.4 569 411.4 569 411.4 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.4,568.6c0,.1-.2.1-.3.1s-.2-.2-.3-.2,0-.3.3-.3S408.5,568.5,408.4,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.8,569.6c.2,0,0,.2.2.1s-.1.3.1.5-.3.1-.1.1h-.8c-.1-.1-.1-.3-.4-.3a.2.2,0,0,0-.1-.3l.6-.3c.1,0,.4.3.5.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.9,562.7h-.4l-.3-.3c.1-.2.1-.3.4-.3l.3.2C402.1,562.5,401.9,562.6,401.9,562.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409 570.7 409 570.6 409 570.6 409 570.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.9,565.9h-.2c-.2-.1-.4-.2-.3-.4s.1-.1.2-.1h.3C403.9,565.7,404,565.9,403.9,565.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.9,567.5c.2.1.1.2.2.4h-.4c-.4,0-.1-.3-.4-.5h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.9,574.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.2,564.2a.3.3,0,0,1-.4-.1c-.1-.1-.1-.2-.1-.3h.5C401.2,564,401.3,564.1,401.2,564.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.1,572.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.7,571.6c-.1-.1-.2-.2-.1-.3s.2.1.3.1S406.9,571.7,406.7,571.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.2,557.3l.3.3h-.2c0,.2-.1.5.3.7l-.4-.3a.3.3,0,0,0-.2.3c0-.1-.2,0-.2,0s0,.5-.2.6.1-.4-.1-.5-.4.1-.6.1h.1c-.2-.1-.5-.3-.7-.1a3.6,3.6,0,0,1-.9-1.2l.4-.6h-.1a.9.9,0,0,0,.8-.3c.2,0,.1.2.3.2h.4l1,.5C415.8,556.9,416.4,557.3,416.2,557.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.2,575.6h-.1l.4.4h-.1a5.8,5.8,0,0,1,.1.6c-.2.3-.8.2-1,.4s0-.1-.1-.2-.3-.2-.2,0l-.4-.3h-.1c-.1-.2,0-.3-.3-.4s0,.2-.1.2-.1-.4.1-.6h-.2c.1-.1.4,0,.3-.2h-.1l.8-.2C409.6,575.1,409.8,575.4,410.2,575.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.6,570.6h-.2c-.1-.1-.1-.2,0-.2S405.6,570.6,405.6,570.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.1,571.3h0C406.2,571.3,406.1,571.3,406.1,571.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.6,574.3c-.1,0-.1-.1,0-.2S407.6,574.3,407.6,574.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.6 576.9 409.6 576.9 409.5 576.9 409.5 576.9 409.6 576.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408 575.4 408.3 575.4 408.1 575.4 408 575.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.7,577.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,577.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.6,576.8c-.1-.1,0,.1-.1.1s.1-.1,0-.3S408.7,576.8,408.6,576.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,582.9c-.3.1-.1.5-.3.5h-.1c0,.3-.5-.1-.5.2h-.3s.1-.1,0-.1l-.5-.3h.1c-.2-.1-.2-.2-.3-.4h-.1c.4,0,0-.6.6-.6s.2-.1.3-.1h.4C409.7,582.4,410,582.6,410.1,582.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,571.4h-.3c-.1-.1.1-.1.2-.1A.2.2,0,0,1,403.7,571.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.5,574.2h0S405.5,574.2,405.5,574.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,574.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.7,574h-.1l-.4-.4c.1,0,0-.2.3-.2l.3.2C404.8,573.8,405,574.1,404.7,574Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "410 583.9 410 583.8 410 583.9 410 583.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.8 574 404.8 574 404.8 574.1 404.8 574"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.9 589.4 417.8 589.3 417.9 589.4 417.9 589.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.1,573.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.5,583.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.6 584 409.6 583.9 409.7 584 409.6 584"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.7,584.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.6,583.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.1,583c.1,0,0-.2.1-.1S408.3,583.1,408.1,583Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,583.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408.6 583.4 408.5 583.3 408.5 583.3 408.6 583.4 408.6 583.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.5,574.3c-.2,0-.2-.2,0-.1S403.6,574.2,403.5,574.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,574.6c-.1-.1-.1-.2.1-.1S403.8,574.6,403.7,574.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.1,574.2c-.1-.1,0-.1,0-.1S403.2,574.2,403.1,574.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.6,573.5c0-.1-.3-.2-.1-.3A.3.3,0,0,1,401.6,573.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.4,573.4s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "401.5 573.5 401.4 573.4 401.5 573.5 401.5 573.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "401.3 573.5 401.3 573.4 401.3 573.5 401.3 573.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.2,574.2c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.1,585h-.2a.2.2,0,0,1,.1-.3A.2.2,0,0,1,407.1,585Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.3,581.4c-.1,0,0-.1,0-.1S403.5,581.4,403.3,581.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.3 583.2 404.4 583.1 404.4 583.2 404.3 583.2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "394.2",
      "y": "496.7",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-245.1 439.8) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,495.7c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C405.5,495.8,405.8,495.6,405.9,495.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,499.2v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.7,499.8c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S400.5,500,400.7,499.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.7,501.5h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.3.1.3.4l-.3.5H395c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2-.1,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399,503.8c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S399,503.7,399,503.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.9,505.3c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S395.8,505.1,395.9,505.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.2,503.5c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S403,503.5,403.2,503.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,504.5a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.7,505.3v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.1,505.1l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,400.1,505.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.5,505.8c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.4,507.1v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S395.3,507.2,395.4,507.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400,505.6v.4h-.3a.6.6,0,0,1,.1-.4C399.8,505.5,400,505.5,400,505.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,506.2c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C400.3,505.9,400.2,506.1,400.3,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.8,505.8c0,.1-.1.2-.2.3s-.2,0-.2-.1S402.7,505.6,402.8,505.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.4,508.3c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417,504.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,508.8c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C405.6,509.3,405.7,508.9,405.9,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.4,509h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.2,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.7,511.3c-.2.1-.1-.1-.1-.1S393.8,511.1,393.7,511.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.9,510.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.3,509.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.9,510.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406,512.1c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S406,512,406,512.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,513.4s0,.2-.1.2S402.3,513.4,402.4,513.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.5,511.8a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407,515.7c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S406.9,515.5,407,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.8,516.3h-.1v-.2A.1.1,0,0,1,405.8,516.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "407.7 516.1 407.7 516.1 407.8 516.1 407.7 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "406.7 517.1 406.7 517.1 406.7 517.1 406.7 517.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.6,517.3c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.8,517.8v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.7,1.7,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C406.8,517.6,406.6,517.8,406.8,517.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,517.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "398.4 521.6 398.5 521.5 398.4 521.7 398.4 521.7 398.4 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.7,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.9,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.4,519c-.1,0-.1-.1-.2-.1S408.4,518.9,408.4,519Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "407.9 519.2 407.9 519.2 407.9 519.2 407.9 519.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,518.8c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408.7 519.2 408.6 519.1 408.7 519.1 408.7 519.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.2,521.8c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S407.1,521.6,407.2,521.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,521.7c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.3,5.3,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.4,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.2,525.6v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C399.1,525.3,399.1,525.5,399.2,525.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.2 522 409.2 522 409.3 522 409.2 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403,525v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C402.8,524.9,403,524.8,403,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.8,524.6h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.6,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,526.8a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S400.3,526.6,400.3,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.8,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.3,524.4c-.1,0-.3.1-.3,0s.1-.2.2-.3S409.4,524.3,409.3,524.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.6,510.3l.4-.2c0,.1-.1.2,0,.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C399.1,510.6,399.7,510.1,399.6,510.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.2,522.7h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.2-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.5,6.5,0,0,1,.1-.8C413.5,523.1,413.9,523,414.2,522.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.9,525.2v.2c-.1.1-.2,0-.2-.1S407.9,525.1,407.9,525.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.8,524.9h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,524.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.1,524.7c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.2 523.8 415.3 523.8 415.2 523.9 415.2 523.9 415.2 523.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "413.3 524.7 413.4 524.4 413.3 524.6 413.3 524.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M415.7,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M415.3,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.8,524.7c-.1.1,0,.1,0,.1s-.1-.2-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421,525.6c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3H421l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,421,525.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,527.2c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,524.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.2,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.3,526.8h0S411.3,526.8,411.3,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.7,527.2v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C410.6,527.1,411,527,410.7,527.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "421.9 526 421.8 526 421.9 526 421.9 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "410.8 527.2 410.8 527.2 410.9 527.1 410.8 527.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "430 520.8 429.9 520.8 429.9 520.8 430 520.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.5,526.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "421.9 526.4 421.8 526.4 421.8 526.4 421.9 526.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.1,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.8,527.2c-.1,0,0,0,0-.1S420.8,527.1,420.8,527.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.4,527.5h-.1C420.3,527.4,420.5,527.3,420.4,527.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "420.9 527.2 420.8 527.2 420.8 527.2 420.9 527.1 420.9 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.6,528.4c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.9,528.4c-.1.1-.2,0-.1-.1S410.9,528.3,410.9,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.3,528.8c-.1.1-.1,0-.1-.1S410.3,528.7,410.3,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,529.9c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.9,530.1s-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.1 530.1 409 530 409 530 409.1 530.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409 530.2 408.9 530.2 409 530.2 409 530.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.8,529.1v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,421.8,529.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417,531.3h-.1C417,531.1,417.2,531.1,417,531.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "419.1 531.1 419.1 530.9 419.1 531 419.1 531.1"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347",
      "y": "550.9",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-297.2 422.3) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.7,549.9c0,.2-.2.2-.2.3s-.4.1-.4,0V550C358.3,550,358.5,549.8,358.7,549.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351,553.4v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.4,554c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S353.2,554.2,353.4,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.5,555.8h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2H347c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2-.1,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.8,558c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S351.8,558,351.8,558Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.7,559.5c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S348.6,559.4,348.7,559.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.9,557.7c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S355.8,557.7,355.9,557.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,558.7a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,559.5v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.8,559.3l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,352.8,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.3,560.1c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,561.4v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S348,561.4,348.2,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.8,559.8v.4h-.3a.6.6,0,0,1,.1-.4C352.5,559.7,352.7,559.7,352.8,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,560.4c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C353.1,560.1,353,560.3,353.1,560.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,560c0,.1-.1.2-.2.3s-.2,0-.2-.1S355.5,559.8,355.6,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.2,562.5c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.8,558.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.6,563c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C358.3,563.5,358.4,563.1,358.6,563Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.2,563.3h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.5,565.5c-.2.1-.1-.1-.1-.1S346.6,565.4,346.5,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.7,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.1,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.7,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.6,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.8,566.3c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S358.8,566.2,358.8,566.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.2,567.6s0,.2-.1.2S355,567.6,355.2,567.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.2,566.1a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.7,569.9c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S359.6,569.7,359.7,569.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.5,570.5h-.1v-.2A.1.1,0,0,1,358.5,570.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "360.5 570.3 360.5 570.3 360.5 570.3 360.5 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "359.5 571.3 359.5 571.3 359.5 571.3 359.5 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.4,571.5c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.6,572v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C359.6,571.9,359.4,572.1,359.6,572Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.8,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361,572h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "351.2 575.8 351.2 575.8 351.2 575.9 351.2 575.9 351.2 575.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.5,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.7,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.2,573.3c-.1,0-.1-.1-.2-.1S361.2,573.1,361.2,573.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "360.7 573.4 360.7 573.4 360.7 573.4 360.7 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.4,573c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.5 573.4 361.4 573.4 361.5 573.4 361.5 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.9,576c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S359.9,575.9,359.9,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361,576c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.4,5.4,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352,579.8v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C351.8,579.6,351.9,579.8,352,579.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "362 576.2 361.9 576.2 362 576.2 362 576.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.7,579.2v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C355.6,579.1,355.7,579.1,355.7,579.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.6,578.8h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.4,575.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,581a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3-.1s.1-.3.2-.4S353.1,580.9,353.1,581Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.6,577.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.1,578.7c-.1,0-.3.1-.3,0s.1-.2.2-.3S362.2,578.5,362.1,578.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.4,564.6l.4-.2c0,.1-.1.2-.1.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6H353c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C351.9,564.8,352.4,564.4,352.4,564.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367,577h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.2-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.5,6.5,0,0,1,.1-.8C366.3,577.3,366.7,577.2,367,577Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.7,579.4v.2c-.1.1-.2,0-.2-.1S360.7,579.3,360.7,579.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.5,579.1h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,578.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.9,578.9c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368 578 368 578 368 578.1 368 578.1 368 578"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "366 578.9 366.1 578.7 366.1 578.9 366 578.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.4,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368,578.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.6,578.9c-.1.1,0,.1,0,.1s-.1-.2-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.8,579.8c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,373.8,579.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.8,581.4c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.7,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364,580.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364,581h0S364,581,364,581Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.5,581.5v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C363.4,581.3,363.7,581.3,363.5,581.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "374.7 580.2 374.6 580.2 374.7 580.2 374.7 580.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "363.6 581.4 363.6 581.4 363.6 581.4 363.6 581.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "382.7 575 382.6 575 382.7 575 382.7 575"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.9,581.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.2,580.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "374.6 580.6 374.6 580.6 374.6 580.6 374.6 580.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.9,580.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.6,581.4c-.1,0,0,0,0-.1S373.6,581.4,373.6,581.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.2,581.7h-.1C373.1,581.6,373.3,581.5,373.2,581.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.3,581.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "373.7 581.4 373.6 581.5 373.6 581.4 373.7 581.4 373.7 581.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.3,582.6c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.7,582.6c-.1.1-.2,0-.1-.1S363.7,582.5,363.7,582.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.1,583c-.1.1-.1,0-.1-.1S363.1,582.9,363.1,583Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.9,584.1c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.7,584.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.8 584.3 361.8 584.3 361.8 584.3 361.8 584.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.8 584.4 361.7 584.4 361.8 584.4 361.8 584.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.4,584.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.6,583.4v.2a.2.2,0,0,1-.3-.2A.2.2,0,0,1,374.6,583.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.8,585.5h-.1C369.7,585.4,370,585.4,369.8,585.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.9 585.3 371.9 585.2 371.9 585.2 371.9 585.3"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "390.7",
      "y": "533.1",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-271.8 448) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,532.1c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C402,532.2,402.3,532,402.4,532.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.7,535.6v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.2,536.2c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S397,536.4,397.2,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.2,537.9h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2-.1,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.5,540.2c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S395.5,540.1,395.5,540.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,541.7c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S392.3,541.5,392.4,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.7,539.9c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S399.5,539.9,399.7,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.8,540.9a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.2,541.6v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.6,541.5l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,396.6,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395,542.2c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392,543.5v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S391.8,543.6,392,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.5,542a1,1,0,0,1-.1.4h-.3a.6.6,0,0,1,.1-.4C396.3,541.9,396.5,541.8,396.5,542Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.8,542.6c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C396.9,542.3,396.7,542.5,396.8,542.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.3,542.2c0,.1-.1.2-.2.3s-.2,0-.2-.1S399.3,542,399.3,542.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,544.7c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.5,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,545.1c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5H400c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C402.1,545.7,402.2,545.3,402.4,545.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402,545.4h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.7,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.2,547.6c-.2.1-.1-.1-.1-.1S390.3,547.5,390.2,547.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.5,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.4,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.6,548.5c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S402.6,548.4,402.6,548.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.9,549.8s0,.2-.1.2S398.8,549.7,398.9,549.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404,548.2a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.5,552.1c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S403.4,551.8,403.5,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.3,552.7h-.1v-.2A.1.1,0,0,1,402.3,552.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.2 552.5 404.2 552.5 404.3 552.4 404.2 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "403.2 553.5 403.2 553.4 403.3 553.4 403.2 553.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.1,553.6c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.3,554.2V554c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3V554C403.3,554,403.1,554.2,403.3,554.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.5,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.7,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "395 557.9 395 557.9 394.9 558.1 394.9 558.1 395 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.2,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.4,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.9,555.4c-.1,0-.1-.1-.2-.1S404.9,555.3,404.9,555.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.4 555.6 404.4 555.6 404.4 555.5 404.4 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.1,555.1c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.3 555.6 405.2 555.5 405.2 555.5 405.3 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,558.1c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S403.6,558,403.7,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.7,558.1c.1-.2.2,0,.2-.2s.2.2.5.1,0,.3.1.2a5.3,5.3,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.7,561.9v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C395.6,561.7,395.6,561.9,395.7,561.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.8 558.4 405.7 558.4 405.8 558.4 405.8 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.5,561.4v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C399.3,561.3,399.5,561.2,399.5,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.3,561h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.8,563.2a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S396.8,563,396.8,563.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.3,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.8,560.8c-.1,0-.3.1-.3,0s.1-.2.2-.3S405.9,560.7,405.8,560.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.1,546.7l.4-.2c0,.1-.1.2,0,.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C395.6,547,396.2,546.5,396.1,546.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.8,559.1h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.2-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.4,6.4,0,0,1,.1-.8C410.1,559.5,410.4,559.4,410.8,559.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.4,561.6v.2c-.1.1-.2,0-.2-.1S404.4,561.5,404.4,561.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,561.3h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.7,561c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.8 560.2 411.8 560.2 411.8 560.3 411.7 560.3 411.8 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.8 561.1 409.9 560.8 409.8 561 409.8 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.8,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.3,561.1c-.1.1,0,.1,0,.1s-.1-.2-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.6,562c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,417.6,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.5,563.6c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.7,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.8,563.2h0S407.8,563.2,407.8,563.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.3,563.6v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C407.2,563.5,407.5,563.4,407.3,563.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "418.4 562.4 418.4 562.4 418.4 562.4 418.4 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "407.3 563.6 407.3 563.5 407.4 563.5 407.3 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "426.5 557.2 426.4 557.2 426.5 557.2 426.5 557.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.6,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,562.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "418.4 562.8 418.3 562.8 418.4 562.8 418.4 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.6,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.3,563.5c-.1,0,0,0,0-.1S417.3,563.5,417.3,563.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,563.8h-.1C416.9,563.7,417,563.7,416.9,563.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.1,563.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.4 563.6 417.3 563.6 417.3 563.6 417.4 563.5 417.4 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.1,564.8c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,564.7c-.1.1-.2,0-.1-.1S407.4,564.7,407.4,564.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.8,565.2c-.1.1-.1,0-.1-.1S406.8,565.1,406.8,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.7,566.3c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.4,566.5s-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.6 566.4 405.5 566.4 405.6 566.4 405.6 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.5 566.6 405.4 566.6 405.5 566.6 405.5 566.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.1,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.3,565.5v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,418.3,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.6,567.7h-.1C413.5,567.5,413.7,567.5,413.6,567.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "415.6 567.4 415.6 567.3 415.7 567.4 415.6 567.4"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-230"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "332.5",
      "y": "552.1",
      "width": "36.7",
      "height": "14.81"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.5 566.9 348.4 566.9 348.5 566.9 348.5 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.6 566.9 348.6 566.9 348.6 566.9 348.6 566.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.5,553.8h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,350.5,553.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.6,553.3s0,.1,0,.1h-.1C350.5,553.4,350.5,553.3,350.6,553.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.2,559.8h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "345",
      "y": "558.6",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,558.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.1,560.1c0,.1,0,.1-.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.6,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,557.5h0c-.1-.1.1-.1.1-.1h.3c0,.1,0,.1,0,.2s0,.2-.1.2h-.3c.1-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.4,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.9,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.8,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.9,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.5,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.1,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.9,555.9h0C339.9,556,339.9,555.9,339.9,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.1,555h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340,555.7h0S340,555.7,340,555.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.3,557.5h0A.1.1,0,0,1,340.3,557.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "335.9 557.6 335.8 557.6 335.8 557.5 335.9 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.3,557.7h.1c-.1.1-.2,0-.3,0h0s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,557.3s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341,556.7a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341,557.3s.2,0,.1.1H341Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.2,557.6h.1c.2,0,.4,0,.5.2h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.6,558.4c0,.1-.2.1-.2.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "337.5 558.4 337.5 558.5 337.5 558.4 337.5 558.5 337.5 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.1,559.6h0c-.2.1-.4,0-.6,0h-.1A.8.8,0,0,1,349.1,559.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "338 558.6 337.9 558.6 338 558.6 338 558.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.4,558.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,558.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.7,559h.3s.1.1,0,.1h-.4S338.7,559,338.7,559Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "338.8 559 338.8 559 338.8 559 338.8 559"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.2,552.2c0,.1-.1.1-.2.1l-.4-.2h-.1C340.7,552.2,341.1,552,341.2,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.2,560.1h.1a.1.1,0,0,1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.9 560.1 340.9 560.1 340.9 560.1 340.9 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.5,560.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "342 553.7 342 553.7 342 553.7 342 553.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.1,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.1,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.4,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.2,558c.1,0,.3-.1.4,0s0,.1-.1.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.6,560.7h.2c0,.1,0,.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,556h-.1C343.6,556,343.7,556,343.8,556Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.8,561s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.9,552.9h.2c0,.1,0,.1-.1.1S343.8,552.9,343.9,552.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.1,554.3h.1c.1,0,.3-.1.4.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.3,556.8h.1c-.1,0,0-.1-.1-.1s.2,0,.2.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.5,562.8c.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.4,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.4,556.8h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.2,561.5h-.1s.2.1.2-.1.4,0,.5.2h.3s0,.1,0,.1-.4-.1-.5.2h-.5c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,561.1h.2c0,.1-.1.1-.1.1h-.1S345.6,561.1,345.6,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.9,554.8h.2s0,.1,0,.1h-.2S344.9,554.9,344.9,554.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345 554.9 344.9 554.9 344.9 554.9 345 554.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,561.8c-.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.4 561.7 346.5 561.7 346.4 561.8 346.4 561.8 346.4 561.7 346.4 561.7 346.4 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.5,561.6h.3c0,.1-.2.1-.2.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.7,563.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.1,554.5h.1c0-.1-.1,0-.1-.1h0A.1.1,0,0,0,346.1,554.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.2,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.9,562.2h0c.1,0,.3-.1.3.1s-.1.1-.2.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.5,556.4h-.3C346.3,556.4,346.4,556.3,346.5,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.2,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.7,557.3h0S349.7,557.3,349.7,557.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.8,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 557.4 349.9 557.4 349.9 557.4 349.9 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.9,561.1c.1,0,.1.1,0,.1h-.1s0-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.8,558.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,558.5h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351,558.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.3,561.5s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.3,562.8c0-.1-.1,0-.1-.1h.6c-.1-.1.1,0,.1-.1h.1c.1.1.2.2.2.3s0,.1,0,.2h0s0,.1,0,.1h-.7c0-.1.1-.1.1-.1h-.2c.1-.1,0-.1-.1-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352,558.5h.2c0,.1-.1.1-.1.1H352Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.9,558.7h.1c.1,0,.1.1.1.2s-.4-.1-.5-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.9,559.3h.3c.1-.1.2,0,.3,0h.1v.2h-.1l.2.2c.1.1-.1.1-.1.2h-.2c.1-.1-.1-.1-.2-.1h-.3S363,559.4,362.9,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.3,561.9h0c.1,0,.1-.2.3-.2h.2c0,.1,0,.2-.1.3h-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "353.1",
      "y": "559.9",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.9,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.4,559.6h0c.1-.1.2.2.3,0s.2,0,.2.2-.1.1-.2.2h-.2c0-.1-.1,0-.1-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358,559.9s.1,0,0-.1h.1c.1,0,.1-.1.2-.1h.2a.2.2,0,0,1,.1.3H358C358,559.9,358.1,559.9,358,559.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.1 560.5 358 560.5 358.1 560.5 358.1 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.4,562.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "360.4",
      "y": "562.5",
      "width": "0.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.8,565.6a.1.1,0,0,1,.1.2h-.2C360.6,565.7,360.6,565.6,360.8,565.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.2,561.1h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.1,563.2h.1s.1,0,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.6,564.1h.1c.1,0,.4-.1.5.1v.2h0l-.2.2h-.3v-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.9,562.1s0,0,0-.1h.1s0-.1,0-.1h.1c.1-.1.2,0,.3,0h.4c-.1.1.1.1,0,.1h0c.1.1-.1.1,0,.2h-.2s-.1-.1-.2,0-.1-.2-.2-.1h0c0-.1.1-.1,0-.1H363s.1-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.5,563.7h0c0-.1.1-.1.1-.2s.1-.2.2-.1h.5c0,.1.1.1.1.2h0v.2h-.1c-.1,0-.1.1-.1.1H366s0,0,0-.1h-.4s.1-.1,0-.1h-.2C365.5,563.8,365.4,563.7,365.5,563.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.7,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.3,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,562.6h0s.1,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.3,560.6h.3c.1.1.2.1.1.2s-.1.1,0,.1-.1,0-.1.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.6,561h.2s0,0,0-.1h.3c.1,0,0,.1.1.1s0,.2-.1.3h0s0,.1,0,.1h-.4c0-.1,0-.2-.1-.1h0C366.5,561.2,366.7,561.1,366.6,561Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.9,561.8h.1c.1,0,0-.1.1-.1s0-.2,0-.2h.3c-.1.1.1.1.1.1s0-.1.1-.1,0,.2.1.2h.2s0,0,0,.1h.1c.1,0,0,.1.1.1s0,.1.1.1h-.1c0,.1.1,0,.1.1h-.1a.2.2,0,0,0,0,.1h0s-.1.1,0,.1h0s-.1-.1-.1,0h0c-.2,0,0,.3-.2.3h-.2c0-.1-.1-.1-.2-.1h-.1s.1-.1,0-.2h-.1s0-.1,0-.1h-.1s.1-.1,0-.1H368s0,0,0-.1H368s0-.1,0-.1h-.1s.1,0,.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.3,558.9h.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.7,559.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "360.9 559 360.8 559 360.8 559 360.8 559 360.8 559 360.9 559"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.1,558.9h.6s-.1,0,0,.1v.2c-.1.1-.1.1-.1.2h-.1c-.1,0,0,.1,0,.1h-.3c-.1-.1-.1,0-.2.1s.1-.1,0-.2h0c-.1-.1.1-.1,0-.1h-.1C361,559.1,361.1,559,361.1,558.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361,559h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.5 559.5 361.5 559.5 361.5 559.5 361.5 559.5"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-231"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "388.3",
      "y": "572",
      "width": "37.3",
      "height": "15.09"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.6 587.1 404.5 587.1 404.6 587.1 404.6 587.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.7 587.1 404.6 587.1 404.7 587.1 404.7 587.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.6,573.7h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,406.6,573.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.8,573.3s0,.1,0,.1h-.1C406.6,573.4,406.7,573.3,406.8,573.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390,579.9h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "401",
      "y": "578.7",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.3,579.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.6,578.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391,580.2c0,.1,0,.1-.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.3,575.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.8,577.5h0c-.1-.1.1-.1.1-.1h.3c0,.1,0,.1,0,.2s0,.2-.2.2h-.3c.1-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.2,576h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.7,575.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,575.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.7,575.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395,577.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.9,575.9h0C395.8,576,395.8,576,395.9,575.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,575h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,575.7h0S395.9,575.7,396,575.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.3,577.6h0A.1.1,0,0,1,396.3,577.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391.7 577.6 391.6 577.6 391.7 577.6 391.7 577.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.2,577.8h.1c-.1.1-.2,0-.3,0h0s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.5,576h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.9,577.4s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.9,576.7a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397,577.3s.2,0,.1.1H397Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.1,577.6h.1c.2,0,.4,0,.5.2h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.5,578.5c0,.2-.2.1-.2.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.4 578.5 393.4 578.6 393.3 578.5 393.4 578.6 393.4 578.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.2,579.7h0c-.2.1-.4,0-.6,0h-.1A.8.8,0,0,1,405.2,579.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "393.9 578.7 393.8 578.7 393.9 578.7 393.9 578.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.3,578.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.2,578.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.6,579h.3s.1.1,0,.1h-.4S394.6,579.1,394.6,579Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.7 579 394.7 579 394.7 579 394.7 579"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.6,581.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.2,572.2c0,.1-.1.1-.2.1l-.4-.2h-.1C396.7,572.1,397,571.9,397.2,572.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,580.2h.1a.1.1,0,0,1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.9 580.2 396.8 580.2 396.9 580.2 396.9 580.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.5,580.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "398 573.7 398 573.7 398 573.7 398 573.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.1,574.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.1,574.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.4,573.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.2,578c.1,0,.3-.1.5,0s0,.1-.1.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.6,580.8h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.8,576h-.1C399.6,576,399.7,576,399.8,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.8,581.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.9,572.8h.2c0,.1,0,.1-.1.1S399.8,572.9,399.9,572.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.1,574.3h.1c.1,0,.3-.1.4.1v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,576.8h.1c-.1,0,0-.1-.1-.1s.2,0,.3.1h-.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.6,583c.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.4,576.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.4,576.8h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.4,581.6h-.1s.2.1.2-.1.4,0,.5.2h.4s0,.1,0,.1-.4-.1-.5.2h-.5c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.7,581.2h.2c0,.1-.1.1-.1.1h-.1S401.6,581.2,401.7,581.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.9,574.8h.2s0,.1,0,.1h-.2S400.9,574.8,400.9,574.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401 574.9 400.9 574.9 400.9 574.9 401 574.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,581.9c-.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.5 581.9 402.5 581.9 402.5 581.9 402.5 581.9 402.4 581.9 402.5 581.8 402.5 581.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.6,581.7h.3c0,.1-.2.1-.3.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,583.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.1,574.5h.1c.1-.1-.2,0-.1-.1h0S402.2,574.5,402.1,574.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.3,576.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404,582.3h0c.1,0,.3-.1.3.1s-.1.1-.2.2H404Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.5,576.4h-.3C402.4,576.4,402.5,576.3,402.5,576.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.3,577.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,581.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.8,577.4h0A0,0,0,0,1,405.8,577.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,577.4h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406 577.4 406 577.4 406 577.4 406 577.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,581.2c.1,0,.1.1,0,.2H408s0-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,578.6h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.1,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,581.6s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.5,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.6,582.9c0-.1-.1,0-.1-.1h0c.1-.1.2,0,.3-.1h.4c-.1-.1.1,0,.1-.1h.2c.1.1.2.2.2.3s0,.1,0,.2h0s0,.1,0,.1h-.3l-.4.2h-.1c0-.1.1-.1.1-.2h-.3c.1-.1,0-.1-.1-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,578.6h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,578.8v.2h0c.1,0,.2.1.1.2s-.4-.1-.5-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.3,579.4h.3c.1-.1.2,0,.3,0h.1v.2h-.1l.2.2c.1.1-.1.1-.1.2h-.2c.1-.1-.1-.1-.2-.1h-.3S419.3,579.5,419.3,579.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.6,582h0c.1,0,.2-.2.3-.2h.2c0,.1,0,.2-.1.3h-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "409.3",
      "y": "580",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,579.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.6,579.7h0c.2-.1.2.2.4,0s.2,0,.2.2-.1.2-.2.2h-.2c0-.1-.1,0-.1-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.3,580s.1,0,0-.1h.1c.1,0,.1-.1.2-.1h.2a.2.2,0,0,1,.1.3h-.6C414.2,580,414.4,580,414.3,580Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "414.4 580.6 414.3 580.6 414.4 580.6 414.4 580.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.7,582.6h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "416.7",
      "y": "582.7",
      "width": "0.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.1,585.8a.1.1,0,0,1,.1.2H417C416.9,585.9,417,585.8,417.1,585.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.5,581.2h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.9,581h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.5,583.3h.1s.1.1,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.5,583.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419,584.3h.1c.1,0,.4-.1.5.1v.2h0l-.2.2h-.3v-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.3,582.2s0,0,0-.1h.1s0-.1,0-.1h.1c.1-.1.2,0,.3,0h.1v.2h.1c-.1.1.1.1,0,.1h0c.1.1-.1.1,0,.2h-.2s-.1-.1-.2,0-.1-.2-.2-.1h0c0-.1.1-.1,0-.1h-.1s.1-.1,0-.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.9,583.8h0c0-.1.1-.1.1-.2s.1-.2.2-.1h.5c0,.1.1.1.1.2h0v.2h-.1c-.1,0-.1.1-.1.1h-.1s0,0,0-.1H422s.1-.1,0-.1h-.2C421.9,584,421.9,583.9,421.9,583.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421,580h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.7,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.5,582.8h0s.1,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.7,580.7h.3c.1.1.2.1.1.2s-.1.1,0,.1-.1,0-.1.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423,581.1h.2s0,0,0-.1h.3c.1,0,0,.1.1.1s0,.2-.1.3h0s0,.1,0,.1h-.4c0-.1,0-.2-.1-.1h0C422.9,581.3,423.1,581.2,423,581.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.4,581.9h.1c.1,0,0-.1.1-.1s0-.2,0-.2h.3c-.1.1.1.1.1.2s0-.1.1-.1,0,.2.1.2h.2s0,0,0,.1h.1c.1,0,0,.1.1.1s0,.1.1.1h-.1c0,.1.1,0,.1.1h-.1a.2.2,0,0,0,0,.1h0s-.1.1,0,.1h0s0,.1,0,.1-.1-.1-.1,0h0c-.2,0,0,.3-.2.3H425c0-.1-.1-.1-.2-.1h-.1s.1-.1,0-.2h-.1s0-.1,0-.1h-.1s.1-.1,0-.1h-.1s0,0,0-.1h-.1s0-.1,0-.1h-.1s.1,0,.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.6,579h.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417,579.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.2 579.1 417.1 579.1 417.1 579.1 417.1 579.1 417.1 579.1 417.2 579.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.4,578.9h.6s-.1,0,0,.1v.2c-.1.1-.1.1-.1.2h-.1c-.1,0,0,.1,0,.1h-.3c-.1-.1-.2,0-.2.1s.1-.1,0-.2h0c-.1-.1.1-.1,0-.2h-.1C417.3,579.1,417.5,579.1,417.4,578.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.3,579h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.9 579.6 417.9 579.6 417.9 579.6 417.9 579.6"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-232"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379",
      "y": "535.4",
      "width": "37.3",
      "height": "15.09"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.3 550.5 395.3 550.4 395.3 550.4 395.3 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.4 550.5 395.4 550.5 395.4 550.4 395.4 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.3,537.1h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,397.3,537.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.5,536.7s0,.1,0,.1h-.1C397.4,536.8,397.4,536.6,397.5,536.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.8,543.2h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "391.7",
      "y": "542.1",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381.7,543.5c0,.1,0,.1-.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.6,540.9h0c-.1-.1.1-.1.1-.1h.3c0,.1,0,.1,0,.2s0,.2-.2.2h-.3c.1-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.4,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.3,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.5,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.1,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M385.7,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.6,539.3h0C386.5,539.4,386.6,539.3,386.6,539.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.7,538.3h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.7,539.1h0S386.6,539.1,386.7,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387,540.9h0A.1.1,0,0,1,387,540.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "382.4 540.9 382.4 541 382.4 540.9 382.4 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M382.9,541.1h.1c-.1.1-.2,0-.3,0h0s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.3,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.6,540.7s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.7,540.1a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.7,540.6s.2,0,.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.8,541h.1c.2,0,.4,0,.5.2h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.3,541.9c0,.2-.2.1-.2.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384.2 541.9 384.1 541.9 384.1 541.8 384.1 541.9 384.2 541.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,543.1h0c-.2.1-.4,0-.6,0h-.1A.8.8,0,0,1,396,543.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "384.6 542.1 384.5 542 384.6 542 384.6 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M385.1,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M385.3,542.4h.3s.1.1,0,.1h-.4S385.3,542.5,385.3,542.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.4 542.4 385.4 542.4 385.4 542.4 385.4 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.3,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.9,535.5c0,.1-.1.1-.2.1l-.4-.2h-.1C387.4,535.5,387.7,535.3,387.9,535.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.9,543.5h.1a.1.1,0,0,1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.6 543.5 387.6 543.5 387.6 543.5 387.6 543.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.3,543.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "388.7 537.1 388.7 537 388.7 537 388.7 537.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.1,537h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.9,541.4c.1,0,.3-.1.5,0a.1.1,0,0,1-.1.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.3,544.1h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.5,539.4h-.1C390.3,539.4,390.4,539.4,390.5,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.5,544.5s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.6,536.2h.2c0,.1,0,.1-.1.1S390.5,536.3,390.6,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.8,537.6h.1c.1,0,.3-.1.4.1v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391,540.2h.1c-.1,0,0-.1-.1-.1s.2,0,.3.1H391Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.3,546.3c.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,540.2h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.1,545H400s.2.1.2-.1.4,0,.5.2h.4s0,.1,0,.1-.4-.1-.5.2H400c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,544.5h.2c0,.1-.1.1-.1.1h-.1S392.3,544.5,392.4,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.6,538.2h.2s0,.1,0,.1h-.2S391.6,538.2,391.6,538.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.7 538.2 391.6 538.2 391.6 538.2 391.7 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.2,545.2c-.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.2 545.2 393.2 545.2 393.2 545.3 393.2 545.2 393.2 545.2 393.2 545.2 393.2 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.3,545h.3c0,.1-.2.1-.3.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.5,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.9,537.9h.1c0-.1-.2,0-.1-.1h0A0,0,0,0,0,392.9,537.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.7,545.7h0c.1,0,.3-.1.3.1s-.1.1-.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.3,539.8H393C393.1,539.7,393.2,539.7,393.3,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.6,540.7h0S396.5,540.7,396.6,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.6,540.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.7 540.8 396.7 540.8 396.7 540.8 396.7 540.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.8,544.6c.1,0,.1.1,0,.2h-.1s0-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.7,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,541.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.8,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,545s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,541.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,546.3c0-.1-.1,0-.1-.1h0c.1-.1.2,0,.3-.1h.4c-.1-.1.1,0,.1-.1h.2c.1.1.2.2.2.3s0,.1,0,.2h0s0,.1,0,.1H406l-.4.2h-.1c0-.1.1-.1.1-.2h-.3c.1-.1,0-.1-.1-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.9,541.9h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.8,542.1v.2h0c.1,0,.2.1.1.2s-.4-.1-.5-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410,542.8h.3c.1-.1.2,0,.3,0h.1v.2h-.1l.2.2c.1.1-.1.1-.1.2h-.2c.1-.1-.1-.1-.2-.1h-.3S410.1,542.8,410,542.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.3,545.4h0c.1,0,.2-.2.3-.2h.2c0,.1,0,.2-.1.3h-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "400",
      "y": "543.4",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.8,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.3,543.1h0c.2-.1.2.2.4,0s.2,0,.2.2-.1.2-.2.2h-.2c0-.1-.1,0-.1-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405,543.3s.1,0,0-.1h.1c.1,0,.1-.1.2-.1h.2a.2.2,0,0,1,.1.3h-.2c0-.1-.1.1-.1,0H405C405,543.4,405.1,543.4,405,543.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 544 405 544 405.1 544 405.1 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,546h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "407.5",
      "y": "546",
      "width": "0.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.8,549.1a.1.1,0,0,1,.1.2h-.2C407.7,549.3,407.7,549.1,407.8,549.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.3,544.6h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,546.7h.1s.1.1,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.7,547.6h.1c.1,0,.4-.1.5.1v.2h0l-.2.2h-.3v-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410,545.5s0,0,0-.1h.1s0-.1,0-.1h.1c.1-.1.2,0,.3,0h.1v.2h.1c-.1.1.1.1,0,.1h0c.1.1-.1.1,0,.2h-.2s-.1-.1-.2,0-.1-.2-.2-.1h0c0-.1.1-.1,0-.1h-.1s.1-.1,0-.2H410Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.7,547.2h0c0-.1.1-.1.1-.2s.1-.2.2-.1h.5c0,.1.1.1.1.2h0v.2h-.1c-.1,0-.1.1-.1.1h-.1s0,0,0-.1h-.4s.1-.1,0-.1h-.2C412.7,547.3,412.6,547.3,412.7,547.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.8,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.5,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.3,546.1h0s.1,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.5,544.1h.3c.1.1.2.1.1.2s-.1.1,0,.1-.1,0-.1.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.7,544.5h.2s0,0,0-.1h.3c.1,0,0,.1.1.1s0,.2-.1.3h0s0,.1,0,.1h-.4c0-.1,0-.2-.1-.1h0C413.6,544.7,413.8,544.5,413.7,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M415.1,545.3h.1c.1,0,0-.1.1-.1s0-.2,0-.2h.3c-.1.1.1.1.1.2s0-.1.1-.1,0,.2.1.2h.3c.1,0,0,.1.1.1s0,.1.1.1h-.1c0,.1.1,0,.1.1h-.1a.2.2,0,0,0,0,.1h0s-.1.1,0,.1h0s0,.1,0,.1-.1-.1-.1,0h0c-.2,0,0,.3-.2.3h-.2c0-.1-.1-.1-.2-.1h-.1s.1-.1,0-.2h-.1s0-.1,0-.1h-.1s.1-.1,0-.1h-.1s0,0,0-.1h-.1s0-.1,0-.1h-.1s.1,0,.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,542.3h.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.7,542.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408 542.4 407.9 542.5 407.9 542.4 407.8 542.5 407.8 542.4 408 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.1,542.3h.6s-.1,0,0,.1v.2c-.1.1-.1.1-.1.2h-.1c-.1,0,0,.1,0,.1h-.3c-.1-.1-.2,0-.2.1s.1-.1,0-.2h0c-.1-.1.1-.1,0-.2H408C408.1,542.5,408.2,542.4,408.1,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,542.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408.6 543 408.6 543 408.6 542.9 408.6 543"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.2,521.2h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.8,516.4h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.5,517.3h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1H296l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.6,522.4h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S293.5,522.4,293.6,522.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.6,517h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3l.2-.2h.2S299.6,516.9,299.6,517Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.4,518.7h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S301.4,518.7,301.4,518.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298,519.9s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C298,519.9,297.9,519.9,298,519.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "297.6 519.4 297.7 519.3 297.6 519.4 297.6 519.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294.7,518.5h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "294.6 518.4 294.6 518.4 294.6 518.4 294.6 518.4 294.6 518.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.1,515.7a.1.1,0,0,1-.2-.1h.1C293.1,515.5,293.2,515.7,293.1,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.6,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.3,520.8s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.7,518.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M293.6,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M291.9,517.9h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S291.9,517.8,291.9,517.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292.5,519.9s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C292.4,519.8,292.5,519.9,292.5,519.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.4,519.4h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C289.3,519.3,289.4,519.3,289.4,519.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M291.7,522.6h.1C291.7,522.5,291.8,522.5,291.7,522.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292,525H292s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.3,520.6h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S289.3,520.6,289.3,520.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.9,522.6h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.5,522.4s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S289.4,522.3,289.5,522.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M287.9,522.2h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.2,521.8H296c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.8,521.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "295.6 522 295.7 521.9 295.7 521.9 295.7 521.9 295.7 521.9 295.6 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.5,522.1h0l-.3.2H295s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C295.5,521.9,295.4,522,295.5,522.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.6,522h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "294.8 521.7 294.8 521.7 294.8 521.7 294.8 521.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.4,523.6h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352,518.8h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.7,519.7h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,524.8h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4H343c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S343.8,524.8,343.8,524.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.9,519.4h0c-.1.1-.1.2-.2.3h-.2c-.1-.1-.1-.2,0-.3h.4S349.9,519.3,349.9,519.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.7,521.1h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S351.7,521.1,351.7,521.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,522.3s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C348.2,522.3,348.1,522.3,348.2,522.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.8 521.8 347.9 521.7 347.8 521.8 347.8 521.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.9,520.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "344.9 520.8 344.9 520.8 344.8 520.8 344.8 520.8 344.9 520.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.3,518.1a.1.1,0,0,1-.2-.1h.1C343.4,517.9,343.4,518.1,343.3,518.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.5,523.2s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.9,520.5h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.1,520.3h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S342.1,520.2,342.1,520.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.7,522.3s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C342.7,522.2,342.7,522.3,342.7,522.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.6,521.8h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0H339s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C339.6,521.7,339.7,521.7,339.6,521.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.9,525h.1C342,524.9,342,524.9,341.9,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.3,527.4h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.5,523h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S339.5,523,339.5,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.1,525h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.7,524.8s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S339.6,524.7,339.7,524.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.1,524.6h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1H338c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1H337s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,524.2h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346,524.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "345.8 524.4 345.9 524.3 345.9 524.3 345.9 524.3 346 524.3 345.8 524.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.7,524.5h0l-.3.2h-.3s0-.1,0-.1H345c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C345.7,524.3,345.6,524.4,345.7,524.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.8,524.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "345 524.1 345 524.1 345 524.1 345 524.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.4,542.4h0c.1.1-.1.1,0,.2H305v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306,537.6h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.7,538.5h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.8,543.6h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4H297c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S297.7,543.6,297.8,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.8,538.2h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3l.2-.2h.2S303.8,538.1,303.8,538.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.6,539.9h0s-.1.1,0,.1-.3-.1-.3.1H305c0-.1,0-.2.1-.2h.5S305.6,539.9,305.6,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302.2,541.2s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C302.2,541.1,302.1,541.1,302.2,541.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.8 540.6 301.9 540.6 301.8 540.6 301.8 540.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.9,539.7h0c-.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "298.8 539.6 298.8 539.6 298.8 539.7 298.8 539.6 298.8 539.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.3,536.9a.1.1,0,0,1-.2-.1h.1C297.3,536.7,297.4,536.9,297.3,536.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.8,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.5,542s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.9,539.3h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.8,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.1,539.1h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S296.1,539,296.1,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.7,541.1s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C296.6,541,296.7,541.1,296.7,541.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.6,540.6h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0H293s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C293.5,540.5,293.6,540.5,293.6,540.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.9,543.8h.1C295.9,543.7,296,543.7,295.9,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.2,546.2h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.5,541.8h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S293.5,541.8,293.5,541.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294.1,543.8h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.7,543.6s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S293.6,543.5,293.7,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292.1,543.4h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.4,543h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300,543h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "299.8 543.2 299.9 543.1 299.9 543.1 299.9 543.1 299.9 543.1 299.8 543.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.7,543.3h0l-.3.2h-.3s0-.1,0-.1H299c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1V543C299.7,543.1,299.6,543.2,299.7,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.8,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "299 542.9 299 542.9 299 542.9 299 542.9"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.8,497.8h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.4,493h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.1,493.9h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,499h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S308.1,499,308.2,499Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.2,493.5h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S314.2,493.5,314.2,493.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316,495.3h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S316,495.3,316,495.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.6,496.5s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C312.6,496.5,312.5,496.5,312.6,496.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 496 312.3 495.9 312.2 496 312.2 496"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.3,495.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.2 495 309.2 495 309.2 495 309.2 495 309.2 495"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.7,492.3a.1.1,0,0,1-.2-.1h.1C307.7,492.1,307.8,492.3,307.7,492.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,497.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,497.4s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.3,494.7h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.2,494.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.5,494.5h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5C306.6,494.4,306.5,494.4,306.5,494.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.1,496.5s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C307,496.4,307.1,496.4,307.1,496.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304,496h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C303.9,495.9,304,495.9,304,496Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.3,499.1h.1C306.3,499.1,306.4,499.1,306.3,499.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,501.6h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.9,497.2h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S303.9,497.2,303.9,497.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.5,499.2h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.1,499s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S304,498.9,304.1,499Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302.5,498.8h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,498.4h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.4,498.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.2 498.5 310.3 498.5 310.3 498.5 310.3 498.4 310.3 498.5 310.2 498.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.1,498.7h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C310.1,498.5,310,498.6,310.1,498.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.2,498.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "309.4 498.3 309.4 498.3 309.4 498.3 309.4 498.3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.7,507.7h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.3,502.9h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373,503.8h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.1,508.9h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S370,508.9,370.1,508.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.1,503.4h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3l.2-.2h.2S376.1,503.4,376.1,503.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.9,505.2h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S377.9,505.1,377.9,505.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.4,506.4s-.1,0,0,.1h0c-.1,0,0,.2-.2.1H374a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C374.5,506.3,374.3,506.4,374.4,506.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.1 505.9 374.1 505.8 374.1 505.8 374.1 505.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.2,504.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "371.1 504.9 371.1 504.9 371.1 504.9 371.1 504.9 371.1 504.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.6,502.2a.1.1,0,0,1-.2-.1h.1C369.6,502,369.7,502.1,369.6,502.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370,506.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.8,507.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.2,504.6h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.1,504.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.4,504.3h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5C368.5,504.3,368.4,504.3,368.4,504.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.9,506.4s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C368.9,506.2,369,506.3,368.9,506.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.9,505.9h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C365.8,505.8,365.9,505.8,365.9,505.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.2,509h.1C368.2,509,368.3,509,368.2,509Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.5,511.5h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.8,507.1h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S365.8,507.1,365.8,507.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.4,509.1H366c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366,508.8s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S365.9,508.8,366,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.4,508.6h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,0,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.7,508.2h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.3,508.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "372.1 508.4 372.2 508.3 372.2 508.3 372.2 508.3 372.2 508.3 372.1 508.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372,508.6h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C372,508.4,371.9,508.5,372,508.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372,508.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.3 508.1 371.3 508.1 371.3 508.2 371.3 508.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.5,498.3h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,493.5h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.8,494.4h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.9,499.5h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S348.8,499.5,348.9,499.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,494h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S354.9,494,354.9,494Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.7,495.8h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S356.7,495.7,356.7,495.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.2,497s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2V497h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C353.2,496.9,353.1,497,353.2,497Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.8 496.5 352.9 496.4 352.9 496.4 352.8 496.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350,495.5h0c-.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 495.5 349.9 495.5 349.9 495.5 349.9 495.5 349.9 495.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.4,492.8a.1.1,0,0,1-.2-.1h.1C348.4,492.6,348.5,492.7,348.4,492.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.8,497.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.6,497.9s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349,495.2h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,495.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.2,494.9h0c-.1,0-.3.2-.5.1V495h0c0-.1.1-.2.1-.2h.5S347.1,494.8,347.2,494.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.7,497s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C347.7,496.8,347.8,496.9,347.7,497Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.7,496.5h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C344.6,496.4,344.7,496.4,344.7,496.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347,499.6h.1C347,499.6,347.1,499.6,347,499.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.3,502.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.5,497.7h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S344.6,497.7,344.5,497.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.2,499.7h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.8,499.4s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S344.7,499.4,344.8,499.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.2,499.2h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1H343c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1H342s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,498.8h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.1,498.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "350.9 499 351 498.9 351 498.9 351 498.9 351 498.9 350.9 499"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.8,499.2h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C350.8,499,350.7,499.1,350.8,499.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.8,499h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "350.1 498.7 350.1 498.7 350.1 498.8 350.1 498.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333,496.7h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.7,491.9h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.4,492.8h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.5,497.9h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S325.4,497.9,325.5,497.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.5,492.4h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S331.5,492.4,331.5,492.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.3,494.2h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S333.3,494.1,333.3,494.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,495.4s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C329.8,495.3,329.7,495.4,329.8,495.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 494.9 329.5 494.8 329.5 494.8 329.4 494.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.5,493.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.5 493.9 326.5 493.9 326.4 493.9 326.4 493.9 326.5 493.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.9,491.2a.1.1,0,0,1-.2-.1h.1C325,491,325.1,491.1,324.9,491.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.4,495.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.2,496.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.6,493.6h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.5,493.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.8,493.3h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S323.7,493.2,323.8,493.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,495.4s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C324.3,495.2,324.4,495.3,324.3,495.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.3,494.9h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1,0,0,0,0h-.5c0-.1-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.5s0,.1,0,.1h.2C321.2,494.8,321.3,494.8,321.3,494.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.6,498h.1C323.6,498,323.7,498,323.6,498Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.9,500.5h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.1,496.1H321s0-.1,0-.1h0s-.1.1,0,.1h0S321.2,496.1,321.1,496.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.8,498.1h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.4,497.8s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S321.3,497.8,321.4,497.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.8,497.6h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.3c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,497.2h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.7,497.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "327.5 497.4 327.5 497.3 327.6 497.3 327.6 497.3 327.6 497.3 327.5 497.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,497.6h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C327.3,497.4,327.3,497.5,327.4,497.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,497.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "326.7 497.1 326.7 497.1 326.7 497.2 326.7 497.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.1,583.1h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.7,578.3h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.4,579.2h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.5,584.3h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S341.4,584.3,341.5,584.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.5,578.9h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S347.5,578.8,347.5,578.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.3,580.6h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S349.3,580.6,349.3,580.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.8,581.8s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C345.8,581.8,345.7,581.8,345.8,581.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.4 581.3 345.5 581.2 345.5 581.3 345.4 581.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.6,580.4h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.5 580.3 342.5 580.3 342.5 580.3 342.4 580.3 342.5 580.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,577.6a.1.1,0,0,1-.2-.1h.1C341,577.4,341.1,577.6,340.9,577.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.4,582.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.2,582.7s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.6,580h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.5,580h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.8,579.8h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S339.7,579.7,339.8,579.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.3,581.8s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C340.3,581.7,340.4,581.8,340.3,581.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.3,581.3h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a.1.1,0,0,0,0,.1h-.5c0-.1-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C337.2,581.2,337.3,581.2,337.3,581.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.6,584.5h.1C339.6,584.4,339.7,584.4,339.6,584.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.9,586.9h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.1,582.5H337s0-.1,0-.1h0s-.1.1,0,.1h0S337.2,582.5,337.1,582.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.8,584.5h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.4,584.3s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S337.3,584.2,337.4,584.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.8,584.1h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.1,583.7h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.7,583.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "343.5 583.8 343.6 583.8 343.6 583.8 343.6 583.8 343.6 583.8 343.5 583.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.4,584h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C343.3,583.8,343.3,583.9,343.4,584Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.4,583.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "342.7 583.6 342.7 583.6 342.7 583.6 342.7 583.6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.6,503.2h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426.2,498.5h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.9,499.4h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,504.5h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S417.9,504.4,418,504.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424,499h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S424,498.9,424,499Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.8,500.7h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S425.8,500.7,425.8,500.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.4,502s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C422.4,501.9,422.3,501.9,422.4,502Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "422 501.4 422.1 501.4 422 501.4 422 501.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.1,500.5h0c-.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "419 500.4 419 500.5 419 500.5 419 500.5 419 500.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.5,497.7a.1.1,0,0,1-.2-.1h.1C417.5,497.6,417.6,497.7,417.5,497.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,502.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.7,502.8s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.1,500.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,500.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.3,499.9h0c-.1,0-.3.2-.5.1V500h0c0-.1.1-.2.1-.2h.5S416.3,499.8,416.3,499.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,501.9s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1H416c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C416.8,501.8,416.9,501.9,416.9,501.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.8,501.4h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1H413a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C413.7,501.3,413.8,501.4,413.8,501.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.1,504.6h.1C416.1,504.5,416.2,504.6,416.1,504.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.4,507h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.7,502.7h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S413.7,502.6,413.7,502.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.3,504.6h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.9,504.4s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S413.8,504.4,413.9,504.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.3,504.2h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.6,503.8h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.2,503.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "420 504 420.1 503.9 420.1 503.9 420.1 503.9 420.1 503.9 420 504"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.9,504.2h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C419.9,503.9,419.8,504,419.9,504.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420,504h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "419.2 503.7 419.2 503.7 419.2 503.8 419.2 503.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M430.1,527.1h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M430.7,522.4h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.4,523.3h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.5,528.4h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S422.4,528.3,422.5,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M428.5,522.9h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S428.5,522.8,428.5,522.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M430.3,524.6h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S430.3,524.6,430.3,524.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426.8,525.9s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C426.8,525.8,426.7,525.8,426.8,525.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "426.4 525.3 426.5 525.3 426.5 525.3 426.4 525.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423.6,524.4h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "423.5 524.3 423.5 524.3 423.4 524.4 423.4 524.4 423.5 524.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.9,521.6a.1.1,0,0,1-.2-.1h.1C422,521.4,422.1,521.6,421.9,521.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.4,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.2,526.7s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.6,524h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M422.5,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.8,523.8h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S420.7,523.7,420.8,523.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.3,525.8s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C421.3,525.7,421.4,525.8,421.3,525.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.3,525.3h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a.1.1,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C418.2,525.2,418.3,525.3,418.3,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.6,528.5h.1C420.6,528.4,420.7,528.4,420.6,528.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.9,530.9h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.1,526.5H418s0-.1,0-.1h0s-.1.1,0,.1h0S418.2,526.5,418.1,526.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.8,528.5h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.4,528.3s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S418.3,528.2,418.4,528.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.8,528.1h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.1,527.7h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.7,527.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "424.5 527.9 424.6 527.8 424.6 527.8 424.6 527.8 424.6 527.8 424.5 527.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.4,528h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C424.3,527.8,424.3,527.9,424.4,528Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.4,527.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "423.7 527.6 423.7 527.6 423.7 527.6 423.7 527.6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.2,527.7h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.8,523h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.5,523.9h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1H348l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,529h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1V529h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S345.5,528.9,345.6,529Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.6,523.5h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S351.7,523.4,351.6,523.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.5,525.2h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S353.5,525.2,353.5,525.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350,526.5s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C350,526.4,349.9,526.4,350,526.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 525.9 349.7 525.9 349.6 525.9 349.6 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.7,525h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.7 524.9 346.7 524.9 346.6 525 346.6 525 346.7 524.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.1,522.2a.1.1,0,0,1-.2-.1h.1C345.2,522,345.2,522.2,345.1,522.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.3,527.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.7,524.6h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,524.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.9,524.4h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S343.9,524.3,343.9,524.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.5,526.4s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.5.5,0,0,0,0,.1h.1s-.1.1,0,.1h.1C344.5,526.3,344.5,526.4,344.5,526.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.4,525.9h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a.1.1,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C341.4,525.8,341.5,525.9,341.4,525.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.7,529.1h.1C343.8,529,343.8,529,343.7,529.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.1,531.5H344s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.3,527.1h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S341.3,527.1,341.3,527.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.9,529.1h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.5,528.9s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S341.4,528.8,341.5,528.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.9,528.7h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1H340c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,528.3H348c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.8,528.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "347.6 528.5 347.7 528.4 347.7 528.4 347.7 528.4 347.8 528.4 347.6 528.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.5,528.6h0l-.3.2H347s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C347.5,528.4,347.4,528.5,347.5,528.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.6,528.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "346.8 528.2 346.8 528.2 346.8 528.2 346.8 528.2"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.8,542.3h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.4,537.5h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.1,538.4h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.2,543.5h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S355.1,543.5,355.2,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.2,538h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S361.2,538,361.2,538Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363,539.8h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S363,539.8,363,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.6,541s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2V541h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C359.6,541,359.5,541,359.6,541Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 540.5 359.3 540.4 359.2 540.5 359.2 540.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.3,539.6h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.2 539.5 356.2 539.5 356.2 539.5 356.2 539.5 356.2 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.7,536.8a.1.1,0,0,1-.2-.1h.1C354.7,536.6,354.8,536.8,354.7,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,541.9s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.3,539.2h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.5,539h0c-.1,0-.3.2-.5.1V539h0c0-.1.1-.2.1-.2h.5S353.5,538.9,353.5,539Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.1,541s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C354,540.9,354.1,540.9,354.1,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351,540.5h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C350.9,540.4,351,540.4,351,540.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.3,543.6h.1C353.3,543.6,353.4,543.6,353.3,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.6,546.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.9,541.7h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S350.9,541.7,350.9,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,543.7h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.1,543.5s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S351,543.4,351.1,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.5,543.3h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.8,542.9h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.4,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "357.2 543 357.3 543 357.3 543 357.3 542.9 357.3 543 357.2 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,543.2h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C357.1,543,357,543.1,357.1,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.2,543.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "356.4 542.8 356.4 542.8 356.4 542.8 356.4 542.8"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.4,560.2s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.2,559.7h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.2,554.8c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.6,553.1h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.2,557.7h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.9,559.9h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,0h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.9,556.8h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C374,556.8,374,556.7,373.9,556.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.4 556.3 374.5 556.4 374.4 556.3 374.4 556.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.7,553.3h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.7 553.2 374.7 553.2 374.7 553.1 374.7 553.1 374.7 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377,551.1a.1.1,0,0,1,.1-.2h.1C377.2,551.1,377.1,551.2,377,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.5,552.6h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.1,552.4h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.8,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.8,552.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.6,550.4h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.8,551.4h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.6,548.3h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370,551.3h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.7,552.1s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.4,548.4s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.6,549.5h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.7,549.1h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C370,549,369.7,548.9,369.7,549.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.6,547.5c-.1,0,0,.1,0,.1h-.9s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.3,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.8,555.5c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.7,555.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.5 554.9 371.6 555 371.6 555 371.6 555 371.6 555 371.5 554.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.3,554.9h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C371.5,554.8,371.4,554.7,371.3,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.4,554.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.5 554.1 371.6 554.1 371.5 554.1 371.5 554.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.8,572.3s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.6,571.8h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.6,566.8c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1H334l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329,565.1h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2c0,.1,0,.1,0,.1H329Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.6,569.8h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.3,571.9h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,.1h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.3,568.8h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C332.4,568.8,332.3,568.7,332.3,568.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.8 568.3 332.9 568.4 332.8 568.4 332.8 568.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.1,565.3H333c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 565.2 333.1 565.2 333.1 565.2 333.1 565.2 333.1 565.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.4,563.1a.1.1,0,0,1,.1-.2h.1C335.6,563.2,335.4,563.3,335.4,563.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.9,564.6h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.5,564.5h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.2,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,564.2h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333,562.5h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1v.2H333Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.2,563.4h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331,560.4h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.4,563.3h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.1,564.2s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,560.5s0-.1,0-.1h.1s-.1,0-.1,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,561.6h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1H328Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.1,561.1h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C328.3,561.1,328.1,561,328.1,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,559.5c-.1,0,0,.1,0,.1h-.4s0,0,0,0H327s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2H327s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.4,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1H328Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.2,567.5c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.1,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.9 567 330 567 330 567 330 567.1 330 567.1 329.9 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.7,566.9h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C329.9,566.8,329.8,566.8,329.7,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,566.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.9 566.1 329.9 566.1 329.9 566.2 329.9 566.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.5,512.5s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.3,512.1h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.3,507.1c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.6,505.4h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2s0-.1,0-.1h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.3,510H397c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,512.2h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,0h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2H396Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394,509.1h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C394.1,509.1,394,509,394,509.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 508.6 394.5 508.7 394.5 508.6 394.5 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.8,505.6h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.8 505.5 394.8 505.5 394.7 505.5 394.8 505.5 394.8 505.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.1,503.4a.1.1,0,0,1,.1-.2h.1C397.3,503.4,397.1,503.5,397.1,503.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.5,504.9h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.2,504.7h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.9,504.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,504.4h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.7,502.7h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.9,503.7h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.7,500.6h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.1,503.6h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.8,504.4s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.4,500.8s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.7,501.8h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.8,501.4h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.2H390C390,501.3,389.8,501.2,389.8,501.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.6,499.8c-.1,0,0,.1,0,.1h-.4s0,0,0,0h-.5s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.4,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.8,507.8c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.8,507.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391.5 507.2 391.6 507.3 391.6 507.3 391.7 507.3 391.6 507.3 391.5 507.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.4,507.2h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C391.6,507.1,391.4,507,391.4,507.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.5,507.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391.6 506.4 391.6 506.4 391.6 506.4 391.6 506.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.3,513.2s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.1,512.7h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,507.7c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,506h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.1,510.7h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.8,512.8h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,.1h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,509.7h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C354.9,509.7,354.9,509.6,354.9,509.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.3 509.2 355.4 509.3 355.3 509.3 355.3 509.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,506.2h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.6 506.1 355.6 506.1 355.6 506.1 355.6 506.1 355.6 506.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.9,504a.1.1,0,0,1,.1-.2h.1C358.1,504,358,504.1,357.9,504Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.4,505.5h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353,505.4h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.7,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,505.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,503.4h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.7,504.3h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.5,501.3H353c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.9,504.2h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.6,505.1s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.3,501.4s0-.1,0-.1h.1s-.1,0-.1,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.5,502.5h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.6,502h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C350.9,502,350.7,501.9,350.6,502Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.5,500.4c-.1,0,0,.1,0,.1H350s0,0,0,0h-.5s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.3,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.7,508.4c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.6,508h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "352.4 507.9 352.5 507.9 352.5 507.9 352.5 507.9 352.5 508 352.4 507.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.2,507.8H352l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C352.4,507.7,352.3,507.7,352.2,507.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.3,507.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "352.5 507 352.5 507 352.4 507 352.5 507"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.1,526.4s0,0,0,0H325c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.9,525.9h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.1.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.9,521c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.3,519.2h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2c0,.1,0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.9,523.9h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.6,526h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,.1h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.7,522.9h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C325.7,522.9,325.7,522.8,325.7,522.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.1 522.4 326.2 522.5 326.1 522.5 326.1 522.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.4,519.4h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.4 519.3 326.4 519.4 326.4 519.3 326.4 519.3 326.4 519.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.7,517.2a.1.1,0,0,1,.1-.2h.1C328.9,517.3,328.8,517.4,328.7,517.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.2,518.8h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.8,518.6h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.5,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.5,518.3h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.4,516.6h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.5,517.5h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,514.5s0,0,0,0h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.7,517.4h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.4,518.3s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.1,514.6s0-.1,0-.1h.1s-.1,0-.1,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.3,515.7h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.4,515.2h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C321.7,515.2,321.4,515.1,321.4,515.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.3,513.6c-.1,0,0,.1,0,.1h-.4s0,0,0,0h-.5s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.3,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.5,521.6c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.4,521.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.2 521.1 323.3 521.1 323.3 521.1 323.3 521.2 323.3 521.2 323.2 521.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323,521h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C323.2,520.9,323.1,520.9,323,521Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.1,521h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.3 520.2 323.3 520.2 323.2 520.3 323.3 520.2"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "304.3",
      "y": "576.3",
      "width": "11.5",
      "height": "4.65"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.4 580.9 309.3 580.9 309.4 580.9 309.4 580.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.4 580.9 309.4 580.9 309.4 580.9 309.4 580.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310,576.8h0a0,0,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310,576.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.9,578.7h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "308.3",
      "y": "578.3",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,578.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.2,578.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.4,577.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.6,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.6,577.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.8,577.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,577.4h0Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-229",
    attrs: {
      "cx": "304.8",
      "cy": "577.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.6,577.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.4,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,577.5h0S306.7,577.5,306.7,577.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,577.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,577.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.8,578h0A0,0,0,0,1,306.8,578Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "305.4 578 305.4 578 305.4 578 305.4 578"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.5,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.9,577.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307,577.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307,577.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.8,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306,578.3h0Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-68",
    attrs: {
      "cx": "305.9",
      "cy": "578.3",
      "transform": "translate(-309.7 799.6) rotate(-81.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.6,578.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "306.1 578.3 306 578.3 306.1 578.3 306.1 578.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.2,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,578.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.3,578.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "306.3 578.4 306.3 578.4 306.3 578.4 306.3 578.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.6,579.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.1,576.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.4,578.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "307 578.8 307 578.8 307 578.8 307 578.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.8,578.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "307.3 576.8 307.3 576.8 307.3 576.8 307.3 576.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.3,576.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.4,576.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.4,576.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.7,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.1,579h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,577.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,579.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,576.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308,577h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.4,579.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.1,577.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.1,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,579.2h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,579.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,577.1h0S308.2,577.1,308.2,577.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.3 577.1 308.2 577.1 308.2 577.1 308.3 577.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.7,579.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.1,579.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.1,579.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.6,577h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "308.6 577.6 308.6 577.6 308.6 577.6 308.7 577.6 308.7 577.6 308.6 577.6 308.6 577.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.2,579.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.7,577.6h0Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-229",
    attrs: {
      "cx": "309.3",
      "cy": "578",
      "transform": "translate(-226.7 200.6) rotate(-26.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.6,579.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,577.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.8,577.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.8 577.9 309.8 577.9 309.8 577.9 309.8 577.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.4,579.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.1,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.1,578.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.2,579.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.3,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.4,579.6h.3s0,0,0,0h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.5,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,578.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.5,579.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "310.8",
      "y": "578.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.1,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.2,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.4,578.7h.2a.1.1,0,0,1,0,.1h-.2S312.4,578.7,312.4,578.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.4 578.9 312.4 578.9 312.4 578.9 312.4 578.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.1,579.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "313.1",
      "y": "579.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.2,580.5h0S313.2,580.5,313.2,580.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.7,579.1h.1a0,0,0,0,1,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.8,579h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,579.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,579.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.8,580h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,579.4h.3s0,0,0,0h0s0,0,0,.1h-.2s0,0,0,0h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.7,579.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.4,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.6,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.9,579.6h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315,578.9h.1s0,0,0,0H315Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315,579.1h.2s0,.1,0,.1H315S315.1,579.1,315,579.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.5,579.3h.4s0,0,0,0h-.3s0,0,0-.1h0s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.1,578.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.2,578.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "313.3 578.4 313.2 578.4 313.2 578.4 313.2 578.4 313.2 578.4 313.3 578.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,578.4h.2s0,0,0,0h-.2s0,0,0-.1h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,578.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "313.5 578.6 313.5 578.6 313.5 578.6 313.5 578.6"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.3",
      "y": "553.2",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-199.9 212.3) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.6,577.3h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,561.5h0v.2A.1.1,0,0,1,366.1,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.4,561.5h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.8 561.6 366.8 561.5 366.8 561.4 366.8 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.5,576c.3,0,.5.3.4.5l-.4.5s-.2-.4-.4-.2,0,.3-.1.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C377.7,576.6,378,576.2,378.5,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.6,564.2c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C372.7,564.5,372.8,564.2,372.6,564.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.2,564.1h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S372.8,564.2,373.2,564.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M373.3,564.2s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.1,575.4c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S379.8,575.4,380.1,575.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374,561.4h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2v-.3l-.6.3C373.5,561.7,373.7,561.4,374,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.2,564.2c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7H407c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3v-.2h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3V565c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,403.2,564.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.5,562c-.1.1,0,.1,0,.2s.3,0,.5,0V562c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S377.4,562,377.5,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381.6,561.2c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,381.6,561.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.3,565h-.1c.1-.1.2-.3.2-.5h-.3c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.8-.1,1.2s-.5.2-.7.4h-.1c0-.5-.6-.1-.9,0H385c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2v-.2h-.4v-.2h-.4C383.2,565.4,383.7,565.1,383.3,565Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.9,574h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2H388C388.1,574.4,387.9,574.2,387.9,574Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 565.8 384.6 565.8 384.8 565.7 384.8 565.7 384.6 565.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.1,562.9a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S387.1,562.7,387.1,562.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.2,562.2h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3c0-.1-.2-.1-.2,0h-.2c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C389,562.5,389.2,562.3,389.2,562.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.9,562.5c-.2,0,.2-.2-.1-.3s.1-.4.2-.5H397c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1v-.2h-.3c.1-.1,0-.1,0-.2h-.2C396.8,562.9,397.3,562.6,396.9,562.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "398.2 562.4 397.9 562.6 398.1 562.5 398.2 562.4"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "353.9",
      "y": "567.9",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-207.2 208.5) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.3,591.9h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.7,576.2h0v.2A.1.1,0,0,1,353.7,576.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.1,576.1h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 576.2 354.4 576.2 354.5 576 354.5 576.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,590.7c.3,0,.5.3.4.5l-.4.5s-.2-.4-.4-.2,0,.3-.1.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C365.4,591.2,365.6,590.8,366.1,590.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.3,578.8c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C360.3,579.1,360.4,578.9,360.3,578.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,578.7h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S360.4,578.9,360.9,578.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M361,578.9s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.8,590c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S367.5,590,367.8,590Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.7,576h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2v-.3l-.6.3C361.1,576.3,361.3,576,361.7,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.9,578.9c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7h-.1c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3v-.2h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3v-.2c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,390.9,578.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.2,576.6c-.1.1,0,.1,0,.2s.3,0,.5,0v-.2c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S365,576.6,365.2,576.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.3,575.8c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,369.3,575.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.9,579.6h-.1c.1-.1.2-.3.2-.5h-.3c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.7-.1,1.2s-.5.2-.7.4h-.1c0-.5-.6-.1-.9,0h-.2c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2v-.2h-.4v-.2h-.4C370.8,580,371.3,579.7,370.9,579.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.6,588.6h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2h-.9C375.7,589.1,375.5,588.8,375.6,588.6Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "372.3",
      "y": "580.4",
      "width": "0.2",
      "height": "0.05",
      "transform": "translate(-205 203.3) rotate(-24.2)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.8,577.5a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S374.7,577.3,374.8,577.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.9,576.8h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3h-.4c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C376.7,577.1,376.8,577,376.9,576.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.5,577.2c-.2,0,.2-.2-.1-.3s.1-.4.2-.5h-.1c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1v-.2h-.3c.1-.1,0-.1,0-.2h-.2C384.5,577.5,385,577.3,384.5,577.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.9 577 385.5 577.3 385.7 577.1 385.9 577"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "286.3",
      "y": "565.6",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-212.4 180) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M290.6,589.7h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M286,573.9h0v.2A.1.1,0,0,1,286,573.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M286.4,573.9h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "286.8 574 286.7 573.9 286.8 573.8 286.8 574"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.4,588.4c.3,0,.5.3.4.5l-.4.5s-.2-.4-.4-.2,0,.3-.2.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C297.7,589,297.9,588.6,298.4,588.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292.6,576.6c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C292.6,576.9,292.8,576.6,292.6,576.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M293.2,576.5h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S292.8,576.6,293.2,576.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M293.3,576.6s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.1,587.8c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S299.8,587.8,300.1,587.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294,573.8h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2V574l-.6.3C293.5,574.1,293.7,573.8,294,573.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.2,576.6c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7H327c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3v-.2h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3v-.2c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,323.2,576.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.5,574.4c-.1.1,0,.1,0,.2s.3,0,.5,0v-.2c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S297.3,574.4,297.5,574.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.6,573.6c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,301.6,573.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.2,577.4h-.1c.1-.1.2-.3.2-.5H303c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.8-.1,1.2s-.5.2-.7.4H306c0-.5-.6-.1-.9,0H305c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2V578h-.4v-.2h-.4C303.1,577.8,303.6,577.5,303.2,577.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,586.4h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2H308C308,586.9,307.9,586.6,307.9,586.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304.6 578.2 304.6 578.2 304.7 578.1 304.8 578.1 304.6 578.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.1,575.3a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S307,575.1,307.1,575.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.2,574.6h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3h-.4c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C309,574.9,309.2,574.7,309.2,574.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.9,574.9c-.2,0,.2-.2-.1-.3s.1-.4.2-.5H317c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1v-.2h-.3c.1-.1,0-.1,0-.2H317C316.8,575.3,317.3,575.1,316.9,574.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.2 574.8 317.8 575 318 574.9 318.2 574.8"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "303.7",
      "y": "523",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-193.1 183.4) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308,547.1h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.4,531.3h0v.2A.1.1,0,0,1,303.4,531.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.8,531.3h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304.2 531.3 304.1 531.3 304.2 531.2 304.2 531.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.8,545.8c.3,0,.5.3.4.5s-.2.3-.4.5-.2-.4-.4-.2,0,.3-.1.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C315.1,546.3,315.3,545.9,315.8,545.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310,534c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C310,534.2,310.2,534,310,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,533.8h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S310.2,534,310.6,533.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M310.7,534s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.5,545.2c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S317.2,545.2,317.5,545.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.4,531.2h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2v-.3l-.6.3C310.9,531.5,311.1,531.2,311.4,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.6,534c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7h-.1c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3V535h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3v-.2c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,340.6,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.9,531.8c-.1.1,0,.1,0,.2s.3,0,.5,0v-.2c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S314.7,531.8,314.9,531.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319,530.9c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,319,530.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M320.6,534.8h-.1c.1-.1.2-.3.2-.5h-.3c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.7-.1,1.2s-.5.2-.7.4h-.1c0-.5-.6-.1-.9,0h-.2c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2v-.2H321v-.2h-.4C320.5,535.2,321,534.9,320.6,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.3,543.8h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2h-.9C325.4,544.2,325.3,544,325.3,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 535.6 322 535.6 322.2 535.5 322.2 535.5 322 535.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.5,532.6a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S324.4,532.5,324.5,532.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.6,532h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3H328c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C326.4,532.2,326.6,532.1,326.6,532Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.3,532.3c-.2,0,.2-.2-.1-.3s.1-.4.2-.5h-.1c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1V533h-.3c.1-.1,0-.1,0-.2h-.2C334.2,532.6,334.7,532.4,334.3,532.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.6 532.2 335.2 532.4 335.4 532.3 335.6 532.2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "337.7",
      "y": "499",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-146.6 144.4) rotate(-19)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.4,498.2h-.1v-.2c-.1,0,0,.2.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.5,514.3h0v-.2A.1.1,0,0,1,377.5,514.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.1,514.3H377l-.2.3h0c-.1.1,0,.2,0,.3s.3-.2.4-.3h.1c-.2.3-.5.3-.8.4l-.2-.2a.9.9,0,0,1,1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.7 514.2 376.7 514.2 376.7 514.4 376.7 514.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.5,498.6c-.3,0-.4-.3-.4-.6l.4-.4s.1.4.3.2,0-.3.2-.4v.2c.2.1.3-.1.5,0v.2h.3C367.3,498.2,367,498.6,366.5,498.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.2,511c-.4.2-.7.6-1.1.2s.1-.5.3-.7l.6-.2h0l.3.2h.2C371.2,510.7,371,510.9,371.2,511Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.5,511.1h.3l-.2.2c-.2,0-.2-.3-.2-.4s.4-.1.5-.3S371,510.9,370.5,511.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M370.5,510.9s.1-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.8,499.1c-.1,0-.1-.2-.1-.3s.4-.3.6-.4-.2.1-.3.3l.2.2c0-.1.2-.2.3-.2S365.1,499.1,364.8,499.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.5,513.6h-.2l.2-.3s-.1.1,0,.1h.1v-.3c.1.1.2,0,.3,0h-.2v.3l.6-.2C370.1,513.4,369.8,513.6,369.5,513.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.7,507.9c0,.4.4,0,.6.1s-.4,0-.4.3a.5.5,0,0,0,.6-.1h0c-.2.3-.9.3-.9.8s.3.1.2.2-.4.6-.8.8h.2l-1.1.4c.4.3-.6.3-.4.6s-.6-.2-.7,0-1.2-.4-1.4-.9,0-.4-.1-.7h.1c0-.1.1-.3-.1-.4a.6.6,0,0,0,.3-.5c-.1-.2.1-.6.3-.5s0-.1,0-.2l.2-.2c.4-.3,1-.5,1.3-1.1v.2l.2.2.3-.5c0,.2-.2.5,0,.7s.3-.1.5-.2v.2c.2.1.4-.3.7-.2s.1.5.5.6l.6-.2A.7.7,0,0,0,340.7,507.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,512.7c.1,0,0-.1,0-.2s-.3,0-.5,0v.2c.2.1.2-.2.3,0s-.4.1-.6.2.1-.5.3-.5.4,0,.7,0S366.3,512.7,366.1,512.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.9,513.1c-.3,0-.7-.3-.7-.5s0-.2,0-.3-.7-.1-.6-.5,1.8-.3,2.4-.2v.2h.3A1.8,1.8,0,0,1,361.9,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.7,509.2h.1c-.2.1-.2.3-.3.5h.3c0,.1-.4.1-.2.4h.1c-.6.1-.5.6-1,.7s-.9.2-1.2.4-.3-.2-.4-.3l-.3-1a1.7,1.7,0,0,0,.3-.7,1.5,1.5,0,0,1-.9-.5c-.4-.5.2-.7.2-1.2s.5-.2.7-.4h.1c-.1.5.6.1.9.1h.2c-.1.1-.3.2-.2.3h.4l-.2.2h.2c-.1,0-.1.1-.1.2h.2l-.2.2c.2.1.4.1.4.3h.6v.2h.4v.2h.4C360.8,508.7,360.3,509,360.7,509.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.9,499.7h.2c-.3.3-.4,1-1,1.2a2.1,2.1,0,0,1-1.1,0c-.4-.5-.2-.9,0-1.5s.7-.5,1.1-.6h0v.2h.9C356.8,499.3,356.9,499.5,356.9,499.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.4 508.2 359.4 508.2 359.2 508.3 359.2 508.2 359.4 508.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.6,510.9a.2.2,0,0,1,0-.1c0,.1.2.3.3.1S356.7,511.1,356.6,510.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.5,511.4h.1c.1,0-.2.2-.1.3s-1.1-.5-1.5.4-.9.1-1.2-.4.1-.7.4-1l.5-.3c0,.1.1.1.2.1h.2c-.1.4.4,0,.6.2h-.1c.2.3.5,0,.7.3h.2C354.7,511.1,354.5,511.2,354.5,511.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.8,510.3c.2,0-.3.2,0,.3s-.1.4-.3.5h.1c-.5,0-.1.7-.9.6s-.6-.1-.8.1a1,1,0,0,1-.6-1.1c.1-.5.1-.2.3-.7v-.2c.3.3.2-.5.5-.2s.3-.3.5-.3a.2.2,0,0,0,0,.2c.2.1.3-.1.4-.1v.2h.3c-.1,0,0,.1,0,.2h.2C347,509.9,346.4,510.1,346.8,510.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.5 510.3 345.9 510.1 345.7 510.2 345.5 510.3"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-237"
  }, [_c('g', [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "364.2",
      "y": "546.5",
      "width": "3.3",
      "height": "6.52",
      "transform": "translate(-294.4 563.1) rotate(-57.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,550s.1.1,0,.2-.1.2-.1.4h-.2c-.1,0-.1.2-.1.2s.1-.1,0-.2h-.8c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h0a.7.7,0,0,0,.1-.3h.2s0,0,0,0h.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.3 550.2 369.3 550.2 369.3 550.2 369.3 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.3 369.1 550.3 369.1 550.3 369.1 550.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.2 550.4 369.2 550.3 369.2 550.4 369.2 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.4 369.1 550.4 369.1 550.4 369.1 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.5 369.1 550.4 369.1 550.5 369.1 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.5 369.2 550.5 369.2 550.5 369.1 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369 550.5 369 550.4 369 550.4 369 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,549.6h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.2 550.6 369.2 550.6 369.2 550.6 369.2 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,549.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369,550.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 550.1 368.3 550.1 368.3 550.1 368.3 550.1 368.3 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,547.9v.2h-.1l-.3.2h-.3c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.4,548.3a1.1,1.1,0,0,1,.1.4h-.1v-.4s0-.1,0-.1S364.4,548.3,364.4,548.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,550.4h0S367.7,550.4,367.7,550.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.7,549.6h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.4s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.3c0-.1,0-.1,0-.1h.1s0,.1,0,.2h.4s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.8,550.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.6,551.3c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.4s.1-.1,0-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.8 550.1 365.8 550.1 365.8 550.2 365.7 550.2 365.8 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.4,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0S367.5,551.4,367.5,551.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 551.4 367.4 551.4 367.4 551.4 367.4 551.4 367.4 551.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.3,551.4s0,0,0,0S367.3,551.4,367.3,551.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.5 551.5 367.5 551.5 367.5 551.5 367.5 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368 551.8 368 551.8 368 551.8 368 551.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.2,550.7H366a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,551.4h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,367.1,551.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.3H367s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,551.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.2 551.5 367.3 551.5 367.3 551.5 367.2 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368 551.9 368 551.9 368 551.9 368 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,551.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.1 551.4 367.1 551.4 367.1 551.4 367.1 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.5 551 366.5 551 366.5 551 366.5 551"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367 551.4 367 551.4 367 551.4 367 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.5 551.1 366.5 551.1 366.5 551.1 366.5 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,550.3h-.2C363.9,550.1,364.1,550.2,364.1,550.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.7,551.4h-.2s0,0,0-.1h.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "358.9",
      "y": "542.3",
      "width": "3.6",
      "height": "7.13",
      "transform": "translate(-292.3 504.5) rotate(-52.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.4,546.4c0,.1.1.1,0,.2s-.1.3-.1.4h-.1s0-.1-.1-.1-.1.2-.2.2.1-.2,0-.2h-.7v.2h-.1c0-.1.1-.1.1-.2h-.1v.2h0c0-.1.2-.2.2-.3h0v-.3c0-.1-.1-.1-.1-.1h.3s0,0,0,0h.2c0-.1-.1,0-.1-.1h.6C364.1,546.2,364.3,546.3,364.4,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.3 546.6 364.3 546.6 364.3 546.6 364.3 546.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,545.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 546.7 364.1 546.7 364.1 546.7 364.1 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 546.8 364.2 546.8 364.2 546.8 364.2 546.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 546.9 364.1 546.9 364.1 546.9 364.1 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 546.9 364.1 546.9 364.1 546.9 364.1 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 547 364.2 547 364.2 547 364.1 547"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364 546.9 364 546.9 364 546.9 364 546.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,545.8l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 547 364.2 547 364.2 547 364.2 547"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,545.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.6,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.4,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364,547.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.2 546.5 363.2 546.5 363.2 546.5 363.2 546.5 363.2 546.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.3,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,543.7v.2h-.2l-.3.2h-.3c.2,0,.3-.2.5-.2s.2,0,.3.1S358.7,543.6,358.7,543.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.7,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.7,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,544.1a1.2,1.2,0,0,1,.1.5h-.1a2.7,2.7,0,0,0-.1-.4s0-.1,0-.1S359.2,544.1,359.2,544.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.5,545.6v.2h-.2c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h-.1s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.5s0-.1,0-.1-.3,0-.4-.2,0-.2.1-.2h.4v-.2c0-.1.1-.1,0-.1h.1c0,.1,0,.1,0,.2h.5c0-.1-.2,0-.2-.1h.2s0-.1.1-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,546.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,547.7c0,.1-.1.2-.2.3h0c0-.1.1,0,0-.1h0v-.2h-.1s-.1-.1,0-.1h-.4s.1,0,.1-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 546.3 360.5 546.3 360.5 546.3 360.5 546.3 360.5 546.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.3,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.2,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.8h0S362.3,547.8,362.3,547.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.2 547.8 362.2 547.8 362.2 547.8 362.2 547.8 362.2 547.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.1,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.1,547.7s0,0,0,0S362.1,547.7,362.1,547.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.3 547.9 362.3 547.9 362.3 547.9 362.3 547.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.8 548.3 362.8 548.3 362.8 548.3 362.8 548.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.9,546.9h-.2a.3.3,0,0,1,.1-.2h.1S360.9,546.9,360.9,546.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,547.8h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,361.9,547.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.1,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,547.6h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,547.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362 547.9 362 547.9 362 547.9 362 547.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.7 548.4 362.7 548.4 362.7 548.4 362.7 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,547.7h0S361.7,547.7,361.7,547.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.7,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.6,547.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 547.8 361.8 547.7 361.8 547.8 361.8 547.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.2 547.3 361.2 547.3 361.2 547.3 361.2 547.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 547.8 361.8 547.7 361.8 547.8 361.8 547.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.2 547.4 361.2 547.3 361.2 547.4 361.2 547.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,546.3h-.2C358.5,546.1,358.7,546.2,358.6,546.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,547.6h-.3s0-.1,0-.1h.1C360.3,547.5,360.4,547.6,360.4,547.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "355.6",
      "y": "540.7",
      "width": "4",
      "height": "7.77",
      "transform": "translate(-292.5 586.7) rotate(-60.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.7,544.7c0,.1.1.1.1.2s-.1.3-.1.4h-.1s0,.1,0,.1h-.1c-.1,0-.1.2-.1.3s.1-.2,0-.2h-.5s0,.1,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1v.2h0c0-.1.2-.2.1-.4h-.1a.1.1,0,0,0,0-.1h-.4l.3-.2h.1a.9.9,0,0,0,.1-.4c0-.1-.2,0-.1-.1h.3s0,0,0,0h.2c0-.1-.1,0-.2-.1l.6-.2C361.4,544.5,361.6,544.5,361.7,544.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.6 544.9 361.6 544.9 361.6 544.9 361.6 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,543.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 545 361.4 545 361.4 545 361.4 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.5 545.1 361.5 545.1 361.5 545.1 361.5 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 545.2 361.5 545.2 361.5 545.2 361.4 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 545.2 361.4 545.2 361.4 545.2 361.4 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.5 545.3 361.5 545.3 361.5 545.3 361.5 545.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.3 545.2 361.3 545.2 361.3 545.2 361.3 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,544.3l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.5 545.3 361.5 545.3 361.5 545.3 361.5 545.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.7,544.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.7,544.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.6,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.3,545.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.4 544.9 360.4 544.9 360.4 544.9 360.4 544.9 360.4 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,542.5c0,.1-.1.1-.1.2h-.2l-.3.2s.1-.1.1-.2h-.4c.2,0,.3-.3.5-.3s.3-.1.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.2,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,542.9a1.3,1.3,0,0,1,.2.5h-.1l-.2-.5s-.1-.1,0-.1S355.7,542.9,355.7,542.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,545.2h0S359.8,545.2,359.8,545.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,544.3v.2H357c0-.1-.2,0-.1-.1h-.1c0,.1,0,.2.1.2h-.1s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.5s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.4v-.2c0-.1,0-.1,0-.1h.1c0,.1,0,.1.1.2h.5c0-.1-.2,0-.2-.1h0c.1,0,.2,0,.2-.1s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,543.7c0-.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,545s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,546.3c0,.1-.1.2-.2.3h0c0-.1.1,0,0-.1h0v-.2h-.1c0-.1-.1-.1,0-.1h-.2l-.2.2s.1-.1.1-.1a.4.4,0,0,1,.3-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.4 545 357.4 545 357.4 545.1 357.4 545 357.4 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.4h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.5,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.5h0S359.6,546.5,359.6,546.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.5 546.4 359.5 546.4 359.5 546.5 359.5 546.5 359.5 546.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,546.4s0,0,0,0S359.4,546.4,359.4,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.6 546.5 359.6 546.5 359.6 546.5 359.6 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.2 546.9 360.2 546.9 360.2 546.9 360.2 546.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,545.7h-.3a.3.3,0,0,1,0-.2h.1C357.9,545.6,358,545.6,358,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,546.5c-.1.1-.2.1-.3.2h-.1a.3.3,0,0,0,0-.2h.3A.1.1,0,0,1,359.1,546.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.3h0c0,.1-.1.1-.1.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.3 546.6 359.3 546.6 359.3 546.6 359.3 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.1 547.1 360.2 547 360.2 547 360.1 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,545.7h0S357.7,545.7,357.7,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,546.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 546.5 359 546.5 359 546.5 359 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.3 546.1 358.3 546.1 358.3 546.1 358.3 546.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 546.5 359 546.5 359 546.5 359 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.4 546.1 358.4 546.1 358.4 546.1 358.4 546.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,545.3h-.3C355.3,545.1,355.4,545.2,355.4,545.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,546.6h-.3s0-.1,0-.1h.1C357.4,546.4,357.5,546.5,357.5,546.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.2",
      "y": "542.1",
      "width": "4.5",
      "height": "8.72",
      "transform": "translate(-288.6 635.3) rotate(-64.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.9,546.7c0-.1-.1-.1-.1-.2s0-.3.1-.5.1-.1.1-.1,0-.1,0-.1h.1c.1-.1.1-.2.1-.3s0,.2.1.2h.3l.2-.2s0-.1,0-.1h.3V545h.1c0,.1-.1.1,0,.2h.1c0-.1.1-.1.1-.2h.1c0,.2-.2.3-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.4.2h-.1a1,1,0,0,0-.1.4c0,.1.2,0,.2.1h-.5c0,.1.1,0,.2.1l-.7.2C355.2,546.9,355,546.9,354.9,546.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 546.5 354.9 546.5 354.9 546.5 354.9 546.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,547.4h.2A.2.2,0,0,1,357.5,547.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 546.3 355.1 546.3 355.1 546.3 355.1 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 546.2 355 546.2 355 546.2 355 546.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 546.1 355.1 546.1 355.1 546.1 355.1 546.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 546.1 355.1 546.1 355.1 546.1 355.1 546.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 546 355 546 355 546 355 546"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 546.1 355.2 546.1 355.2 546.1 355.2 546.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,547l-.3-.2h.1l.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 545.9 355 546 355 546 355 545.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,546.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,546.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,545.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 546.4 356.2 546.4 356.2 546.3 356.3 546.4 356.2 546.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,546.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,548.6c0-.1.1-.2.1-.2h.2l.3-.3s-.1.1,0,.2h.4c-.3,0-.3.3-.5.3s-.3.1-.4,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,545.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.5,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.7,548.2a1.4,1.4,0,0,1-.3-.5h.1l.2.5s.1.1,0,.1S361.7,548.2,361.7,548.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,545.9h0S357,545.9,357,545.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,546.7v-.2h.2c0,.1.2,0,.2.1h.1c-.1-.1,0-.2-.1-.3h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.1a.1.1,0,0,0,.1-.2h.3c0-.1.1,0,.1-.1s0,.1,0,.1.3,0,.5.1,0,.2-.1.3.1.1.2.1H361v.2c0,.1,0,.1,0,.1h-.2v-.2h-.6c0,.1.2,0,.3.1a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.3,547.3c0,.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,546s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,544.7c0-.2.1-.3.2-.4h0c0,.1-.1,0,0,.1h0a.3.3,0,0,0-.1.2h.1c0,.1.1.1,0,.1h.3c.1,0,.1-.2.2-.2s-.1.1,0,.1a.5.5,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.6 546 359.6 546 359.6 545.9 359.6 545.9 359.6 546"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,544.6h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,544.5h0S357,544.5,357,544.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 544.6 357.2 544.6 357.2 544.5 357.2 544.5 357.2 544.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,544.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.1 544.5 357 544.5 357 544.4 357.1 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.3 544.1 356.3 544.1 356.3 544.1 356.3 544.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,545.3h.3a.4.4,0,0,1,0,.2h-.1C359,545.4,358.9,545.3,358.9,545.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,544.5c0-.2.2-.1.3-.2h.1a.3.3,0,0,0,0,.3h-.3A.1.1,0,0,1,357.5,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,544.6h0c0-.1.1-.1.1-.2h.1s0,0,0,.1h-.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.4 544.4 357.4 544.4 357.4 544.4 357.4 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.4 543.9 356.4 543.9 356.4 543.9 356.4 543.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,544.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.7 544.5 357.7 544.5 357.7 544.5 357.7 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 544.9 358.5 544.9 358.5 544.9 358.5 544.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.7 544.5 357.7 544.5 357.7 544.5 357.7 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 544.8 358.4 544.8 358.5 544.8 358.5 544.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.8,545.5v-.2h.3s0,.2-.1.2S361.8,545.6,361.8,545.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,544.3h.2A.2.2,0,0,1,359.4,544.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "346.9",
      "y": "541.9",
      "width": "6.8",
      "height": "3.45",
      "transform": "translate(-263 749) rotate(-75.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,540.2h.8s-.1,0,0,.1h.2s0-.1,0-.1h.2v.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0h-.3s0,0,0,.1h-.1c0,.1.1.2.1.3l-.2-.2c.1.1,0,.2,0,.2v-.3h-.3s0,.1-.1.2,0-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.1l-.3-.5A.6.6,0,0,1,349.4,540.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.6 540.2 349.6 540.2 349.6 540.2 349.6 540.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,542.3h0A.1.1,0,0,1,349.3,542.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 540.3 349.7 540.3 349.7 540.3 349.7 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.8 540.2 349.7 540.2 349.8 540.2 349.8 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.8 540.3 349.8 540.3 349.9 540.3 349.8 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.9 540.3 349.9 540.3 349.9 540.3 349.9 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 540.2 349.9 540.2 349.9 540.2 350 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.9 540.4 349.9 540.4 349.9 540.4 349.9 540.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,542v-.2h0v.2S349.5,542,349.5,542Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 540.2 350 540.2 350 540.2 350 540.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,541.9h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,540.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "349.8",
      "y": "541.2",
      "height": "0.02",
      "transform": "translate(-259.1 752) rotate(-76.2)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,546.2h.2c0,.1,0,.1,0,.1l.2.2h-.1c-.1,0,0,.1,0,.2s.1.1,0,.2-.3-.2-.3-.3-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,541.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,545.6l.4-.3h0l-.3.2h-.1C349.2,545.6,349.3,545.6,349.3,545.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,543.9h.2v.2c-.1,0,.1.1,0,.1h.8c-.1.2.1.3,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.4h-.1c0-.1,0-.2,0-.2v-.2c-.1,0,0,.1,0,.2h-.1c0-.1,0-.2-.1-.1H350a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,541.5h.3c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2l-.3-.2C351.2,541.6,351.2,541.5,351.2,541.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.7 543.7 350.7 543.7 350.7 543.7 350.7 543.7 350.7 543.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,541.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,541.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.3 541.6 351.3 541.6 351.4 541.6 351.4 541.6 351.3 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.4 541.6 351.4 541.5 351.4 541.5 351.4 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 540.9 351.6 540.9 351.6 540.9 351.6 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.1,543.1l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,541.9c.1,0,.1.1.2.2h-.3c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.1s0,0,0,0h.1s0,0,0,0h-.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.2h0S351.4,542.2,351.4,542.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.5 541.8 351.5 541.8 351.5 541.8 351.5 541.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.7 540.9 351.7 540.9 351.7 540.9 351.7 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 542 351.5 542 351.5 542 351.5 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.3 542.7 351.3 542.7 351.3 542.7 351.3 542.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 542 351.5 542 351.5 542 351.5 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.4 542.7 351.3 542.7 351.3 542.7 351.4 542.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352,541h0S352,541,352,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,545.3h.1c0,.1.1.2,0,.2h-.2C351.2,545.5,351.2,545.3,351.4,545.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,543.3h.1a.1.1,0,0,1,0,.1h-.2A.1.1,0,0,1,351.9,543.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "349.7",
      "y": "534.4",
      "width": "4.2",
      "height": "8.2",
      "transform": "translate(-231.5 809.8) rotate(-81.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.8,540s-.2-.1-.2-.2-.1-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2l.2-.2h.1v-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.2,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.1l-.6.4A.7.7,0,0,1,347.8,540Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.8 347.8 539.8 347.8 539.8 347.8 539.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,539.9v-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 539.6 347.9 539.6 347.9 539.6 347.9 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.6 347.8 539.6 347.7 539.6 347.8 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.5 347.8 539.5 347.8 539.4 347.8 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.4 347.8 539.4 347.8 539.4 347.8 539.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 539.3 347.7 539.4 347.7 539.3 347.7 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 539.4 347.9 539.4 347.9 539.4 347.9 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 539.3 347.7 539.3 347.7 539.3 347.7 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,539.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 539.3 348.9 539.3 348.9 539.3 348.9 539.3 348.9 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,539.7c0-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,539.4l-.4-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S354.3,539.5,354.3,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,538.7c0-.1.1-.1.1-.2h.2c.1.1.1-.1.2,0h.1l-.2-.2h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5-.1s.1.2,0,.3h.2s0,.1,0,.1h.2l-.5.3s-.1.1-.1.1h.1c.1,0,0,.1,0,.1h-.8c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.8,538.8c.1,0,0,0,0,.1S353.7,538.8,353.8,538.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,538.1h.2a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,538.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,537.6c-.1-.1,0-.3,0-.4l.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.8 538 351.8 538 351.8 538 351.8 538 351.8 538"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,537.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,537.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.3 537.5 349.3 537.5 349.3 537.4 349.3 537.4 349.3 537.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,537.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.1 537.4 349.1 537.4 349.1 537.4 349.1 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.4 537.3 348.3 537.3 348.3 537.3 348.4 537.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,537.6a.3.3,0,0,1,.2-.2.3.3,0,0,1,.1.2H351Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,537.3c0-.1.1-.2.2-.3h.1a.3.3,0,0,0,.1.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,537.3h0c0-.1.1-.2,0-.2h0s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.4 537.3 349.4 537.3 349.4 537.2 349.4 537.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.4 537.1 348.4 537.1 348.4 537.1 348.4 537.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,537.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 537.2 349.7 537.3 349.7 537.3 349.7 537.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 537.4 350.5 537.4 350.5 537.4 350.5 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 537.2 349.7 537.2 349.7 537.2 349.7 537.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 537.3 350.5 537.3 350.5 537.3 350.5 537.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.4,536.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.7,537c0-.1,0-.1,0-.2h.4c0,.1,0,.2-.1.2S353.7,537.1,353.7,537Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,536.6c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.4",
      "y": "532.2",
      "width": "4.4",
      "height": "8.57",
      "transform": "translate(-104.1 86.9) rotate(-12.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,539.9c0,.1,0,.2-.1.2s-.3.2-.4.3h-.3s.1-.1,0-.1-.2.1-.3.1.2-.1.2-.2h-.2s.1.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.9c.1-.1.3,0,.4-.2h0c0-.2-.2-.2-.3-.3l.4.2-.2-.2.3.2.4-.2c0-.1-.1-.2,0-.2s0,.1.1.2h.4c.1-.1-.1-.1,0-.2l.6.4C362.5,539.5,362.6,539.7,362.5,539.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.3 540 362.3 540 362.3 540 362.3 540"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,537.4h-.2a.2.2,0,0,1,0-.2h.1A.2.2,0,0,1,361.5,537.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362 540 362.1 540 362.1 540 362 540"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.1 540.1 362.1 540.1 362.1 540.1 362.1 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 540.1 362 540.1 361.9 540.1 361.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 540.1 361.9 540.1 361.9 540.1 361.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 540.2 361.9 540.2 361.9 540.2 361.9 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 540 361.8 540 361.8 540 361.8 540"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.4,538a.9.9,0,0,1,0,.3h-.1c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 540.3 361.9 540.3 361.9 540.3 361.8 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.4,538.1h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.4,538h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.4,538.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.5,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,540.2h0S361.7,540.2,361.7,540.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 539 361.4 539 361.4 539 361.4 539 361.4 539"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,532.9H359c.1-.1,0-.2,0-.2v-.2c.1.2.4,0,.6.2s.3.1.2.3S359.5,532.9,359.5,532.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,533.7a1.4,1.4,0,0,1-.2.5h-.1s0-.1,0-.1l.3-.5h.1C359.7,533.6,359.6,533.7,359.6,533.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,536.1h-.4c0-.1-.1-.1,0-.2H359c0,.1-.1.1-.1.3h-.3c-.1,0,0,.1-.1.1s0-.1,0-.1h-.4s0-.1,0-.1H358c0-.2-.2-.2-.2-.4h.3c.1-.1,0-.1,0-.2h.1c-.1-.1,0-.2-.1-.2l.5.4h.1V535h.1c.1.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1-.1-.3h.1c.1,0,.1.2.2.1h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,536.7h0A.1.1,0,0,1,359.2,536.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,536.7h0S359.2,536.7,359.1,536.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,539.5c-.1.1-.3.1-.4.1s-.2-.1-.3-.2h.3s0,0,0,0h.2c.1,0,0-.1.1-.1h-.1s0,.1,0,.1h.1C359.7,539.4,359.7,539.5,359.7,539.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.1 536.7 359.1 536.7 359.1 536.7 359.1 536.7 359.1 536.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.5,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.5 539.4 359.5 539.4 359.4 539.4 359.4 539.4 359.5 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.4 539.5 359.5 539.5 359.4 539.6 359.4 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.6 540.4 359.6 540.4 359.6 540.4 359.6 540.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,539.4s0,0,0,0S359.4,539.4,359.4,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,537.6h0C359,537.5,359,537.6,358.9,537.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,539.1c-.1.1-.2-.1-.3-.1s0-.1,0-.1l.2-.2h.2c.1,0,0,.2.1.2A.1.1,0,0,1,359.2,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,538.9H359s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,538.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 539.3 359.2 539.3 359.2 539.3 359.2 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.4 540.4 359.5 540.4 359.4 540.4 359.4 540.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,538.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.1 539.1 359.1 539.1 359.1 539.1 359.1 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 538.2 358.9 538.2 358.9 538.2 358.9 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.1 539 359.1 539 359.1 539.1 359.1 539"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 538.2 358.9 538.2 358.9 538.2 358.9 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,540.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,535.3h-.2c-.1-.1-.2-.1-.2-.3h.3C357.4,535,357.5,535.2,357.4,535.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,537.8h-.2a.2.2,0,0,1-.1-.2h.2A.2.2,0,0,1,357.9,537.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "355.6",
      "y": "527.6",
      "width": "3.7",
      "height": "7.16",
      "transform": "translate(-145.3 134.8) rotate(-17.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,528.6c0-.1,0-.2.1-.2s.2-.2.3-.2h.2s-.1.1,0,.1h.3c0,.1-.1.1-.1.2h1l-.3.2h0c0,.1.2.1.3.3h-.3l.2.2-.3-.2-.3.2c0,.1.1.1,0,.2s0-.1-.1-.2h-.3c-.1.1.1.1.1.1l-.5-.3C354.8,528.9,354.7,528.8,354.7,528.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 528.5 354.9 528.5 354.9 528.5 354.9 528.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,530.5h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,355.8,530.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 528.5 355.1 528.5 355.1 528.5 355.1 528.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 528.4 355.1 528.4 355.1 528.4 355.1 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.4 355.2 528.4 355.2 528.4 355.2 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.4 355.2 528.4 355.2 528.4 355.2 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.3 355.2 528.3 355.2 528.3 355.2 528.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.3 528.4 355.3 528.4 355.3 528.4 355.3 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,530.1a.8.8,0,0,1-.1-.3h.1c0,.1.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.2 355.2 528.2 355.2 528.2 355.2 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,530h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,529.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.6,529.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.4,528.3h0S355.4,528.3,355.4,528.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.7 529.2 355.7 529.2 355.7 529.2 355.7 529.2 355.7 529.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,534.1h.5c0,.1,0,.1.1.2h.1c-.1-.2-.3,0-.5-.1s-.2-.1-.2-.2S357.8,534.2,357.8,534.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,533.5a1.2,1.2,0,0,1,.2-.4h.1s0,.1,0,.1l-.2.4h-.1C357.6,533.6,357.6,533.5,357.7,533.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,531.5h.4c0,.1.1.1,0,.2h.1c0-.1.1-.1.1-.2h.3c.1,0,0-.1,0-.1s0,.1,0,.1h.3s0,0,0,.1h.1c0,.2.2.2.2.4h-.2c-.1.1,0,.1,0,.2h-.1c.1,0,0,.1.1.2l-.4-.3h-.1v.2h-.1s0-.1,0-.2v-.4h-.2c-.1.1.1.1.1.2h-.3a.3.3,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,532.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,530.9h0A.1.1,0,0,1,357.8,530.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,528.7h.3s0,0,0,0h-.1c-.1,0,0,.1-.1.1h.1s0-.1,0-.1h-.1C357.1,528.8,357.1,528.7,357.1,528.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.8 531 357.8 531 357.8 531 357.8 531 357.8 531"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.3 528.7 357.3 528.7 357.3 528.7 357.3 528.7 357.3 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,528.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.3 528.6 357.3 528.6 357.3 528.6 357.3 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.1 528 357.1 528 357.1 527.9 357.1 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,528.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,530.2h0C357.8,530.3,357.8,530.2,357.9,530.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,528.9h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.2A.1.1,0,0,1,357.5,528.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.5 528.8 357.5 528.8 357.5 528.8 357.5 528.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 527.9 357.2 527.9 357.2 527.9 357.2 527.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.6 529 357.6 529 357.6 529 357.6 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.9 529.7 357.8 529.7 357.8 529.7 357.9 529.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.6 529 357.6 529 357.6 529 357.6 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.9 529.7 357.8 529.7 357.9 529.7 357.9 529.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.6,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,532h.2c.1.1.2.1.1.2h-.2C359.3,532.2,359.3,532.1,359.4,532Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,529.9h0A.1.1,0,0,1,358.7,529.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "350.6",
      "y": "523.6",
      "width": "7.7",
      "height": "3.91",
      "transform": "translate(-262.1 673.3) rotate(-69.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,521.6h.2c.2-.1.3,0,.5,0h.2s-.1,0-.1.1h.1v.2s0-.1,0-.1h0l.2.2h.1c.1,0,0,.2.1.2h.2s0,0,0,0h-.4s0,.1,0,.1H355c-.1.1.1.3,0,.4l-.2-.3c.1.1,0,.2,0,.3v-.3h-.4s0,.2-.1.2.1-.1.1-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.2-.4-.3-.6S353.8,521.8,353.9,521.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.1 521.7 354.1 521.7 354.1 521.7 354.1 521.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,524h.1v.2h-.1A.1.1,0,0,1,353.5,524Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.3 521.8 354.3 521.8 354.3 521.8 354.3 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.4 521.7 354.3 521.7 354.3 521.7 354.4 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.4 521.8 354.4 521.7 354.5 521.8 354.4 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 521.8 354.5 521.8 354.5 521.8 354.5 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.6 521.7 354.5 521.7 354.6 521.7 354.6 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 521.9 354.5 521.9 354.5 521.9 354.5 521.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,523.7v-.3h0v.3S353.8,523.7,353.9,523.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.6 521.7 354.6 521.7 354.6 521.7 354.6 521.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,522.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.7,521.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.3 522.8 354.3 522.8 354.3 522.8 354.3 522.8 354.3 522.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,522.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,528.3h.2c0,.1,0,.1,0,.2l.2.3h-.2c-.1,0-.1.1-.1.2s.1.1,0,.2-.3-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.9,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.8,523s0,0,0,0S354.8,523,354.8,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,527.7l.4-.3h0l-.4.2H353C353,527.7,353.1,527.7,353.2,527.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,525.9h.2v.2c-.1,0,0,.2-.1.2s0,.1,0,.1h.8c-.1.2.1.3,0,.4H355c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.1c.1-.1,0-.2.1-.3v-.2c-.1,0,0,.2-.1.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.9,525.6h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.9,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,523.3h.3c0,.1.1.2.1.3h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2a.4.4,0,0,1-.3-.3C355.8,523.4,355.8,523.3,355.9,523.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 525.7 354.9 525.7 355 525.7 355 525.7 354.9 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,523.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,523.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 523.5 356 523.5 356 523.5 356 523.5 356 523.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,523.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.1 523.4 356 523.4 356.1 523.4 356.1 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.3 522.7 356.3 522.7 356.3 522.7 356.3 522.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,525.1a.2.2,0,0,1,.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,523.8c.1,0,.1.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524s0,0,0,0h.1s0,0,0,0H356s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524.1s0,0,0,0S356,524.1,356,524.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.1 523.7 356.1 523.6 356.1 523.7 356.1 523.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.5 522.7 356.5 522.7 356.5 522.7 356.5 522.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.6,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.1 523.9 356.1 523.9 356.1 523.9 356.1 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.8 524.7 355.8 524.6 355.8 524.6 355.8 524.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.1 523.9 356.1 523.9 356.1 523.9 356.1 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.9 524.6 355.8 524.6 355.8 524.6 355.9 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,522.8h0S356.8,522.8,356.8,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,527.6h.2c0,.1.1.2,0,.3h-.3C355.4,527.8,355.4,527.6,355.5,527.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,525.4h.1a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,356.4,525.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "353.4",
      "y": "520.5",
      "width": "7.1",
      "height": "3.61",
      "transform": "translate(-268 620.6) rotate(-64.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,518.6h.8v.2h0v.2h.1c.1,0,0,.2.1.2h.1s0,0,0,0h-.4s0,.1,0,.1h-.1c-.1.1,0,.2,0,.4l-.2-.3c0,.1,0,.2,0,.2v-.3H357s0,.2-.1.1.1-.1.1-.2,0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.2-.4-.2-.6S356.6,518.7,356.7,518.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 518.6 356.9 518.6 356.9 518.6 356.9 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,520.7h-.1A.1.1,0,0,1,356.2,520.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 518.8 357 518.8 357 518.8 357.1 518.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 518.7 357.1 518.7 357.1 518.7 357.1 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 518.7 357.2 518.7 357.2 518.7 357.2 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 518.8 357.2 518.7 357.2 518.7 357.2 518.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 518.7 357.3 518.7 357.3 518.7 357.3 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 518.8 357.2 518.9 357.2 518.9 357.2 518.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,520.4v-.2h0l-.2.2S356.4,520.4,356.5,520.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 518.7 357.3 518.7 357.3 518.7 357.3 518.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.6,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.5,520.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.6,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,518.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 519.7 357 519.7 357 519.7 357 519.7 357 519.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,524.7h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s.1.1,0,.2-.2-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.5,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,519.9s0,0,0,0S357.4,519.9,357.4,519.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,524.1l.4-.2h0l-.4.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,522.5h.2v.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.7c-.1.1,0,.3-.1.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.3-.1-.5h-.1c.1-.1,0-.2.1-.2V523c-.1,0,0,.2-.1.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,522.3h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.2h.3c0,.1.1.2.1.3h-.1s0-.1,0-.1h-.2s0,.1,0,.1h.1c-.1-.1-.2-.1-.3-.3S358.3,520.3,358.4,520.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 522.4 357.3 522.4 357.3 522.4 357.3 522.4 357.3 522.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,520.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.4 520.4 358.4 520.4 358.5 520.4 358.5 520.5 358.4 520.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 520.4 358.5 520.3 358.5 520.3 358.5 520.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 519.7 358.8 519.7 358.8 519.7 358.8 519.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,521.9a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,520.7c.1,0,.1.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,520.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.9h.1s0,0,0,0h-.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,521s0,0,0,0S358.4,521,358.4,521Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.6 520.6 358.6 520.6 358.6 520.6 358.6 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 519.8 359 519.8 359 519.8 359 519.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,521h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,521h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.5 520.8 358.5 520.8 358.5 520.8 358.5 520.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.2 521.5 358.2 521.5 358.2 521.5 358.2 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.5 520.9 358.5 520.9 358.5 520.9 358.5 520.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.3 521.5 358.2 521.5 358.2 521.5 358.3 521.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,520.6h0S358.6,520.6,358.7,520.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,519.9h0S359.3,519.9,359.3,519.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,524.2h.1c0,.1.1.2,0,.2h-.2C357.6,524.3,357.6,524.2,357.7,524.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,522.2h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,358.7,522.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.6",
      "y": "516.1",
      "width": "6.6",
      "height": "3.4",
      "transform": "translate(-209.9 248.5) rotate(-29.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.8,514.8h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.1.1.2h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.2.2,0,0,0,0,.2h0c0,.1-.1.1,0,.2h-.1c-.1-.1-.1-.2-.2-.3h-.1c-.1,0-.1.2-.2.3a.9.9,0,0,0,0-.3v-.1l-.2-.2h0s.1-.1,0-.1h-.2c.1-.2.1-.4.1-.5S362.6,514.8,362.8,514.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.9 515 362.9 515 362.9 515 362.9 515"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,516.2a.1.1,0,0,1,0,.1h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.9 515.2 362.9 515.1 362.9 515.2 362.9 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 515.1 363 515.1 363 515.1 363 515.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.1 515.2 363.1 515.2 363.1 515.2 363.1 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.1 515.2 363.1 515.2 363.1 515.2 363.1 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.2 515.2 363.2 515.2 363.2 515.2 363.2 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 515.3 363 515.3 363 515.3 363 515.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,516.2h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.2 515.2 363.2 515.2 363.2 515.2 363.2 515.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.5,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,515.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.4 515.8 362.4 515.8 362.4 515.9 362.4 515.9 362.4 515.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.5,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,518.7h0a1.1,1.1,0,0,0,0,.3h-.2v.2c.1-.2-.1-.3,0-.5s0-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.4s0,0,0,.1S362.4,516.4,362.4,516.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,518.5h.4s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.5h0S362.4,516.5,362.4,516.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,517.9v.2a.3.3,0,0,1,0,.2h-.1s-.1.1,0,.1h.2s0,0,0,0h.1s0,.1,0,.1h0s0,.1,0,.1h-.1s0,.1,0,.1h-.1c-.2,0-.1.2-.3.3v-.2h-.3c.1-.1.1-.3.2-.4s0-.1,0-.1h.2v-.2c-.1,0-.1.1-.2.1h0c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,518.6c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.2,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517c.1,0,.1.2.2.3s0,.2-.1.2h0s0-.1,0,0h0V517s0,0,0,.1h0s.1,0,0,.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.2 518.1 361.2 518.1 361.2 518.1 361.2 518.1 361.2 518.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.1,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 517.2 363.1 517.2 363.1 517.2 363.1 517.2 363.1 517.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.2 517.2 363.2 517.2 363.3 517.2 363.2 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.8 516.9 363.8 516.9 363.8 516.9 363.8 516.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,518a.2.2,0,0,1,0,.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363,517.5c.1.1,0,.2,0,.3h-.2a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.5h0s0,.2.1.1h0s0,0,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,517.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 517.4 363.1 517.4 363.1 517.4 363.1 517.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.9 517 363.9 517 363.9 517 363.9 517"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,518.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,517.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 517.6 363 517.5 363 517.5 363 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.4 517.9 362.4 517.9 362.4 517.9 362.4 517.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 517.6 362.9 517.6 363 517.6 363 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.4 517.9 362.4 517.9 362.4 517.9 362.4 517.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,519.7h.1c0,.1-.1.2-.2.2h-.1s-.1-.1-.1-.2S360.5,519.7,360.6,519.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,518.7c.1,0,0,.1,0,.1h-.2a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "349.2",
      "y": "513.4",
      "width": "8.3",
      "height": "4.27",
      "transform": "translate(-152.2 148) rotate(-19.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,518.8h-.2c-.2-.1-.2-.3-.3-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.5.5,0,0,0,0-.2h.1a.3.3,0,0,0,0-.3h0c0-.1.1-.2.1-.3v-.2h.1c.1,0,0,.2.2.2h0v-.2h0c.1.1.1.3.2.4h.1c.2,0,.2-.2.3-.3a1.1,1.1,0,0,0-.1.4l.2-.2-.2.3.2.3h0s-.1.1,0,.1h0c.1.1.1-.1.2-.1s-.2.5-.3.6S350.6,518.8,350.4,518.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 518.6 350.3 518.6 350.3 518.6 350.3 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,517.4a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 518.3 350.3 518.3 350.3 518.3 350.3 518.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 518.4 350.2 518.4 350.1 518.4 350.1 518.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 518.2 350.1 518.3 350.1 518.2 350.1 518.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 518.2 350.1 518.2 350.1 518.2 350.1 518.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 518.2 350 518.2 350 518.2 350 518.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 518.1 350.2 518.1 350.2 518.1 350.2 518.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,517.4h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 518.2 350 518.2 350 518.2 350 518.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,517.4s0,0,0,0S351.9,517.4,351.9,517.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,518h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.1 517.6 351.1 517.6 351.1 517.6 351.1 517.6 351.1 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,515c-.1,0-.1-.1-.1-.2h.1a1.4,1.4,0,0,0,0-.4v.2h.2l.2-.2c-.2.2,0,.4-.1.6s-.1.3-.3.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,517s0-.1,0-.1S351.3,517,351.2,517Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,515.2l-.5-.2s-.1-.1,0-.1h.1l.5.2H356Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.7,515.5c-.1-.1,0-.2-.1-.2V515c.1,0,.1-.1.2-.1s.1-.1.1-.1h-.4s.1-.1,0-.1h0a.1.1,0,0,0-.1-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.3.4-.3s.2.1.1.2h.4c-.1.1-.2.4-.3.5s-.1.1,0,.1h-.3v.2c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1.1.1a.3.3,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,514.8c.1,0,0,0,0,.1S355.1,514.8,355.2,514.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353,515.1a.2.2,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.1,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,516c-.1-.1-.1-.2-.2-.4s.1-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0-.1,0-.1h.1c0-.1-.1-.1,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s0,.1.1.1a.5.5,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.1 515.1 353.1 515.1 353.1 515 353.1 515 353.1 515.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,515.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.8h0S350.4,515.8,350.4,515.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.8h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 515.8 350.5 515.8 350.5 515.7 350.5 515.7 350.5 515.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,515.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.4 515.8 350.4 515.8 350.3 515.8 350.4 515.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 516 349.6 516 349.6 516 349.6 516"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,515a.3.3,0,0,1,.1-.3l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,515.5c-.1-.1,0-.2.1-.4h.3a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,515.4h0c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,515.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.6 515.5 350.5 515.5 350.5 515.5 350.6 515.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.5 515.9 349.5 515.9 349.5 515.9 349.5 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,515.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,515.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.3,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,515.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.8 515.4 350.8 515.4 350.8 515.4 350.8 515.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 515.1 351.6 515.1 351.6 515.1 351.6 515.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.8 515.3 350.8 515.3 350.8 515.4 350.8 515.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.5 515 351.5 515.1 351.5 515.1 351.5 515"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,513.2c-.1,0-.1-.1,0-.2s.1-.2.2-.2h.1c0,.1.1.1,0,.2S354.4,513.3,354.2,513.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,514c-.1-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351.2",
      "y": "504",
      "width": "4.1",
      "height": "8.02",
      "transform": "translate(-224.1 730.6) rotate(-76.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,509.1c0-.1-.2-.1-.1-.2s0-.3,0-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2.1-.3s0,.2.1.2l.2-.2h.1l.2-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c0,.1-.1.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,0,.4h-.1l-.6.3A.7.7,0,0,1,349.2,509.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.2 508.9 349.2 508.9 349.2 508.9 349.2 508.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,509.2h.3c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 508.7 349.3 508.7 349.3 508.7 349.3 508.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.2 508.7 349.2 508.7 349.2 508.7 349.2 508.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 508.6 349.2 508.6 349.2 508.6 349.3 508.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 508.5 349.3 508.5 349.2 508.5 349.3 508.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.2 508.4 349.2 508.5 349.2 508.4 349.2 508.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.4 508.5 349.4 508.5 349.4 508.5 349.4 508.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,508.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.1 508.4 349.2 508.4 349.1 508.4 349.1 508.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,508.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,508.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,508.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,508.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.4 508.6 350.3 508.6 350.4 508.5 350.4 508.5 350.4 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,508.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,509.4c0-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2,0-.2.3-.4.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.6,509.2l-.3-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S355.6,509.2,355.6,509.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.6,508.2c0-.1.1-.1.1-.2h.2c.1.1.2-.1.2.1h.1c-.1-.1-.1-.2-.2-.2h0c0-.1,0-.1-.1-.1h.1c0-.1-.1,0-.1-.1h.1a.1.1,0,0,0,0-.2h.2c0-.1.1,0,.1-.1h0c.2.1.3-.1.5,0s0,.2,0,.3h.2s0,.1,0,.1h.2l-.5.2s-.1,0-.1.1h.1c.1.1,0,.1,0,.1h-.2v-.2H354c0,.1.2,0,.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,508.5c.1,0,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,507.6h.2a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.3,507.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.9c-.1-.1,0-.2.1-.4h.2s-.1,0,0,.1h-.1c0,.1,0,0,0,.1h0a.3.3,0,0,0,0,.2h0c0,.1.1,0,.1.1h.2c.1-.1,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.3 507.6 353.3 507.6 353.3 507.5 353.3 507.5 353.3 507.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,506.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.8h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.8 506.8 350.8 506.8 350.9 506.7 350.9 506.7 350.8 506.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,506.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 506.7 350.7 506.7 350.7 506.7 350.7 506.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 506.5 350 506.5 350 506.5 350 506.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,507.1l.2-.2a.3.3,0,0,1,0,.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,506.6c0-.1.2-.2.2-.2h.1a.3.3,0,0,0,.1.2h-.3A.1.1,0,0,1,351.2,506.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,506.7h0c0-.1.1-.2,0-.2h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,506.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 506.6 351 506.6 351 506.6 351 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 506.3 350 506.3 350 506.3 350 506.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,506.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,507h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,506.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 506.6 351.3 506.6 351.3 506.6 351.3 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.1 506.8 352.1 506.8 352.1 506.8 352.1 506.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 506.6 351.3 506.6 351.3 506.6 351.3 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.1 506.7 352 506.8 352.1 506.8 352.1 506.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,506h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,506.7c0-.1,0-.1.1-.2h.3c0,.1,0,.2-.1.2S355.2,506.8,355.2,506.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,506.1c0-.1.1-.1.1-.1h-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "345.2",
      "y": "502.1",
      "width": "8.2",
      "height": "4.2",
      "transform": "translate(-263.6 479.8) rotate(-53)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,500h.2c.2,0,.3.1.5.2s.1.1.1.1h0c0,.1.2.1.3.2h-.2v.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,.1.2h.1c.1.1,0,.2.1.3H351s0,.1,0,.1h.2c-.1,0-.2-.2-.4-.2h-.1c-.1.1,0,.3-.1.4a1.1,1.1,0,0,0-.1-.4c0,.1,0,.2-.1.3a1,1,0,0,1,0-.4H350c-.1,0-.1.2-.2.1v-.2c0-.1,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.5-.1-.7S349.7,500.1,349.9,500Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 500.1 350.1 500.1 350.1 500.1 350.1 500.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.8,502.3v.2h-.2C348.6,502.4,348.7,502.3,348.8,502.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 500.3 350.3 500.3 350.3 500.3 350.3 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.4 500.2 350.3 500.2 350.4 500.2 350.4 500.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.4 500.3 350.4 500.3 350.4 500.3 350.4 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.5 500.3 350.5 500.3 350.5 500.3 350.5 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.6 500.3 350.5 500.2 350.6 500.2 350.6 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.5 500.4 350.4 500.4 350.4 500.4 350.5 500.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,502l.2-.2h0l-.2.2S349.2,502,349.2,502Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.6 500.2 350.6 500.2 350.6 500.2 350.6 500.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,501.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.7,500.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 501.3 350 501.3 350 501.3 350 501.3 350 501.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,501.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,506.5h.2c-.1.1,0,.1,0,.2l.2.3h-.2c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,501.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,501.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,506h-.1C347.1,506,347.3,506,347.3,506Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,504.5l.2.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0v-.3a.8.8,0,0,0,0-.3c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,505.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,504.4h.1a.1.1,0,0,1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,504.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,502.3c.1,0,.2.1.3.2s0,.2,0,.3h-.4c0,.1,0,.1,0,.1h.1c0,.1.1,0,.1.1h-.1s0,.1,0,.1h0c0,.1.2.1.2.2h-.1a.4.4,0,0,1-.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 504.5 349.7 504.5 349.8 504.5 349.8 504.5 349.7 504.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,502.5s0,0,0,0S351.4,502.5,351.4,502.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,502.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.5 502.5 351.5 502.5 351.5 502.5 351.5 502.5 351.5 502.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,502.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,502.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 502.4 351.6 502.4 351.6 502.4 351.6 502.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.1 501.8 352.1 501.8 352.1 501.8 352.1 501.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,504a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.9c.1.1.1.2.1.3h-.4c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,502.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,502.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503h.1s.1,0,0,.1h-.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 502.7 351.6 502.7 351.6 502.7 351.6 502.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.2 501.9 352.2 501.9 352.2 501.9 352.2 501.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 503 351.5 503 351.5 503 351.5 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 503.7 350.9 503.7 351 503.6 351 503.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 503 351.4 503 351.5 503 351.5 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 503.6 351 503.6 351 503.6 351 503.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,502.7h0S351.6,502.7,351.7,502.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,502.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,506.6h.1c0,.1,0,.2-.1.3h-.1v-.2C349.6,506.7,349.6,506.6,349.8,506.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,504.6h.1a.2.2,0,0,1-.1.2h-.2C351.1,504.7,351.2,504.6,351.3,504.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "343.4",
      "y": "510.3",
      "width": "3.4",
      "height": "6.72",
      "transform": "translate(-251.6 349.8) rotate(-40.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.4,514.9c0,.1.1.2,0,.2s-.1.2-.2.3h-.1s0-.1,0-.1-.1.1-.2.2.1-.1,0-.2H347c0-.1.1-.1.1-.2h-.2c.1-.1.2-.1.2-.3h.1l.2-.3c0-.1-.1-.1-.1-.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1,0-.1-.1h.6C348.3,514.7,348.4,514.8,348.4,514.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.3 515.1 348.3 515.1 348.3 515.1 348.3 515.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,513.6h-.1C346.8,513.5,346.8,513.6,346.8,513.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.2 348.2 515.1 348.2 515.1 348.1 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.2 515.2 348.2 515.2 348.2 515.2 348.2 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.3 348.1 515.3 348.1 515.3 348.1 515.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.3 348.1 515.3 348.1 515.3 348.1 515.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.4 348.1 515.4 348.1 515.4 348.1 515.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 515.3 348 515.3 348 515.3 348 515.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,514v.2H347V514Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.4 348.1 515.4 348.1 515.4 348.1 515.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,514.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.9,514.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,515.4h0S348,515.4,348,515.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.4 514.7 347.4 514.7 347.4 514.8 347.4 514.7 347.4 514.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.4,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,511.2H343c.2.1.3-.1.5-.1s.2,0,.3.1S343.8,511.2,343.8,511.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.1,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,511.8a1.1,1.1,0,0,1,0,.4H344a2.6,2.6,0,0,0,0-.4s0-.1,0-.1S344.1,511.8,344.1,511.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,513.4h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2,0,.2h-.1s0,.1,0,.1h-.1s0,.1,0,.1h-.5s0,0,0-.1-.3-.1-.3-.2v-.2c0-.1,0-.1-.1-.1h.5a.2.2,0,0,0,0-.2h.1s0,.1,0,.2h.4c0-.1-.1-.1-.2-.2h.3l.3.2A.4.4,0,0,1,345,513.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,512.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,514h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.9,514h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.4,515.7c0,.1-.2.1-.2.2h0c0-.1.1,0,0-.1h.1c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "344.9 514 344.9 514 344.9 514 344.9 514 344.9 514"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.3,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,515.7h0S346.2,515.7,346.3,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.2 515.7 346.2 515.7 346.1 515.8 346.1 515.8 346.2 515.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,515.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.2 515.8 346.2 515.8 346.2 515.9 346.2 515.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.6 516.3 346.6 516.3 346.6 516.3 346.6 516.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.1,514.7h-.2v-.2h.1S345.2,514.6,345.1,514.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,515.7h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,345.9,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,515.5h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346 515.8 346 515.8 346 515.8 346 515.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.5 516.4 346.5 516.4 346.5 516.4 346.5 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.6h0S345.7,515.6,345.7,515.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.9,514.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 515.6 345.8 515.6 345.8 515.6 345.8 515.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.3 515.1 345.3 515.1 345.3 515.1 345.3 515.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 515.6 345.8 515.6 345.8 515.6 345.8 515.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.3 515.2 345.4 515.1 345.3 515.1 345.3 515.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.2,513.7h-.3a.2.2,0,0,1,0-.1h.2C343.1,513.5,343.2,513.5,343.2,513.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,515.3h-.3s0-.1,0-.1h.1A.1.1,0,0,1,344.5,515.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "333.9",
      "y": "510.5",
      "width": "7.3",
      "height": "3.75",
      "transform": "matrix(0.57, -0.82, 0.82, 0.57, -275.93, 500.03)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.9,508.6h.2c.2-.1.3.1.4.1h.1c0,.1.2.1.2.2h-.2v.2h0v.2h.1c.1.1,0,.2.1.2H339s0,0,0,.1h.1l-.3-.2h-.1c-.1.1,0,.3,0,.4a1,1,0,0,0-.1-.3c0,.1,0,.2,0,.2a.9.9,0,0,1,0-.3h-.3c-.1,0-.1.2-.1.1v-.2s0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.6S337.8,508.7,337.9,508.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.1 508.7 338.1 508.6 338.1 508.6 338.1 508.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337,510.7h-.1C336.9,510.8,336.9,510.7,337,510.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.3 508.8 338.2 508.8 338.2 508.8 338.3 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.3 508.7 338.3 508.7 338.3 508.7 338.3 508.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 508.8 338.4 508.8 338.4 508.8 338.4 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 508.8 338.4 508.8 338.4 508.8 338.4 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.5 508.8 338.5 508.8 338.5 508.8 338.5 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 508.9 338.4 508.9 338.4 508.9 338.4 508.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.4,510.4l.2-.2h0l-.2.2S337.4,510.4,337.4,510.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 508.8 338.5 508.8 338.5 508.8 338.6 508.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.1,509.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.6,508.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338 509.8 338 509.7 338 509.8 338 509.8 338 509.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.2,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,514.5h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.5,509.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.5,510h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.8,514h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.3,512.6h.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.6c.1,0,0,.1.1.1H338c-.2.1,0,.3-.1.4h-.5c0,.1-.1.1-.1.2s-.1-.3,0-.5h-.1v-.2a.8.8,0,0,0,0-.2c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2-.1-.2H337a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.6,513.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.9,512.5h.1a.1.1,0,0,1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.9,512.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.6l.3.2c-.1.1.1.2,0,.3h-.2v.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "337.9 512.6 337.9 512.6 338 512.6 338 512.6 337.9 512.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,510.8s0,0,0,0S339.3,510.8,339.3,510.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.5,510.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 510.8 339.4 510.8 339.4 510.8 339.4 510.8 339.4 510.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,510.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.5 510.7 339.5 510.7 339.5 510.7 339.5 510.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 510.1 339.9 510.1 339.9 510.1 339.9 510.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.5,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.6,512.1a.2.2,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,511.1c.1.1.1.2.1.3h-.4c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.5,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.2h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.5 511 339.5 510.9 339.5 511 339.5 511"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.1 510.2 340 510.2 340.1 510.2 340.1 510.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,511.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.6,512.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,511.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.4 511.2 339.4 511.2 339.4 511.2 339.4 511.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339 511.8 339 511.8 339 511.8 339 511.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.4 511.2 339.4 511.2 339.4 511.2 339.4 511.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339 511.8 339 511.8 339 511.8 339 511.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,511h0S339.6,511,339.6,511Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.3,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.1,514.5h.1c0,.1,0,.2-.1.2h-.2C337.9,514.6,337.9,514.5,338.1,514.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,512.7h.1a.1.1,0,0,1-.1.2h-.2C339.2,512.7,339.3,512.6,339.4,512.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "330.5",
      "y": "513.5",
      "width": "7.1",
      "height": "3.62",
      "transform": "translate(-196.6 824.3) rotate(-87.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.7,518.6h-.8s.1,0,0-.1h-.3s0,.1,0,.1h0a.4.4,0,0,1,0-.1H334a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.1-.2-.2-.3l.3.2c-.1-.1-.1-.2-.1-.2l.2.2h.3c0-.1,0-.2,0-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.2l.4.4A.6.6,0,0,1,335.7,518.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.5 518.6 335.5 518.6 335.5 518.6 335.5 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.4,516.4h-.1a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,335.4,516.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.3 518.6 335.3 518.6 335.3 518.6 335.3 518.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.3 518.7 335.3 518.7 335.3 518.7 335.3 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.2 518.6 335.2 518.7 335.2 518.7 335.2 518.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.7 335.1 518.7 335.1 518.7 335.1 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.7 335.1 518.7 335.1 518.7 335.1 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.6 335.1 518.6 335.1 518.6 335.1 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.1,516.8a.8.8,0,0,1,0,.3h0c0-.1,0-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.8 335.1 518.8 335.1 518.8 335.1 518.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.1,516.9h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.1,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.1,517h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.9,518.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335 517.7 335 517.7 335 517.7 335 517.7 335 517.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.9,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.7,512.4h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.1c.1-.1,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.5,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.5,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.6,513.1l-.3.4h0l.3-.3h.1C334.8,513,334.7,513.1,334.6,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.5,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,515h-.3c0-.1-.1-.1,0-.2h-.1l-.2.2h-.5s0,0,0-.1H333s0,0,0-.1h0c.1-.2-.1-.2-.1-.4h.2c.1,0,0-.1,0-.2h.1c0-.1,0-.1,0-.2l.3.4h.3c0,.1-.1.1,0,.2h-.1c0,.1,0,.2,0,.2v.2c.1-.1-.1-.1,0-.2h.1s0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,513.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.7,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.7,515.3h0S333.7,515.3,333.7,515.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.5,517.7h-.3c0-.1-.1-.1-.2-.2h.2s0,0,0,0h.1s0-.1,0-.1h.1S333.5,517.7,333.5,517.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.6 515.3 333.6 515.3 333.6 515.3 333.6 515.3 333.6 515.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.5,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.4,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.4,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.4,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,517.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.3 517.6 333.3 517.6 333.3 517.6 333.3 517.6 333.3 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.3 517.7 333.3 517.7 333.3 517.7 333.3 517.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.2 518.4 333.3 518.4 333.3 518.4 333.2 518.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,516l-.2-.2h.3C333.4,515.9,333.4,516,333.3,516Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,517.3l-.3-.2s0,0,0-.1h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,517.1s0,0,0,0h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,517h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 517.4 333.2 517.5 333.1 517.5 333.1 517.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 518.4 333.1 518.4 333.1 518.4 333.1 518.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.1 517.2 333.1 517.2 333.1 517.2 333.1 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 516.5 333.2 516.5 333.2 516.5 333.1 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.1 517.2 333.1 517.2 333.1 517.2 333.1 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 516.5 333.1 516.5 333.1 516.5 333.1 516.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.1,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.8,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.6,513.8h-.2c-.1-.1-.1-.2-.1-.2h.3C332.6,513.6,332.7,513.8,332.6,513.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.4,516h-.1a.1.1,0,0,1,0-.2h.2A.1.1,0,0,1,332.4,516Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "332.4",
      "y": "520.4",
      "width": "8.7",
      "height": "4.45",
      "transform": "translate(-261.8 354.4) rotate(-41.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.2,526.9h-.3c-.2,0-.3-.2-.4-.3s0-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2a.5.5,0,0,0,0-.3h-.1s0-.1,0-.1h.1a.3.3,0,0,0-.1-.3h-.1c-.1-.1.1-.2,0-.3l-.2-.2h.3s0-.1,0-.1l-.2-.2h0c.1.1.2.3.4.3h.1c.1-.1.1-.3.2-.4a1.2,1.2,0,0,0,.1.4c0-.1.1-.2.1-.3a1.1,1.1,0,0,1-.1.4l.4.2c.1,0,.1-.2.2-.1h-.2c0,.1-.1.1,0,.2h.1c0,.1-.1.1,0,.1h.1c.1,0,.1-.1.1-.1s0,.5,0,.7S335.4,526.9,335.2,526.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335 526.8 335 526.8 335 526.8 335 526.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.8,524.8a.1.1,0,0,1-.1-.2h.3C337,524.7,336.9,524.8,336.8,524.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.9 526.5 334.9 526.6 334.9 526.6 334.9 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.8 526.6 334.8 526.7 334.8 526.7 334.8 526.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.7 526.5 334.7 526.5 334.7 526.5 334.7 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.7 526.5 334.7 526.5 334.7 526.5 334.7 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.6 526.5 334.6 526.5 334.6 526.5 334.6 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.7 526.4 334.7 526.4 334.7 526.4 334.7 526.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,524.9l-.3.2s0,0,0-.1l.3-.2S336.4,525,336.3,524.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.5 526.5 334.5 526.5 334.5 526.5 334.5 526.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.2,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.3,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.1,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.3,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,526.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.4 525.5 335.4 525.6 335.4 525.5 335.4 525.5 335.4 525.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.2,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.9,520.8l-.2-.2c.1,0,0-.1.1-.2a1.4,1.4,0,0,0-.1-.4h.1c.1,0,.1-.1.2-.1s0-.2.1-.2.2.4.1.6,0,.3-.2.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.9,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.9s0,0,0-.1S335.3,524.8,335.3,524.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.2,521.3h-.6s-.1,0,0-.1h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.1,522.4v-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.2-.1s.1-.1,0-.1h-.3s0,0,0-.1h-.2s0-.1,0-.1h-.1c0-.1,0-.1-.1-.1h.1c-.1,0,0-.1-.1-.2h.1c.2-.1.1-.3.3-.4l.2.2h.3v-.2c-.1.2,0,.4-.1.6s0,.1.1.1h0l-.2.2a.9.9,0,0,0,0,.3c.1,0,.1-.2.2-.2h.1c0,.1-.1.2,0,.2h.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,521.3c.1,0,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,522.4h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.4,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.2c-.2,0-.2-.2-.3-.3s0-.2,0-.3h0s0,.1,0,.1h0l.2.2h.1c0-.1,0-.1,0-.1h-.1c0-.1-.1,0,0-.1h.1s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.5.5,0,0,1,.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "336.3 522.3 336.3 522.3 336.3 522.3 336.3 522.3 336.3 522.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.2,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.2,524s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334,524.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334.1 524 334.1 524 334.1 524 334.1 524 334.1 524"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.1,523.9s0,0,0,0S334.1,523.9,334.1,523.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.2,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334 524 334 524.1 333.9 524.1 334 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.3 524.6 333.3 524.6 333.3 524.6 333.3 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.4,522.6a.3.3,0,0,1,0-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.2,523.6c-.1-.1-.1-.2-.1-.4h.3v.2c0,.1-.2.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.5h0s-.1-.2-.1-.1h0s-.1,0,0-.1h.1s.1.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334 523.7 334 523.7 334 523.7 334 523.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.2 524.5 333.2 524.5 333.2 524.5 333.2 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.3,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.3,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.5,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.3,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.2 523.5 334.2 523.5 334.2 523.5 334.2 523.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334.9 522.9 334.9 522.9 334.9 522.9 334.9 522.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.2 523.5 334.2 523.5 334.2 523.5 334.2 523.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334.8 522.9 334.8 522.9 334.8 522.9 334.8 522.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334,523.7h0S334,523.7,334,523.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.7,520.1v-.2c0-.1,0-.2.1-.3h.1c0,.1.1.1.1.2S336.9,520.1,336.7,520.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.7,521.8c-.1,0-.1-.1-.1-.2v-.2h.1a.2.2,0,0,1,.1.2A.2.2,0,0,1,334.7,521.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "328.8",
      "y": "521.6",
      "width": "3.4",
      "height": "6.66",
      "transform": "translate(-233.5 783.1) rotate(-82.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.2,526.1s-.1-.1-.1-.2-.1-.3-.1-.4,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2v-.2h.1V525s0,0,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c0,.1,0,.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.3h.4l-.2.2h.2l-.2.2a.7.7,0,0,0,.1.3h0l-.4.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.9 327.2 526 327.2 526 327.2 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.3,526h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.3 525.8 327.3 525.8 327.3 525.8 327.3 525.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.8 327.2 525.8 327.2 525.8 327.2 525.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.7 327.2 525.7 327.2 525.7 327.2 525.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.6 327.2 525.6 327.2 525.6 327.2 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.6 327.2 525.6 327.1 525.6 327.2 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.3 525.6 327.3 525.6 327.3 525.6 327.3 525.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.9,525.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.1 525.6 327.1 525.6 327.1 525.6 327.1 525.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,525.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.2,525.4h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "328.1",
      "y": "525.6",
      "height": "0.01",
      "transform": "translate(-235 784) rotate(-82.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.1,525.8c0-.1,0-.1,0-.2h.1l.2-.3s0,.1,0,.1h.3c-.2.1-.1.3-.3.4h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.1,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.2,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.5,525.6l-.3-.3s0-.1,0-.1h.1l.3.3s.1.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,525c0-.1.1-.1,0-.2h.4l-.2-.2h.1a.1.1,0,0,0,0-.1h.2c0-.1.1,0,.1-.1h0c.2.1.2-.1.4,0s.1.2,0,.2h.1s0,.1,0,.1h.2l-.4.2s-.1.1-.1.1h.1s0,.1,0,.1h-.4a0,0,0,0,1,0,.1s-.2,0-.1.1,0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332,525.1s0,0,0,0S332,525.1,332,525.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.4,524.5h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.5,524.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,524.2c-.1-.1,0-.2,0-.3h.1s-.1,0,0,0h-.1s0,0,0,.1h0a.3.3,0,0,0,0,.2h.2s0,0,0,0h0c.1-.1,0-.2.1-.2s0,.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.5 524.5 330.5 524.5 330.5 524.5 330.5 524.5 330.5 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.3,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.4,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.4 524 328.4 524 328.4 524 328.4 524 328.4 524"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,524h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.3 524 328.3 524 328.3 524 328.3 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.6 523.9 327.6 523.9 327.6 523.9 327.6 523.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,524.1l.2-.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.6,523.9c0-.1.1-.2.2-.2h.1v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,523.9h0s.1-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.5 523.9 328.5 523.9 328.5 523.9 328.5 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.6 523.8 327.7 523.8 327.6 523.8 327.6 523.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,523.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.7,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.7 523.9 328.7 523.9 328.7 523.9 328.7 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 523.9 329.4 524 329.4 524 329.4 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.7 523.9 328.7 523.9 328.7 523.9 328.7 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 523.9 329.4 523.9 329.4 523.9 329.4 523.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332,523.6s0-.1,0-.1h.3s0,.1-.1.2S332,523.7,332,523.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.9,523.3c0-.1,0-.1.1-.1h-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "323.8",
      "y": "523.9",
      "width": "4.2",
      "height": "8.18",
      "transform": "matrix(0.85, -0.53, 0.53, 0.85, -228.74, 249.82)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,525.9c0-.1,0-.2.1-.2s.2-.2.3-.4h.2s0,.1,0,.1.2-.2.3-.2-.1.1-.1.2H324c0,.1-.2.1-.1.2h.3c-.1.1-.3.1-.3.3h0c.1.1.3.1.4.2h-.4l.2.2h-.3l-.3.3c0,.1.1.1.1.2v-.2h-.2s0,0,0,0h-.1a.1.1,0,0,0,0,.1H323c-.1.1.1.1.1.1l-.7-.2C322.3,526.2,322.1,526.1,322.1,525.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.3 525.7 322.3 525.7 322.3 525.7 322.3 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.9,527.7h.2v.2H324C323.9,527.9,323.8,527.8,323.9,527.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.6 322.5 525.7 322.5 525.7 322.6 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 525.5 322.5 525.5 322.5 525.5 322.5 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.5 322.6 525.5 322.6 525.5 322.6 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.5 322.6 525.5 322.6 525.5 322.6 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.4 322.6 525.4 322.6 525.4 322.6 525.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.7 525.5 322.7 525.5 322.7 525.5 322.7 525.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,527.2V527h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.3 322.6 525.3 322.6 525.3 322.6 525.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,527.1h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.7,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,526.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.8,525.3h0S322.8,525.3,322.8,525.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "323.4",
      "y": "526.3",
      "height": "0.01",
      "transform": "translate(-230.4 252.7) rotate(-32.1)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,526.1h0S323.5,526.1,323.4,526.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.1,531.2h.6c0,.1.1.1.1.2h.2c-.2-.1-.4.1-.6,0s-.3,0-.3-.2S327.1,531.2,327.1,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,530.5a1.3,1.3,0,0,1,.1-.5h.1s0,.1,0,.1a3.2,3.2,0,0,0-.1.5s0,.1-.1.1S326.7,530.5,326.8,530.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326,528.3h.4c0,.1.2.1.1.2h.1c0-.1.1-.2,0-.3h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.4c.1,0,0,.1,0,.1h.1c0,.2.3.1.3.3l-.2.2c-.1.1,0,.1.1.2h-.1v.2l-.5-.2H327a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1-.1-.2s.1-.1,0-.2l-.2-.2h-.3c0,.1.2.1.2.2h-.1c-.1,0-.2-.1-.2,0h-.1a.3.3,0,0,1-.3-.2A.5.5,0,0,1,326,528.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.2,527.6h0A.1.1,0,0,1,326.2,527.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.2,527.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.8,525.3c0-.1.2-.1.3-.2h0c0,.1-.1,0,0,.1h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.2 527.7 326.2 527.7 326.3 527.6 326.3 527.7 326.2 527.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.9,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.9,525.3h0S324.9,525.3,324.9,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.9,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,525.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325 525.3 325 525.3 325.1 525.3 325.1 525.3 325 525.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,525.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325 525.2 325 525.2 325 525.2 325 525.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.6 524.5 324.6 524.5 324.6 524.5 324.6 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.1,526.8h.3v.2h-.1C326.1,526.9,326,526.8,326.1,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.4,525.5h.4s0,.1,0,.1a.3.3,0,0,0-.1.2h-.2c-.1,0,0-.1-.2-.1A.1.1,0,0,1,325.4,525.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.2,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.7h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.6,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.3 525.3 325.3 525.3 325.3 525.3 325.3 525.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.8 524.4 324.7 524.4 324.7 524.4 324.8 524.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.3,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.6,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.5 525.5 325.5 525.5 325.5 525.5 325.5 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.9 526.2 325.9 526.3 325.9 526.2 325.9 526.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.5 525.5 325.5 525.5 325.5 525.5 325.5 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.9 526.2 325.9 526.2 325.9 526.2 325.9 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.3,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,528.4h.2c.1,0,.2.1.2.2h-.2C328.3,528.7,328.2,528.5,328.2,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,526.2h.1A.1.1,0,0,1,327,526.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "325.3",
      "y": "529.2",
      "width": "3.9",
      "height": "7.57",
      "transform": "translate(-199.3 195.4) rotate(-25.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,530.7c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1.2-.1.3-.1-.1.1-.1.2h1c0,.1-.1,0-.2.2h.3c-.1.1-.3.1-.3.2h0c0,.1.2.1.3.2h-.4l.2.2h-.3l-.3.3c0,.1.1.1,0,.2s0-.1-.1-.2h-.4c-.1.1.1.1.1.1l-.6-.2C324.1,531,324,530.9,324,530.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 530.6 324.1 530.6 324.1 530.6 324.1 530.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.4,532.6h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,325.4,532.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.4 530.5 324.3 530.5 324.4 530.5 324.4 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.3 530.4 324.3 530.4 324.3 530.4 324.3 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.4 530.4 324.4 530.4 324.4 530.4 324.4 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.4 324.4 530.4 324.4 530.4 324.5 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.3 324.4 530.3 324.5 530.3 324.5 530.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.4 324.5 530.5 324.5 530.5 324.5 530.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.4,532.1v-.3h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.2 324.5 530.3 324.5 530.2 324.5 530.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.3,532h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.4,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.3,531.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325,531.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,530.3a0,0,0,0,1,0,0S324.6,530.3,324.6,530.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 531.2 325.1 531.2 325.1 531.2 325.1 531.2 325.1 531.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,531.1h0S325.1,531.1,325.1,531.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,536.1h.5c0,.1,0,.1.1.2h.2c-.2-.1-.4,0-.5-.1s-.3-.1-.3-.2S328,536.1,328,536.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,530.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.8,535.4a1.2,1.2,0,0,1,.1-.5h.1s0,.1,0,.1a3,3,0,0,0-.1.5s0,.1-.1.1S327.8,535.4,327.8,535.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.3,533.3h.4c0,.1.1.1.1.2h.1c0-.1.1-.2.1-.2h.1c.1,0,0-.1,0-.1h.2c.1,0,0-.1,0-.1h.4s0,0,0,.1h.1c0,.2.3.2.3.3h-.2c-.1.1,0,.1,0,.2h-.1v.2l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.2s.1-.1,0-.2l-.2-.2h-.2c-.1.1.1.1.1.2h-.1c-.1,0-.1-.1-.2-.1h-.1a.3.3,0,0,1-.2-.2A.5.5,0,0,1,327.3,533.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,532.7h0A.1.1,0,0,1,327.5,532.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.5,532.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.5,530.4l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C326.5,530.6,326.5,530.5,326.5,530.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.6 532.7 327.6 532.7 327.6 532.7 327.6 532.7 327.6 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.5,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.4h0S326.6,530.5,326.6,530.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,530.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.7 530.5 326.7 530.5 326.7 530.5 326.7 530.5 326.7 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,530.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.7 530.4 326.7 530.4 326.7 530.3 326.7 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.4 529.7 326.3 529.7 326.3 529.7 326.4 529.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.7,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,531.9h.3v.2h-.1C327.5,532,327.5,532,327.5,531.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,530.6h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,327,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327,530.8h.1s0-.1,0-.1H327Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.9 530.5 326.9 530.5 326.9 530.5 326.9 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.5 529.6 326.5 529.6 326.5 529.6 326.5 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.7,532h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.1 530.7 327.1 530.7 327.1 530.7 327.1 530.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.4 531.4 327.4 531.4 327.4 531.4 327.4 531.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.1 530.7 327.1 530.7 327.1 530.7 327.1 530.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.4 531.4 327.4 531.4 327.4 531.4 327.4 531.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.3,533.6h.2c.1,0,.2.1.2.2h-.2C329.4,533.8,329.3,533.7,329.3,533.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,531.5h.1A.1.1,0,0,1,328.4,531.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "326.3",
      "y": "534",
      "width": "4.1",
      "height": "7.97",
      "transform": "translate(-44.3 29.7) rotate(-4.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,541.5s0,.2-.2.2-.3.1-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.8s0,0,0,0h.4s0,0,0-.1h.1c0-.2-.2-.2-.2-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.4c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.4A.7.7,0,0,1,330.7,541.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.4 541.5 330.5 541.5 330.5 541.5 330.4 541.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330,539.1h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,330,539.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.2 541.5 330.2 541.5 330.2 541.5 330.2 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.2 541.6 330.2 541.6 330.2 541.6 330.2 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.1 541.6 330.1 541.6 330.1 541.6 330.1 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.1 541.6 330.1 541.6 330.1 541.6 330.1 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330 541.7 330 541.7 330 541.7 330 541.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330 541.5 330 541.5 330 541.5 330 541.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,539.5a.9.9,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330 541.7 330 541.7 330 541.7 330 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,539.7h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,541.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.8 540.5 329.8 540.5 329.7 540.6 329.7 540.5 329.8 540.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.6,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.7,534.7h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2s-.1-.1-.1-.2.4.1.5.3.2.2.2.3S328.7,534.6,328.7,534.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.7,535.4l-.3.4h-.1s0-.1,0-.1l.3-.4h.1C328.8,535.3,328.7,535.4,328.7,535.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,537.6H328c0-.1-.1-.1,0-.2h-.1c0,.1-.2.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1H327c.1-.2-.2-.3-.2-.4h.3c.1,0,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.2,0-.3h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,536.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,538.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.9,538.1h0S328,538.1,327.9,538.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.1,540.8h-.4c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C328.1,540.6,328.1,540.7,328.1,540.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.9 538.1 327.9 538.1 327.9 538.1 327.9 538.1 327.9 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.1,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,540.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.9 540.7 327.9 540.7 327.9 540.7 327.9 540.7 327.9 540.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.9,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.9,540.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.9 540.8 327.9 540.8 327.9 540.8 327.9 540.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.9 541.6 327.9 541.6 327.9 541.6 327.9 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,540.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,538.9l-.2-.2h.3C327.7,538.8,327.7,538.9,327.6,538.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.7,540.4c-.1,0-.2-.1-.3-.2s0,0,0-.1l.2-.2h.2c.1.1,0,.1.1.2A.1.1,0,0,1,327.7,540.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.8,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.8,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.7,540.2h-.2s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.7 540.5 327.7 540.6 327.7 540.6 327.7 540.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.8 541.6 327.8 541.6 327.8 541.6 327.8 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.5,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.6 540.3 327.6 540.3 327.6 540.3 327.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.5 539.5 327.5 539.5 327.5 539.5 327.5 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.6 540.3 327.6 540.3 327.6 540.3 327.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.5 539.5 327.5 539.5 327.5 539.5 327.5 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.5,536.6h-.2c-.1-.1-.2-.2-.1-.3h.3C326.5,536.3,326.6,536.5,326.5,536.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,539h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,326.6,539Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "318.8",
      "y": "538.8",
      "width": "6.8",
      "height": "3.47",
      "transform": "translate(-286.9 382.3) rotate(-44.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,537.2h.2l.4.2c0,.1,0,.1.1.1h0c0,.1.2.1.2.2h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.2.2,0,0,0,.1.2h.1c.1.1,0,.2,0,.2h-.1s0,0,0,.1h.1l-.3-.2h-.1c-.1.1,0,.2-.1.3a.9.9,0,0,0-.1-.3c0,.1-.1.2-.1.2a.8.8,0,0,1,0-.3l-.3-.2h0s0-.1,0-.1h0s.1-.1,0-.1H323c-.1,0,0,.1-.1.1s0-.4,0-.6S323,537.2,323.2,537.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 537.3 323.3 537.3 323.3 537.3 323.3 537.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,538.9a.1.1,0,0,1,.1.1H322Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.4 537.4 323.4 537.4 323.4 537.4 323.4 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.5 537.4 323.5 537.4 323.5 537.4 323.5 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.5 537.5 323.6 537.4 323.6 537.5 323.5 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.6 537.5 323.6 537.5 323.6 537.5 323.6 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 537.5 323.7 537.4 323.7 537.5 323.7 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.6 537.6 323.5 537.6 323.5 537.6 323.6 537.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,538.8l.2-.2s0,0,0,.1l-.2.2S322.3,538.7,322.4,538.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 537.4 323.7 537.4 323.7 537.4 323.7 537.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,538.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.7,537.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.1 538.2 323.1 538.2 323.1 538.3 323.1 538.3 323.1 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.8,542.1h.1c-.1,0,0,.1,0,.1v.3h-.2c0,.1,0,.1-.1.2s-.1-.3-.1-.5,0-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,540.7h.1a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s-.1.1,0,.1h.2s0,0,0,0h.2s0,.1,0,.1h.1c.1,0,0,.1.1.1h-.1c-.2.1-.1.3-.2.3h-.5c.1-.1,0-.3.1-.5s0-.1,0-.1h0v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.1-.1.2h-.1c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,540.7h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,539.2c.1,0,.2.1.2.2s0,.2,0,.3h-.3s0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 540.8 322.5 540.8 322.5 540.8 322.5 540.8 322.5 540.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.4s0,0,0,0S324,539.4,324.1,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.1 539.4 324.1 539.4 324.2 539.4 324.2 539.4 324.1 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.2 539.4 324.2 539.3 324.3 539.3 324.2 539.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.7 538.9 324.7 538.9 324.7 538.9 324.7 538.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,540.5a.2.2,0,0,1,0,.2H323a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,539.7c.1.1.1.2.1.3h-.3c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h.1s.1,0,0,.1H324s0,0,0-.1H324Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,539.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.2 539.6 324.2 539.6 324.2 539.6 324.2 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.8 539 324.8 539 324.8 539 324.8 539"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,539.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 539.8 324.1 539.8 324.1 539.8 324.1 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.6 540.3 323.6 540.3 323.6 540.3 323.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 539.8 324.1 539.8 324.1 539.8 324.1 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.6 540.3 323.6 540.3 323.6 540.3 323.6 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,539.6h0S324.2,539.6,324.3,539.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,542.6h.1c0,.1,0,.2-.1.2h-.2C322.1,542.6,322.1,542.5,322.3,542.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,541.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "320",
      "y": "543.6",
      "width": "8.6",
      "height": "4.38",
      "transform": "translate(-279 348.1) rotate(-41.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,541.6h.3c.2,0,.3.2.4.3s0,.1.1.1h0c0,.1.2.1.2.2h-.2a.5.5,0,0,0,0,.3h.1s0,.1,0,.1h-.1a.3.3,0,0,0,.1.3h.1c.1.1-.1.2,0,.3l.2.2h-.3s0,.1,0,.1l.2.2h0c-.1-.1-.2-.3-.3-.3h-.1c-.1.1-.1.3-.2.4a1.2,1.2,0,0,0-.1-.4c0,.1-.1.2-.1.3a1.1,1.1,0,0,1,.1-.4l-.4-.2c-.1,0-.1.2-.2.1h.2c0-.1.1-.1,0-.2h0s.1-.1,0-.1h-.1c-.1,0-.1.1-.1.1s0-.5.1-.7S325.6,541.6,325.8,541.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326 541.8 326 541.7 326 541.7 326 541.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,543.7a.1.1,0,0,1,.1.2H324C324,543.8,324.1,543.7,324.2,543.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.1 542 326.1 542 326.1 542 326.1 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.2 541.9 326.2 541.9 326.2 541.9 326.2 541.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 542 326.3 542 326.3 542 326.3 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 542 326.3 542 326.3 542 326.3 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.4 542 326.4 542 326.4 542 326.4 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 542.1 326.3 542.1 326.3 542.1 326.3 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,543.6l.3-.2s0,0,0,.1l-.3.2S324.6,543.5,324.7,543.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.5 542 326.4 542 326.5 542 326.5 542"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.8,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.7,542.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.5,542.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.6 543 325.6 543 325.6 543 325.6 543 325.6 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.8,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.2,547.6l.2.2c-.1,0,0,.1-.1.2a1.4,1.4,0,0,0,.1.4h-.1c-.1,0-.1.1-.2.1s0,.2-.1.2-.2-.4-.1-.6,0-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.1,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.6s0,0,0,.1S325.7,543.7,325.7,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,547.2h.6s.1,0,0,.1h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.9,546v.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s-.1.1,0,.1h.3s0,0,0,.1h.2s0,.1,0,.1h.1c0,.1,0,.1.1.1h-.1c.1,0,0,.1.1.1h-.1c-.2.1-.1.3-.3.4l-.2-.2h-.3v.2c.1-.2,0-.4.1-.6s0-.1-.1-.1h0l.2-.2a.9.9,0,0,0,0-.3c-.1,0-.1.2-.2.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,547.2c-.1,0,0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,546.1h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.3c.2,0,.2.2.3.3s0,.2,0,.3h0s0-.1,0-.1h0l-.2-.2h-.1c0,.1,0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.5.5,0,0,1-.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 546.2 324.7 546.1 324.7 546.2 324.7 546.2 324.7 546.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.5s0,0,0,0S326.7,544.5,326.8,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,544.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.9 544.5 326.9 544.5 326.9 544.5 326.9 544.5 326.9 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.6s0,0,0,0S326.8,544.6,326.8,544.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327 544.5 327 544.4 327 544.4 327 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.6 543.9 327.6 543.9 327.6 543.9 327.6 543.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.5,545.8a.3.3,0,0,1,0,.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,544.9c.1.1.1.2.1.4h-.3v-.2c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.1,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.6,545h0s.1.2.1.1h0s.1,0,0,.1h-.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.5,545.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.9 544.8 326.9 544.8 326.9 544.8 326.9 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.8 544 327.7 544 327.8 544 327.8 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.6,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.6,545.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.8 545 326.7 545 326.7 545 326.8 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.1 545.6 326.1 545.6 326.1 545.6 326.1 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.7 545 326.7 545 326.7 545 326.7 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.1 545.6 326.1 545.6 326.1 545.6 326.1 545.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,544.8h0S327,544.8,327,544.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,548.3v.2c0,.1,0,.2-.1.3h-.1c0-.1-.1-.1-.1-.2S324.1,548.3,324.2,548.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.3,546.6c.1,0,.1.1.1.2v.2h-.1a.2.2,0,0,1-.1-.2A.2.2,0,0,1,326.3,546.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "327.4",
      "y": "548.9",
      "width": "3.2",
      "height": "6.19",
      "transform": "translate(-276.8 337.8) rotate(-39.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326,550.8s-.1-.1,0-.2.1-.2.2-.3h.1s0,.1,0,.1.1-.1.2-.2-.1.1,0,.2h.8c0,.1-.1.1-.1.2h.2c-.1.1-.2.1-.2.2h-.1l-.2.3c0,.1.1.1.1.1h-.2s0,0,0,0h-.1a.1.1,0,0,0,0,.1h-.1c0,.1.1,0,.1.1h-.5C326.2,551,326,550.9,326,550.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.1 550.6 326.1 550.6 326.1 550.6 326.1 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,552h.1C327.5,552.1,327.5,552.1,327.5,552Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.6 326.3 550.6 326.3 550.6 326.3 550.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.2 550.5 326.2 550.5 326.2 550.5 326.2 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.5 326.3 550.5 326.3 550.4 326.3 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.4 326.3 550.4 326.3 550.4 326.3 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.3 326.3 550.4 326.3 550.4 326.3 550.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.4 550.5 326.4 550.5 326.4 550.5 326.4 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.4,551.6v-.2h0v.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.3 326.3 550.3 326.3 550.3 326.3 550.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.3,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.4,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.3,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.9,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.4,550.3h0S326.4,550.3,326.4,550.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327 551 327 551 327 551 327 551 327 551"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.3,554.2h0S330.3,554.3,330.3,554.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.2,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.3,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.9,553.7a1,1,0,0,1,0-.4h.1a2.5,2.5,0,0,0,0,.4s0,.1,0,.1S329.9,553.8,329.9,553.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,552.2h.3c0,.1.1,0,.1.1h.1c0-.1,0-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.4c.1.2.2.1.3.2v.2c0,.1,0,.1.1.1H330a.2.2,0,0,0,0,.2h-.1s0-.1,0-.1h-.4c0,.1.1.1.1.1h-.3l-.2-.2A.4.4,0,0,1,329.1,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,551.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,550.1l.2-.2h0c0,.1,0,0,0,.1H328s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.3 551.7 329.3 551.7 329.3 551.7 329.3 551.7 329.3 551.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550.1h0S328,550.1,328,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.1,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.1 550.1 328.1 550.1 328.1 550.1 328.1 550.1 328.1 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.2,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.2,550.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.1 550 328.1 550 328.1 550 328.1 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.7 549.5 327.7 549.5 327.7 549.5 327.7 549.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,551.1h.2v.2h-.1S329,551.1,329.1,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,550.1h.3a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,328.4,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.3h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.3 550 328.3 550 328.3 550 328.3 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.8 549.4 327.8 549.4 327.8 549.4 327.8 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.2h0S328.5,550.2,328.5,550.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.6,550.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.5 550.2 328.5 550.2 328.5 550.2 328.5 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.9 550.7 328.9 550.7 328.9 550.7 328.9 550.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.5 550.2 328.5 550.2 328.5 550.2 328.5 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.9 550.6 328.9 550.6 328.9 550.6 328.9 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,552h.1C330.9,552.2,330.8,552.1,330.8,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.6,550.5h.2s0,0,0,.1h-.1A.1.1,0,0,1,329.6,550.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "315.1",
      "y": "549.1",
      "width": "8.3",
      "height": "4.23",
      "transform": "translate(-315.5 498.1) rotate(-55.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.8,546.9h.2c.2-.1.3.1.5.1s.1.1.1.1h0c0,.1.2.1.3.2h-.2v.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,.1.2h.1c.1.1,0,.2.1.3h-.1s0,.1,0,.1h.2c-.1,0-.2-.2-.4-.2h-.1c-.1.1,0,.3-.1.4a1.1,1.1,0,0,0-.2-.4c0,.1,0,.2,0,.3a1,1,0,0,1,0-.4h-.4c-.1,0-.1.2-.2.1s.1-.1.1-.2,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.2s-.1-.5-.1-.7S319.6,547,319.8,546.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320 547 320 547 320 547 320 547"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.7,549.3v.2h-.2C318.6,549.4,318.6,549.3,318.7,549.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.1 547.2 320.1 547.2 320.1 547.2 320.1 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.2 547.1 320.2 547.1 320.2 547.1 320.2 547.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 547.2 320.3 547.2 320.3 547.2 320.3 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 547.2 320.3 547.2 320.3 547.2 320.3 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.4 547.2 320.4 547.1 320.4 547.2 320.4 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 547.3 320.3 547.3 320.3 547.3 320.3 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,549l.2-.2h0l-.2.2S319.1,549,319.2,549Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.5 547.1 320.5 547.1 320.5 547.1 320.5 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.3,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,547.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.9 548.2 319.9 548.2 319.9 548.2 319.9 548.3 319.9 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.1,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,553.6h.2c-.1.1,0,.1,0,.2l.2.3H317c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.1,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.1,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,553l.5-.2h-.7C317.2,553,317.3,553,317.4,553Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.1,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319,551.5l.2.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.5h-.3c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0v-.3a.8.8,0,0,0,0-.3c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2-.1-.2h-.1a.3.3,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.2,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.7,551.3h.1a.1.1,0,0,1,0,.1h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.7,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.1c.1,0,.2.1.3.2s.1.2,0,.3h-.3s0,.1,0,.1h0s0,.1,0,.1h0c0,.1.2.1.2.2h-.1a.4.4,0,0,1-.2-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "319.8",
      "y": "551.4",
      "height": "0.02",
      "transform": "translate(-312.9 473.8) rotate(-52.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,549.4s0,0,0,0S321.3,549.4,321.3,549.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,549.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.4 549.4 321.4 549.4 321.5 549.4 321.5 549.4 321.4 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.5 549.3 321.5 549.3 321.6 549.3 321.5 549.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322 548.7 322 548.6 322 548.6 322 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.5,550.9a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.8c.1.1.1.2.1.3h-.4c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.6,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,549.9h.1s0,0,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,550h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.5 549.6 321.5 549.6 321.6 549.6 321.5 549.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.2 548.7 322.1 548.7 322.2 548.7 322.2 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,550h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 549.9 321.4 549.9 321.4 549.9 321.4 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.9 550.6 320.9 550.6 320.9 550.6 320.9 550.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 549.9 321.4 549.9 321.4 549.9 321.4 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321 550.6 321 550.5 321 550.6 321 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.6,549.6h0S321.6,549.6,321.6,549.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.9,553.6h.1c0,.1,0,.2-.1.3h-.1v-.2C319.7,553.7,319.7,553.6,319.9,553.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,551.5h.1a.2.2,0,0,1-.1.2h-.2C321.2,551.6,321.3,551.5,321.4,551.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "314.8",
      "y": "559.4",
      "width": "7.2",
      "height": "3.66",
      "transform": "translate(-54.7 34.8) rotate(-5.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,559.2h.2c.1.1.1.3.2.4s0,.1,0,.1h0c-.1.1.1.2,0,.3s-.1-.2-.1-.1v.2h-.1v.2h0c0,.1-.1.1-.1.2s0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h0c0,.1,0,.1,0,.2h0c-.1-.1,0-.3-.1-.4H321l-.3.2.2-.3h-.2l.2-.2V560h.1s.1,0,.1-.1h-.2l.4-.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.4 321.6 559.4 321.6 559.4 321.6 559.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,559.8a.1.1,0,0,1,0,.2h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 559.6 321.5 559.5 321.5 559.6 321.5 559.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.7 559.6 321.6 559.5 321.7 559.5 321.7 559.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.7 321.6 559.7 321.6 559.7 321.6 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.7 321.6 559.7 321.6 559.7 321.6 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.7 559.7 321.7 559.7 321.7 559.7 321.7 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.8 321.6 559.7 321.6 559.7 321.6 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.8,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.8 559.8 321.8 559.7 321.8 559.7 321.8 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.7,559.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.7 560 320.7 560 320.7 560 320.7 560 320.7 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.4,561c.1.1,0,.1,0,.2h-.1v.3s0-.1,0-.1h-.3c.2-.1.1-.3.2-.5s.1-.2.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.9,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,561l.4.3s0,.1,0,.1h-.1l-.4-.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.6h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,561.2c0,.1,0,.1,0,.2H318a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1,0,.1h-.1c-.2-.1-.2.2-.4.1s-.1-.1-.1-.2h-.4l.4-.4s.1-.1,0-.1h.3l.2-.2h-.2a0,0,0,0,1,0-.1s.2-.1.1-.2-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,561.5c-.1,0,0,0,0,0S316.8,561.5,316.7,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.6,561.7h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.5,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.5c.1.1,0,.2.1.3s-.1.1-.2.2h0s0,0,0-.1h0s.1-.1,0-.1h.1a.3.3,0,0,0,0-.2s0,0,0,.1h-.1s0,.1,0,.1,0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2,0,.2s0-.1,0-.1a.4.4,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.5 561.7 318.5 561.7 318.5 561.7 318.5 561.7 318.5 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.9,561.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,561.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.8 561.6 320.8 561.6 320.8 561.7 320.8 561.7 320.8 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.7,561.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.9 561.7 320.9 561.7 321 561.7 320.9 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.6 561.6 321.6 561.6 321.6 561.6 321.6 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.3,561.9a.2.2,0,0,1-.1.2V562h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,561.9c0,.1-.1.2-.1.3h-.1V562a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,561.9h0c0,.1,0,.2,0,.2h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.7 561.9 320.8 561.8 320.7 561.9 320.7 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.7 561.8 321.6 561.8 321.7 561.8 321.7 561.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.1,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.5 561.9 320.5 561.9 320.5 561.9 320.5 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.8 562 319.8 562 319.8 562 319.8 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.5 561.9 320.5 561.9 320.5 561.9 320.5 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.8 562 319.8 562 319.8 562 319.8 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.2,563s0,.1,0,.2h-.3c0-.1,0-.1,0-.2S317.1,562.9,317.2,563Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,562.8c0,.1,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "315.4",
      "y": "550.1",
      "width": "3.9",
      "height": "7.71",
      "transform": "translate(-313.1 453.2) rotate(-51.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,553.2c0-.1-.1-.2,0-.2s.1-.3.2-.4h.1s0,.1.1.1.1-.2.2-.2-.1.2,0,.2h.8V552h.1c0,.1-.1.1-.1.2h.1v-.2h0c0,.1-.2.2-.2.3h0v.4c0,.1.2.1.1.2h-.3s0,0,0,0h-.2c0,.1.1,0,.1.1h-.6C313.6,553.5,313.4,553.4,313.4,553.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.5 553 313.5 553.1 313.5 553 313.5 553"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.5,554.4h.2C315.6,554.5,315.5,554.4,315.5,554.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.7 552.9 313.6 552.9 313.6 552.9 313.7 552.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.5 552.8 313.5 552.9 313.5 552.8 313.5 552.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.7 552.8 313.6 552.8 313.6 552.8 313.7 552.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.7 552.7 313.7 552.7 313.7 552.7 313.7 552.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 552.6 313.6 552.7 313.6 552.6 313.6 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.8 552.7 313.8 552.8 313.8 552.8 313.8 552.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553.9l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 552.6 313.6 552.6 313.6 552.6 313.6 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.2,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.2,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.1,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.5,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.8,552.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.6 553.2 314.6 553.2 314.6 553.2 314.6 553.2 314.6 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,556.4v-.2h.2l.3-.2h.3c-.2-.1-.3.2-.5.2s-.3,0-.3-.1S319.4,556.5,319.4,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.8,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.2,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.9,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.2,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.9,555.9a1.3,1.3,0,0,1-.1-.5h.1a3,3,0,0,0,.1.5s0,.1,0,.1S318.9,555.9,318.9,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,554.2l.2-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.2c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.2,0,.2-.1.2.1.1.1.1h-.6v.2c0,.1-.1.1,0,.1h-.1c0-.1,0-.1,0-.2H318c0,.1.2,0,.2.1h0c-.1,0-.2-.1-.2,0s0,.1-.1.1h-.3A.5.5,0,0,1,317.6,554.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.8,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.5,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.5,553.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.5,551.9c0-.1.1-.2.2-.3h0c0,.1-.1,0,0,.1h0v.2h.1c-.1,0,.1.1,0,.1h.5s-.1,0-.1.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.6 553.6 317.6 553.6 317.6 553.5 317.6 553.5 317.6 553.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.8,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.8h0S315.7,551.8,315.7,551.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.8 551.9 315.8 551.9 315.8 551.8 315.8 551.8 315.8 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.9,551.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.7 551.7 315.7 551.8 315.7 551.7 315.7 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.1 551.3 315.1 551.3 315.1 551.3 315.1 551.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.8,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.2,552.8h.3a.3.3,0,0,1-.1.2h-.1C317.2,552.9,317.1,552.9,317.2,552.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,551.9h.4a.3.3,0,0,0,0,.2h-.3A.1.1,0,0,1,316.1,551.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.9,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.8,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.2,552h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316 551.8 316 551.8 316 551.8 316 551.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.2 551.1 315.2 551.2 315.2 551.1 315.2 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,552h0S316.3,552,316.3,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.2,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,552h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.2 551.9 316.2 551.9 316.2 551.9 316.2 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 552.4 316.8 552.4 316.8 552.4 316.9 552.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.3 551.9 316.2 551.9 316.2 551.9 316.3 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.8 552.3 316.8 552.4 316.8 552.3 316.8 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.4,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.6,553.6h.2C319.7,553.8,319.5,553.7,319.6,553.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.8,552.1h.3s0,.1,0,.1h-.1C317.8,552.2,317.7,552.1,317.8,552.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "317.3",
      "y": "548.5",
      "width": "7.9",
      "height": "4.02",
      "transform": "translate(-314.4 503.5) rotate(-55.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,546.4h.2c.2-.1.3.1.4.1s.1.1.1.1h0c0,.1.2.1.3.2h-.2v.2h.1s0,0,0,.1h-.1v.2h.1c.1.1,0,.2.1.2h-.1s0,.1,0,.1h.2c-.1,0-.2-.2-.4-.2h-.1c-.1.1,0,.3,0,.4a1.1,1.1,0,0,0-.1-.4c0,.1,0,.2,0,.3a1,1,0,0,1,0-.3h-.4c-.1,0-.1.2-.1.1s.1-.1.1-.2,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.7S321.5,546.5,321.7,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.9 546.5 321.9 546.4 321.9 546.4 321.9 546.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,548.6h-.1C320.5,548.7,320.6,548.6,320.7,548.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 546.6 322 546.6 322 546.6 322 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 546.5 322.1 546.5 322.1 546.5 322.1 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 546.6 322.2 546.6 322.2 546.6 322.2 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 546.6 322.2 546.6 322.2 546.6 322.2 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.3 546.6 322.3 546.6 322.3 546.6 322.3 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 546.7 322.2 546.7 322.2 546.8 322.2 546.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.1,548.4l.2-.2h0l-.2.2S321.1,548.4,321.1,548.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.4 546.6 322.3 546.6 322.3 546.6 322.4 546.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.2,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.2,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.9,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,546.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.8 547.6 321.8 547.6 321.8 547.6 321.8 547.6 321.8 547.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.9,552.8h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.3,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.3,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,552.2l.5-.2h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,550.7h.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.4h-.5c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0v-.2a.8.8,0,0,0,0-.3c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2-.1-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,550.6h.1s0,.1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.7,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,548.5c.1,0,.2.1.3.2s.1.2,0,.3h-.3s0,.1,0,.1h0s0,.1,0,.1h0l.2.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.7 550.7 321.7 550.7 321.7 550.7 321.7 550.7 321.7 550.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,548.7s0,0,0,0S323.2,548.7,323.2,548.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,548.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.3 548.7 323.3 548.7 323.3 548.7 323.3 548.7 323.3 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.4 548.6 323.4 548.6 323.4 548.6 323.4 548.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.8 548 323.8 548 323.8 548 323.8 548"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,550.2a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,549.1c.1.1.1.2.1.3H323c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.2h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.4 548.9 323.4 548.9 323.4 548.9 323.4 548.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324 548.1 324 548.1 324 548.1 324 548.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 549.2 323.3 549.2 323.3 549.2 323.3 549.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 549.9 322.8 549.8 322.8 549.8 322.8 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 549.2 323.3 549.2 323.3 549.2 323.3 549.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.9 549.8 322.9 549.8 322.9 549.8 322.9 549.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,548.9h0S323.4,548.9,323.5,548.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.8,552.7h.1c0,.1,0,.2-.1.3h-.3C321.6,552.9,321.7,552.7,321.8,552.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,550.7h.1a.2.2,0,0,1-.1.2h-.2C323.1,550.8,323.1,550.7,323.2,550.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "309.5",
      "y": "543.3",
      "width": "3.7",
      "height": "7.22",
      "transform": "translate(-108.8 78.4) rotate(-12.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,549.8s0,.2-.1.2-.2.1-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.1-.2h-.2a.4.4,0,0,1,0-.1h-.4c0-.1-.2-.2-.2-.3h.3V549l.2.2.3-.2c0-.1-.1-.1,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.3A.6.6,0,0,1,313.8,549.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 549.9 313.6 549.9 313.6 549.9 313.6 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,547.7h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,312.9,547.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 549.8 313.4 549.8 313.4 549.8 313.4 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 550 313.4 550 313.4 550 313.4 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 549.9 313.3 550 313.3 550 313.3 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 550 313.3 550 313.3 550 313.3 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 550.1 313.3 550 313.3 550.1 313.2 550.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 549.9 313.2 549.9 313.2 549.9 313.2 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.8,548.1a.8.8,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 550.1 313.3 550.1 313.2 550.1 313.2 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,548.3h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.9,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,550h0S313.1,550,313.1,550Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 549.1 312.9 549.1 312.9 549.1 312.9 549.1 312.9 549.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,543.9h-.5c.1-.1,0-.1,0-.2v-.2c.1.2.3,0,.5.2s.2.1.2.3S311.3,543.9,311.3,543.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,544.6l-.2.4H311s0-.1,0-.1l.2-.4h.1C311.4,544.5,311.3,544.6,311.3,544.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,546.6H311c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2h-.3s0-.1,0-.1h-.3s0,0,0-.1H310c0-.2-.2-.2-.2-.4h.2c.1-.1,0-.1,0-.2h.1c-.1,0,0-.1-.1-.2l.4.3h.1v-.2h.1s-.1.1,0,.2v.4h.2c.1-.1-.1-.1-.1-.2h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,547.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311,547.1h0S311,547.1,311,547.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.4,549.5h-.3l-.2-.2h.3s0,0,0,0h.1s0,.1,0,.1h.1C311.4,549.3,311.4,549.4,311.4,549.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.9 547.1 310.9 547.1 310.9 547.1 310.9 547.1 310.9 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.4,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.3,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.2 549.4 311.2 549.4 311.2 549.4 311.2 549.4 311.2 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.2 549.5 311.2 549.5 311.2 549.5 311.2 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.3 550.2 311.4 550.2 311.4 550.2 311.3 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.2,549.4s0,0,0,0S311.2,549.4,311.2,549.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.8,547.9h0C310.8,547.8,310.9,547.8,310.8,547.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,549.2h-.3s0-.1,0-.1v-.2h.1c.1,0,0,.1.1.2A.1.1,0,0,1,311,549.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311,549h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,548.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311 549.3 311 549.3 311 549.3 311 549.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.2 550.2 311.2 550.2 311.2 550.2 311.2 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,549.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,548.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.9 549.1 310.9 549.1 310.9 549.1 310.9 549.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.8 548.3 310.8 548.3 310.8 548.4 310.8 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.9 549.1 310.9 549.1 310.9 549.1 310.9 549.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.7 548.4 310.8 548.4 310.8 548.4 310.7 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.9,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.5,545.9h-.2c-.1-.1-.2-.1-.1-.2h.2C309.5,545.7,309.6,545.8,309.5,545.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.9,548.1h0A.1.1,0,0,1,309.9,548.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "310.4",
      "y": "538.3",
      "width": "3.6",
      "height": "7.04",
      "transform": "translate(-175 149.8) rotate(-21.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,539.4c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1h.3c0,.1-.1.1-.1.2h1l-.3.2h0c0,.1.2.1.3.2h-.3l.2.2h-.3l-.3.2c0,.1.1.1,0,.2s0-.1-.1-.2h-.3c-.1.1.1.1.1.1l-.5-.2C309.5,539.7,309.4,539.6,309.4,539.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.6 539.3 309.6 539.3 309.6 539.3 309.6 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.6,541.3h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,310.6,541.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.8 539.3 309.8 539.3 309.8 539.3 309.8 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.8 539.2 309.7 539.2 309.8 539.2 309.8 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539.2 309.9 539.2 309.9 539.2 309.9 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539.2 309.9 539.2 309.9 539.2 309.9 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539.1 309.9 539.1 309.9 539.1 309.9 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310 539.2 310 539.2 310 539.2 310 539.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.6,540.8v-.2h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539 309.9 539 309.9 539 309.9 539"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,540.7h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.3,539.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.1,539.1h0S310.1,539.1,310.1,539.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.4 540 310.4 540 310.4 540 310.4 540 310.4 540"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.5,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.8,544.7h.5c0,.1,0,.1.1.2h.1c-.1-.1-.3,0-.5-.1s-.2-.1-.2-.2S312.8,544.7,312.8,544.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.6,544a1.2,1.2,0,0,1,.1-.4h.1s0,.1,0,.1v.4h-.1C312.5,544.1,312.6,544.1,312.6,544Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,542.1h.4c0,.1.1.1,0,.1h.1c0-.1.1-.1.1-.2h.3s0-.1,0-.1h.3s0,0,0,.1h.1c0,.2.2.2.2.3h-.2c-.1.1,0,.1,0,.2h-.1v.2l-.4-.3h-.1v.2H313c-.1,0,0-.1,0-.2v-.4h-.2c-.1.1.1.1.1.2h-.3a.3.3,0,0,1-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.6,541.5h0A.1.1,0,0,1,312.6,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,541.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.8,539.4h.1c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C311.8,539.5,311.8,539.4,311.8,539.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.6 541.6 312.6 541.6 312.6 541.6 312.6 541.6 312.6 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.4h0S311.9,539.4,311.9,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.9,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312 539.4 312 539.4 312 539.4 312 539.4 312 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312,539.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312 539.3 311.9 539.3 312 539.3 312 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.7 538.7 311.7 538.7 311.7 538.7 311.7 538.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.6,540.8h0C312.6,540.9,312.6,540.9,312.6,540.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,539.6h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,312.2,539.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.8h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 539.5 312.2 539.4 312.2 539.4 312.2 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.9 538.6 311.8 538.6 311.9 538.6 311.9 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,539.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.3 539.6 312.3 539.7 312.3 539.6 312.3 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.6 540.3 312.6 540.3 312.6 540.3 312.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.3 539.7 312.3 539.7 312.3 539.7 312.3 539.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.6 540.3 312.6 540.3 312.6 540.3 312.6 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.2,542.5h.2c.1,0,.2.1.2.2h-.2C314.2,542.7,314.1,542.6,314.2,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,540.5h0A.1.1,0,0,1,313.4,540.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "310.9",
      "y": "535.8",
      "width": "7.2",
      "height": "3.69",
      "transform": "translate(-202.1 189.7) rotate(-25.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,534.6h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.2.1.3h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,0,.2h0c0,.1-.1.1,0,.2v.2h-.2v.2h0c-.1-.1-.1-.3-.2-.3h-.1c-.1,0-.1.2-.2.3a1,1,0,0,0,0-.4l-.2.2v-.3l-.2-.3h0s.1-.1,0-.1h-.2c.1-.2.1-.4.2-.6S316.5,534.6,316.7,534.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.8 534.7 316.8 534.7 316.8 534.7 316.8 534.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.9,535.9a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.9 535 316.9 534.9 316.9 534.9 316.9 535"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 534.9 317 534.9 317 534.9 317 534.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 535 317 535 317 535 317 535"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 535 317 535 317 535 317 535"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.1 535.1 317.1 535 317.1 535 317.1 535.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 535.1 316.9 535.1 316.9 535.1 317 535.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,535.9h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.1 535 317.1 535 317.1 535 317.1 535"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.5,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.4,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.5,535.9s0,0,0,0S315.5,535.9,315.5,535.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,535.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.1,535.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.2 535.6 316.2 535.6 316.2 535.6 316.2 535.6 316.2 535.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,535.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.6,538.4v.2h-.1a1.2,1.2,0,0,0,0,.3h-.3v.2c.1-.2,0-.3.1-.5s.1-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.2,536.2s0,0,0,.1S316.1,536.2,316.2,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,536.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,538.2h.5s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.3h0S316.1,536.3,316.1,536.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.2,537.7c.1,0,0,.1.1.2v.2c-.1,0-.1.1-.1.1s-.1.1,0,.1h.4s0,.1,0,.1h0s0,.1,0,.1h-.1s-.1.1,0,.1h-.1c-.2,0-.2.2-.3.3v-.2h-.4c.1-.1.1-.3.2-.5s0-.1,0-.1h.3v-.2c-.1-.1-.1.1-.2.1h0c0-.1.1-.1.1-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313,538.4c-.1,0,0,0,0,0S313,538.4,313,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,538h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537c.1,0,.1.2.2.3s0,.2-.1.3,0-.1,0-.1h0s0-.1,0-.1h.1V537s0,0,0,.1h0c0,.1.1,0,0,.1s0-.1,0-.1h0s0,.1,0,.1h0c0,.1.1.1,0,.2h-.1a.4.4,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.7 538 314.8 538 314.8 538 314.8 538 314.7 538"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.9,537h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.9,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.9,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.8,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 537.2 316.9 537.2 316.9 537.2 316.9 537.2 316.9 537.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.9,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.8,537.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317 537.2 317 537.1 317 537.2 317 537.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.7 536.9 317.7 536.8 317.7 536.8 317.7 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.9,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.5,538a.2.2,0,0,1,0,.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,537.4c.1.1,0,.2,0,.3h-.3a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,537.5h0s0,.2.1.1h0s0,0,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,537.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 537.4 316.9 537.4 316.9 537.4 316.9 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.7 537 317.7 537 317.7 537 317.7 537"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,537.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,537.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.7,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.4,538.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.7,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,537.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.7 537.5 316.7 537.5 316.7 537.5 316.7 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316 537.9 316 537.9 316 537.9 316 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.7 537.6 316.7 537.6 316.7 537.5 316.7 537.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.1 537.9 316.1 537.9 316.1 537.9 316.1 537.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.9,539.7c.1,0,.1.1.1.2s-.1.2-.2.2h-.1c0-.1-.1-.1,0-.2S313.8,539.6,313.9,539.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.9,538.8c.1,0,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "310.5",
      "y": "531.4",
      "width": "6.3",
      "height": "3.24",
      "transform": "translate(-303 580) rotate(-63.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,536.3H313v-.2h0v-.2h-.1c-.1,0,0-.1-.1-.2h.2s0,0,0-.1h.1c.1-.1,0-.2,0-.3l.2.3c0-.1,0-.2,0-.2v.3h.3s0-.1.1-.1-.1.1-.1.1,0,.1,0,.1h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.2.3.2.5S313.9,536.2,313.8,536.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 536.2 313.6 536.2 313.6 536.3 313.6 536.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,534.4h.1A.1.1,0,0,1,314.3,534.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 536.1 313.5 536.1 313.5 536.1 313.4 536.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 536.2 313.4 536.2 313.4 536.2 313.4 536.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 536.1 313.3 536.2 313.3 536.2 313.3 536.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 536.1 313.3 536.1 313.3 536.1 313.3 536.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 536.2 313.2 536.2 313.2 536.2 313.2 536.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 536.1 313.3 536 313.3 536 313.3 536.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314,534.6v.2h0v-.2S314,534.6,314,534.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 536.2 313.2 536.2 313.2 536.2 313.2 536.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,535.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,536.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.5 535.3 313.5 535.3 313.5 535.3 313.5 535.3 313.5 535.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,535.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.2,530.9H315c0-.1,0-.1,0-.1l-.2-.2h.1c.1,0,.1-.1.1-.1s0-.1,0-.2.2.2.2.4.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,535.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,535.1s0,0,0,0S313.1,535.1,313.1,535.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.9,531.4l-.4.2h0l.4-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,532.7h-.2v-.2c.1,0,0-.1.1-.1s0-.1,0-.1H313c.1-.1,0-.2.1-.4h.4c0-.1.1-.1.1-.2s.1.3.1.4h.1c-.1.1,0,.1-.1.2v.2c.1,0,0-.1.1-.2h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,531.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,532.9h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.3,532.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,534.8H312c0-.1-.1-.1-.1-.2h.1s0,.1,0,.1h.2s0,0,0-.1h-.1a.3.3,0,0,1,.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 532.9 313.2 532.9 313.2 532.9 313.2 532.8 313.2 532.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 534.6 312.2 534.6 312.2 534.6 312.2 534.6 312.2 534.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.1 534.7 312.1 534.7 312.1 534.7 312.1 534.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.9 535.2 311.9 535.2 311.9 535.3 311.9 535.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.7,533.3a.2.2,0,0,1-.1-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.3c-.1,0-.1-.1-.1-.2h.3c0,.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.1h0S312.3,534.1,312.3,534.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.1 534.4 312.1 534.5 312.1 534.5 312.1 534.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.7 535.2 311.7 535.2 311.7 535.2 311.7 535.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.7,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.1 534.2 312.2 534.2 312.2 534.3 312.1 534.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.4 533.6 312.5 533.7 312.4 533.7 312.4 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.2 534.2 312.2 534.2 312.2 534.2 312.2 534.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.4 533.7 312.4 533.7 312.4 533.7 312.4 533.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.5,535.1h0S311.5,535.1,311.5,535.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,531.2h-.1c0-.1,0-.2,0-.2h.2C313,531.1,313,531.2,312.9,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312,533h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,312,533Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "316.7",
      "y": "525.3",
      "width": "4.2",
      "height": "8.29",
      "transform": "translate(-272.9 351) rotate(-42.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,528c0-.1-.1-.2,0-.2s.2-.3.2-.4h.2c.1,0,0,.1,0,.1s.1-.2.2-.2-.1.2,0,.2h.9v-.2h.1c0,.1-.1.1-.1.2h.1V527h0c-.1.1-.3.2-.3.3h-.1l-.2.3c0,.1.2.1.1.2h-.3s0,0,0,0h-.1s0,.1,0,.1h-.1c0,.1.1.1.1.1h-.7C315,528.3,314.8,528.2,314.7,528Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.9 527.8 314.9 527.8 314.9 527.8 314.9 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,529.5h.2v.2h-.1C316.8,529.7,316.8,529.6,316.8,529.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.7 315.1 527.7 315.1 527.7 315.1 527.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315 527.6 315 527.6 315 527.6 315 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.5 315.1 527.5 315.1 527.5 315.1 527.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.5 315.1 527.5 315.1 527.5 315.1 527.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.4 315.1 527.4 315.1 527.4 315.1 527.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.2 527.5 315.2 527.5 315.2 527.5 315.2 527.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.6,529l-.2-.2h.1l.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.3 315.1 527.3 315.1 527.3 315.1 527.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,528.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.9,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.3,527.3h0S315.3,527.3,315.3,527.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316 528.2 316 528.2 316.1 528.1 316.1 528.1 316 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.1,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,532.4v-.2h.4c0,.1.1.1.1.2h.2c-.2-.1-.4.2-.6.1s-.3,0-.3-.1S320.6,532.4,320.6,532.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,531.7a1.4,1.4,0,0,1,0-.6h.1a3.2,3.2,0,0,0,0,.5s0,.1,0,.1S320.1,531.7,320.2,531.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319,529.7h.4c0,.1.2,0,.1.1h.1c0-.1.1-.2,0-.3h.1c.1,0,0-.1,0-.1h.2c0-.1-.1-.1,0-.1h.6s0,.1,0,.1.3.1.4.3-.1.2-.2.2.1.1.1.2h-.7a.3.3,0,0,0,0,.2c0,.1-.1.1-.1.1s0-.1-.1-.2,0-.1,0-.2l-.2-.2h-.3c0,.1.2.1.2.2h-.1c-.1,0-.2-.1-.2,0h-.1l-.3-.2A.5.5,0,0,1,319,529.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,530.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.1,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.1,529h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,526.9c0-.2.2-.2.3-.3h0c0,.1-.1,0,0,.1h0l-.2.2h.1c-.1,0,.1.1,0,.1h.4l-.4.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.1 529 319.1 529 319.2 529 319.2 529 319.1 529"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.4,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.9h0S317.4,526.9,317.4,526.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.5,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.5 526.9 317.5 526.9 317.5 526.9 317.5 526.9 317.5 526.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.5 526.8 317.4 526.8 317.5 526.8 317.5 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 526.2 316.9 526.2 316.9 526.2 316.9 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.8,528.2h.3v.2h-.1C318.8,528.3,318.8,528.2,318.8,528.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,527h.4a.3.3,0,0,0-.1.2h-.1c-.1,0-.1-.1-.2-.1A.1.1,0,0,1,317.9,527Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527.1h.1s0-.1,0-.1H318Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.8 526.8 317.7 526.8 317.8 526.8 317.8 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.1 526 317 526.1 317 526 317.1 526"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527.1h0S318.1,527.1,318,527.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.1,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318 527 318 527 318 527 318 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318.6 527.6 318.6 527.7 318.6 527.6 318.6 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318 527 318 527 318 527 318 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318.6 527.6 318.5 527.6 318.6 527.6 318.6 527.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.8,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.3,529.4h.1c.1,0,.2,0,.3.1a.2.2,0,0,1,0,.1h-.2C321.4,529.6,321.2,529.5,321.3,529.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.6,527.4h.3s0,.1,0,.1h-.2A.1.1,0,0,1,319.6,527.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "319.6",
      "y": "521.7",
      "width": "3.5",
      "height": "6.88",
      "transform": "translate(-211.7 833.3) rotate(-88.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.5,523.5h.1c.1.1.1.3.1.4s0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2v.2h-.1v.2h0v.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h0c0,.1,0,.1,0,.2h0c0-.1,0-.3-.1-.4h-.1l-.3.2.2-.3h-.2l.2-.2a.8.8,0,0,0-.1-.3h0l.4-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 523.7 324.6 523.7 324.6 523.7 324.6 523.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,523.9a.1.1,0,0,1-.1.1h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 523.9 324.5 523.9 324.5 523.9 324.5 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 523.9 324.6 523.9 324.6 523.9 324.6 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 524 324.6 524 324.6 524 324.6 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 524.1 324.6 524.1 324.6 524.1 324.6 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 524.1 324.7 524.1 324.7 524.1 324.7 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 524.1 324.5 524.1 324.5 524.1 324.5 524.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,524.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 524.1 324.7 524.1 324.7 524.1 324.7 524.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,524.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,524.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 524.2 323.7 524.2 323.7 524.2 323.7 524.2 323.7 524.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.5,524.6c0,.1,0,.1,0,.2h-.1l-.2.3s0-.1,0-.1h-.3c.2-.1.1-.3.3-.4s.2-.2.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.7,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,524.7l.4.3s0,.1,0,.1h-.1l-.3-.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,525.1c0,.1,0,.1,0,.2h-.2a.1.1,0,0,0,0,.1h-.1s-.1.1,0,.1h-.1c0,.1-.1.1,0,.1h0c-.2-.1-.2.1-.4.1s-.1-.2,0-.2h-.3l.4-.3s.1-.1,0-.1h.3a0,0,0,0,1,0-.1s.2,0,.1-.1-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.7,525.2c-.1,0,0,0,0,0S319.7,525.2,319.7,525.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,525.6h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.7c.1.1,0,.2,0,.3l-.2.2h.1s.1,0,0-.1h.1c-.1,0,0,0,0-.1h0a.3.3,0,0,0,0-.2h-.1s0,.1,0,.1,0,0,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s0-.1,0-.1a.4.4,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 525.6 321.4 525.6 321.4 525.6 321.4 525.6 321.4 525.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,525.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.6 525.8 323.6 525.8 323.6 525.9 323.6 525.9 323.6 525.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,525.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.7 525.9 323.7 525.9 323.7 525.9 323.7 525.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.4 525.9 324.4 525.9 324.4 525.9 324.4 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,525.9a.2.2,0,0,1-.2.2v-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,526c0,.1-.1.2-.2.2h-.1v-.2a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0c0,.1-.1.1,0,.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,526h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.5 526 323.5 526 323.5 526 323.5 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.4 526 324.4 526 324.4 526 324.4 526"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.9,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,526h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 526.1 323.3 526 323.3 526 323.3 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 526 322.5 526 322.5 526 322.5 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.2 526.1 323.2 526.1 323.2 526.1 323.2 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.6 526.1 322.6 526 322.6 526.1 322.6 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,526.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320,526.7s0,.1,0,.2h-.3s0-.1,0-.2S319.9,526.6,320,526.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,526.8c0,.1,0,.1,0,.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "320.2",
      "y": "517.8",
      "width": "7.5",
      "height": "3.85",
      "transform": "translate(-286.6 472) rotate(-53.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,523.7h-.2c-.2,0-.3-.1-.4-.1s-.1-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2V523h-.1s0,0,0-.1h.1v-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0,0,0-.1h-.1l.3.2h.1c.1-.1,0-.3.1-.4a1,1,0,0,0,.1.4c0-.1,0-.2.1-.2a.9.9,0,0,1,0,.3h.3c.1,0,.1-.2.1-.1v.2s0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.1.4.1.6S323.6,523.6,323.4,523.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.2 523.6 323.3 523.6 323.2 523.6 323.2 523.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,521.5h.1C324.6,521.5,324.5,521.5,324.4,521.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.1 523.4 323.1 523.4 323.1 523.4 323.1 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323 523.5 323.1 523.5 323 523.5 323 523.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323 523.4 323 523.4 323 523.4 323 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 523.4 322.9 523.4 322.9 523.4 322.9 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.8 523.4 322.9 523.4 322.9 523.4 322.8 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 523.3 323 523.3 323 523.3 322.9 523.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,521.8l-.2.2h0l.2-.2S324.1,521.8,324,521.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.8 523.4 322.8 523.4 322.8 523.4 322.8 523.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.7,523.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "323.4",
      "y": "522.4",
      "height": "0.02",
      "transform": "translate(-287.4 455.1) rotate(-52)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.3,517.6h-.2c.1-.1,0-.1,0-.2l-.2-.3h.1c.1,0,.1-.1.1-.2s0-.2,0-.2.2.3.2.5.1.3-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,519.5h-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.4s0-.1,0-.1h-.2c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.5v-.2c0,.2.1.4,0,.5s0,.1.1.1h0v.2a.8.8,0,0,0,0,.3c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,518.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,519.6h-.1a.1.1,0,0,1,0-.1h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.6c-.1,0-.2-.1-.3-.2s0-.2,0-.3h.3s0-.1,0-.1h0v-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.6 519.5 323.6 519.5 323.5 519.5 323.6 519.5 323.6 519.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,521.3s0,0,0,0S322.1,521.3,322.1,521.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,521.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322 521.4 322 521.4 322 521.4 322 521.3 322 521.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,521.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.9 521.4 321.9 521.5 321.9 521.5 321.9 521.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.4 522 321.4 522 321.4 522 321.4 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,520a.2.2,0,0,1-.1-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521c-.1-.1-.1-.2-.1-.3h.4c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.8,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.9H322s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.2,520.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.9 521.1 321.9 521.2 321.9 521.2 321.9 521.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.3 521.9 321.3 521.9 321.3 521.9 321.3 521.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 520.9 322 520.9 322 520.9 322 520.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 520.3 322.5 520.3 322.5 520.3 322.5 520.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 520.9 322 520.9 322 520.9 322 520.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.4 520.3 322.4 520.3 322.4 520.3 322.4 520.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.8,521.1h0S321.8,521.1,321.8,521.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,517.6h-.1c0-.1,0-.2.1-.2h.2C323.7,517.5,323.6,517.6,323.5,517.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,519.4H322a.2.2,0,0,1,.1-.2h.2C322.3,519.4,322.2,519.5,322.1,519.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "318.1",
      "y": "513.8",
      "width": "7.4",
      "height": "3.78",
      "transform": "translate(-69.9 50.9) rotate(-8.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.9,513.3h.2c.2.1.1.3.2.4s0,.1,0,.1h0c-.1.1.1.2.1.3s-.1-.2-.2-.1v.2h-.1a.3.3,0,0,0-.1.2h0c0,.1-.1.1-.1.2s.1.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h0c0,.1,0,.1,0,.2h0c-.1-.1,0-.3-.1-.4h-.1c-.1,0-.2.2-.3.2l.2-.3H324l.2-.2-.2-.3h.1s.1,0,.1-.1H324l.4-.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.9 513.5 324.9 513.5 325 513.5 324.9 513.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,514.1a.1.1,0,0,1,0,.2h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.9 513.7 324.9 513.7 324.9 513.7 324.9 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.7 325 513.7 325 513.7 325 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.8 325 513.8 325 513.8 325 513.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.9 325 513.9 325 513.9 325 513.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 513.9 325.1 513.9 325.1 513.9 325.1 513.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.9 324.9 513.9 324.9 513.9 325 513.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,514.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.2 513.9 325.1 513.9 325.2 513.9 325.2 513.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,514.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 514.2 324.1 514.2 324.1 514.2 324.1 514.2 324.1 514.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,514.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.7,515.5c.1.1,0,.1.1.2h-.1v.3s0-.1,0-.1h-.4c.2-.1.1-.4.2-.5s.1-.2.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,514.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.9,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,514.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,515.5l.4.2s0,.1,0,.1h-.1l-.4-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.9h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,515.6c0,.1,0,.1,0,.2v.2h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1,0,.1h-.1c-.2,0-.2.2-.4.2s-.1-.1-.1-.2h-.4l.4-.4s.1-.1,0-.1h.3l.2-.2h-.3s.2-.1.1-.2-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320,515.9c-.1,0,0,0,0-.1S320.1,515.9,320,515.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,516h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.9,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,515.7c.1.1,0,.2.1.3s-.1.2-.2.2h0s0,0,0-.1h0s.1-.1,0-.1h.1a.3.3,0,0,0,0-.2s0,0,0,.1h-.1s0,.1,0,.1,0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2,0,.2s0-.1,0-.1a.4.4,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.9 516.1 321.9 516.1 321.9 516.1 321.9 516.1 321.9 516.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,515.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,515.9h0S324.3,515.9,324.4,515.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,515.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.3 515.9 324.3 515.9 324.3 516 324.3 516 324.3 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,516h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.4 516 324.4 515.9 324.4 516 324.4 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.1 515.9 325.1 515.8 325.1 515.8 325.1 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,516.3a.2.2,0,0,1-.1.2v-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,516.2c0,.1-.1.2-.1.3h-.1v-.2a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0c0,.1,0,.2,0,.2h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.2 516.1 324.2 516.1 324.2 516.1 324.2 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.1 516 325.1 516 325.1 516 325.1 516"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324 516.2 324 516.2 324 516.2 324 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 516.3 323.2 516.3 323.2 516.3 323.2 516.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.9 516.2 323.9 516.2 324 516.2 323.9 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 516.4 323.2 516.3 323.2 516.3 323.2 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.2,516.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,517.5s0,.1,0,.2h-.3c0-.1,0-.1,0-.2S320.5,517.4,320.6,517.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,517.2c0,.1,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "311",
      "y": "514.3",
      "width": "7.1",
      "height": "3.61",
      "transform": "translate(-258.3 323.1) rotate(-40)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,519.6h-.2c-.2,0-.2-.1-.4-.2s0-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.3.3,0,0,0,0-.2h-.1c0-.1,0-.2,0-.2h.1s0,0,0-.1h-.1c.1.1.1.2.3.2h.1c.1-.1.1-.2.1-.3a1,1,0,0,0,0,.3c0-.1.1-.2.1-.2a.9.9,0,0,1,0,.3l.3.2h0s0,.1,0,.1h0s-.1.1,0,.1h.1c.1,0,0-.1.1-.1s0,.4-.1.6S313.3,519.5,313.2,519.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313 519.4 313 519.5 313 519.5 313 519.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,517.9a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 519.3 312.9 519.3 312.9 519.3 312.9 519.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 519.3 312.8 519.3 312.8 519.3 312.8 519.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 519.2 312.8 519.2 312.8 519.2 312.8 519.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.7 519.2 312.8 519.2 312.7 519.2 312.7 519.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.6 519.2 312.7 519.2 312.7 519.2 312.6 519.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 519.1 312.8 519.1 312.8 519.1 312.8 519.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.1,518h-.2s0,0,0-.1h.2S314.1,518,314.1,518Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.6 519.2 312.6 519.2 312.6 519.2 312.6 519.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314,518h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.1,518h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.3,518.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,519.1h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "313.3",
      "y": "518.4",
      "height": "0.02",
      "transform": "translate(-260.9 325.4) rotate(-40.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.2,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.1,514.7h-.1c.1,0,0-.1.1-.1a1.1,1.1,0,0,0-.1-.3h.3c0-.1,0-.1.1-.2s.1.3.1.5,0,.2-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313,518.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.9s0,0,0-.1S313.3,517.9,313.3,517.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.5,515.1H316s-.1,0,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,516v-.2a.3.3,0,0,1,0-.2c.1,0,0-.1.1-.1s.1-.1,0-.1h-.2s0,0,0-.1h-.2s0-.1,0-.1h-.1s0-.1,0-.1h.1c.2-.1.1-.3.2-.3l.2.2h.4c-.1.1,0,.3-.1.5s0,.1,0,.1h0l-.2.2a.7.7,0,0,0,0,.2c.1,0,.1-.1.2-.2h.1c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.8,515c.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.1,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.2,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.4c-.1,0-.2-.2-.2-.2s0-.2,0-.3h0s0,.1,0,0h0v.2h.1s0-.1,0-.1h-.1c0-.1-.1,0,0-.1h.1s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.4.4,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.2 515.8 314.2 515.9 314.2 515.8 314.2 515.8 314.2 515.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,517.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,517.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 517.2 312.3 517.2 312.3 517.1 312.3 517.1 312.3 517.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,517.1s0,0,0,0S312.4,517.1,312.3,517.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,517.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 517.2 312.2 517.2 312.2 517.2 312.2 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.7 517.6 311.7 517.7 311.7 517.7 311.7 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,516.1a.2.2,0,0,1,0-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.4,516.9c-.1-.1,0-.2,0-.3h.3c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.8h-.1s-.1,0,0-.1h.1s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 516.9 312.3 517 312.3 516.9 312.3 516.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.6 517.5 311.6 517.5 311.6 517.5 311.6 517.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.4 516.8 312.4 516.8 312.4 516.8 312.4 516.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "313 516.3 313 516.3 313 516.3 313 516.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.4 516.7 312.4 516.7 312.4 516.8 312.4 516.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.9 516.3 313 516.3 313 516.3 312.9 516.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,516.9h0S312.2,516.9,312.2,516.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,514.1h-.1c0-.1,0-.2.1-.2h.1s.1.1.1.2S314.7,514.1,314.5,514.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,515.4c-.1,0,0-.1-.1-.1h.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "308.1",
      "y": "509.4",
      "width": "7.8",
      "height": "3.99",
      "transform": "translate(-117 93.3) rotate(-14.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.1,514.2h-.2c-.2-.1-.2-.3-.2-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.4.4,0,0,0,.1-.2h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.2v-.2h.1c.1.1,0,.2.1.2h0c-.1-.1,0-.1-.1-.2h0c.1.1,0,.3.2.4h.1c.2,0,.2-.2.3-.3a1.1,1.1,0,0,0-.1.4l.2-.2-.2.3.2.3h0s-.1.1-.1.1h.2l-.3.6C309.4,514.2,309.2,514.3,309.1,514.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309 514 308.9 514 308.9 514 309 514"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.2,513.2a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309 513.8 309 513.8 309 513.8 309 513.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.8 513.8 308.8 513.8 308.8 513.8 308.8 513.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.8 513.7 308.8 513.7 308.8 513.7 308.8 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.8 513.7 308.8 513.7 308.8 513.7 308.8 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.7 513.6 308.7 513.7 308.7 513.6 308.7 513.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.9 513.6 308.9 513.6 308.9 513.6 308.9 513.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.8,513.1h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.7 513.6 308.7 513.6 308.7 513.6 308.7 513.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.7,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,513.1s0,0,0,0S310.6,513.1,310.6,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.6,513.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M308.7,513.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.8 513.2 309.8 513.2 309.8 513.2 309.8 513.2 309.8 513.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.6,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,511.2c-.1,0-.1-.1-.1-.2h.1a1.3,1.3,0,0,0,.1-.4h.4c-.2.1,0,.4-.2.5s-.1.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.5,512.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.6s0-.1,0-.1S310,512.6,310,512.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.6,512.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,511.3l-.5-.2s0-.1,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.4,511.4c-.1-.1,0-.2,0-.2V511c.1,0,.1-.1.2,0h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2,0,.2-.2.4-.2s.1.1.1.2h.4c-.1.1-.2.3-.3.4s-.1.1,0,.1h-.3l-.2.2c.1.1.1-.1.2-.1h0c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,511c.1,0,0,0,0,.1S313.8,511,313.8,511Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.8,511.1a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.9,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.3,511.6c-.1-.1-.1-.2-.1-.4s.1-.2.2-.2,0,.1,0,.1h0s0,0,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.2s0,.1.1.1a.4.4,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 511 311.8 511 311.8 511 311.8 511 311.9 511"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.4,511.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.3,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.5,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.3,511.5a0,0,0,0,1,0,0S309.3,511.5,309.3,511.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.2,511.5h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.4 511.4 309.4 511.4 309.4 511.4 309.4 511.4 309.4 511.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.4,511.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.5,511.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.3 511.4 309.3 511.4 309.2 511.4 309.3 511.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.5 511.6 308.5 511.6 308.5 511.6 308.5 511.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,510.9a.3.3,0,0,1,.1-.3v.2H311Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.6,511.2c-.1-.1.1-.2.1-.3h.3a.1.1,0,0,1,0,.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.8,511.1h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.9,511.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.5 511.2 309.4 511.2 309.4 511.2 309.5 511.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.5 511.4 308.5 511.4 308.5 511.4 308.5 511.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.8,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.9,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.1,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.9,511s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.7 511.1 309.7 511.1 309.7 511.1 309.7 511.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.5 510.9 310.5 510.9 310.5 510.9 310.5 510.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.7 511.1 309.7 511.1 309.7 511.1 309.7 511.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.4 510.9 310.4 510.9 310.4 510.9 310.4 510.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.3,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.1,509.4s0-.1,0-.2h.3c0,.1.1.1,0,.2S313.2,509.5,313.1,509.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.7,509.9c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "302.9",
      "y": "506.9",
      "width": "6.6",
      "height": "3.4",
      "transform": "translate(-256 699.2) rotate(-77.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.2,511.9h-.8s.1,0,0-.1h-.2s0,.1,0,.1H306v-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.3s0,0,0-.1h.1c0-.1-.1-.2-.1-.3l.2.2c-.1-.1,0-.2,0-.2v.3h.3s0-.1.1-.2,0,.1,0,.2h.2c.1,0,0-.1,0-.1l.3.5A.5.5,0,0,1,307.2,511.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "307 511.9 307 512 307 512 307 511.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.2,509.9h0A.1.1,0,0,1,307.2,509.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.8 511.9 306.8 511.9 306.8 511.9 306.8 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.8 512 306.8 512 306.8 512 306.8 512"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.7 511.9 306.7 511.9 306.7 511.9 306.7 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 511.9 306.7 511.9 306.6 511.9 306.6 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 512 306.6 512 306.6 512 306.6 512"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 511.8 306.6 511.8 306.6 511.8 306.6 511.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.9,510.2v.2h0v-.2S307,510.2,306.9,510.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 512 306.6 512 306.6 512 306.6 512"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.9,510.3h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.9,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.9,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.5,511.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.7 511 306.7 511 306.6 511 306.6 511 306.7 511"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.5,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.3,506.1h-.2c0-.1,0-.1,0-.1l-.2-.2h.1c.1,0,0-.1,0-.2s-.1-.1,0-.2.3.2.3.3.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.2,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.2,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307,506.7l-.3.3h0l.3-.2h.1C307.2,506.6,307.1,506.7,307,506.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,508.3H306c.1,0-.1-.1,0-.1h-.8c.1-.2-.1-.2,0-.4h.2c.1,0,.1-.1.1-.1h.1c0-.1.1-.1,0-.2s.2.3.2.4h.3c0,.1-.1.1-.1.1H306c0,.1,0,.2,0,.2v.2c.1,0,0-.1,0-.2h.1s0,.2.1.1h.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.5,507.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.8,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.8,508.6h0S305.8,508.6,305.8,508.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.3,510.8H305c0-.1-.1-.1-.1-.2h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1H305l.3.2C305.3,510.7,305.3,510.7,305.3,510.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305.8 508.6 305.8 508.6 305.7 508.6 305.7 508.6 305.8 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.3,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.2,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,510.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.2 510.6 305.2 510.6 305.1 510.6 305.1 510.6 305.2 510.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 510.7 305.1 510.7 305.1 510.7 305.1 510.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.9 511.3 305 511.4 305 511.4 304.9 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.4,509.2l-.2-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,510.4c-.1,0-.1-.1-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.2s0,0,0,0H305s0,0,0,0h.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305 510.5 305 510.5 305 510.5 305 510.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.8 511.3 304.8 511.3 304.8 511.3 304.8 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.3,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305 510.3 305 510.3 305 510.3 305 510.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 509.6 305.2 509.6 305.1 509.6 305.1 509.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305 510.2 305 510.2 305 510.3 305 510.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 509.6 305.1 509.6 305.1 509.6 305.1 509.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.5,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,507h-.1c0-.1-.1-.2,0-.2h.2C305.1,506.9,305.1,507,305,507Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.5,509h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,304.5,509Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "305.1",
      "y": "512.1",
      "width": "4",
      "height": "7.84",
      "transform": "translate(-283 626.8) rotate(-69.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,516.6c0-.1-.1-.1-.1-.2s0-.3,0-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2.1-.3s0,.2.1.2h.3l.2-.2s0-.1,0-.1h.2c0-.1,0-.1.1-.2h.1c0,.1-.1.1,0,.2h.1c0-.1,0-.1.1-.2h0c0,.1-.1.3-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.8.8,0,0,0,0,.4h-.1l-.6.3C303.3,516.7,303.1,516.7,303,516.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516.4 303 516.4 303 516.4 303.1 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.4,517h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 516.2 303.2 516.2 303.2 516.2 303.2 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516.1 303.1 516.1 303.1 516.1 303.1 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516 303.1 516 303.1 516 303.1 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516 303.1 516 303.1 516 303.1 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 515.9 303.1 515.9 303.1 515.9 303.1 515.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 516 303.3 516 303.3 516 303.2 516"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,516.6h-.2l.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 515.9 303.1 515.9 303.1 515.9 303.1 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,516.6s0,0,0,0h0S305,516.6,305,516.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,516.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.2,515.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304.2 516.2 304.2 516.2 304.2 516.1 304.2 516.1 304.2 516.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.9,517.7c0-.1,0-.1,0-.2h.2l.3-.3s-.1.1,0,.2h.4c-.2,0-.2.3-.4.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.3,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.4,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.2,517.3l-.3-.4h.1l.2.4s.1.1,0,.1S309.2,517.4,309.2,517.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,515.7h0S304.8,515.7,304.8,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.4,516.2c0-.1.1-.1.1-.2h.2c0,.1.2,0,.2.1h.1c-.1-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.1a.1.1,0,0,0,.1-.2h.2c0-.1.1,0,.1-.1s0,.1,0,.1.3-.1.5,0,0,.2,0,.3h.3l-.5.2h-.1v.2c0,.1,0,.1,0,.1h-.1V516h-.5c0,.1.2,0,.3.1a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.8,516.6c0,.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.1,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M307.2,515.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,514.6c-.1-.1.1-.2.1-.4h0c0,.1-.1,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1,0,0,.1h.2c.1,0,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "307.2 515.5 307.2 515.5 307.2 515.5 307.2 515.5 307.2 515.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.8,514.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,514.5h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,514.4h0S304.8,514.4,304.7,514.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.9 514.5 304.9 514.5 304.9 514.4 304.9 514.4 304.9 514.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,514.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.8 514.4 304.8 514.4 304.8 514.4 304.8 514.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 514.1 304.1 514.1 304 514.1 304.1 514.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.5,514.9l.2-.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,514.4c0-.1.2-.1.3-.2h.1a.3.3,0,0,0,.1.2h-.3A.1.1,0,0,1,305.2,514.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,514.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,514.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.4,514.5h0c0-.1.1-.1.1-.2h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,514.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 514.3 305 514.3 305.1 514.3 305.1 514.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 513.9 304.1 514 304.1 514 304.1 513.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.4,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.4,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.3,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,514.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305.3 514.3 305.3 514.4 305.3 514.4 305.3 514.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "306.1 514.6 306.1 514.6 306.1 514.6 306.1 514.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305.4 514.3 305.4 514.3 305.3 514.3 305.4 514.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "306.1 514.6 306 514.6 306.1 514.6 306.1 514.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,513.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.1,514.9v-.2h.3s0,.1-.1.2S309.1,515,309.1,514.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.9,514h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "302.3",
      "y": "517.9",
      "width": "8.4",
      "height": "4.29",
      "transform": "translate(-99.4 73.3) rotate(-11.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.1,522.9h-.2c-.2-.1-.2-.3-.2-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3s.1.2.2.2v-.2h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.3s-.1-.1-.1-.2h.1c.1.1,0,.2.1.2h0c-.1-.1,0-.1-.1-.2h0c.1.1,0,.3.2.4h.1c.2,0,.2-.2.3-.3a1.2,1.2,0,0,0-.2.4l.2-.2-.2.3.2.4h0s-.1.1-.1.1h0c.1.1.1-.1.2,0l-.4.6A.7.7,0,0,1,303.1,522.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 522.6 303 522.7 303 522.7 303 522.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.5,521.9a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 522.4 303 522.4 303 522.4 303 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 522.4 302.9 522.5 302.9 522.4 302.9 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 522.3 302.9 522.3 302.9 522.3 302.9 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 522.3 302.9 522.3 302.9 522.3 302.9 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.8 522.2 302.8 522.2 302.8 522.2 302.8 522.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 522.2 303 522.2 303 522.2 303 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,521.7h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.8 522.2 302.8 522.2 302.8 522.2 302.8 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.8,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.8,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.8,522h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 521.8 304 521.8 303.9 521.8 304 521.8 304 521.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.8,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,520c-.1-.1-.1-.2-.1-.2h.1a1.4,1.4,0,0,0,.1-.4s0,.1.1.2h.4c-.2.1,0,.4-.2.6s-.1.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.2s0-.1,0-.1S304.2,521.2,304.2,521.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.8,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.2,520l-.5-.2s0-.1,0-.1h.1l.5.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.8,520c-.1-.1,0-.2,0-.2v-.2c.1,0,.1-.1.2,0h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.2.4-.2s.1.2.1.3h.4c-.2.1-.2.3-.4.5s-.1.1,0,.1h-.4l-.2.2c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.4,519.6c.1,0,0,0,0,.1S308.4,519.6,308.4,519.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,519.6a.2.2,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.3,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,520.1c-.1-.1-.1-.3-.1-.4s.1-.2.2-.3h0s0,0,0,.1h0s-.1.1,0,.1h-.1a.3.3,0,0,0,.1.3s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s0,.1,0,.1a.5.5,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.3 519.5 306.3 519.5 306.3 519.5 306.3 519.5 306.3 519.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.6,520s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,520h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,520h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,519.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,520a0,0,0,0,1,0,0S303.5,520,303.5,520Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,519.9h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.6 519.9 303.6 519.9 303.6 519.8 303.6 519.8 303.6 519.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,519.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.5 519.9 303.5 519.9 303.5 519.9 303.5 519.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.7 520 302.7 520 302.7 520 302.7 520"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.4,519.4a.3.3,0,0,1,.1-.3v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.9,519.6c-.1-.1.1-.2.1-.3h.1l.2.2a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,519.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,519.6h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.2,519.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.7 519.6 303.7 519.6 303.7 519.6 303.7 519.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.6 519.8 302.6 519.9 302.6 519.9 302.6 519.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,519.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.2,519.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.9 519.5 304 519.5 303.9 519.5 303.9 519.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.8 519.3 304.8 519.4 304.8 519.4 304.8 519.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 519.5 304 519.5 304 519.5 304 519.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.7 519.3 304.7 519.4 304.8 519.3 304.7 519.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.7,517.9c-.1,0,0-.1,0-.2s.1-.2.3-.1h.1c0,.1.1.1,0,.2S307.8,518,307.7,517.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,518.4c0-.1,0-.1,0-.2h.3a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "295.5",
      "y": "518.1",
      "width": "3.7",
      "height": "7.15",
      "transform": "translate(-243.7 782.1) rotate(-86)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.7,520.1s.2.1.1.2.1.3.1.4,0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2v.2h-.1v.2s0,0,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.3,0-.4h-.4l.2-.3h-.2l.2-.2a.8.8,0,0,0-.1-.3h0l.5-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.3 300.8 520.3 300.8 520.3 300.8 520.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.5,520.4h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.7 520.5 300.7 520.5 300.7 520.5 300.7 520.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.5 300.8 520.5 300.8 520.5 300.8 520.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.6 300.8 520.6 300.8 520.6 300.8 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.6 300.8 520.6 300.8 520.6 300.8 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.7 300.8 520.7 300.8 520.7 300.8 520.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.7 520.7 300.7 520.7 300.7 520.7 300.7 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,520.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.9 520.7 300.9 520.7 300.9 520.7 300.9 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299,520.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.9,520.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.8,520.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.8 520.7 299.8 520.8 299.8 520.8 299.8 520.8 299.8 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.9,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M294.4,520.9c0,.1,0,.1,0,.2h-.1l-.2.3s0-.1,0-.1h-.4c.2-.1.1-.3.3-.4s.2-.2.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.9,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.5,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.8,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.1,521l.4.3s0,.1,0,.1h-.1l-.3-.3s-.1-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297,521.6c0,.1-.1.1,0,.2h-.4l.2.2h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1-.1.1h0c-.2-.1-.3.1-.4.1s-.1-.2,0-.2h-.2s0-.1,0-.1h-.2l.4-.3s.1-.1.1-.1H296c-.1,0,0-.1,0-.1h.5a0,0,0,0,1,0-.1s.2,0,.1-.1-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.6,521.5c-.1,0,0,0,0,0S295.7,521.5,295.6,521.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.4,522h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M297.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.8,522.3c.1.1,0,.2,0,.3l-.2.2h.1s.1,0,0-.1h.1c-.1,0,0,0,0-.1h0a.3.3,0,0,0,0-.2h-.1s0,.1,0,.1,0,0,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s0-.1,0-.1a.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "297.4 522.1 297.4 522.1 297.4 522.1 297.4 522.1 297.4 522.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.6,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.8,522.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.6 522.4 299.6 522.4 299.6 522.4 299.6 522.4 299.6 522.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.6,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.5,522.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.7 522.5 299.8 522.4 299.8 522.5 299.7 522.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.4 522.5 300.4 522.5 300.5 522.5 300.4 522.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.1,522.4a.2.2,0,0,1-.2.2v-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,522.6c0,.1-.1.2-.2.3h-.1v-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.2,522.5h0c0,.1-.1.2,0,.2h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,522.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.5 522.6 299.5 522.6 299.5 522.6 299.5 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.4 522.7 300.4 522.7 300.4 522.7 300.4 522.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.2,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.2,522.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M297.9,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.3,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,522.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 522.6 299.3 522.6 299.3 522.6 299.3 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "298.5 522.6 298.5 522.6 298.5 522.6 298.5 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 522.6 299.3 522.6 299.3 522.6 299.3 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "298.6 522.6 298.6 522.6 298.6 522.6 298.6 522.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,522.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,523h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.8,523.1c0,.1,0,.1,0,.2h-.3s0-.1,0-.2S295.8,523,295.8,523.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298,523.3c0,.1,0,.1-.1.1h.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "298",
      "y": "523.3",
      "width": "3.9",
      "height": "7.61",
      "transform": "translate(-248 787.1) rotate(-85.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,525.5s.2.1.2.2.1.3.1.4,0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2v.2h-.1v.2s0,0,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2H303c0,.1,0,.1,0,.2h0c0-.1.1-.3,0-.4h-.1l-.4.2.2-.3h-.2l.3-.2a.8.8,0,0,0-.1-.4h0l.5-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 525.7 303.6 525.7 303.6 525.7 303.6 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.3,525.8a.1.1,0,0,1-.1.2H301s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 525.9 303.6 525.9 303.6 525.9 303.6 525.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.7 525.9 303.7 525.9 303.7 525.9 303.7 525.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 526 303.6 526 303.6 526 303.6 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 526.1 303.6 526.1 303.6 526.1 303.6 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.7 526.1 303.7 526.1 303.7 526.1 303.7 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 526.1 303.5 526.1 303.5 526.1 303.6 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.7,526h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.8 526.2 303.8 526.1 303.8 526.1 303.8 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.8,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.7,526h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.8,526.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.6,526.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.6 526.2 302.6 526.2 302.6 526.2 302.6 526.2 302.6 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.7,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M296.9,526.3c0,.1,0,.1,0,.2h-.2l-.2.3s0-.1,0-.2h-.4c.2-.1.1-.3.3-.4s.2-.2.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.7,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.3,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.6,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,526.5l.4.3s0,.1,0,.1h-.1l-.3-.3s-.1-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,527c0,.1-.1.1,0,.2h-.2c-.1-.1-.1.1-.2,0h-.1l.2.2h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1-.1.1h0c-.2-.1-.3.1-.4.1s-.1-.2,0-.3h-.2s0-.1,0-.1h-.2l.5-.3s.1-.1.1-.1h-.1c-.1,0,0-.1,0-.1h.5a0,0,0,0,1,0-.1c.1,0,.2,0,.1-.1s-.1-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.2,527c-.1,0,0,0,0-.1S298.2,527,298.2,527Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.1,527.6H300a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.6,527.8c.1.1,0,.2,0,.4l-.2.2h.1s.1,0,0-.1h.1c-.1,0,0,0,0-.1h0a.3.3,0,0,0,0-.2h-.1c-.1,0,0,.1,0,.1s0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s.1-.1,0-.1a.4.4,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300 527.6 300 527.6 300 527.6 300 527.6 300 527.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.5,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.4,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.6,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.4 528 302.4 528 302.4 528 302.4 528 302.4 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.4,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.3,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.5 528 302.5 528 302.6 528 302.5 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.3 528.1 303.3 528.1 303.3 528.1 303.3 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.4,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.8,528a.2.2,0,0,1-.2.2.3.3,0,0,1-.1-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.1,528.1c0,.1-.1.2-.2.3h-.1v-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.4,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.1h0c0,.1-.1.2,0,.2h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,528.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.3 528.2 302.3 528.2 302.3 528.2 302.3 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.3 528.3 303.3 528.2 303.3 528.2 303.3 528.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.6,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,528.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.1 528.2 302 528.2 302.1 528.2 302.1 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.2 528.1 301.3 528.1 301.3 528.1 301.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302 528.2 302 528.2 302 528.2 302 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.3 528.2 301.3 528.2 301.3 528.2 301.3 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.3,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.3,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.4,528.7c0,.1,0,.1,0,.2H298c0-.1,0-.1.1-.2S298.3,528.6,298.4,528.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.7,528.9c0,.1,0,.1-.1.2h-.2v-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "293.8",
      "y": "529.5",
      "width": "8.2",
      "height": "4.19",
      "transform": "translate(-262.1 291.3) rotate(-37.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,527.7h.2c.2,0,.3.2.4.3s0,.1.1.1h0c0,.1.2.1.2.2h-.2a.5.5,0,0,0,0,.2h.1s0,.1,0,.1h-.1a.3.3,0,0,0,0,.2h.1c.1.1-.1.2,0,.3v.2h-.3s0,.1,0,.1v.2h0c-.1-.1-.2-.3-.3-.3H300c-.1.1-.1.3-.2.4a1.1,1.1,0,0,0,0-.4c0,.1-.1.2-.1.2a1,1,0,0,1,.1-.3l-.3-.2h0c0-.1.1-.1,0-.2h0s.1-.1,0-.1h-.1c-.1,0-.1.1-.1.1s0-.5.1-.7S299.4,527.7,299.6,527.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.8 527.8 299.8 527.8 299.8 527.8 299.8 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298,529.6a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1-.1-.1S297.9,529.5,298,529.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.9 528 299.9 528 299.9 528 299.9 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300 528 300 527.9 300 527.9 300 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.1 528.1 300.1 528.1 300.1 528.1 300.1 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.1 528.1 300.1 528.1 300.1 528.1 300.1 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.2 528.1 300.2 528.1 300.2 528.1 300.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.1 528.2 300 528.2 300 528.2 300.1 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.4,529.5l.3-.2s0,0,0,.1l-.3.2S298.4,529.4,298.4,529.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.2 528.1 300.2 528.1 300.2 528.1 300.2 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.6,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.5,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.6,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.5,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,528.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 528.9 299.4 528.9 299.4 529 299.4 529 299.3 528.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.5,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M294.8,533.1l.2.2c-.1,0,0,.1-.1.2a1.3,1.3,0,0,0,.1.4h-.3c0,.1,0,.2-.1.2s-.1-.4-.1-.6,0-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.8,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.6s0,0,0,.1S299.4,529.6,299.4,529.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.7,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.5,532.7h.5s.1,0,0,.1h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,531.7v.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.2.1s-.1.1,0,.1h.3s0,0,0,.1h.2s0,.1,0,.1h.1s0,.1.1.1H298c.1,0,0,.1,0,.1H298c-.2.1-.1.3-.3.4l-.2-.2H297c.1-.2,0-.4.1-.6s0-.1,0-.1h0l.2-.2a.9.9,0,0,0,.1-.3c-.1,0-.1.2-.2.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M296.4,532.8c-.1,0,0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.3,531.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.2,531.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.3c.1,0,.2.2.3.3s0,.2-.1.3h0s0-.1,0-.1h0l-.2-.2h-.1s0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.3 531.9 298.3 531.9 298.3 532 298.3 532 298.3 531.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.6,530.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.5 530.5 300.5 530.5 300.5 530.5 300.5 530.5 300.5 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.6s0,0,0,0S300.4,530.6,300.4,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.6 530.5 300.6 530.4 300.6 530.4 300.6 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.2 530 301.2 530 301.3 530 301.2 530"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.1,531.7a.3.3,0,0,1,0,.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,530.8c.1.1,0,.2,0,.4H300c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.6,530.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.7,530.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,530.9h0s.1.2.1.1h0s.1,0,0,.1h-.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.1,531h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.5 530.8 300.5 530.7 300.5 530.8 300.5 530.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.4 530.1 301.3 530.1 301.4 530.1 301.4 530.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,531.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,530.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,531.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.3 531 300.3 530.9 300.3 530.9 300.3 531"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.7 531.5 299.6 531.5 299.7 531.5 299.7 531.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.3 531 300.3 531 300.3 531 300.3 531"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.7 531.5 299.7 531.5 299.7 531.5 299.7 531.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.6,530.8h0S300.6,530.8,300.6,530.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.6,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.7,534v.2c0,.1,0,.2-.2.2h-.1c0-.1-.1-.1-.1-.2S297.6,533.9,297.7,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.8,532.5c.1,0,.1.1.1.2h-.2a.2.2,0,0,1-.1-.2A.1.1,0,0,1,299.8,532.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "299.1",
      "y": "534.2",
      "width": "6.5",
      "height": "3.33",
      "transform": "translate(-311.2 489.7) rotate(-56.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.6,532.5h.7v.2h0v.2h.1c.1.1,0,.2.1.2h-.1s0,0,0,.1h-.3c-.1.1,0,.2,0,.3v-.3c0,.1,0,.2,0,.2a.8.8,0,0,1,0-.3h-.3s0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.5S302.5,532.5,302.6,532.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.8 532.6 302.8 532.5 302.8 532.5 302.8 532.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.9,534.3h-.1A.1.1,0,0,1,301.9,534.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 532.7 302.9 532.7 302.9 532.7 302.9 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 532.6 303 532.6 303 532.6 303 532.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 532.7 303.1 532.7 303.1 532.7 303.1 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 532.7 303.1 532.7 303.1 532.7 303.1 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 532.7 303.1 532.7 303.2 532.7 303.2 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 532.8 303.1 532.8 303.1 532.8 303.1 532.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,534.1v-.2h0l-.2.2S302.2,534.1,302.2,534.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 532.6 303.2 532.6 303.2 532.6 303.2 532.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.3,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.2,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.3,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.8,533.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.3,532.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.7 533.5 302.7 533.5 302.8 533.5 302.8 533.5 302.7 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.9,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,537.8h.2c-.1,0,0,.1,0,.1l.2.3h-.1c-.1,0-.1.1-.1.1s0,.1,0,.2-.2-.2-.2-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.2,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.1,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.1,536.1h.1a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.6c-.1.1,0,.3-.1.4h-.5c0-.1-.1-.3,0-.5h-.1v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.1-.1.2H302c0-.1,0-.2,0-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.5,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.7,536h.1s0,.1,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.7,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.9,534.2l.3.2c-.1.1,0,.2,0,.2H304v.2H304a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.7 536 302.7 536 302.7 536 302.7 536 302.7 536"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.4s0,0,0,0S303.9,534.4,303.9,534.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304 534.4 304 534.4 304 534.4 304 534.4 304 534.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 534.3 304.1 534.3 304.1 534.3 304.1 534.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.4 533.8 304.4 533.8 304.4 533.8 304.4 533.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.3,535.6a.2.2,0,0,1,.1.2h-.2a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.7c.1.1.1.2.1.3h-.3c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.1,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.1,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.8h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 534.6 304.1 534.6 304.1 534.6 304.1 534.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.6 533.9 304.5 533.9 304.5 533.9 304.6 533.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.3,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 534.8 304 534.8 304 534.8 304 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.6 535.3 303.6 535.3 303.6 535.3 303.6 535.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 534.8 304 534.8 304 534.8 304 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.7 535.3 303.7 535.3 303.7 535.3 303.7 535.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,534.6h0S304.1,534.6,304.2,534.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.8,537.7h.1c0,.1,0,.2-.1.2h-.2C302.7,537.8,302.7,537.7,302.8,537.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,536.1h-.1C303.8,536.1,303.9,536,304,536.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "294.6",
      "y": "540",
      "width": "8.5",
      "height": "4.32",
      "transform": "translate(-303.2 686.5) rotate(-74.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.8,537.9h.2c.2-.1.3,0,.5,0h.3c0,.1-.1,0-.1.1s.2,0,.3.1h-.2l.2.2s0-.1,0-.1h0v.2l.2.2h.1c.1,0,.1.2.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,.1h-.4s0,.1,0,.1h-.1c-.1.2.1.3.1.4l-.3-.3c.1.1,0,.2,0,.3l-.2-.3h-.4c-.1.1,0,.2-.1.2s.1-.1,0-.2V539h0s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.3-.4-.4-.6A.7.7,0,0,1,297.8,537.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.1 537.9 298 537.9 298 537.9 298.1 537.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,540.5h.1v.2h-.1A.2.2,0,0,1,297.6,540.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.3 538.1 298.2 538 298.2 538 298.3 538.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.3 537.9 298.3 537.9 298.3 537.9 298.3 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.4 538 298.4 538 298.4 538 298.4 538"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.5 538 298.4 538 298.4 538 298.5 538"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.5 537.9 298.5 537.9 298.5 537.9 298.5 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.5 538.1 298.5 538.1 298.5 538.1 298.5 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.9,540.1v-.3h0c-.1.1-.1.2-.1.3S297.9,540.1,297.9,540.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.6 537.9 298.5 537.9 298.6 537.9 298.6 537.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298,540h0c-.1,0,0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.4,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.7,538h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.4 539.1 298.4 539.1 298.4 539.1 298.4 539.1 298.4 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.5,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.3,545.4h.2c0,.1.1.1,0,.2l.3.3h-.2c-.1,0-.1.1-.1.2s.1.2,0,.2-.3-.2-.4-.4-.2-.2-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.8,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.9,539.3s0,0,0,0S298.9,539.3,298.9,539.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,544.6l.5-.3h0l-.4.3h-.1C297.4,544.7,297.5,544.6,297.6,544.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.6,542.6h.2v.2c-.1.1.1.2-.1.2s0,.1.1.1l.2-.2h.7s0,0,0,.1h0c-.1.2.1.3,0,.5h-.3c-.1,0-.1.1-.1.2h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.6h-.4c0-.1.1-.1.1-.2h.2c.1-.1,0-.2,0-.3V543c-.1,0,0,.2-.1.3h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.3,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.3,542.2h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.3,542.3h0S299.3,542.3,299.3,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.1,539.5h.4c0,.1.1.2.1.3h-.2s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2a.5.5,0,0,1-.4-.3C300,539.6,300.1,539.6,300.1,539.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 542.3 299.3 542.3 299.4 542.3 299.4 542.3 299.3 542.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.1,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.3,539.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.3 539.7 300.3 539.7 300.3 539.7 300.3 539.7 300.3 539.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.3 539.6 300.3 539.6 300.3 539.6 300.3 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.6 538.8 300.6 538.8 300.6 538.8 300.6 538.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.9,541.5a.3.3,0,0,1,.2.2h-.3C299.8,541.6,299.8,541.5,299.9,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,540.1c.2,0,.2.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,540.3s0,0,0,0h.2s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,540.4s0,0,0,0S300.3,540.4,300.3,540.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.4 539.9 300.4 539.9 300.5 539.9 300.4 539.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.7 538.9 300.7 538.9 300.7 538.8 300.7 538.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.4 540.2 300.4 540.2 300.4 540.2 300.4 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.2 541 300.2 541 300.2 541 300.2 541"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.4 540.2 300.4 540.2 300.4 540.2 300.4 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.2 541 300.2 541 300.2 541 300.2 541"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.1,538.9h0S301.1,538.9,301.1,538.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,544.3h.2c0,.1.1.2,0,.3h-.3C300,544.5,300,544.3,300.2,544.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.9,541.8h.2a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,300.9,541.8Z"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-238"
  }, [_c('g', [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "342.6",
      "y": "564.4",
      "width": "3.3",
      "height": "6.55",
      "transform": "translate(-315.6 640.8) rotate(-65.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.8,567.9s-.1-.1-.1-.2,0-.3,0-.4h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.2s0,.1,0,.2h.4s0,0,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.3l-.3.2h-.1a.7.7,0,0,0,0,.3h-.1l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.7 340.8 567.7 340.8 567.7 340.9 567.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.8,568.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341 567.6 341 567.6 341 567.6 341 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.5 340.9 567.5 340.9 567.5 340.9 567.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.4 340.9 567.4 340.9 567.4 340.9 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341 567.4 340.9 567.4 340.9 567.4 341 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.3 340.9 567.4 340.9 567.3 340.9 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341 567.4 341 567.4 341 567.4 341 567.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.5,568.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.3 340.9 567.3 340.9 567.3 340.9 567.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.4,568s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.5,568h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.4,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.7,567.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,567.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341.8 567.6 341.8 567.6 341.8 567.6 341.8 567.6 341.8 567.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.8,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.4,569.3c0-.1,0-.1.1-.2h.1l.2-.2s-.1.1,0,.1h.3c-.2,0-.2.2-.4.3h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.9,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,568.9l-.2-.4h.1l.2.4s.1.1,0,.1S345.9,569,345.9,568.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,567.3h0S342.4,567.3,342.4,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,567.8v-.2h.4c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2s0,.1,0,.1h-.6s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.3,567.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,566.3c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0s.1,0,0,.1h.2v-.2s-.1.1,0,.1-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "344.3 567.3 344.3 567.3 344.3 567.3 344.4 567.3 344.3 567.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.5,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.2h0S342.4,566.2,342.4,566.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.5 566.3 342.5 566.3 342.5 566.2 342.5 566.2 342.5 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.6,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.6,566.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.4 566.2 342.4 566.2 342.4 566.2 342.4 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.9 565.9 341.8 565.9 341.8 565.9 341.9 565.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.5,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,566.8h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.8,566.2l.2-.2h0a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,342.8,566.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.6,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.5,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.9,566.3h0s.1-.1.1-.1h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.7 566.1 342.7 566.1 342.7 566.1 342.7 566.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.9 565.8 341.9 565.8 341.9 565.8 341.9 565.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.9 566.2 342.9 566.2 342.9 566.2 342.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "343.5 566.5 343.5 566.5 343.5 566.5 343.5 566.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.9 566.2 342.9 566.2 342.9 566.2 342.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "343.5 566.4 343.5 566.4 343.5 566.4 343.5 566.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.7,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,566.9h.2C346.1,567,346,567,346,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,566h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347.3",
      "y": "561.2",
      "width": "3.7",
      "height": "7.16",
      "transform": "translate(-254.1 287.4) rotate(-33.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,566.5c0,.1,0,.2,0,.2s-.2.2-.3.3H352s0-.1,0-.1-.1.1-.2.2.1-.1.1-.2h-1c0-.1.1-.1.1-.2h-.2c.1-.1.3-.1.3-.3h0l-.3-.2h.4l.2-.3c0-.1-.1-.1-.1-.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1-.1-.1-.1h.6C352.3,566.2,352.4,566.3,352.5,566.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.3 566.6 352.3 566.6 352.3 566.6 352.3 566.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,564.9h-.2v-.2h.1C350.9,564.7,350.9,564.8,350.9,564.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 566.7 352.1 566.7 352.1 566.7 352.1 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.2 566.8 352.2 566.8 352.2 566.8 352.2 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 566.8 352.1 566.8 352.1 566.8 352.1 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 566.9 352.1 566.8 352.1 566.8 352 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 566.9 352.1 566.9 352.1 566.9 352 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 566.8 352 566.8 352 566.8 352 566.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,565.3v.2H351v-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 567 352.1 567 352.1 567 352.1 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,566.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,567h0S351.9,567,351.9,567Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 566.1 351.4 566.2 351.3 566.2 351.3 566.2 351.4 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,566.3h0S351.3,566.3,351.3,566.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348,562h-.5c0-.1-.1-.1-.1-.2h-.2c.2.1.3-.1.5,0s.2,0,.3.2S348,561.9,348,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,566.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.3,562.6a1.2,1.2,0,0,1,0,.5h-.1a2.8,2.8,0,0,0,.1-.4s0-.1.1-.1S348.3,562.6,348.3,562.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,564.4h-.4c0-.1-.1,0-.1-.1h-.1c0,.1-.1.2,0,.2h-.1c-.1,0,0,.1,0,.1h-.2s0,.1,0,.1h-.5c0-.2-.3-.1-.3-.3l.2-.2c0-.1,0-.1-.1-.1h0l.5.2h.1a.2.2,0,0,0,0-.2h.1c.1,0,0,.1.1.1s0,.1,0,.2l.2.2h.2c0-.1-.1-.1-.1-.2h.3l.3.2A.5.5,0,0,1,349,564.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,565.1h0A.1.1,0,0,1,348.9,565.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,565h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,567.1c0,.1-.2.1-.3.2h0c0-.1.1,0,0-.1h.1c.1,0,0-.1,0-.1H350s0,0,0,.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 565 348.8 565 348.8 565 348.8 565 348.8 565"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.1h0S350,567,350,567.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 567 349.9 567 349.9 567.1 349.9 567.1 349.9 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,567h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 567.1 350 567.1 350 567.2 350 567.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.3 567.7 350.4 567.7 350.4 567.7 350.3 567.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,565.8h-.3v-.2h.1C349,565.7,349,565.7,349,565.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,566.9h-.3a.2.2,0,0,0,.1-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,349.6,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,566.8h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.7 567 349.7 567.1 349.7 567.1 349.7 567"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.2 567.8 350.2 567.8 350.2 567.8 350.2 567.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.6 566.9 349.6 566.9 349.6 566.9 349.6 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.1 566.3 349.1 566.3 349.1 566.3 349.1 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.5 566.9 349.5 566.9 349.5 566.9 349.5 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.1 566.3 349.2 566.3 349.1 566.3 349.1 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.1,564.4h-.1l-.2-.2h.2C347,564.2,347.1,564.3,347.1,564.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,566.3h-.1A.1.1,0,0,1,348.2,566.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351",
      "y": "554.8",
      "width": "4.4",
      "height": "8.62",
      "transform": "translate(-248.7 833.1) rotate(-82.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.7c0-.1-.2-.1-.2-.2s-.1-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2l.2-.2h.1l.2-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.2.1.2h.1c0-.1,0-.1,0-.2h.1c0,.1-.1.3,0,.4h.1c.2,0,.3-.1.4-.2l-.3.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.2c0,.1.1,0,.2,0l-.6.4A.7.7,0,0,1,349,560.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 560.4 348.9 560.5 348.9 560.4 348.9 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,560.5a.1.1,0,0,1,.1-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349 560.2 349 560.2 349 560.2 349 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 560.2 348.9 560.2 348.9 560.2 348.9 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349 560.1 348.9 560.1 348.9 560.1 349 560.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 560 349 560 348.9 560 348.9 560"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 559.9 348.9 560 348.9 560 348.9 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.1 560 349.1 560 349.1 560 349.1 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 559.9 348.8 559.9 348.8 559.9 348.8 559.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,560.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349,559.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 560 350.1 560 350.1 559.9 350.1 559.9 350.1 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.6,560.2c-.1-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.5s-.2.2-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,560l-.4-.4s0-.1,0-.1h.1l.4.4s.1.1.1.1S355.8,560.1,355.8,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,559.2c0-.1.1-.2.1-.2h.2c.1.1.2-.1.2,0h.1l-.2-.2h0c0-.1-.1-.1-.1-.1h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5-.1s.1.2,0,.3h.2s0,.1,0,.2h.2l-.5.3s-.1.1-.1.1h.2c.1,0,0,.1,0,.1h-.2v-.2h-.3l-.2.2c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.2s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,559.3c.1,0,0,0,0,.1S355.2,559.3,355.2,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.1,558.6h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.1,558.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558.2c-.1-.1,0-.3,0-.4s.2-.1.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1s0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.2a.5.5,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.2 558.6 353.2 558.6 353.2 558.5 353.2 558.5 353.2 558.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 558 350.5 558 350.5 557.9 350.5 557.9 350.5 558"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,557.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.3 557.9 350.3 557.9 350.3 557.9 350.3 557.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.5 557.8 349.5 557.8 349.5 557.8 349.5 557.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.3,558.1a.3.3,0,0,1,.2-.2.3.3,0,0,1,.1.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,557.8c0-.2.1-.2.2-.3h.1a.3.3,0,0,0,.1.2v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,557.8h0c0-.1.1-.2,0-.2h0s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,557.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.6 557.8 350.6 557.8 350.6 557.7 350.6 557.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.5 557.6 349.5 557.6 349.5 557.6 349.5 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,557.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.6,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,557.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.9 557.7 350.9 557.8 350.9 557.8 350.9 557.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 557.9 351.8 557.9 351.8 557.9 351.8 557.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.9 557.7 350.9 557.7 350.9 557.7 350.9 557.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 557.8 351.7 557.8 351.7 557.8 351.8 557.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,557.4c0-.1,0-.1,0-.2h.4c0,.1,0,.2-.1.2S355.1,557.6,355.1,557.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,557c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "341.4",
      "y": "556.1",
      "width": "6.8",
      "height": "3.46",
      "transform": "translate(-309.4 511.9) rotate(-54.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,554.3h.7v.2h0v.2h.1c.1.1,0,.2.1.2h-.1s0,0,0,.1h.1l-.3-.2h-.1c-.1.1,0,.2,0,.3a.9.9,0,0,0-.1-.3c0,.1,0,.2,0,.2a.8.8,0,0,1,0-.3h-.4s0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.6S345,554.3,345.2,554.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.4 554.4 345.4 554.4 345.4 554.4 345.4 554.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.3,556.2h-.1C344.2,556.3,344.2,556.2,344.3,556.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.5 554.5 345.5 554.5 345.5 554.5 345.5 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.4 345.5 554.4 345.5 554.4 345.6 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.5 345.6 554.5 345.6 554.5 345.6 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.5 345.6 554.5 345.6 554.5 345.6 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 554.5 345.7 554.5 345.7 554.5 345.7 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.6 345.6 554.6 345.6 554.6 345.6 554.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,556l.2-.2h0l-.2.2S344.6,556,344.7,556Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 554.5 345.7 554.5 345.7 554.5 345.8 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.8,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.7,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.8,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.3,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,554.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.3 555.4 345.3 555.4 345.3 555.4 345.3 555.4 345.3 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.4,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.7,559.7h.2c-.1,0,0,.1,0,.1l.2.3h-.1c-.1,0-.1.1-.1.1s0,.1,0,.2-.2-.3-.2-.4-.1-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.1,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,558h.1a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.6c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.1.4h-.5c0-.1-.1-.3,0-.5h-.1v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,559.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.1,557.9h.1s0,.1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.1,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.1l.3.2c-.1.1,0,.2,0,.3h-.2v.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.1 558 345.1 558 345.1 558 345.1 558 345.1 558"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.3s0,0,0,0S346.4,556.4,346.4,556.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.6,556.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.5 556.3 346.5 556.3 346.5 556.3 346.5 556.3 346.5 556.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.6 556.3 346.6 556.2 346.6 556.3 346.6 556.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347 555.7 347 555.7 347 555.7 347 555.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,557.6a.2.2,0,0,1,.1.2h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.6c.1.1.1.2.1.3h-.3c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.6,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.7h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.6 556.5 346.6 556.5 346.6 556.5 346.6 556.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.1 555.8 347.1 555.8 347.1 555.8 347.1 555.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.5 556.7 346.5 556.7 346.5 556.7 346.5 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.1 557.3 346.1 557.3 346.1 557.3 346.1 557.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.5 556.7 346.5 556.7 346.5 556.7 346.5 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.2 557.3 346.1 557.3 346.1 557.3 346.2 557.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,556.5h0S346.7,556.5,346.7,556.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,559.7h.1c0,.1,0,.2-.1.2H345C345,559.9,345.1,559.7,345.2,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.4,558.1h-.1C346.3,558.1,346.4,558,346.4,558.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "342.7",
      "y": "550.7",
      "width": "6.6",
      "height": "3.37",
      "transform": "translate(-264.9 325.2) rotate(-37.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,549.2h.2c.2,0,.2.1.3.2s0,.1,0,.1h0c0,.1.1.1.2.2H348a.4.4,0,0,0,0,.2h.1s0,0,0,.1H348a.2.2,0,0,0,0,.2h.1c0,.1,0,.1,0,.2H348s0,0,0,.1h.1c-.1-.1-.1-.2-.3-.2h-.1c-.1.1-.1.2-.1.3a.9.9,0,0,0,0-.3v.2a.8.8,0,0,1,.1-.3l-.3-.2h0s0-.1,0-.1h0s.1-.1,0-.1h0c-.1,0,0,.1-.1.1s0-.4.1-.6S347.3,549.2,347.4,549.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 549.3 347.6 549.3 347.6 549.3 347.6 549.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,550.7a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 549.5 347.6 549.5 347.6 549.5 347.6 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 549.4 347.7 549.4 347.7 549.4 347.7 549.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 549.5 347.8 549.5 347.8 549.5 347.7 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 549.5 347.8 549.5 347.8 549.5 347.8 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 549.5 347.8 549.5 347.9 549.5 347.9 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 549.6 347.7 549.6 347.7 549.6 347.7 549.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,550.6h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 549.5 347.9 549.5 347.9 549.5 347.9 549.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.6,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.6,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,549.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.2 550.2 347.2 550.2 347.2 550.2 347.2 550.2 347.2 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.6,553.6h.1c-.1,0,0,.1-.1.1a1,1,0,0,0,.1.3h-.2c0,.1,0,.1-.1.2s-.1-.3,0-.5,0-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.7s0,0,0,.1S347.2,550.8,347.2,550.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,553.3h.4s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,552.5v.2a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s-.1.1,0,.1h.2s0,0,0,0h.2s0,.1,0,.1h0s0,.1,0,.1h-.1c-.2.1-.1.2-.2.3l-.2-.2h-.3c.1-.1,0-.3.1-.5s0-.1,0-.1h0l.2-.2v-.2c-.1,0-.1.1-.2.1h-.1c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.8,553.3c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.3,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.3c.1,0,.1.2.2.2s0,.2,0,.2h0s0-.1,0,0h0v-.2H348s0,.1,0,.1h.1c0,.1.1,0,0,.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.3 552.6 346.3 552.6 346.3 552.6 346.3 552.6 346.3 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.1 551.5 348.1 551.5 348.1 551.5 348.1 551.5 348.1 551.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,551.5s0,0,0,0S348.1,551.5,348.1,551.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,551.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.2 551.4 348.2 551.4 348.2 551.4 348.2 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.7 551.1 348.7 551 348.7 551 348.7 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,552.4a.2.2,0,0,1,0,.2h-.2a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348,551.8c.1.1,0,.2,0,.3h-.3c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.8h.1s0,0,0,.1h-.1s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.1 551.7 348.1 551.7 348.1 551.7 348.1 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.8 551.2 348.8 551.2 348.8 551.2 348.8 551.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 551.8 348 551.8 348 551.8 348 551.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.4 552.3 347.4 552.3 347.4 552.3 347.4 552.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 551.9 348 551.9 348 551.9 348 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.5 552.3 347.5 552.2 347.5 552.3 347.5 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.7h0S348.2,551.7,348.2,551.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,554.3h.1c0,.1,0,.2-.1.2h-.1s-.1-.1-.1-.2S345.8,554.2,345.9,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,553.1c.1,0,0,.1,0,.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "344.5",
      "y": "542.8",
      "width": "3.1",
      "height": "5.99",
      "transform": "translate(-100 78.2) rotate(-11.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,548.1s0,.1-.1.2l-.3.2h-.2s.1,0,0-.1h-.6c0-.1-.1-.1-.2-.2h.3v-.2l.2.2h.3s-.1-.1,0-.2,0,.1,0,.1h.3c.1-.1,0-.1,0-.1l.4.3A.5.5,0,0,1,348.1,548.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 548.2 347.9 548.2 347.9 548.2 347.9 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,546.4h-.1a.1.1,0,0,1,0-.1h.1A.1.1,0,0,1,347.4,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 548.2 347.8 548.2 347.7 548.2 347.7 548.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 548.3 347.8 548.3 347.8 548.3 347.8 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 548.3 347.7 548.3 347.7 548.3 347.7 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.3 347.6 548.3 347.6 548.3 347.6 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.4 347.6 548.4 347.6 548.4 347.6 548.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.2 347.6 548.2 347.6 548.2 347.6 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,546.8a.6.6,0,0,1,0,.2h0c0-.1,0-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.4 347.6 548.4 347.6 548.4 347.6 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,546.9h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.4,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,548.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.3 547.5 347.3 547.5 347.3 547.6 347.3 547.5 347.3 547.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.2,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,543.2h-.4c0-.1,0-.1,0-.2h-.1c.1.1.3,0,.4.1s.2.1.2.2S346.1,543.2,346,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,543.8l-.2.4h-.1s0-.1,0-.1l.2-.3h.1C346.2,543.7,346.1,543.8,346.1,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,545.5h-.3c0-.1-.1-.1,0-.1h-.1c0,.1-.1.1-.1.2h-.3s0,0,0-.1H345s0,0,0-.1H345c0-.2-.2-.2-.2-.3h.2c.1,0,0-.1,0-.1h.1c-.1,0,0-.1,0-.1l.3.3h.2s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.2.2,0,0,1,.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,545.9h0S345.8,545.9,345.7,545.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,547.9h-.2s0,0,0,0h.1s0,0,0,.1h.1S346.1,547.8,346.1,547.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 545.9 345.7 545.9 345.7 545.9 345.7 545.9 345.7 545.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 547.8 345.9 547.8 345.9 547.8 345.9 547.8 345.9 547.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 547.9 345.9 547.9 345.9 547.9 345.9 547.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346 548.5 346 548.5 346 548.5 346 548.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,547.8s0,0,0,0S345.9,547.8,345.9,547.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,546.5h0C345.6,546.4,345.6,546.5,345.6,546.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,547.6h-.2s0,0,0-.1h.2c.1,0,0,.1.1.1A.1.1,0,0,1,345.7,547.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.8 547.7 345.8 547.7 345.8 547.7 345.8 547.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 548.5 345.9 548.5 345.9 548.5 345.9 548.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 547.5 345.7 547.5 345.7 547.5 345.7 547.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.6 546.9 345.6 546.9 345.6 546.9 345.6 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 547.5 345.7 547.5 345.7 547.5 345.7 547.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.5 547 345.6 547 345.6 547 345.5 547"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,544.9h-.1c-.1,0-.1-.1-.1-.2h.2C344.6,544.7,344.6,544.8,344.5,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.9,546.7h0A.1.1,0,0,1,344.9,546.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "337.2",
      "y": "537.1",
      "width": "4.3",
      "height": "8.34",
      "transform": "translate(-296.2 477.1) rotate(-52.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.7,541.9c0,.1.1.2,0,.2s-.1.3-.2.5h-.1c-.1,0,0-.1-.1-.1s-.1.2-.2.3.1-.2,0-.2h-.8v.2h-.1c0-.1.1-.1.1-.2h-.1v.2h0c0-.1.2-.2.2-.4h0a.9.9,0,0,0,.1-.4c0-.1-.2-.1-.1-.2h.3s0,0,0,0h.2c0-.1-.1,0-.1-.1h.7C343.4,541.7,343.6,541.7,343.7,541.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.5 542.1 343.6 542.1 343.6 542.1 343.5 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.4,540.8h-.2C341.3,540.6,341.4,540.7,341.4,540.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.3 343.4 542.3 343.4 542.3 343.4 542.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.5 542.4 343.5 542.4 343.5 542.4 343.5 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.4 343.4 542.4 343.4 542.5 343.4 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.3 542.5 343.3 542.5 343.3 542.5 343.3 542.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.6 343.4 542.6 343.4 542.6 343.4 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 542.5 343.2 542.5 343.2 542.5 343.2 542.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,541.2l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.6 343.4 542.6 343.4 542.6 343.4 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.7,541.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.6,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.7,541.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.5,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.2,542.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.3 542 342.3 542 342.3 542 342.3 542 342.3 542"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.3,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.1,538.6v.2h-.2l-.4.2v-.2h-.4c.2.1.3-.2.6-.2s.3-.1.4.1S337.1,538.6,337.1,538.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.1,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.6,539.2a1.4,1.4,0,0,1,.1.5h-.1a3.2,3.2,0,0,0-.1-.5s-.1-.1,0-.1S337.6,539.1,337.6,539.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,542.3h0S341.6,542.2,341.6,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.1,540.9l-.2.2h-.2c0-.1-.2,0-.1-.1h-.1c0,.1,0,.2.1.3h-.1c-.1,0,0,.1,0,.1h-.2c0,.1.1.1,0,.1h-.6s0-.1,0-.1-.3,0-.5-.2,0-.2.1-.2-.1-.1-.1-.1h.6v-.2c0-.1.1-.1,0-.1h.1c0,.1,0,.1,0,.2h.5c0-.1-.2,0-.2-.2h0c.1,0,.2.1.2,0s0-.1.1-.1h.4A.5.5,0,0,1,339.1,540.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.8,540h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.2,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.1,541.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.3,543.4c0,.2-.1.2-.2.3h0c0-.1.1,0,0-.1h0l.2-.2h-.1c.1,0-.1-.1,0-.1h-.3l-.2.2c0-.1.1-.1.1-.1a.5.5,0,0,1,.4-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 541.7 339.1 541.7 339.1 541.7 339.1 541.7 339.1 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.2,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.1,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.6h0S341.2,543.5,341.2,543.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.1 543.5 341.1 543.5 341.1 543.5 341.1 543.5 341.1 543.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,543.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.1 543.6 341.2 543.6 341.2 543.6 341.1 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.8 544.1 341.8 544.1 341.8 544.1 341.8 544.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,542.5h-.3a.3.3,0,0,1,.1-.2h.1C339.5,542.4,339.6,542.4,339.6,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.7,543.5c-.1.1-.2.1-.3.1h0a.3.3,0,0,0,0-.2h.3A.1.1,0,0,1,340.7,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.1,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.6,543.3h0s-.2.1-.1.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.8 543.6 340.9 543.6 340.8 543.6 340.8 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.7 544.3 341.7 544.2 341.7 544.2 341.7 544.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.5,543.4h0S340.5,543.4,340.5,543.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.4,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.6 543.5 340.6 543.4 340.6 543.5 340.6 543.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 542.9 339.9 542.9 339.9 542.9 339.9 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.6 543.5 340.6 543.4 340.6 543.5 340.6 543.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 543 339.9 543 339.9 543 339.9 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.8,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.5,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.9,541.7h-.3C336.8,541.5,337,541.5,336.9,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.9,543.3h-.3s0-.1,0-.1h.2C338.9,543.1,339,543.2,338.9,543.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "331.9",
      "y": "538.2",
      "width": "6.4",
      "height": "3.28",
      "transform": "translate(-6.7 4.2) rotate(-0.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.2,541.5H332c-.1-.1-.1-.2-.1-.4s0-.1,0-.1h0c.1-.1,0-.2,0-.3s0,.1.1.1v-.2h.1v-.2h0v-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.1.1.2h0c0-.1,0-.1,0-.2h0c0,.1,0,.2.1.3h.1l.3-.2-.2.3h.2l-.2.2v.3h0l-.4.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541.3 332.1 541.4 332.1 541.4 332.1 541.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,541.1a.1.1,0,0,1,.1-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.2 541.2 332.2 541.2 332.2 541.2 332.2 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541.2 332.1 541.2 332.1 541.2 332.1 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541.1 332.1 541.1 332.1 541.1 332.1 541.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541 332.1 541.1 332.1 541.1 332.1 541"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 541 332 541 332 541 332 541"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.2 541 332.2 541 332.2 541 332.2 541"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.8,541h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 541 332 541 332 541 332 541"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.6,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.7,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.6,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.8,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.1,540.9h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "332.9",
      "y": "540.8",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.9,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.7,540.4c0-.1,0-.1,0-.2h.1v-.3s0,.1,0,.1h.3c-.2.1-.1.3-.2.4s-.1.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.8,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.9,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.1,540.3l-.3-.3s0-.1,0-.1h.1l.3.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.4,539.9c0-.1,0-.1,0-.2h.2a.1.1,0,0,0,0-.1h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.1h0c.2.1.2-.1.4-.1s.1.1,0,.2h.3l-.4.3s-.1.1,0,.1h-.2a0,0,0,0,1,0,.1s-.1.1-.1.1.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.6,539.8s0,0,0,0S336.6,539.8,336.6,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335,539.5h.1a.1.1,0,0,1,0,.1H335Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.5c-.1-.1,0-.2,0-.3l.2-.2H333s-.1,0,0,0h-.1a.2.2,0,0,0,0,.2h.1s0-.1,0-.1,0,0,0,.1h.1s0,0,0,0h0c.1-.1,0-.1.1-.2s0,.1,0,.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "335",
      "y": "539.5",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.9,539.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.8,539.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333 539.4 333 539.4 333 539.3 333 539.3 333 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.9 539.3 332.9 539.3 332.9 539.3 332.9 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.2 539.3 332.2 539.3 332.2 539.3 332.2 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.4,539.2a.2.2,0,0,1,.1-.2v.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,539.2c0-.1.1-.2.1-.2h.1v.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.2h0s.1-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 539.2 333 539.2 333.1 539.2 333.1 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.2 539.2 332.2 539.2 332.2 539.2 332.2 539.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.3 539.1 333.3 539.2 333.3 539.2 333.3 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.9 539.1 333.9 539.1 333.9 539.1 333.9 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.3 539.1 333.3 539.1 333.3 539.1 333.3 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.9 539.1 333.9 539.1 333.9 539.1 333.9 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,538.4s0-.1,0-.1h.3s0,.1,0,.2S336.4,538.6,336.3,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.3,538.4c0-.1,0-.1,0-.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "328",
      "y": "547.4",
      "width": "6.1",
      "height": "3.09",
      "transform": "translate(-301.7 652) rotate(-68.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,552.1h-1v-.2h-.1s0,0,0,0h.3s0,0,0-.1h.1c.1-.1,0-.2,0-.3l.2.2c0-.1,0-.2,0-.2v.2h.3s0-.1.1-.1-.1.1,0,.1h.1s0,.1,0,.1h.1c.1,0,0-.1,0-.1l.2.5C331.5,551.8,331.5,552,331.4,552.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.2 552 331.2 552 331.2 552 331.2 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.7,550.2h.1A.1.1,0,0,1,331.7,550.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 551.9 331.1 551.9 331.1 551.9 331.1 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 552 331 552 331 552 331 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 552 331 552 330.9 552 331 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.9 552 330.9 552 330.9 552 330.9 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.8 552 330.9 552 330.9 552 330.8 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.9 551.9 330.9 551.9 330.9 551.9 330.9 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,550.5v.2h0v-.2S331.5,550.5,331.4,550.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.8 552 330.8 552 330.8 552 330.8 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 551.1 331.1 551.1 331.1 551.1 331.1 551.1 331.1 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.9,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.4,546.8h-.2c0-.1,0-.1,0-.1l-.2-.2h.1c.1,0,.1-.1.1-.1s-.1-.1,0-.2.2.2.3.3.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,551s0,0,0,0S330.7,551,330.7,551Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.1,547.3l-.3.2h0l.3-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.1,548.7h-.2c.1,0,0-.1.1-.1s0-.1,0-.1h-.6c.1-.1,0-.2,0-.4h.2c.1,0,.1-.1.1-.1h.1c0-.1.1-.1,0-.1s.1.3.1.4h.1c0,.1,0,.1,0,.2v.2c.1,0,0-.1.1-.2h.1s0,.1.1.1h.1a.2.2,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.5,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.6,548.9h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.9,550.7h-.3c0-.1-.1-.1-.1-.2h.1s0,.1,0,.1h.2s0,0,0-.1h-.1l.2.2C329.9,550.7,329.9,550.7,329.9,550.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.6 548.8 330.6 548.8 330.6 548.8 330.6 548.8 330.6 548.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.9,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,550.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.8 550.6 329.8 550.6 329.7 550.6 329.7 550.6 329.8 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 550.7 329.7 550.7 329.7 550.7 329.7 550.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.5 551.2 329.5 551.2 329.5 551.2 329.5 551.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.2,549.3a.2.2,0,0,1-.1-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,550.3c-.1,0-.1-.1-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.6,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.1s0,0,0,0S329.8,550.1,329.8,550.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 550.4 329.7 550.5 329.6 550.4 329.7 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 551.2 329.4 551.2 329.4 551.2 329.4 551.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.7,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.7,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.1,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.7,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.7 550.2 329.7 550.2 329.7 550.2 329.7 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.9 549.6 329.9 549.7 329.9 549.7 329.9 549.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.7 550.2 329.7 550.2 329.7 550.2 329.7 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.9 549.7 329.9 549.7 329.9 549.7 329.9 549.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.6,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,551.1h0S329.1,551.1,329.1,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.2,547.3h-.1c0-.1-.1-.2,0-.2h.2C330.3,547.2,330.3,547.3,330.2,547.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.5,549.1h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,329.5,549.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "321.6",
      "y": "541",
      "width": "3.4",
      "height": "6.64",
      "transform": "translate(-90.4 65.1) rotate(-10.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.5,547s0,.2-.1.2l-.3.2h-.2s.1-.1,0-.1h-.3c0-.1.1-.1.1-.1h-.2a.4.4,0,0,1,0-.1h-.3c0-.1-.2-.2-.2-.3h.3v-.2l.2.2h.3c0-.1-.1-.1,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.1l.5.3A.5.5,0,0,1,325.5,547Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.3 547.1 325.3 547.1 325.3 547.1 325.3 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.8,545.1h-.1a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,324.8,545.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 547.1 325.2 547.1 325.2 547.1 325.1 547.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.2 547.2 325.2 547.2 325.2 547.2 325.2 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 547.2 325.1 547.2 325.1 547.2 325.1 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.2 325 547.2 325 547.2 325 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.3 325 547.3 325 547.3 325 547.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.1 325 547.1 325 547.1 325 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,545.5a.7.7,0,0,1,0,.2h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.3 325 547.3 325 547.3 325 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,545.6h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,545.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.8,547.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 546.3 324.7 546.3 324.7 546.3 324.7 546.3 324.7 546.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,541.5h-.4c.1-.1,0-.1,0-.2h-.1c.1.2.3,0,.4.2s.2.1.2.2S323.4,541.5,323.4,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,546.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,542.2l-.2.4h-.1s0-.1,0-.1l.2-.4h.1C323.5,542.1,323.4,542.2,323.4,542.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,544H323c0-.1-.1-.1,0-.1h-.1c0,.1-.1.1-.1.2h-.3s0-.1,0-.1h-.3s0,0,0-.1h-.1c0-.2-.2-.2-.2-.4h.2c.1,0,0-.1,0-.1h.1c-.1,0,0-.1,0-.2l.4.3h.1v-.2h.1s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,542.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323,544.4h0S323,544.4,323,544.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,546.7H323l-.2-.2h.3s0,0,0,0h.1s0,.1,0,.1h.1S323.3,546.6,323.3,546.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323 544.4 323 544.5 322.9 544.5 322.9 544.4 323 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 546.6 323.2 546.6 323.1 546.6 323.1 546.6 323.2 546.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,546.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.1 546.7 323.2 546.7 323.1 546.7 323.1 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 547.3 323.3 547.3 323.3 547.3 323.2 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,546.6s0,0,0,0S323.1,546.6,323.1,546.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,545.2h0C322.9,545.1,322.9,545.1,322.8,545.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,546.4h-.3s0,0,0-.1h.3c.1,0,0,.1.1.2A.1.1,0,0,1,323,546.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323 546.5 323 546.5 323 546.5 323 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.1 547.3 323.1 547.3 323.1 547.3 323.1 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.7,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 546.3 322.9 546.3 322.9 546.3 322.9 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 545.6 322.8 545.6 322.8 545.6 322.8 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 546.3 322.9 546.3 322.9 546.3 322.9 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.7 545.7 322.8 545.7 322.8 545.7 322.7 545.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,543.3h-.2c-.1-.1-.1-.1-.1-.2h.2C321.7,543.1,321.8,543.2,321.7,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,545.3h0A.1.1,0,0,1,322,545.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "320.4",
      "y": "551.3",
      "width": "7.7",
      "height": "3.93",
      "transform": "translate(-316 590.4) rotate(-62.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,557.3h-.2c-.2.1-.3,0-.4-.1h-.1c0-.1-.2-.1-.3-.1h.2v-.2h0v-.2h-.1c-.1-.1,0-.2-.1-.2h-.1s0,0,0,0h.4s0-.1,0-.1h.1c.1-.1,0-.3,0-.4l.2.3c0-.1,0-.2,0-.3a.9.9,0,0,1,.1.3h.4c.1,0,0-.2.1-.2s-.1.1-.1.2,0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.2s.2.4.2.6S324.5,557.2,324.4,557.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.2 557.3 324.2 557.3 324.2 557.3 324.2 557.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,555h.1A.1.1,0,0,1,325,555Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324 557.1 324 557.1 324 557.1 324 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.9 557.2 324 557.2 323.9 557.2 323.9 557.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.9 557.2 323.9 557.2 323.8 557.2 323.9 557.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.8 557.1 323.8 557.1 323.8 557.2 323.8 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 557.2 323.8 557.2 323.7 557.2 323.7 557.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.8 557 323.8 557 323.8 557 323.8 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,555.3v.2h0l.2-.2S324.7,555.3,324.7,555.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 557.2 323.7 557.2 323.7 557.2 323.7 557.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,557.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 556.1 324.1 556.1 324.1 556.1 324.1 556.1 324.1 556.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.2,550.8H326c.1-.1,0-.1,0-.2l-.2-.3h.2c.1,0,.1-.1.1-.2s-.1-.2,0-.2.3.3.3.5.1.3,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,555.9s0,0,0,0S323.6,555.9,323.6,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,551.4l-.5.2h0l.4-.2h.1C326,551.4,325.9,551.4,325.8,551.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.5,553h-.2a.3.3,0,0,1-.1-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.7c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.1-.4h.2c.1,0,.1-.1.1-.1h.1c0-.1.1-.1.1-.2s.1.3.1.5h.1c-.1.1,0,.2-.1.3a.8.8,0,0,0,.1.3c.1,0,0-.2.1-.2h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,553.3h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,555.5h-.3c.1-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.2s0-.1,0-.1h-.1l-.2-.2h.1a.4.4,0,0,1,.3.3C322.7,555.4,322.6,555.4,322.6,555.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.8 553.2 323.8 553.2 323.8 553.2 323.8 553.2 323.8 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,555.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,555.2s0,0,0,0S322.6,555.2,322.6,555.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,555.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "322.5",
      "y": "555.2",
      "height": "0.04",
      "transform": "translate(-318.7 588.9) rotate(-62.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,555.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.4 555.4 322.4 555.4 322.4 555.4 322.4 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.1 556 322.1 556 322.1 556 322.1 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,553.7a.2.2,0,0,1-.1-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,554.9c-.1,0-.1-.2-.2-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,555.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.8h-.1s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.7h0S322.6,554.7,322.6,554.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.4 555.1 322.4 555.1 322.4 555.1 322.4 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.9 556 322 556 321.9 556 321.9 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 554.8 322.5 554.8 322.5 554.8 322.5 554.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 554.1 322.8 554.1 322.8 554.1 322.8 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 554.8 322.5 554.8 322.5 554.8 322.5 554.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 554.1 322.8 554.2 322.8 554.1 322.8 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,555.1h0S322.3,555.1,322.3,555.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.6,555.8h0S321.6,555.8,321.6,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,551.2h-.1c0-.1-.1-.2,0-.3h.3C323.6,551,323.6,551.2,323.4,551.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,553.3h-.1a.2.2,0,0,1,0-.2h.2C322.5,553.2,322.4,553.3,322.3,553.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "315.3",
      "y": "552.7",
      "width": "7.2",
      "height": "3.67",
      "transform": "translate(-269.5 805.5) rotate(-83.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.3,558h-.8s.1,0,0-.1h-.3s0,.1,0,.1h0a.4.4,0,0,1,0-.1H319l-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.1-.2-.1-.3l.3.2c-.1-.1-.1-.2-.1-.2l.2.3h.3c0-.1,0-.2.1-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.2l.4.5A.6.6,0,0,1,320.3,558Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.1 558 320.1 558 320.1 558 320.1 558"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,555.8H320a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,320.2,555.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.9 557.9 320 557.9 319.9 557.9 319.9 557.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.9 558.1 319.9 558 319.9 558.1 319.9 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.8 558 319.8 558 319.8 558 319.8 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.8 558 319.8 558 319.8 558 319.8 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 558.1 319.7 558.1 319.7 558.1 319.7 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 557.9 319.8 557.9 319.8 557.9 319.7 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.9,556.1a.8.8,0,0,1-.1.3h0c0-.1,0-.2.1-.3S320,556.1,319.9,556.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 558.1 319.7 558.1 319.7 558.1 319.7 558.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,556.3h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.7,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.6,558h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 557 319.7 557 319.7 557 319.7 557 319.7 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.6,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.9,551.6h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.1c.1,0,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.3,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.3,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.7,552.3l-.3.3h0l.3-.3h.1C319.8,552.2,319.7,552.3,319.7,552.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319,554.2h-.3c.1-.1-.1-.1,0-.2h-.1l-.2.2H318s0,0,0-.1h-.1s0,0,0-.1h0c.1-.2-.1-.3-.1-.4h.2c.1,0,0-.1.1-.2h.1c0-.1,0-.1,0-.2s.2.3.3.4h.3c0,.1-.1.1-.1.1h-.1c0,.1,0,.2,0,.3v.2c.1-.1-.1-.2,0-.2h.1c0,.1,0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.1,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.5,554.5h0S318.6,554.5,318.5,554.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.2,556.9h-.3c0-.1-.1-.1-.2-.2h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2l.3.2C318.3,556.8,318.2,556.9,318.2,556.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.5 554.5 318.5 554.5 318.5 554.5 318.5 554.5 318.5 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.2,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318,556.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318.1 556.8 318.1 556.8 318 556.8 318 556.8 318.1 556.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,556.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318 556.9 318 556.9 318 556.9 318 556.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 557.6 317.9 557.6 317.9 557.6 317.9 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,555.2l-.2-.2h.3C318.2,555.1,318.2,555.2,318.1,555.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,556.5c-.1,0-.2-.1-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.3s0,0,0,0h-.2s0,0,0,0h0s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 556.6 317.9 556.7 317.9 556.7 317.9 556.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.7 557.6 317.8 557.6 317.8 557.6 317.7 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.8 556.4 317.9 556.4 317.9 556.4 317.8 556.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 555.7 317.9 555.7 317.9 555.7 317.9 555.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.8 556.4 317.8 556.4 317.8 556.4 317.8 556.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 555.7 317.9 555.7 317.9 555.7 317.9 555.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.8,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.5,552.9h-.2c0-.1-.1-.2-.1-.2h.3C317.6,552.7,317.6,552.9,317.5,552.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.2,555.1h-.1a.1.1,0,0,1,0-.2h.2A.1.1,0,0,1,317.2,555.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "309.7",
      "y": "555.9",
      "width": "7.5",
      "height": "3.83",
      "transform": "translate(-296.5 751.4) rotate(-78.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,554.1h.9s-.1,0,0,.1h.1l.2.2s0-.1,0-.1h.2l.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0h-.4s0,.1,0,.1h-.1c0,.1.1.2.1.4l-.3-.3c.1.1,0,.2.1.2l-.2-.3h-.4s0,.2-.1.2,0-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2l-.3-.5A.6.6,0,0,1,312.3,554.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.5 554.1 312.5 554.1 312.5 554.1 312.5 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,556.4h.1v.2h-.1A.1.1,0,0,1,312.3,556.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.7 554.2 312.7 554.2 312.7 554.2 312.7 554.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.7 554.1 312.7 554.1 312.7 554.1 312.7 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 554.1 312.8 554.1 312.8 554.1 312.8 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 554.1 312.8 554.1 312.9 554.1 312.9 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 554.1 312.9 554.1 312.9 554.1 312.9 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 554.2 312.9 554.2 312.9 554.2 312.9 554.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.5,556.1v-.3h0c-.1.1,0,.2-.1.3S312.5,556.1,312.5,556.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313 554 312.9 554 312.9 554 313 554"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,555.9h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.9,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 555.2 312.9 555.2 312.9 555.2 312.9 555.2 312.9 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,560.7h.2c0,.1.1.1,0,.2l.3.2h-.2c-.1,0,0,.1,0,.2s.1.1.1.2-.3-.2-.4-.4-.2-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.5,560l.4-.3h0l-.4.3h-.1C312.3,560.1,312.4,560.1,312.5,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,558.2h.2v.2c-.1,0,.1.1,0,.2s0,.1.1.1l.2-.2h.5s0,.1,0,.1h.1s0,0,0,.1h0c-.1.2.1.3,0,.4h-.3c-.1,0-.1.1-.1.2H314c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.4c0-.1.1-.1.1-.2h.1c0-.1,0-.2,0-.3v-.2c-.1,0,0,.2,0,.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.1,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.9,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,557.9h0S313.8,557.9,313.9,557.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.4,555.4h.4c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2l-.3-.2C314.3,555.5,314.4,555.4,314.4,555.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.9 557.9 313.9 557.9 313.9 557.9 313.9 557.9 313.9 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.5,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 555.6 314.6 555.6 314.6 555.6 314.6 555.6 314.6 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,555.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 555.5 314.6 555.4 314.6 555.4 314.6 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.8 554.7 314.8 554.7 314.8 554.7 314.8 554.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.6,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,557.2a.2.2,0,0,1,.2.2h-.3C314.3,557.3,314.3,557.2,314.3,557.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,555.9c.1,0,.2.1.2.2h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,556s0,0,0,0h.2s0,0,0,0h0s0,0,0,0h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.7 555.7 314.7 555.7 314.7 555.7 314.7 555.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.9 554.8 314.9 554.8 314.9 554.8 314.9 554.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.4,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.7 556 314.7 556 314.7 556 314.7 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 556.7 314.6 556.7 314.6 556.7 314.6 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.7 556 314.7 556 314.7 556 314.7 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 556.7 314.6 556.7 314.6 556.7 314.6 556.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,559.6h.2c0,.1.1.2,0,.3h-.3C314.6,559.8,314.6,559.6,314.8,559.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,557.4h.1a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,315.3,557.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "311.1",
      "y": "562.3",
      "width": "6.8",
      "height": "3.5",
      "transform": "translate(-168.2 135) rotate(-19.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,566.7H312c-.2-.1-.2-.2-.2-.3s0-.1,0-.1h0c0-.1-.1-.2-.1-.2h.2a.4.4,0,0,0,0-.2h0a.3.3,0,0,0,0-.2h0c0-.1.1-.1.1-.2V565h.1c.1,0,0,.1.1.2h0v-.2h0c.1.1.1.3.2.3h.1c.1,0,.1-.2.2-.3a.9.9,0,0,0-.1.3l.2-.2v.3l.2.3h0s-.1.1,0,.1h.2c-.1.2-.1.4-.3.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.1 566.5 312.1 566.5 312.1 566.5 312.1 566.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314,565.6a.1.1,0,0,1,0-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.1 566.3 312.1 566.3 312.1 566.3 312.1 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 566.4 312 566.4 311.9 566.4 311.9 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 566.3 311.9 566.3 311.9 566.3 311.9 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 566.2 311.9 566.2 311.9 566.2 311.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.8 566.2 311.8 566.2 311.8 566.2 311.8 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312 566.1 312 566.2 312 566.2 312 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.6,565.6h-.2s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.8 566.2 311.8 566.2 311.8 566.2 311.8 566.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,565.6s0,0,0,0S313.4,565.6,313.4,565.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.8,566h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "312.7",
      "y": "565.7",
      "height": "0.02",
      "transform": "translate(-138.4 102.7) rotate(-15.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,563.6v-.2h.1a1.1,1.1,0,0,0,0-.3h.4c-.1.1,0,.3-.1.5s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.8,565.2s0,0,0-.1S312.9,565.2,312.8,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,563.7h-.4s0-.1,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.9,564c-.1-.1,0-.1,0-.2v-.2h-.1s0-.1,0-.1h0a.1.1,0,0,0,0-.1h.1s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.2-.2.3-.2s.1.1.1.2h.4c-.1.1-.1.3-.3.4s-.1.1,0,.1h-.3v.2h.2c0,.1-.1.1-.1.2s.1,0,0,.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,563.5c.1,0,0,0,0,0S316.1,563.5,316.1,563.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,563.7a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.4,563.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.4c-.1-.1-.1-.2-.1-.3s.1-.2.1-.2,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0,0,0-.1h.1s0-.1,0-.1,0,0,0,.1h0s0-.1,0-.1h0c0-.1-.1-.1,0-.2s0,.1.1.1a.4.4,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.4 563.7 314.4 563.7 314.4 563.6 314.4 563.6 314.4 563.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,564.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.3h0S312.2,564.3,312.2,564.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,564.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 564.2 312.2 564.2 312.2 564.2 312.2 564.2 312.3 564.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,564.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.1 564.2 312.1 564.2 312.1 564.2 312.1 564.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.5 564.4 311.5 564.4 311.5 564.4 311.5 564.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.6,563.6a.2.2,0,0,1,.1-.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.4,564c-.1-.1,0-.2.1-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.9h0s0-.2,0-.1h0s0-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.7,563.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 564 312.3 564 312.3 564 312.3 564"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.4 564.3 311.5 564.3 311.5 564.3 311.4 564.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.7,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.5 563.9 312.5 563.9 312.5 563.9 312.5 563.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "313.2 563.6 313.2 563.7 313.1 563.7 313.2 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.5 563.9 312.5 563.9 312.5 563.9 312.5 563.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "313.1 563.6 313.1 563.7 313.1 563.7 313.1 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,562.2s0-.1,0-.2h.3s.1.1,0,.2S315.4,562.2,315.3,562.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,562.8s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "317.3",
      "y": "565.8",
      "width": "3.3",
      "height": "6.36",
      "transform": "translate(-328.4 648.9) rotate(-67.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.2,568.6s.1.1.1.2,0,.2,0,.4h-.1s0,.1,0,.1h-.1c-.1,0,0,.2-.1.2s0-.1-.1-.2h-.4s0,0,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1v.2h0c0-.1.1-.2.1-.3h-.1a.1.1,0,0,0,0-.1h-.3l.3-.2h0a.7.7,0,0,0,0-.3h.1l.5-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 568.8 322.2 568.8 322.2 568.8 322.2 568.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.3,568.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 568.9 322.1 568.9 322.1 568.9 322.1 568.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 569 322.2 569 322.2 569 322.2 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 569 322.1 569 322.1 569.1 322.1 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 569.1 322.1 569.1 322.1 569.1 322.1 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 569.2 322.2 569.1 322.2 569.1 322.2 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 569.1 322 569.1 322 569.1 322 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,568.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 569.2 322.2 569.2 322.2 569.2 322.2 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.7,568.6s0,0,0,0h0S320.7,568.6,320.7,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,568.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.7,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,569.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.3 568.9 321.3 568.9 321.3 568.9 321.3 568.9 321.3 568.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,567.5c0,.1,0,.1,0,.2h-.1l-.2.2s0-.1,0-.1H316c.2,0,.2-.2.4-.3h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.1,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,567.8l.2.4h-.1l-.2-.4s-.1-.1,0-.1S317.3,567.8,317.3,567.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.3h0S320.8,569.3,320.8,569.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.7,568.8v.2h-.4c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1,0,0,.1h-.4s0-.1,0-.1-.2,0-.4,0,0-.2,0-.2h.2s0-.1,0-.1h.4a0,0,0,0,1,0-.1h.2s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.5,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.9,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.9,569.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.2c0,.1-.1.2-.1.3h0s0,0,0-.1h0a.2.2,0,0,0,.1-.2h0s-.1,0,0-.1h-.2v.2s.1-.1,0-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.9 569.4 318.9 569.4 318.9 569.4 318.8 569.4 318.9 569.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.3h0S320.8,570.3,320.8,570.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.7 570.3 320.7 570.3 320.7 570.3 320.7 570.3 320.7 570.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,570.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.8 570.4 320.8 570.3 320.8 570.4 320.8 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.3 570.6 321.3 570.6 321.3 570.6 321.3 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,569.8h-.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,570.3l-.2.2h0a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,320.4,570.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,570.3h0s-.1.1-.1.1h0s0,0,0,0h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.5 570.4 320.5 570.4 320.5 570.4 320.5 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.3 570.7 321.3 570.7 321.3 570.7 321.3 570.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 570.4 320.3 570.4 320.3 570.4 320.3 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.7 570.1 319.7 570.1 319.7 570.1 319.7 570.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 570.4 320.3 570.4 320.3 570.4 320.3 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.7 570.2 319.7 570.1 319.7 570.1 319.7 570.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.5,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.2,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,569.8H317C317.1,569.7,317.3,569.7,317.3,569.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.1,570.6h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "323",
      "y": "566.7",
      "width": "3.1",
      "height": "6.05",
      "transform": "translate(-331.1 566.9) rotate(-60.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.3,569.6s-.1-.1,0-.2,0-.2.1-.3h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.2s0,.1,0,.2h.4s0,0,0-.1h.3c0,.1-.1.1,0,.2h.2c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h0a.7.7,0,0,0-.1.3h-.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 569.5 321.4 569.5 321.4 569.5 321.4 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,570.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.3 321.5 569.3 321.5 569.3 321.5 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 569.3 321.4 569.3 321.4 569.3 321.4 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.2 321.5 569.2 321.5 569.2 321.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.2 321.5 569.2 321.5 569.2 321.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.1 321.5 569.1 321.5 569.1 321.5 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 569.2 321.6 569.2 321.6 569.2 321.6 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,569.9h-.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.1 321.4 569.1 321.4 569.1 321.5 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.8,569.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.8,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.6,569h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.3 569.5 322.3 569.5 322.3 569.4 322.3 569.4 322.3 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.3,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.4,571.3v-.2h.1l.2-.2h.3c-.2,0-.2.2-.4.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.9,571l-.2-.4h.1v.4s0,.1,0,.1S325.9,571,325.9,571Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,569.2h0S322.8,569.2,322.8,569.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,569.9h.5c0-.1,0-.1-.1-.2h0s0-.1,0-.1h.1s-.1,0,0-.1h.4s0,0,0,.1.2,0,.3.1,0,.1-.1.2h-.2s0,.1,0,.1h-.5s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.3c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0s.1,0,0,.1h.3s-.1.1,0,.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 569.3 324.6 569.3 324.6 569.3 324.6 569.3 324.6 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.2h0S322.9,568.2,322.9,568.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323 568.3 323 568.2 323 568.2 323 568.2 323 568.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,568.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323 568.2 323 568.2 323 568.2 323 568.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 567.9 322.4 567.9 322.4 567.9 322.5 567.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,568.8h.2a.2.2,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,568.2h.3a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,323.3,568.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.3h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,568.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 568.1 323.2 568.1 323.2 568.1 323.2 568.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 567.8 322.5 567.8 322.5 567.8 322.5 567.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.4,568.8h0S324.4,568.8,324.4,568.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,568.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.4 568.2 323.4 568.2 323.4 568.2 323.4 568.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.9 568.5 323.9 568.5 323.9 568.5 323.9 568.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.4 568.2 323.4 568.2 323.4 568.2 323.4 568.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.9 568.5 323.9 568.5 323.9 568.5 323.9 568.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.2,569.1h.2C326.3,569.3,326.2,569.2,326.2,569.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.6,568.2h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "326.3",
      "y": "570.2",
      "width": "6",
      "height": "3.06",
      "transform": "translate(-63.5 41.6) rotate(-6.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.9,569.9h.1c.1.1.1.2.1.3s0,.1,0,.1h0c-.1.1.1.2,0,.2H332v.2h0v.2h0v.2c0,.1,0,.1,0,.1h-.1c-.1,0,0-.1-.1-.2h0s0,.1,0,.2h0c0-.1,0-.2-.1-.3h-.1l-.3.2V571h-.2l.2-.2v-.3h0l.3-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.9 570.1 332 570.1 332 570.1 331.9 570.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.1,570.5a.1.1,0,0,1,0,.1H330s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.9 570.3 331.9 570.3 331.9 570.3 331.9 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 570.3 332 570.3 332 570.3 332 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 570.4 332 570.4 332 570.4 332 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 570.4 332 570.4 332 570.4 332 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 570.4 332.1 570.4 332.1 570.4 332.1 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.9 570.4 331.9 570.4 331.9 570.4 331.9 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,570.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 570.4 332.1 570.4 332.1 570.4 332.1 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.5,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332,570.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.2 570.6 331.2 570.6 331.2 570.7 331.2 570.7 331.2 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,570.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,571.6s0,.1,0,.2h-.1v.3s0-.1,0-.1h-.3c.1-.1.1-.3.2-.4s.1-.2.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.4,571.6l.3.2s0,.1,0,.1h-.1l-.3-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.2h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,571.7c0,.1,0,.1,0,.2H329a.1.1,0,0,0,0,.1h-.1s0,.1,0,.1h-.1s-.1.1,0,.1h0c-.2,0-.2.1-.3.1s-.1-.1-.1-.2h-.3l.3-.3s.1-.1,0-.1h.2s.1-.1.1-.1-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,571.9s0,0,0,0S328,571.9,327.9,571.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.5,572.1h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,571.9c.1.1,0,.2,0,.3v.2h0s0,0,0,0h0s0,0,0,0h.1a.2.2,0,0,0,0-.2h-.1s0,.1,0,.1,0,0,0-.1h-.1s0,0,0,0h0c-.1.1,0,.1,0,.2s0-.1,0-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.4 572.1 329.4 572.1 329.4 572.1 329.4 572.1 329.4 572.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,571.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.5,572h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.4 572 331.4 572 331.4 572.1 331.4 572.1 331.4 572"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,572.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.4 572.1 331.4 572 331.5 572.1 331.4 572.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332 572 332 572 332 572 332 572"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.3,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.1,572.3a.2.2,0,0,1-.1.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.2,572.2c0,.1-.1.2-.1.2h-.2a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,572.2h0s0,.1,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.9,572.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.3 572.2 331.3 572.2 331.3 572.2 331.3 572.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332 572.1 332 572.1 332 572.1 332 572.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.9,572.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.9,572.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 572.3 331.1 572.3 331.1 572.3 331.1 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.5 572.3 330.5 572.3 330.5 572.3 330.5 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 572.3 331.1 572.3 331.1 572.3 331.1 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.5 572.4 330.5 572.3 330.5 572.4 330.5 572.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.3,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.1,572.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,573.2s0,.1,0,.1h-.3s0-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.2,573s0,.1,0,.1H330a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "331",
      "y": "557.5",
      "width": "4.1",
      "height": "8.1",
      "transform": "translate(-270.6 810.1) rotate(-81.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,563s-.2-.1-.1-.2-.1-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2l.2-.2h.1v-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.2,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.1l-.6.4A.7.7,0,0,1,329.1,563Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.8 329.1 562.8 329.1 562.8 329.1 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.6,562.9v-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.2 562.6 329.2 562.6 329.2 562.6 329.2 562.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.5 329.1 562.6 329.1 562.6 329.1 562.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.4 329.1 562.5 329.1 562.4 329.1 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.4 329.1 562.4 329.1 562.4 329.1 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.3 329.1 562.4 329.1 562.3 329.1 562.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.2 562.4 329.3 562.4 329.3 562.4 329.2 562.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.2,562.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329 562.3 329 562.3 329 562.3 329 562.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,562.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,562.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,562.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.1,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.3 562.3 330.2 562.3 330.2 562.3 330.3 562.3 330.3 562.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.2,562.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,562.7c0-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.2,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.3,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.6,562.4l-.4-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S335.6,562.5,335.6,562.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.5,561.7c0-.1.1-.1.1-.2h.2c.1.1.1-.1.2,0h.1l-.2-.2h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5-.1s.1.2,0,.3h.2s0,.1,0,.1h.2l-.5.3s-.1.1-.1.1h.1c.1,0,0,.1,0,.1h-.8c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335,561.8c.1,0,0,0,0,.1S335,561.8,335,561.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,561.1h.2a.1.1,0,0,1,0,.1H333Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.4,560.6c-.1-.1,0-.3,0-.4l.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.1 561 333.1 561 333.1 561 333.1 561 333.1 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.5,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.6 560.5 330.6 560.5 330.6 560.4 330.6 560.4 330.6 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,560.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.5 560.4 330.4 560.4 330.4 560.4 330.5 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 560.3 329.7 560.3 329.7 560.3 329.7 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.6,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.3,560.6c0-.1.1-.2.2-.2a.3.3,0,0,1,.1.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.9,560.3c0-.1.1-.2.2-.3h.1v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.6,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,560.4h0c0-.1.1-.2,0-.2h0s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.7 560.3 330.7 560.3 330.7 560.3 330.7 560.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 560.1 329.7 560.1 329.7 560.1 329.7 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,560.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.6,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 560.3 331 560.3 331 560.3 331 560.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.8 560.4 331.8 560.4 331.8 560.4 331.8 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 560.3 331 560.3 331 560.3 331 560.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.8 560.3 331.8 560.4 331.8 560.4 331.8 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.9,560c0-.1,0-.1,0-.2h.3c0,.1,0,.2-.1.2S335,560.1,334.9,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.5,559.6c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "333.2",
      "y": "561",
      "width": "8.7",
      "height": "4.44",
      "transform": "translate(-318.2 529.1) rotate(-56.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338,558.7h.3c.2-.1.3.1.5.1s.1.1.1.1h0c0,.1.2.1.3.2h-.3v.2h.1s0,0,0,.1H339a.3.3,0,0,0,.1.2h.1c.1.1,0,.2.1.3h-.1s0,.1,0,.1h.2c-.1,0-.3-.2-.4-.2h-.1c-.1.1,0,.3,0,.4a1.2,1.2,0,0,0-.2-.4c0,.1,0,.2,0,.3a1.1,1.1,0,0,1,0-.4h-.4c-.1,0-.1.2-.2.2s.1-.1.1-.2,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.2s-.1-.5-.1-.7S337.8,558.8,338,558.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.2 558.8 338.2 558.8 338.2 558.8 338.2 558.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337,561.2v.2h-.2C336.8,561.3,336.9,561.2,337,561.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 559 338.4 559 338.4 559 338.4 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.5 558.9 338.5 558.9 338.5 558.9 338.5 558.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 559 338.6 559 338.6 559 338.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 559 338.6 559 338.6 559 338.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.7 559 338.7 559 338.7 559 338.7 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 559.1 338.6 559.1 338.6 559.1 338.6 559.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.4,560.9l.2-.2h0l-.2.2S337.4,560.9,337.4,560.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.8 558.9 338.7 558.9 338.7 558.9 338.8 558.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.6,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.2,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.8,559.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.1 560.1 338.1 560.1 338.2 560.1 338.2 560.1 338.1 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.3,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335,565.8h.2c-.1.1,0,.1,0,.2l.2.4h-.2c-.1,0-.1.1-.1.2s0,.2,0,.2-.3-.3-.3-.6-.1-.3.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.7,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.4,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.7,560.4s0,0,0,0S338.6,560.4,338.7,560.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.4,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.6,565.2l.5-.2h-.7C335.4,565.2,335.5,565.2,335.6,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.4,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.3,563.5l.2.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.2s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.5h-.3c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0c.1-.1.1-.2.1-.3a.9.9,0,0,0,0-.3c-.1,0,0,.2-.1.3h-.1c0-.1.1-.2-.1-.2h-.1a.4.4,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.5,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.1,563.4h.1s0,.1,0,.1H338s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.7,561c.2,0,.2.1.4.2s.1.2,0,.3H340s0-.1,0-.1h-.3c0,.1.1,0,.1.1h-.1c0,.1,0,.1,0,.1h0s0,.1,0,.1h0c0,.1.2.1.2.2h-.1a.5.5,0,0,1-.3-.4C339.6,561.1,339.7,561.1,339.7,561Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.1 563.5 338.1 563.5 338.1 563.5 338.1 563.5 338.1 563.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.3s0,0,0,0S339.7,561.3,339.7,561.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.9,561.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.8 561.3 339.8 561.3 339.8 561.3 339.8 561.3 339.8 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 561.2 339.9 561.2 339.9 561.2 339.9 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.4 560.5 340.4 560.5 340.4 560.5 340.4 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.9,562.9a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.7c.1.1.1.2.2.3h-.4c-.1-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.9,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.8h.2s.1,0,0,.1h-.1s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.6,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 561.5 339.9 561.5 339.9 561.5 339.9 561.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.6 560.6 340.5 560.6 340.5 560.6 340.6 560.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.9,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,562h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.8 561.8 339.8 561.8 339.8 561.8 339.8 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.3 562.6 339.3 562.5 339.3 562.5 339.3 562.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.8 561.8 339.8 561.8 339.8 561.8 339.8 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 562.5 339.3 562.5 339.4 562.5 339.4 562.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340,561.5h0S340,561.5,340,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.9,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.2,565.7h.2c0,.1,0,.2-.1.3h-.1l-.2-.2C338,565.9,338.1,565.7,338.2,565.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,563.5h.1a.2.2,0,0,1-.1.2h-.2C339.6,563.6,339.7,563.5,339.8,563.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "338",
      "y": "564.1",
      "width": "8.5",
      "height": "4.35",
      "transform": "translate(-183.6 164.6) rotate(-21.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,569.7h-.2c-.2-.1-.2-.3-.3-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.5.5,0,0,0,0-.3h.1a.3.3,0,0,0,0-.3H339c0-.1.1-.2.1-.3v-.2h.1c.1,0,0,.2.2.2h0v-.2h0c.1.1.1.3.2.4h.1c.2,0,.2-.2.3-.3a1.2,1.2,0,0,0-.1.4l.2-.2-.2.3.3.3h0v.2h0s-.1.1,0,.1h0c.1.1.1-.1.2-.1s-.1.5-.3.7S339.6,569.8,339.4,569.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.3 569.5 339.3 569.5 339.3 569.5 339.3 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,568.3a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.3 569.3 339.3 569.3 339.3 569.3 339.3 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 569.3 339.1 569.3 339.1 569.3 339.1 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 569.2 339.1 569.2 339.1 569.2 339.1 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 569.1 339.1 569.2 339.1 569.2 339.1 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339 569.1 339 569.2 339 569.1 339 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.2 569.1 339.2 569.1 339.2 569.1 339.2 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.1,568.3h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.9 569.1 339 569.1 338.9 569.1 338.9 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.1,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.9,568.3s0,0,0,0S340.9,568.3,340.9,568.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339,568.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.1 568.5 340.1 568.5 340.1 568.5 340.1 568.5 340.1 568.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,565.7c-.1,0-.1-.1-.1-.2s0-.1.1-.1a1.4,1.4,0,0,0,0-.4v.2h.2l.2-.2c-.2.2,0,.4-.1.6s-.1.3-.3.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.9s0-.1,0-.1S340.2,567.8,340.2,567.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,565.9l-.5-.2s-.1-.1,0-.1h.1l.5.2H345Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.7,566.2c-.1-.1,0-.2-.1-.2v-.2c.1,0,.1-.1.2-.1s.1-.1.1-.1h-.4s.1-.1,0-.1h0a.1.1,0,0,0-.1-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.3.4-.3s.2.1.1.2h.5c-.1.1-.1.4-.3.5s-.1.1,0,.1h-.1l-.3.2v.3c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1.1.1a.3.3,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,565.5c.1,0,0,0,0,.1S344.1,565.6,344.1,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342,565.9a.2.2,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342,565.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.9c-.1-.1-.1-.2-.2-.4s.1-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0-.1,0-.1h.1c0-.1-.1-.1,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.2,0-.3s0,.1.1.1a.5.5,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342 565.9 342 565.9 342 565.8 342 565.8 342 565.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,566.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.7h0S339.3,566.7,339.3,566.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.7h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 566.7 339.4 566.7 339.4 566.6 339.4 566.6 339.4 566.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.5,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.5,566.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.3 566.7 339.3 566.7 339.2 566.7 339.3 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "338.5 566.9 338.5 567 338.5 567 338.5 566.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.1,565.9a.3.3,0,0,1,.1-.3l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,566.3c-.1-.1,0-.2.1-.4h.3a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.2,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,566.3h0c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 566.4 339.4 566.4 339.4 566.4 339.4 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "338.4 566.8 338.4 566.8 338.4 566.8 338.4 566.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.2,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,566.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.7 566.2 339.7 566.3 339.7 566.3 339.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.5 565.9 340.5 565.9 340.5 565.9 340.5 565.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.7 566.2 339.7 566.2 339.7 566.2 339.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.4 565.9 340.4 565.9 340.4 565.9 340.4 565.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.2,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.1,563.9c-.1,0-.1-.1-.1-.2s.1-.2.2-.2h.1c0,.1.1.1,0,.2S343.2,564.1,343.1,563.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.7,564.9c-.1-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "344.3",
      "y": "567",
      "width": "8.6",
      "height": "4.42",
      "transform": "translate(-259.4 293.7) rotate(-34.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,573.2h-.3c-.2,0-.3-.2-.4-.3s0-.1-.1-.1h0c0-.1-.2-.2-.2-.3h.2a.5.5,0,0,0,0-.3h-.1s0-.1,0-.1h.1a.3.3,0,0,0,0-.3h-.1c0-.1.1-.2,0-.3v-.2h.1c.1,0,.1.2.2.1s0-.1,0-.1v-.2h0c.1.1.1.3.3.3h.1c.1-.1.1-.3.2-.4a1.2,1.2,0,0,0,0,.4c0-.1.1-.2.1-.2a1.1,1.1,0,0,1-.1.4l.3.3h0c0,.1-.1.1,0,.2h0c0,.1-.1.1,0,.1h.1c.1,0,.1-.1.1-.1s0,.5-.1.7S346.7,573.2,346.5,573.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.3 573.1 346.3 573.1 346.3 573.1 346.3 573.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.4,571.3a.1.1,0,0,1,0-.2h.2c.1,0,0,.1.1.1S348.5,571.4,348.4,571.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.2 572.8 346.3 572.9 346.3 572.8 346.2 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 572.9 346.1 572.9 346.1 572.9 346.1 572.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 572.8 346.1 572.8 346.1 572.8 346.1 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 572.8 346.1 572.8 346.1 572.8 346 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 572.8 346 572.8 345.9 572.8 345.9 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 572.7 346.1 572.7 346.1 572.7 346.1 572.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,571.4l-.3.2s0,0,0-.1h.3S347.9,571.5,347.9,571.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 572.8 345.9 572.8 345.9 572.8 345.9 572.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.8,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,572.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.9 571.9 346.9 571.9 346.9 571.9 346.9 571.9 346.9 571.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.7,571.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,567.8l-.2-.2c.1,0,0-.1.1-.2a1.4,1.4,0,0,0-.1-.4h.3c0-.1,0-.2.1-.2s.1.4,0,.6,0,.3-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,571.2s0-.1,0-.1S346.9,571.2,346.8,571.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.1,568.2h-.6s-.1,0,0-.1h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,569.1v-.2a.3.3,0,0,1,0-.2c.1,0,.1-.2.2-.1s.1-.1,0-.1h-.3s0,0,0-.1h-.2s0-.1,0-.1h0v-.2h.1c0-.1,0-.1,0-.1h.1c-.1,0,0-.1,0-.2h.1c.2-.1.1-.3.3-.4l.2.2h.4c-.1.2-.1.4-.2.6s0,.1,0,.1h0l-.2.2v.3c.1,0,.1-.2.2-.2h.1c0,.1-.1.2,0,.2h.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,568.1c.1,0,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.5c-.2,0-.2-.2-.2-.3s0-.2.1-.3h0s0,.1,0,.1h0l.2.2s0,0,0-.1h.1s0-.1,0-.1h-.1c0-.1-.1,0,0-.1h.1s0-.1,0-.1h0c0-.1-.1-.2-.1-.3h.1a.5.5,0,0,1,.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.2 568.8 348.2 568.8 348.2 568.8 348.2 568.8 348.2 568.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,570.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.8 570.2 345.8 570.2 345.8 570.2 345.8 570.2 345.8 570.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,570.1s0,0,0,0S345.8,570.1,345.8,570.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,570.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.7 570.2 345.7 570.3 345.6 570.3 345.7 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345 570.7 345 570.7 344.9 570.7 345 570.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,569a.3.3,0,0,1,0-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,569.9c-.1-.1,0-.2,0-.4h.3a.2.2,0,0,1,.1.2c0,.1-.2,0-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,569.8h0c0-.1,0-.2-.1-.2h0s-.1-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,569.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.8 569.9 345.8 570 345.8 569.9 345.8 569.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "344.8 570.6 344.9 570.6 344.9 570.6 344.8 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.4,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,569.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 569.7 346 569.8 346 569.8 346 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.7 569.2 346.7 569.2 346.7 569.2 346.7 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 569.7 346 569.7 346 569.7 346 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.7 569.2 346.7 569.3 346.7 569.2 346.7 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,569.9h0S345.7,569.9,345.7,569.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.6,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,566.7v-.2c0-.1.1-.2.2-.2h.1c0,.1.1.1.1.2S349,566.8,348.9,566.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,568.2c-.1,0,0-.1-.1-.2h.2a.2.2,0,0,1,0,.2A.2.2,0,0,1,346.7,568.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "349.8",
      "y": "566.5",
      "width": "6.1",
      "height": "3.14",
      "transform": "translate(-95.2 71.6) rotate(-10.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,570.1h-.2c-.1-.1-.1-.2-.2-.3s0-.1,0-.1h0c.1-.1-.1-.2-.1-.2h.1v-.2h0a.2.2,0,0,0,.1-.2h0c0-.1.1-.1.1-.2h0c.1,0,0,.1.1.2h0s0-.1,0-.2h0c.1.1,0,.2.1.3h.1l.2-.2v.3h.2l-.2.2v.3h.1l-.3.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 570 350.3 570 350.3 570 350.3 570"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,569.4a.1.1,0,0,1,0-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 569.8 350.3 569.8 350.3 569.8 350.3 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 569.8 350.2 569.8 350.2 569.8 350.2 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 569.7 350.2 569.7 350.2 569.7 350.2 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 569.7 350.2 569.7 350.2 569.7 350.2 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 569.6 350.1 569.7 350.1 569.7 350.1 569.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 569.6 350.3 569.6 350.3 569.6 350.3 569.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,569.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 569.6 350.1 569.6 350.1 569.6 350.1 569.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.7,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.7,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,569.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351 569.4 351 569.4 351 569.4 351 569.4 351 569.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,568.1c-.1,0,0-.1-.1-.2h.1v-.3h.3c-.1.1,0,.3-.2.4s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,568.2l-.4-.2s0-.1,0-.1h.1l.3.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.8h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.1,568.1c0-.1,0-.1,0-.2h.1a.1.1,0,0,0,0-.1h.1s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.2-.2.3-.2s.1.1.1.2h.3l-.3.3s-.1.1,0,.1h-.3v.2h.2s-.1.1-.1.1.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,567.8c.1,0,0,0,0,0S354.3,567.8,354.3,567.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.7,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.7,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568.1c-.1-.1,0-.2-.1-.3s.1-.1.1-.2h0s0,0,0,0h0s0,0,0,0h-.1a.2.2,0,0,0,0,.2s0,0,0-.1h0s0-.1,0-.1,0,0,0,.1h.1c0-.1,0-.1,0-.2s0,.1,0,.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.7 567.8 352.7 567.8 352.7 567.7 352.7 567.7 352.7 567.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,568.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568h0S350.7,568,350.7,568Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.8 568 350.8 568 350.8 567.9 350.8 567.9 350.8 568"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,567.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 567.9 350.7 568 350.7 567.9 350.7 567.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.1 568 350.1 568 350.1 568 350.1 568"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,567.6a.2.2,0,0,1,.1-.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,567.8c0-.1.1-.2.1-.2h.2a.1.1,0,0,1,0,.1H351Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,567.7h0s0-.1,0-.1h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.8 567.8 350.8 567.8 350.8 567.8 350.8 567.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.1 567.9 350.1 567.9 350.1 567.9 350.1 567.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.2,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351 567.7 351 567.7 351 567.7 351 567.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.7 567.6 351.7 567.6 351.6 567.6 351.7 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351 567.7 351 567.7 351 567.7 351 567.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 567.6 351.6 567.6 351.6 567.6 351.6 567.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.8,566.6s0-.1,0-.1h.3s0,.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,566.9s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351.8",
      "y": "555.6",
      "width": "4",
      "height": "7.81",
      "transform": "translate(-241.6 270.2) rotate(-31.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,561.5c0,.1,0,.2-.1.2s-.2.2-.3.4h-.2s0-.1,0-.1-.2.1-.3.2.1-.1.1-.2h-1.1c0-.1.1-.1.1-.2h-.3c.1-.1.3-.1.3-.3h0l-.3-.2h.5l.3-.3c0-.1-.1-.1-.1-.2v.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1-.1-.1-.1l.6.2C357.1,561.2,357.3,561.3,357.3,561.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 561.6 357.1 561.6 357.1 561.7 357.1 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,559.7h-.2v-.2h.1A.1.1,0,0,1,355.7,559.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 561.7 356.9 561.7 356.9 561.7 356.9 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 561.8 357 561.8 357 561.8 357 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 561.8 356.9 561.8 356.9 561.9 356.9 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 561.9 356.9 561.9 356.9 561.9 356.8 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 562 356.9 562 356.8 562 356.8 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.7 561.8 356.8 561.8 356.8 561.8 356.7 561.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,560.2v.3h-.1c0-.1-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 562 356.9 562 356.9 562 356.8 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,561.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.7,562h0S356.7,562,356.7,562Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.1 561.1 356.1 561.1 356.1 561.1 356.1 561.1 356.1 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,561.3h0S356.1,561.2,356.1,561.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,556.4H352c0-.1-.1-.1-.1-.2h-.2c.2.1.4-.1.6,0s.3,0,.3.2S352.6,556.4,352.6,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.9,557.1a1.3,1.3,0,0,1-.1.5h-.1s0-.1,0-.1a3,3,0,0,0,.1-.5s0-.1.1-.1S352.9,557.1,352.9,557.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.6,559.1h-.4c0-.1-.1-.1-.1-.2H353c0,.1-.1.2,0,.3h-.1c-.1,0,0,.1,0,.1h-.2s0,.1,0,.1h-.4s0-.1,0-.1h-.1c0-.2-.3-.1-.3-.3l.2-.2c0-.1,0-.1-.1-.2h.1v-.2l.5.2h.1a.3.3,0,0,0,0-.2h.1c.1,0,0,.1.1.2s-.1.1,0,.2l.2.2h.2c0-.1-.2-.1-.2-.2h.1c.1,0,.1.1.2,0h.1a.3.3,0,0,1,.3.2A.5.5,0,0,1,353.6,559.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,559.8h0A.1.1,0,0,1,353.5,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.4,559.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,562c0,.1-.2.1-.3.2h0c0-.1.1,0,0-.1h.2c.1,0,0-.1,0-.1h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 559.8 353.4 559.8 353.4 559.8 353.4 559.8 353.4 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.7,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,562h0S354.6,562,354.7,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,562.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.5 562 354.5 562 354.5 562 354.5 562 354.5 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.6 562.1 354.6 562.1 354.6 562.2 354.6 562.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.9 562.8 355 562.8 355 562.8 354.9 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,560.6h-.3v-.2h.1C353.5,560.5,353.6,560.6,353.5,560.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,561.9h-.3s0-.1,0-.1a.3.3,0,0,0,.1-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,354.2,561.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,562.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.7H354s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.3 562 354.3 562 354.3 562 354.3 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.8 562.9 354.8 562.9 354.8 562.9 354.8 562.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.3,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354,561.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.1 561.8 354.1 561.8 354.1 561.8 354.1 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.7 561.1 353.7 561.1 353.7 561.1 353.7 561.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.1 561.8 354.1 561.8 354.1 561.8 354.1 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.7 561.2 353.7 561.2 353.7 561.2 353.7 561.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,563.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,559.1h-.2c-.1,0-.2-.1-.2-.2h.2C351.4,558.8,351.6,559,351.5,559.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.7,561.2h-.1A.1.1,0,0,1,352.7,561.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "356.4",
      "y": "560.9",
      "width": "7.4",
      "height": "3.79",
      "transform": "translate(-234.9 866.9) rotate(-84.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,566.4h-.8s.1,0,0-.1h-.3s0,.1,0,.1h0a.4.4,0,0,1,0-.1h-.3l-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.1-.2-.1-.4l.3.2c-.1-.1-.1-.2-.1-.2l.2.3h.4c0-.1,0-.2.1-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.2l.4.5A.6.6,0,0,1,361.6,566.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 566.4 361.4 566.4 361.4 566.4 361.4 566.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.4,564.1h-.1a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,361.4,564.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.2 566.3 361.2 566.4 361.2 566.3 361.2 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.2 566.5 361.2 566.5 361.2 566.5 361.2 566.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.1 566.4 361.1 566.4 361.1 566.4 361.1 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361 566.4 361 566.4 361 566.4 361 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 566.5 361 566.5 361 566.5 360.9 566.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361 566.3 361 566.3 361 566.3 361 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.1,564.5a.8.8,0,0,1,0,.3h0c0-.1,0-.2.1-.3S361.2,564.5,361.1,564.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 566.5 361 566.5 360.9 566.5 360.9 566.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,564.6h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.8,566.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 565.4 360.9 565.4 360.9 565.4 360.9 565.4 360.9 565.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.8,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.9,559.9h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.2c.1,0,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,560.6l-.3.4h0l.3-.3h.1C360.9,560.5,360.8,560.6,360.8,560.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.3,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.3,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,562.5H360v-.2c.1-.1-.1-.1,0-.2h-.1l-.2.2h-.5s0-.1,0-.1H359s0,0,0-.1h0c.1-.2-.1-.3-.1-.4h.2c.1,0,0-.1,0-.2h.1c0-.1,0-.1,0-.2s.2.3.3.4h.4c0,.1-.1.1-.1.2h-.1c0,.1,0,.2,0,.3v.2c.1-.1-.1-.2,0-.2h.1c0,.1,0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.7,562.9h0S359.7,562.9,359.7,562.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,565.4H359c0-.1-.1-.1-.2-.2h.2s0,0,0,0h.2s0-.1,0-.1H359l.3.2C359.4,565.2,359.4,565.3,359.4,565.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.6 562.9 359.6 562.9 359.6 562.9 359.6 562.9 359.6 562.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.3,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.3,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,565.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 565.2 359.2 565.2 359.2 565.2 359.2 565.2 359.2 565.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,565.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 565.3 359.2 565.3 359.1 565.3 359.1 565.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 566 359.1 566 359.1 566.1 359.1 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,563.6l-.2-.2h.3C359.3,563.5,359.3,563.6,359.2,563.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,564.9c-.1,0-.2-.1-.3-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,564.7s0,0,0,0h-.2s0,0,0,0h0s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,564.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 565.1 359 565.1 359 565.1 359 565.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 566 358.9 566 358.9 566 358.9 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 564.8 359 564.8 359 564.8 359 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 564.1 359.1 564.1 359.1 564.1 359.1 564.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 564.8 359 564.8 359 564.8 359 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 564.1 359 564.1 359 564.1 359 564.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,566h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,561.2h-.2c0-.1-.1-.2-.1-.2h.3C358.7,561,358.7,561.2,358.6,561.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,563.5h-.1a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,358.3,563.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "359.1",
      "y": "550.7",
      "width": "4.5",
      "height": "8.72",
      "transform": "translate(-290 434.7) rotate(-46.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.9c0-.1-.1-.2,0-.3s.1-.3.2-.5h.2c.1,0,0,.1.1.1s.1-.2.2-.3-.1.2,0,.3h.9v-.2h.1c0,.1-.1.1-.1.2h.1v-.2h0c-.1.1-.3.2-.2.4h0c.1.1.3,0,.4.1h-.5l-.2.4c0,.1.2.1.1.2h-.3s0,0,0,.1H358c0,.1.1,0,.1.1h-.7C357.2,554.2,357,554.1,356.9,553.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 553.7 357.1 553.7 357.1 553.7 357.1 553.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,555.4h.2v.2h-.1C359.3,555.6,359.2,555.5,359.2,555.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.6 357.3 553.6 357.3 553.6 357.3 553.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 553.5 357.2 553.5 357.2 553.5 357.2 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.4 357.3 553.4 357.3 553.4 357.3 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.4 357.3 553.4 357.3 553.4 357.3 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.3 357.3 553.3 357.3 553.3 357.3 553.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.4 553.4 357.4 553.4 357.4 553.4 357.4 553.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,554.9l-.2-.2h.1l.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.2 357.3 553.2 357.3 553.2 357.3 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.2,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.5,553.2h0S357.5,553.2,357.5,553.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.3 554 358.3 554 358.4 554 358.4 554 358.3 554"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.5,558.1v-.2h.6v.2c0,.1.1.1.2.2h.2c-.2-.1-.4.2-.6.2s-.3,0-.4-.1S363.5,558.1,363.5,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.6,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.9,557.4a1.4,1.4,0,0,1-.1-.6h.1a3.4,3.4,0,0,0,.1.5s0,.1,0,.1S362.9,557.4,362.9,557.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,555.4l.2-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2,0-.3h.1c.1,0,0-.1,0-.1h.2c0-.1-.1-.1,0-.1h.6s0,.1,0,.1.3.1.4.2-.1.2-.2.2.1.1.1.2h-.7a.3.3,0,0,0,0,.2c0,.1-.1.1,0,.1s0-.1-.1-.2,0-.1,0-.2l-.3-.2h-.3c0,.1.2.1.2.2h-.1c-.1,0-.2-.1-.2,0s0,.1-.1.1l-.4-.2A.6.6,0,0,1,361.6,555.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.9,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.6,554.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,552.6c0-.2.2-.2.3-.3h0c0,.1-.1,0,0,.1h0l-.2.2h.1c-.1,0,.1.1,0,.1h.5c0,.1-.1,0-.1.1a.5.5,0,0,1-.4.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.7 554.7 361.6 554.6 361.7 554.6 361.7 554.6 361.7 554.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,552.5h0S359.7,552.5,359.7,552.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.8 552.6 359.8 552.6 359.8 552.5 359.8 552.5 359.8 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.9,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.9,552.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.7 552.4 359.7 552.5 359.7 552.4 359.7 552.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 551.8 359.1 551.9 359.1 551.9 359.1 551.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.3,553.8h.3a.4.4,0,0,1-.1.2h-.2C361.3,553.9,361.2,553.9,361.3,553.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,552.6c.1-.1.2-.1.4-.1h0a.3.3,0,0,0,0,.3h-.1c-.1,0-.1-.1-.2-.1A.1.1,0,0,1,360.2,552.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,552.8h.1s0,.1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.1 552.5 360 552.5 360 552.5 360.1 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 551.7 359.2 551.7 359.2 551.7 359.2 551.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.7h0S360.4,552.7,360.4,552.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.5,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.3 552.6 360.3 552.7 360.3 552.7 360.3 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361 553.3 360.9 553.3 360.9 553.3 361 553.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.3 552.7 360.3 552.7 360.3 552.6 360.3 552.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.9 553.2 360.9 553.2 360.9 553.2 360.9 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.1,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,554.9h.1c.1,0,.2,0,.3.1a.3.3,0,0,1,0,.1h-.2C364,555.1,363.9,555,363.9,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362,553h.3s0,.1,0,.1h-.2C362,553.2,361.9,553.1,362,553Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.8",
      "y": "554.4",
      "width": "3.9",
      "height": "7.57",
      "transform": "translate(-134.5 117.4) rotate(-15.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.5,561.1c0,.1,0,.2-.1.2s-.2.2-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.1-.2h-1.1l.4-.2h0c0-.1-.2-.2-.3-.3h.4l-.2-.2.3.2.3-.2c0-.1-.1-.1,0-.2s0,.1.1.2h.3c.1-.1-.1-.1-.1-.2l.6.3C371.4,560.8,371.5,560.9,371.5,561.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.3 561.2 371.3 561.2 371.3 561.2 371.3 561.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.5,559h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,370.5,559Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.1 561.2 371.1 561.2 371.1 561.2 371.1 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.1 561.3 371.1 561.3 371.1 561.3 371.1 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371 561.3 371 561.3 371 561.3 371 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371 561.3 371 561.3 371 561.3 371 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.9 561.4 371 561.4 370.9 561.4 370.9 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.9 561.3 370.9 561.2 370.9 561.2 370.9 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.4,559.4a.8.8,0,0,1,.1.3h-.1c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.9 561.5 370.9 561.4 370.9 561.4 370.9 561.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,559.6h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.6,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.8,561.4h0S370.8,561.4,370.8,561.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.5 560.4 370.5 560.4 370.5 560.4 370.5 560.4 370.5 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,555.1H368c.1-.1,0-.1,0-.2v-.2c.1.2.4,0,.5.2s.2.1.2.3S368.5,555,368.5,555.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,555.8a1.2,1.2,0,0,1-.2.5h-.1s0-.1,0-.1l.2-.4h.1C368.7,555.7,368.6,555.8,368.6,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,557.9h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2h-.3c-.1,0,0,.1-.1.1s0-.1,0-.1h-.3s0,0,0-.1h-.1c0-.2-.2-.2-.2-.4h.2c.1-.1,0-.1,0-.2h.1c-.1,0,0-.1-.1-.2l.4.3h.1V557h.1s0,.1,0,.2v.4h.2c.1-.1-.1-.1-.1-.2h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,558.5h0A.1.1,0,0,1,368.4,558.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,558.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,560.9h-.3l-.2-.2h.3s0,0,0,0h.2c.1,0,0-.1.1-.1h-.1s0,.1,0,.1h.1C369,560.8,369,560.8,369,560.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 558.4 368.3 558.4 368.3 558.4 368.3 558.4 368.3 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,560.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.8 560.8 368.8 560.8 368.8 560.8 368.8 560.8 368.8 560.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,560.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.8 560.9 368.8 560.9 368.8 561 368.8 560.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369 561.6 369 561.7 369 561.7 369 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,560.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,559.2h0C368.3,559.1,368.3,559.2,368.2,559.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,560.6h-.3s0-.1,0-.1v-.2h.1c.1,0,0,.1.1.2A.1.1,0,0,1,368.5,560.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.5,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.5 560.7 368.6 560.8 368.6 560.8 368.5 560.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.8 561.7 368.8 561.7 368.8 561.7 368.8 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,559.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 560.5 368.5 560.5 368.5 560.5 368.4 560.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.2 559.8 368.2 559.8 368.2 559.8 368.2 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 560.5 368.4 560.5 368.4 560.5 368.4 560.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.2 559.8 368.2 559.8 368.2 559.8 368.2 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.7,557.3h-.2c-.1-.1-.2-.1-.1-.2h.2C366.8,557,366.8,557.2,366.7,557.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.3,559.5h0A.1.1,0,0,1,367.3,559.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "368.7",
      "y": "549.5",
      "width": "4.4",
      "height": "8.63",
      "transform": "translate(-247.3 803.3) rotate(-78.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.6,555.2c0-.1-.2-.1-.1-.2s0-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2.1-.3s0,.2.1.2l.2-.2h.1l.2-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1-.1.2,0,.2h.1c0-.1,0-.1,0-.2h.1c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,0,.4h-.3c0,.1.1,0,.2,0l-.6.4A.7.7,0,0,1,366.6,555.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 554.9 366.6 554.9 366.6 554.9 366.6 554.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,555.2V555h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.7 554.7 366.7 554.7 366.7 554.7 366.7 554.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 554.7 366.5 554.7 366.5 554.7 366.5 554.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 554.6 366.6 554.6 366.6 554.5 366.6 554.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 554.5 366.6 554.5 366.6 554.5 366.6 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 554.4 366.5 554.5 366.5 554.4 366.5 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.7 554.5 366.7 554.5 366.7 554.5 366.7 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,554.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 554.4 366.5 554.4 366.5 554.4 366.5 554.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,554.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.6,554.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.8 554.5 367.8 554.5 367.8 554.5 367.8 554.5 367.8 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.3c0-.1,0-.2,0-.2h.2l.3-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.4s-.2.2-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.9,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.4,555l-.4-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S373.4,555,373.4,555Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.3,554c0-.1.1-.2.1-.2h.2c.1.1.2-.1.2,0h.1c-.1-.1-.1-.2-.2-.2h0c0-.1-.1-.1-.1-.1h.1c0-.1-.1,0-.1-.1h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5,0s.1.2,0,.3h.2s0,.1,0,.2h.2l-.6.3s-.1.1-.1.1v.2c.1.1,0,.1,0,.1h-.2v-.2h-.6c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,554.3c.1,0,0,0,0,.1S372.9,554.2,372.9,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.8,553.4h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.9,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.7c-.1-.1,0-.3.1-.4s.2-.1.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1h.1c.1-.1,0-.2.1-.2s-.1.1,0,.2a.5.5,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "370.9",
      "y": "553.3",
      "height": "0.01",
      "transform": "translate(-245.4 806.1) rotate(-78.5)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.6h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.3 552.6 368.3 552.6 368.3 552.5 368.3 552.5 368.3 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,552.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.1 552.5 368.1 552.5 368.1 552.5 368.1 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.3 552.3 367.3 552.3 367.3 552.3 367.3 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.1,552.8a.3.3,0,0,1,.2-.2.4.4,0,0,1,0,.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,552.4c0-.2.2-.2.3-.3h.1a.3.3,0,0,0,.1.2h-.3A.1.1,0,0,1,368.6,552.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,552.5h0c0-.1.1-.2,0-.2h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,552.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.4 552.4 368.4 552.4 368.4 552.3 368.4 552.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.3 552.1 367.4 552.1 367.3 552.1 367.3 552.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,552.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,552.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.7 552.3 368.7 552.4 368.7 552.4 368.7 552.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.6 552.5 369.6 552.5 369.6 552.5 369.6 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.8 552.3 368.8 552.4 368.7 552.4 368.8 552.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.6 552.5 369.6 552.5 369.6 552.5 369.6 552.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,552.3c0-.1,0-.1.1-.2h.4c0,.1,0,.2-.1.2S373,552.5,372.9,552.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,551.7c0-.1.1-.1.1-.2h.2v.2A.2.2,0,0,1,370.3,551.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.4",
      "y": "549.9",
      "width": "4.1",
      "height": "8.05",
      "transform": "translate(-68 52.9) rotate(-7.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,557.3c0,.1,0,.2-.1.2s-.3.1-.4.2h-.2s.1-.1,0-.1-.2.1-.3.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.4s0,0,0-.1h.1c0-.2-.2-.2-.2-.3l.4.2v-.2l.3.2.4-.2c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.4A.7.7,0,0,1,378.9,557.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 557.4 378.7 557.4 378.7 557.4 378.7 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,554.9H378a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,378.1,554.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.5 557.3 378.5 557.4 378.5 557.3 378.5 557.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.5 557.5 378.5 557.5 378.5 557.5 378.5 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 557.5 378.4 557.5 378.4 557.5 378.4 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 557.5 378.3 557.5 378.3 557.5 378.3 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 557.6 378.3 557.6 378.3 557.6 378.3 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.2 557.4 378.3 557.4 378.3 557.4 378.2 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378,555.4a.9.9,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 557.6 378.3 557.6 378.3 557.6 378.3 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,555.5h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,557.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 556.4 378 556.4 377.9 556.4 377.9 556.4 378 556.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.9,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,550.6h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2v-.2c.1.2.4.1.5.2s.2.2.2.3S376.7,550.5,376.6,550.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,551.3l-.3.5h-.1s0-.1,0-.1l.3-.4h.1C376.8,551.2,376.7,551.3,376.6,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.5,553.5h-.4c0-.1-.1-.1,0-.2H376c0,.1-.1.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1H375c.1-.2-.2-.2-.2-.4h.3c.1-.1,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1-.1-.3h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,554h0S376,554,376,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.3,556.7h-.4c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C376.3,556.6,376.3,556.7,376.3,556.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376 554 376 554 375.9 554.1 375.9 554 376 554"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.3,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.1,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,556.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 556.6 376.1 556.6 376.1 556.6 376.1 556.6 376.1 556.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,556.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 556.7 376.1 556.8 376.1 556.8 376.1 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 557.5 376.2 557.5 376.2 557.5 376.1 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,556.6s0,0,0,0S376,556.6,376,556.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,554.9h0C375.8,554.8,375.8,554.9,375.7,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,556.4c-.1,0-.2-.1-.3-.1s0-.1,0-.1l.2-.2h.2c.1.1,0,.1.1.2A.1.1,0,0,1,375.9,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,556.2h-.1s0,0,0-.1h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.9 556.5 375.9 556.5 375.9 556.5 375.9 556.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376 557.6 376 557.5 376 557.6 376 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 556.3 375.8 556.3 375.8 556.3 375.8 556.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.7 555.4 375.7 555.4 375.7 555.5 375.7 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 556.2 375.8 556.2 375.8 556.3 375.8 556.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.6 555.5 375.7 555.5 375.7 555.5 375.6 555.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,552.6h-.2c-.1-.1-.2-.1-.1-.2h.3C374.5,552.3,374.6,552.5,374.5,552.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,555h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,374.7,555Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "373.2",
      "y": "545.1",
      "width": "3.1",
      "height": "5.99",
      "transform": "translate(-288.5 517.6) rotate(-53)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.9,548.6s.1.1,0,.2-.1.2-.1.3h-.1c-.1,0-.1.1-.1.2s.1-.1,0-.2h-.7c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h0v-.3h.1s0,0,0,0h.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.8 548.7 377.8 548.7 377.8 548.7 377.8 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,547.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.6 548.8 377.7 548.8 377.7 548.8 377.6 548.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 548.9 377.7 548.9 377.7 548.9 377.7 548.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 548.9 377.7 549 377.7 549 377.7 548.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.6 549 377.6 549 377.6 549 377.6 549"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 549.1 377.7 549 377.7 549 377.7 549.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.6 549 377.6 549 377.6 549 377.6 549"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.1h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 549.1 377.7 549.1 377.7 549.1 377.7 549.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.5,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,549.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.9 548.6 376.9 548.6 376.9 548.6 376.9 548.6 376.9 548.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.9,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.1,546.3h-.7c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.5,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.5,546.7a1,1,0,0,1,.1.4h-.1a2.3,2.3,0,0,0-.1-.4s0-.1,0-.1S373.5,546.6,373.5,546.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,547.9h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.1,0,.2h0s0,.1,0,.1H374s0,.1,0,.1h-.4s0,0,0-.1-.2,0-.3-.1,0-.1.1-.2h.3s0-.1,0-.1h.1s0,.1,0,.1h.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.6,548.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,549.7c0,.1-.1.2-.2.2h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.3l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 548.4 374.6 548.5 374.6 548.5 374.6 548.5 374.6 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.8h0S376.1,549.8,376.1,549.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376 549.7 376 549.7 376 549.7 376 549.7 376 549.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,549.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 549.8 376.1 549.8 376.1 549.8 376.1 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.5 550.2 376.6 550.2 376.6 550.2 376.5 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.9,549h-.2a.2.2,0,0,1,0-.2h.1S375,549,374.9,549Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,549.7h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,375.8,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,549.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.9 549.8 375.9 549.8 375.9 549.8 375.9 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.5 550.3 376.5 550.3 376.5 550.3 376.5 550.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.7h0S375.6,549.7,375.6,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 549.7 375.7 549.7 375.7 549.7 375.7 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.2 549.3 375.2 549.3 375.2 549.3 375.2 549.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 549.7 375.7 549.7 375.7 549.7 375.7 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.2 549.4 375.2 549.4 375.2 549.4 375.2 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373,548.5h-.2C372.9,548.3,373.1,548.4,373,548.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,549.6h-.2s0,0,0-.1h.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "376.8",
      "y": "551.1",
      "width": "3.1",
      "height": "5.99",
      "transform": "translate(-290.1 612.2) rotate(-60.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,554.1s.1.1.1.2,0,.2-.1.3h-.1s0,.1,0,.1h-.1c-.1,0,0,.2-.1.2s0-.1,0-.2h-.4s0,0,0,.1h-.3c0-.1.1-.1,0-.2h-.2c0-.1.1-.2.1-.3h-.1a.1.1,0,0,0,0-.1h0a.7.7,0,0,0,.1-.3h.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 554.3 381.4 554.3 381.4 554.3 381.4 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,553.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.4 381.3 554.4 381.3 554.4 381.3 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 554.5 381.4 554.5 381.4 554.5 381.4 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.5 381.3 554.5 381.3 554.5 381.3 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.6 381.3 554.6 381.3 554.6 381.3 554.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.6 381.3 554.6 381.3 554.6 381.3 554.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 554.6 381.2 554.6 381.2 554.6 381.2 554.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,553.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.7 381.3 554.6 381.3 554.6 381.3 554.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,553.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,553.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.5 554.3 380.5 554.3 380.5 554.3 380.5 554.3 380.5 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,552.5v.2h-.1l-.2.2h-.3c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,552.8l.2.4h-.1v-.4s0-.1,0-.1S376.9,552.8,376.9,552.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,554.6h0S380,554.6,380,554.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,553.9h-.5c0,.1,0,.1.1.2h0s0,.1,0,.1h-.1s.1,0,0,.1h-.4s0,0,0-.1-.2,0-.3-.1,0-.1.1-.2h.2s0-.1,0-.1h.5s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.2,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,555.4c0,.1-.1.2-.1.3h0s0,0,0-.1h0v-.2h0s-.1,0,0-.1h-.3s.1,0,0-.1l.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.2 554.4 378.2 554.4 378.2 554.5 378.2 554.5 378.2 554.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,555.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,555.6h0S379.9,555.5,379.9,555.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.8 555.5 379.8 555.5 379.8 555.5 379.8 555.5 379.8 555.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.7,555.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.8 555.6 379.9 555.6 379.9 555.6 379.8 555.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 555.9 380.4 555.9 380.4 555.9 380.3 555.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.6,554.9h-.2a.2.2,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,555.5h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,379.5,555.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.4h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,555.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 555.6 379.6 555.6 379.6 555.6 379.6 555.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 556 380.3 556 380.3 556 380.3 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,555.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 555.5 379.4 555.5 379.4 555.5 379.4 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 555.2 378.9 555.2 378.9 555.2 378.9 555.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 555.5 379.4 555.5 379.4 555.5 379.4 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 555.3 378.9 555.3 378.9 555.3 378.9 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.7,554.7h-.2C376.5,554.5,376.7,554.6,376.7,554.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,555.6h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.2",
      "y": "552.8",
      "width": "3.9",
      "height": "7.67",
      "transform": "translate(-232.8 273) rotate(-31)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,554.6c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s0,.1,0,.1.1-.1.3-.2-.1.1-.1.2h1c0,.1-.1.1-.1.2h.3c-.1.1-.3.1-.3.3h0l.3.2h-.5l-.2.3c0,.1.1.1.1.2V555h-.1s0,0,0,0h-.1a.1.1,0,0,0,0,.1h-.1c0,.1.1.1.1.1l-.6-.2C372.8,554.9,372.7,554.8,372.7,554.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.8 554.5 372.8 554.5 372.8 554.5 372.8 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,556.4h.2v.2h-.1A.1.1,0,0,1,374.3,556.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.4 373 554.4 373 554.4 373.1 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373 554.3 373 554.3 373 554.3 373 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.3 373.1 554.3 373.1 554.3 373.1 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.2 373.1 554.3 373.1 554.3 373.1 554.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.1 373.1 554.2 373.1 554.2 373.1 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.2 554.3 373.2 554.3 373.2 554.3 373.2 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9v-.2h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.1 373.1 554.1 373.1 554.1 373.1 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.1,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,554.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.3,554.1a0,0,0,0,1,0,0S373.3,554.1,373.3,554.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.8 555 373.8 555 373.9 555 373.9 555 373.8 555"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,554.9h0S373.9,554.9,373.9,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.2,559.7h.6c0,.1.1.1.1.2h.2c-.2-.1-.4.1-.5,0s-.3,0-.3-.2S377.2,559.7,377.2,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,559a1.3,1.3,0,0,1,.1-.5h.1s0,.1,0,.1a3,3,0,0,0-.1.5s0,.1-.1.1S376.9,559,376.9,559Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.3,557h.4c0,.1.1.1.1.2h.1c0-.1.1-.2,0-.2h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.4s0,0,0,.1h.1c0,.2.3.1.3.3l-.2.2c0,.1,0,.1.1.2h-.1v.2l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1-.1-.2s.1-.1,0-.2l-.2-.2h-.2c0,.1.1.1.2.2h-.4a.3.3,0,0,1-.3-.2A.5.5,0,0,1,376.3,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,558.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,556.3h0A.1.1,0,0,1,376.4,556.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.5,556.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.2,554.1c0-.1.2-.1.3-.2h0c0,.1-.1,0,0,.1h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.5 556.4 376.5 556.3 376.5 556.3 376.5 556.3 376.5 556.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.3,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554.1h0S375.3,554.1,375.3,554.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "375.4",
      "y": "554.1",
      "transform": "translate(-235.6 280.9) rotate(-31.8)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 554 375.4 554 375.4 554 375.4 554"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375 553.4 375 553.4 375 553.4 375 553.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,555.5h.3v.2h-.1C376.4,555.6,376.3,555.6,376.4,555.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,554.3h.3s0,.1,0,.1a.3.3,0,0,0-.1.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,375.7,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.5,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.5,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,554.5h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,554.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.6 554.1 375.6 554.1 375.6 554.1 375.6 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.1 553.3 375.1 553.3 375.1 553.3 375.1 553.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.6,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,554.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 554.3 375.8 554.3 375.8 554.3 375.8 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.2 555 376.2 555 376.2 555 376.2 555"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 554.3 375.8 554.4 375.8 554.3 375.8 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.2 555 376.2 555 376.2 555 376.2 555"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,557.1h.2c.1,0,.2.1.2.2h-.2C378.4,557.3,378.3,557.2,378.4,557.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.2,555h.1A.1.1,0,0,1,377.2,555Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "365",
      "y": "560",
      "width": "8.3",
      "height": "4.24",
      "transform": "translate(-261.5 795.7) rotate(-77)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,566.3h-.2c-.2.1-.3,0-.5,0h-.2c0-.1.1,0,.1-.1s-.2,0-.3-.1h.2l-.2-.2s0,.1,0,.1h0v-.2l-.2-.2h-.1c-.1,0-.1-.2-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0-.1,0-.1h.1c.1-.2-.1-.3-.1-.4l.3.3c-.1-.1-.1-.2-.1-.3l.2.3h.4c0-.1,0-.2.1-.2s-.1.1,0,.2h.1s0,.1.1.1h.1c.1,0,0-.1,0-.2s.3.4.4.6A.7.7,0,0,1,370.3,566.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 566.3 370.1 566.3 370.1 566.3 370.1 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.4,563.7h-.2v-.2h.1A.2.2,0,0,1,370.4,563.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.9 566.2 369.9 566.2 369.9 566.2 369.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 566.3 369.9 566.3 369.9 566.3 369.8 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 566.2 369.7 566.3 369.7 566.3 369.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 566.2 369.7 566.2 369.7 566.2 369.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 566.3 369.6 566.3 369.6 566.3 369.6 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 566.1 369.7 566.1 369.7 566.1 369.7 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.1,564.1v.3h0c.1-.1,0-.2.1-.3S370.2,564.1,370.1,564.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 566.4 369.6 566.4 369.6 566.4 369.6 566.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,564.2h0c.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.1,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.7,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.5,566.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 565.1 369.7 565.1 369.7 565.1 369.7 565.1 369.7 565.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.6,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,558.9h-.2c0-.1-.1-.1,0-.2l-.3-.2h.2c.1,0,.1-.1.1-.2s-.1-.1-.1-.2.3.2.4.4.2.2.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,559.7l-.4.3h0l.4-.3h.1C370.4,559.6,370.3,559.7,370.3,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,561.8h-.2v-.2c.1-.1-.1-.2.1-.2s0-.1-.1-.1l-.2.2h-.7s0,0,0-.1h0c.1-.2-.1-.3,0-.5h.3c.1,0,.1-.1.1-.2h.1c0-.1.1-.1,0-.2s.2.3.2.5h.4c0,.1-.1.1-.1.2H369c0,.1,0,.2,0,.3v.2c.1-.1,0-.2,0-.3h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.6,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,562.2h-.1s0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,562.1h0S368.7,562.1,368.7,562.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,564.8h-.4c0-.1-.1-.2-.2-.3h.2s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2a.4.4,0,0,1,.4.2C368.1,564.7,368,564.8,368,564.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.6 562.1 368.6 562.1 368.6 562.1 368.6 562.1 368.6 562.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.9,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,564.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 564.6 367.9 564.6 367.8 564.6 367.8 564.6 367.9 564.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.8 564.7 367.8 564.7 367.8 564.8 367.8 564.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 565.5 367.6 565.5 367.6 565.5 367.6 565.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,562.8a.3.3,0,0,1-.2-.2h.3C368.2,562.7,368.2,562.8,368.1,562.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,564.3c-.2,0-.2-.2-.3-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564.1s0,0,0,0h-.2s0,0,0-.1h0s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564h0S367.8,564,367.8,564Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.7 564.4 367.7 564.5 367.6 564.5 367.7 564.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 565.5 367.4 565.5 367.4 565.5 367.4 565.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,562.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.7 564.2 367.7 564.2 367.7 564.2 367.7 564.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 563.3 367.9 563.3 367.9 563.3 367.9 563.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.7 564.1 367.7 564.1 367.7 564.2 367.7 564.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.8 563.4 367.8 563.4 367.8 563.4 367.8 563.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.6,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,565.5h0S367.1,565.4,367.1,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,560.1h-.2c0-.1-.1-.2,0-.3h.3C367.9,559.9,367.9,560.1,367.7,560.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,562.6H367a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,367.1,562.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "370.3",
      "y": "563",
      "width": "8.6",
      "height": "4.41",
      "transform": "translate(-79.7 61.9) rotate(-8.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,562.5c.1,0,.2,0,.2.2s.2.3.2.5,0,.1,0,.1h0c-.1.1.1.2.1.3s-.1-.2-.2-.2v.2h-.1a.3.3,0,0,0-.1.2h0c0,.1-.1.1-.1.3s.1.1,0,.2h-.1c-.1-.1,0-.2-.1-.2h-.1c.1.1,0,.1,0,.2h0c-.1-.1,0-.3-.1-.4h-.1c-.2,0-.2.2-.4.3a1.2,1.2,0,0,0,.2-.4l-.2.2.2-.3-.2-.4h.1s.1-.1.1-.1h0c-.1-.1-.1.1-.2,0l.4-.6A.7.7,0,0,1,378.2,562.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 562.7 378.3 562.7 378.3 562.7 378.3 562.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,563.4a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 563 378.3 562.9 378.3 562.9 378.3 563"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 562.9 378.4 562.9 378.4 562.9 378.4 562.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 563 378.4 563 378.4 563.1 378.4 563"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 563.1 378.4 563.1 378.4 563.1 378.4 563.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.5 563.2 378.5 563.1 378.5 563.1 378.5 563.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 563.2 378.3 563.2 378.3 563.2 378.3 563.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,563.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.6 563.2 378.6 563.1 378.6 563.1 378.6 563.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.3,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.5,563.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.3 563.5 377.3 563.5 377.3 563.5 377.3 563.5 377.3 563.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,563.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371,565c.1.1,0,.2.1.2H371a1.4,1.4,0,0,0-.1.4s0-.1-.1-.2h-.4c.2-.1.1-.4.2-.6s.2-.3.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,564.1h0S377,564.1,377.1,564.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.9,565l.5.3s0,.1,0,.1h-.1l-.5-.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.3h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,565.2c.1.1,0,.2,0,.2v.2c-.1,0-.1.1-.2,0h.2s-.1.1,0,.1h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1H374c0,.1-.1.1,0,.2h-.1c-.2-.1-.3.2-.5.2s-.1-.2-.1-.3h-.4l.4-.4s.1-.1,0-.1h.4l.2-.2c-.1-.1-.2.1-.3.1a.1.1,0,0,1,0-.1c0-.1.2-.1.1-.2s-.1-.1,0-.1l.4-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,565.5c-.1,0,0,0,0-.1S372.7,565.5,372.6,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.9,565.6a.2.2,0,0,1,0,.1h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,565.3c.1.1.1.3.1.4s-.1.2-.2.3h0s0,0,0-.1h0s.1-.1,0-.1h.1a.3.3,0,0,0,0-.3s0,.1,0,.1h-.1s0,.1,0,.1,0-.1,0-.1h0s0,.1,0,.1h0s0,0,0,0h0c-.1.1,0,.2,0,.3s0-.1,0-.1a.5.5,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.8 565.7 374.8 565.7 374.8 565.7 374.8 565.7 374.8 565.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,565.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.4h0S377.6,565.4,377.6,565.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,565.5h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.6 565.5 377.6 565.5 377.6 565.5 377.6 565.5 377.6 565.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.7 565.5 377.7 565.5 377.7 565.5 377.7 565.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.5 565.4 378.5 565.4 378.5 565.4 378.5 565.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,565.9a.3.3,0,0,1-.1.3V566h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,565.8c0,.2-.1.2-.1.3H377l-.2-.2a.2.2,0,0,1,0-.2c.1-.1.2,0,.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,565.8h0c0,.1,0,.2,0,.2h0s0,.1,0,.1H377s0-.1,0-.1,0-.1-.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,565.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.4 565.8 377.5 565.7 377.5 565.8 377.4 565.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.6 565.6 378.6 565.6 378.6 565.6 378.6 565.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.2,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,565.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.2 565.8 377.2 565.8 377.2 565.8 377.2 565.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.3 566 376.3 566 376.3 566 376.3 566"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.2 565.9 377.2 565.9 377.2 565.8 377.2 565.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.4 566 376.4 566 376.4 566 376.4 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.7,565.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.3,567.3c0,.1,0,.1,0,.2s-.2.2-.3.1h-.1c0-.1-.1-.2,0-.2S373.2,567.2,373.3,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,567c0,.1,0,.1,0,.2h-.3a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "373",
      "y": "567.8",
      "width": "7.9",
      "height": "4.05",
      "transform": "translate(-26.5 18.4) rotate(-2.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.4,572s-.2-.1-.2-.2-.1-.3-.2-.4,0-.1,0-.1h.1c.1-.1-.1-.2,0-.3s.1.2.2.2v-.2h.1v-.2h0c0-.1.1-.1.1-.2s0-.1,0-.2h.1c.1.1,0,.2.1.2h.1c0-.1,0-.1,0-.2h0c.1.1,0,.3.1.4h.1c.2,0,.2-.2.4-.2l-.2.3h.2l-.2.2v.4h-.1s-.1,0-.1.1h.2l-.5.5A.6.6,0,0,1,373.4,572Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.7 373.3 571.8 373.3 571.8 373.3 571.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,571.4a.1.1,0,0,1,.1-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.4 571.5 373.4 571.5 373.4 571.5 373.4 571.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.5 373.3 571.5 373.3 571.5 373.3 571.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.4 373.3 571.4 373.3 571.4 373.3 571.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.4 373.3 571.4 373.3 571.4 373.3 571.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.2 571.3 373.2 571.3 373.2 571.3 373.2 571.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.4 571.3 373.4 571.3 373.4 571.3 373.4 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,571.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.2 571.3 373.2 571.3 373.2 571.3 373.2 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.2,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.3,571.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.1,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.3,571.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.3 571.1 374.3 571.1 374.3 571.1 374.3 571.1 374.3 571.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,570.3c-.1-.1,0-.1,0-.2h.1l.2-.3s0,.1,0,.2h.4c-.2.1-.1.4-.3.5s-.2.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,570.2l-.4-.3s0-.1,0-.1h.1l.4.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.4h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,569.9c0-.1,0-.2,0-.2h.1c.1,0,.1-.1.2,0h.1l-.2-.2h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2.1.3-.2.4-.1s.1.2.1.3h.4l-.4.4s-.1.1,0,.1h-.4l-.2.2c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1s-.2.1-.1.2.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,569.7c.1,0,0,0,0,.1S378.8,569.7,378.8,569.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.8,569.4h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.5c-.1-.1,0-.2,0-.4s.1-.2.2-.2h-.1s0,0,0,.1h0s-.1.1,0,.1h-.1c.1,0,0,0,0,.1h0a.3.3,0,0,0,0,.2h.1s0-.1,0-.1,0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s0,.1,0,.1a.4.4,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.8 569.3 376.8 569.3 376.8 569.3 376.8 569.3 376.8 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,569.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.3h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.3 569.3 374.3 569.3 374.3 569.2 374.3 569.2 374.3 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,569.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.2 569.2 374.2 569.2 374.2 569.2 374.2 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.4 569.2 373.4 569.3 373.4 569.3 373.4 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,569.1a.3.3,0,0,1,.2-.2v.2H376Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,569c0-.1.1-.2.2-.3h.1v.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,569.1h0c0-.1.1-.2,0-.2h0s0-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.9,569h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.4 569 374.4 569 374.4 569 374.4 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.4 569.1 373.4 569.1 373.4 569.1 373.4 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.7,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.7,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.9,569h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 569 374.7 569 374.7 569 374.7 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.5 568.9 375.5 568.9 375.5 568.9 375.5 568.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 569 374.7 569 374.7 569 374.7 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 568.9 375.4 568.9 375.4 568.9 375.4 568.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.3,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,568c0-.1,0-.1,0-.2h.3c0,.1,0,.1,0,.2S378.5,568.1,378.4,568Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,568.1c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.3",
      "y": "573.4",
      "width": "7.9",
      "height": "4.04",
      "transform": "translate(-210 217.5) rotate(-25.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,572.1h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.2.1.3h-.2a.4.4,0,0,0,0,.2h.1s0,.1,0,.1h-.1a.3.3,0,0,0,0,.2h.1c0,.1-.1.2-.1.3v.2h-.1c-.1,0,0-.2-.2-.2h0v.2h0c-.1-.1-.1-.3-.2-.3h-.1c-.1,0-.1.2-.2.3a1.1,1.1,0,0,0,.1-.4l-.2.2v-.3l-.3-.3h0s.1-.1,0-.1h0c-.1-.1-.1.1-.2.1s.1-.4.2-.6S380.5,572.1,380.7,572.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 572.3 380.9 572.3 380.9 572.3 380.9 572.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,573.6a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 572.5 380.9 572.5 380.9 572.5 380.9 572.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 572.4 381 572.4 381 572.4 381 572.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 572.6 381 572.6 381 572.6 381 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.1 572.6 381.1 572.6 381.1 572.6 381.1 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 572.6 381.1 572.6 381.2 572.6 381.2 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 572.7 381 572.7 381 572.7 381 572.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,573.5h.3s0,0,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 572.6 381.2 572.6 381.2 572.6 381.2 572.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,573.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,573.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,573.5s0,0,0,0S379.4,573.5,379.4,573.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,573.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,572.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 573.2 380.2 573.2 380.2 573.3 380.2 573.3 380.2 573.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,573.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.1,576.3v.2c-.1,0,0,.1-.1.1a1.3,1.3,0,0,0,0,.4h-.3v.2c.1-.2,0-.4.1-.6s.1-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,573.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,573.9s0,.1,0,.1S380.1,573.9,380.1,573.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,573.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,576h.5s.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,574h0S380.1,574,380.1,574Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,574h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.9,575.5c.1.1,0,.2.1.2v.2c-.1,0-.1.1-.2.1s-.1.1,0,.1h.4s0,.1,0,.1h0a.1.1,0,0,0,.1.2h-.1s0,.1,0,.1h-.1c0,.1-.1.1,0,.1H378c-.2,0-.2.3-.4.3s-.2-.1-.2-.2h-.4c.1-.1.1-.4.3-.5s.1-.1,0-.1h.1l.2-.2V576c-.1-.1-.1.1-.2.1h0c0-.1.1-.1.1-.2s-.1,0-.1-.1a.3.3,0,0,1,.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,576.3c-.1,0,0,0,0-.1S376.6,576.2,376.6,576.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.6,575.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,575.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,574.7c.1.1.1.2.2.3s0,.2-.1.3,0-.1,0-.1h0s0-.1,0-.1h.1v-.2s0,0,0,.1H381c0,.1.1.1,0,.1s0-.1,0-.1h0s0,.1,0,.1h0c0,.1.1.2,0,.2s0-.1-.1-.1a.4.4,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.6 575.8 378.6 575.8 378.6 575.9 378.6 575.9 378.6 575.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,574.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,574.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,574.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.8,574.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,574.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,574.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 574.9 380.9 574.9 381 575 380.9 575 380.9 574.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,575h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.1 574.9 381.1 574.9 381.1 574.9 381.1 574.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.8 574.6 381.8 574.6 381.8 574.6 381.8 574.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,575.8a.3.3,0,0,1-.1.3l-.2-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,575.2c.1.1,0,.2,0,.3h-.3a.1.1,0,0,1,0-.2c0-.1.1,0,.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,575.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,575.3h0c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,575.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 575.2 380.9 575.2 380.9 575.2 380.9 575.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.8 574.8 381.8 574.7 381.8 574.7 381.8 574.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.7,575.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,576h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.7,575.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,575.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 575.3 380.7 575.3 380.7 575.3 380.7 575.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 575.7 380 575.7 380 575.7 380 575.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 575.4 380.7 575.4 380.7 575.3 380.7 575.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 575.7 380 575.7 380 575.7 380 575.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,575.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,577.7c.1,0,.1.1.1.2s-.1.2-.2.2h-.1c0-.1-.1-.1,0-.2S377.5,577.6,377.7,577.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,576.7c.1,0,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "382.5",
      "y": "572.3",
      "width": "7.4",
      "height": "3.8",
      "transform": "translate(-286.1 738) rotate(-69.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,570.3h.9s-.1,0-.1.1h.1v.2s0-.1,0-.1h0v.2h.1c.1,0,0,.2.1.2h.2s0,0,0,0h-.4s0,.1,0,.1h-.1c-.1.1.1.2,0,.4l-.2-.3c.1.1,0,.2,0,.2v-.3h-.4s0,.2-.1.2.1-.1.1-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.2-.4-.3-.6S385.5,570.5,385.6,570.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.8 570.4 385.8 570.4 385.8 570.4 385.8 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.3,572.6h-.1A.1.1,0,0,1,385.3,572.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 570.5 386 570.5 386 570.5 386 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 570.4 386 570.4 386.1 570.4 386.1 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 570.5 386.1 570.4 386.2 570.4 386.1 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 570.5 386.2 570.5 386.2 570.5 386.2 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.3 570.4 386.2 570.4 386.3 570.4 386.3 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 570.6 386.2 570.6 386.2 570.6 386.2 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,572.3v-.2h0v.3S385.5,572.3,385.6,572.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.3 570.4 386.3 570.4 386.3 570.4 386.3 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.1,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,570.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 571.5 386 571.5 386 571.5 386 571.5 386 571.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.6,576.9h.2c0,.1,0,.1,0,.2l.2.3h-.2c-.1,0-.1.1-.1.2s.1.1,0,.2-.3-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,571.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,571.6s0,0,0,0S386.5,571.6,386.5,571.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.9,576.2l.4-.3h0l-.4.2h-.1C384.8,576.3,384.9,576.2,384.9,576.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386,574.5h.2v.2c-.1,0,0,.1-.1.2s0,.1,0,.1h.8c-.1.2.1.3,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.1c.1-.1,0-.2,0-.3v-.2c-.1,0,0,.2-.1.2H386c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,575.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.6,574.2h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.6,574.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,571.9h.3c0,.1.1.2.1.3h-.1s0-.1,0-.1h-.2s0,.1,0,.1h.2a.4.4,0,0,1-.3-.3C387.4,572,387.5,572,387.5,571.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.6 574.3 386.6 574.3 386.7 574.3 386.7 574.3 386.6 574.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,572s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.6 572.1 387.6 572.1 387.7 572.1 387.7 572.1 387.6 572.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.7 572 387.7 572 387.7 572 387.7 572"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "388 571.3 388 571.3 388 571.3 388 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,573.7a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,572.4c.1,0,.1.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.8,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.8,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.6s0,0,0,0h.1s0,0,0,0h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.7s0,0,0,0S387.6,572.7,387.6,572.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.8 572.3 387.8 572.3 387.8 572.3 387.8 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "388.1 571.4 388.1 571.4 388.1 571.4 388.1 571.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.2,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.8 572.5 387.7 572.5 387.7 572.5 387.8 572.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 573.3 387.5 573.3 387.5 573.3 387.5 573.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.8 572.6 387.8 572.6 387.8 572.5 387.8 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 573.2 387.5 573.2 387.5 573.2 387.5 573.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.9,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,571.5h0S388.4,571.5,388.4,571.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,576.1h.2c0,.1.1.2,0,.3h-.3C387.1,576.3,387.1,576.1,387.2,576.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,574h.1a.2.2,0,0,1,0,.2H388A.1.1,0,0,1,388.1,574Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "389.4",
      "y": "565.6",
      "width": "3.3",
      "height": "6.37",
      "transform": "translate(-234.6 277.1) rotate(-30.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,567.1s0-.2,0-.2.2-.2.2-.3h.2s0,.1,0,.1h.2c0,.1-.1.1-.1.2h1l-.3.2h0l.3.2h-.4l-.2.2c0,.1.1.1,0,.2h-.4c0,.1.1.1.1.1h-.5C388.3,567.4,388.1,567.3,388.1,567.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 567 388.3 567 388.3 567 388.3 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,568.6h.1A.1.1,0,0,1,389.4,568.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.9 388.4 567 388.4 567 388.5 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.4 566.9 388.4 566.9 388.4 566.9 388.4 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.8 388.5 566.8 388.5 566.8 388.5 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.8 388.5 566.8 388.5 566.8 388.5 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.7 388.5 566.7 388.5 566.7 388.5 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.6 566.9 388.6 566.9 388.6 566.9 388.6 566.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,568.2V568h.1v.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.7 388.5 566.7 388.5 566.7 388.5 566.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389,567.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.7,566.7a0,0,0,0,1,0,0S388.7,566.7,388.7,566.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 567.5 389.1 567.5 389.1 567.5 389.1 567.5 389.1 567.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.1,567.3h0S389.1,567.3,389.1,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,571.3h.5c0,.1,0,.1.1.1h.1c-.2-.1-.3.1-.5,0s-.2,0-.2-.2S391.9,571.4,391.9,571.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.6,570.8a1,1,0,0,1,.1-.4h.1a2.5,2.5,0,0,0-.1.4s0,.1-.1.1S391.6,570.8,391.6,570.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,569.1h.3c0,.1.1,0,.1.1h.1c0-.1.1-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.4c0,.2.2.1.3.3h-.2c0,.1,0,.1,0,.1h0l-.4-.2h-.1a.2.2,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.1s0-.1,0-.2v-.2h-.2c0,.1.1.1.1.2h-.3l-.2-.2A.4.4,0,0,1,391.1,569.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.8,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,568.6h0A.1.1,0,0,1,391.2,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.3,568.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.2,566.7l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.3 568.6 391.3 568.6 391.3 568.6 391.3 568.6 391.3 568.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.7h0S390.3,566.7,390.3,566.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.4,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.4 566.7 390.4 566.7 390.4 566.7 390.4 566.7 390.4 566.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.4 566.6 390.4 566.6 390.4 566.6 390.4 566.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.1 566.1 390.1 566.1 390.1 566.1 390.1 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.4,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,567.9h0S391.1,567.9,391.2,567.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,566.9h.3v.2h-.2A.1.1,0,0,1,390.7,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.7,567h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.6 566.7 390.6 566.7 390.6 566.7 390.6 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.2 566 390.2 566 390.2 566 390.2 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.4,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.7 566.9 390.7 566.9 390.7 566.9 390.7 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.1 567.5 391.1 567.5 391.1 567.5 391.1 567.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.8 566.9 390.8 566.9 390.7 566.9 390.8 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.1 567.4 391.1 567.4 391.1 567.4 391.1 567.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.4,565.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.8,569.2h.1C392.9,569.4,392.8,569.3,392.8,569.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,567.5h.1A.1.1,0,0,1,391.9,567.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "393.5",
      "y": "566.8",
      "width": "3.5",
      "height": "6.82",
      "transform": "translate(-217.1 896.4) rotate(-83.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392,571.6s-.1-.1-.1-.2-.1-.3-.1-.4,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2v-.2h.1v-.2s0,0,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c0,.1,0,.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.4l-.2.3h.2l-.2.2a.7.7,0,0,0,.1.3h0l-.5.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571.4 391.9 571.4 391.9 571.4 391.9 571.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,571.4h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 571.2 392 571.2 392 571.2 392 571.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571.2 391.9 571.2 391.9 571.2 391.9 571.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 571.1 391.9 571.1 391.9 571.1 392 571.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571.1 391.9 571.1 391.9 571.1 391.9 571.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571 391.9 571 391.9 571 391.9 571"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 571 392 571 392 571 392 571"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,571.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 571 391.9 571 391.8 571 391.8 571"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,571.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392,570.9h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "392.9",
      "y": "571",
      "height": "0.01",
      "transform": "translate(-223.4 888.1) rotate(-82.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.8,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398,571.1c0-.1,0-.1,0-.2h.1l.2-.3s0,.1,0,.1h.3c-.2.1-.1.3-.3.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.8,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.9,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,570.9l-.3-.3s0-.1,0-.1h.1l.3.3s.1.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.6,570.3c0-.1.1-.1,0-.2h.4l-.2-.2h.1a.1.1,0,0,0,0-.1h.1s.1-.1,0-.1h.1c0-.1.1,0,.1-.1h0c.2.1.2-.1.4-.1s.1.2,0,.2h.1s0,.1,0,.1h.2l-.4.3s-.1.1-.1.1h.1s0,.1,0,.1h-.5a0,0,0,0,1,0,.1s-.2,0-.1.1.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,570.4s0,0,0,0S396.8,570.4,396.9,570.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,569.9h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.2,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.5c-.1-.1,0-.2,0-.3h.1s-.1,0,0,0H393s0,0,0,.1h0a.3.3,0,0,0,0,.2h.2s0,0,0,0h0c.1-.1,0-.2.1-.2s0,.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.3 569.8 395.2 569.8 395.3 569.8 395.3 569.8 395.3 569.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.2,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.1 569.4 393.1 569.4 393.1 569.4 393.1 569.4 393.1 569.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393 569.4 393 569.4 393 569.3 393 569.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "392.4 569.3 392.3 569.3 392.3 569.3 392.4 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.6,569.5l.2-.2a.3.3,0,0,1,.1.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.4,569.3c0-.1.1-.2.2-.2h.1v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.3h0c0-.1.1-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.2 569.2 393.2 569.2 393.2 569.2 393.2 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "392.4 569.1 392.4 569.1 392.4 569.1 392.4 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,569.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 569.2 393.5 569.2 393.4 569.2 393.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.2 569.3 394.2 569.3 394.2 569.3 394.2 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 569.2 393.5 569.2 393.5 569.2 393.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.1 569.3 394.1 569.3 394.1 569.3 394.1 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.8,568.9c0-.1,0-.1,0-.2h.3s0,.1-.1.2S396.8,569,396.8,568.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,568.6c0-.1,0-.1.1-.1h-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "397.3",
      "y": "565.1",
      "width": "3.7",
      "height": "7.26",
      "transform": "translate(-294.4 527.3) rotate(-51.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.5,568.1c0-.1-.1-.1,0-.2s.1-.3.2-.4h.1s0,.1.1.1.1-.2.2-.2-.1.2,0,.2h.7v-.2h.1c0,.1-.1.1-.1.2h.1V567h0c0,.1-.2.2-.2.3h0v.3c0,.1.1.1.1.1h-.3s0,0,0,0h-.2c0,.1.1,0,.1.1h-.6C395.7,568.3,395.5,568.2,395.5,568.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.6 567.9 395.5 567.9 395.5 567.9 395.6 567.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.5,569.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.8 395.7 567.8 395.7 567.8 395.7 567.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.6 567.7 395.6 567.7 395.6 567.7 395.6 567.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.6 395.7 567.6 395.7 567.6 395.7 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.6 395.7 567.6 395.7 567.6 395.7 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.5 395.7 567.5 395.7 567.5 395.7 567.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.8 567.6 395.8 567.6 395.8 567.6 395.8 567.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,568.7l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.5 395.7 567.5 395.7 567.5 395.7 567.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.2,568.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.2,568.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.1,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.9,567.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 568.1 396.6 568.1 396.6 568 396.6 568 396.6 568.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.6,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.2,571v-.2h.7c-.2,0-.3.2-.5.2s-.3,0-.3-.1S401.2,571.1,401.2,571Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.8,567.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.9,567.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.7,570.5a1.2,1.2,0,0,1-.1-.5h.1a2.9,2.9,0,0,0,.1.4s0,.1,0,.1S400.7,570.6,400.7,570.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.4,569v-.2h.2c0,.1.1,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.2,0,.2-.1.2.1.1.1.1h-.5v.2c0,.1-.1.1,0,.1h-.1c0-.1,0-.1,0-.2h-.5c0,.1.2,0,.2.1h-.2s0,.1-.1.1h-.3A.5.5,0,0,1,399.4,569Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.6,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.3,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399.4,568.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.5,566.8c0-.1.1-.2.2-.3h0c0,.1-.1,0,0,.1h0v.2h.1s.1.1,0,.1h.4s-.1,0-.1.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "399.4 568.3 399.4 568.3 399.4 568.3 399.4 568.3 399.4 568.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.6,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.7,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.7h0S397.6,566.7,397.6,566.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.7 566.8 397.7 566.8 397.7 566.7 397.7 566.7 397.7 566.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,566.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.7 566.7 397.6 566.7 397.6 566.6 397.7 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.1 566.2 397.1 566.2 397.1 566.2 397.1 566.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399,567.7h.3a.3.3,0,0,1-.1.2h-.1S399,567.7,399,567.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398,566.8h.3a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,398,566.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.7,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.9h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.3,566.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.9 566.7 397.9 566.7 397.9 566.7 397.9 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.2 566.1 397.2 566.1 397.2 566.1 397.2 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.8h0S398.2,566.8,398.2,566.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.1,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.3,566.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "398.1 566.8 398.1 566.8 398.1 566.8 398.1 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.7 567.3 398.7 567.3 398.7 567.3 398.7 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "398.2 566.8 398.2 566.8 398.1 566.8 398.2 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.7 567.2 398.7 567.2 398.7 567.2 398.7 567.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.9,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.3,568.4h.2C401.4,568.6,401.3,568.5,401.3,568.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.6,566.9h.3s0,.1,0,.1h-.1C399.6,567.1,399.5,567,399.6,566.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "400.3",
      "y": "568.8",
      "width": "7.4",
      "height": "3.81",
      "transform": "translate(-226 267.4) rotate(-29)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,574h-.2c-.2,0-.2-.2-.3-.3s0-.1,0-.1h0c0-.1-.1-.2-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.3.3,0,0,0,0-.2h-.1c0-.1.1-.2,0-.2v-.2h.2v-.2h0c.1.1.1.3.2.3h.1c.1-.1.1-.2.2-.3a1,1,0,0,0,0,.4v.1l.3.3h0c0,.1-.1.1-.1.1h0s-.1.1,0,.1h0c.1.1.1-.1.1-.1s-.1.4-.2.6S402.1,574,401.9,574Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 573.8 401.7 573.8 401.7 573.8 401.7 573.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,572.5a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 573.6 401.7 573.6 401.7 573.6 401.7 573.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.6 573.7 401.6 573.7 401.6 573.7 401.6 573.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.6 573.6 401.6 573.6 401.6 573.6 401.6 573.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.5 573.5 401.5 573.5 401.5 573.5 401.5 573.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.4 573.5 401.5 573.5 401.4 573.5 401.4 573.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.6 573.4 401.6 573.4 401.6 573.4 401.6 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,572.5H403s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.4 573.5 401.4 573.5 401.4 573.5 401.4 573.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.1,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.1,572.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.2,573h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.4,573.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.3 572.9 402.3 572.9 402.3 572.8 402.3 572.8 402.3 572.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.2,572.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.9,569.7v-.2c.1,0,0-.1.1-.1a1.2,1.2,0,0,0,0-.4h.3v-.2c-.1.2.1.4,0,.5s-.1.3-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,572.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.3,572.3s0,0,0-.1S402.4,572.3,402.3,572.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,572.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,570h-.5s-.1,0,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.1h0S402.3,572.2,402.4,572.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.3,570.6v-.2a.3.3,0,0,1,.1-.2c.1,0,.1-.1.1-.1s.1-.1,0-.1h-.2s0,0,0-.1h-.2s0-.1,0-.1h0s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.1-.3.3-.3l.2.2h.4c-.1.1-.1.3-.2.5s0,.1,0,.1h-.1l-.2.2v.2c.1,0,.1-.1.2-.1h0c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.5,569.8c.1,0,0,0,0,0S405.5,569.8,405.5,569.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.5c-.1,0-.1-.2-.2-.3s0-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h0v.2s0,0,0-.1h0c0-.1-.1,0,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.4.4,0,0,1,.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.7 570.3 403.7 570.3 403.7 570.3 403.7 570.3 403.7 570.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.5,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.6,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.4,571.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.5 571.3 401.5 571.3 401.5 571.3 401.5 571.3 401.5 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.6,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.6,571.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.4 571.3 401.4 571.4 401.4 571.3 401.4 571.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "400.8 571.7 400.8 571.7 400.7 571.7 400.8 571.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.9,570.4a.2.2,0,0,1,0-.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,571c-.1-.1,0-.2,0-.3h.3a.1.1,0,0,1,0,.1c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.4,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.8,571h0s0-.2-.1-.1h0s0,0,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,570.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.5 571.1 401.5 571.1 401.5 571.1 401.5 571.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "400.7 571.5 400.7 571.6 400.7 571.6 400.7 571.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.8,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.8,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.7,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,570.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 570.9 401.7 570.9 401.7 570.9 401.7 570.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.4 570.5 402.4 570.6 402.4 570.6 402.4 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 570.9 401.7 570.9 401.7 570.9 401.7 570.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.3 570.5 402.3 570.6 402.3 570.6 402.3 570.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.4,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.5,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.4,568.5v-.2c0-.1.1-.2.2-.2h.1c0,.1.1.1.1.2S404.6,568.6,404.4,568.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,569.6c-.1,0,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "405",
      "y": "568.2",
      "width": "7",
      "height": "3.59",
      "transform": "translate(-221 260.9) rotate(-28.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.5,567h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.1.1.2h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,0,.2h0c0,.1-.1.1,0,.2h-.1v.2h0c-.1-.1-.1-.3-.2-.3h-.1c-.1,0-.1.2-.2.3a1,1,0,0,0,0-.3v-.1l-.2-.2h0s.1-.1,0-.1h-.2c.1-.2.1-.4.2-.6S410.3,566.9,410.5,567Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 567.1 410.6 567.1 410.6 567.1 410.6 567.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,568.3a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 567.3 410.6 567.3 410.6 567.3 410.6 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 567.3 410.7 567.2 410.7 567.2 410.8 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 567.4 410.8 567.3 410.8 567.4 410.8 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 567.4 410.8 567.4 410.8 567.4 410.8 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.9 567.4 410.9 567.4 410.9 567.4 410.9 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 567.5 410.7 567.5 410.7 567.5 410.7 567.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,568.3h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.9 567.4 410.9 567.4 410.9 567.4 410.9 567.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.9,567.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 568 410 568 410.1 568 410.1 568 410 568"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,570.9v.2h-.1a1.1,1.1,0,0,0,0,.3h-.3v.2c.1-.2-.1-.3,0-.5s.1-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.6s0,0,0,.1S410,568.6,410,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.3,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,570.7h.5s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.7h0S410,568.7,410,568.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,570.1v.4c-.1,0-.1.1-.1.1s-.1.1,0,.1h.2s0,0,0,.1h.1s0,.1,0,.1h0s0,.1,0,.1h-.1s-.1.1,0,.1h-.1c-.2,0-.1.2-.3.3v-.2h-.4c.1-.1.1-.3.2-.5s0-.1,0-.1h0l.2-.2v-.2c-.1,0-.1.1-.2.1h0c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,570.8c-.1,0,0,0,0,0S407,570.8,407,570.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.3c.1,0,.1.2.2.3s0,.2-.1.2,0-.1,0-.1h0s0-.1,0-.1h0v-.2s0,0,0,.1h0c0,.1.1,0,0,.1s0,0,0-.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "408.7 570.4 408.7 570.4 408.7 570.4 408.7 570.4 408.7 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.8,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.7,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.9,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.8 569.5 410.8 569.5 410.8 569.5 410.8 569.5 410.8 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.7,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.7,569.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.9 569.5 410.9 569.4 410.9 569.4 410.9 569.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.5 569.1 411.5 569.1 411.5 569.1 411.5 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.5,570.3a.2.2,0,0,1,0,.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.6,569.7c.1.1,0,.2,0,.3h-.2a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.9,569.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,569.8h0s0,.2.1.1h0s0,0,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,569.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.8 569.7 410.8 569.7 410.8 569.7 410.8 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.6 569.3 411.6 569.3 411.6 569.3 411.6 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,569.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 569.8 410.6 569.8 410.6 569.8 410.6 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410 570.2 410 570.2 410 570.2 410 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 569.9 410.6 569.8 410.6 569.8 410.6 569.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410 570.2 410 570.2 410 570.2 410 570.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,572h.1c0,.1-.1.2-.2.2h-.1s-.1-.1-.1-.2S407.9,572,408,572Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.9,571.1c.1,0,0,.1,0,.1h-.2a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "410.7",
      "y": "568.8",
      "width": "6.2",
      "height": "3.17",
      "transform": "matrix(0.96, -0.28, 0.28, 0.96, -144.55, 140.47)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.5,572.7h-.2c-.1-.1-.1-.2-.2-.3s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1v-.2h0a.2.2,0,0,0,0-.2h0c0-.1.1-.1.1-.2h.1c.1.1,0,.2.1.3h.1l.2-.2a.9.9,0,0,0-.1.3h.2v.2l.2.3h0s-.1.1,0,.1h.1l-.3.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.4 572.5 411.4 572.6 411.4 572.6 411.4 572.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.2,571.8a.1.1,0,0,1,0-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.4 572.4 411.4 572.4 411.4 572.4 411.4 572.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.3 572.4 411.3 572.4 411.3 572.4 411.3 572.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.3 572.3 411.3 572.3 411.3 572.3 411.3 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.3 572.3 411.3 572.3 411.3 572.3 411.3 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.2 572.2 411.2 572.3 411.2 572.3 411.2 572.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.4 572.2 411.4 572.2 411.4 572.2 411.4 572.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,571.8h-.2s0,0,0,0h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.2 572.2 411.2 572.3 411.2 572.3 411.2 572.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,571.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,571.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,571.8s0,0,0,0S412.7,571.8,412.7,571.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,571.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.2,572.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.1 571.9 412.1 571.9 412.1 571.9 412.1 571.9 412.1 571.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,571.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,570.2V570h.1a1,1,0,0,0,.1-.3h.3c-.1.1,0,.3-.1.4s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.8,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.4s0,0,0-.1S412.2,571.4,412.2,571.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.8,570.3l-.4-.2s0,0,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.1,570.4c0-.1,0-.1,0-.2h0s0,0,0-.1h0a.1.1,0,0,0,0-.1h.1s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.2-.2.3-.2s.1.1.1.2h.3l-.3.4s-.1.1,0,.1h-.3v.2h.2s-.1.1-.1.2.1,0,0,.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.2,570c.1,0,0,0,0,0S415.2,570,415.2,570Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.6,570.1a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M413.6,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.7c-.1-.1-.1-.2-.1-.3s.1-.1.1-.2,0,0,0,.1h0s0,.1,0,0h-.1a.2.2,0,0,0,.1.2s0,0,0-.1h0s0,0,0-.1,0,0,0,.1h0s0,0,0-.1h0c0-.1-.1-.1,0-.2s0,.1,0,.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "413.6 570.1 413.6 570.1 413.6 570.1 413.6 570.1 413.6 570.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.7,570.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.8,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.5h0S411.6,570.5,411.6,570.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.7 570.5 411.7 570.5 411.7 570.5 411.7 570.5 411.7 570.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.8,570.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.6 570.5 411.6 570.5 411.6 570.5 411.6 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411 570.6 411 570.7 411 570.7 411 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413,570a.2.2,0,0,1,.1-.2H413Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.9,570.3c0-.1,0-.2.1-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412,570.2h0s0-.1,0-.1h0s0,0,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.1,570.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.7 570.3 411.7 570.3 411.7 570.3 411.7 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411 570.5 411 570.5 411 570.5 411 570.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M413.1,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.1,570.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.9 570.2 411.9 570.2 411.9 570.2 411.9 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.5 570 412.5 570 412.5 570 412.5 570"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.9 570.2 411.9 570.2 411.9 570.2 411.9 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.5 570 412.5 570 412.5 570 412.5 570"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.6,568.8s0-.1,0-.1h.3s.1.1,0,.2S414.6,568.8,414.6,568.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.7,569.3s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "407.3",
      "y": "559",
      "width": "3.7",
      "height": "7.17",
      "transform": "translate(-158.1 160) rotate(-18.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,560c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1h.3c0,.1-.1.1-.1.2h1l-.3.2h0c0,.1.2.1.3.3h-.3l.2.2-.3-.2-.3.2c0,.1.1.1,0,.2s0-.1-.1-.2h-.3c-.1.1.1.1.1.1l-.5-.3C406.5,560.3,406.4,560.2,406.4,560Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.6 559.9 406.6 559.9 406.6 559.9 406.6 559.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,562h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,407.5,562Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.8 559.9 406.8 559.9 406.8 559.9 406.8 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.8 559.8 406.7 559.8 406.8 559.8 406.8 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.8 406.9 559.8 406.9 559.8 406.9 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.8 406.9 559.8 406.9 559.8 406.9 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.7 406.9 559.7 406.9 559.7 406.9 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407 559.8 407 559.9 407 559.9 407 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.6,561.5v-.3h.1c0,.1.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.6 406.9 559.7 406.9 559.7 406.9 559.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.5,561.4h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,561.5h0S407.6,561.5,407.6,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.5,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.1,559.7h0S407.1,559.7,407.1,559.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.4 560.6 407.4 560.6 407.4 560.6 407.4 560.6 407.4 560.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.6,565.5h.5c0,.1,0,.1.1.2h.1c-.1-.2-.3,0-.5-.1s-.2-.1-.2-.2S409.6,565.6,409.6,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.9,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.4,564.9a1.2,1.2,0,0,1,.2-.5h.1s0,.1,0,.1l-.2.4h-.1C409.3,565,409.4,564.9,409.4,564.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.1,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.1,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,562.9h.4c0,.1.1.1,0,.2h.1c0-.1.1-.1.1-.2h.3c.1,0,0-.1,0-.1h.3s0,0,0,.1h.1c0,.2.2.2.2.4h-.2c-.1.1,0,.1,0,.2h-.1c.1,0,0,.1.1.2l-.4-.3H410v.2h-.1s0-.1,0-.2v-.4h-.2c-.1.1.1.1.1.2h-.3a.3.3,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.5,562.3h0A.1.1,0,0,1,409.5,562.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.5,562.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,560.1h.3s0,0,0,0h-.1c-.1,0,0,.1-.1.1h.1s0-.1,0-.1h-.1C408.8,560.2,408.8,560.1,408.8,560.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.6 562.4 409.6 562.4 409.6 562.4 409.6 562.4 409.6 562.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409 560.1 409 560.1 409 560.1 409 560.1 409 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.1,560.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409 560 409 560 409 560 409 560"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.8 559.4 408.8 559.4 408.8 559.3 408.8 559.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,560.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.6,561.6h0C409.6,561.7,409.5,561.6,409.6,561.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,560.3h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.2A.1.1,0,0,1,409.3,560.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.1,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.1,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.5h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.2 560.2 409.2 560.2 409.2 560.2 409.2 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.9 559.3 408.9 559.3 408.9 559.3 408.9 559.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,560.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.3 560.4 409.3 560.4 409.3 560.4 409.3 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.6 561.1 409.6 561.1 409.6 561.1 409.6 561.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.4 560.4 409.3 560.4 409.3 560.4 409.4 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.6 561 409.6 561 409.6 561 409.6 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.1,563.4h.2c.1.1.2.1.2.2h-.2C411.1,563.6,411,563.5,411.1,563.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.4,561.3h0A.1.1,0,0,1,410.4,561.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "418.7",
      "y": "554",
      "width": "3.1",
      "height": "6.1",
      "transform": "translate(-210.1 856.4) rotate(-78.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,558s-.1-.1-.1-.2,0-.2,0-.4,0-.1,0-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.2s0,.1.1.2h.3s0,0,0-.1h.2c0-.1,0-.1,0-.2h.1c0,.1,0,.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.2,0,.3h.4l-.2.2h0a.7.7,0,0,0,0,.3h-.1l-.4.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.8 417.2 557.8 417.2 557.8 417.3 557.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M419.1,558h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.7 417.3 557.7 417.3 557.7 417.3 557.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.2 557.6 417.2 557.7 417.2 557.7 417.2 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.6 417.3 557.6 417.3 557.6 417.3 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.5 417.3 557.6 417.3 557.5 417.3 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.2 557.5 417.2 557.5 417.2 557.5 417.2 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.4 557.5 417.4 557.5 417.4 557.5 417.4 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.8,557.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.2 557.5 417.2 557.5 417.2 557.5 417.2 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,557.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.7,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418,557.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.1 557.5 418.1 557.5 418.1 557.5 418.1 557.5 418.1 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M422.7,558.1c0-.1,0-.1,0-.2h.1l.2-.2s0,.1,0,.1h.3c-.2,0-.1.3-.3.3h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.1,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.2,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M422.1,557.9l-.3-.3h.1l.2.3s.1.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M420.6,557.2c0-.1.1-.1,0-.2h.3v-.2h.1a.1.1,0,0,0,0-.1h.2c0-.1.1,0,.1-.1h.4c0,.1,0,.1,0,.2h.1s0,.1,0,.1h.2l-.4.2h0s0,.1,0,.1h-.4a0,0,0,0,1,0,.1H421s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M421.7,557.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M420.3,556.7h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M420.3,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,556.3c-.1-.1,0-.2,0-.3h0s0,0,0,.1h0a.2.2,0,0,0,0,.2h.2c.1,0,0-.1.1-.2s-.1.1,0,.1a.3.3,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "420.3 556.7 420.3 556.7 420.3 556.7 420.3 556.7 420.3 556.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.4,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.5,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "418.4 556.2 418.4 556.2 418.4 556.1 418.4 556.1 418.4 556.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.5,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.5,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "418.4 556.1 418.3 556.1 418.3 556.1 418.4 556.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.8 556 417.8 556 417.8 556 417.8 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M419.8,556.3h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.7,556.1c0-.1.1-.1.2-.2h.1v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556.1h0s.1-.1,0-.1h0s0,0,0,0h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "418.6 556 418.6 556 418.6 556 418.6 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.8 555.8 417.8 555.9 417.8 555.9 417.8 555.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M419.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.8 556 418.8 556 418.8 556 418.8 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "419.4 556.1 419.4 556.2 419.4 556.1 419.4 556.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.8 556 418.8 556 418.8 556 418.8 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "419.4 556.1 419.4 556.1 419.4 556.1 419.4 556.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M421.7,556s0-.1,0-.1h.3s0,.1-.1.1S421.8,556.1,421.7,556Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M419.9,555.6h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "407.9",
      "y": "553.7",
      "width": "8",
      "height": "4.09",
      "transform": "translate(-156.8 949.6) rotate(-88.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,552s.1-.2.2-.2.3-.1.5-.1h.2s-.1,0,0,.1h.3c0,.1-.2,0-.2.1h.2s0-.1,0-.1h0a.4.4,0,0,1,0,.2h.3l.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0h-.4s0,0,0,.1h-.1c0,.2.2.2.2.4l-.3-.2c.1.1.1.2.1.2l-.2-.3h-.4c0,.1,0,.2-.1.2s0-.1,0-.2h-.3c-.1.1,0,.1,0,.2l-.5-.5A.7.7,0,0,1,410,552Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.2 552 410.2 552 410.2 552 410.2 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.4,554.5h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,410.4,554.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 552.1 410.4 552 410.4 552.1 410.4 552.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 551.9 410.4 551.9 410.4 551.9 410.4 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 552 410.6 552 410.6 552 410.6 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 552 410.6 552 410.6 552 410.6 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 551.9 410.6 551.9 410.7 551.9 410.7 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 552 410.6 552.1 410.6 552.1 410.7 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.6,554a.9.9,0,0,1,0-.3h.1c0,.1,0,.2-.1.3S410.6,554.1,410.6,554Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 551.8 410.7 551.8 410.7 551.8 410.7 551.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,553.9h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.8,552.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 553 410.8 553 410.8 553 410.8 553 410.8 553"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.9,552.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.1,559h.2c0,.1.1.1.1.2l.3.2h-.2c-.1.1,0,.1,0,.2s.1.1.1.2-.4-.1-.5-.3-.2-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.3,552.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,558.3l.3-.4h0l-.3.4h-.1C411.1,558.3,411.2,558.3,411.3,558.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.4,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.4,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.4,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,556.1h.2v.2c-.1.1.1.1,0,.2h.1l.2-.2h.4s0,.1,0,.1h.2s0,.1,0,.1h.1s0,0,0,.1h.1c-.1.2.2.3.1.5H413c-.1,0,0,.1,0,.2h-.1c.1.1,0,.1,0,.2s-.3-.3-.3-.5h-.1v.2h-.1c0-.1.1-.1,0-.2h.1c0-.1,0-.2,0-.3l-.2-.2c-.1.1.1.2,0,.3H412c0-.1-.1-.2-.2-.1h-.1a.3.3,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.3,555.7h0S412.3,555.7,412.3,555.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.5,553h.4c0,.1.2.1.2.2h-.3s0,0,0,0h-.2s0-.1,0-.1h0s0,.1,0,.1h.2l-.4-.2C412.4,553.1,412.5,553.1,412.5,553Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.4 555.7 412.4 555.7 412.4 555.7 412.4 555.7 412.4 555.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.5,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.6,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.6 553.2 412.6 553.1 412.7 553.1 412.7 553.2 412.6 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,553.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.7 553 412.7 553 412.7 553 412.7 553"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.7 552.3 412.7 552.2 412.7 552.2 412.7 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.7,553.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.7,554.9l.2.2h-.3C412.6,555,412.6,554.9,412.7,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,553.4c.1,0,.2.1.3.2s0,0,0,.1h-.3c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,553.6s0,0,0,0h.2s0,0,0,.1h0s0,0,0,0h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,553.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 553.3 412.9 553.3 412.9 553.3 412.9 553.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 552.2 412.9 552.3 412.9 552.2 412.9 552.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.9 553.5 412.9 553.5 412.9 553.5 412.9 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 554.4 412.9 554.4 412.9 554.4 412.9 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.9 553.6 412.9 553.6 412.9 553.5 412.9 553.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 554.3 412.9 554.3 412.9 554.3 412.9 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.9,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.2,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.6,557.4h.2c.1.1.1.2.1.3h-.3C413.5,557.6,413.5,557.4,413.6,557.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.7,554.9h.2a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,413.7,554.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "413.8",
      "y": "545",
      "width": "4.4",
      "height": "8.67",
      "transform": "translate(-247.6 363.6) rotate(-37.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M420.2,551.2c0,.1.1.2,0,.3s-.2.3-.3.4h-.2c-.1,0,0-.1,0-.1s-.2.2-.3.2.1-.2.1-.2h-1.2c0-.1.2-.1.1-.2h-.3c.1-.1.3-.2.3-.3h0c-.1-.1-.3-.1-.4-.2h.5l.2-.3c0-.1-.2-.1-.1-.2v.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1-.1-.1-.1h.7C420,550.9,420.1,551,420.2,551.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "420 551.4 420 551.4 420 551.4 420 551.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.2,549.4H418v-.2h.1C418.1,549.2,418.2,549.4,418.2,549.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.8 551.5 419.8 551.5 419.8 551.5 419.8 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.9 551.6 419.9 551.6 419.9 551.6 419.9 551.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.7 419.7 551.7 419.7 551.7 419.7 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.7 419.7 551.7 419.7 551.7 419.7 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.8 419.7 551.8 419.7 551.8 419.7 551.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.6 551.7 419.6 551.6 419.6 551.7 419.6 551.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,550l.2.3h-.1l-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.9 419.7 551.9 419.7 551.9 419.7 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.4,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,551s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M419.5,551.9h0S419.5,551.9,419.5,551.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.8 550.9 418.8 550.9 418.8 550.9 418.8 550.9 418.8 550.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,551.1h0S418.8,551.1,418.8,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.4,546.1l-.2.2h-.5c0-.1-.1-.1-.1-.2h-.2c.2.1.4-.1.6-.1s.3,0,.3.2S414.4,546.1,414.4,546.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.1,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.1,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.8,546.9a1.4,1.4,0,0,1,0,.6h-.1a3.3,3.3,0,0,0,0-.5s0-.1.1-.1S414.9,546.8,414.8,546.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,549h-.4c0-.1-.2,0-.1-.2h-.1c0,.1-.1.2,0,.3h-.1c-.1,0,0,.1,0,.1h-.2c0,.1,0,.1,0,.1h-.4c-.1,0,0-.1,0-.1h-.2s0-.1,0-.1-.3-.1-.4-.3l.2-.2c0-.1,0-.1-.1-.2h.1l-.2-.2.6.2h.1a.3.3,0,0,0,0-.2h.1c.1,0,0,.1.1.2s0,.1,0,.2l.2.2h.3c0-.1-.2-.1-.2-.2h.1c.1,0,.2.1.2,0h.1a.4.4,0,0,1,.3.2A.6.6,0,0,1,415.9,549Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.8,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,549.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.7,549.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.4,552.1c0,.2-.2.2-.3.3h0c0-.1.1,0,0-.1h0l.2-.2h-.1c.1,0-.1-.1,0-.1h-.1c0,.1.1.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.7 549.8 415.7 549.8 415.6 549.8 415.6 549.8 415.7 549.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.1h0S417.3,552.1,417.3,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.2 552.1 417.2 552.1 417.1 552.1 417.1 552.1 417.2 552.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.1,552h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.2 552.2 417.2 552.2 417.2 552.3 417.2 552.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.7 552.9 417.7 552.9 417.7 552.9 417.7 552.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,550.7h-.3v-.2h.1C415.9,550.6,416,550.6,415.9,550.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,552c-.1.1-.2,0-.4,0h0a.3.3,0,0,0,.1-.2h.2c.1,0,0,.2.2.1A.1.1,0,0,1,416.8,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.1,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,551.8h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.9 552.1 416.9 552.1 416.9 552.2 416.9 552.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.6 553 417.6 553 417.6 553 417.6 553"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.9h0S416.6,551.9,416.6,551.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.7,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.7 552 416.7 551.9 416.7 551.9 416.7 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.1 551.2 416.1 551.2 416.1 551.2 416.1 551.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.6 551.9 416.7 551.9 416.7 551.9 416.6 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.1 551.3 416.2 551.3 416.1 551.3 416.1 551.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,553.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.5,549.2h-.2c-.1,0-.2,0-.2-.2h.2C413.4,548.9,413.5,549.1,413.5,549.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.1,551.4h-.3s0-.1,0-.1h.2A.2.2,0,0,1,415.1,551.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "408.4",
      "y": "544.5",
      "width": "8.3",
      "height": "4.27",
      "transform": "translate(-207.4 255.6) rotate(-27.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.1,550.3h-.2c-.2,0-.2-.2-.4-.3s0-.1,0-.1h0c0-.1-.1-.2-.2-.3h.2a.5.5,0,0,0,0-.2h-.1s0-.1,0-.1h.1a.3.3,0,0,0,0-.3h-.1c0-.1.1-.2,0-.3v-.2h.1c.1,0,.1.2.2.2h0v-.2h0c.1.1.1.3.3.3h.1c.2-.1.1-.3.2-.4a1.2,1.2,0,0,0,0,.4l.2-.2v.3l.3.3h0c0,.1-.1.1-.1.2h0s-.1.1,0,.1h0c.1.1.1-.1.2-.1s-.1.5-.2.7S410.3,550.3,410.1,550.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 550.1 410 550.1 410 550.1 410 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,548.7a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.9 549.9 409.9 549.9 409.9 549.9 409.9 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.9 409.8 549.9 409.8 549.9 409.8 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.8 409.8 549.8 409.8 549.8 409.8 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.8 409.8 549.8 409.8 549.8 409.8 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.7 549.7 409.7 549.8 409.7 549.8 409.7 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.7 409.8 549.7 409.8 549.7 409.8 549.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,548.7h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.6 549.8 409.6 549.8 409.6 549.8 409.6 549.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.5,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.6,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.4,548.8h0S411.5,548.7,411.4,548.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,549.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 549 410.7 549 410.6 549 410.6 549 410.7 549"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,545.6v-.2c.1,0,0-.1.1-.2a1.4,1.4,0,0,0,0-.4h.3c0-.1,0-.2.1-.2s.1.4,0,.6-.1.3-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.3,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.4s0-.1,0-.1S410.7,548.4,410.7,548.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.1,545.9h-.5s-.1-.1,0-.1h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.2h0S410.7,548.3,410.7,548.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.9,546.5c-.1-.1,0-.2-.1-.2a.3.3,0,0,1,.1-.2c.1,0,.1-.2.2-.1s.1-.1,0-.1h-.3s0,0,0-.1h-.2s0-.1,0-.1h0a.1.1,0,0,0-.1-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.3.4-.3s.2.1.2.2h.4c-.1.1-.1.4-.2.5s0,.1,0,.1h-.1l-.2.2v.3c.1.1.1-.2.2-.2h.1c0,.1-.1.1-.1.2s.1,0,.1.1a.3.3,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.3,545.7c.1,0,0,0,0,.1S414.3,545.7,414.3,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.3,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.5c-.1-.1-.1-.2-.2-.3s0-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h-.1v.2s0,0,0-.1h.1c0-.1-.1-.1,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.2-.1-.3s0,.1.1.1a.5.5,0,0,1,.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.3 546.2 412.2 546.2 412.2 546.2 412.2 546.2 412.3 546.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.9,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.8 547.3 409.8 547.3 409.8 547.3 409.8 547.3 409.8 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.9,547.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.7 547.3 409.7 547.3 409.6 547.3 409.7 547.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.9 547.7 408.9 547.7 408.9 547.7 408.9 547.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,546.3a.3.3,0,0,1,0-.3l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,547c-.1-.1,0-.2,0-.4h.3a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.6,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.9h0c0-.1,0-.2-.1-.2h0s-.1-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.8 547 409.8 547 409.8 547 409.8 547"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.8 547.5 408.9 547.5 408.8 547.5 408.8 547.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.1,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.1,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.5,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 546.9 410 546.9 410 546.9 410 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.8 546.4 410.8 546.5 410.8 546.5 410.8 546.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 546.8 410 546.8 410 546.9 410 546.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.7 546.4 410.7 546.5 410.7 546.5 410.7 546.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.6,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.1,544.2c-.1,0-.1-.1-.1-.2s.1-.2.2-.2h.1c0,.1.1.1.1.2S413.3,544.3,413.1,544.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,545.4c-.1,0,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "414.1",
      "y": "537.8",
      "width": "3.9",
      "height": "7.65",
      "transform": "translate(-46.8 39.4) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,544.9s0,.2-.1.2-.3.1-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.1h-.8s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.2-.2-.2-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.3c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1,0-.1,0-.2l.5.4A.6.6,0,0,1,418.3,544.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.1 545 418.1 545 418.1 545 418.1 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.6,542.6h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,417.6,542.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.8 544.9 417.9 544.9 417.8 544.9 417.8 544.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.8 545.1 417.9 545.1 417.9 545.1 417.8 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.7 545 417.7 545 417.7 545 417.7 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.7 545.1 417.7 545 417.7 545.1 417.7 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.6 545.1 417.7 545.1 417.7 545.1 417.6 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.6 545 417.6 545 417.6 545 417.6 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.4,543.1a.8.8,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.6 545.2 417.6 545.2 417.6 545.2 417.6 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,543.2h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.5,545.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.4 544 417.4 544 417.4 544 417.4 544 417.4 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,538.4h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2v-.2c.1.2.4.1.5.2s.2.2.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.9,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.9,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.3,539.1l-.3.4H416s0-.1,0-.1l.3-.4h.1C416.5,539,416.4,539.1,416.3,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.1,541.2h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1h-.1c.1-.2-.2-.2-.2-.4h.2c.1,0,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2h-.1c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1,0-.3h.1s.1.2.2.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.6,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.6,541.7h0S415.7,541.7,415.6,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.8,544.3h-.4c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C415.8,544.1,415.8,544.2,415.8,544.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.6 541.7 415.6 541.7 415.6 541.7 415.6 541.7 415.6 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.8,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.7,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.6,544.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 544.2 415.6 544.2 415.6 544.2 415.6 544.2 415.6 544.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.6,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.6,544.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 544.3 415.6 544.3 415.6 544.3 415.6 544.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 545 415.7 545 415.7 545 415.6 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.6,544.1s0,0,0,0S415.6,544.1,415.6,544.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.3,542.5h.1C415.4,542.4,415.4,542.5,415.3,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.4,543.9h-.3s0,0,0-.1h.3c.1.1,0,.1.1.2A.1.1,0,0,1,415.4,543.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.5,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.5,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.4,543.7h-.1s0,0,0,0h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.4,543.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.4 544 415.4 544.1 415.4 544.1 415.4 544"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.5 545 415.5 545 415.5 545 415.5 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.2,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.4,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.3 543.8 415.3 543.8 415.3 543.8 415.3 543.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.2 543 415.3 543 415.3 543 415.2 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.3 543.8 415.3 543.8 415.3 543.8 415.3 543.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.2 543.1 415.3 543.1 415.2 543.1 415.2 543.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.3,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.2,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.2,540.3H414c-.1-.1-.2-.1-.1-.2h.3C414.3,540,414.3,540.2,414.2,540.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.4,542.6h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,414.4,542.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "413.1",
      "y": "534.7",
      "width": "3.6",
      "height": "6.99",
      "transform": "translate(-250.1 678.1) rotate(-64.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,538c0,.1.1.1.1.2s0,.3-.1.4h-.1s0,.1,0,.1h-.1c-.1,0,0,.2-.1.3s0-.2,0-.2h-.4s0,0,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1v.2h0c0-.1.2-.2.1-.3h-.1a.1.1,0,0,0,0-.1H417l.3-.2h.1a.8.8,0,0,0,.1-.3h.1l.6-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.5 538.2 418.5 538.2 418.5 538.2 418.5 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,537.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.3 538.4 418.4 538.4 418.4 538.4 418.3 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.5 538.4 418.5 538.4 418.5 538.4 418.5 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.5 418.4 538.5 418.4 538.5 418.4 538.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.5 418.4 538.5 418.4 538.5 418.4 538.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.6 418.4 538.6 418.4 538.6 418.4 538.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.3 538.6 418.3 538.5 418.3 538.5 418.3 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,537.8h.2l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.7 418.4 538.6 418.4 538.6 418.4 538.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.8,537.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.8,537.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.9,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.6,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,538.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.4 538.3 417.4 538.3 417.4 538.3 417.4 538.3 417.4 538.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.5,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.5,536.5c0,.1,0,.1-.1.2h-.2l-.3.2s.1-.1,0-.1h-.4c.2,0,.2-.2.4-.3s.2-.1.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,538.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.1,536.8l.2.4h-.1l-.2-.4s-.1-.1,0-.1S413.1,536.8,413.1,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,538.7h0S416.9,538.7,416.9,538.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.6,538v.2h-.2c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.4s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.3V538c0-.1,0-.1,0-.1h.1v.2h.4s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.4,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.8,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M414.8,538.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,539.7c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1,0,0-.1h-.2v.2s.1-.1,0-.1a.4.4,0,0,1,.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "414.8 538.6 414.8 538.6 414.8 538.6 414.7 538.6 414.8 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.7h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.8h0S416.8,539.8,416.8,539.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.7 539.8 416.7 539.8 416.7 539.8 416.7 539.8 416.7 539.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,539.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.8 539.8 416.8 539.8 416.8 539.9 416.8 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.4 540.1 417.4 540.1 417.4 540.1 417.4 540.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.3,539.2H415a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,539.8l-.3.2h-.1a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,416.4,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.6,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.2,539.7h0s-.1.1-.1.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.1,539.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.5 539.9 416.5 539.9 416.5 539.9 416.5 539.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.3 540.3 417.3 540.3 417.3 540.3 417.3 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.2,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.2,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.1,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.1,539.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.3 539.8 416.3 539.8 416.3 539.8 416.3 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 539.5 415.6 539.5 415.6 539.5 415.6 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.3 539.8 416.3 539.8 416.3 539.8 416.3 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.7 539.6 415.7 539.5 415.7 539.5 415.7 539.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.5,540h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.2,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413,539h-.2C412.8,538.9,413,538.9,413,539Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.9,540h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "405.3",
      "y": "530.7",
      "width": "3.4",
      "height": "6.65",
      "transform": "matrix(0.62, -0.78, 0.78, 0.62, -264.35, 521.55)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.6,533.5c0-.1-.1-.1,0-.2s.1-.2.1-.4h.2c.1,0,.1-.2.2-.2s-.1.1,0,.2h.8c0,.1-.1.1-.1.2h.2c0,.1-.2.2-.2.3h0v.3c0,.1.1.1.1.1h-.3s0,0,0,0h-.6C403.8,533.7,403.6,533.6,403.6,533.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.7 533.3 403.7 533.3 403.7 533.3 403.7 533.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.4,534.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 533.2 403.8 533.2 403.8 533.2 403.8 533.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.7 533.1 403.7 533.1 403.7 533.1 403.7 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 533.1 403.8 533.1 403.8 533.1 403.8 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 533 403.8 533 403.8 533 403.8 533"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 532.9 403.8 533 403.8 533 403.8 532.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.9 533 403.9 533.1 403.9 533.1 403.9 533"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,534.1l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 532.9 403.8 532.9 403.8 532.9 403.8 532.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.1,533.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.5,533.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,532.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.7 533.5 404.7 533.4 404.7 533.4 404.7 533.4 404.7 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.6,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,536.2V536h.7c-.2,0-.3.2-.4.2h-.3S408.8,536.2,408.8,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.4,535.7a1.1,1.1,0,0,1-.1-.4h.1a2.6,2.6,0,0,0,.1.4s0,.1,0,.1S408.4,535.7,408.4,535.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,534.3h.3c0,.1.1,0,.1.1h.1c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s-.1-.1,0-.1h.5s0,0,0,.1.3,0,.4.2,0,.2-.1.2h-.4v.2c0,.1,0,.1,0,.1h-.1s0-.1,0-.2h-.4c0,.1.1,0,.2.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,535h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.2,533.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.5,532.3c0-.1.1-.2.2-.3h0c0,.1,0,0,0,.1h0v.2h0s.1.1,0,.1h.3l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 533.7 407.2 533.7 407.2 533.7 407.2 533.7 407.2 533.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.5,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.2h0S405.6,532.2,405.6,532.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.7 532.3 405.7 532.3 405.7 532.2 405.7 532.2 405.7 532.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,532.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.6 532.2 405.6 532.2 405.6 532.1 405.6 532.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 531.8 405.1 531.8 405.1 531.8 405.1 531.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.9,533.1h.2a.3.3,0,0,1-.1.2h-.1S406.8,533.1,406.9,533.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,532.3h.3a.2.2,0,0,0,0,.2H406A.1.1,0,0,1,406,532.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,532.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.9 532.2 405.8 532.2 405.8 532.2 405.9 532.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.2 531.6 405.2 531.7 405.2 531.6 405.2 531.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.3h0S406.1,532.3,406.1,532.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.1,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,532.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406 532.3 406 532.3 406 532.3 406 532.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.6 532.7 406.6 532.7 406.6 532.7 406.6 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.1 532.3 406.1 532.3 406.1 532.3 406.1 532.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.6 532.7 406.6 532.7 406.6 532.7 406.6 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,531.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,533.7h.2C409.1,533.9,408.9,533.8,409,533.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,532.4h.3s0,.1,0,.1h-.1C407.4,532.6,407.3,532.5,407.4,532.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "406.3",
      "y": "525.8",
      "width": "3.9",
      "height": "7.68",
      "transform": "translate(-247.4 661.2) rotate(-63.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,529.8c0-.1-.1-.1-.1-.2s0-.3.1-.4,0-.1.1-.1,0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2,0,.2h.5s0-.1,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.2.2-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.8.8,0,0,0-.1.4c0,.1.2,0,.2.1h-.5c0,.1.1,0,.2.1l-.6.2C404.5,530,404.3,530,404.2,529.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.3 529.6 404.3 529.6 404.3 529.6 404.3 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.5 529.4 404.4 529.5 404.4 529.5 404.5 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.3 529.4 404.3 529.4 404.3 529.4 404.3 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.4 529.3 404.4 529.3 404.4 529.3 404.4 529.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.4 529.3 404.4 529.3 404.4 529.3 404.4 529.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.4 529.2 404.4 529.2 404.4 529.2 404.4 529.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.5 529.3 404.5 529.3 404.5 529.3 404.5 529.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,530.1h-.2l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.3 529.1 404.3 529.2 404.3 529.2 404.3 529.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,530s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,530h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.3,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.5,529.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.4 529.5 405.4 529.5 405.4 529.5 405.5 529.5 405.4 529.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.4,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,531.6c0-.1,0-.1.1-.2h.2l.3-.2s-.1.1,0,.2h.4c-.2,0-.3.3-.5.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.6,529s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.2,531.2a1.3,1.3,0,0,1-.2-.5h.1l.2.4s.1.1,0,.1S410.2,531.2,410.2,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,529.1h0S406.1,529.2,406.1,529.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.5,529.9v-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.4v.2c0,.1,0,.1,0,.1h-.1v-.2H409c0,.1.2,0,.2.1a0,0,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.9,530.4c0,.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.4,529.2s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,528.1c0-.1.1-.2.1-.3h0c0,.1-.1,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1.1,0,.1h.2l.2-.2s-.1.1,0,.1a.4.4,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "408.4",
      "y": "529.2",
      "height": "0.01",
      "transform": "translate(-247.7 656.9) rotate(-63.4)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,528h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.3,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,527.9h0S406.2,527.9,406.1,527.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.3 528 406.3 528 406.3 527.9 406.3 527.9 406.3 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,528s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.2 527.9 406.2 527.9 406.2 527.9 406.2 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.5 527.5 405.5 527.5 405.5 527.5 405.5 527.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.8,528.6h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,527.9c0-.1.2-.1.3-.2h.1a.3.3,0,0,0,0,.2h-.3A.1.1,0,0,1,406.6,527.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,528h0c0-.1.1-.1.1-.1h.1s0,0,0,.1h0s0,0,0,0h-.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.5 527.8 406.5 527.8 406.5 527.8 406.5 527.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.6 527.4 405.6 527.4 405.6 527.4 405.6 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.1,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.7,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.7 527.9 406.7 527.9 406.7 527.9 406.7 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.5 528.2 407.4 528.2 407.4 528.2 407.5 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.8 527.9 406.7 527.9 406.7 527.9 406.8 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.4 528.2 407.4 528.2 407.4 528.2 407.4 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.5,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.3,528.8v-.2h.3v.2C410.5,529,410.3,528.9,410.3,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,527.7h.2A.1.1,0,0,1,408.2,527.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "399.9",
      "y": "523.3",
      "width": "8.3",
      "height": "4.27",
      "transform": "translate(-258.3 548.7) rotate(-54.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.5,529.7h-.2c-.2.1-.3-.1-.5-.1s-.1-.1-.1-.1h0c0-.1-.2-.1-.3-.2h.2V529h-.1s0,0,0-.1h.1a.3.3,0,0,0-.1-.2h-.1c-.1-.1,0-.2-.1-.3h.1s0-.1,0-.1h-.2c.1,0,.2.2.4.2h.1c.1-.1,0-.3.1-.4a1.2,1.2,0,0,0,.1.4c0-.1,0-.2.1-.3a1,1,0,0,1,0,.4h.4c.1,0,.1-.2.2-.1s-.1.1-.1.2,0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.2s.1.5.1.7S403.7,529.7,403.5,529.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 529.6 403.3 529.7 403.3 529.7 403.3 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.6,527.4v-.2h.2C404.8,527.3,404.7,527.4,404.6,527.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.1 529.4 403.2 529.5 403.2 529.5 403.1 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.1 529.6 403.1 529.6 403.1 529.6 403.1 529.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403 529.5 403 529.5 403 529.5 403 529.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.9 529.4 403 529.5 403 529.5 402.9 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 529.5 402.9 529.5 402.9 529.5 402.8 529.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403 529.3 403 529.3 403 529.3 403 529.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,527.6l-.2.2h0l.2-.2S404.2,527.6,404.1,527.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 529.5 402.8 529.5 402.8 529.5 402.8 529.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.4,528.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.7,529.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.4 528.4 403.4 528.4 403.4 528.4 403.4 528.4 403.4 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.2,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,523h-.2c.1-.1,0-.1,0-.2l-.2-.3h.2c.1,0,.1-.1.1-.2s0-.2,0-.2.2.3.2.5.1.3-.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.9,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.9,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,523.6l-.5.2h.7C406.2,523.6,406.1,523.6,406,523.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.1,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.1,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.3,525.1l-.2-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.5s0-.1,0-.1h-.2c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.5h.3c.1,0,.1-.1.1-.1h.1c0-.1.1-.1.1-.2s.1.4,0,.6,0,.1.1.1h0v.3a.9.9,0,0,0,0,.3c.1,0,0-.2.1-.2h.1c0,.1-.1.2.1.2h.1a.3.3,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.6,525.3h-.1a.1.1,0,0,1,0-.1h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.6,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.5c-.2,0-.2-.1-.3-.2s-.1-.2,0-.3h.3c0-.1-.1,0-.1-.1h.1s0-.1,0-.1h0c0-.1-.2-.1-.2-.2h.1a.5.5,0,0,1,.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.6 525.2 403.6 525.2 403.6 525.2 403.6 525.2 403.6 525.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,527.2s0,0,0,0S402,527.2,402,527.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.8,527.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.9 527.2 401.9 527.2 401.8 527.2 401.8 527.2 401.9 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,527.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.8 527.3 401.8 527.3 401.7 527.3 401.8 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.3 528 401.3 528 401.3 528 401.3 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.8,525.7a.3.3,0,0,1-.1-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,526.9c-.1-.1-.1-.2-.1-.3h.4c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.7h-.1s0,0,0-.1h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.8 527 401.8 527 401.7 527 401.8 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.1 527.9 401.1 527.9 401.1 527.9 401.1 527.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.9 526.7 401.9 526.7 401.9 526.8 401.9 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.4 526 402.4 526 402.4 526 402.4 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.9 526.7 401.9 526.7 401.9 526.7 401.9 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.3 526 402.3 526.1 402.3 526.1 402.3 526"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,527h0S401.7,527,401.7,527Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.8,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.5,523h-.1c0-.1,0-.2.1-.3h.1v.2C403.7,522.9,403.6,523,403.5,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402,525.1h-.1a.2.2,0,0,1,.1-.2h.2C402.1,525,402.1,525.1,402,525.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "406",
      "y": "516.9",
      "width": "4.1",
      "height": "7.95",
      "transform": "translate(-139.8 149.7) rotate(-17.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411,523.8c0,.1,0,.2-.1.2s-.2.2-.4.3h-.2s.1-.1,0-.1-.2.1-.3.1.2-.1.1-.2H409c.1-.1.3-.1.4-.2h0c0-.2-.2-.2-.3-.3h.4l-.2-.2.3.2.3-.2c0-.1-.1-.1,0-.2s0,.1.1.2h.4c.1-.1-.1-.1-.1-.2l.6.3C410.9,523.5,411.1,523.6,411,523.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 523.9 410.8 523.9 410.8 523.9 410.8 523.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,521.6h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,409.8,521.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 523.9 410.6 523.9 410.6 523.9 410.6 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 524 410.6 524 410.6 524 410.6 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.5 524 410.5 524 410.5 524.1 410.5 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.5 524.1 410.5 524.1 410.5 524.1 410.5 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 524.2 410.5 524.1 410.5 524.2 410.4 524.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 524 410.4 524 410.4 524 410.4 524"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,522.1a.8.8,0,0,1,.1.3h-.1c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 524.2 410.4 524.2 410.4 524.2 410.4 524.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,522.2h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,522.2h0S409.8,522.2,409.8,522.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410,523.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.3,524.2h0S410.3,524.1,410.3,524.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.9 523.1 409.9 523.1 409.9 523.1 409.9 523.1 409.9 523.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.9,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.6,517.6h-.5c.1-.1,0-.1-.1-.2l-.2-.2c.2.2.4,0,.6.1s.3.1.2.3S407.6,517.6,407.6,517.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.5,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,523h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.7,518.4a1.3,1.3,0,0,1-.2.5h-.1s0-.1,0-.1l.2-.5h.1C407.8,518.3,407.8,518.4,407.7,518.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,520.6h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2H407c-.1,0,0,.1-.1.1s0-.1,0-.1h-.3s0-.1,0-.1h-.1c0-.2-.2-.2-.3-.4h.2c.1-.1,0-.1,0-.2h.1c-.1,0,0-.1-.1-.2l.5.3h.1v-.2h.1c.1,0,0,.1,0,.2v.4h.2c.1-.1-.1-.1-.1-.2h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,519.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.6,521.2h0A.1.1,0,0,1,407.6,521.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,521.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.4,523.7H408l-.3-.2h.3s0,0,0,0h.2c.1,0,0-.1.1-.1h-.1s0,.1,0,.1h.1C408.4,523.6,408.4,523.7,408.4,523.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 521.1 407.6 521.2 407.5 521.2 407.5 521.1 407.6 521.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.3,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.2,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.2 523.6 408.2 523.6 408.1 523.6 408.1 523.6 408.2 523.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.1,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.1,523.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.1 523.8 408.2 523.8 408.2 523.8 408.1 523.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.4 524.5 408.4 524.5 408.4 524.5 408.4 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.1,523.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,522h0C407.5,521.9,407.6,522,407.5,522Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,523.4h-.3s0-.1,0-.1v-.2h.2c.1,0,0,.1.1.2A.1.1,0,0,1,407.9,523.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.2h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.9 523.6 407.9 523.6 407.9 523.6 407.9 523.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.2 524.6 408.2 524.5 408.2 524.6 408.2 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.7,523.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.8 523.4 407.8 523.3 407.8 523.4 407.8 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.5 522.6 407.5 522.6 407.5 522.6 407.5 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.8 523.3 407.8 523.3 407.8 523.3 407.8 523.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.5 522.6 407.5 522.6 407.5 522.6 407.5 522.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,520h-.2c-.1-.1-.2-.1-.2-.2h.3C405.9,519.7,406,519.9,405.9,520Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,522.3h-.2v-.2h.2A.1.1,0,0,1,406.6,522.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "407.7",
      "y": "511.8",
      "width": "4.2",
      "height": "8.3",
      "transform": "translate(-129.9 893.9) rotate(-86.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,517.8s-.2-.1-.2-.2-.1-.3-.1-.5,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2v-.2h.1v-.2s0-.1,0-.1.2-.1.2-.2,0-.1,0-.2h.1c.1.1,0,.2.1.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.1c.2,0,.2-.2.4-.2l-.2.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.2c.1.1.1,0,.2,0l-.5.5A.7.7,0,0,1,405.9,517.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.9 517.6 405.9 517.6 405.9 517.6 405.9 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.5,517.5a.1.1,0,0,1,.1-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406 517.3 406 517.4 406 517.4 406 517.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.8 517.3 405.8 517.4 405.8 517.3 405.8 517.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.9 517.2 405.9 517.2 405.9 517.2 405.9 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.9 517.2 405.9 517.2 405.9 517.2 405.9 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.8 517.1 405.8 517.1 405.8 517.1 405.8 517.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406 517.1 406 517.1 406 517.1 406 517.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,517.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.8 517.1 405.8 517.1 405.8 517.1 405.8 517.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.9,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408,517.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,517h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.9,516.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407 517 407 517 407 517 407 517 407 517"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.2,516.8c-.1-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.1.4-.3.5s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.4,516.7l-.4-.4s0-.1,0-.1h.1l.4.4s.1.1.1.1S412.5,516.7,412.4,516.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.2,516.1c0-.1.1-.2,0-.2h.2c.1.1.1-.1.2,0h.1l-.2-.2h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1.1-.1h.1c.2.1.3-.2.5-.1s.1.2,0,.3h.2s0,.1,0,.1h.2l-.5.3s-.1.1-.1.1h.2c.1,0,0,.1.1.1h-.6l-.2.2c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2.1-.2.2s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,516.1c.1,0,0,0,0,.1S411.8,516.1,411.8,516.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,515.5h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,515.3c-.1-.1,0-.3,0-.4s.1-.2.2-.2h-.1s-.1,0,0,.1H407c.1,0,0,0,0,.1h0a.3.3,0,0,0,0,.3h.1c.1,0,0-.1.1-.1s0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.1a.5.5,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 515.5 409.8 515.5 409.8 515.4 409.8 515.4 409.8 515.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.1,515.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,515.1h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.2 515.1 407.2 515.1 407.2 515.1 407.2 515.1 407.2 515.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.1 515 407 515.1 407 515 407.1 515"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.3 515 406.2 515 406.2 515 406.3 515"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,515h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,515.1a.3.3,0,0,1,.2-.2.3.3,0,0,1,.1.2H409Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,514.9c0-.2.1-.2.2-.3h.1v.2a.1.1,0,0,1-.1.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.7,514.9h0c0-.1.1-.2,0-.2h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.3 514.9 407.3 514.9 407.3 514.9 407.3 514.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.3 514.8 406.3 514.8 406.3 514.8 406.3 514.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.7,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,514.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.2,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 514.8 407.6 514.8 407.6 514.8 407.6 514.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.5 514.9 408.5 514.9 408.4 514.9 408.5 514.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 514.8 407.6 514.8 407.6 514.8 407.6 514.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.4 514.8 408.4 514.9 408.4 514.9 408.4 514.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.3,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,514.2c0-.1,0-.1,0-.2h.4c0,.1,0,.2-.1.2S411.7,514.4,411.6,514.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,514c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "403.6",
      "y": "509",
      "width": "4",
      "height": "7.84",
      "transform": "translate(-43.2 37.4) rotate(-5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,516.4s0,.2-.1.2-.3.1-.4.2H407s.1-.1,0-.1h-.3c0-.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.8s0,0,0,0h.4s0,0,0-.1h.1c0-.2-.2-.2-.2-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.4c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.4A.6.6,0,0,1,407.9,516.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 516.4 407.6 516.4 407.6 516.4 407.6 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,514H407a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,407.2,514Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.4 516.4 407.4 516.4 407.4 516.4 407.4 516.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.4 516.5 407.4 516.5 407.4 516.5 407.4 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.3 516.5 407.3 516.5 407.3 516.5 407.3 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.3 516.5 407.3 516.5 407.3 516.5 407.3 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 516.6 407.2 516.6 407.2 516.6 407.2 516.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 516.4 407.2 516.4 407.2 516.4 407.2 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,514.5a.9.9,0,0,1,0,.3H407c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 516.6 407.2 516.6 407.2 516.6 407.2 516.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,514.6h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,514.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,516.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407 515.5 407 515.5 406.9 515.5 406.9 515.5 407 515.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,509.7h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2s-.1-.1-.1-.2.4.1.5.3.2.2.2.3S405.9,509.7,405.9,509.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,510.4l-.3.4h-.1s0-.1,0-.1l.3-.4h.1C406,510.3,405.9,510.4,405.9,510.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,512.6h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.2.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1h-.1c.1-.2-.2-.2-.2-.4h.3c.1,0,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1,0-.3h.1s.1.2.2.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.4,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,513.1h0S405.2,513,405.2,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,515.7H405c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C405.4,515.6,405.3,515.6,405.3,515.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.1 513.1 405.1 513.1 405.1 513.1 405.1 513.1 405.1 513.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.3,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 515.6 405.1 515.6 405.1 515.6 405.1 515.6 405.1 515.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.1,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.1,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 515.7 405.1 515.7 405.1 515.7 405.1 515.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.2 516.5 405.2 516.5 405.2 516.5 405.2 516.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.1,515.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.9,513.9h.1C404.9,513.8,404.9,513.9,404.9,513.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.9,515.3c-.1,0-.2-.1-.3-.2s0,0,0-.1h.3c.1.1,0,.1.1.2A.1.1,0,0,1,404.9,515.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515.1h-.1s0,0,0,0h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.9 515.5 404.9 515.5 404.9 515.5 404.9 515.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405 516.5 405 516.5 405 516.5 405 516.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.8,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.8,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.7,513.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.8,515h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.8 515.2 404.9 515.2 404.9 515.2 404.8 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.8 514.4 404.8 514.4 404.8 514.4 404.8 514.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.8 515.2 404.8 515.2 404.8 515.2 404.8 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.7 514.5 404.8 514.5 404.8 514.5 404.7 514.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.8,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,516.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,511.6h-.2c-.1-.1-.2-.1-.1-.2h.3C403.8,511.3,403.8,511.5,403.7,511.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.9,514h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,403.9,514Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "404.1",
      "y": "501.6",
      "width": "4.3",
      "height": "8.33",
      "transform": "translate(-171.3 210.4) rotate(-24.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.7,503.1c0-.1,0-.2.1-.2s.2-.2.4-.3h.2s-.1.1,0,.1.2-.1.3-.1-.2.1-.1.2h1.1c0,.1-.2,0-.2.2h.3c-.1.1-.3.1-.4.2h0c0,.2.2.1.3.3h-.4l.2.2-.3-.2-.3.3c0,.1.1.1,0,.2s0-.1-.1-.2h-.4c-.1.1.1.1.1.2l-.7-.3C402.9,503.5,402.7,503.3,402.7,503.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.9 503 402.9 503 402.9 503 402.9 503"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,505.2h.2a.2.2,0,0,1,0,.2h-.1A.2.2,0,0,1,404.2,505.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.2 503 403.1 503 403.2 503 403.2 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.1 502.8 403.1 502.8 403.1 502.8 403.1 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.2 502.8 403.2 502.8 403.2 502.8 403.2 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.8 403.3 502.8 403.3 502.8 403.3 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.7 403.3 502.7 403.3 502.7 403.3 502.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.4 502.8 403.4 502.9 403.4 502.9 403.4 502.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,504.7v-.3h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.6 403.3 502.6 403.3 502.6 403.3 502.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.2,504.6h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.2,504.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.2,504.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.8,503.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.5,502.7a0,0,0,0,1,0,0S403.5,502.7,403.5,502.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.9 503.7 403.9 503.7 404 503.7 404 503.7 403.9 503.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,509.1h.6c0,.1,0,.1.1.2h.2c-.2-.2-.4,0-.6-.1s-.3-.1-.3-.2S407,509.2,407,509.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.6,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.5,503.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.6,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.8,508.4a1.4,1.4,0,0,1,.1-.5h.1s0,.1,0,.1a3.2,3.2,0,0,0-.1.5s0,.1-.1.1S406.7,508.4,406.8,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,506.1h.4c0,.1.1.1.1.2h.1c0-.1.1-.2.1-.3h.1c.1,0,0-.1.1-.1h.2c.1,0,0-.1,0-.1h.4s0,.1,0,.1h.1c0,.2.3.2.3.4l-.2.2c-.1.1,0,.1,0,.2h-.1c.1,0,0,.1.1.2l-.5-.3h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.2s.1-.1.1-.2l-.2-.2h-.3c-.1.1.1.1.1.2h-.1c-.1,0-.1-.2-.2-.1h-.1a.3.3,0,0,1-.3-.3A.5.5,0,0,1,406.3,506.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,507.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,505.4h0A.1.1,0,0,1,406.6,505.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.6,505.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.5,502.9c.1-.1.2-.1.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C405.5,503.1,405.5,503,405.5,502.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.6 505.5 406.6 505.5 406.7 505.5 406.7 505.5 406.6 505.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.6,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,502.9h0S405.6,502.9,405.6,502.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,503.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,502.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,502.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.7 503 405.7 503 405.8 503 405.8 503 405.7 503"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.8,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.8,503h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.7 502.8 405.7 502.8 405.7 502.8 405.7 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.4 502.1 405.4 502.1 405.4 502.1 405.4 502.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.8,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,504.6h.3l-.2.2h-.1C406.6,504.7,406.5,504.6,406.6,504.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,503.2h.4s0,.1,0,.1v.2h-.2c-.1,0,0-.2-.1-.2A.1.1,0,0,1,406.1,503.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,502.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.8,502.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,503.4h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406 503 406 503 406 503 406 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.6 502 405.5 502 405.6 502 405.6 502"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,504.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.2 503.2 406.1 503.2 406.1 503.2 406.2 503.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.5 504 406.5 504 406.5 504 406.5 504"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.2 503.2 406.2 503.2 406.2 503.2 406.2 503.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.5 504 406.5 504 406.5 504 406.5 504"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,502.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,501.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.6,506.5h.2c.1,0,.2.1.2.2h-.3C408.6,506.8,408.5,506.6,408.6,506.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,504.1h.1A.1.1,0,0,1,407.5,504.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "399.6",
      "y": "501.1",
      "width": "6.5",
      "height": "3.31",
      "transform": "translate(-195.5 741.5) rotate(-73)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.2,499.4h.7s-.1,0,0,.1h.2s0-.1,0-.1h.2v.2h.2s0,0,0,0h-.3s0,0,0,.1h-.1c-.1.1.1.2.1.3l-.2-.2c.1.1,0,.2,0,.2v-.3h-.3s0,.1-.1.1.1-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.1l-.3-.5C402.1,499.7,402.1,499.5,402.2,499.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.4 499.5 402.4 499.4 402.4 499.4 402.4 499.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402,501.4h-.1A.1.1,0,0,1,402,501.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.5 499.6 402.5 499.5 402.5 499.6 402.5 499.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.6 499.4 402.6 499.4 402.6 499.4 402.6 499.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.6 499.5 402.6 499.5 402.7 499.5 402.6 499.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.7 499.5 402.7 499.5 402.7 499.5 402.7 499.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 499.5 402.7 499.5 402.7 499.5 402.8 499.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.7 499.6 402.7 499.6 402.7 499.6 402.7 499.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.3,501.1v-.2h0v.2S402.2,501.1,402.3,501.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 499.4 402.8 499.4 402.8 499.4 402.8 499.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.3,501h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.3,501.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.3,501h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.6,500.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.9,499.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.6 500.4 402.6 500.4 402.6 500.4 402.6 500.4 402.6 500.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.7,500.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.6,505.1h.2c0,.1,0,.1,0,.1l.2.2h-.1c-.1,0,0,.1-.1.2s.1.1,0,.2-.3-.2-.3-.3-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,500.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.9,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,500.5s0,0,0,0S403,500.5,403,500.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.9,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,504.6l.4-.2h0l-.3.2h-.1C401.7,504.6,401.8,504.6,401.9,504.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.7,503h.2v.2c-.1,0,0,.1,0,.1s0,.1,0,.1h.7c-.1.1.1.2,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.4h-.1c0-.1,0-.2,0-.2v-.2c-.1,0,0,.1,0,.2h-.1c0-.1,0-.2-.1-.1h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.3,502.7h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.2,502.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.9,500.7h.3c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0H404s0,.1,0,.1h.1l-.3-.2C403.8,500.8,403.9,500.8,403.9,500.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.8 403.3 502.8 403.3 502.8 403.3 502.8 403.3 502.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.9,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,500.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404 500.9 404 500.9 404.1 500.9 404.1 500.9 404 500.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,501h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.1 500.8 404.1 500.8 404.1 500.8 404.1 500.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.3 500.2 404.3 500.2 404.3 500.2 404.3 500.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,502.3a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,501.1c.1,0,.1.1.2.2H404c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.3s0,0,0,0h.1s0,0,0,0H404s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.4s0,0,0,0S404.1,501.4,404.1,501.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.2 501 404.2 501 404.2 501 404.2 501"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.4 500.2 404.4 500.2 404.4 500.2 404.4 500.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.8,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.2 501.2 404.1 501.2 404.1 501.2 404.2 501.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404 501.9 403.9 501.9 404 501.9 404 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.2 501.3 404.1 501.3 404.2 501.2 404.2 501.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404 501.9 404 501.8 404 501.8 404 501.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,501h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,500.3h0S404.7,500.3,404.7,500.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.9,504.4h.1c0,.1.1.2,0,.2h-.2C403.8,504.5,403.8,504.4,403.9,504.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.5,502.5h.1a.1.1,0,0,1,0,.1h-.2A.1.1,0,0,1,404.5,502.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "392.2",
      "y": "506.4",
      "width": "7.9",
      "height": "4.05",
      "transform": "translate(-192.3 771.5) rotate(-76.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,512.5H397c-.2.1-.3,0-.5,0h-.2s.1,0,0-.1h-.1l-.2-.2s0,.1,0,.1h0l-.2-.2h-.1l-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0-.1,0-.1h.1c.1-.1-.1-.3-.1-.4l.3.3c-.1-.1,0-.2-.1-.3l.2.3h.4c0-.1,0-.2.1-.2s-.1.1,0,.2h.1s0,.1.1.1h.1c.1,0,0-.1,0-.2s.3.4.3.6A.6.6,0,0,1,397.3,512.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "397 512.5 397 512.5 397 512.5 397 512.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.4,510h-.1v-.2h.1A.1.1,0,0,1,397.4,510Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.8 512.4 396.8 512.4 396.8 512.4 396.8 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.8 512.5 396.8 512.5 396.8 512.5 396.8 512.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.7 512.4 396.7 512.4 396.7 512.4 396.7 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 512.4 396.7 512.4 396.7 512.4 396.6 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 512.5 396.6 512.5 396.6 512.5 396.6 512.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 512.3 396.6 512.3 396.6 512.3 396.6 512.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.1,510.4v.3h0c.1-.1,0-.2.1-.3S397.1,510.4,397.1,510.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.5 512.5 396.6 512.5 396.6 512.5 396.5 512.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,510.5h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.7,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.4,512.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.7 511.3 396.7 511.3 396.7 511.3 396.7 511.3 396.7 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,511.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,505.5h-.2c0-.1-.1-.1,0-.2l-.3-.2h.2c.1,0,.1-.1.1-.2s-.1-.1,0-.2.3.2.4.4.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.1,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.3,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.2,511.2h0S396.2,511.2,396.2,511.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,506.2l-.4.3h0l.4-.3h.1C397.5,506.1,397.3,506.2,397.3,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.4,508.2h-.2v-.2c.1-.1-.1-.1.1-.2s0-.1-.1-.1l-.2.2h-.7s0,0,0-.1h0c.1-.2-.1-.3,0-.5h.3c.1,0,.1-.1.1-.2h.1c0-.1.1-.1,0-.2s.2.3.2.5h.4c0,.1-.1.1-.1.2H396c0,.1,0,.2,0,.3v.2c.1,0,0-.2,0-.3h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.6,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.7,508.5h-.1s0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.7,508.4h0S395.8,508.4,395.7,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,511h-.4c0-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2a.4.4,0,0,1,.3.2C395.1,510.9,395.1,511,395.1,511Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 508.4 395.7 508.4 395.7 508.4 395.7 508.4 395.7 508.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,511s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.9 510.8 394.9 510.9 394.9 510.8 394.9 510.8 394.9 510.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,510.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.8 511 394.9 511 394.8 511 394.8 511"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.6 511.7 394.7 511.7 394.7 511.7 394.6 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,509.1a.3.3,0,0,1-.2-.2h.3C395.3,509.1,395.3,509.1,395.2,509.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,510.5c-.1,0-.2-.2-.2-.2h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,510.3s0,0,0,0h-.2s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.2h0S394.8,510.2,394.8,510.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.7 510.7 394.7 510.7 394.7 510.7 394.7 510.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 511.7 394.5 511.7 394.5 511.7 394.5 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,508.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "394.7 510.4 394.8 510.4 394.8 510.4 394.7 510.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.9 509.6 395 509.6 394.9 509.6 394.9 509.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "394.7 510.4 394.7 510.4 394.7 510.4 394.7 510.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.9 509.6 394.9 509.7 394.9 509.7 394.9 509.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.6,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,511.6h0S394.2,511.6,394.1,511.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,506.6h-.2c0-.1-.1-.2,0-.3h.3C395,506.4,395,506.5,394.9,506.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.2,508.9h-.1a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,394.2,508.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "389.2",
      "y": "504.9",
      "width": "7",
      "height": "3.58",
      "transform": "translate(-248.2 520.2) rotate(-53.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.2,510.3h-.7c0-.1-.2-.1-.2-.2h.2v-.2h0v-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0,0,0-.1h-.1l.3.2h.1c.1-.1,0-.2.1-.4a1,1,0,0,0,.1.3c0-.1,0-.2,0-.2a.8.8,0,0,1,0,.3h.4s0,.1,0,.1h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.1.4.1.6S392.3,510.3,392.2,510.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 510.3 392 510.3 392 510.3 392 510.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,508.4h.1C393.3,508.3,393.2,508.4,393.1,508.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 510.1 391.9 510.1 391.9 510.1 391.9 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 510.2 391.8 510.2 391.8 510.2 391.8 510.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 510.1 391.8 510.1 391.7 510.1 391.8 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.7 510.1 391.7 510.1 391.7 510.1 391.7 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.6 510.1 391.7 510.1 391.6 510.1 391.6 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.7 510 391.7 510 391.7 510 391.7 510"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.8,508.6l-.2.2h0l.2-.2S392.8,508.6,392.8,508.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.6 510.1 391.6 510.1 391.6 510.1 391.6 510.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.6,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.1,509.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.5,510h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.1 509.2 392.1 509.2 392.1 509.2 392.1 509.2 392.1 509.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,504.8h-.2c.1,0,0-.1,0-.2l-.2-.3h.1c.1,0,.1-.1.1-.1s0-.1,0-.2.2.3.2.5,0,.2-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.4,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.9,506.5h-.2a.3.3,0,0,1,0-.2c.1,0,0-.1.1-.1s0-.1,0-.1h-.6c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.4v-.2c0,.1.1.3,0,.5h.1v.2a.7.7,0,0,0,0,.2c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,506.6h-.1a.1.1,0,0,1,0-.1h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.3,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,508.4l-.3-.2c.1-.1,0-.2,0-.3h.3s0-.1,0-.1h0v-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.3 506.5 392.3 506.5 392.3 506.5 392.3 506.5 392.3 506.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.2s0,0,0,0S390.9,508.2,390.9,508.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,508.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.9 508.2 390.8 508.2 390.8 508.2 390.8 508.2 390.9 508.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.7 508.3 390.8 508.3 390.7 508.3 390.7 508.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.3 508.8 390.3 508.8 390.3 508.8 390.3 508.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,508.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,506.9a.2.2,0,0,1-.1-.2h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,507.9c-.1-.1-.1-.2-.1-.3h.3c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,508.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.8h-.1s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.8 508 390.8 508 390.7 508 390.8 508"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.2 508.7 390.2 508.7 390.2 508.7 390.2 508.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,507.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.8 507.8 390.9 507.8 390.9 507.8 390.8 507.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.3 507.2 391.3 507.2 391.3 507.2 391.3 507.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.9 507.8 390.9 507.8 390.9 507.8 390.9 507.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.2 507.2 391.3 507.3 391.2 507.2 391.2 507.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,508h0S390.7,508,390.7,508Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,504.7h-.1c0-.1,0-.2.1-.2h.2C392.5,504.6,392.4,504.7,392.3,504.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391,506.4h.1C391.1,506.4,391,506.4,391,506.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "384.3",
      "y": "503.6",
      "width": "7",
      "height": "3.57",
      "transform": "translate(-245.1 577.4) rotate(-59)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388,501.7h.8v.2h0v.2h.1c.1.1,0,.2.1.2h-.3c-.1.1,0,.2,0,.4V503c0,.1,0,.2,0,.2a.9.9,0,0,1,0-.3h-.3c-.1,0,0,.1-.1.1v-.2s0-.1,0-.1h0s0-.1,0-.1H388c-.1,0,0,.1-.1.1s-.1-.4-.1-.6S387.8,501.8,388,501.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 501.8 388.1 501.8 388.2 501.8 388.2 501.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,503.8h-.1A.1.1,0,0,1,387.2,503.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 501.9 388.3 501.9 388.3 501.9 388.3 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.4 501.8 388.3 501.8 388.3 501.8 388.4 501.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.4 501.9 388.4 501.9 388.4 501.9 388.4 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 501.9 388.4 501.9 388.5 501.9 388.5 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 501.9 388.5 501.9 388.5 501.9 388.5 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 502 388.4 502 388.4 502 388.5 502"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,503.5v-.2h0l-.2.2S387.5,503.5,387.6,503.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.6 501.9 388.6 501.9 388.6 501.9 388.6 501.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,503.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.2,502.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,502h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 502.8 388.1 502.8 388.2 502.8 388.1 502.8 388.1 502.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.3,502.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.9,507.5h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s0,.1,0,.2-.2-.3-.2-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,503.1s0,0,0,0S388.5,503.1,388.6,503.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,507l.4-.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,505.6h.2a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.6c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.1.4h-.4c0,.1-.1.1-.1.2s-.1-.3-.1-.5h-.1v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.2-.1.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.2,505.5h.1a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.2,505.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,503.5l.3.2c-.1.1.1.2,0,.3h-.1s0-.1,0-.1h-.2s0,0,0,.1h.1l.2.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 505.5 388.2 505.5 388.2 505.5 388.2 505.5 388.2 505.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,503.7s0,0,0,0S389.4,503.7,389.4,503.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,503.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.5 503.7 389.5 503.7 389.5 503.7 389.5 503.7 389.5 503.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,503.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.6 503.6 389.6 503.6 389.6 503.6 389.6 503.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390 503.1 389.9 503 390 503 390 503.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.8,505.1a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,504c.1.1.1.2.1.3h-.3c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,503.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.2h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.6 503.9 389.6 503.9 389.6 503.9 389.6 503.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.1 503.1 390.1 503.1 390.1 503.1 390.1 503.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,504.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.8,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,504.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.5 504.1 389.5 504.1 389.5 504.1 389.5 504.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.2 504.8 389.2 504.7 389.2 504.7 389.2 504.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.5 504.1 389.5 504.1 389.5 504.1 389.5 504.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.2 504.7 389.2 504.7 389.2 504.7 389.2 504.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,503.9h0S389.7,503.9,389.7,503.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.4,503.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,507.3h.1c0,.1,0,.2-.1.2h-.2C388.3,507.5,388.3,507.3,388.4,507.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,505.5h.1a.1.1,0,0,1,0,.1h-.2C389.4,505.6,389.5,505.5,389.6,505.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "381.3",
      "y": "503.4",
      "width": "3.7",
      "height": "7.19",
      "transform": "translate(-242.9 615.9) rotate(-62.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,507.1c0-.1-.1-.1-.1-.2s0-.3.1-.4h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2,0,.2h.4s0-.1,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.2.2-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.8.8,0,0,0-.1.3h-.2l-.6.2C379.7,507.2,379.5,507.2,379.4,507.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 506.9 379.4 506.9 379.4 506.9 379.4 506.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,507.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 506.7 379.6 506.7 379.6 506.7 379.6 506.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.5 506.7 379.5 506.7 379.5 506.7 379.5 506.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 506.6 379.5 506.6 379.6 506.6 379.6 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 506.6 379.6 506.6 379.6 506.6 379.6 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.5 506.5 379.5 506.5 379.5 506.5 379.5 506.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.7 506.5 379.7 506.6 379.7 506.6 379.7 506.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,507.4h-.2l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.5 506.4 379.5 506.5 379.5 506.5 379.5 506.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,507.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,507.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,507.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,506.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.5 506.8 380.5 506.8 380.5 506.8 380.5 506.8 380.5 506.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,508.8c0-.1,0-.1.1-.2h.2l.3-.2s-.1.1,0,.1h.4c-.2,0-.2.2-.4.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,506.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.7,506.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.9,508.4a1.2,1.2,0,0,1-.2-.4h.1l.2.4s.1.1,0,.1S384.9,508.5,384.9,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,506.5h0S381.1,506.5,381.1,506.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,507.2V507h.2c0,.1.1,0,.1.1h.1c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.3v.2c0,.1,0,.1,0,.1h-.1v-.2h-.5c0,.1.2,0,.2.1h-.2s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.7,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.2,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,506.6s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,505.4c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0c0,.1.1.1,0,.1h.2l.2-.2s-.1.1,0,.1a.4.4,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.3 506.6 383.3 506.6 383.3 506.5 383.3 506.6 383.3 506.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,505.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,505.4h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,505.3h0S381.2,505.3,381.2,505.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.3 505.4 381.3 505.4 381.3 505.3 381.3 505.3 381.3 505.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,505.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 505.3 381.2 505.3 381.2 505.3 381.2 505.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.6 504.9 380.6 505 380.6 504.9 380.6 504.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.8,506h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.6,505.3l.3-.2h.1a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,381.6,505.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,505.4h0s.1-.1.1-.1h.1s0,0,0,0h-.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,505.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.5 505.2 381.5 505.2 381.5 505.2 381.5 505.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 504.8 380.7 504.8 380.7 504.8 380.7 504.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383,505.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,505.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.7 505.3 381.7 505.3 381.7 505.3 381.7 505.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 505.6 382.4 505.6 382.4 505.6 382.4 505.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.8 505.3 381.8 505.3 381.7 505.3 381.8 505.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 505.6 382.4 505.6 382.4 505.6 382.4 505.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,504.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.1,506.2h.2C385.3,506.4,385.1,506.3,385.1,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.2,505.2h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.2",
      "y": "507.5",
      "width": "7.5",
      "height": "3.82",
      "transform": "translate(-142.6 147) rotate(-18.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,512.3h-.2c-.2-.1-.2-.2-.3-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.4.4,0,0,0,0-.2h.1a.3.3,0,0,0,0-.2h0c0-.1.1-.1.1-.2v-.2h.1c.1,0,0,.1.1.2h0v-.2h0c.1.1.1.3.2.3h.1c.1,0,.2-.2.3-.3a1,1,0,0,0-.1.4l.2-.2-.2.3.2.3h0s-.1.1,0,.1h.2c-.1.2-.1.4-.3.6S375.5,512.3,375.3,512.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.2 512.1 375.2 512.1 375.2 512.1 375.2 512.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,511.1a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.2 511.9 375.2 511.9 375.2 511.9 375.2 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.1 511.9 375.1 511.9 375.1 511.9 375.1 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.1 511.8 375.1 511.8 375.1 511.8 375.1 511.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375 511.8 375.1 511.8 375 511.8 375 511.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375 511.7 375 511.8 375 511.8 375 511.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.1 511.7 375.1 511.7 375.1 511.7 375.1 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,511.1h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.9 511.7 374.9 511.7 374.9 511.7 374.9 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.8,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,511.1s0,0,0,0S376.7,511.1,376.7,511.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375,511.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.9 511.3 375.9 511.3 375.9 511.2 375.9 511.2 375.9 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,511.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,509c-.1,0-.1-.1-.1-.2h.1a1.2,1.2,0,0,0,0-.4h.4c-.2.1,0,.4-.1.5s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.7s0-.1,0-.1S376.1,510.7,376.1,510.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.3,509.1l-.5-.2s-.1-.1,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,509.4c-.1-.1,0-.2-.1-.2V509c.1,0,.1-.1.2,0s.1-.1.1-.1h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2,0,.2-.2.4-.2s.1.1.1.2h.4c-.1.1-.1.3-.3.4s-.1.1,0,.1h-.3v.2c.1.1.1-.1.2-.1h0c0,.1-.1.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,508.8c.1,0,0,0,0,.1S379.6,508.8,379.6,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,509.1a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.8,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.8c-.1-.1-.1-.2-.1-.3s.1-.2.1-.2,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0,0,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.2,0-.2s0,.1.1.1a.4.4,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.8 509 377.7 509 377.7 509 377.7 509 377.8 509"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.4,509.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,509.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.7h0S375.4,509.7,375.4,509.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,509.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 509.6 375.4 509.6 375.4 509.6 375.4 509.6 375.4 509.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,509.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.3 509.6 375.3 509.6 375.3 509.6 375.3 509.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.6 509.8 374.6 509.8 374.6 509.8 374.6 509.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,509a.2.2,0,0,1,.1-.3v.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.6,509.3c-.1-.1,0-.2.1-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,509.3h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,509.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.5 509.4 375.5 509.4 375.5 509.4 375.5 509.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.6 509.7 374.6 509.7 374.6 509.7 374.6 509.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,508.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,509.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,509.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 509.2 375.7 509.2 375.7 509.3 375.7 509.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.4 509 376.4 509 376.4 509 376.4 509"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 509.2 375.7 509.2 375.7 509.2 375.7 509.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.4 509 376.4 509 376.4 509 376.4 509"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,509.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,507.4s0-.1,0-.2l.2-.2h.1c0,.1.1.1,0,.2S378.9,507.5,378.8,507.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,508.1c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379.9",
      "y": "513.4",
      "width": "3.1",
      "height": "6.14",
      "transform": "translate(-216.7 749.7) rotate(-74.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.6,515.7s.1.1.1.2,0,.2,0,.4,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.2s0-.1-.1-.2h-.3s0,0,0,.1H384c0,.1,0,.1,0,.2h-.1c0-.1,0-.1,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.2,0-.3h-.4l.2-.2h0a.7.7,0,0,0,0-.3h.1l.5-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 515.9 384.6 515.9 384.6 515.9 384.6 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.5 516 384.5 516 384.5 516 384.5 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516 384.6 516 384.6 516 384.6 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.1 384.6 516.1 384.6 516.1 384.6 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.2 384.6 516.1 384.6 516.1 384.6 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.2 384.6 516.2 384.6 516.2 384.6 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.5 516.2 384.5 516.2 384.5 516.2 384.5 516.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383,515.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.2 384.6 516.2 384.6 516.2 384.6 516.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.1,515.8h0S383.1,515.8,383.1,515.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.1,515.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.2,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.8,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M384.5,516.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.7 516.1 383.7 516.1 383.7 516.1 383.7 516.1 383.7 516.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,515.3c0,.1,0,.1,0,.2H379l-.2.2s0-.1,0-.1h-.3c.2,0,.2-.2.3-.3h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.7,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.6,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,515.5l.2.3h-.1l-.2-.3s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,516.3v.2h-.4v.2h-.1a.1.1,0,0,0,0,.1h-.3c-.1-.1-.2.1-.4,0s0-.1,0-.2h-.1s0-.1,0-.1h-.2l.4-.2h0s0-.1,0-.1h.4a0,0,0,0,1,0-.1h.1s0-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,516.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,516.8h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.5,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.5,517.4c.1.1,0,.2-.1.3h0s0,0,0-.1h0a.2.2,0,0,0,0-.2h-.2v.2s.1-.1,0-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.5 516.8 381.5 516.8 381.5 516.8 381.4 516.8 381.5 516.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.4,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "383.3",
      "y": "517.5",
      "transform": "matrix(0.28, -0.96, 0.96, 0.28, -221.61, 738.34)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.2,517.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "383.4 517.5 383.4 517.5 383.4 517.5 383.4 517.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384 517.7 384 517.7 384 517.7 384 517.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,517.2h-.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.1,517.6l-.2.2h-.1a.2.2,0,0,0-.1-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.5h0s-.1.1,0,.1h0s0,0,0,0h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,517.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "383.2 517.6 383.2 517.6 383.2 517.6 383.2 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "383.9 517.8 383.9 517.8 383.9 517.8 383.9 517.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,517.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 517.6 383 517.6 383 517.6 383 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.3 517.4 382.4 517.4 382.4 517.4 382.3 517.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 517.6 383 517.6 383 517.6 382.9 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 517.5 382.4 517.4 382.4 517.4 382.4 517.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.2,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.9,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,517.4h-.2C379.8,517.3,380,517.3,380,517.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,518h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "378.7",
      "y": "517.4",
      "width": "3.3",
      "height": "6.48",
      "transform": "translate(-264.2 536.4) rotate(-55.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.7,521s.1.1,0,.2-.1.2-.1.4h-.2c-.1,0-.1.2-.1.2s.1-.1,0-.2h-.8c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h0v-.3s-.1,0-.1-.1h.3s0,0,0,0h.6C383.5,520.8,383.7,520.9,383.7,521Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.6 521.2 383.7 521.2 383.7 521.2 383.6 521.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,520.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.3 383.5 521.3 383.5 521.3 383.5 521.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.6 521.4 383.6 521.4 383.6 521.4 383.6 521.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.4 383.5 521.4 383.5 521.4 383.5 521.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.5 383.5 521.4 383.5 521.5 383.5 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.5 383.5 521.5 383.5 521.5 383.5 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.4 521.5 383.4 521.4 383.4 521.4 383.4 521.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,520.5h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.6 383.5 521.6 383.5 521.6 383.5 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.1,520.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.1,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,520.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.4,521.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.7 521.1 382.7 521.1 382.7 521.1 382.7 521.1 382.7 521.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.7,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,518.7v.2h-.7c.2,0,.3-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.2,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.4,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.2,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,519.1a1.1,1.1,0,0,1,.1.4h-.1v-.4s0-.1,0-.1S378.9,519.1,378.9,519.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,521.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,521.3h0S382.1,521.3,382.1,521.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,520.4h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1s.1.1,0,.1h-.4s0,0,0-.1-.3,0-.4-.1,0-.2.1-.2h.4v-.2c0-.1,0-.1,0-.1h.1s0,.1,0,.2h.4s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,521h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.2,521h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,522.3c0,.1-.1.2-.2.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.4s.1,0,.1-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 521 380.2 521 380.2 521 380.2 521 380.2 521"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,522.4h0S381.9,522.4,381.9,522.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "381.8",
      "y": "522.3",
      "transform": "translate(-261.9 588) rotate(-59.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,522.3s0,0,0,0S381.7,522.3,381.7,522.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.8 522.4 381.9 522.4 381.9 522.4 381.8 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 522.8 382.4 522.8 382.4 522.8 382.4 522.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.6,521.6h-.2a.3.3,0,0,1,0-.2h.1S380.6,521.5,380.6,521.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,522.3h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,381.5,522.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.7,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,522.2h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.6 522.4 381.6 522.4 381.6 522.4 381.6 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.3 522.9 382.3 522.9 382.3 522.9 382.3 522.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 522.3 381.4 522.3 381.4 522.3 381.4 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.8 521.9 380.9 521.9 380.9 521.9 380.8 521.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 522.3 381.4 522.3 381.4 522.3 381.4 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 522 380.9 522 380.9 522 380.9 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.2,523.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,521.1h-.2C378.4,520.9,378.5,521,378.5,521.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,522.3h-.2s0,0,0-.1h.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.8",
      "y": "522.4",
      "width": "7",
      "height": "3.6",
      "transform": "translate(-229.9 743.1) rotate(-74)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,520.6h.8s-.1,0,0,.1h.1v.2s0-.1,0-.1h0l.2.2h.1v.2h.2s0,0,0,0h-.4s0,0,0,.1h-.1c-.1.1.1.2.1.4l-.2-.3c.1.1,0,.2,0,.2v-.3H378s0,.2-.1.2.1-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.1l-.3-.5A.6.6,0,0,1,377.5,520.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 520.6 377.7 520.6 377.7 520.6 377.7 520.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,522.7h-.1A.1.1,0,0,1,377.3,522.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.9 520.7 377.8 520.7 377.8 520.7 377.9 520.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.9 520.6 377.9 520.6 377.9 520.6 377.9 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 520.6 378 520.6 378 520.6 378 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 520.6 378 520.6 378 520.6 378 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.1 520.6 378.1 520.6 378.1 520.6 378.1 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 520.7 378 520.7 378 520.7 378 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,522.4v-.2h0v.2S377.5,522.4,377.6,522.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.1 520.5 378.1 520.5 378.1 520.5 378.1 520.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,522.3h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.9,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.2,520.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.9 521.6 377.9 521.6 377.9 521.6 377.9 521.6 377.9 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,526.8h.2c0,.1,0,.1,0,.2l.2.2h-.1c-.1,0-.1.1-.1.2s.1.1,0,.2-.3-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,521.7s0,0,0,0S378.4,521.7,378.4,521.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.2,526.1l.4-.3h0l-.4.2h-.1C377.1,526.2,377.2,526.2,377.2,526.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,524.4h.2v.2c-.1,0,.1.1-.1.1s0,.1,0,.1h.8c-.1.2.1.3,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.1c0-.1,0-.2,0-.2v-.2c-.1,0,0,.2,0,.2h-.1c0-.1,0-.2-.1-.2H378a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.8,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.7,524.1h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,521.9h.3c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2l-.3-.2C379.3,522,379.4,522,379.4,521.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 524.2 378.7 524.2 378.7 524.2 378.7 524.2 378.7 524.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,522s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.5 522.1 379.5 522.1 379.5 522.1 379.5 522.1 379.5 522.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 522 379.5 522 379.6 522 379.6 522"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.8 521.3 379.7 521.3 379.8 521.3 379.8 521.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,523.6a.2.2,0,0,1,.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,522.4c.1,0,.1.1.2.2h-.3c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.5s0,0,0,0h.1s0,0,0,0h-.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.6s0,0,0,0S379.5,522.6,379.5,522.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 522.3 379.6 522.2 379.7 522.2 379.6 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.9 521.4 379.9 521.4 379.9 521.4 379.9 521.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 522.5 379.6 522.5 379.6 522.5 379.6 522.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.4 523.2 379.4 523.2 379.4 523.2 379.4 523.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 522.5 379.6 522.5 379.6 522.5 379.6 522.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.5 523.2 379.4 523.1 379.5 523.2 379.5 523.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,521.4h0S380.2,521.4,380.2,521.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,525.9h.2c0,.1.1.2,0,.2h-.3C379.3,526.1,379.3,525.9,379.4,525.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,523.8h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,380,523.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "373.9",
      "y": "525.7",
      "width": "3.5",
      "height": "6.83",
      "transform": "translate(-257.3 672) rotate(-67.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,529.5s-.1-.1-.1-.2,0-.3,0-.4,0-.1.1-.1,0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2.1.2h.4s0,0,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.7.7,0,0,0,0,.3H373l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.1 529.3 372.1 529.3 372.1 529.3 372.1 529.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,529.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.3 529.1 372.2 529.1 372.3 529.1 372.3 529.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.1 529.1 372.1 529.1 372.1 529.1 372.1 529.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 529 372.2 529 372.2 529 372.2 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 529 372.2 529 372.2 529 372.2 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 528.9 372.2 528.9 372.2 528.9 372.2 528.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.3 528.9 372.3 529 372.3 529 372.3 528.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.9,529.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.1 528.9 372.1 528.9 372.1 528.9 372.1 528.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,529.5s0,0,0,0h0S373.8,529.5,373.8,529.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,529.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.3,528.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 529.2 373.1 529.1 373.1 529.1 373.1 529.1 373.1 529.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.1,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378,530.7c0-.1,0-.1,0-.2h.1l.2-.2s-.1.1,0,.1h.3c-.2,0-.2.3-.4.3H378Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.3,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,530.3l-.2-.4h.1l.2.4s.1.1,0,.1S377.5,530.4,377.4,530.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,528.8h0S373.7,528.8,373.7,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,529.3v-.2h.4c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2s0,.1,0,.1h-.4a0,0,0,0,1,0,.1h-.2s0,.1,0,.1H376Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,529.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,528.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,527.8c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1,0,0,.1h.2v-.2s-.1.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 528.7 375.7 528.7 375.7 528.7 375.8 528.7 375.7 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0S373.7,527.7,373.7,527.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.8 527.7 373.8 527.7 373.8 527.7 373.8 527.7 373.8 527.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,527.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.7 527.6 373.7 527.6 373.7 527.6 373.7 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.1 527.3 373.1 527.4 373.1 527.4 373.1 527.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.8,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.2,528.2h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,527.6l.2-.2h.1a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,374.1,527.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.8,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.8,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,527.7h0s.1-.1.1-.1h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374 527.6 373.9 527.6 374 527.6 374 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.1 527.2 373.1 527.2 373.1 527.2 373.1 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.4,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.2 527.6 374.2 527.6 374.2 527.6 374.2 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.8 527.9 374.8 527.9 374.8 527.9 374.8 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.2 527.6 374.2 527.6 374.2 527.6 374.2 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.8 527.8 374.8 527.9 374.8 527.8 374.8 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.9,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.2,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,528.2h.2C377.6,528.4,377.5,528.3,377.5,528.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.5,527.4h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "375.9",
      "y": "530",
      "width": "3.3",
      "height": "6.4",
      "transform": "translate(-273.8 584.2) rotate(-59.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,533.3s.1.1,0,.2,0,.2-.1.4h-.1s0,.1,0,.1h-.1c-.1,0-.1.2-.1.2s0-.1,0-.2h-.4s0,0,0,.1h-.3c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h-.1a.1.1,0,0,0,0-.1h0a.7.7,0,0,0,.1-.3h.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 533.5 380.8 533.5 380.8 533.5 380.8 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,532.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.6 380.7 533.6 380.7 533.6 380.7 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 533.7 380.8 533.7 380.8 533.7 380.8 533.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.7 380.7 533.7 380.7 533.7 380.7 533.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.8 380.7 533.8 380.7 533.8 380.7 533.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.8 380.8 533.8 380.8 533.8 380.7 533.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.6 533.8 380.6 533.7 380.6 533.8 380.6 533.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,533h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 533.9 380.8 533.9 380.8 533.9 380.8 533.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,533s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,533h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,533.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 533.5 379.9 533.5 379.9 533.5 379.9 533.5 379.9 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,533.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.6,531.4v.2h-.1l-.3.2h-.3c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,533.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.7,533.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,531.8a1,1,0,0,1,.2.4h-.1v-.4s0-.1,0-.1S376,531.8,376,531.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.3,533.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.3,533.8h0S379.3,533.7,379.3,533.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,533h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.4s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.3c0-.1,0-.1,0-.1h.6s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,532.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,533.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.3,534.7c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1,0,0-.1h-.3s.1-.1,0-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.4 533.5 377.4 533.5 377.4 533.6 377.4 533.6 377.4 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,534.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.1,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,534.8h0S379.2,534.8,379.2,534.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.1 534.7 379.1 534.7 379.1 534.8 379.1 534.8 379.1 534.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,534.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.1 534.8 379.2 534.8 379.2 534.8 379.1 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.7 535.1 379.7 535.1 379.7 535.1 379.7 535.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.8,534.1h-.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,534.8h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,378.8,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,534.7h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 534.8 378.9 534.8 378.9 534.8 378.9 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 535.3 379.6 535.2 379.6 535.3 379.6 535.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,534.1h0S377.6,534.1,377.6,534.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 534.8 378.7 534.7 378.7 534.8 378.7 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.1 534.4 378.1 534.4 378.1 534.4 378.1 534.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 534.8 378.7 534.8 378.7 534.8 378.7 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.1 534.5 378.2 534.4 378.2 534.5 378.1 534.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,535.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,533.8h-.2C375.6,533.6,375.8,533.6,375.8,533.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,534.8h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379.6",
      "y": "533.7",
      "width": "3.1",
      "height": "6.09",
      "transform": "translate(-131.7 124) rotate(-15.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,539s0,.1-.1.2l-.3.2h-.2s.1-.1,0-.1h-.2c0-.1.1-.1.1-.1h-.6l-.2-.2h.3v-.2h.2l.2-.2c0-.1-.1-.1,0-.2s0,.1,0,.1h.3c.1-.1-.1-.1,0-.1l.4.3C383.3,538.7,383.4,538.8,383.4,539Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.2 539.1 383.2 539.1 383.2 539.1 383.2 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,537.3h-.1a.1.1,0,0,1,0-.1h.1A.1.1,0,0,1,382.5,537.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 539.1 383.1 539.1 383.1 539.1 383 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.1 539.2 383.1 539.2 383.1 539.2 383.1 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 539.2 383 539.2 383 539.2 383 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 539.2 383 539.2 383 539.2 383 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 539.3 382.9 539.2 382.9 539.3 382.9 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 539.1 382.9 539.1 382.9 539.1 382.9 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,537.7a.6.6,0,0,1,0,.2h0c0-.1,0-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 539.3 382.9 539.3 382.9 539.3 382.9 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,537.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,537.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.6,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,539.2h0S382.8,539.2,382.8,539.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.6 538.4 382.6 538.4 382.6 538.4 382.6 538.4 382.6 538.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,534.2h-.4c0-.1,0-.1,0-.2h-.1c.1.1.3,0,.4.1s.2.1.2.2S380.9,534.2,380.9,534.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,534.8l-.2.4h-.1s0-.1,0-.1l.2-.3h.1C381.1,534.7,381,534.7,381,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,536.4h-.3c0-.1-.1-.1,0-.1h-.1c0,.1-.1.1-.1.2h-.3s0-.1,0-.1h-.3s0,0,0-.1H380c0-.2-.2-.2-.2-.3h.2c.1,0,0-.1,0-.1h.1c-.1,0,0-.1-.1-.1l.3.3h.2s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.2.2,0,0,1,.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,535.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,536.9h0A.1.1,0,0,1,380.9,536.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.8,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,538.9h-.2s0,0,0,0h.1s0,0,0,.1h.1S381.4,538.8,381.4,538.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 536.9 380.8 536.9 380.8 536.9 380.8 536.9 380.8 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 538.8 381.2 538.8 381.2 538.8 381.2 538.8 381.2 538.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,538.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 538.9 381.2 538.9 381.2 538.9 381.2 538.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.3 539.5 381.4 539.5 381.4 539.5 381.3 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,538.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,537.5h0C380.8,537.5,380.8,537.5,380.7,537.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,538.6h-.3s0,0,0-.1h.2c.1,0,0,.1.1.1A.1.1,0,0,1,381,538.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381 538.7 381 538.8 381 538.7 381 538.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 539.5 381.2 539.5 381.2 539.5 381.2 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 538.6 380.9 538.6 380.9 538.6 380.9 538.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 537.9 380.8 537.9 380.8 538 380.7 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 538.5 380.9 538.5 380.9 538.6 380.9 538.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 538 380.8 538 380.7 538 380.7 538"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,535.9h-.1c-.1,0-.1-.1-.1-.2h.2C379.6,535.8,379.6,535.9,379.5,535.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,537.8h0A.1.1,0,0,1,380,537.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "375.6",
      "y": "540",
      "width": "3.2",
      "height": "6.29",
      "transform": "translate(-279.6 466.7) rotate(-48.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,543.8s.1.1,0,.2-.1.2-.1.3h-.2c-.1,0-.1.1-.2.2s.1-.1,0-.2h-.8c0-.1.1-.1.1-.2h-.2c0-.1.2-.2.2-.3h0v-.3c0-.1-.1-.1-.1-.1h.2s0,0,0,0h.6C380.3,543.7,380.4,543.7,380.4,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.4 544 380.4 544 380.4 544 380.4 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.1 380.2 544.1 380.2 544.1 380.2 544.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.3 544.2 380.3 544.2 380.3 544.2 380.3 544.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.2 380.2 544.2 380.2 544.2 380.2 544.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.3 380.2 544.2 380.2 544.2 380.2 544.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.3 380.2 544.3 380.2 544.3 380.2 544.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 544.2 380.1 544.2 380.1 544.2 380.1 544.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,543.2l.2.2h0l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.4 380.2 544.4 380.2 544.4 380.2 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.1,544.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 543.8 379.4 543.8 379.4 543.8 379.4 543.8 379.4 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.6,541h-.7c.2.1.3-.2.4-.1h.3S375.6,541,375.6,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,541.5a1,1,0,0,1,.1.4H376a2.5,2.5,0,0,0-.1-.4s0-.1,0-.1S376,541.5,376,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,542.9h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2,0,.2h0s0,.1,0,.1h-.1s0,.1,0,.1H376s0,0,0-.1-.2,0-.3-.2v-.2h.4v-.2c0-.1,0,0,0-.1h.1s0,.1,0,.2h.4c0-.1-.1,0-.2-.1h.5A.4.4,0,0,1,377.1,542.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,543.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.6,544.9c0,.1-.1.2-.2.2h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.3l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377 543.4 377 543.5 377 543.5 377 543.5 377 543.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.5,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,545h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.4 544.9 378.4 544.9 378.4 544.9 378.4 544.9 378.4 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,544.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.5 545 378.5 545 378.5 545 378.5 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 545.4 379 545.4 379 545.4 378.9 545.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,544.1h-.2v-.2h.1S377.4,544,377.3,544.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,544.9h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,378.2,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.2 545 378.3 545 378.3 545 378.2 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 545.5 378.9 545.5 378.9 545.5 378.9 545.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.8h0S378,544.8,378,544.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.2,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.1 544.9 378.1 544.8 378.1 544.9 378.1 544.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.6 544.4 377.6 544.4 377.6 544.4 377.6 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 544.8 378.1 544.8 378.1 544.9 378 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.6 544.5 377.6 544.5 377.6 544.5 377.6 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.7,545.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,543.4h-.3a.2.2,0,0,1,0-.1h.1C375.3,543.2,375.4,543.2,375.4,543.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.8,544.7h-.2s0,0,0-.1h.1C376.8,544.5,376.9,544.6,376.8,544.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "384.4",
      "y": "540.9",
      "width": "6.2",
      "height": "3.17",
      "transform": "translate(-255 364.5) rotate(-39)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,545.5h-.2l-.3-.2s0-.1,0-.1h0c0-.1-.1-.1-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.2.2,0,0,0,0-.2h0c0-.1,0-.1,0-.2h.1s0,0,0-.1h-.1l.2.2h.1c.1-.1.1-.2.1-.3a.8.8,0,0,0,0,.3v-.2a.8.8,0,0,1,0,.3l.3.2h0s0,.1,0,.1h0s-.1.1,0,.1h0c.1,0,0-.1.1-.1s0,.4-.1.5S386.4,545.5,386.3,545.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 545.4 386.1 545.4 386.1 545.4 386.1 545.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,544a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 545.2 386.1 545.2 386.1 545.2 386.1 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 545.3 386 545.3 386 545.3 386 545.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 545.2 385.9 545.2 385.9 545.2 386 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.9 545.2 385.9 545.2 385.9 545.2 385.9 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.8 545.2 385.9 545.2 385.8 545.2 385.8 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.9 545.1 386 545.1 386 545.1 385.9 545.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,544.1H387s0,0,0,0h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.8 545.2 385.8 545.2 385.8 545.2 385.8 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.1,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,545h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.5 544.5 386.5 544.5 386.5 544.5 386.5 544.5 386.5 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,541.3h-.1c.1,0,0-.1.1-.1a1,1,0,0,0-.1-.3h.2c0-.1,0-.1.1-.2s.1.3.1.4,0,.2-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.1,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,544h0S386.4,544,386.4,544Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.3,541.6h-.4s-.1,0,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.8,542.4h-.1a.2.2,0,0,1,0-.2c.1,0,0-.1.1-.1s.1-.1,0-.1h-.2s0,0,0,0h-.1s0-.1,0-.1h-.1s0-.1,0-.1h.1c.2-.1.1-.2.2-.3h.5c-.1.1,0,.3-.1.4s0,.1,0,.1h0v.2a.6.6,0,0,0,0,.2c.1,0,.1-.1.1-.1h0c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,541.6c.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.2,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.6c-.1,0-.1-.1-.2-.2s0-.2,0-.2h.2s0-.1,0-.1h-.1s-.1,0,0-.1h0s0,0,0-.1h0c0-.1-.1-.1-.1-.2h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.2 542.2 387.2 542.2 387.2 542.2 387.2 542.2 387.2 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.6 543.4 385.6 543.4 385.6 543.3 385.6 543.3 385.6 543.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,543.3s0,0,0,0S385.6,543.3,385.6,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.5 543.4 385.5 543.4 385.5 543.4 385.5 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385 543.8 385 543.8 385 543.8 385 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.6,542.4a.2.2,0,0,1,0-.2h.2a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.7,543.1c-.1-.1,0-.2,0-.3h.3c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,543h-.1s0,0,0-.1h.1s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.6 543.2 385.5 543.2 385.5 543.2 385.6 543.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384.9 543.7 384.9 543.7 384.9 543.7 384.9 543.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.6,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.7 543 385.7 543 385.7 543 385.7 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.2 542.6 386.2 542.6 386.2 542.6 386.2 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.7 543 385.7 543 385.7 543 385.7 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.1 542.6 386.2 542.6 386.1 542.6 386.1 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.2h0S385.5,543.2,385.5,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.7,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,540.7h-.1c0-.1,0-.2.1-.2h.2C387.8,540.6,387.7,540.7,387.6,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.1,541.8c-.1,0,0-.1,0-.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "385.2",
      "y": "549.3",
      "width": "3.2",
      "height": "6.25",
      "transform": "translate(-47.1 36.2) rotate(-5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,555.2H388s.1,0,0-.1h-.3s0,.1,0,.1h0a.3.3,0,0,1,0-.1h-.3c0-.1-.1-.2-.2-.3h.3v-.2l.2.2h.3s0-.1,0-.2,0,.1,0,.2h.3c.1,0,0-.1,0-.1l.4.3A.5.5,0,0,1,388.6,555.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 555.2 388.5 555.3 388.5 555.3 388.5 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,553.3H388a.1.1,0,0,1,0-.1h.1A.1.1,0,0,1,388.1,553.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 555.2 388.3 555.2 388.3 555.2 388.3 555.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 555.3 388.3 555.3 388.3 555.3 388.3 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 555.3 388.2 555.3 388.2 555.3 388.2 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 555.3 388.2 555.3 388.2 555.3 388.2 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 555.4 388.1 555.4 388.1 555.4 388.1 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 555.2 388.1 555.2 388.1 555.2 388.1 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388,553.7a.7.7,0,0,1,0,.2h0c0-.1,0-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 555.4 388.1 555.4 388.1 555.4 388.1 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,553.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,555.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.9 554.5 387.9 554.5 387.9 554.5 387.9 554.5 387.9 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.8,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,549.9h-.4c.1-.1,0-.1,0-.2h-.1c.1.2.3.1.4.2s.2.1.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,550.5l-.2.3h0l.2-.3h.1C387.2,550.4,387.1,550.5,387.1,550.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.9,552.2h-.3c0-.1-.1-.1,0-.1h-.1v.2H386s0,0,0-.1h-.3s0,0,0-.1h-.1c0-.2-.1-.2-.1-.3h.2c.1,0,0-.1,0-.1h.1s0-.1,0-.2l.3.3h.3s-.1.1,0,.1h-.1c0,.1,0,.1.1.2h.1c.1-.1-.1-.1,0-.2h.3a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.7,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,552.6h0S386.5,552.6,386.5,552.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.6,554.7h-.3l-.2-.2h.2s0,0,0,0h.1s0,.1,0,.1h.1S386.6,554.6,386.6,554.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.4 552.6 386.5 552.6 386.4 552.6 386.4 552.6 386.4 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.6,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.5 554.6 386.5 554.6 386.4 554.6 386.4 554.6 386.5 554.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,554.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.4 554.7 386.5 554.7 386.4 554.7 386.4 554.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.5 555.3 386.5 555.3 386.5 555.3 386.5 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,554.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,553.2h0C386.3,553.1,386.3,553.2,386.3,553.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,554.4h-.2s0,0,0-.1h.3c.1,0,0,.1.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.3 554.5 386.3 554.5 386.3 554.5 386.3 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.4 555.3 386.4 555.3 386.4 555.3 386.4 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.1,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,554.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 554.3 386.2 554.3 386.2 554.3 386.2 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.2 553.6 386.2 553.6 386.2 553.6 386.2 553.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 554.3 386.2 554.3 386.2 554.3 386.2 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.1 553.7 386.2 553.7 386.2 553.7 386.1 553.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.2,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.1,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.3,551.4h-.1c-.1-.1-.1-.1-.1-.2h.2C385.4,551.2,385.4,551.3,385.3,551.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,553.3h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,385.5,553.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "387.1",
      "y": "544.4",
      "width": "8.3",
      "height": "4.22",
      "transform": "translate(-263.6 395.2) rotate(-41.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.7,542.5h.2c.2,0,.3.2.4.2s0,.1.1.1h0c0,.1.2.1.2.2h-.2a.5.5,0,0,0,0,.2h.1s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2h.1c.1.1,0,.2,0,.3h-.1s0,.1,0,.1h.1c-.1-.1-.2-.3-.3-.3h-.1c-.1.1-.1.3-.2.4a1.1,1.1,0,0,0-.1-.4c0,.1-.1.2-.1.3a1,1,0,0,1,0-.4l-.3-.2h0c0-.1.1-.1,0-.2h0s.1-.1,0-.1h-.1c-.1,0-.1.1-.1.1s0-.5,0-.7S392.5,542.5,392.7,542.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.9 542.6 392.9 542.6 392.9 542.6 392.9 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,544.5a.1.1,0,0,1,.1.2H391C391,544.6,391.1,544.5,391.2,544.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393 542.9 393 542.8 393 542.9 393 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.1 542.8 393.1 542.8 393.1 542.8 393.1 542.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.2 542.9 393.2 542.9 393.2 542.9 393.2 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.2 542.9 393.2 542.9 393.2 542.9 393.2 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.3 542.9 393.3 542.9 393.3 542.9 393.3 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.2 543 393.2 543 393.2 543 393.2 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,544.4l.2-.2s0,0,0,.1l-.3.2S391.6,544.4,391.7,544.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 542.9 393.3 542.9 393.4 542.9 393.4 542.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.6,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.4,543.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.5 543.8 392.5 543.8 392.5 543.8 392.5 543.8 392.5 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,548.3h.2c-.1,0,0,.1-.1.2a1.3,1.3,0,0,0,.1.4h-.3c0,.1,0,.2-.1.2s-.2-.4-.1-.6,0-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,544.4s0,0,0,.1S392.6,544.5,392.6,544.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.9,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,547.9h.5s.1,0,0,.1h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,546.7v.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s-.1.1,0,.1h.3s0,0,0,.1h.2s0,.1,0,.1h.1s0,.1.1.1h-.1c.1,0,0,.1.1.1h-.1c-.2.1-.1.3-.3.4l-.2-.2h-.3v.2c.1-.2,0-.4.1-.6s0-.1,0-.1h0l.2-.2a.9.9,0,0,0,0-.3c-.1,0-.1.2-.2.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,547.9c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,546.8h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.6,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,545c.1,0,.2.2.3.3s0,.2,0,.3h0s0-.1,0-.1h0l-.2-.2h-.1s0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.6 546.9 391.6 546.9 391.7 546.9 391.7 546.9 391.6 546.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.8,545.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.8 545.3 393.8 545.3 393.8 545.3 393.8 545.3 393.8 545.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.4s0,0,0,0S393.7,545.4,393.7,545.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.9 545.2 393.9 545.2 393.9 545.2 393.9 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 544.7 394.5 544.7 394.5 544.7 394.5 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.8,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.5,546.6a.3.3,0,0,1,0,.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,545.6c.1.1.1.2.1.4h-.4c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.8h0s.1.2.1.1h0s.1,0,0,.1h-.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.8 545.6 393.8 545.5 393.8 545.5 393.8 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.6 544.8 394.6 544.8 394.6 544.8 394.6 544.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.4,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,545.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.7 545.8 393.6 545.7 393.6 545.7 393.7 545.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393 546.3 393 546.3 393 546.3 393 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.6 545.8 393.6 545.8 393.6 545.8 393.6 545.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.1 546.3 393.1 546.3 393.1 546.3 393.1 546.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.6h0S393.9,545.6,393.9,545.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.3,549v.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1-.1-.2S391.1,548.9,391.3,549Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,547.3c.1,0,.1.1.1.2h-.2v-.2A.1.1,0,0,1,393.2,547.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "388.1",
      "y": "539.6",
      "width": "6.1",
      "height": "3.12",
      "transform": "translate(-156.8 922.7) rotate(-89)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,538.4h.7s-.1,0,0,.1h.3s0-.1,0-.1h0a.3.3,0,0,1,0,.1h.5a.1.1,0,0,1,0,.1h0s0,0,0,0h-.3s0,0,0,.1h-.1c0,.1.1.2.1.3l-.2-.2c.1,0,.1.1.1.2l-.2-.2h-.3s0,.1,0,.2,0-.1,0-.1h-.2c-.1,0,0,.1,0,.1l-.4-.4A.5.5,0,0,1,389.7,538.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.9 538.3 389.9 538.3 389.9 538.3 389.9 538.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390,540.2h.1a.1.1,0,0,1,0,.1H390A.1.1,0,0,1,390,540.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.1 538.4 390 538.4 390 538.4 390.1 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.1 538.3 390 538.3 390 538.3 390.1 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.1 538.3 390.1 538.3 390.1 538.3 390.1 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.3 390.2 538.3 390.2 538.3 390.2 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.2 390.2 538.2 390.2 538.2 390.2 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.4 390.2 538.4 390.2 538.4 390.2 538.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.2,539.9a.7.7,0,0,1,0-.2h0c0,.1,0,.2,0,.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.2 390.2 538.2 390.2 538.2 390.2 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.2,539.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.2,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.2,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.3,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.3,538.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "390.3",
      "y": "539.1",
      "height": "0.02",
      "transform": "translate(-172.7 894.1) rotate(-86.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.4,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,543.7h.4c-.1,0,0,.1,0,.2h.1c-.1-.2-.3-.1-.4-.2s-.2-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.7,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,543.1l.3-.3h0l-.3.3h-.1C390.6,543.2,390.7,543.1,390.8,543.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,541.5h.3s.1.1,0,.1h.1v-.2h.5s0,0,0,.1h0c-.1.2.1.2.1.3H392c-.1,0,0,.1,0,.1h-.1c0,.1,0,.1,0,.2l-.3-.3h-.3s.1-.1,0-.1h.1c0-.1,0-.1,0-.2v-.2c-.1.1.1.1,0,.2h-.1s0-.1-.1-.1h-.1a.2.2,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,542.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.5,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.5,541.1h0S391.5,541.1,391.5,541.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.6,539.1h.3l.2.2h-.2s0,0,0,0h-.2S391.6,539.1,391.6,539.1Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "391.6",
      "y": "541.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.6,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "391.7",
      "y": "539.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.8 539.1 391.8 539.1 391.8 539.1 391.8 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.8 538.5 391.8 538.5 391.8 538.5 391.8 538.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.8,540.5h-.1C391.8,540.6,391.8,540.5,391.8,540.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,539.4h.2s0,0,0,.1h-.3c-.1-.1,0-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h.1s0,0,0,0h-.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.9 539.3 391.9 539.3 391.9 539.3 391.9 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.9 538.5 391.9 538.5 391.9 538.5 391.9 538.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 539.5 391.9 539.5 391.9 539.5 391.9 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.9 540.1 391.9 540.1 391.9 540.1 391.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 539.5 391.9 539.5 391.9 539.5 392 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "392 540.1 391.9 540.1 392 540.1 392 540.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.2,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.5,542.4h.1c0,.1.1.1.1.2h-.2C392.4,542.6,392.4,542.4,392.5,542.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,540.5h.1a.1.1,0,0,1,0,.1h-.2A.1.1,0,0,1,392.6,540.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "393.6",
      "y": "535.6",
      "width": "4",
      "height": "7.73",
      "transform": "translate(-208.8 252.8) rotate(-28.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.2,537.2c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1.2-.1.3-.2-.1.1-.1.2h1c0,.1-.1.1-.1.2h.3c-.1.1-.3.1-.3.2h0c.1.1.2.1.3.2h-.4l.2.2h-.3l-.3.3c0,.1.1.1.1.2v-.2h-.1s0,0,0,0H393c-.1.1.1.1.1.1l-.6-.2C392.4,537.5,392.2,537.4,392.2,537.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.4 537.1 392.4 537.1 392.4 537.1 392.4 537.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,539.1h.2a.2.2,0,0,1,.1.2h-.1A.1.1,0,0,1,393.7,539.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.6 537 392.6 537 392.6 537 392.6 537"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.5 536.9 392.5 536.9 392.5 536.9 392.5 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.9 392.6 536.9 392.7 536.9 392.7 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.9 392.7 536.9 392.7 536.9 392.7 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.8 392.7 536.8 392.7 536.8 392.7 536.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.8 536.9 392.8 536.9 392.8 536.9 392.8 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,538.6v-.3h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.7 392.7 536.7 392.7 536.7 392.7 536.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,538.5h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.3,537.6s0,0,0,0S393.3,537.6,393.3,537.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.9,536.7a0,0,0,0,1,0,0S392.9,536.8,392.9,536.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 537.7 393.4 537.7 393.4 537.7 393.4 537.7 393.4 537.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.4,537.5h0S393.4,537.5,393.4,537.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.6,542.5h.6c0,.1.1.1.1.2h.2c-.2-.1-.4.1-.6,0s-.3-.1-.3-.2S396.6,542.5,396.6,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.3,541.8a1.3,1.3,0,0,1,.1-.5h.1s0,.1,0,.1a3,3,0,0,0-.1.5s0,.1-.1.1S396.3,541.8,396.3,541.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394,537.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.7,539.8h.4c0,.1.1.1.1.2h.1c0-.1.1-.2,0-.2h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.4s0,.1,0,.1h.1c0,.2.3.2.3.3l-.2.2c-.1.1,0,.1,0,.2h-.1v.2l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.2s.1-.1,0-.2l-.2-.2h-.2c0,.1.1.1.1.2h-.1c-.1,0-.1-.1-.2,0h-.1a.3.3,0,0,1-.3-.2A.5.5,0,0,1,395.7,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.5,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.9,539.1h0A.1.1,0,0,1,395.9,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.9,539.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,536.8c0-.1.2-.1.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C394.8,537,394.8,536.9,394.7,536.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396 539.1 396 539.1 396 539.1 396 539.1 396 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.8h0S394.9,536.9,394.9,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,537h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 536.9 395 536.9 395 536.9 395 536.9 395 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,536.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 536.7 394.9 536.7 394.9 536.7 395 536.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.6 536.1 394.6 536.1 394.6 536.1 394.6 536.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.9,538.3h.3v.2h-.1C395.9,538.4,395.8,538.4,395.9,538.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.3,537h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,395.3,537Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,536.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,536.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.2h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.2 536.9 395.2 536.9 395.2 536.9 395.2 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.7 536 394.7 536 394.7 536 394.7 536"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.1,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 537.1 395.4 537.1 395.4 537.1 395.4 537.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.8 537.8 395.8 537.8 395.8 537.8 395.8 537.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 537.1 395.4 537.1 395.4 537.1 395.4 537.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.8 537.7 395.7 537.7 395.8 537.7 395.8 537.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.3,536.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,539.9h.2c.1,0,.2.1.2.2H398C397.9,540.2,397.7,540.1,397.8,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.7,537.8h.1A.1.1,0,0,1,396.7,537.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "397.1",
      "y": "531.3",
      "width": "3.8",
      "height": "7.47",
      "transform": "matrix(0.55, -0.84, 0.84, 0.55, -267.29, 574.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,534.7c0-.1-.1-.1,0-.2s.1-.3.1-.4h.2c.1,0,.1-.2.1-.3s-.1.2,0,.2h.5s0-.1,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.2.2-.2.4h0a.8.8,0,0,0-.1.4c0,.1.2,0,.1.1h-.3s0,0,0,0H396c0,.1.1,0,.1.1h-.6C395.4,534.9,395.2,534.9,395.1,534.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.2 534.5 395.2 534.5 395.2 534.5 395.2 534.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.4 395.4 534.4 395.4 534.4 395.4 534.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.3 534.3 395.3 534.3 395.3 534.3 395.3 534.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.3 395.4 534.3 395.4 534.2 395.4 534.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.2 395.4 534.2 395.4 534.2 395.4 534.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.1 395.3 534.1 395.3 534.1 395.4 534.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.5 534.2 395.5 534.2 395.5 534.2 395.5 534.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397,535.2l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.3 534.1 395.3 534.1 395.3 534.1 395.3 534.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,535.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,535.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.9,535.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.2,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,534h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.3 534.6 396.3 534.6 396.3 534.6 396.4 534.6 396.3 534.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.3,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.3,537.2c0-.1.1-.1.1-.2h.2l.3-.2h.3c-.2,0-.3.2-.5.2s-.3.1-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.6,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.7,536.8a1.2,1.2,0,0,1-.2-.5h.1v.4s.1.1,0,.1S400.7,536.8,400.7,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397,534.3h0S397,534.3,397,534.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.3,535.3v-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.4v.2c0,.1,0,.1,0,.1h-.1c0-.1,0-.1,0-.2h-.5c0,.1.2,0,.2.1h-.2s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.5,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.1,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399.2,534.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.1,533.2c0-.1.1-.2.2-.3h0c0,.1-.1,0,0,.1h0v.2h.1s.1.1,0,.1h.2l.2-.2s-.1.1-.1.1a.4.4,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "399.2",
      "y": "534.6",
      "height": "0.01",
      "transform": "translate(-266.9 572.3) rotate(-56.5)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,533.2h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.4,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,533.1h0S397.2,533.1,397.2,533.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.3 533.2 397.3 533.2 397.4 533.1 397.4 533.1 397.3 533.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.4,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.4,533.2s0,0,0,0S397.4,533.2,397.4,533.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.3 533.1 397.2 533.1 397.2 533.1 397.3 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.7 532.7 396.6 532.7 396.6 532.7 396.7 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.4,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.8,534h.3a.3.3,0,0,1,0,.2h-.1C398.8,534.1,398.7,534,398.8,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.7,533.2h.3a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,397.7,533.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.4,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.3h0s.1-.1.1-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.9,533.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.6 533.1 397.5 533.1 397.5 533.1 397.6 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.7 532.5 396.7 532.5 396.7 532.5 396.7 532.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.9,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.9,533.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "397.8 533.2 397.8 533.2 397.8 533.2 397.8 533.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.4 533.6 398.4 533.6 398.4 533.6 398.4 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "397.8 533.2 397.8 533.2 397.8 533.2 397.8 533.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.4 533.5 398.4 533.6 398.4 533.5 398.4 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.5,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.2,534.5h.2C401.3,534.7,401.1,534.6,401.2,534.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.3,533.2h.3s0,.1,0,.1h-.1C399.3,533.3,399.2,533.3,399.3,533.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "395",
      "y": "525.7",
      "width": "3.3",
      "height": "6.43",
      "transform": "translate(-256.1 633.7) rotate(-62.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,528.9s-.1-.1-.1-.2,0-.2.1-.4h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.2s0,.1,0,.2h.4s0,0,0-.1h.3c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.3l-.3.2h-.1a.7.7,0,0,0-.1.3h-.1l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.3 528.7 393.3 528.8 393.3 528.7 393.3 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,529.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 528.6 393.4 528.6 393.5 528.6 393.5 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.6 393.4 528.6 393.4 528.6 393.4 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.5 393.4 528.5 393.4 528.5 393.4 528.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.5 393.4 528.5 393.4 528.5 393.4 528.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.4 393.4 528.4 393.4 528.4 393.4 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 528.4 393.5 528.5 393.5 528.5 393.5 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,529.2h-.2l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.4 393.4 528.4 393.4 528.4 393.4 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,529.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,529.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,528.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "394.3 528.7 394.3 528.7 394.3 528.7 394.3 528.7 394.3 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.2,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.7,530.5c0-.1,0-.1.1-.2h.1l.2-.2s-.1.1,0,.1h.3c-.2,0-.2.2-.4.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.4,528.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.5,528.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.2,530.2l-.2-.4h.1v.4s.1.1,0,.1S398.2,530.2,398.2,530.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,528.4h0S394.8,528.4,394.8,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,529.1v-.2h.4c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2s0,.1,0,.1h-.6s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.7,528.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.7,528.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,527.5c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0s.1,0,0,.1h.3s-.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.8 528.5 396.8 528.5 396.8 528.5 396.8 528.5 396.8 528.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,527.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,527.4h0S394.9,527.4,394.9,527.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 527.4 395 527.4 395 527.4 395 527.4 395 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,527.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 527.3 394.9 527.3 394.9 527.3 395 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.4 527 394.4 527 394.4 527 394.4 527"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.3,528h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.3,527.4h.3a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,395.3,527.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,527.5h0s.1-.1.1-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.2 527.3 395.2 527.3 395.2 527.3 395.2 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 526.9 394.5 526.9 394.5 526.9 394.5 526.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 527.3 395.4 527.4 395.4 527.4 395.4 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396 527.7 396 527.7 396 527.7 396 527.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 527.4 395.4 527.4 395.4 527.4 395.4 527.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396 527.6 396 527.6 396 527.6 396 527.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.5,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.4,528.2h.2C398.5,528.3,398.4,528.3,398.4,528.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.7,527.2h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "387.3",
      "y": "527.6",
      "width": "3.6",
      "height": "7.05",
      "transform": "translate(-209.6 257.1) rotate(-29.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,533.1c0,.1,0,.2-.1.2s-.2.2-.3.3h-.2s0-.1,0-.1-.1.1-.2.1.1-.1.1-.2h-.9c0-.1.1,0,.1-.2h-.2c.1-.1.3-.1.3-.2h0l-.3-.2h.4l.2-.2c0-.1-.1-.1-.1-.2h.4c0-.1-.1-.1-.1-.1l.6.2C392.1,532.8,392.3,533,392.3,533.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.1 533.3 392.1 533.3 392.1 533.3 392.1 533.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,531.5h-.2v-.2h.1A.1.1,0,0,1,390.8,531.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 533.3 391.9 533.3 391.9 533.3 391.9 533.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 533.4 392 533.4 392 533.4 392 533.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 533.4 391.9 533.4 391.9 533.4 391.9 533.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 533.5 391.8 533.5 391.8 533.5 391.8 533.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 533.6 391.8 533.5 391.8 533.5 391.8 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.7 533.4 391.8 533.4 391.7 533.4 391.7 533.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,531.9v.2h-.1c0-.1-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 533.6 391.8 533.6 391.8 533.6 391.8 533.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,532h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,532h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.3,532.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,533.6a0,0,0,0,1,0,0S391.7,533.6,391.7,533.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.2 532.7 391.2 532.7 391.2 532.7 391.2 532.7 391.2 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.2,532.9h0S391.1,532.9,391.2,532.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.2,528.4h-.5c0-.1,0-.1-.1-.2h-.2c.2.1.3-.1.5,0s.2.1.3.2S388.2,528.3,388.2,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.5,529a1.1,1.1,0,0,1-.1.5h-.1s0-.1,0-.1a2.7,2.7,0,0,0,.1-.4s0-.1.1-.1S388.5,529,388.5,529Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389,530.9h-.4c0-.1-.1-.1-.1-.1h-.1c0,.1-.1.1,0,.2h-.1c-.1,0,0,.1,0,.1h-.2s0,.1,0,.1h-.3s0,0,0-.1h-.1c0-.2-.2-.1-.3-.3l.2-.2c0-.1,0-.1,0-.1h0l.5.2h.1a.2.2,0,0,0,0-.2h.1c.1,0,0,.1,0,.2s-.1.1,0,.2l.2.2h.2c0-.1-.1-.1-.1-.2h.3l.2.2A.5.5,0,0,1,389,530.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,531.5h0A.1.1,0,0,1,388.9,531.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.8,531.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390,533.5l-.3.2h.2c.1,0,0-.1,0-.1h-.1s0,0,0,.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.8 531.4 388.8 531.4 388.8 531.4 388.8 531.4 388.8 531.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.9,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.5h0S389.8,533.5,389.8,533.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.8,533.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.8 533.5 389.8 533.5 389.7 533.5 389.7 533.5 389.8 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.7,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.7,533.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.8 533.6 389.8 533.6 389.8 533.6 389.8 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.1 534.2 390.1 534.2 390.1 534.2 390.1 534.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,532.2h-.3V532h.1C388.9,532.1,389,532.2,388.9,532.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,533.4h-.3s0-.1,0-.1v-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,389.5,533.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,533.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,533.2h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.5 533.5 389.5 533.5 389.5 533.5 389.5 533.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390 534.3 390 534.3 390 534.3 390 534.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.7,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.4 533.3 389.4 533.3 389.4 533.3 389.4 533.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389 532.7 389 532.7 389 532.7 389 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.4 533.3 389.4 533.3 389.4 533.3 389.4 533.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389 532.7 389 532.7 389 532.7 389 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,533.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,530.7H387l-.2-.2h.2C387.1,530.5,387.2,530.6,387.1,530.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,532.6h-.1A.1.1,0,0,1,388.1,532.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "384.9",
      "y": "523.2",
      "width": "6.6",
      "height": "3.35",
      "transform": "translate(-158.6 881.6) rotate(-86.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,528H389s.1,0,0-.1h-.3s0,.1,0,.1h0a.3.3,0,0,1,0-.1h-.6a.1.1,0,0,1,0-.1h0s0,0,0,0h.3s0,0,0-.1h.1c0-.1-.1-.2-.1-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.3s0-.1,0-.2,0,.1,0,.2h.3c.1,0,0-.1,0-.1l.4.4A.5.5,0,0,1,389.7,528Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.5 528.1 389.5 528.1 389.5 528.1 389.5 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,526h-.1a.2.2,0,0,1,0-.1h.1A.1.1,0,0,1,389.4,526Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.3 528 389.3 528 389.3 528 389.3 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.3 528.1 389.3 528.1 389.3 528.1 389.3 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.2 528.1 389.2 528.1 389.2 528.1 389.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.2 528.1 389.2 528.1 389.2 528.1 389.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 528.1 389.2 528.1 389.1 528.1 389.1 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 528 389.2 528 389.2 528 389.1 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.2,526.4a.7.7,0,0,1,0,.2h0c0-.1,0-.2.1-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 528.2 389.1 528.2 389.1 528.2 389.1 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.2,526.5h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.2,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.2,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.1,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389,528.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 527.2 389.1 527.2 389 527.2 389 527.2 389.1 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,522.3h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.1c.1,0,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.8,522.9l-.3.3h0l.3-.3h.1C388.9,522.8,388.8,522.9,388.8,522.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.5,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.5,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,524.6H388c0-.1-.1-.1,0-.1H388v.2h-.5s0,0,0-.1h-.1s0,0,0-.1h0c.1-.2-.1-.2-.1-.4h.2c.1,0,0-.1,0-.1h.1c0-.1,0-.1,0-.2l.3.4h.3c0,.1-.1.1,0,.1h-.1c0,.1,0,.2,0,.2v.2c.1-.1-.1-.1,0-.2h.1s0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.9,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.9,525h0S387.9,525,387.9,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,527.2h-.3c0-.1-.1-.1-.2-.2h.2s0,0,0,0h.1s0-.1,0-.1h.1S387.7,527.1,387.7,527.2Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "387.8",
      "y": "525",
      "height": "0.02",
      "transform": "translate(-156.3 885.4) rotate(-87.1)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 527 387.5 527 387.5 527 387.5 527 387.5 527"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,527h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 527.1 387.5 527.2 387.5 527.2 387.5 527.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.4 527.8 387.5 527.8 387.5 527.8 387.4 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,525.6l-.2-.2h.2C387.6,525.5,387.6,525.6,387.5,525.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,526.8l-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6s0,0,0,0h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.4 526.9 387.4 527 387.4 526.9 387.4 526.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.3 527.8 387.3 527.8 387.3 527.8 387.3 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.3,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.3,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.3 526.7 387.3 526.7 387.3 526.7 387.3 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.4 526 387.4 526 387.4 526 387.4 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.3 526.7 387.3 526.7 387.3 526.7 387.3 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.3 526.1 387.4 526.1 387.4 526.1 387.3 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.3,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.8,523.6h-.1c0-.1-.1-.1-.1-.2h.2C386.9,523.4,387,523.5,386.8,523.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.7,525.6h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,386.7,525.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379.6",
      "y": "528.8",
      "width": "7.7",
      "height": "3.93",
      "transform": "translate(-58.6 47.7) rotate(-6.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,533.1H380c-.2-.1-.1-.3-.2-.4s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s.1.2.2.2V532h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.2s0-.1,0-.2h.1c.1.1,0,.2.1.2h0c0-.1,0-.1,0-.2h0c.1.1,0,.3.1.4h.1c.1,0,.2-.2.3-.2l-.2.3h.2l-.2.2.2.3H381s-.1,0-.1.1h.2l-.4.5A.6.6,0,0,1,380.2,533.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 532.9 380.1 532.9 380.1 532.9 380.1 532.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,532.4a.1.1,0,0,1,0-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 532.7 380.2 532.7 380.2 532.7 380.2 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380 532.7 380 532.7 380 532.7 380 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 532.6 380 532.6 380 532.6 380.1 532.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380 532.6 380 532.6 380 532.6 380 532.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 532.5 380 532.5 380 532.5 379.9 532.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 532.5 380.1 532.5 380.1 532.5 380.1 532.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,532.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 532.5 379.9 532.5 379.9 532.5 379.9 532.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,532.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 532.2 381 532.2 381 532.2 381 532.2 381 532.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.7,531c-.1-.1,0-.1-.1-.2h.1v-.3s0,.1,0,.2h.4c-.2.1-.1.4-.2.5s-.2.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.9,531l-.4-.3s0-.1,0-.1h.1l.4.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,531.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,531.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,531.6h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.8,530.8c0-.1,0-.2,0-.2v-.2c.1,0,.1-.1.2,0H384a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2.1.2-.2.4-.2s.1.2.1.2h.4l-.4.4s-.1.1,0,.1h-.3l-.2.2c.1.1.1-.1.3-.1a0,0,0,0,1,0,.1s-.2.1-.1.2.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.3,530.6c.1,0,0,0,0,.1S385.2,530.6,385.3,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,530.4h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.6c-.1-.1,0-.2-.1-.4s.1-.2.2-.2h0s0,0,0,.1h0s-.1.1,0,.1h-.1a.3.3,0,0,0,0,.2s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2,0-.2s0,.1,0,.1a.4.4,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.4 530.4 383.3 530.4 383.3 530.3 383.4 530.3 383.4 530.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.8,530.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,530.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 530.5 380.9 530.5 380.9 530.4 380.9 530.4 380.9 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.8 530.4 380.8 530.4 380.7 530.4 380.8 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 530.5 380 530.5 380 530.5 380 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,530.1a.2.2,0,0,1,.1-.2v.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,530.2c0-.1.1-.2.1-.3h.1l.2.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,530.2h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,530.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381 530.2 381 530.2 381 530.2 381 530.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 530.3 380 530.3 380 530.3 380 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,530.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.7,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,530.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 530.1 381.2 530.2 381.2 530.2 381.2 530.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382 530 382 530.1 382 530.1 382 530"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 530.1 381.2 530.1 381.2 530.1 381.2 530.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382 530 382 530.1 382 530 382 530"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.8,528.9s0-.1,0-.2h.3c0,.1,0,.1,0,.2S384.8,529.1,384.8,528.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.4,529.2c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "377.4",
      "y": "521.7",
      "width": "3.6",
      "height": "7.05",
      "transform": "translate(-254.1 388.7) rotate(-42)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.7,526.5c0,.1.1.2,0,.2s-.1.2-.2.4h-.2s0-.1,0-.1-.1.2-.2.2.1-.1,0-.2h-.9c0-.1.1-.1.1-.2H381c.1-.1.2-.2.2-.3h.1l.2-.3c0-.1-.1-.1-.1-.2h.3s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1,0-.1-.1h.6C382.5,526.2,382.6,526.3,382.7,526.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.5 526.7 382.6 526.7 382.6 526.7 382.5 526.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,525.2h-.1C380.9,525,380.9,525.1,380.9,525.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.4 526.7 382.4 526.7 382.4 526.7 382.4 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.4 526.8 382.5 526.8 382.5 526.8 382.4 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 526.9 382.4 526.9 382.4 526.9 382.3 526.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 526.9 382.3 526.9 382.3 526.9 382.3 526.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 527 382.4 527 382.3 527 382.3 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.2 526.9 382.2 526.9 382.2 526.9 382.2 526.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,525.6l.2.2h-.1v-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 527 382.4 527 382.4 527 382.3 527"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,527.1h0S382.2,527,382.2,527.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.5 526.3 381.6 526.3 381.5 526.3 381.5 526.3 381.5 526.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.5,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,522.8h-.8c.2.1.3-.1.5-.1s.2,0,.3.1S377.7,522.7,377.7,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,523.3a1.2,1.2,0,0,1,0,.5H378a2.8,2.8,0,0,0,0-.4s0-.1,0-.1S378.1,523.3,378.1,523.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,525h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2,0,.2h-.1s0,.1,0,.1h-.2s0,.1,0,.1h-.5s0,0,0-.1-.3-.1-.3-.2V525c0-.1,0-.1-.1-.1h.6a.2.2,0,0,0,0-.2h.1c0,.1,0,.1,0,.2l.2.2h.2c0-.1-.1-.1-.2-.2h.3l.3.2A.5.5,0,0,1,379,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.9,525.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.5,527.4c0,.1-.2.2-.2.2h0c0-.1.1,0,0-.1h0l.2-.2h-.1c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "378.9",
      "y": "525.6",
      "height": "0.01",
      "transform": "translate(-254.2 387.8) rotate(-41.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.4h0S380.4,527.4,380.4,527.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 527.4 380.3 527.4 380.3 527.4 380.3 527.4 380.3 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.2,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.2,527.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 527.5 380.4 527.5 380.3 527.5 380.3 527.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.8 528 380.8 528 380.8 528 380.8 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.3,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,526.3h-.3v-.2h.1S379.2,526.3,379.2,526.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,527.3h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,380,527.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,527.2h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.1 527.4 380.1 527.5 380.1 527.5 380.1 527.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 528.1 380.7 528.1 380.7 528.1 380.7 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.2h0S379.8,527.2,379.8,527.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 527.3 379.9 527.3 379.9 527.3 379.9 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.4 526.8 379.4 526.8 379.4 526.8 379.4 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 527.3 379.9 527.3 379.9 527.3 379.9 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.4 526.8 379.4 526.8 379.4 526.8 379.4 526.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.5,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,525.3h-.3a.2.2,0,0,1,0-.1h.2C377,525.1,377.2,525.2,377.1,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,526.9h-.3s0-.1,0-.1h.1A.1.1,0,0,1,378.5,526.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "370.9",
      "y": "518.8",
      "width": "3.3",
      "height": "6.52",
      "transform": "translate(-146.1 144.8) rotate(-18.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375,524.4s0,.2-.1.2-.2.2-.3.2h-.2s.1-.1,0-.1h-.2c0-.1.1-.1.1-.2h-1l.3-.2h0l-.2-.2h.3v-.2h.2l.3-.2c0-.1-.1-.1,0-.2s0,.1.1.1h.3c.1-.1-.1-.1-.1-.1l.5.2C374.9,524.1,375.1,524.2,375,524.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.9 524.5 374.9 524.5 374.9 524.5 374.9 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374,522.6h-.1a.2.2,0,0,1,0-.1h.1A.1.1,0,0,1,374,522.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 524.5 374.7 524.5 374.7 524.5 374.7 524.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 524.6 374.7 524.6 374.7 524.6 374.7 524.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 524.6 374.6 524.6 374.6 524.6 374.6 524.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 524.6 374.6 524.6 374.6 524.6 374.6 524.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.5 524.7 374.6 524.7 374.6 524.7 374.5 524.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.5 524.6 374.5 524.5 374.5 524.5 374.5 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374,523v.2H374c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.5 524.7 374.6 524.7 374.6 524.7 374.5 524.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374,523.1h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374,523.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374,523.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,524.7h0S374.4,524.7,374.4,524.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.1 523.8 374.1 523.8 374.1 523.8 374.1 523.8 374.1 523.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.1,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,519.4h-.5c0-.1,0-.1-.1-.2h-.1c.1.1.3,0,.5.1s.2.1.2.2S372.2,519.3,372.2,519.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.3,520a1.1,1.1,0,0,1-.1.4h-.1s0-.1,0-.1l.2-.4h.1C372.4,519.9,372.3,520,372.3,520Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.5,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.5,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.5,521.8h-.3c0-.1-.1-.1,0-.1H372c0,.1-.1.1-.1.2h-.6s0,0,0-.1h-.1c0-.2-.2-.2-.2-.3h.2c.1-.1,0-.1,0-.1h.1c-.1,0,0-.1-.1-.1l.4.3h.1V521h.1s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.3.3,0,0,1,.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,522.3h0A.1.1,0,0,1,372.2,522.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,524.3h-.1c.1,0,0-.1,0-.1h-.1s0,0,0,.1h.1C372.9,524.2,372.8,524.3,372.9,524.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 522.2 372.2 522.3 372.2 522.3 372.2 522.2 372.2 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.7,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,524.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.7 524.3 372.7 524.3 372.6 524.3 372.6 524.3 372.7 524.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.6,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.6,524.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.7 524.4 372.7 524.4 372.7 524.4 372.7 524.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.9 525 372.9 525 372.9 525 372.9 525"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,524.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,523h0C372.2,522.9,372.2,522.9,372.1,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.4,524.1h-.3s0,0,0-.1v-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,372.4,524.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,524.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.5 524.2 372.5 524.2 372.5 524.2 372.5 524.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.7 525 372.7 525 372.7 525 372.7 525"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372,522.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.3,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.4 524.1 372.4 524 372.4 524 372.4 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 523.4 372.2 523.4 372.2 523.4 372.1 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.4 524 372.4 524 372.4 524 372.4 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 523.5 372.2 523.4 372.1 523.4 372.1 523.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.4,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.5,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.8,521.3h-.1c-.1,0-.2-.1-.1-.2h.2C370.8,521.1,370.8,521.2,370.8,521.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.4,523.2h0A.1.1,0,0,1,371.4,523.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.8",
      "y": "520.5",
      "width": "3.3",
      "height": "6.38",
      "transform": "translate(-201.8 232.4) rotate(-27.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.7,521.9s0-.2.1-.2.2-.2.3-.3h.2s0,.1,0,.1h.2c0,.1-.1.1-.1.2h1l-.3.2h0l.3.2h-.4l-.2.2c0,.1.1.1,0,.2h-.4c0,.1.1.1.1.1l-.5-.2C365.8,522.1,365.6,522,365.7,521.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.8 521.7 365.8 521.7 365.8 521.7 365.8 521.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,523.4h.1A.1.1,0,0,1,366.9,523.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366 521.7 366 521.7 366 521.7 366 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.9 521.6 365.9 521.6 365.9 521.6 365.9 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366 521.6 366 521.6 366 521.6 366 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.6 366 521.6 366 521.6 366.1 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.5 366 521.5 366.1 521.5 366.1 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.6 366.1 521.6 366.1 521.6 366.1 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,523v-.2h.1c0,.1.1.2.1.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.4 366.1 521.5 366.1 521.5 366.1 521.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.8,522.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.5,522.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.2,521.5a0,0,0,0,1,0,0S366.2,521.5,366.2,521.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 522.2 366.6 522.2 366.6 522.2 366.6 522.2 366.6 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.6,522.1h0S366.7,522.1,366.6,522.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,526.2h.5c0,.1,0,.1.1.2h.1c-.1-.1-.3.1-.5,0s-.2-.1-.2-.2S369.2,526.3,369.2,526.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,525.7a1,1,0,0,1,.1-.4h.1s0,.1,0,.1a2.4,2.4,0,0,0-.1.4H369C368.9,525.8,369,525.7,369,525.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,524h.3c0,.1.1.1.1.1h.1c0-.1.1-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.3s0,0,0,.1h.1c0,.2.2.1.3.3h-.2c0,.1,0,.1,0,.1h0l-.4-.2h-.1a.2.2,0,0,0,0,.2h-.1s0-.1,0-.1.1-.1,0-.1v-.2h-.2c0,.1.1.1.1.2h-.3l-.2-.2A.4.4,0,0,1,368.5,524Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,523.4h0A.1.1,0,0,1,368.7,523.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,523.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,521.5l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.8 523.5 368.7 523.5 368.8 523.4 368.8 523.5 368.8 523.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,521.5h0S367.9,521.6,367.8,521.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.9,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,521.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 521.6 367.9 521.6 368 521.6 368 521.6 367.9 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,521.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 521.5 367.9 521.5 367.9 521.5 367.9 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 520.9 367.6 520.9 367.6 520.9 367.6 520.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,522.8h0S368.6,522.8,368.7,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,521.7h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,368.2,521.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,521.9h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.1 521.6 368.1 521.6 368.1 521.6 368.1 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.8 520.9 367.7 520.9 367.8 520.9 367.8 520.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 521.7 368.3 521.8 368.3 521.8 368.3 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.6 522.3 368.6 522.3 368.6 522.3 368.6 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 521.8 368.3 521.8 368.3 521.8 368.3 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.6 522.3 368.6 522.3 368.6 522.3 368.6 522.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,520.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,524.1h.1l.2.2h-.2C370.3,524.3,370.2,524.2,370.3,524.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.4,522.4h.1A.1.1,0,0,1,369.4,522.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "363.8",
      "y": "524",
      "width": "3.8",
      "height": "7.43",
      "transform": "translate(-238.6 310.9) rotate(-35.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,526c0-.1,0-.2,0-.2s.2-.2.3-.4h.2s0,.1,0,.1.1-.1.2-.2-.1.1-.1.2h1c0,.1-.1.1-.1.2h.3c-.1.1-.3.1-.3.3h0l.3.2h-.5l-.2.3c0,.1.1.1.1.2h-.3s0,0,0,0H363a.1.1,0,0,0,0,.1H363c0,.1.1.1.1.1h-.6C362.3,526.3,362.2,526.2,362.2,526Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.3 525.9 362.3 525.9 362.3 525.9 362.3 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.8,527.6h.2v.2H364C363.9,527.8,363.8,527.7,363.8,527.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.5 525.8 362.5 525.8 362.5 525.8 362.5 525.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.4 525.7 362.4 525.7 362.4 525.7 362.4 525.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.5 525.7 362.5 525.7 362.5 525.7 362.5 525.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.6 525.6 362.6 525.7 362.6 525.6 362.6 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.6 525.5 362.5 525.6 362.6 525.6 362.6 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.7 525.7 362.7 525.7 362.7 525.7 362.7 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.7,527.2v-.2h.1v.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.6 525.5 362.5 525.5 362.6 525.5 362.6 525.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,526.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,525.5h0S362.7,525.5,362.7,525.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.3 526.3 363.3 526.3 363.3 526.3 363.3 526.3 363.3 526.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.3,526.2h0S363.4,526.2,363.3,526.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,530.6h.5c0,.1.1.1.1.2h.2c-.2-.1-.3.1-.5,0s-.3,0-.3-.2S366.9,530.6,366.9,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.6,529.9a1.2,1.2,0,0,1,0-.5h.1a2.9,2.9,0,0,0,0,.5s0,.1-.1.1S366.6,530,366.6,529.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.8,528h.4c0,.1.1,0,.1.1h.1c0-.1.1-.2,0-.2h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.5c.1.2.3.1.3.3l-.2.2c0,.1,0,.1.1.2h0l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1-.1-.2s0-.1,0-.2l-.2-.2h-.2c0,.1.1.1.2.2h-.3l-.3-.2A.5.5,0,0,1,365.8,528Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.9,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.9,527.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,525.4c0-.1.2-.1.3-.2h0c0,.1-.1,0,0,.1h-.1c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366 527.4 366 527.4 366 527.4 366 527.4 366 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.6,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,525.3h0S364.7,525.4,364.6,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.7,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,525.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.7 525.4 364.7 525.4 364.8 525.4 364.8 525.4 364.7 525.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.7 525.3 364.7 525.3 364.7 525.2 364.7 525.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.3 524.7 364.3 524.7 364.3 524.7 364.3 524.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.8,526.6h.3v.2h-.1C365.8,526.7,365.7,526.7,365.8,526.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.1,525.5h.3a.2.2,0,0,0-.1.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,365.1,525.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.9,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.1,525.6h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "365 525.4 365 525.3 365 525.3 365 525.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.4 524.6 364.4 524.6 364.4 524.6 364.4 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.6h0S365.2,525.6,365.2,525.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.1,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.3,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.2 525.5 365.1 525.5 365.1 525.5 365.2 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "365.6 526.1 365.6 526.1 365.6 526.1 365.6 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.2 525.5 365.2 525.5 365.2 525.5 365.2 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "365.6 526.1 365.6 526.1 365.6 526.1 365.6 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,528h.1l.2.2H368C367.9,528.2,367.8,528.1,367.8,528Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.5,526.1h.3s0,.1,0,.1h-.2A.1.1,0,0,1,366.5,526.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.7",
      "y": "524.1",
      "width": "3.3",
      "height": "6.52",
      "transform": "translate(-25.1 18) rotate(-2.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,530.3h-.7s.1,0,0-.1h-.3s0,.1,0,.1h0a.3.3,0,0,1,0-.1h-.6s0,0,0,0h.3s0,0,0-.1h.1c0-.1-.1-.2-.2-.3l.3.2v-.2l.2.2h.3c0-.1,0-.1,0-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.1l.4.4A.5.5,0,0,1,361.2,530.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361 530.4 361 530.4 361 530.4 361 530.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,528.3h-.1a.2.2,0,0,1,0-.1h.1A.1.1,0,0,1,360.7,528.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.8 530.3 360.8 530.3 360.8 530.3 360.8 530.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.8 530.4 360.8 530.4 360.8 530.4 360.8 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 530.4 360.7 530.4 360.7 530.4 360.7 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 530.4 360.7 530.4 360.7 530.4 360.7 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 530.5 360.7 530.5 360.7 530.5 360.6 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 530.3 360.7 530.3 360.7 530.3 360.6 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,528.7a.7.7,0,0,1,0,.2h0c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 530.5 360.7 530.5 360.7 530.5 360.6 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,528.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,528.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 529.5 360.5 529.5 360.5 529.5 360.5 529.5 360.5 529.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,524.7h-.4c.1-.1,0-.1,0-.2v-.2c.1.2.3.1.4.2s.2.1.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,525.3l-.2.4h0l.3-.3h.1C359.9,525.2,359.8,525.3,359.7,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,527.1h-.3c0-.1-.1-.1,0-.1h-.1v.2h-.3s0,0,0-.1h-.3s0,0,0-.1h-.1c.1-.2-.1-.2-.1-.4h.2c.1,0,0-.1,0-.1h.1c0-.1,0-.1,0-.2l.3.4h.3s-.1.1,0,.1H359c0,.1,0,.1,0,.2v.2c.1-.1-.1-.1,0-.2h.1s.1.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,527.5h0S359.1,527.5,359.1,527.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,529.7h-.3l-.2-.2h.2s0,0,0,0h.1s0,.1,0,.1h.1S359.1,529.6,359.1,529.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 527.5 359 527.5 359 527.5 359 527.5 359 527.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 529.6 359 529.6 358.9 529.6 358.9 529.6 359 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,529.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 529.7 358.9 529.7 358.9 529.7 358.9 529.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 530.3 359 530.3 359 530.3 358.9 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,529.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,528.1h.1C358.8,528.1,358.9,528.1,358.8,528.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,529.3h-.2s0,0,0-.1h.3c.1,0,0,.1.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,529.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,529.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 529.5 358.8 529.5 358.8 529.5 358.8 529.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 530.3 358.8 530.3 358.8 530.3 358.8 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.7 529.3 358.7 529.3 358.7 529.3 358.7 529.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.7 528.6 358.7 528.6 358.7 528.6 358.7 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.7 529.2 358.7 529.2 358.7 529.3 358.7 529.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.7 528.6 358.7 528.6 358.7 528.6 358.7 528.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,526.2h-.1c-.1-.1-.1-.1-.1-.2h.2C358,526,358,526.1,357.9,526.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,528.2h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,358,528.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "356.5",
      "y": "534.2",
      "width": "8.3",
      "height": "4.25",
      "transform": "translate(-49.8 37.1) rotate(-5.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,538.8c-.1,0-.2,0-.2-.2s-.1-.3-.2-.4,0-.1,0-.1h0c.1-.1-.1-.2,0-.3s.1.2.2.2v-.2h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.2s-.1-.1,0-.2h.1c.1.1,0,.2.1.2h.1c-.1-.1,0-.1,0-.2h0c.1.1,0,.3.1.4h.1c.2,0,.2-.2.4-.2a1.1,1.1,0,0,0-.2.4h.2l-.2.3.2.4h-.1s-.1,0-.1.1h0c.1.1.1-.1.2,0l-.5.5A.7.7,0,0,1,357.1,538.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 538.6 357 538.6 357 538.6 357 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,538.1a.1.1,0,0,1,.1-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 538.3 357 538.4 357 538.4 357 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 538.4 356.9 538.4 356.9 538.4 356.9 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 538.2 356.9 538.2 356.9 538.2 356.9 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 538.2 356.9 538.2 356.9 538.2 356.9 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 538.1 356.8 538.2 356.8 538.2 356.8 538.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 538.1 357 538.1 357 538.1 357 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,537.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 538.1 356.8 538.1 356.8 538.1 356.8 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.9,538h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "358",
      "y": "537.8",
      "height": "0.02",
      "transform": "translate(-52.8 39.1) rotate(-5.8)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,536.7c-.1-.1,0-.2-.1-.2h.2V536s0,.1,0,.2h.4c-.2.1-.1.4-.3.5s-.2.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,536.7l-.5-.3s0-.1,0-.1h.1l.4.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,537.1h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361,536.4c0-.1,0-.2,0-.2V536c.1,0,.1-.1.2,0h-.2s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2.1.3-.2.5-.2s.1.2.1.3h.4l-.4.4s-.1.1,0,.1h-.4l-.2.2c.1.1.2-.1.3-.1a.1.1,0,0,1,0,.1c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,536.2c.1,0,0,0,0,.1S362.6,536.2,362.6,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.5,535.9h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,536.1c-.1-.1,0-.3-.1-.4s.1-.2.2-.2h-.1s0,0,0,.1h0s-.1.1,0,.1h-.1c.1,0,0,.1,0,.1h0a.3.3,0,0,0,0,.3s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2,0-.3s0,.1,0,.1a.5.5,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 535.9 360.5 535.9 360.5 535.9 360.5 535.9 360.5 535.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,536.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,536h0S357.8,536,357.8,536Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,536h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.9 535.9 357.9 535.9 357.9 535.9 357.9 535.9 357.9 535.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358,535.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.7 535.9 357.7 535.9 357.7 535.9 357.7 535.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.9 536 356.9 536 356.9 536 356.9 536"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,535.6a.3.3,0,0,1,.2-.3v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.1,535.7c0-.1.1-.2.2-.3h.1l.2.2a.1.1,0,0,1,0,.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.7h0c0-.1.1-.2,0-.2h0s0-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,535.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358 535.7 357.9 535.7 358 535.7 358 535.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.9 535.8 356.9 535.8 356.9 535.8 356.9 535.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,535.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,535.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.2 535.6 358.2 535.6 358.2 535.6 358.2 535.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 535.5 359.1 535.5 359.1 535.5 359.1 535.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.3 535.6 358.3 535.6 358.2 535.6 358.3 535.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 535.5 359 535.5 359 535.5 359 535.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,535.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.1,534.4c0-.1,0-.1,0-.2h.4c0,.1,0,.2,0,.2S362.2,534.5,362.1,534.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,534.6c0-.1,0-.1,0-.2h.3a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.7",
      "y": "537.6",
      "width": "4.3",
      "height": "8.48",
      "transform": "translate(-250.5 766.8) rotate(-76.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.2,540.7c0,.1.2.1.1.2s0,.3,0,.5,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.3s0-.2-.1-.2l-.2.2h-.1l-.2.2s0,.1,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1.1-.2,0-.2h-.1c0,.1,0,.1,0,.2h-.1c0-.1.1-.3,0-.4h-.5l.3-.3h-.3l.3-.2a.9.9,0,0,0,0-.4h.3c0-.1-.1,0-.2,0l.6-.4A.7.7,0,0,1,364.2,540.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 540.9 364.2 540.9 364.2 540.9 364.2 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,540.6v.2h-.2c0-.1,0-.1.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364 541.2 364.1 541.1 364 541.1 364 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 541.2 364.2 541.2 364.2 541.2 364.2 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 541.3 364.1 541.3 364.1 541.3 364.1 541.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 541.3 364.1 541.3 364.1 541.3 364.1 541.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 541.4 364.2 541.4 364.2 541.4 364.2 541.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364 541.4 364 541.4 364 541.4 364 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,540.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 541.4 364.2 541.4 364.2 541.4 364.2 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.1,541s0,0,0,0h0S362.1,541,362.1,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362,540.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.2,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.1,541.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.9 541.3 363 541.3 363 541.3 362.9 541.3 362.9 541.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,541.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,540.4c0,.1,0,.2,0,.2h-.2l-.3.3s.1-.1,0-.2h-.4c.2,0,.2-.4.4-.4s.2-.2.4-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,540.7l.4.4s0,.1,0,.1h-.1l-.3-.4s-.1-.1,0-.1S357.4,540.7,357.4,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.9h0S362.4,541.9,362.4,541.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,541.7c0,.1-.1.1-.1.2h-.2c-.1-.1-.2.1-.2-.1H359c.1.1.1.2.2.2h0c0,.1.1.1.1.1h-.1c0,.1.1,0,.1.1H359a.1.1,0,0,0,0,.2h-.1s-.1.1-.1.1h-.1c0,.1-.1,0-.1.1h0c-.2-.1-.3.1-.5,0s-.1-.2,0-.3H358s0-.1,0-.2h-.2l.5-.3s.1-.1.1-.1v-.2c-.1-.1,0-.1,0-.1h.2v.2h.6c-.1-.1-.2,0-.3,0a.1.1,0,0,1,0-.1c.1,0,.2,0,.2-.1s-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,541.4c-.1,0,0,0,0-.1S358,541.4,357.9,541.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,542.3h-.2a.1.1,0,0,1,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.9,542.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543c.1.1,0,.3-.1.4l-.3.2h.1s.1,0,0-.1h.1c-.1-.1.1,0,0-.1h0a.3.3,0,0,0,.1-.3h0c0-.1-.1,0-.1-.1h-.2c-.1.1,0,.2-.1.2s.1-.1,0-.1a.5.5,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.8 542.4 359.9 542.4 359.9 542.4 359.8 542.4 359.8 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.5,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543.1h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.4,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.4 543.2 362.4 543.2 362.4 543.2 362.4 543.2 362.4 543.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.4,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.3,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.6 543.3 362.6 543.3 362.6 543.3 362.6 543.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.4 543.5 363.4 543.5 363.4 543.5 363.4 543.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,542.9a.3.3,0,0,1-.2.2.3.3,0,0,1,0-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.1,543.3c0,.2-.2.2-.3.3h-.1a.3.3,0,0,0-.1-.2h.3A.1.1,0,0,1,362.1,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.9,543.3h0c0,.1-.1.2,0,.2h-.1s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.3 543.4 362.3 543.4 362.3 543.4 362.3 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.3 543.7 363.3 543.6 363.3 543.7 363.3 543.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.9,543.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,543.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362 543.4 362 543.4 362 543.4 362 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.1 543.2 361.1 543.2 361.1 543.2 361.1 543.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 543.4 361.9 543.4 362 543.4 361.9 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.2 543.2 361.2 543.2 361.2 543.2 361.2 543.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,543.3c0,.1,0,.1-.1.2h-.4c0-.1,0-.2.1-.2S357.8,543.2,357.9,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,543.9c0,.1-.1.1-.1.2h-.2v-.2A.1.1,0,0,1,360.4,543.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "354.3",
      "y": "540.8",
      "width": "3.3",
      "height": "6.41",
      "transform": "translate(-230.1 262.6) rotate(-31.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353,542.4s0-.2,0-.2.2-.2.2-.3h.2s0,.1,0,.1h.2c0,.1-.1.1-.1.2h1l-.2.2h0l.3.2h-.4l-.2.2c0,.1.1.1.1.2h-.2s0,0,0,0h-.2c0,.1.1.1.1.1h-.5C353.2,542.6,353,542.5,353,542.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.2 542.2 353.2 542.2 353.2 542.2 353.2 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,543.8h.1C354.4,544,354.3,543.9,354.4,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.3 542.2 353.3 542.2 353.3 542.2 353.3 542.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.3 542.1 353.3 542.1 353.3 542.1 353.3 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 542.1 353.4 542.1 353.4 542.1 353.4 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 542 353.4 542.1 353.4 542 353.4 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 542 353.4 542 353.4 542 353.4 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.5 542.1 353.5 542.1 353.5 542.1 353.5 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,543.4v-.2h.1v.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 541.9 353.4 541.9 353.4 541.9 353.4 541.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,542.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.6,541.9h0S353.5,541.9,353.6,541.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354 542.7 354 542.7 354 542.7 354 542.7 354 542.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354,542.6h0S354,542.6,354,542.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,546.6h.5c0,.1,0,.1.1.1h.1c-.2-.1-.3.1-.5,0s-.2,0-.2-.2S356.8,546.6,356.9,546.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.4,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.6,546a1,1,0,0,1,0-.4h.1a2.5,2.5,0,0,0-.1.4s0,.1-.1.1S356.6,546,356.6,546Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,544.3h.3c0,.1.1,0,.1.1h.1c0-.1.1-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.4c0,.2.2.1.3.3h-.2c0,.1,0,.1,0,.1h0l-.4-.2h-.1a.2.2,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.1s0-.1,0-.2v-.2h-.2c0,.1.1.1.1.2h-.3l-.2-.2A.4.4,0,0,1,356,544.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,543.8h0A.1.1,0,0,1,356.2,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,543.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,541.9l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 543.8 356.2 543.8 356.2 543.8 356.2 543.8 356.2 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,541.9h0S355.2,541.9,355.2,541.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.3,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,541.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.3 542 355.3 542 355.3 541.9 355.3 541.9 355.3 542"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.4,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.4,542h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.3 541.9 355.3 541.9 355.3 541.8 355.3 541.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355 541.3 355 541.3 354.9 541.3 355 541.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.3,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,543.1h0S356.1,543.1,356.1,543.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.6,542.1h.3v.2h-.2A.1.1,0,0,1,355.6,542.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.6,542.2h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.5 542 355.5 541.9 355.5 541.9 355.5 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.1 541.2 355.1 541.3 355.1 541.2 355.1 541.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.6 542.1 355.6 542.1 355.6 542.1 355.6 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 542.7 356 542.7 356 542.7 356 542.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.7 542.1 355.7 542.1 355.7 542.1 355.7 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 542.6 356 542.6 356 542.6 356 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.3,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,544.4h.1C357.8,544.6,357.7,544.5,357.8,544.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,542.7h.1A.1.1,0,0,1,356.8,542.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "345",
      "y": "539.2",
      "width": "4.3",
      "height": "8.39",
      "transform": "translate(-241.4 807) rotate(-81.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,541.9c0,.1.2.1.2.2s.1.3.1.5,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2l-.2.2H351l-.2.2s0,.1,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.2,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.3,0-.4h-.5l.3-.3h-.3l.3-.2a.9.9,0,0,0-.1-.4h.2c0-.1-.1,0-.2,0l.6-.4A.7.7,0,0,1,351.3,541.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 542.2 351.3 542.1 351.3 542.1 351.3 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.7,542a.1.1,0,0,1-.1.2h-.2c0-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.2 542.4 351.2 542.4 351.2 542.4 351.2 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 542.4 351.4 542.4 351.4 542.4 351.4 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 542.5 351.3 542.5 351.3 542.5 351.3 542.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 542.6 351.3 542.5 351.3 542.5 351.3 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 542.6 351.4 542.6 351.4 542.6 351.4 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.2 542.6 351.2 542.6 351.2 542.6 351.2 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,542.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 542.7 351.4 542.6 351.4 542.6 351.4 542.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,542.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,542.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,542.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 542.6 350.2 542.6 350.2 542.6 350.1 542.6 350.2 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,542.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.9,542.3c0,.1,0,.2,0,.2h-.2l-.2.3s0-.1,0-.2H343c.2-.1.2-.4.4-.5s.2-.2.4-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,542.5l.4.4s0,.1,0,.1h-.1l-.3-.4s-.1-.1,0-.1S344.6,542.4,344.7,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,543.3c0,.1-.1.2-.1.2h-.2c-.1-.1-.2.1-.2,0h-.1l.2.2h0c0,.1.1.1.1.1h-.1a.1.1,0,0,0,0,.2h-.1s-.1.1-.1.1h-.1c0,.1-.1.1-.1.1h0c-.2-.1-.3.1-.5.1s-.1-.2,0-.3h-.2s0-.1,0-.1h-.2l.5-.3s.1-.1.1-.1h-.2c-.1,0,0-.1,0-.1h.2v.2h.5c-.1-.1-.2.1-.3,0a.1.1,0,0,1,0-.1c.1,0,.2,0,.2-.1s-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,543.2c-.1,0,0,0,0-.1S345.3,543.2,345.2,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,543.9h-.2a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.2,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,544.4c.1.1,0,.3,0,.4s-.2.1-.3.2h.1s.1,0,0-.1h.1c-.1-.1,0,0,0-.1h0a.3.3,0,0,0,0-.3h0c0-.1-.1,0-.1-.1h0c-.1,0,0,.1-.1.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s.1-.1,0-.1a.5.5,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.2 543.9 347.2 543.9 347.2 544 347.2 544 347.2 543.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.5h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,544.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.8 544.5 349.8 544.5 349.8 544.6 349.8 544.6 349.8 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 544.6 349.9 544.6 350 544.6 349.9 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 544.7 350.8 544.7 350.8 544.7 350.7 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348,544.4a.3.3,0,0,1-.2.2.3.3,0,0,1-.1-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,544.7c0,.2-.1.2-.2.3h-.1a.3.3,0,0,0-.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,544.7h0c0,.1-.1.2,0,.2h0s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 544.8 349.7 544.7 349.7 544.8 349.6 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 544.9 350.7 544.9 350.7 544.9 350.7 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,544.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.4 544.8 349.4 544.7 349.4 544.7 349.4 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.5 544.6 348.5 544.6 348.5 544.6 348.5 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 544.8 349.3 544.8 349.4 544.8 349.3 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.6 544.7 348.6 544.6 348.6 544.7 348.6 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.3,545c0,.1,0,.1,0,.2h-.4c0-.1,0-.2.1-.2S345.3,544.9,345.3,545Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,545.4c0,.1,0,.1-.1.2h-.2v-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "342.9",
      "y": "544.1",
      "width": "4.2",
      "height": "8.28",
      "transform": "translate(-55.5 39.1) rotate(-6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.6,544.7c0-.1,0-.2.2-.2s.3-.1.4-.2h.2s-.1.1,0,.1.2-.1.3,0-.2.1-.2.2h.2s0-.1,0-.1h.1a.4.4,0,0,1,0,.2h.8s0,0,0,0-.3,0-.4.1,0,0,0,.1h-.1c0,.2.2.2.2.4l-.4-.2c.1,0,.1.2.1.2l-.3-.2-.4.2c0,.1.1.2,0,.2s0-.1,0-.2h-.4c-.1.1.1.1,0,.2l-.5-.4A.7.7,0,0,1,342.6,544.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.8 544.6 342.8 544.6 342.8 544.6 342.8 544.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.3,547.2h.2a.2.2,0,0,1,0,.2h-.1A.2.2,0,0,1,343.3,547.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343 544.7 343 544.7 343 544.7 343 544.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343 544.5 343 544.6 343 544.5 343 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.1 544.6 343.1 544.6 343.1 544.6 343.1 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.6 343.2 544.6 343.2 544.6 343.2 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.5 343.2 544.5 343.2 544.5 343.2 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.7 343.2 544.7 343.2 544.7 343.2 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.5,546.7a.9.9,0,0,1,0-.3h.1c0,.1,0,.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.4 343.2 544.4 343.2 544.4 343.2 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,546.6h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.4,544.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.5 545.7 343.5 545.6 343.5 545.6 343.5 545.7 343.5 545.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.6,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,551.7h.2c0,.1.1.1.1.1h.2c-.1.1,0,.2,0,.2s.1.1.1.2-.4-.1-.5-.3-.2-.2-.2-.3S344.7,551.8,344.7,551.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.1,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.1,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,550.9l.3-.5h.1s0,.1,0,.1l-.3.4h-.1C344.6,551,344.7,551,344.7,550.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,548.7h.4c0,.1.1.1,0,.2h.1c0-.1.2-.1.1-.2h.4s0,.1,0,.1h.3s0,.1,0,.1h.1c-.1.2.2.3.2.5h-.3c-.1.1,0,.1,0,.2h-.1c.1.1,0,.1,0,.2l-.4-.4h-.1v.2h-.1c0-.1.1-.1,0-.2v-.2c0-.1-.1-.2-.1-.3l-.2-.2c-.1.1.1.2.1.3h-.1c-.1,0-.1-.2-.2-.1H345a.3.3,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.4,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,548.2h0S345.4,548.2,345.5,548.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,545.4h.4c0,.1.2.1.2.2h-.3s0,0,0,0h-.2s0-.1,0-.1h-.1C345.2,545.5,345.2,545.4,345.2,545.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.5 548.2 345.5 548.1 345.5 548.1 345.5 548.2 345.5 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.3,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.3,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.3,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.4,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.4,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.4,545.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.4 545.5 345.4 545.5 345.5 545.5 345.5 545.5 345.4 545.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,545.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.5 545.4 345.4 545.4 345.5 545.3 345.5 545.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.4 544.6 345.4 544.6 345.4 544.5 345.4 544.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,545.5s0,0,0,0S345.5,545.5,345.5,545.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,547.3l.3.2h-.3C345.7,547.4,345.7,547.3,345.8,547.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,545.8c.1,0,.2.1.3.2s0,.1,0,.1l-.2.2h-.2c-.1-.1,0-.1-.1-.2A.1.1,0,0,1,345.7,545.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,546h.2s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.7 545.6 345.7 545.6 345.7 545.6 345.7 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.6 544.5 345.6 544.5 345.6 544.5 345.6 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 545.9 345.7 545.9 345.7 545.9 345.8 545.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 546.7 345.8 546.7 345.8 546.7 345.9 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 545.9 345.8 545.9 345.8 545.9 345.8 545.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 546.7 345.9 546.7 345.9 546.7 345.9 546.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,549.7h.2c.1.1.2.2.1.3H347C346.9,549.9,346.9,549.8,347,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,547.2h.2a.2.2,0,0,1,.1.2h-.2A.1.1,0,0,1,346.8,547.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347.7",
      "y": "552.2",
      "width": "7.6",
      "height": "3.89",
      "transform": "translate(-290.1 691.9) rotate(-69.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,558.1h-.2c-.2.1-.3,0-.4,0h-.2s.1,0,.1-.1h-.1v-.2s0,.1,0,.1h0l-.2-.2h-.1c-.1,0,0-.2-.1-.2h-.2s0,0,0,0h.4s0-.1,0-.1h.1c.1-.1-.1-.3-.1-.4l.2.3c-.1-.1,0-.2,0-.3v.3h.4s0-.2.1-.2-.1.1-.1.2h.1s0,.1.1.1h.1c.1,0,0-.1,0-.2s.2.4.3.6S352.3,558,352.1,558.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 558.1 351.9 558.1 351.9 558.1 351.9 558.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,555.8h-.1v-.2h.1A.1.1,0,0,1,352.5,555.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.7 558 351.8 558 351.7 558 351.7 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.7 558.1 351.7 558.1 351.7 558.1 351.7 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.6 558 351.6 558 351.6 558 351.6 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.6 558 351.6 558 351.6 558 351.6 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 558.1 351.5 558.1 351.5 558.1 351.5 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 557.9 351.6 557.9 351.5 557.9 351.5 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,556.1v.3h0v-.3S352.2,556.1,352.2,556.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 558.1 351.5 558.1 351.5 558.1 351.4 558.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,556.2h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.7,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,557.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.7 557 351.7 557 351.7 557 351.7 557 351.7 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.6,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,551.5H353c0-.1,0-.1,0-.2l-.2-.3h.2c.1,0,.1-.1.1-.2s-.1-.1,0-.2.3.2.3.4.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,556.8s0,0,0,0S351.2,556.8,351.2,556.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,552.1l-.4.3h0l.4-.2h.1C353,552.1,352.9,552.1,352.8,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,553.9h-.2v-.2c.1,0,0-.1.1-.2s0-.1,0-.1h-.8c.1-.2-.1-.3,0-.4h.3c.1,0,.1-.1.1-.1h.1c0-.1.1-.1,0-.2s.2.3.2.5h.1c-.1.1,0,.2,0,.3v.2c.1,0,0-.2.1-.2h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.1,554.2H351a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,556.5h-.3c0-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1H350a.4.4,0,0,1,.3.3C350.3,556.4,350.2,556.5,350.2,556.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.1 554.1 351.1 554.1 351.1 554.1 351.1 554.1 351.1 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,556.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.1 556.3 350.1 556.3 350 556.3 350 556.3 350.1 556.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,556.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 556.4 350 556.4 350 556.4 350 556.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.7 557.1 349.7 557.1 349.7 557.1 349.7 557.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,554.7a.2.2,0,0,1-.2-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,556c-.1,0-.1-.2-.2-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,555.8s0,0,0,0h-.1s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,555.7s0,0,0,0S350.1,555.7,350.1,555.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 556.1 349.9 556.2 349.9 556.1 349.9 556.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 557.1 349.6 557.1 349.6 557.1 349.6 557.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,554.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.9 555.9 350 555.9 350 555.9 349.9 555.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.2 555.1 350.2 555.1 350.2 555.1 350.2 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 555.9 350 555.9 350 555.9 350 555.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.2 555.2 350.2 555.2 350.2 555.2 350.2 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,557h0S349.3,557,349.3,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,552.2h-.2c0-.1-.1-.2,0-.3h.3C350.6,552,350.6,552.2,350.5,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,554.4h-.1a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,349.6,554.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "343.5",
      "y": "559.6",
      "width": "6.6",
      "height": "3.35",
      "transform": "translate(-242.1 263.9) rotate(-31.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.5,558.3h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.1.1.2H349a.4.4,0,0,0,0,.2h.1s0,0,0,.1H349a.2.2,0,0,0,0,.2h0c0,.1-.1.1,0,.2h0c-.1-.1-.1-.2-.2-.3h-.1c-.1.1-.1.2-.2.3a.9.9,0,0,0,0-.3v-.1l-.2-.2h0s.1-.1,0-.1h0s.1-.1,0-.1H348c.1-.2,0-.4.1-.5S348.3,558.3,348.5,558.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.6 558.4 348.6 558.4 348.6 558.4 348.6 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,559.6a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.7 558.6 348.7 558.6 348.7 558.6 348.7 558.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.5 348.8 558.5 348.8 558.5 348.8 558.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.6 348.8 558.6 348.8 558.6 348.8 558.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.7 348.8 558.6 348.8 558.6 348.8 558.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 558.7 348.9 558.6 348.9 558.7 348.9 558.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.7 348.8 558.7 348.8 558.7 348.8 558.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,559.6h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 558.7 348.9 558.6 348.9 558.6 348.9 558.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.3,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,558.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.2 559.3 348.2 559.3 348.2 559.3 348.2 559.3 348.2 559.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.3,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,562.2h.1c-.1,0,0,.1-.1.1a1.1,1.1,0,0,0,0,.3h-.2v.2c.1-.2-.1-.3,0-.5s0-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.8s0,0,0,.1S348.1,559.8,348.2,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.4,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.8,561.9h.4s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,561.3v.2a.3.3,0,0,1,0,.2h-.1s-.1.1,0,.1h.2s0,0,0,0h.1s0,.1,0,.1h0s0,.1,0,.1h-.1s0,.1,0,.1h-.1c-.2,0-.1.2-.3.3v-.2H346c.1-.1.1-.3.2-.4s0-.1,0-.1h0l.2-.2v-.2c-.1,0-.1.1-.2.1h0c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,562.1c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.1,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,560.4c.1,0,.1.2.2.3s0,.2-.1.2h0s0-.1,0,0h0v-.2s0,0,0,.1h0s.1,0,0,.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.1 561.5 347.1 561.5 347.1 561.6 347.1 561.6 347.1 561.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.9 560.6 348.9 560.6 348.9 560.6 348.9 560.6 348.9 560.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,560.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,560.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349 560.6 349 560.6 349 560.6 349 560.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 560.3 349.6 560.2 349.6 560.2 349.6 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.8,561.4a.2.2,0,0,1,0,.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.8,560.9c.1.1,0,.2,0,.3h-.2a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.7,560.9h0s0,.2.1.1h0s0,0,0,.1h-.1s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.6,561h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.9 560.8 348.9 560.8 348.9 560.8 348.9 560.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.7 560.4 349.6 560.4 349.7 560.4 349.7 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.7,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.6,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.7,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.6,561h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 560.9 348.8 560.9 348.8 560.9 348.8 560.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.2 561.3 348.2 561.3 348.2 561.3 348.2 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 561 348.8 561 348.8 560.9 348.8 561"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.2 561.3 348.2 561.3 348.2 561.3 348.2 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,563.1h.1c0,.1-.1.2-.1.2h-.1s-.1-.1-.1-.2S346.4,563.1,346.5,563.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,562.1c.1,0,0,.1,0,.1h-.2a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "350.6",
      "y": "560",
      "width": "6.5",
      "height": "3.35",
      "transform": "translate(-250.2 286.5) rotate(-33.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.3,564.7h-.2c-.2,0-.2-.2-.3-.2s0-.1,0-.1h0c0-.1-.1-.1-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.2.2,0,0,0,0-.2h0c0-.1.1-.1,0-.2h.1s0,0,0-.1h-.1c.1.1.1.2.2.2h.1c.1-.1.1-.2.2-.3a.9.9,0,0,0,0,.3v.1l.2.2h0s-.1.1,0,.1h0s-.1.1,0,.1h.2c-.1.2,0,.4-.1.5S352.4,564.7,352.3,564.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 564.5 352.1 564.5 352.1 564.5 352.1 564.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.7,563.3a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 564.4 352.1 564.4 352.1 564.4 352.1 564.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 564.4 352 564.4 352 564.4 352 564.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 564.3 352 564.3 352 564.3 352 564.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 564.3 351.9 564.3 351.9 564.3 351.9 564.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.8 564.3 351.9 564.3 351.9 564.3 351.8 564.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 564.2 352 564.2 352 564.2 352 564.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.3,563.3h-.2s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.8 564.3 351.8 564.3 351.8 564.3 351.8 564.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.2,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.3,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.2,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.5,563.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,564.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.6 563.7 352.6 563.7 352.6 563.7 352.6 563.6 352.6 563.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.4,563.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,560.6h-.1c.1,0,0-.1.1-.1a1.1,1.1,0,0,0,0-.3h.2v-.2c-.1.2.1.3,0,.5s0,.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.2,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563.1s0,0,0-.1S352.6,563.1,352.6,563.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.3,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,560.9h-.4s-.1,0,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,561.5v-.2a.3.3,0,0,1,0-.2h.1s.1-.1,0-.1H354s0,0,0,0h-.1s0-.1,0-.1h0s0-.1,0-.1h.1s0-.1,0-.1h.1c.2,0,.1-.2.3-.3l.2.2h.3c-.1.1-.1.3-.1.4s0,.1,0,.1h0l-.2.2v.2c.1,0,.1-.1.2-.1h0c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,560.8c.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.6,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.6,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,562.6c-.1,0-.1-.2-.2-.2s0-.2.1-.2h0s0,.1,0,0h0v.2h0s-.1,0,0-.1h0s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.4.4,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.6 561.3 353.6 561.4 353.6 561.3 353.6 561.3 353.6 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 562.4 351.8 562.4 351.8 562.3 351.8 562.3 351.8 562.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,562.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,562.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.7 562.4 351.7 562.4 351.7 562.4 351.7 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.1 562.7 351.1 562.7 351.1 562.8 351.1 562.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.9,561.5a.2.2,0,0,1,0-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,562.1c-.1-.1,0-.2,0-.3h.3c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,562h0s0-.1-.1-.1h0s0,0,0-.1h.1s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,562h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 562.2 351.8 562.2 351.7 562.2 351.8 562.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 562.6 351.1 562.6 351.1 562.6 351 562.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 562 351.9 562 351.9 562 351.9 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.5 561.6 352.5 561.6 352.5 561.6 352.5 561.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 562 351.9 562 351.9 562 351.9 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.4 561.6 352.4 561.6 352.4 561.6 352.4 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,559.7h-.1c0-.1,0-.2.1-.2h.1s.1.1.1.2S354.3,559.8,354.2,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.4,560.8c-.1,0,0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "354.5",
      "y": "565.2",
      "width": "8.4",
      "height": "4.32",
      "transform": "translate(-107.5 84.5) rotate(-11.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,570.2c-.1,0-.2,0-.2-.1s-.2-.3-.2-.4,0-.1,0-.1h0c.1-.1-.1-.2-.1-.3s.1.2.2.2V569h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.3s-.1-.1-.1-.2h.1c.1.1,0,.2.1.2h0c-.1-.1,0-.1-.1-.2h0c.1.1,0,.3.2.4h.1c.2,0,.2-.2.3-.3a1.2,1.2,0,0,0-.2.4l.2-.2-.2.3.2.4h0s-.1.1-.1.1h0c.1.1.1-.1.2,0l-.4.6A.7.7,0,0,1,355.4,570.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.3 570 355.3 570 355.3 570 355.3 570"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,569.2a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.3 569.7 355.3 569.8 355.3 569.7 355.3 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.8 355.2 569.8 355.2 569.8 355.2 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.6 355.2 569.6 355.2 569.6 355.2 569.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.6 355.2 569.6 355.2 569.6 355.2 569.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 569.5 355.1 569.6 355.1 569.6 355.1 569.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.5 355.3 569.5 355.3 569.5 355.2 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,569.1H357s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 569.5 355 569.6 355 569.5 355 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 569.1 356.2 569.1 356.2 569.1 356.2 569.1 356.2 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,567.3c-.1-.1-.1-.2-.1-.2h.1a1.4,1.4,0,0,0,.1-.4s0,.1.1.2h.4c-.2.1,0,.4-.2.6s-.1.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.5s0-.1,0-.1S356.5,568.5,356.5,568.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,567.3l-.5-.2s0-.1,0-.1h.1l.5.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.4h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,567.3c-.1-.1,0-.2,0-.2v-.2c.1,0,.1-.1.2,0h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.2.4-.2s.1.2.1.3h.4c-.2.1-.2.4-.4.5s-.1.1,0,.1h-.4l-.2.2c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,566.9c.1,0,0,0,0,.1S360.7,566.9,360.7,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,566.9a.2.2,0,0,1,0-.1h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.6,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567.4c-.1-.1-.1-.3-.1-.4s.1-.2.2-.3h0s0,0,0,.1h0s-.1.1,0,.1h-.1a.3.3,0,0,0,.1.3s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s0,.1,0,.1a.5.5,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "358.6",
      "y": "566.8",
      "height": "0.02",
      "transform": "translate(-101.3 78.6) rotate(-11)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,567.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567.3h0S355.8,567.3,355.8,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,567.2h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.9 567.2 355.9 567.2 355.9 567.2 355.9 567.2 355.9 567.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.8 567.2 355.7 567.2 355.7 567.2 355.8 567.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.9 567.3 354.9 567.4 354.9 567.4 354.9 567.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,566.7a.3.3,0,0,1,.1-.3v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,566.9c-.1-.1.1-.2.1-.3h.1l.2.2a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,566.9h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 566.9 355.9 567 356 566.9 356 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.9 567.2 354.9 567.2 354.9 567.2 354.9 567.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,566.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 566.8 356.2 566.9 356.2 566.9 356.2 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.1 566.6 357.1 566.7 357.1 566.7 357.1 566.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.3 566.8 356.3 566.8 356.2 566.8 356.3 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357 566.6 357 566.7 357 566.6 357 566.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,565.2c-.1-.1,0-.1,0-.2s.1-.2.3-.1h.1c0,.1.1.1,0,.2S360.1,565.3,360,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,565.7c0-.1,0-.1,0-.2h.3a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "356.1",
      "y": "554.9",
      "width": "8.4",
      "height": "4.29",
      "transform": "translate(-275.9 745) rotate(-73.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,561.3H361c-.2.1-.3,0-.5,0h-.2c0-.1.1,0,.1-.1s-.2,0-.3-.1h.2l-.2-.2s0,.1,0,.1h0v-.2l-.2-.2h-.1c-.1,0-.1-.2-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0-.1,0-.1h.1c.1-.2-.1-.3-.1-.4l.3.3c-.1-.1,0-.2,0-.3v.3h.4c.1-.1,0-.2.1-.2s-.1.1,0,.2v.2h0s0,.1.1.1h.1c.1,0,0-.1,0-.2s.3.4.3.6A.7.7,0,0,1,361.2,561.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 561.3 361 561.3 360.9 561.3 360.9 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.4,558.7h-.1v-.2h.1A.2.2,0,0,1,361.4,558.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 561.2 360.8 561.2 360.7 561.2 360.7 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 561.3 360.7 561.3 360.7 561.3 360.7 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 561.2 360.6 561.3 360.6 561.3 360.6 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 561.2 360.6 561.2 360.6 561.2 360.5 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 561.3 360.5 561.3 360.5 561.3 360.5 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 561.1 360.5 561.1 360.5 561.1 360.5 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.1,559.1v.3h0v-.3S361.1,559.1,361.1,559.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.4 561.3 360.4 561.3 360.4 561.3 360.4 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361,559.2h0c.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.6,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,561.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 560.1 360.7 560.1 360.6 560.1 360.6 560.1 360.7 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,553.9h-.2c0-.1-.1-.1,0-.2l-.3-.3h.2c.1,0,.1-.1.1-.2s-.1-.2,0-.2.3.2.4.4.2.3.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.1,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.1,560s0,0,0,0S360.1,559.9,360.1,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,554.7l-.5.3h0l.4-.3h.1C361.7,554.6,361.6,554.7,361.5,554.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.1,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.1,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,556.7h-.2v-.2c.1-.1-.1-.2.1-.2s0-.1-.1-.1l-.2.2h-.7c.1-.2-.1-.3,0-.5h.3c.1,0,.1-.1.1-.2h.1c0-.1.1-.1,0-.2s.2.3.2.6h.4c0,.1-.1.1-.1.2h-.2c-.1.1,0,.2,0,.3v.3c.1,0,0-.2.1-.3h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,557.1h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,557h0S359.8,557,359.8,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,559.7h-.4c0-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2a.5.5,0,0,1,.3.3C359,559.6,359,559.6,358.9,559.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.7 557 359.7 557 359.7 557 359.7 557 359.7 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,559.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 559.5 358.8 559.5 358.8 559.5 358.8 559.5 358.8 559.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,559.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.7 559.6 358.7 559.6 358.7 559.6 358.7 559.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 560.4 358.5 560.4 358.5 560.4 358.5 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,557.7a.3.3,0,0,1-.2-.2h.3C359.3,557.6,359.3,557.7,359.2,557.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,559.1c-.2,0-.2-.2-.2-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,558.9s0,0,0,0h-.2s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.8s0,0,0,0S358.7,558.8,358.7,558.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.6 559.3 358.6 559.3 358.6 559.3 358.6 559.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.3 560.3 358.3 560.3 358.3 560.3 358.3 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,559h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,557.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,559h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.6 559 358.6 559 358.6 559 358.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 558.2 358.9 558.2 358.9 558.2 358.9 558.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.6 559 358.6 559 358.6 559 358.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 558.2 358.9 558.2 358.8 558.2 358.8 558.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,560.3h0S357.9,560.3,357.9,560.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,554.9h-.2c0-.1-.1-.2,0-.3h.3C359.1,554.7,359.1,554.9,358.9,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.2,557.4H358a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,358.2,557.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "365.6",
      "y": "559.2",
      "width": "7.6",
      "height": "3.89",
      "transform": "translate(-301.9 536) rotate(-54.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,565.1h-.2c-.2,0-.3-.1-.4-.1s-.1-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2v-.2H368s0,0,0-.1h.1v-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0-.1,0-.1h-.1l.4.2h.1c.1-.1,0-.3.1-.4a1.1,1.1,0,0,0,.1.4c0-.1,0-.2,0-.3a.9.9,0,0,1,0,.3h.4c.1,0,.1-.2.1-.1v.2s0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.1.4.1.6S369.1,565,369,565.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.8 565 368.8 565 368.8 565 368.8 565"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,562.9h.1C370.1,562.8,370,562.9,369.9,562.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.6 564.8 368.6 564.8 368.6 564.8 368.6 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.6 564.9 368.6 564.9 368.6 564.9 368.6 564.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.5 564.8 368.5 564.8 368.5 564.8 368.5 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 564.8 368.5 564.8 368.5 564.8 368.4 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 564.8 368.4 564.9 368.4 564.9 368.4 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.5 564.7 368.5 564.7 368.5 564.7 368.5 564.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.5,563.2l-.2.2h0l.2-.2S369.6,563.2,369.5,563.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 564.9 368.3 564.9 368.3 564.9 368.3 564.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.5,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.5,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.4,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,564.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.9 563.9 368.9 563.9 368.9 563.9 368.9 563.8 368.9 563.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.8,558.9h-.2c.1-.1,0-.1,0-.2l-.2-.3h.1c.1,0,.1-.1.1-.2s0-.2,0-.2.2.3.2.5.1.3-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,563.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,563.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.7,560.9h-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.5s0-.1,0-.1h-.2c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.5c0-.1.1-.1.1-.2s.1.4,0,.5,0,.1.1.1h0v.2a.8.8,0,0,0,0,.3c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,561H369s0-.1,0-.1h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,563c-.1,0-.2-.1-.3-.2s0-.2,0-.3h.3s0-.1,0-.1h0l-.2-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369 560.9 369 560.9 369 560.9 369 560.9 369 560.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.8s0,0,0,0S367.6,562.8,367.6,562.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,562.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.5 562.8 367.5 562.8 367.4 562.8 367.4 562.8 367.5 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 562.9 367.4 562.9 367.3 562.9 367.4 562.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.9 563.5 366.9 563.5 366.9 563.5 366.9 563.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,562.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,561.4a.2.2,0,0,1-.1-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.5c-.1-.1-.1-.2-.1-.3h.4c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.3,562.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.3h-.1s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 562.6 367.4 562.6 367.4 562.6 367.4 562.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.8 563.4 366.8 563.4 366.8 563.4 366.8 563.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.5 562.3 367.5 562.4 367.5 562.4 367.5 562.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 561.7 367.9 561.7 367.9 561.7 367.9 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.5 562.3 367.5 562.3 367.5 562.3 367.5 562.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 561.7 367.9 561.7 367.9 561.7 367.9 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.3,562.6h0S367.3,562.6,367.3,562.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.5,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,558.9h-.1c0-.1,0-.2.1-.3h.2C369.1,558.8,369.1,559,368.9,558.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,560.8h-.1a.2.2,0,0,1,.1-.2h.2C367.7,560.8,367.6,560.9,367.5,560.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "369.4",
      "y": "552",
      "width": "4.4",
      "height": "8.66",
      "transform": "translate(-220.6 867.5) rotate(-84)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,554.6c0,.1.2.1.2.2s.1.3.1.5,0,.1,0,.1,0,.1,0,.1H376c-.1.1,0,.2,0,.3s0-.2-.1-.2l-.2.2h-.1l-.2.2s0,.1,0,.1-.2.1-.2.2,0,.1,0,.2h-.1c-.1-.1,0-.2-.1-.2H375c0,.1,0,.1,0,.2H375c0-.1.1-.3,0-.4h-.1c-.2,0-.3.1-.4.2l.3-.3h-.3l.3-.2a1,1,0,0,0-.1-.4h.1s.1,0,.1-.1h0c0-.1-.1,0-.2,0l.6-.5A.7.7,0,0,1,375.8,554.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 554.8 375.8 554.8 375.8 554.8 375.8 554.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.1,554.8a.1.1,0,0,1-.1.2h-.2c0-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 555.1 375.8 555 375.7 555.1 375.7 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.9 555.1 375.9 555.1 375.9 555.1 375.9 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 555.2 375.8 555.2 375.8 555.2 375.8 555.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 555.3 375.8 555.2 375.8 555.2 375.8 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.9 555.3 375.9 555.3 375.9 555.3 375.9 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 555.3 375.7 555.3 375.7 555.3 375.7 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,555.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376 555.4 376 555.3 376 555.3 376 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,555.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 555.4 374.7 555.4 374.7 555.4 374.6 555.4 374.6 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,555.3c.1.1,0,.2,0,.2H368l-.2.3s0-.1,0-.2h-.4c.2-.1.2-.4.4-.5s.2-.2.4-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,555.5l.4.4s0,.1,0,.1h-.1l-.4-.4s-.1-.1-.1-.1S369,555.4,369,555.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.3,556.2c0,.1-.1.2,0,.2H371c-.1-.1-.2.1-.2,0h-.1l.2.2h-.1a.1.1,0,0,0,0,.2h-.1s-.1.1-.1.1h-.1c0,.1-.1.1-.1.1h-.1c-.2-.1-.3.1-.5.1s-.1-.2,0-.3h-.2s0-.1,0-.2h-.2l.5-.3s.1-.1.1-.1H370c-.1,0,0-.1,0-.1h.2v.2h.3l.2-.2c-.1-.1-.2.1-.3,0a.1.1,0,0,1,0-.1c.1,0,.2,0,.2-.2s-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.6,556.1c-.1,0,0,0,0-.1S369.6,556.1,369.6,556.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.7,556.8h-.2a.1.1,0,0,1,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.7,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,557.2c.1.1,0,.3,0,.4s-.2.2-.3.2h.1s.1,0,0-.1h.1c-.1-.1,0,0,0-.1h0a.3.3,0,0,0,0-.3h0c0-.1-.1,0-.1-.1h0c-.1,0,0,.1-.1.1s0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.3s.1-.1,0-.2a.5.5,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.7 556.9 371.7 556.9 371.7 556.9 371.6 556.9 371.7 556.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.4 557.4 374.4 557.4 374.4 557.4 374.4 557.4 374.4 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.5 557.4 374.5 557.4 374.5 557.4 374.5 557.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 557.5 375.4 557.5 375.4 557.5 375.4 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.5,557.3a.3.3,0,0,1-.2.2.4.4,0,0,1-.1-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,557.6c0,.2-.1.2-.2.3h-.1v-.2a.2.2,0,0,1,.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,557.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,557.5h0c0,.1-.1.2,0,.2h0s0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,557.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.2 557.6 374.3 557.6 374.2 557.6 374.2 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.3 557.7 375.3 557.7 375.3 557.7 375.3 557.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,557.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,557.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374 557.6 373.9 557.6 374 557.6 374 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373 557.5 373 557.5 373.1 557.5 373 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.9 557.6 373.9 557.6 373.9 557.6 373.9 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.1 557.6 373.1 557.5 373.1 557.6 373.1 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,558.1c0,.1,0,.1,0,.2h-.4c0-.1,0-.2.1-.2S369.7,557.9,369.8,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.4,558.4c0,.1,0,.1-.1.2h-.3v-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "367.5",
      "y": "548.4",
      "width": "6.9",
      "height": "3.51",
      "transform": "translate(-288.3 474.8) rotate(-49.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.2,553.7H370l-.4-.2c0-.1,0-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2V553h-.1s0,0,0-.1h.1a.3.3,0,0,0-.1-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0,0,0-.1h-.1l.3.2h.1c.1-.1,0-.2.1-.3a.9.9,0,0,0,.1.3c0-.1,0-.2.1-.2a.8.8,0,0,1,0,.3h.3s0,.1,0,.1h0s0,.1,0,.1h.1s0,0,0,.1,0-.1.1-.1.1.4,0,.6S370.3,553.6,370.2,553.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370 553.6 370 553.6 370 553.6 370 553.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,551.8h.1C371.4,551.7,371.3,551.8,371.2,551.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.9 553.4 369.9 553.4 369.9 553.4 369.9 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 553.5 369.8 553.5 369.8 553.5 369.8 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 553.4 369.8 553.4 369.8 553.4 369.8 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 553.4 369.7 553.4 369.7 553.4 369.7 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 553.4 369.7 553.4 369.7 553.4 369.6 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 553.3 369.8 553.3 369.8 553.3 369.7 553.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.8,552l-.2.2h0l.2-.2S370.9,552,370.8,552Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 553.4 369.6 553.4 369.6 553.4 369.6 553.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.8,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.8,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.7,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.1,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.6,553.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 552.6 370.2 552.6 370.2 552.5 370.2 552.5 370.2 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.2,548.4H373c.1,0,0-.1,0-.1v-.3h.2c0-.1,0-.1,0-.2s.2.3.2.5,0,.2-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,550H371a.3.3,0,0,1,0-.2c.1,0,0-.1.1-.1s0-.1,0-.1h-.2s0,0,0-.1h-.2s0-.1,0-.1h-.1c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.5c0,.1,0,.3,0,.5s0,.1.1.1h0v.2a.7.7,0,0,0,0,.2c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,550h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.6,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.7l-.3-.2c.1-.1,0-.2,0-.3h.3s0-.1,0-.1H369s0-.1,0-.1h0v-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.6 549.9 370.6 549.9 370.5 549.9 370.5 549.9 370.6 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.5s0,0,0,0S369.1,551.5,369.1,551.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369 551.5 369 551.5 369 551.5 369 551.5 369 551.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369,551.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.9 551.5 368.9 551.5 368.9 551.5 368.9 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.5 552 368.5 552 368.5 552.1 368.5 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,550.3a.2.2,0,0,1-.1-.2h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.2c-.1-.1-.1-.2-.1-.3h.3c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.9 551.3 368.9 551.3 368.9 551.3 368.9 551.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.4 551.9 368.4 552 368.4 552 368.4 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.9,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369 551.1 369.1 551.1 369.1 551.1 369 551.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.5 550.5 369.5 550.5 369.5 550.5 369.5 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 551.1 369.1 551.1 369 551.1 369.1 551.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.5 550.5 369.5 550.6 369.5 550.6 369.5 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.3h0S368.9,551.3,368.9,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,548.1h-.1c0-.1,0-.2.1-.2h.2C370.8,548,370.8,548.2,370.6,548.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,549.7h.2C369.4,549.7,369.3,549.8,369.2,549.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.5",
      "y": "543.5",
      "width": "8.4",
      "height": "4.27",
      "transform": "translate(-248.3 773.7) rotate(-76)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.6,541.4h.2c.2-.1.3,0,.5,0h.2c0,.1-.1,0-.1.1s.2,0,.3.1h-.2l.2.2s0-.1,0-.1h0v.2l.2.2h.1c.1,0,.1.2.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0H371s0,.1,0,.1h-.1c-.1.2.1.3.1.4l-.3-.3c.1.1,0,.2.1.3l-.2-.3h-.4c0,.1,0,.2-.1.2s.1-.1,0-.2H370s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.3-.4-.4-.6A.7.7,0,0,1,369.6,541.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 541.4 369.8 541.4 369.8 541.4 369.8 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.4,544h.1v.2h-.1A.2.2,0,0,1,369.4,544Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370 541.5 370 541.5 370 541.5 370 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 541.4 370 541.4 370.1 541.4 370.1 541.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 541.5 370.2 541.5 370.2 541.5 370.2 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 541.5 370.2 541.5 370.2 541.5 370.2 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 541.4 370.3 541.4 370.3 541.4 370.3 541.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 541.6 370.2 541.6 370.2 541.6 370.3 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,543.6v-.3h0c-.1.1-.1.2-.1.3S369.7,543.6,369.8,543.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 541.4 370.3 541.4 370.3 541.4 370.3 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,543.5h0c-.1,0,0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.2,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.5,541.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 542.6 370.2 542.6 370.2 542.6 370.2 542.6 370.2 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.3,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,548.8h.2c0,.1.1.1,0,.2l.3.3h-.2c-.1,0-.1.1-.1.2s.1.1.1.2-.3-.2-.4-.4-.2-.2-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.7,542.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.7,542.7s0,0,0,0S370.7,542.7,370.7,542.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.5,548l.4-.3h0l-.4.3h-.1C369.4,548.1,369.5,548.1,369.5,548Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.5,546h.2v.2c-.1.1.1.2-.1.2s0,.1.1.1l.2-.2h.7s0,0,0,.1h0c-.1.2.1.3,0,.5h-.3c-.1,0-.1.1-.1.2h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.4c0-.1.1-.1.1-.2h.2c0-.1,0-.2,0-.3v-.3c-.1.1,0,.2,0,.3h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.2,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,545.6h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.2,545.7h0S371.1,545.7,371.2,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.9,542.9h.4c0,.1.1.2.1.3h-.2s0-.1,0-.1h-.1s0,0,0,0H372s0,.1,0,.1h.2a.5.5,0,0,1-.4-.2C371.8,543.1,371.9,543,371.9,542.9Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "371.2",
      "y": "545.7",
      "height": "0.02",
      "transform": "translate(-247.1 776.4) rotate(-76.2)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.9,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,543s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372 543.1 372 543.1 372.1 543.1 372.1 543.1 372 543.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 543 372.1 543 372.1 543 372.1 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.3 542.2 372.3 542.2 372.3 542.2 372.3 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.7,544.9a.3.3,0,0,1,.2.2h-.3C371.6,545,371.6,544.9,371.7,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,543.5c.2,0,.2.2.3.3H372c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.7s0,0,0,0h.2s0,0,0,.1h0s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.8h0S372.1,543.8,372.1,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.2 543.3 372.2 543.3 372.2 543.3 372.2 543.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.5 542.3 372.5 542.3 372.5 542.3 372.5 542.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 543.6 372.2 543.6 372.2 543.6 372.2 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372 544.4 372 544.4 372 544.4 372 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 543.6 372.2 543.6 372.2 543.6 372.2 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 544.4 372 544.4 372 544.4 372.1 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.3,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,542.3h0S372.8,542.3,372.9,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,547.7h.2c0,.1.1.2,0,.3H372C371.9,547.9,371.9,547.7,372.1,547.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.8,545.2h.2a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,372.8,545.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "365",
      "y": "544.8",
      "width": "3.5",
      "height": "6.89",
      "transform": "translate(-274.3 703.6) rotate(-69.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,547.7s.1.1.1.2,0,.3,0,.4,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.3s0-.2-.1-.2h-.4s0,0,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.2.1-.3h-.1a.1.1,0,0,0,0-.1h-.4l.3-.2h0a.8.8,0,0,0,0-.3h.1l.5-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 547.9 370.3 547.9 370.3 547.9 370.3 547.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 548.1 370.2 548 370.1 548.1 370.1 548.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 548.1 370.3 548.1 370.3 548.1 370.3 548.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 548.2 370.2 548.2 370.2 548.2 370.2 548.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 548.2 370.2 548.2 370.2 548.2 370.2 548.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 548.3 370.2 548.3 370.2 548.3 370.2 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 548.2 370.1 548.2 370.1 548.2 370.1 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,547.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 548.3 370.3 548.3 370.3 548.3 370.3 548.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,547.7s0,0,0,0h0S368.6,547.7,368.6,547.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.5,547.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.4,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.1,548.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.2 548.1 369.2 548.1 369.2 548.1 369.2 548.1 369.2 548.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.3,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.3,546.8c0,.1,0,.1,0,.2h-.1l-.2.2s.1-.1,0-.1h-.4c.2,0,.2-.3.4-.3h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,547.1l.2.4H365l-.2-.4s-.1-.1,0-.1S364.8,547,364.8,547.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,548.5h0S368.7,548.5,368.7,548.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.5,548.1v.2H366c0,.1,0,.2.1.2h0s0,.1,0,.1H366c0,.1.1,0,0,.1H366a.1.1,0,0,0-.1.1h-.3s0-.1,0-.1-.3.1-.4,0,0-.2,0-.2H365l.5-.2h0s0-.1,0-.1h.4a0,0,0,0,1,0-.1c.1,0,.2,0,.2-.1s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.2,547.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.7,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.7,548.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,549.5c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0a.3.3,0,0,0,.1-.2h0c0-.1-.1,0,0-.1h-.2v.2s.1-.1,0-.1a.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 548.7 366.6 548.7 366.6 548.7 366.6 548.7 366.6 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.5h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,549.6h0S368.8,549.6,368.8,549.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.6 549.6 368.7 549.6 368.6 549.6 368.6 549.6 368.6 549.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.7 549.6 368.7 549.6 368.8 549.7 368.7 549.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.4 549.9 369.4 549.9 369.4 549.9 369.4 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,549.2H367a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,549.7c0,.1-.1.1-.2.2h-.1a.2.2,0,0,0-.1-.2h.3A.1.1,0,0,1,368.4,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,549.6h0s-.1.1-.1.1h-.1s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.5 549.7 368.5 549.7 368.5 549.7 368.5 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.3 550 369.3 550 369.3 550 369.3 550"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,549.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 549.7 368.3 549.7 368.3 549.7 368.3 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 549.4 367.6 549.4 367.6 549.4 367.6 549.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.2 549.7 368.2 549.7 368.3 549.7 368.2 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 549.5 367.6 549.5 367.6 549.5 367.6 549.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,549.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.9,549.2h-.3v-.2C364.8,549.1,364.9,549.1,364.9,549.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,550h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "360.7",
      "y": "546.1",
      "width": "3.9",
      "height": "7.67",
      "transform": "translate(-290.8 466.7) rotate(-49.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.6,550.8c0,.1.1.2,0,.2s-.1.3-.2.4h-.1s0-.1-.1-.1-.1.2-.2.2.1-.2,0-.2h-.8v.2h-.1c0-.1.1-.1.1-.2h-.1v.2h0c0-.1.2-.2.2-.3h0v-.3c0-.1-.2-.1-.1-.2h.3s0,0,0,0h.2c0-.1-.1,0-.1-.1h.6C366.3,550.5,366.5,550.6,366.6,550.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 551 366.5 551 366.5 551 366.5 551"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,549.6h-.2C364.4,549.4,364.5,549.5,364.5,549.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.1 366.3 551.1 366.3 551.1 366.3 551.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.4 551.2 366.4 551.2 366.4 551.2 366.4 551.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.2 366.3 551.2 366.3 551.2 366.3 551.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.3 366.3 551.3 366.3 551.3 366.3 551.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.4 366.3 551.3 366.3 551.4 366.3 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.2 551.3 366.2 551.2 366.2 551.2 366.2 551.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,550l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.4 366.3 551.4 366.3 551.4 366.3 551.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.7,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.5,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.1,551.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.3 550.7 365.3 550.8 365.3 550.8 365.3 550.8 365.3 550.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.3,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,547.4v.2h-.8c.2.1.3-.2.5-.2s.3,0,.3.1S360.7,547.4,360.7,547.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.1,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,548a1.3,1.3,0,0,1,.1.5h-.1a3,3,0,0,0-.1-.5s0-.1,0-.1S361.2,547.9,361.2,548Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,549.7l-.2.2h-.2c0-.1-.2,0-.1-.1h-.1c0,.1,0,.2,0,.2h-.1s0,.1,0,.1h-.2c0,.1.1.1,0,.1h-.5s0-.1,0-.1-.3-.1-.4-.2,0-.2.1-.2-.1-.1-.1-.1h.6v-.2c0-.1.1-.1,0-.1h.1c0,.1,0,.1,0,.2h.5c0-.1-.2,0-.2-.1h.2s0-.1.1-.1h.3A.5.5,0,0,1,362.4,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.4,550.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.4,552c0,.1-.1.2-.2.3h0c0-.1.1,0,0-.1h0v-.2h-.1c.1,0-.1-.1,0-.1h-.5s.1,0,.1-.1l.4-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.4 550.3 362.4 550.3 362.4 550.4 362.4 550.4 362.4 550.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.3,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.1,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.2,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.3,552.2h0S364.2,552.1,364.3,552.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.1 552.1 364.1 552.1 364.1 552.1 364.1 552.1 364.1 552.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364,552s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.2 552.2 364.2 552.2 364.2 552.2 364.2 552.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.8 552.7 364.8 552.7 364.8 552.7 364.8 552.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.8,551.1h-.3a.3.3,0,0,1,.1-.2h.1C362.8,551,362.8,551,362.8,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.8,552h-.4a.3.3,0,0,0,0-.2h.3A.1.1,0,0,1,363.8,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,551.9h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.9 552.2 363.9 552.2 363.9 552.2 363.9 552.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.7 552.8 364.7 552.8 364.7 552.8 364.7 552.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,552h0S363.6,552,363.6,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.6,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.7 552 363.7 552 363.7 552 363.7 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 551.5 363.1 551.5 363.1 551.5 363.1 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.7 552 363.7 552 363.7 552 363.7 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 551.6 363.1 551.6 363.1 551.6 363.1 551.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,550.3H360a.2.2,0,0,1,0-.1h.2C360.3,550,360.4,550.1,360.4,550.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,551.8h-.3s0-.1,0-.1h.1C362.1,551.6,362.2,551.7,362.2,551.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "359.3",
      "y": "552",
      "width": "3.7",
      "height": "7.19",
      "transform": "translate(-279 726.8) rotate(-71.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.9,554.9s.1.1.1.2,0,.3,0,.4,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.3s0-.2-.1-.2h-.2l-.2.2s0,0,0,.1h-.2c0,.1,0,.1,0,.2H364c0-.1.1-.1,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.3.1-.4h-.1a.1.1,0,0,0,0-.1h-.4l.3-.2h0a.8.8,0,0,0,0-.4h.1l.5-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.9 555.2 364.9 555.1 364.9 555.1 364.9 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.7,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.7 555.3 364.7 555.3 364.7 555.3 364.7 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.9 555.4 364.9 555.3 364.9 555.4 364.9 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.8 555.4 364.8 555.4 364.8 555.5 364.8 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.8 555.5 364.8 555.5 364.8 555.5 364.8 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.8 555.6 364.8 555.5 364.8 555.6 364.8 555.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.7 555.5 364.7 555.5 364.7 555.5 364.7 555.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363,555h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.9 555.6 364.9 555.6 364.9 555.6 364.9 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,555s0,0,0,0h0S363.1,555,363.1,555Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,555h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.9,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.7,555.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.8 555.4 363.8 555.4 363.8 555.4 363.8 555.4 363.8 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.9,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,554.2c0,.1,0,.1,0,.2h-.2l-.2.2s.1-.1,0-.1h-.4c.2,0,.2-.3.4-.3s.2-.1.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.8,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.4,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,554.5l.3.4h-.1l-.2-.4s-.1-.1,0-.1S359.2,554.4,359.2,554.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.8h0S363.3,555.8,363.3,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.9,555.5c0,.1-.1.1-.1.2h-.2c0-.1-.1,0-.1-.1h-.1c.1.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1,0,0,.1h-.1a.1.1,0,0,0-.1.1h-.2c0,.1-.1,0-.1.1h0c-.2-.1-.3.1-.4,0s0-.2,0-.2h-.3l.5-.2h0s0-.1,0-.1h.5a0,0,0,0,1,0-.1c.1,0,.2,0,.2-.1s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,555.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,556s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.4,556.8c.1.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0a.3.3,0,0,0,.1-.2h0c0-.1-.1,0,0-.1h-.2c-.1,0,0,.2-.1.2s.1-.1,0-.1a.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.1 556.1 361.1 556.1 361.1 556.1 361.1 556.1 361.1 556.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.3,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,556.9h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.4,557h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.2 556.9 363.2 556.9 363.2 557 363.2 557 363.2 556.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,557h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.3 557 363.3 557 363.4 557 363.3 557"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364 557.3 364 557.2 364 557.2 364 557.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.7,556.6l-.2.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.9,557c0,.1-.1.1-.2.2h-.1a.2.2,0,0,0-.1-.2h.3A.1.1,0,0,1,362.9,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557h0c0,.1-.1.1-.1.1h-.1s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,557h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 557.1 363.1 557.1 363.1 557.1 363.1 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364 557.4 364 557.4 364 557.4 364 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.5,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,557h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.8 557.1 362.8 557.1 362.8 557.1 362.8 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.1 556.9 362.1 556.8 362.1 556.8 362.1 556.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.8 557.1 362.8 557.1 362.8 557.1 362.8 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.2 556.9 362.2 556.9 362.2 556.9 362.2 556.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.1,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,556.7v.2H359s0-.1.1-.2S359.3,556.6,359.4,556.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,557.4h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "354.4",
      "y": "552.4",
      "width": "3.9",
      "height": "7.56",
      "transform": "translate(-5.3 3.4) rotate(-0.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,552.7s.1-.2.2-.2.3-.1.4-.1h.2s-.1,0,0,.1h.3s0-.1,0-.1h0a.4.4,0,0,1,0,.1h.7a.1.1,0,0,1,0,.1h0s0,0,0,0h-.4s0,0,0,.1h-.1c0,.1.2.2.2.3l-.3-.2c.1.1.1.2.1.2l-.2-.2h-.4c0,.1,0,.2,0,.2s0-.1,0-.2h-.3c-.1.1,0,.1,0,.2l-.5-.5A.6.6,0,0,1,354.4,552.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.6 552.6 354.6 552.6 354.6 552.6 354.6 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.9,555h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,354.9,555Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 552.7 354.8 552.7 354.8 552.7 354.9 552.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 552.6 354.8 552.6 354.8 552.6 354.9 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 552.6 354.9 552.6 355 552.6 355 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 552.6 355 552.6 355 552.6 355 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 552.5 355 552.5 355 552.5 355.1 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 552.7 355 552.7 355 552.7 355.1 552.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,554.6a.8.8,0,0,1,0-.3h.1c0,.1,0,.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 552.5 355.1 552.5 355.1 552.5 355.1 552.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,554.4h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,552.6h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "355.2",
      "y": "553.6",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.3,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,559.2h.2c0,.1.1.1.1.1l.3.2h-.2c-.1.1,0,.1,0,.2s.1.1.1.2-.4-.1-.5-.3-.2-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,558.5l.3-.4h0l-.3.4h-.1C355.7,558.6,355.8,558.5,355.9,558.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,556.5h.4c0,.1.1.1,0,.2h.1l.2-.2h.4s0,.1,0,.1h.3s0,0,0,.1h.1c-.1.2.2.3.1.4h-.3c-.1,0,0,.1,0,.2h-.1c.1.1,0,.1,0,.2l-.3-.4h-.1v.2h-.1c0-.1.1-.1,0-.2h.1c0-.1,0-.2,0-.3l-.2-.2c-.1.1.1.1,0,.3h-.1s-.1-.2-.2-.1h-.1a.3.3,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.8,556.1h0S356.7,556.1,356.8,556.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,553.5h.4c0,.1.1.1.2.2h-.3s0,0,0,0h-.2s0-.1,0-.1h0s0,.1,0,.1h-.2S356.8,553.6,356.8,553.5Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "356.8",
      "y": "556.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.8,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.9,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,553.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "357",
      "y": "553.6",
      "transform": "translate(-54.6 39.3) rotate(-5.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,553.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357 553.5 357 553.5 357 553.5 357 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357 552.8 357 552.8 357 552.8 357 552.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,553.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,555.3l.2.2H357C357,555.4,357,555.3,357.1,555.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,553.9c.1,0,.2.1.3.2s0,0,0,.1h-.3c-.1-.1.1-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,554.1h.1s0,0,0,0h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 553.8 357.2 553.7 357.2 553.8 357.2 553.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 552.8 357.2 552.8 357.2 552.8 357.2 552.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 554 357.2 554 357.2 554 357.2 554"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 554.8 357.2 554.8 357.2 554.8 357.2 554.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 554 357.2 554 357.2 554 357.2 554"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.3 554.8 357.2 554.7 357.3 554.8 357.3 554.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,557.6h.2c.1.1.1.2.1.2H358C358,557.8,357.9,557.7,358,557.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.1,555.3h.2a.2.2,0,0,1,0,.2H358A.1.1,0,0,1,358.1,555.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351.4",
      "y": "559.6",
      "width": "6.6",
      "height": "3.36",
      "transform": "translate(-210.2 212.3) rotate(-26)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.7,564h-.2c-.2,0-.2-.2-.3-.3s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.2a.4.4,0,0,0,0-.2h0a.2.2,0,0,0,0-.2h0c0-.1.1-.1,0-.2h.1c.1.1.1.2.2.3h.1c.1,0,.1-.2.2-.3a.9.9,0,0,0,0,.3v.1l.2.2h0s-.1.1,0,.1h.2c-.1.2-.1.4-.2.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.6 563.9 352.6 563.9 352.6 563.9 352.6 563.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,562.8a.1.1,0,0,1,0-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.6 563.7 352.6 563.7 352.6 563.7 352.6 563.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.5 563.8 352.5 563.8 352.5 563.8 352.5 563.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.5 563.7 352.4 563.7 352.4 563.7 352.5 563.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.4 563.6 352.4 563.6 352.4 563.6 352.4 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.3 563.6 352.4 563.6 352.3 563.6 352.3 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.5 563.6 352.5 563.6 352.5 563.6 352.5 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,562.8h-.2s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.3 563.6 352.3 563.6 352.3 563.6 352.3 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.8,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,562.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.8,562.9s0,0,0,0S353.8,562.9,353.8,562.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.3,563.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.1 563.1 353.1 563.1 353.1 563.1 353.1 563.1 353.1 563.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353,563h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,560.5h0a1,1,0,0,0,0-.3h.3c-.1.1,0,.3,0,.5s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.6s0,0,0-.1S353.2,562.6,353.2,562.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.9,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,560.7h-.4s-.1,0,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0S353.2,562.5,353.2,562.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355,561.2v-.3h.1s.1-.1,0-.1h-.3s0-.1,0-.1h0s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.1-.2.3-.3v.2h.3c-.1.1-.1.3-.2.4s0,.1,0,.1h-.2v.2c.1,0,.1-.1.2-.1h0c0,.1-.1.1,0,.2h.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,560.5c.1,0,0,0,0,0S356.1,560.6,356.1,560.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.9c-.1,0-.1-.2-.2-.3s0-.2.1-.2,0,.1,0,.1h0s0,.1,0,0h0v.2s0,0,0-.1h0s0,0,0-.1,0,0,0,.1h0s0-.1,0-.1h0c0-.1-.1-.1,0-.2h.1a.4.4,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 560.9 354.5 560.9 354.5 560.9 354.5 560.9 354.5 560.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.6,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.4,561.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.5 561.7 352.5 561.7 352.5 561.7 352.5 561.7 352.5 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.5,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.6,561.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.4 561.7 352.4 561.7 352.4 561.7 352.4 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 562 351.8 562 351.8 562 351.8 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.8,561a.2.2,0,0,1,0-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,561.4c-.1-.1,0-.2,0-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.4,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.4h0s0-.2-.1-.1h0s0,0,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.9,561.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.5 561.5 352.5 561.5 352.5 561.5 352.5 561.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 561.9 351.8 561.9 351.8 561.9 351.8 561.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.7,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.8,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.7,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.7 561.4 352.7 561.4 352.7 561.4 352.7 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.3 561 353.3 561.1 353.3 561.1 353.3 561"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.7 561.3 352.7 561.3 352.7 561.3 352.7 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.3 561 353.3 561.1 353.3 561.1 353.3 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,559.4h-.1l.2-.2h.1s.1.1,0,.2S355.3,559.5,355.2,559.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.4,560.2s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347.7",
      "y": "557.9",
      "width": "3.6",
      "height": "6.98",
      "transform": "translate(-304.3 661) rotate(-66.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,561.8s-.1-.1-.1-.2,0-.3,0-.4,0-.1.1-.1,0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2.1.2h.4s0,0,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.4l-.3.2H347a.8.8,0,0,0,0,.3h-.1l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.6 345.9 561.6 345.9 561.6 345.9 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 561.4 346 561.4 346 561.4 346 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.4 345.9 561.4 345.9 561.4 345.9 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 561.3 345.9 561.3 345.9 561.3 346 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 561.2 346 561.3 346 561.3 346 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.2 345.9 561.2 345.9 561.2 345.9 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 561.2 346.1 561.2 346.1 561.2 346.1 561.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.7,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.1 345.9 561.2 345.9 561.1 345.9 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,561.8s0,0,0,0h0S347.6,561.8,347.6,561.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,561.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.8,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,561.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.9 561.4 346.9 561.4 346.9 561.4 346.9 561.4 346.9 561.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,563.1c0-.1,0-.1.1-.2h.2l.3-.2s-.1.1,0,.1h.4c-.2,0-.2.3-.4.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.1,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,562.7l-.2-.4h.1l.2.4s.1.1,0,.1S351.3,562.7,351.3,562.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,561.1h0S347.5,561.1,347.5,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,561.6v-.2h.2c0,.1.1,0,.1.1h.1c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2c0,.1,0,.1,0,.1h-.1v-.2h-.2a0,0,0,0,1,0,.1h-.2s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,562.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,561s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,560.1c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1,0,0,.1h.2v-.2s-.1.1,0,.1-.1.2-.3.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.6 561 349.6 561 349.6 561 349.6 561 349.6 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,560h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,559.9h0S347.5,559.9,347.5,559.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.6 560 347.6 560 347.6 559.9 347.6 559.9 347.6 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.5 559.9 347.5 559.9 347.5 559.9 347.5 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.9 559.6 346.9 559.6 346.9 559.6 346.9 559.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.6,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5h.2a.3.3,0,0,1,0,.2H349Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,559.9l.2-.2h.1a.2.2,0,0,0,0,.2H348A.1.1,0,0,1,347.9,559.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.6,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.6,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,560h0s.1-.1.1-.1h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.8 559.8 347.7 559.8 347.7 559.8 347.8 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.9 559.5 346.9 559.5 346.9 559.5 346.9 559.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,560h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 559.9 348 559.9 348 559.9 348 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.7 560.2 348.6 560.2 348.6 560.2 348.7 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 559.9 348 559.9 348 559.9 348 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.6 560.1 348.6 560.1 348.6 560.1 348.6 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.7,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,560.5h.3C351.5,560.7,351.3,560.7,351.3,560.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,559.7h0Z"
    }
  })])])])])])])]), _vm._v(" "), _c('path', {
    staticClass: "cls-225",
    attrs: {
      "d": "M375.7,532.9s1.6,15.6-7.2,21.6L354,564.3l-10.1,18.1s-8.5,9.6-8.8,11.1-14.7,7.1-14.7,7.1l-9.2,6.4-6.4-24.4s4.8-42.4,6-43.2,16.8-21.2,21.6-20.8,26,3.2,26,3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-239",
    attrs: {
      "d": "M330.8,612.4l-17-32.3,9.2-4.8,8.6-.2,10.9,5.3s13.5,2.1,14.3,3.3,1.6,10,1.6,10-3.6,15.2-6.4,16S330.8,612.4,330.8,612.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-240",
    attrs: {
      "d": "M268.4,594.9l1.6-21.1,22.5-19.7,3.6-10.5,10.4-12.9s4.3-3.7,4.2-5.7-2.2-11.4-2.2-11.4l12.8-16.9,4.4-13.9v-3.3l26.4-1.9-12.8,18.7-3.6,10.2-7.4,5.8-3.9,10.5s2,7.8-1,11.1-12.6,9.7-12.6,11.3,2.3,12.6,2.3,12.6l4.1,9s-3.3,10.3-3,11.7,8.2,18.3,8.2,18.3,3.6,14.4.4,14.8S268.4,594.9,268.4,594.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-240",
    attrs: {
      "d": "M305.6,554c-6.3-1.9-2.5-13.3-9.5-15.6-1.2-.4-11.4,5.3-12.5,4.9-9.3-3.1-7.7-11.6-7.7-11.6l1.6-21.1L300,491l3.6-10.5L314,467.6s4.3-3.7,4.2-5.7-2.2-11.4-2.2-11.4l12.8-16.9,4.4-13.9v-3.3l26.4-1.9-12.8,18.7-3.6,10.2-7.4,5.8L332,459.7s2,7.8-1,11.1-12.6,9.7-12.6,11.3,2.3,12.6,2.3,12.6l4.1,9s-3.3,10.3-3,11.7,25.4,15.3,25.4,15.3-8.9,15.9-12.1,16.3C334,547.2,312.6,556.1,305.6,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-241",
    attrs: {
      "d": "M427,494.9c-1.7,1.1-11.5,5.9-13.1,6.2s-10.1,19.2-11.9,20.4.1,21.9-.3,27-23.4,16.3-23.4,16.3l-23.1,26-3.5,68.5,23.9-5,39.7-42.9L395.5,592l-.9-9.8-3.1-5.3,2.5-4.6,4.9,4.3,12.3,2.9-1.2,9.8,11.6,5,5.7,7.5v.5l2.8-1.6s12.7-33.9,12.6-40.3,1.2-37.2,1.2-37.2l-6.5-33.5S428.7,493.7,427,494.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-241",
    attrs: {
      "d": "M332.4,561.3c2,0,12.8,1.9,14.3,2.5s19.3-9.8,21.6-9.7,12.7-17.9,15.9-21.8,28.5.3,28.5.3l33.9-7.7,42.7-53.7-22.3-9.8-57.3,11.8,4.7,27.3-5,8.5-.5,6.1-4.7,2.3-1.5-6.3-8.3-9.5,6.7-7.2-6.5-10.8-.3-9.4.3-.5-3.2-.3s-30.1,20.2-33.7,25.5-22.7,29.5-22.7,29.5l-14.2,31.1S330.4,561.2,332.4,561.3Z"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-242"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.3,581.4c-.1,0-.3,0-.2-.2s.2-.1.2-.2S285.4,581.3,285.3,581.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284,581.3h-.1a.1.1,0,0,1-.1-.2C283.9,581.2,284,581.2,284,581.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.8,581.6h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.7,583.5c0,.1-.1.1-.2.1s-.1-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.7,584.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.7,585.3h0S286.7,585.3,286.7,585.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.2,585.4v.2h-.5c0-.1-.1-.2,0-.4h.3C286.1,585.1,286.4,585.3,286.2,585.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "286.2 585.4 286.2 585.3 286.3 585.4 286.2 585.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.5,585.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.8,586.5c-.1.2-.2-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.1,586.7c-.1.1-.1-.1,0-.1S286.2,586.6,286.1,586.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.5,586.8c-.1,0-.1-.1-.1-.1S285.6,586.7,285.5,586.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.4,587.2c-.1-.1-.3,0-.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.1,587.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "284.3 587.3 284.2 587.3 284.3 587.3 284.3 587.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "284.2 587.4 284.1 587.4 284.2 587.4 284.2 587.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.7,588.2h0Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-242"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.5,556.1c-.1,0-.3,0-.2-.2s.2-.1.2-.2S283.7,556,283.5,556.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.2,556h-.1a.1.1,0,0,1-.1-.2C282.1,555.9,282.2,556,282.2,556Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283,556.3h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282,558.2c0,.1-.1.1-.2.1s-.1-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.9,559.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.9,560h0S284.9,560,284.9,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.4,560.1v.2H284c0-.1-.1-.2,0-.4h.3C284.3,559.9,284.6,560,284.4,560.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "284.5 560.1 284.5 560.1 284.5 560.1 284.5 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.8,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284,561.2c-.1.2-.2-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.3,561.4c-.1.1-.1-.1,0-.1S284.4,561.3,284.3,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.8,561.5c-.1,0-.1-.1-.1-.1S283.8,561.4,283.8,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.6,561.9c-.1-.1-.3,0-.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.3,562s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "282.5 562.1 282.4 562 282.5 562 282.5 562.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "282.4 562.2 282.3 562.1 282.4 562.1 282.4 562.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.9,562.9h0Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-242"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.3,506.5c-.1,0-.3,0-.2-.2s.2-.1.2-.2S284.5,506.4,284.3,506.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283,506.4h-.1a.1.1,0,0,1-.1-.2C282.9,506.2,283,506.3,283,506.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.8,506.7h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.8,508.6c0,.1-.1.1-.2.1s-.1-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.7,510h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.7,510.4h0S285.7,510.3,285.7,510.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.2,510.5v.2h-.5c0-.1-.1-.2,0-.4h.3C285.1,510.2,285.4,510.4,285.2,510.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "285.3 510.5 285.3 510.4 285.3 510.5 285.3 510.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.6,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.8,511.6c-.1.2-.2-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.1,511.8c-.1.1-.1-.1,0-.1S285.2,511.7,285.1,511.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.6,511.9c-.1,0-.1-.1-.1-.1S284.6,511.8,284.6,511.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.4,512.3c-.1-.1-.3,0-.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.1,512.4s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "283.3 512.4 283.2 512.4 283.3 512.4 283.3 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "283.2 512.5 283.1 512.5 283.2 512.5 283.2 512.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.7,513.3h0Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.4,523.9h.1c-.1.2-.3.1-.4,0S284.3,523.9,284.4,523.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.1,526.1h.1c-.1.2-.3.1-.4,0S282,526.1,282.1,526.1Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,592.1h.1c-.1.2-.3.1-.4,0S298.8,592.1,298.9,592.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M296.6,594.2h.1c-.1.2-.3.1-.4,0S296.5,594.2,296.6,594.2Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.9,592.2h.1c-.1.2-.3.1-.4,0S338.8,592.2,338.9,592.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.7,594.4h.1c-.1.2-.3.1-.4,0S336.6,594.4,336.7,594.4Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.5,591.8h.1c-.1.2-.3.1-.4,0S369.4,591.8,369.5,591.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,594h.1c-.1.2-.3.1-.4,0S367.1,594,367.2,594Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.5,592.2h.1c-.1.2-.3.1-.4,0S399.4,592.2,399.5,592.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,594.4h.1c-.1.2-.3.1-.4,0S397.1,594.4,397.2,594.4Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.9,592.6h.1c-.1.2-.3.1-.4,0S413.8,592.6,413.9,592.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,594.8h.1c-.1.2-.3.1-.4,0S411.5,594.8,411.6,594.8Z"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-244"
  }, [_c('g', {
    staticClass: "cls-218"
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-219",
    attrs: {
      "d": "M285.4,499.2l-3.7,6.4-1.6,10.1.8,9.3v3.9l-.4,6.8.4,7.8.2,8.9s-1,6-.6,8.6,1.9,10.5,1.9,11.3-.4,11.9-.4,11.9l1.2,6.8,2.9,3.7,8.5,1.8h7.4l9.3-.6,12.1.2h15l8.8-.8h24.4l11.4.8s6.6-1.2,7.4-1.2l14,1.2s6.8.4,7.6,0,8.4-1.6,8.4-1.6l5.2-6.5-1-2.5.4-6.2v-7a50.4,50.4,0,0,0,.4-5.6c0-2.5-1.6-8-1.6-10.3s.6-7,.6-7l.2-8.6V529.4l.8-3.9v-3.1a41.3,41.3,0,0,0-.8-4.9,6.4,6.4,0,0,1,.2-2.3v-7.8l-.8-2.7-2.1-1.6s-.2-1.2-.8-1.4a11.9,11.9,0,0,1-1.9-1l-5.6-2.5-3.5.2h-2.5l-5.7.6H389l-2.3.4h-5.1L375,498c-.6-.2-7.1.2-7.1.2l-5.6.2-3.7.8-8.6,1-3.5-.4-6.6-.6L329.8,498l-4.3,1c-.6.2-4.7.6-4.7.6l-7-.6h-1.6l-2.5-.2h-4.1l-4.9-.6-3.9,1.2-4.1-1.2-2-5.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-220",
    attrs: {
      "d": "M424.5,585.6l.4-6.2v-7a50.4,50.4,0,0,0,.4-5.6c0-2.5-1.6-8-1.6-10.3s.6-7,.6-7l.2-8.6V529.4l.8-3.9v-3.1a41.3,41.3,0,0,0-.8-4.9,6.4,6.4,0,0,1,.2-2.3v-7.8l-.8-2.7-2.1-1.6s-.2-1.2-.8-1.4a11.9,11.9,0,0,1-1.9-1l-5.6-2.5-3.5.2h-2.5l-5.7.6H389l-2.3.4h-5.1L375,498c-.6-.2-7.1.2-7.1.2l-5.6.2-3.7.8-8.6,1-3.5-.4-6.6-.6L329.8,498l-4.3,1c-.6.2-4.7.6-4.7.6l-7-.6h-3.2l-2,3.5L307,512.4l.8,9.3v3.9l-.4,6.8.4,7.8.2,8.9s-4.1,7.5-3.7,10.1-4,26.1-4,27-8.5,2.7-8.5,2.7l-3.2,3.7-2.5,2.2,8.5,1.8h7.4l9.3-.6,12.1.2h15l8.7-.5h18.7l5.9-.3,11.4.8s6.6-1.2,7.4-1.2l14,1.2s6.8.4,7.6,0,8.4-1.6,8.4-1.6l5.2-6.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-221",
    attrs: {
      "points": "280.6 532.2 281.5 530.9 283.1 528.8 284.5 529.4 285.6 529.1 287.3 536.3 283.7 533.9 280.6 535.9 280.6 532.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-222",
    attrs: {
      "points": "281.3 551 282.7 545.9 284.5 544.9 284.9 548.3 284.8 554.1 285.8 556.8 282.3 553 281.3 551"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-221",
    attrs: {
      "points": "281.4 562.1 283.8 563.9 285.2 569.7 283 574.5 282.3 576.2 282.3 572 281 563.7 281.4 562.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-221",
    attrs: {
      "points": "283 590.6 281.9 584.6 286.1 587.4 288.3 584.5 287.9 587.7 285.9 590.8 290.9 595.7 286 594.7 283 590.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-223",
    attrs: {
      "points": "291.2 588.2 293.2 591.4 299 590.4 291.2 588.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-222",
    attrs: {
      "points": "281.6 506.6 283.7 505.3 285.8 502.9 285.3 508.5 285.8 514.6 282.9 511.7 280.1 515.6 281.6 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "353.3 595.2 364.6 593.1 371.5 595.4 361.5 595.5 353.3 595.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "387.5 589.7 389.3 591.8 387.1 594.3 383.9 595.9 390.3 595 395.1 595.2 394.7 593.6 391.6 591.3 391.2 589.4 387.5 589.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "405.2 596.2 407.4 594.3 412.1 592.1 415 590.2 418 593.1 415.1 595.5 411.4 596.3 407.6 596.2 405.2 596.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "422.2 589.1 422 592.2 425.4 588.2 422.2 589.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "349.9 592.5 352.8 590.1 354.9 588.9 362.7 589.2 360.2 591.6 354.3 593.7 351.5 595.2 348.9 595.3 349.9 592.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-225",
    attrs: {
      "points": "306.4 590.2 310.1 592.3 312.7 594.5 315.8 596.2 318.8 596.3 317.3 592.4 318.6 591.2 319.4 589.6 311.6 590 306.4 590.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-225",
    attrs: {
      "points": "331.8 590.1 335.1 591.9 335.1 595.2 339.1 594.1 340.9 591.2 337.8 589.4 331.8 590.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-225",
    attrs: {
      "points": "371.2 589.8 374.4 591.6 374.4 595 378.4 593.8 380.2 591 377.2 589.2 371.2 589.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "298.1 596.2 303.5 593.9 312.7 594.5 318.6 591.2 327.1 594.8 329.7 596 318.7 596 310.6 595.8 306.2 596.2 298.1 596.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-224",
    attrs: {
      "points": "329.2 589.9 340.9 591.2 346.3 589.7 337.1 589.3 329.2 589.9"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-226"
  }, [_c('g', [_c('use', {
    attrs: {
      "transform": "translate(273.9 472.1) scale(0.13)",
      "xlink:href": "#image-3"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "306.6",
      "y": "528.2",
      "width": "50.6",
      "height": "22.41"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.7,529.6c.1.1,0,.2.1.3a.4.4,0,0,1-.4.2h-.1C310.4,529.9,310.5,529.7,310.7,529.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.8,535.9c.1,0,0,.1,0,.2h-.2C306.6,535.9,306.7,535.9,306.8,535.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,534.8l.3.2a.7.7,0,0,1-.4.7h-.2c-.1-.2-.1-.5,0-.7S309.7,535.1,309.7,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.5,538h0c.1,0,0,.2.1.3l.2-.2c.1,0,0,.1,0,.2h.9v.2h.3c-.3.2.1.3.1.5s-.1.3-.3.4l.3.3H309a.1.1,0,0,0,.1.2c-.1,0-.1.2-.1.2s.5-.1.7.1.1.3.2.5-.3.3-.5.3-.4-.1-.5-.4l-.2.2c.1.1.3,0,.3.2l-.7.2h0c-.3-.2-.7.1-.9,0a1.9,1.9,0,0,1-.6-1c.3-.1,0-.4,0-.5s.2.1.2-.1-.3.1-.3-.2.1-.7.2-.9.4,0,.4-.3,0-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.9,538c.1,0,.1.1.1.2s-.2.2-.3.2a.3.3,0,0,1-.1-.3C311.6,537.9,311.8,538,311.9,538Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.3,540.6l.3.2c0,.2,0,.3-.1.4s-.3.1-.4-.1A.3.3,0,0,1,310.3,540.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.5,535.5c.3,0,.2.3.3.4s.2.4-.1.5h-.3c.2-.3-.5-.3-.3-.6S315.3,535.6,315.5,535.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.7,537.7a.2.2,0,0,1,.1.3c0,.1-.2.1-.3.1a.2.2,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313,539c.1.1,0,.1.1.2s-.2.1-.2.1V539Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.1,538.1a.4.4,0,0,1,.1.3c-.1,0-.3.2-.4,0s0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,539.4h.3c0,.2.2.2.3.3s-.1.3-.1.4a.6.6,0,0,1-.8-.1c0-.2-.2-.5.1-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.7,541.8h.4c.1.2,0,.6,0,.7s-.5-.1-.5.2a.5.5,0,0,1-.6-.1c-.2-.4.6-.5.3-.9S311.5,542,311.7,541.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.4,538.4l.2.3-.2.2c-.1-.1-.3-.1-.3-.3A.2.2,0,0,1,314.4,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.4,538.6c0,.2-.2.2-.3.3h-.2a.3.3,0,0,1,.1-.3C315.1,538.4,315.2,538.6,315.4,538.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.3,537c.2,0,.1.2.1.3h-.3C316.9,537.1,317.1,536.9,317.3,537Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.5,540.3a.1.1,0,0,1-.1.2v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.2,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323,536.9c.1.2,0,.6.3.5s.6.1.9,0,.1.3.2.3h.1c0,.1,0,.5.2.7a4.8,4.8,0,0,0-.3.8h.1c-.2,0-.5.1-.7.2h0c-.2.2-.4.1-.6,0s-.1.1-.1.2-.1-.4-.3-.3l-.2.2c0-.1.2-.2.1-.3h-.2c.1-.2-.3-.4-.1-.7s.1-.3.1-.4h.2c0-.2.1-.4.2-.5h.1C323.2,537.4,322.9,537.1,323,536.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.8,537.3h0v-.2C322.8,537.2,322.8,537.3,322.8,537.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.3,538.4s0,.1,0,.1S322.3,538.4,322.3,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,545.1c-.1.2-.2,0-.2,0S313.9,545,313.9,545.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.5,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.5,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.2,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.1,538.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.3,538.7c.1-.2.3,0,.5-.1s-.1.2,0,.2.1-.1.2,0-.2.2-.2.3h.1c-.2.1-.5.3-.8.1s0-.3-.1-.4S326.2,538.6,326.3,538.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.1,541.5a.1.1,0,0,1,.1.2C324,541.7,323.9,541.5,324.1,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,537.7s.1,0,.1.1-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.5,540.2c0-.2.5-.2.5-.6s0,.3-.1.3.3.3.6.2a2.3,2.3,0,0,0,.1.7.4.4,0,0,0-.3.3h.1c-.2,0-.4,0-.5.2h0c-.1-.1,0-.1,0-.2s-.2-.1-.2,0-.2-.3-.4-.4S330.2,540.1,330.5,540.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330,541.2h-.1a.1.1,0,0,1,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "331.6 540 331.6 540 331.6 539.9 331.6 540"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "331.6 541.1 331.6 541.1 331.6 541.1 331.6 541.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.6,540.7c.1,0,0,.2,0,.2S332.6,540.8,332.6,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.3,541.4c0-.1,0-.1,0-.2s.2-.2.3-.3.6-.1.9,0h0c.1.3.4.2.6.4s0,.2.1.2.3-.1.4-.1h-.2c0,.1-.1.2,0,.3h0a.3.3,0,0,0,.2.3c-.3.1-.3.4-.5.7h.1c-.1-.1-.2,0-.3,0s-.5.1-.6.3-.4-.1-.6-.2h0c-.4-.1-.5-.6-.8-.8s0-.4.3-.5v-.2C332.2,541.4,332.2,541.6,332.3,541.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.4,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.7,540.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "328 548.2 328 548.2 328.1 548.3 328.1 548.3 328 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.9,547.3h-.1C328.8,547.4,328.8,547.3,328.9,547.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.8,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335,541.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "334.7 541.6 334.7 541.6 334.7 541.6 334.7 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.9,540.4c.1.1,0,.1-.1.1S335.8,540.4,335.9,540.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "335.5 541.1 335.3 541.2 335.4 541.1 335.5 541.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.4,543.5c.2,0,.2.1.3.2s-.2.2,0,.3-.4.1-.5-.1S336.2,543.4,336.4,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.3,542.9c-.1-.2.2-.1.1-.2s.4,0,.6-.3.2.2.2,0,.3.4.3.6-.3.2-.2.4-.4,0-.4.2l-.6-.4c-.1-.1.1-.4-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.5,550l.2.3c0,.2-.2.1-.2.3s-.4,0-.5-.2,0-.2,0-.3S332.4,550.1,332.5,550Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "338.6 542.4 338.5 542.5 338.6 542.4 338.6 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.5,547.6v.2c0,.2-.1.3-.3.3s-.2,0-.3-.1,0-.2,0-.3S335.4,547.5,335.5,547.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.9,546.4c.1-.1.2-.2.3-.2s.2.1.3.3-.3.2-.4.4l-.3-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.4,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.7,550.1c.1,0,.3.2.1.3s-.2.1-.3.1a.3.3,0,0,1-.1-.4C334.5,550.1,334.6,550,334.7,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.6,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,543.8c-.1.1-.1.2-.3.2s-.1-.2-.1-.3S340.9,543.6,340.9,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.6,541.3c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C318.3,541.7,318.4,541.2,318.6,541.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344,540h0l.3-.4h0l.7-.3c.4.1.7.5,1.1.6s-.1,0-.2.2-.1.3.1.2l-.2.4h.1c-.2.1-.3.1-.3.3h.3c-.3-.1-.5.2-.8.1h0c-.2,0-.2-.3-.4-.1h0l-.7-.5C343.7,540.7,343.9,540.4,344,540Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.3,544.9h.1a.1.1,0,0,1-.2,0C340.1,545,340.3,544.9,340.3,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,544.3c.1,0,0,.1,0,.1a.1.1,0,0,1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.4,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,542.3c0,.1-.1.1-.2.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 540.1 345.9 540.1 346 540.1 346 540.1 345.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "344.9 541.7 344.8 541.5 344.9 541.6 344.9 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,539.9a.1.1,0,0,1,0,.1A.1.1,0,0,1,346.4,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,540.8c0,.1.1,0,.1,0s-.2-.1-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,537.9c.3.2.6-.1.8.1h-.1c.4-.1.2.4.5.3h-.1c0,.1.1.1.2.2h-.2a.7.7,0,0,1-.1.5h0a.6.6,0,0,1-.3.3h.1c-.2-.2-.7.1-1-.2s-.2-.1-.3-.2-.1-.2-.1-.3A1.1,1.1,0,0,1,353.1,537.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.3,546c.1,0,.1.1.1.2s-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.7,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.9,544.5h.2c-.2.1-.1.2-.3.4s-.3,0-.4-.2a.3.3,0,0,1,0-.3C344.7,544.5,344.9,544.3,344.9,544.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "354.2 537.6 354.2 537.6 354.2 537.6 354.2 537.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "344.9 544.4 344.9 544.4 344.9 544.4 344.9 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "356.9 530.2 356.8 530.3 356.9 530.2 356.9 530.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.7,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.2,538.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "354.6 537.8 354.5 537.9 354.5 537.9 354.6 537.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,537.8s0,0,0,.1S354.8,537.8,354.9,537.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.2,539.3H354C354.1,539.2,354.2,539.1,354.2,539.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.8,538.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "354.4 538.8 354.4 538.9 354.3 538.9 354.4 538.8 354.4 538.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.8,545.3c.1.2-.2.2-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.1,545.1c0,.1-.2.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346,545.6c0,.1-.1,0-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.9,546.9c-.2,0-.2.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.9,547.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "346 547 345.9 547.1 346 547 346 547"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "346 547.1 346 547.2 346 547.1 346 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.9,547h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,539.4h.1c-.1.2-.3.1-.4,0S357,539.4,357.1,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.6,543.3h-.1C354.4,543.2,354.6,543.1,354.6,543.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "356.4 542 356.2 541.9 356.4 541.9 356.4 542"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "290",
      "y": "495.2",
      "width": "50.6",
      "height": "22.41"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294.1,496.6c.1.1,0,.2.1.3a.4.4,0,0,1-.4.2h-.1C293.8,496.9,293.9,496.6,294.1,496.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M290.1,502.9c.1,0,0,.1,0,.2H290C290,502.9,290.1,502.9,290.1,502.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.1,501.8l.3.2a.7.7,0,0,1-.4.7h-.2c-.1-.2-.1-.5,0-.7S293.1,502,293.1,501.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M290.9,505h0c.1,0,0,.2.1.3l.2-.2c.1,0,0,.1,0,.2h.9v.2h.3c-.3.2.1.3.1.5s-.1.3-.3.4l.3.3h-.1a.1.1,0,0,0,.1.2c-.1,0-.1.2-.1.2s.5-.1.7.1.1.3.2.5-.3.3-.5.3-.4-.1-.5-.4l-.2.2c.1.1.3,0,.3.2l-.7.2h0c-.3-.2-.7.1-.9,0a1.9,1.9,0,0,1-.6-.9c.3-.1,0-.4,0-.5s.2.1.2-.1-.3.1-.3-.2.1-.7.2-.9.4,0,.4-.3,0-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.3,505c.1,0,.1.1.1.2s-.2.2-.3.2a.3.3,0,0,1-.1-.3C295,504.9,295.2,504.9,295.3,505Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.7,507.6l.3.2c0,.2,0,.3-.1.4s-.3.1-.4-.1A.3.3,0,0,1,293.7,507.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.9,502.5c.3,0,.2.3.3.4s.2.4-.1.5h-.3c.2-.3-.5-.3-.3-.6S298.7,502.6,298.9,502.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.1,504.7a.2.2,0,0,1,.1.3c0,.1-.2.1-.3.1a.2.2,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.3,506c.1.1,0,.1.1.2s-.2.1-.2.1V506Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.5,505.1a.4.4,0,0,1,.1.3c-.1,0-.3.2-.4,0s0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.7,506.4h.3c0,.2.2.2.3.3s-.1.3-.1.4a.6.6,0,0,1-.8-.1c0-.2-.2-.5.1-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295,508.8h.4c.1.2,0,.6,0,.7s-.5-.1-.5.2a.5.5,0,0,1-.6-.1c-.2-.4.6-.5.3-.9S294.9,508.9,295,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.8,505.4l.2.3-.2.2c-.1-.1-.3-.1-.3-.3A.2.2,0,0,1,297.8,505.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.8,505.6c0,.2-.2.2-.3.3h-.2a.3.3,0,0,1,.1-.3C298.5,505.4,298.6,505.6,298.8,505.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.7,504c.2,0,.1.2.1.3h-.3C300.3,504.1,300.5,503.9,300.7,504Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.9,507.2c.1.1,0,.2-.1.2v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.6,495.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.4,503.9c.1.2,0,.6.3.5s.6.1.9,0,.1.3.2.3h.1c0,.1,0,.5.2.7a4.7,4.7,0,0,0-.3.8h.1c-.2,0-.5.1-.7.2h0c-.2.2-.4.1-.6,0s-.1.1-.1.2-.1-.4-.3-.3l-.2.2c0-.1.2-.2.1-.3H306c.1-.2-.3-.4-.1-.7s.1-.3.1-.4h.2c0-.2.1-.4.2-.5h.1C306.6,504.4,306.3,504.1,306.4,503.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.2,504.3h0v-.2C306.2,504.2,306.2,504.3,306.2,504.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.7,505.4s0,.1,0,.1S305.7,505.4,305.7,505.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.3,512.1c-.1.2-.2,0-.2,0S297.3,512,297.3,512.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.9,505.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,504.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.6,504.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,505.7c.1-.2.3,0,.5-.1s-.1.2,0,.2.1-.1.2,0-.2.2-.2.3h.1c-.3.1-.5.3-.8.1s0-.3-.1-.4S309.6,505.6,309.7,505.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.5,508.4a.1.1,0,0,1,.1.2C307.4,508.7,307.3,508.5,307.5,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,504.7s.1,0,.1.1-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,507.2c0-.2.5-.2.5-.6s0,.3-.1.3.3.3.6.2a2.3,2.3,0,0,0,.1.7.4.4,0,0,0-.3.3h.1c-.2,0-.4,0-.5.2h0c-.1-.1,0-.1,0-.2s-.2-.1-.2,0-.2-.3-.4-.4S313.6,507.1,313.9,507.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.4,508.2h-.1a.1.1,0,0,1,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "315 507 314.9 507 315 506.9 315 507"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "315 508.1 314.9 508.1 315 508.1 315 508.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316,507.7c.1,0,0,.2,0,.2S316,507.8,316,507.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.7,508.4c0-.1,0-.1,0-.2s.2-.2.3-.3.6-.1.9,0h0c.1.3.4.2.6.4s0,.2.1.2.3-.1.4-.1h-.2c0,.1-.1.2,0,.3h0a.3.3,0,0,0,.2.3c-.3.1-.3.4-.5.7h.1c-.1-.1-.2,0-.3,0s-.5.1-.6.3-.4-.1-.6-.2h0c-.4-.1-.5-.6-.8-.8s0-.4.3-.5v-.2C315.6,508.3,315.6,508.5,315.7,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.8,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.1,507.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "311.4 515.2 311.4 515.2 311.5 515.3 311.5 515.3 311.4 515.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.3,514.3h-.1C312.1,514.4,312.2,514.3,312.3,514.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.2,507.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.4,508.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "318.1 508.6 318.1 508.6 318.1 508.6 318.1 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.3,507.4c.1.1,0,.1-.1.1S319.2,507.4,319.3,507.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "318.9 508.1 318.7 508.1 318.8 508.1 318.9 508.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.8,510.4c.2,0,.2.1.3.2s-.2.2,0,.3-.4.1-.5-.1S319.6,510.4,319.8,510.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M320.7,509.8c-.1-.2.2-.1.1-.2s.4,0,.6-.3.2.2.2,0,.3.4.3.6-.3.2-.2.4-.4,0-.4.2l-.6-.4c-.1-.1.1-.4-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.9,517l.2.3c0,.2-.2.1-.2.3s-.4,0-.5-.2,0-.2,0-.3S315.8,517.1,315.9,517Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "322 509.4 321.9 509.5 322 509.4 322 509.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.9,514.6v.2c0,.2-.1.3-.3.3s-.2,0-.3-.1,0-.2,0-.3S318.7,514.5,318.9,514.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M320.3,513.3c.1-.1.2-.2.3-.2s.2.1.3.3-.3.2-.4.4l-.3-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.8,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.1,517c.1,0,.3.2.1.3h-.3a.3.3,0,0,1-.1-.4C317.9,517.1,318,517,318.1,517Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.9,509.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,510.7c-.1.1-.1.2-.3.2s-.1-.2-.1-.3S324.3,510.6,324.3,510.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,508.3c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4H304c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a3.9,3.9,0,0,0,.2-.9C301.7,508.7,301.8,508.1,302,508.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.6,509.7c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1H301a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C300.3,510.2,300.5,509.6,300.6,509.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.9,515c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4H308c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C305.6,515.4,305.8,514.8,305.9,515Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.7,518.8c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1H300a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C299.4,519.2,299.5,518.7,299.7,518.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309,528.8c.1-.1.2-.2.2-.3s0,.2.1.1.6-.1.7-.4-.2.2-.1.4h.4c-.1.1.1.1.1.2s.6-.1.8,0-.5,0-.6.2.3.3.4.4h-.1c0,.2-.1.4.2.5s-.6.7-.9,1h-.9a1.1,1.1,0,0,0-.8-.5c-.1-.1.2-.1.1-.3s-.1-.2-.2-.3a4,4,0,0,0,.2-.9C308.8,529.2,308.9,528.7,309,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,507h0l.3-.4h0l.7-.3c.4.1.7.5,1.1.6s-.1,0-.2.1-.1.3.1.2l-.2.4h.1c-.2.1-.3.1-.3.3h.3c-.3-.1-.5.2-.8.1h0c-.2,0-.2-.3-.4-.1h0l-.7-.5C327.1,507.6,327.3,507.3,327.4,507Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.7,511.9h.1a.1.1,0,0,1-.2,0C323.5,512,323.6,511.9,323.7,511.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,511.3c.1,0,0,.1,0,.1a.1.1,0,0,1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.2,509.3c0,.1-.1.1-.2.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.3 507.1 329.3 507 329.4 507.1 329.4 507.1 329.3 507.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "328.3 508.7 328.1 508.5 328.3 508.6 328.3 508.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,506.9s0,.1,0,.1A.1.1,0,0,1,329.8,506.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,507.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,507.8c0,.1.1,0,.1,0s-.2-.1-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.5,504.9c.3.2.6-.1.8.1h-.1c.4-.1.2.4.5.3h-.1c0,.1.1.1.2.2h-.2a.7.7,0,0,1-.1.5h0a.6.6,0,0,1-.3.3h.1c-.2-.2-.7.1-1-.2s-.2-.1-.3-.2-.1-.2-.1-.3A1.1,1.1,0,0,1,336.5,504.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.7,513c.1,0,.1.1.1.2s-.2,0-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.6,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.1,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.4,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.3,511.5h.2c-.2.1-.1.2-.3.4s-.3,0-.4-.2a.3.3,0,0,1,0-.3C328.1,511.5,328.3,511.3,328.3,511.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "337.6 504.6 337.6 504.6 337.6 504.6 337.6 504.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "328.3 511.4 328.3 511.4 328.3 511.4 328.3 511.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "340.3 497.2 340.2 497.3 340.3 497.2 340.3 497.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,512.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.6,505.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "338 504.8 337.9 504.8 337.9 504.8 338 504.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.3,504.7s0,0,0,.1S338.2,504.8,338.3,504.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.7,505.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.6,506.2h-.2C337.4,506.2,337.6,506.1,337.6,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.2,505.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "337.8 505.8 337.8 505.9 337.7 505.8 337.8 505.8 337.8 505.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.2,512.3c.1.2-.2.2-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.5,512c0,.1-.2.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.4,512.6c0,.1-.1,0-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.3,513.9c-.1,0-.2.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.2,514.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.4 514 329.3 514 329.4 514 329.4 514"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.4 514.1 329.3 514.2 329.4 514.1 329.4 514.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.3,514h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.5,506.4h.1c-.1.2-.3.1-.4,0S340.4,506.4,340.5,506.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338,510.2h-.1C337.8,510.2,338,510.1,338,510.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "339.8 509 339.6 508.9 339.8 508.9 339.8 509"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "363.3",
      "y": "519.7",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-270.4 424.7) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375,518.7c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C374.6,518.7,374.8,518.6,375,518.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.3,522.1v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.7,522.8c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S369.5,523,369.7,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.8,524.5h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5H366c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5H365c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.4s.1.2.2,0-.2,0,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.1,526.8c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S368.1,526.7,368.1,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365,528.3c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S364.9,528.1,365,528.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.2,526.5c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S372.1,526.4,372.2,526.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.4,527.5a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.8,528.2v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.1,528.1l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,369.1,528.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.6,528.8c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.5,530.1v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S364.3,530.2,364.5,530.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.1,528.5v.4h-.3a.6.6,0,0,1,.1-.4C368.8,528.4,369,528.4,369.1,528.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.4,529.2c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C369.4,528.8,369.3,529.1,369.4,529.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.9,528.7c0,.1-.1.2-.2.3s-.2,0-.2-.1S371.8,528.6,371.9,528.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.5,531.3c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.9,531.7c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C374.6,532.2,374.7,531.9,374.9,531.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.5,532h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.3,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.8,534.2c-.2.1-.1-.1-.1-.1S362.9,534.1,362.8,534.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.4,532.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.9,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.1,535.1c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S375.1,535,375.1,535.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.5,536.4s0,.2-.1.2S371.3,536.3,371.5,536.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.5,534.8a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376,538.7c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S375.9,538.4,376,538.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.8,539.3h-.1v-.2A.1.1,0,0,1,374.8,539.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "376.8 539.1 376.8 539 376.8 539 376.8 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "375.8 540.1 375.8 540 375.8 540 375.8 540.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.7,540.2c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.9,540.7v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1H377l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C375.9,540.6,375.7,540.8,375.9,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.1,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.3,540.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "367.5 544.5 367.5 544.5 367.5 544.7 367.5 544.7 367.5 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.8,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.5,542h-.2C377.4,541.9,377.5,541.9,377.5,542Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "377 542.2 377 542.1 377 542.1 377 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.7,541.7c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "377.8 542.1 377.7 542.1 377.8 542.1 377.8 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.2,544.7c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S376.2,544.6,376.2,544.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.3,544.7c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.5,5.5,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.3,548.5v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C368.1,548.3,368.2,548.5,368.3,548.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "378.3 545 378.2 545 378.3 544.9 378.3 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372,548v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C371.9,547.8,372,547.8,372,548Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.9,547.6h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M382.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.4,549.7a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S369.4,549.6,369.4,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.9,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.4,547.4c-.1,0-.3.1-.3,0s.1-.2.2-.3S378.5,547.2,378.4,547.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.7,533.3l.4-.2c0,.1-.1.2-.1.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6H367a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C368.2,533.5,368.7,533.1,368.7,533.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.3,545.7h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.3-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.7,6.7,0,0,1,.1-.8C382.6,546.1,383,545.9,383.3,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377,548.1v.2c-.1.1-.2,0-.2-.1S377,548.1,377,548.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.8,547.9h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381.2,547.6c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384.3 546.7 384.3 546.7 384.3 546.9 384.3 546.9 384.3 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "382.3 547.7 382.4 547.4 382.4 547.6 382.3 547.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.7,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.3,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.9,547.7c-.1.1,0,.1,0,.1s-.1-.2-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.1,548.6c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,390.1,548.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.1,550.1c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.3,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.3,549.8h0S380.3,549.8,380.3,549.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.8,550.2v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C379.7,550,380,550,379.8,550.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391 549 390.9 549 391 549 391 549"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "379.9 550.1 379.9 550.1 379.9 550.1 379.9 550.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "399 543.8 398.9 543.8 399 543.8 399 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.2,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.5,549.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391 549.4 390.9 549.3 390.9 549.4 391 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.2,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.9,550.1c-.1,0,0,0,0-.1S389.9,550.1,389.9,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.5,550.4c0-.1-.1,0-.1-.1S389.6,550.3,389.5,550.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.6,549.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "390 550.2 389.9 550.2 389.9 550.1 390 550.1 390 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.6,551.4c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380,551.3c-.1.1-.2,0-.1-.1S380,551.2,380,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.4,551.8c-.1.1-.1,0-.1-.1S379.4,551.7,379.4,551.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.2,552.9c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378,553h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "378.1 553 378.1 553 378.1 553 378.1 553"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "378.1 553.1 378 553.2 378.1 553.1 378.1 553.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.7,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.9,552.1v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,390.9,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.1,554.3H386C386,554.1,386.3,554.1,386.1,554.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "388.2 554 388.2 553.9 388.2 554 388.2 554"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "295.9",
      "y": "550.9",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-312.2 386.2) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.6,549.9c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C307.2,550,307.5,549.9,307.6,549.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.9,553.4v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302.4,554c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S302.2,554.3,302.4,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.4,555.8h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2,0,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.7,558.1c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S300.7,558,300.7,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.6,559.6c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S297.5,559.4,297.6,559.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.9,557.7c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S304.7,557.7,304.9,557.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,558.7a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.4,559.5v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.8,559.3l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,301.8,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.2,560.1c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.2,561.4v.3c-.1.3-.5.5-.6.6s-.2-.3-.5-.1-.3-.2-.2-.4.8-.1.9-.6S297,561.4,297.2,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.7,559.8v.4h-.3a.6.6,0,0,1,.1-.4C301.5,559.7,301.7,559.7,301.7,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,560.4c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C302.1,560.1,301.9,560.4,302,560.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.5,560c0,.1-.1.2-.2.3s-.2,0-.2-.1S304.5,559.8,304.5,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.2,562.6c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.7,558.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.6,563c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C307.3,563.5,307.4,563.1,307.6,563Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.2,563.3h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.9,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.4,565.5c-.2.1-.1-.1-.1-.1S295.5,565.4,295.4,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.7,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.1,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.6,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.6,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.8,566.4c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S307.8,566.2,307.8,566.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.1,567.7s0,.2-.1.2S304,567.6,304.1,567.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.2,566.1a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.7,569.9c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S308.6,569.7,308.7,569.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.5,570.6h-.1v-.2A.1.1,0,0,1,307.5,570.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "309.4 570.4 309.4 570.3 309.5 570.3 309.4 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "308.4 571.3 308.4 571.3 308.5 571.3 308.4 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.3,571.5c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,572v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C308.5,571.9,308.3,572.1,308.5,572Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.9,572.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "300.2 575.8 300.2 575.8 300.1 575.9 300.1 575.9 300.2 575.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.4,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.6,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.1,573.3h-.2C310,573.2,310.1,573.2,310.1,573.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "309.6 573.5 309.6 573.4 309.6 573.4 309.6 573.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.3,573c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.5 573.4 310.4 573.4 310.4 573.4 310.5 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.9,576c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S308.8,575.9,308.9,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.9,576c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.4,5.4,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.9,579.8v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C300.8,579.6,300.8,579.8,300.9,579.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "311 576.3 310.9 576.2 311 576.2 311 576.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.7,579.2v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C304.5,579.1,304.7,579.1,304.7,579.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.5,578.9h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.3,575.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302,581a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S302,580.9,302,581Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.5,577.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311,578.7c-.1,0-.3.1-.3,0s.1-.2.2-.3S311.1,578.5,311,578.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.3,564.6l.4-.2c0,.1-.1.2,0,.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C300.8,564.8,301.4,564.4,301.3,564.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316,577h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.3-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.5,6.5,0,0,1,.1-.8C315.3,577.4,315.6,577.2,316,577Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.6,579.4v.2c-.1.1-.2,0-.2-.1S309.6,579.4,309.6,579.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.5,579.2h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,578.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,578.9c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317 578 317 578 317 578.1 316.9 578.1 317 578"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "315 579 315.1 578.7 315 578.9 315 579"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.4,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317,578.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.5,578.9c-.1.1,0,.1,0,.1s-.1-.2-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.8,579.9c0,.3.4.2.4.5H323c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,322.8,579.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,581.4c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.7,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.9,580.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313,581.1h0S313,581.1,313,581.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.5,581.5v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C312.4,581.3,312.7,581.3,312.5,581.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.6 580.3 323.6 580.3 323.6 580.2 323.6 580.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "312.5 581.4 312.5 581.4 312.6 581.4 312.5 581.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "331.7 575.1 331.6 575.1 331.7 575.1 331.7 575.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.8,581.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.2,580.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.6 580.7 323.5 580.6 323.6 580.6 323.6 580.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.8,580.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.5,581.4c-.1,0,0,0,0-.1S322.5,581.4,322.5,581.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.1,581.7c0-.1-.1,0-.1-.1S322.2,581.5,322.1,581.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.3,581.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "322.6 581.4 322.5 581.5 322.5 581.4 322.6 581.4 322.6 581.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.3,582.7c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.6,582.6c-.1.1-.2,0-.1-.1S312.6,582.5,312.6,582.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312,583.1c-.1.1-.1,0-.1-.1S312,582.9,312,583.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.9,584.2c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.6,584.3s-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.8 584.3 310.7 584.3 310.8 584.3 310.8 584.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.7 584.4 310.6 584.4 310.7 584.4 310.7 584.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.3,584.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.5,583.4v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,323.5,583.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M318.8,585.5h-.1C318.7,585.4,318.9,585.4,318.8,585.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "320.8 585.3 320.8 585.2 320.9 585.3 320.8 585.3"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "395.5",
      "y": "553.3",
      "width": "38.1",
      "height": "28.41",
      "transform": "translate(-269.7 728.1) rotate(-67.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M432.1,557.6c-.2,0-.2-.1-.4,0s-.2-.3-.1-.4h.2C431.9,557.3,432.1,557.5,432.1,557.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426,551.8h-.1A.1.1,0,0,1,426,551.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426.3,554.4H426a1,1,0,0,1-.7-.6h.2a1.3,1.3,0,0,1,.8.4C426.6,554.3,426.1,554.3,426.3,554.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423.2,551.3H423l.2.2H423c0,.3-.3.3-.3.6l-.2-.2-.3.2c-.1-.3-.4-.1-.6-.2l-.4-.4h-.7c0-.1-.2-.1-.3-.2s0,.4-.3.5h-.6c0-.2-.2-.4-.2-.5s.3-.3.6-.1l-.2-.3c-.2,0-.1.2-.3.1a1.6,1.6,0,0,1,0-.5h-.2c.3-.1.1-.6.3-.6a2.8,2.8,0,0,1,1.3,0c.1.2.4.2.6.3s-.1.1,0,.2,0-.2.4-.1.8.4,1,.6-.1.3.3.4.1,0,.2,0S423.3,551.3,423.2,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422,554.3h-.3c-.2-.1-.2-.2-.1-.3h.4C422.2,554.2,422.1,554.3,422,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.4,552h-.3l-.4-.3c0-.1-.1-.3.2-.3S419.5,551.8,419.4,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423.9,558.1c-.1.2-.4,0-.6,0s-.5,0-.6-.3,0-.1.1-.1.5-.2.8.1S423.8,557.9,423.9,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.8,555.8h-.4a.2.2,0,0,1,0-.3h.4C421.9,555.6,421.8,555.7,421.8,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.5,554.6h-.2c-.1-.1,0-.1,0-.2h.2C420.6,554.5,420.6,554.5,420.5,554.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.2,555.8h-.4c0-.1-.1-.3.1-.3h.3A.2.2,0,0,1,421.2,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.9,554.6c-.1,0-.1.1-.1.2h-.5c0-.2-.3-.2-.4-.3s0-.5.4-.5.7.1.6.4S419.8,554.5,419.9,554.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.6,552.3l-.2.2-.8-.3c0-.1.2-.3-.1-.5s.1-.3.3-.3.4.6.9.6S417.5,552.1,417.6,552.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.7,555.9h-.4l-.2-.3h.4C420.7,555.7,420.8,555.8,420.7,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.3,556.4c-.3-.1-.2-.2-.3-.4h.2l.3.2C420.6,556.3,420.3,556.3,420.3,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.6,558.6c-.1.1-.2,0-.3-.1s0-.2.1-.2S421.8,558.5,421.6,558.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,556.4c-.1,0-.3-.1-.2-.2h.3C418,556.3,418.1,556.4,418,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M428.4,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420,562.5c-.3,0-.8-.3-.7,0s-.3.4-.3.6-.3-.1-.4,0h.1c-.1,0-.5-.3-.8-.2l-.8-.6c-.1,0,0,.1-.1.1s0-.4,0-.6h-.1c-.1-.2.1-.3.2-.4s-.1-.1-.2-.2.5.1.5-.1l-.2-.2c.2.1.2.2.4.2h.2c.2.2.6,0,.8.2s.3.2.5.2h-.2a1.2,1.2,0,0,1,.6.4h-.1C419.4,562.4,419.8,562.4,420,562.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.6,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.5,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.1,552.2c-.2-.1,0-.1.1-.1S413.3,552.3,413.1,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.9,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.1,563.4s-.1-.1,0-.1S419.1,563.4,419.1,563.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.1,564h0S419.1,564,419.1,564Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.9,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,564c.2.2-.1.2,0,.4s-.2-.2-.3-.1.1.1,0,.1-.2-.3-.3-.3h-.1c-.1-.2-.2-.5.1-.6s.3.1.5.1S417.1,563.9,416.9,564Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.4,561.1h-.2C414.1,560.9,414.4,560.9,414.4,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.7,565.2h-.2c-.1-.1,0-.1.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414,566.2c.3.1.1.4.5.6s-.3-.1-.3-.2-.4.1-.4.3l-.8-.3a.5.5,0,0,0-.2-.4h-.1c0-.2.1-.2-.1-.4h.2c0-.1.1-.1,0-.2s.5,0,.6-.1S414.2,566,414,566.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413,565.3c-.1,0-.1-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "413.9 567 413.9 567 413.9 567 413.9 567"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "412.6 566.5 412.6 566.4 412.6 566.5 412.6 566.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.8,567.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412,566.8h.2c-.2.1.2.2.2.4s-.1.4-.2.7h.1c-.3-.1-.4.1-.6.2s-.2-.1-.3,0a.3.3,0,0,1,0,.4v-.2l-.4-.2s0,.1-.1.1a.1.1,0,0,1,0-.1c-.2-.1-.3,0-.4,0s-.4-.4-.6-.6h-.1c.1,0,.1-.2.1-.2s.1-.4-.2-.6.3-.2.4-.3h0c.3-.2.9,0,1.2-.1s.4.2.5.4h.3C412.1,566.7,411.9,566.6,412,566.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.4,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.5,568.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.3 560.5 405.4 560.5 405.2 560.5 405.2 560.5 405.3 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.2,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.4,568.8c-.1-.1.1-.1,0-.2S411.5,568.7,411.4,568.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "411.1 568.4 411.1 568.3 411.1 568.4 411.1 568.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.1,569.8c-.1,0-.1-.1-.1-.1S412.2,569.8,412.1,569.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "411.4 569.1 411.4 569 411.4 569 411.4 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.4,568.6c0,.1-.2.1-.3.1s-.2-.2-.3-.2,0-.3.3-.3S408.5,568.5,408.4,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.8,569.6c.2,0,0,.2.2.1s-.1.3.1.5-.3.1-.1.1h-.8c-.1-.1-.1-.3-.4-.3a.2.2,0,0,0-.1-.3l.6-.3c.1,0,.4.3.5.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.9,562.7h-.4l-.3-.3c.1-.2.1-.3.4-.3l.3.2C402.1,562.5,401.9,562.6,401.9,562.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409 570.7 409 570.6 409 570.6 409 570.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.9,565.9h-.2c-.2-.1-.4-.2-.3-.4s.1-.1.2-.1h.3C403.9,565.7,404,565.9,403.9,565.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.9,567.5c.2.1.1.2.2.4h-.4c-.4,0-.1-.3-.4-.5h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.9,574.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.2,564.2a.3.3,0,0,1-.4-.1c-.1-.1-.1-.2-.1-.3h.5C401.2,564,401.3,564.1,401.2,564.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.1,572.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.7,571.6c-.1-.1-.2-.2-.1-.3s.2.1.3.1S406.9,571.7,406.7,571.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.2,557.3l.3.3h-.2c0,.2-.1.5.3.7l-.4-.3a.3.3,0,0,0-.2.3c0-.1-.2,0-.2,0s0,.5-.2.6.1-.4-.1-.5-.4.1-.6.1h.1c-.2-.1-.5-.3-.7-.1a3.6,3.6,0,0,1-.9-1.2l.4-.6h-.1a.9.9,0,0,0,.8-.3c.2,0,.1.2.3.2h.4l1,.5C415.8,556.9,416.4,557.3,416.2,557.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.2,575.6h-.1l.4.4h-.1a5.8,5.8,0,0,1,.1.6c-.2.3-.8.2-1,.4s0-.1-.1-.2-.3-.2-.2,0l-.4-.3h-.1c-.1-.2,0-.3-.3-.4s0,.2-.1.2-.1-.4.1-.6h-.2c.1-.1.4,0,.3-.2h-.1l.8-.2C409.6,575.1,409.8,575.4,410.2,575.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.6,570.6h-.2c-.1-.1-.1-.2,0-.2S405.6,570.6,405.6,570.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.1,571.3h0C406.2,571.3,406.1,571.3,406.1,571.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.6,574.3c-.1,0-.1-.1,0-.2S407.6,574.3,407.6,574.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.6 576.9 409.6 576.9 409.5 576.9 409.5 576.9 409.6 576.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408 575.4 408.3 575.4 408.1 575.4 408 575.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.7,577.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,577.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.6,576.8c-.1-.1,0,.1-.1.1s.1-.1,0-.3S408.7,576.8,408.6,576.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,582.9c-.3.1-.1.5-.3.5h-.1c0,.3-.5-.1-.5.2h-.3s.1-.1,0-.1l-.5-.3h.1c-.2-.1-.2-.2-.3-.4h-.1c.4,0,0-.6.6-.6s.2-.1.3-.1h.4C409.7,582.4,410,582.6,410.1,582.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,571.4h-.3c-.1-.1.1-.1.2-.1A.2.2,0,0,1,403.7,571.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.5,574.2h0S405.5,574.2,405.5,574.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,574.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.7,574h-.1l-.4-.4c.1,0,0-.2.3-.2l.3.2C404.8,573.8,405,574.1,404.7,574Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "410 583.9 410 583.8 410 583.9 410 583.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.8 574 404.8 574 404.8 574.1 404.8 574"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.9 589.4 417.8 589.3 417.9 589.4 417.9 589.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.1,573.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.5,583.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.6 584 409.6 583.9 409.7 584 409.6 584"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.7,584.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.6,583.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.1,583c.1,0,0-.2.1-.1S408.3,583.1,408.1,583Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,583.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408.6 583.4 408.5 583.3 408.5 583.3 408.6 583.4 408.6 583.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.5,574.3c-.2,0-.2-.2,0-.1S403.6,574.2,403.5,574.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,574.6c-.1-.1-.1-.2.1-.1S403.8,574.6,403.7,574.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.1,574.2c-.1-.1,0-.1,0-.1S403.2,574.2,403.1,574.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.6,573.5c0-.1-.3-.2-.1-.3A.3.3,0,0,1,401.6,573.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.4,573.4s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "401.5 573.5 401.4 573.4 401.5 573.5 401.5 573.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "401.3 573.5 401.3 573.4 401.3 573.5 401.3 573.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.2,574.2c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.1,585h-.2a.2.2,0,0,1,.1-.3A.2.2,0,0,1,407.1,585Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.3,581.4c-.1,0,0-.1,0-.1S403.5,581.4,403.3,581.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.3 583.2 404.4 583.1 404.4 583.2 404.3 583.2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "394.2",
      "y": "496.7",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-245.1 439.8) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,495.7c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C405.5,495.8,405.8,495.6,405.9,495.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,499.2v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.7,499.8c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S400.5,500,400.7,499.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.7,501.5h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.3.1.3.4l-.3.5H395c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2-.1,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399,503.8c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S399,503.7,399,503.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.9,505.3c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S395.8,505.1,395.9,505.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.2,503.5c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S403,503.5,403.2,503.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,504.5a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.7,505.3v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.1,505.1l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,400.1,505.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.5,505.8c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.4,507.1v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S395.3,507.2,395.4,507.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400,505.6v.4h-.3a.6.6,0,0,1,.1-.4C399.8,505.5,400,505.5,400,505.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,506.2c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C400.3,505.9,400.2,506.1,400.3,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.8,505.8c0,.1-.1.2-.2.3s-.2,0-.2-.1S402.7,505.6,402.8,505.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.4,508.3c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417,504.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,508.8c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C405.6,509.3,405.7,508.9,405.9,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.4,509h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.2,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.7,511.3c-.2.1-.1-.1-.1-.1S393.8,511.1,393.7,511.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.9,510.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.3,509.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.9,510.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406,512.1c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S406,512,406,512.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,513.4s0,.2-.1.2S402.3,513.4,402.4,513.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.5,511.8a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407,515.7c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S406.9,515.5,407,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.8,516.3h-.1v-.2A.1.1,0,0,1,405.8,516.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "407.7 516.1 407.7 516.1 407.8 516.1 407.7 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "406.7 517.1 406.7 517.1 406.7 517.1 406.7 517.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.6,517.3c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.8,517.8v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.7,1.7,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C406.8,517.6,406.6,517.8,406.8,517.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,517.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "398.4 521.6 398.5 521.5 398.4 521.7 398.4 521.7 398.4 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.7,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.9,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.4,519c-.1,0-.1-.1-.2-.1S408.4,518.9,408.4,519Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "407.9 519.2 407.9 519.2 407.9 519.2 407.9 519.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,518.8c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408.7 519.2 408.6 519.1 408.7 519.1 408.7 519.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.2,521.8c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S407.1,521.6,407.2,521.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,521.7c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.3,5.3,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.4,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.2,525.6v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C399.1,525.3,399.1,525.5,399.2,525.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.2 522 409.2 522 409.3 522 409.2 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403,525v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C402.8,524.9,403,524.8,403,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.8,524.6h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.6,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,526.8a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S400.3,526.6,400.3,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.8,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.3,524.4c-.1,0-.3.1-.3,0s.1-.2.2-.3S409.4,524.3,409.3,524.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.6,510.3l.4-.2c0,.1-.1.2,0,.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C399.1,510.6,399.7,510.1,399.6,510.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.2,522.7h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.2-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.5,6.5,0,0,1,.1-.8C413.5,523.1,413.9,523,414.2,522.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.9,525.2v.2c-.1.1-.2,0-.2-.1S407.9,525.1,407.9,525.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.8,524.9h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,524.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.1,524.7c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.2 523.8 415.3 523.8 415.2 523.9 415.2 523.9 415.2 523.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "413.3 524.7 413.4 524.4 413.3 524.6 413.3 524.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M415.7,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M415.3,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.8,524.7c-.1.1,0,.1,0,.1s-.1-.2-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421,525.6c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3H421l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,421,525.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,527.2c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,524.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.2,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.3,526.8h0S411.3,526.8,411.3,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.7,527.2v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C410.6,527.1,411,527,410.7,527.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "421.9 526 421.8 526 421.9 526 421.9 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "410.8 527.2 410.8 527.2 410.9 527.1 410.8 527.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "430 520.8 429.9 520.8 429.9 520.8 430 520.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.5,526.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "421.9 526.4 421.8 526.4 421.8 526.4 421.9 526.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.1,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.8,527.2c-.1,0,0,0,0-.1S420.8,527.1,420.8,527.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.4,527.5h-.1C420.3,527.4,420.5,527.3,420.4,527.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "420.9 527.2 420.8 527.2 420.8 527.2 420.9 527.1 420.9 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.6,528.4c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.9,528.4c-.1.1-.2,0-.1-.1S410.9,528.3,410.9,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.3,528.8c-.1.1-.1,0-.1-.1S410.3,528.7,410.3,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,529.9c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.9,530.1s-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.1 530.1 409 530 409 530 409.1 530.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409 530.2 408.9 530.2 409 530.2 409 530.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.8,529.1v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,421.8,529.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417,531.3h-.1C417,531.1,417.2,531.1,417,531.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "419.1 531.1 419.1 530.9 419.1 531 419.1 531.1"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347",
      "y": "550.9",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-297.2 422.3) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.7,549.9c0,.2-.2.2-.2.3s-.4.1-.4,0V550C358.3,550,358.5,549.8,358.7,549.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351,553.4v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.4,554c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S353.2,554.2,353.4,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.5,555.8h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2H347c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2-.1,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.8,558c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S351.8,558,351.8,558Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.7,559.5c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S348.6,559.4,348.7,559.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.9,557.7c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S355.8,557.7,355.9,557.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,558.7a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,559.5v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.8,559.3l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,352.8,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.3,560.1c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,561.4v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S348,561.4,348.2,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.8,559.8v.4h-.3a.6.6,0,0,1,.1-.4C352.5,559.7,352.7,559.7,352.8,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,560.4c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C353.1,560.1,353,560.3,353.1,560.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,560c0,.1-.1.2-.2.3s-.2,0-.2-.1S355.5,559.8,355.6,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.2,562.5c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.8,558.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.6,563c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5h-.3c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C358.3,563.5,358.4,563.1,358.6,563Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.2,563.3h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.5,565.5c-.2.1-.1-.1-.1-.1S346.6,565.4,346.5,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.7,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.1,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.7,564.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.6,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.8,566.3c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S358.8,566.2,358.8,566.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.2,567.6s0,.2-.1.2S355,567.6,355.2,567.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.2,566.1a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.7,569.9c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S359.6,569.7,359.7,569.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.5,570.5h-.1v-.2A.1.1,0,0,1,358.5,570.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "360.5 570.3 360.5 570.3 360.5 570.3 360.5 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "359.5 571.3 359.5 571.3 359.5 571.3 359.5 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.4,571.5c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.6,572v-.2c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3v-.2C359.6,571.9,359.4,572.1,359.6,572Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.8,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361,572h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "351.2 575.8 351.2 575.8 351.2 575.9 351.2 575.9 351.2 575.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.5,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.7,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.2,573.3c-.1,0-.1-.1-.2-.1S361.2,573.1,361.2,573.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "360.7 573.4 360.7 573.4 360.7 573.4 360.7 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.4,573c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.5 573.4 361.4 573.4 361.5 573.4 361.5 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.9,576c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S359.9,575.9,359.9,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361,576c.1-.2.2,0,.2-.2s.2.2.6.1,0,.3.1.2a5.4,5.4,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352,579.8v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C351.8,579.6,351.9,579.8,352,579.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "362 576.2 361.9 576.2 362 576.2 362 576.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.7,579.2v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C355.6,579.1,355.7,579.1,355.7,579.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.6,578.8h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.4,575.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.1,581a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3-.1s.1-.3.2-.4S353.1,580.9,353.1,581Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.6,577.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.1,578.7c-.1,0-.3.1-.3,0s.1-.2.2-.3S362.2,578.5,362.1,578.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.4,564.6l.4-.2c0,.1-.1.2-.1.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6H353c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C351.9,564.8,352.4,564.4,352.4,564.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367,577h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.2-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.5,6.5,0,0,1,.1-.8C366.3,577.3,366.7,577.2,367,577Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.7,579.4v.2c-.1.1-.2,0-.2-.1S360.7,579.3,360.7,579.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.5,579.1h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,578.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.9,578.9c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368 578 368 578 368 578.1 368 578.1 368 578"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "366 578.9 366.1 578.7 366.1 578.9 366 578.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.4,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368,578.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.6,578.9c-.1.1,0,.1,0,.1s-.1-.2-.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.8,579.8c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,373.8,579.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.8,581.4c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.7,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364,580.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364,581h0S364,581,364,581Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.5,581.5v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C363.4,581.3,363.7,581.3,363.5,581.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "374.7 580.2 374.6 580.2 374.7 580.2 374.7 580.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "363.6 581.4 363.6 581.4 363.6 581.4 363.6 581.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "382.7 575 382.6 575 382.7 575 382.7 575"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.9,581.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.2,580.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "374.6 580.6 374.6 580.6 374.6 580.6 374.6 580.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.9,580.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.6,581.4c-.1,0,0,0,0-.1S373.6,581.4,373.6,581.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.2,581.7h-.1C373.1,581.6,373.3,581.5,373.2,581.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.3,581.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "373.7 581.4 373.6 581.5 373.6 581.4 373.7 581.4 373.7 581.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.3,582.6c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.7,582.6c-.1.1-.2,0-.1-.1S363.7,582.5,363.7,582.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.1,583c-.1.1-.1,0-.1-.1S363.1,582.9,363.1,583Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.9,584.1c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.7,584.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.8 584.3 361.8 584.3 361.8 584.3 361.8 584.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.8 584.4 361.7 584.4 361.8 584.4 361.8 584.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.4,584.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.6,583.4v.2a.2.2,0,0,1-.3-.2A.2.2,0,0,1,374.6,583.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.8,585.5h-.1C369.7,585.4,370,585.4,369.8,585.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.9 585.3 371.9 585.2 371.9 585.2 371.9 585.3"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-227"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "390.7",
      "y": "533.1",
      "width": "28.4",
      "height": "38.07",
      "transform": "translate(-271.8 448) rotate(-45)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-228"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,532.1c0,.2-.2.2-.2.3s-.4.1-.4,0v-.2C402,532.2,402.3,532,402.4,532.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.7,535.6v.2s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.2,536.2c0,.1,0,.2,0,.3a1,1,0,0,1-.8.4c-.1,0-.1-.1,0-.2s.3-.5.6-.6S397,536.4,397.2,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.2,537.9h.1c0,.1-.2.2-.2.3h.3c0,.1-.1.1-.1.2s.1.4.4.5h-.2c0,.1.1.2.1.3s-.2.3-.4.5l-.5.2a1.2,1.2,0,0,1-.1.5h-.1c-.1.1-.2.2-.1.3s-.2.1-.3.2.4.1.3.4l-.3.5h-.5c.1-.2-.1-.3.1-.6h-.3c-.1.2.1.2,0,.3l-.5-.2h-.1c0-.3-.5-.3-.5-.5a2.8,2.8,0,0,1,.5-1.2c.2,0,.3-.3.5-.5s.1.2.2,0-.2-.1,0-.4.7-.5.9-.7.2.2.5-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.5,540.2c0,.1-.1.2-.1.2s-.3.1-.4,0,.1-.3.2-.4S395.5,540.1,395.5,540.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,541.7c0,.1.1.2,0,.3l-.4.3c-.1-.1-.3,0-.2-.3S392.3,541.5,392.4,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.7,539.9c.2.2-.1.3-.2.6s-.2.4-.5.4-.1-.1-.1-.2,0-.5.4-.7S399.5,539.9,399.7,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.8,540.9a.4.4,0,0,1-.2.3.2.2,0,0,1-.2-.1.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.2,541.6v.2c-.1.1-.1,0-.2-.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.6,541.5l-.2.3c-.1,0-.3,0-.2-.2l.2-.3A.2.2,0,0,1,396.6,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395,542.2c0,.1.1.2.1.2s-.1.3-.1.5-.3.2-.4.3-.5-.2-.3-.6.4-.6.6-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392,543.5v.3c-.1.3-.5.5-.6.6s-.2-.4-.5-.1-.3-.2-.2-.4.8-.1.9-.6S391.8,543.6,392,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.5,542a1,1,0,0,1-.1.4h-.3a.6.6,0,0,1,.1-.4C396.3,541.9,396.5,541.8,396.5,542Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.8,542.6c-.2.2-.3.1-.4.1a.2.2,0,0,1,0-.2l.3-.2C396.9,542.3,396.7,542.5,396.8,542.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.3,542.2c0,.1-.1.2-.2.3s-.2,0-.2-.1S399.3,542,399.3,542.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,544.7c0,.1-.2.2-.3.1v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.5,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,545.1c-.1.2-.6.6-.3.7s.2.4.5.5-.2.3-.1.4h.2c-.1.1-.4.4-.5.7l-.9.6c0,.1.1,0,0,.1s-.4-.1-.6-.2h0c-.3.1-.3-.2-.3-.3h-.2s.3-.4.1-.5H400c.1-.1.3-.1.3-.3v-.2c.3-.2.2-.5.5-.7s.3-.2.4-.3v.2a1.2,1.2,0,0,1,.6-.4h0C402.1,545.7,402.2,545.3,402.4,545.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402,545.4h0v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.7,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.2,547.6c-.2.1-.1-.1-.1-.1S390.3,547.5,390.2,547.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.5,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.4,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.6,548.5c.2-.2.1.2.4.2s-.3.1-.2.2.2-.1.1.1-.3.1-.4.2h.1c-.2,0-.5,0-.5-.3s.2-.2.3-.5S402.6,548.4,402.6,548.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.9,549.8s0,.2-.1.2S398.8,549.7,398.9,549.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404,548.2a.1.1,0,0,1-.1.2c-.1,0-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.5,552.1c.2-.2.4.1.8-.2s-.3.3-.3.2-.1.4.2.5l-.6.7h-.4c-.2-.1-.2-.2-.5-.1h0c0-.1.1-.1.2-.2s0-.2-.1-.1.2-.4.1-.6S403.4,551.8,403.5,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.3,552.7h-.1v-.2A.1.1,0,0,1,402.3,552.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.2 552.5 404.2 552.5 404.3 552.4 404.2 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "403.2 553.5 403.2 553.4 403.3 553.4 403.2 553.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.1,553.6c0,.1-.2.1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.3,554.2V554c0,.2.3,0,.4-.1s.4.3.5.5h0c-.2.3,0,.4,0,.6s-.1.2-.2.3a.3.3,0,0,1,.3.1h-.2l-.3.3s.1,0,.1.1h-.1c-.2.2-.2.3-.1.4a1.8,1.8,0,0,0-.8.3h0c.1-.1-.1-.1-.1-.2s-.3-.2-.6,0-.1-.3-.2-.5h0c-.1-.3.3-.8.3-1.2s.3-.3.6-.3V554C403.3,554,403.1,554.2,403.3,554.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.5,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.7,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "395 557.9 395 557.9 394.9 558.1 394.9 558.1 395 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.2,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.4,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.9,555.4c-.1,0-.1-.1-.2-.1S404.9,555.3,404.9,555.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "404.4 555.6 404.4 555.6 404.4 555.5 404.4 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.1,555.1c0,.1-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.3 555.6 405.2 555.5 405.2 555.5 405.3 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,558.1c.1.1,0,.2-.1.3s-.3.1-.3.2-.3-.1-.2-.4S403.6,558,403.7,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.7,558.1c.1-.2.2,0,.2-.2s.2.2.5.1,0,.3.1.2a5.3,5.3,0,0,1-.4.7c-.2.1-.4,0-.5.2a.2.2,0,0,0-.3,0,2.1,2.1,0,0,1,0-.7c.1-.1.4-.3.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.7,561.9v.4l-.4.2c-.1-.1-.2-.2-.1-.4l.2-.2C395.6,561.7,395.6,561.9,395.7,561.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.8 558.4 405.7 558.4 405.8 558.4 405.8 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.5,561.4v.2c-.2.1-.3.3-.5.1s-.1-.1,0-.3l.2-.2C399.3,561.3,399.5,561.2,399.5,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.3,561h.4c0,.2,0,.2-.1.4s-.4,0-.6.2l.3-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.8,563.2a.3.3,0,0,1-.2.4c-.1.1-.2,0-.3,0s.1-.3.2-.4S396.8,563,396.8,563.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.3,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.8,560.8c-.1,0-.3.1-.3,0s.1-.2.2-.3S405.9,560.7,405.8,560.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.1,546.7l.4-.2c0,.1-.1.2,0,.2s.4.2.8,0l-.4.3a.3.3,0,0,0,.2.3c-.1,0-.1.2-.1.2s.4.2.5.4-.3-.3-.5-.1-.1.4-.1.6h-.1c-.1.2-.5.3-.4.5a3.6,3.6,0,0,1-1.4.4l-.4-.6h-.1a.9.9,0,0,0,0-.9c.1-.2.2,0,.3-.2s.1-.3.2-.4l.9-.7C395.6,547,396.2,546.5,396.1,546.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.8,559.1h0l.6-.2h-.1l.6.2c.2.3-.1.8,0,1.1s-.1,0-.2,0-.3.2-.1.2l-.4.2h0c-.2,0-.2-.1-.5.1s.2,0,.1.2-.4-.1-.5-.4v.2c-.1-.1.1-.4-.1-.3h-.1a6.4,6.4,0,0,1,.1-.8C410.1,559.5,410.4,559.4,410.8,559.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.4,561.6v.2c-.1.1-.2,0-.2-.1S404.4,561.5,404.4,561.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,561.3h-.1c-.1,0-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.7,561c-.1.1-.2.1-.2,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.8 560.2 411.8 560.2 411.8 560.3 411.7 560.3 411.8 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "409.8 561.1 409.9 560.8 409.8 561 409.8 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.8,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.3,561.1c-.1.1,0,.1,0,.1s-.1-.2-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.6,562c0,.3.4.2.4.5h-.1c.3.1-.3.4,0,.5h-.2c-.1.1-.1.2,0,.3h-.1l-.5.4h-.4a.1.1,0,0,0,0,.1c.1-.3-.5-.3-.3-.7s0-.2,0-.4.1-.2.2-.4A1.5,1.5,0,0,1,417.6,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.5,563.6c0,.1-.1.2-.2.2s-.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.7,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.8,563.2h0S407.8,563.2,407.8,563.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.3,563.6v.2l-.5.2c0-.1-.2-.1-.1-.3l.3-.2C407.2,563.5,407.5,563.4,407.3,563.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "418.4 562.4 418.4 562.4 418.4 562.4 418.4 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "407.3 563.6 407.3 563.5 407.4 563.5 407.3 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "426.5 557.2 426.4 557.2 426.5 557.2 426.5 557.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.6,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,562.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "418.4 562.8 418.3 562.8 418.4 562.8 418.4 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.6,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.3,563.5c-.1,0,0,0,0-.1S417.3,563.5,417.3,563.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,563.8h-.1C416.9,563.7,417,563.7,416.9,563.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.1,563.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.4 563.6 417.3 563.6 417.3 563.6 417.4 563.5 417.4 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.1,564.8c-.1.2-.3.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,564.7c-.1.1-.2,0-.1-.1S407.4,564.7,407.4,564.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.8,565.2c-.1.1-.1,0-.1-.1S406.8,565.1,406.8,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.7,566.3c-.1,0-.3.2-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.4,566.5s-.1.1-.1,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.6 566.4 405.5 566.4 405.6 566.4 405.6 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "405.5 566.6 405.4 566.6 405.5 566.6 405.5 566.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.1,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.3,565.5v.2c-.2.1-.3-.1-.3-.2A.2.2,0,0,1,418.3,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.6,567.7h-.1C413.5,567.5,413.7,567.5,413.6,567.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "415.6 567.4 415.6 567.3 415.7 567.4 415.6 567.4"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-230"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "332.5",
      "y": "552.1",
      "width": "36.7",
      "height": "14.81"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.5 566.9 348.4 566.9 348.5 566.9 348.5 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.6 566.9 348.6 566.9 348.6 566.9 348.6 566.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.5,553.8h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,350.5,553.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.6,553.3s0,.1,0,.1h-.1C350.5,553.4,350.5,553.3,350.6,553.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.2,559.8h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "345",
      "y": "558.6",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,558.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.1,560.1c0,.1,0,.1-.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.6,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,557.5h0c-.1-.1.1-.1.1-.1h.3c0,.1,0,.1,0,.2s0,.2-.1.2h-.3c.1-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.4,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.9,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.8,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.9,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.5,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.1,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.9,555.9h0C339.9,556,339.9,555.9,339.9,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.1,555h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340,555.7h0S340,555.7,340,555.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.3,557.5h0A.1.1,0,0,1,340.3,557.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "335.9 557.6 335.8 557.6 335.8 557.5 335.9 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.3,557.7h.1c-.1.1-.2,0-.3,0h0s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,557.3s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341,556.7a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341,557.3s.2,0,.1.1H341Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.2,557.6h.1c.2,0,.4,0,.5.2h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.6,558.4c0,.1-.2.1-.2.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "337.5 558.4 337.5 558.5 337.5 558.4 337.5 558.5 337.5 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.1,559.6h0c-.2.1-.4,0-.6,0h-.1A.8.8,0,0,1,349.1,559.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "338 558.6 337.9 558.6 338 558.6 338 558.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.4,558.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,558.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.7,559h.3s.1.1,0,.1h-.4S338.7,559,338.7,559Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "338.8 559 338.8 559 338.8 559 338.8 559"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.2,552.2c0,.1-.1.1-.2.1l-.4-.2h-.1C340.7,552.2,341.1,552,341.2,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.2,560.1h.1a.1.1,0,0,1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.9 560.1 340.9 560.1 340.9 560.1 340.9 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.5,560.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "342 553.7 342 553.7 342 553.7 342 553.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.1,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.1,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.4,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.2,558c.1,0,.3-.1.4,0s0,.1-.1.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.6,560.7h.2c0,.1,0,.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,556h-.1C343.6,556,343.7,556,343.8,556Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.8,561s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.9,552.9h.2c0,.1,0,.1-.1.1S343.8,552.9,343.9,552.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.1,554.3h.1c.1,0,.3-.1.4.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.3,556.8h.1c-.1,0,0-.1-.1-.1s.2,0,.2.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.5,562.8c.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.4,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.4,556.8h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.2,561.5h-.1s.2.1.2-.1.4,0,.5.2h.3s0,.1,0,.1-.4-.1-.5.2h-.5c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,561.1h.2c0,.1-.1.1-.1.1h-.1S345.6,561.1,345.6,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.9,554.8h.2s0,.1,0,.1h-.2S344.9,554.9,344.9,554.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345 554.9 344.9 554.9 344.9 554.9 345 554.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,561.8c-.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.4 561.7 346.5 561.7 346.4 561.8 346.4 561.8 346.4 561.7 346.4 561.7 346.4 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.5,561.6h.3c0,.1-.2.1-.2.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.7,563.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.1,554.5h.1c0-.1-.1,0-.1-.1h0A.1.1,0,0,0,346.1,554.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.2,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.9,562.2h0c.1,0,.3-.1.3.1s-.1.1-.2.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.5,556.4h-.3C346.3,556.4,346.4,556.3,346.5,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.2,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.7,557.3h0S349.7,557.3,349.7,557.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.8,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 557.4 349.9 557.4 349.9 557.4 349.9 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.9,561.1c.1,0,.1.1,0,.1h-.1s0-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.8,558.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,558.5h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351,558.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.3,561.5s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.3,562.8c0-.1-.1,0-.1-.1h.6c-.1-.1.1,0,.1-.1h.1c.1.1.2.2.2.3s0,.1,0,.2h0s0,.1,0,.1h-.7c0-.1.1-.1.1-.1h-.2c.1-.1,0-.1-.1-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352,558.5h.2c0,.1-.1.1-.1.1H352Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.9,558.7h.1c.1,0,.1.1.1.2s-.4-.1-.5-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.9,559.3h.3c.1-.1.2,0,.3,0h.1v.2h-.1l.2.2c.1.1-.1.1-.1.2h-.2c.1-.1-.1-.1-.2-.1h-.3S363,559.4,362.9,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.3,561.9h0c.1,0,.1-.2.3-.2h.2c0,.1,0,.2-.1.3h-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "353.1",
      "y": "559.9",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.9,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.4,559.6h0c.1-.1.2.2.3,0s.2,0,.2.2-.1.1-.2.2h-.2c0-.1-.1,0-.1-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358,559.9s.1,0,0-.1h.1c.1,0,.1-.1.2-.1h.2a.2.2,0,0,1,.1.3H358C358,559.9,358.1,559.9,358,559.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.1 560.5 358 560.5 358.1 560.5 358.1 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.4,562.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "360.4",
      "y": "562.5",
      "width": "0.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.8,565.6a.1.1,0,0,1,.1.2h-.2C360.6,565.7,360.6,565.6,360.8,565.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.2,561.1h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.1,563.2h.1s.1,0,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.6,564.1h.1c.1,0,.4-.1.5.1v.2h0l-.2.2h-.3v-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.9,562.1s0,0,0-.1h.1s0-.1,0-.1h.1c.1-.1.2,0,.3,0h.4c-.1.1.1.1,0,.1h0c.1.1-.1.1,0,.2h-.2s-.1-.1-.2,0-.1-.2-.2-.1h0c0-.1.1-.1,0-.1H363s.1-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.5,563.7h0c0-.1.1-.1.1-.2s.1-.2.2-.1h.5c0,.1.1.1.1.2h0v.2h-.1c-.1,0-.1.1-.1.1H366s0,0,0-.1h-.4s.1-.1,0-.1h-.2C365.5,563.8,365.4,563.7,365.5,563.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.7,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.3,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,562.6h0s.1,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.3,560.6h.3c.1.1.2.1.1.2s-.1.1,0,.1-.1,0-.1.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.6,561h.2s0,0,0-.1h.3c.1,0,0,.1.1.1s0,.2-.1.3h0s0,.1,0,.1h-.4c0-.1,0-.2-.1-.1h0C366.5,561.2,366.7,561.1,366.6,561Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.9,561.8h.1c.1,0,0-.1.1-.1s0-.2,0-.2h.3c-.1.1.1.1.1.1s0-.1.1-.1,0,.2.1.2h.2s0,0,0,.1h.1c.1,0,0,.1.1.1s0,.1.1.1h-.1c0,.1.1,0,.1.1h-.1a.2.2,0,0,0,0,.1h0s-.1.1,0,.1h0s-.1-.1-.1,0h0c-.2,0,0,.3-.2.3h-.2c0-.1-.1-.1-.2-.1h-.1s.1-.1,0-.2h-.1s0-.1,0-.1h-.1s.1-.1,0-.1H368s0,0,0-.1H368s0-.1,0-.1h-.1s.1,0,.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.3,558.9h.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.7,559.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "360.9 559 360.8 559 360.8 559 360.8 559 360.8 559 360.9 559"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.1,558.9h.6s-.1,0,0,.1v.2c-.1.1-.1.1-.1.2h-.1c-.1,0,0,.1,0,.1h-.3c-.1-.1-.1,0-.2.1s.1-.1,0-.2h0c-.1-.1.1-.1,0-.1h-.1C361,559.1,361.1,559,361.1,558.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361,559h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "361.5 559.5 361.5 559.5 361.5 559.5 361.5 559.5"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-231"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "388.3",
      "y": "572",
      "width": "37.3",
      "height": "15.09"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.6 587.1 404.5 587.1 404.6 587.1 404.6 587.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.7 587.1 404.6 587.1 404.7 587.1 404.7 587.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.6,573.7h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,406.6,573.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M406.8,573.3s0,.1,0,.1h-.1C406.6,573.4,406.7,573.3,406.8,573.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390,579.9h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "401",
      "y": "578.7",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.3,579.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.6,578.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391,580.2c0,.1,0,.1-.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.3,575.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.8,577.5h0c-.1-.1.1-.1.1-.1h.3c0,.1,0,.1,0,.2s0,.2-.2.2h-.3c.1-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.2,576h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.7,575.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,575.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.7,575.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395,577.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.9,575.9h0C395.8,576,395.8,576,395.9,575.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,575h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,575.7h0S395.9,575.7,396,575.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.3,577.6h0A.1.1,0,0,1,396.3,577.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391.7 577.6 391.6 577.6 391.7 577.6 391.7 577.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.2,577.8h.1c-.1.1-.2,0-.3,0h0s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.5,576h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.9,577.4s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.9,576.7a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397,577.3s.2,0,.1.1H397Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.1,577.6h.1c.2,0,.4,0,.5.2h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.5,578.5c0,.2-.2.1-.2.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.4 578.5 393.4 578.6 393.3 578.5 393.4 578.6 393.4 578.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.2,579.7h0c-.2.1-.4,0-.6,0h-.1A.8.8,0,0,1,405.2,579.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "393.9 578.7 393.8 578.7 393.9 578.7 393.9 578.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.3,578.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.2,578.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.6,579h.3s.1.1,0,.1h-.4S394.6,579.1,394.6,579Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.7 579 394.7 579 394.7 579 394.7 579"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395.6,581.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.2,572.2c0,.1-.1.1-.2.1l-.4-.2h-.1C396.7,572.1,397,571.9,397.2,572.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,580.2h.1a.1.1,0,0,1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.9 580.2 396.8 580.2 396.9 580.2 396.9 580.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.5,580.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "398 573.7 398 573.7 398 573.7 398 573.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.1,574.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.1,574.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.4,573.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.2,578c.1,0,.3-.1.5,0s0,.1-.1.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.6,580.8h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.8,576h-.1C399.6,576,399.7,576,399.8,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.8,581.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.9,572.8h.2c0,.1,0,.1-.1.1S399.8,572.9,399.9,572.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.1,574.3h.1c.1,0,.3-.1.4.1v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.3,576.8h.1c-.1,0,0-.1-.1-.1s.2,0,.3.1h-.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.6,583c.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.4,576.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.4,576.8h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.4,581.6h-.1s.2.1.2-.1.4,0,.5.2h.4s0,.1,0,.1-.4-.1-.5.2h-.5c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.7,581.2h.2c0,.1-.1.1-.1.1h-.1S401.6,581.2,401.7,581.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.9,574.8h.2s0,.1,0,.1h-.2S400.9,574.8,400.9,574.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401 574.9 400.9 574.9 400.9 574.9 401 574.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.4,581.9c-.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.5 581.9 402.5 581.9 402.5 581.9 402.5 581.9 402.4 581.9 402.5 581.8 402.5 581.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.6,581.7h.3c0,.1-.2.1-.3.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.7,583.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.1,574.5h.1c.1-.1-.2,0-.1-.1h0S402.2,574.5,402.1,574.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.3,576.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404,582.3h0c.1,0,.3-.1.3.1s-.1.1-.2.2H404Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.5,576.4h-.3C402.4,576.4,402.5,576.3,402.5,576.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M404.3,577.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,581.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.8,577.4h0A0,0,0,0,1,405.8,577.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.9,577.4h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406 577.4 406 577.4 406 577.4 406 577.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,581.2c.1,0,.1.1,0,.2H408s0-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,578.6h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.1,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,581.6s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.5,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.6,582.9c0-.1-.1,0-.1-.1h0c.1-.1.2,0,.3-.1h.4c-.1-.1.1,0,.1-.1h.2c.1.1.2.2.2.3s0,.1,0,.2h0s0,.1,0,.1h-.3l-.4.2h-.1c0-.1.1-.1.1-.2h-.3c.1-.1,0-.1-.1-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,578.6h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.1,578.8v.2h0c.1,0,.2.1.1.2s-.4-.1-.5-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.3,579.4h.3c.1-.1.2,0,.3,0h.1v.2h-.1l.2.2c.1.1-.1.1-.1.2h-.2c.1-.1-.1-.1-.2-.1h-.3S419.3,579.5,419.3,579.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.6,582h0c.1,0,.2-.2.3-.2h.2c0,.1,0,.2-.1.3h-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "409.3",
      "y": "580",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.1,579.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410.6,579.7h0c.2-.1.2.2.4,0s.2,0,.2.2-.1.2-.2.2h-.2c0-.1-.1,0-.1-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.3,580s.1,0,0-.1h.1c.1,0,.1-.1.2-.1h.2a.2.2,0,0,1,.1.3h-.6C414.2,580,414.4,580,414.3,580Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "414.4 580.6 414.3 580.6 414.4 580.6 414.4 580.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.7,582.6h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "416.7",
      "y": "582.7",
      "width": "0.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.1,585.8a.1.1,0,0,1,.1.2H417C416.9,585.9,417,585.8,417.1,585.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.5,581.2h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.9,581h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.5,583.3h.1s.1.1,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.5,583.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419,584.3h.1c.1,0,.4-.1.5.1v.2h0l-.2.2h-.3v-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.3,582.2s0,0,0-.1h.1s0-.1,0-.1h.1c.1-.1.2,0,.3,0h.1v.2h.1c-.1.1.1.1,0,.1h0c.1.1-.1.1,0,.2h-.2s-.1-.1-.2,0-.1-.2-.2-.1h0c0-.1.1-.1,0-.1h-.1s.1-.1,0-.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.9,583.8h0c0-.1.1-.1.1-.2s.1-.2.2-.1h.5c0,.1.1.1.1.2h0v.2h-.1c-.1,0-.1.1-.1.1h-.1s0,0,0-.1H422s.1-.1,0-.1h-.2C421.9,584,421.9,583.9,421.9,583.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421,580h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.7,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.5,582.8h0s.1,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.7,580.7h.3c.1.1.2.1.1.2s-.1.1,0,.1-.1,0-.1.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423,581.1h.2s0,0,0-.1h.3c.1,0,0,.1.1.1s0,.2-.1.3h0s0,.1,0,.1h-.4c0-.1,0-.2-.1-.1h0C422.9,581.3,423.1,581.2,423,581.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.4,581.9h.1c.1,0,0-.1.1-.1s0-.2,0-.2h.3c-.1.1.1.1.1.2s0-.1.1-.1,0,.2.1.2h.2s0,0,0,.1h.1c.1,0,0,.1.1.1s0,.1.1.1h-.1c0,.1.1,0,.1.1h-.1a.2.2,0,0,0,0,.1h0s-.1.1,0,.1h0s0,.1,0,.1-.1-.1-.1,0h0c-.2,0,0,.3-.2.3H425c0-.1-.1-.1-.2-.1h-.1s.1-.1,0-.2h-.1s0-.1,0-.1h-.1s.1-.1,0-.1h-.1s0,0,0-.1h-.1s0-.1,0-.1h-.1s.1,0,.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.6,579h.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417,579.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.2 579.1 417.1 579.1 417.1 579.1 417.1 579.1 417.1 579.1 417.2 579.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.4,578.9h.6s-.1,0,0,.1v.2c-.1.1-.1.1-.1.2h-.1c-.1,0,0,.1,0,.1h-.3c-.1-.1-.2,0-.2.1s.1-.1,0-.2h0c-.1-.1.1-.1,0-.2h-.1C417.3,579.1,417.5,579.1,417.4,578.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.3,579h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "417.9 579.6 417.9 579.6 417.9 579.6 417.9 579.6"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-232"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379",
      "y": "535.4",
      "width": "37.3",
      "height": "15.09"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.3 550.5 395.3 550.4 395.3 550.4 395.3 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.4 550.5 395.4 550.5 395.4 550.4 395.4 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.3,537.1h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,397.3,537.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.5,536.7s0,.1,0,.1h-.1C397.4,536.8,397.4,536.6,397.5,536.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.8,543.2h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "391.7",
      "y": "542.1",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381.7,543.5c0,.1,0,.1-.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M379.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.6,540.9h0c-.1-.1.1-.1.1-.1h.3c0,.1,0,.1,0,.2s0,.2-.2.2h-.3c.1-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.4,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.3,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.5,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.1,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M385.7,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.6,539.3h0C386.5,539.4,386.6,539.3,386.6,539.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.7,538.3h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.7,539.1h0S386.6,539.1,386.7,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387,540.9h0A.1.1,0,0,1,387,540.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "382.4 540.9 382.4 541 382.4 540.9 382.4 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M382.9,541.1h.1c-.1.1-.2,0-.3,0h0s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.3,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.6,540.7s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.7,540.1a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.7,540.6s.2,0,.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.8,541h.1c.2,0,.4,0,.5.2h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.3,541.9c0,.2-.2.1-.2.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384.2 541.9 384.1 541.9 384.1 541.8 384.1 541.9 384.2 541.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,543.1h0c-.2.1-.4,0-.6,0h-.1A.8.8,0,0,1,396,543.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "384.6 542.1 384.5 542 384.6 542 384.6 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M385.1,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M385.3,542.4h.3s.1.1,0,.1h-.4S385.3,542.5,385.3,542.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.4 542.4 385.4 542.4 385.4 542.4 385.4 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M386.3,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.9,535.5c0,.1-.1.1-.2.1l-.4-.2h-.1C387.4,535.5,387.7,535.3,387.9,535.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.9,543.5h.1a.1.1,0,0,1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.6 543.5 387.6 543.5 387.6 543.5 387.6 543.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.3,543.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "388.7 537.1 388.7 537 388.7 537 388.7 537.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M388.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.1,537h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.9,541.4c.1,0,.3-.1.5,0a.1.1,0,0,1-.1.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.3,544.1h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.5,539.4h-.1C390.3,539.4,390.4,539.4,390.5,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.5,544.5s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.6,536.2h.2c0,.1,0,.1-.1.1S390.5,536.3,390.6,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.8,537.6h.1c.1,0,.3-.1.4.1v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391,540.2h.1c-.1,0,0-.1-.1-.1s.2,0,.3.1H391Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.3,546.3c.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,540.2h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.1,545H400s.2.1.2-.1.4,0,.5.2h.4s0,.1,0,.1-.4-.1-.5.2H400c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.4,544.5h.2c0,.1-.1.1-.1.1h-.1S392.3,544.5,392.4,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.6,538.2h.2s0,.1,0,.1h-.2S391.6,538.2,391.6,538.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.7 538.2 391.6 538.2 391.6 538.2 391.7 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.2,545.2c-.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.2 545.2 393.2 545.2 393.2 545.3 393.2 545.2 393.2 545.2 393.2 545.2 393.2 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.3,545h.3c0,.1-.2.1-.3.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.5,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.9,537.9h.1c0-.1-.2,0-.1-.1h0A0,0,0,0,0,392.9,537.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.7,545.7h0c.1,0,.3-.1.3.1s-.1.1-.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.3,539.8H393C393.1,539.7,393.2,539.7,393.3,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M395,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.6,540.7h0S396.5,540.7,396.6,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.6,540.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.7 540.8 396.7 540.8 396.7 540.8 396.7 540.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.8,544.6c.1,0,.1.1,0,.2h-.1s0-.1-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.7,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,541.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.8,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,545s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.2,541.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405.3,546.3c0-.1-.1,0-.1-.1h0c.1-.1.2,0,.3-.1h.4c-.1-.1.1,0,.1-.1h.2c.1.1.2.2.2.3s0,.1,0,.2h0s0,.1,0,.1H406l-.4.2h-.1c0-.1.1-.1.1-.2h-.3c.1-.1,0-.1-.1-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.9,541.9h.2c0,.1-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M399.8,542.1v.2h0c.1,0,.2.1.1.2s-.4-.1-.5-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410,542.8h.3c.1-.1.2,0,.3,0h.1v.2h-.1l.2.2c.1.1-.1.1-.1.2h-.2c.1-.1-.1-.1-.2-.1h-.3S410.1,542.8,410,542.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M402.3,545.4h0c.1,0,.2-.2.3-.2h.2c0,.1,0,.2-.1.3h-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "400",
      "y": "543.4",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M400.8,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M401.3,543.1h0c.2-.1.2.2.4,0s.2,0,.2.2-.1.2-.2.2h-.2c0-.1-.1,0-.1-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M405,543.3s.1,0,0-.1h.1c.1,0,.1-.1.2-.1h.2a.2.2,0,0,1,.1.3h-.2c0-.1-.1.1-.1,0H405C405,543.4,405.1,543.4,405,543.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 544 405 544 405.1 544 405.1 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,546h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "407.5",
      "y": "546",
      "width": "0.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.8,549.1a.1.1,0,0,1,.1.2h-.2C407.7,549.3,407.7,549.1,407.8,549.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.3,544.6h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.6,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.2,546.7h.1s.1.1,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M409.7,547.6h.1c.1,0,.4-.1.5.1v.2h0l-.2.2h-.3v-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M410,545.5s0,0,0-.1h.1s0-.1,0-.1h.1c.1-.1.2,0,.3,0h.1v.2h.1c-.1.1.1.1,0,.1h0c.1.1-.1.1,0,.2h-.2s-.1-.1-.2,0-.1-.2-.2-.1h0c0-.1.1-.1,0-.1h-.1s.1-.1,0-.2H410Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.7,547.2h0c0-.1.1-.1.1-.2s.1-.2.2-.1h.5c0,.1.1.1.1.2h0v.2h-.1c-.1,0-.1.1-.1.1h-.1s0,0,0-.1h-.4s.1-.1,0-.1h-.2C412.7,547.3,412.6,547.3,412.7,547.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M411.8,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.5,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.3,546.1h0s.1,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.5,544.1h.3c.1.1.2.1.1.2s-.1.1,0,.1-.1,0-.1.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.7,544.5h.2s0,0,0-.1h.3c.1,0,0,.1.1.1s0,.2-.1.3h0s0,.1,0,.1h-.4c0-.1,0-.2-.1-.1h0C413.6,544.7,413.8,544.5,413.7,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M415.1,545.3h.1c.1,0,0-.1.1-.1s0-.2,0-.2h.3c-.1.1.1.1.1.2s0-.1.1-.1,0,.2.1.2h.3c.1,0,0,.1.1.1s0,.1.1.1h-.1c0,.1.1,0,.1.1h-.1a.2.2,0,0,0,0,.1h0s-.1.1,0,.1h0s0,.1,0,.1-.1-.1-.1,0h0c-.2,0,0,.3-.2.3h-.2c0-.1-.1-.1-.2-.1h-.1s.1-.1,0-.2h-.1s0-.1,0-.1h-.1s.1-.1,0-.1h-.1s0,0,0-.1h-.1s0-.1,0-.1h-.1s.1,0,.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.4,542.3h.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M407.7,542.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408 542.4 407.9 542.5 407.9 542.4 407.8 542.5 407.8 542.4 408 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408.1,542.3h.6s-.1,0,0,.1v.2c-.1.1-.1.1-.1.2h-.1c-.1,0,0,.1,0,.1h-.3c-.1-.1-.2,0-.2.1s.1-.1,0-.2h0c-.1-.1.1-.1,0-.2H408C408.1,542.5,408.2,542.4,408.1,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M408,542.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "408.6 543 408.6 543 408.6 542.9 408.6 543"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.2,521.2h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.8,516.4h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.5,517.3h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1H296l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.6,522.4h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S293.5,522.4,293.6,522.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.6,517h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3l.2-.2h.2S299.6,516.9,299.6,517Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.4,518.7h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S301.4,518.7,301.4,518.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298,519.9s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C298,519.9,297.9,519.9,298,519.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "297.6 519.4 297.7 519.3 297.6 519.4 297.6 519.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294.7,518.5h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "294.6 518.4 294.6 518.4 294.6 518.4 294.6 518.4 294.6 518.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.1,515.7a.1.1,0,0,1-.2-.1h.1C293.1,515.5,293.2,515.7,293.1,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.6,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.3,520.8s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.7,518.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M293.6,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M291.9,517.9h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S291.9,517.8,291.9,517.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292.5,519.9s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C292.4,519.8,292.5,519.9,292.5,519.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.4,519.4h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C289.3,519.3,289.4,519.3,289.4,519.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M291.7,522.6h.1C291.7,522.5,291.8,522.5,291.7,522.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292,525H292s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.3,520.6h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S289.3,520.6,289.3,520.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.9,522.6h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M289.5,522.4s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S289.4,522.3,289.5,522.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M287.9,522.2h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.2,521.8H296c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.8,521.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "295.6 522 295.7 521.9 295.7 521.9 295.7 521.9 295.7 521.9 295.6 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.5,522.1h0l-.3.2H295s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C295.5,521.9,295.4,522,295.5,522.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.6,522h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "294.8 521.7 294.8 521.7 294.8 521.7 294.8 521.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.4,523.6h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352,518.8h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.7,519.7h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,524.8h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4H343c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S343.8,524.8,343.8,524.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.9,519.4h0c-.1.1-.1.2-.2.3h-.2c-.1-.1-.1-.2,0-.3h.4S349.9,519.3,349.9,519.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.7,521.1h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S351.7,521.1,351.7,521.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,522.3s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C348.2,522.3,348.1,522.3,348.2,522.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.8 521.8 347.9 521.7 347.8 521.8 347.8 521.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.9,520.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "344.9 520.8 344.9 520.8 344.8 520.8 344.8 520.8 344.9 520.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.3,518.1a.1.1,0,0,1-.2-.1h.1C343.4,517.9,343.4,518.1,343.3,518.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.8,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.5,523.2s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.9,520.5h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.1,520.3h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S342.1,520.2,342.1,520.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.7,522.3s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C342.7,522.2,342.7,522.3,342.7,522.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.6,521.8h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0H339s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C339.6,521.7,339.7,521.7,339.6,521.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.9,525h.1C342,524.9,342,524.9,341.9,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.3,527.4h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.5,523h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S339.5,523,339.5,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.1,525h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.7,524.8s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S339.6,524.7,339.7,524.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M338.1,524.6h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1H338c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1H337s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.4,524.2h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346,524.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "345.8 524.4 345.9 524.3 345.9 524.3 345.9 524.3 346 524.3 345.8 524.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.7,524.5h0l-.3.2h-.3s0-.1,0-.1H345c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C345.7,524.3,345.6,524.4,345.7,524.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.8,524.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "345 524.1 345 524.1 345 524.1 345 524.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.4,542.4h0c.1.1-.1.1,0,.2H305v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306,537.6h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.7,538.5h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.8,543.6h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4H297c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S297.7,543.6,297.8,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.8,538.2h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3l.2-.2h.2S303.8,538.1,303.8,538.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.6,539.9h0s-.1.1,0,.1-.3-.1-.3.1H305c0-.1,0-.2.1-.2h.5S305.6,539.9,305.6,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302.2,541.2s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C302.2,541.1,302.1,541.1,302.2,541.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.8 540.6 301.9 540.6 301.8 540.6 301.8 540.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.9,539.7h0c-.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "298.8 539.6 298.8 539.6 298.8 539.7 298.8 539.6 298.8 539.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.3,536.9a.1.1,0,0,1-.2-.1h.1C297.3,536.7,297.4,536.9,297.3,536.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.8,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.5,542s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.9,539.3h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.8,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.1,539.1h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S296.1,539,296.1,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.7,541.1s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C296.6,541,296.7,541.1,296.7,541.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.6,540.6h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0H293s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C293.5,540.5,293.6,540.5,293.6,540.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M295.9,543.8h.1C295.9,543.7,296,543.7,295.9,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M296.2,546.2h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.5,541.8h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S293.5,541.8,293.5,541.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294.1,543.8h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M293.7,543.6s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S293.6,543.5,293.7,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292.1,543.4h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.4,543h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300,543h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "299.8 543.2 299.9 543.1 299.9 543.1 299.9 543.1 299.9 543.1 299.8 543.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.7,543.3h0l-.3.2h-.3s0-.1,0-.1H299c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1V543C299.7,543.1,299.6,543.2,299.7,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M299.8,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "299 542.9 299 542.9 299 542.9 299 542.9"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.8,497.8h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.4,493h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.1,493.9h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,499h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S308.1,499,308.2,499Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.2,493.5h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S314.2,493.5,314.2,493.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316,495.3h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S316,495.3,316,495.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.6,496.5s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C312.6,496.5,312.5,496.5,312.6,496.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 496 312.3 495.9 312.2 496 312.2 496"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.3,495.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.2 495 309.2 495 309.2 495 309.2 495 309.2 495"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.7,492.3a.1.1,0,0,1-.2-.1h.1C307.7,492.1,307.8,492.3,307.7,492.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,497.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,497.4s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.3,494.7h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.2,494.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.5,494.5h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5C306.6,494.4,306.5,494.4,306.5,494.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.1,496.5s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C307,496.4,307.1,496.4,307.1,496.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304,496h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C303.9,495.9,304,495.9,304,496Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.3,499.1h.1C306.3,499.1,306.4,499.1,306.3,499.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,501.6h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.9,497.2h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S303.9,497.2,303.9,497.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.5,499.2h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.1,499s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S304,498.9,304.1,499Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M302.5,498.8h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,498.4h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.4,498.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.2 498.5 310.3 498.5 310.3 498.5 310.3 498.4 310.3 498.5 310.2 498.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.1,498.7h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C310.1,498.5,310,498.6,310.1,498.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.2,498.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "309.4 498.3 309.4 498.3 309.4 498.3 309.4 498.3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.7,507.7h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.3,502.9h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373,503.8h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.1,508.9h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S370,508.9,370.1,508.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.1,503.4h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3l.2-.2h.2S376.1,503.4,376.1,503.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.9,505.2h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S377.9,505.1,377.9,505.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.4,506.4s-.1,0,0,.1h0c-.1,0,0,.2-.2.1H374a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C374.5,506.3,374.3,506.4,374.4,506.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.1 505.9 374.1 505.8 374.1 505.8 374.1 505.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.2,504.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "371.1 504.9 371.1 504.9 371.1 504.9 371.1 504.9 371.1 504.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.6,502.2a.1.1,0,0,1-.2-.1h.1C369.6,502,369.7,502.1,369.6,502.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370,506.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.8,507.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.2,504.6h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.1,504.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.4,504.3h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5C368.5,504.3,368.4,504.3,368.4,504.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.9,506.4s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C368.9,506.2,369,506.3,368.9,506.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.9,505.9h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C365.8,505.8,365.9,505.8,365.9,505.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.2,509h.1C368.2,509,368.3,509,368.2,509Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M368.5,511.5h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.8,507.1h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S365.8,507.1,365.8,507.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.4,509.1H366c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366,508.8s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S365.9,508.8,366,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.4,508.6h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,0,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.7,508.2h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.3,508.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "372.1 508.4 372.2 508.3 372.2 508.3 372.2 508.3 372.2 508.3 372.1 508.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372,508.6h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C372,508.4,371.9,508.5,372,508.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372,508.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.3 508.1 371.3 508.1 371.3 508.2 371.3 508.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.5,498.3h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,493.5h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.8,494.4h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.9,499.5h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S348.8,499.5,348.9,499.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,494h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S354.9,494,354.9,494Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.7,495.8h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S356.7,495.7,356.7,495.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.2,497s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2V497h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C353.2,496.9,353.1,497,353.2,497Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.8 496.5 352.9 496.4 352.9 496.4 352.8 496.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350,495.5h0c-.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 495.5 349.9 495.5 349.9 495.5 349.9 495.5 349.9 495.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.4,492.8a.1.1,0,0,1-.2-.1h.1C348.4,492.6,348.5,492.7,348.4,492.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.8,497.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.6,497.9s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349,495.2h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,495.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.2,494.9h0c-.1,0-.3.2-.5.1V495h0c0-.1.1-.2.1-.2h.5S347.1,494.8,347.2,494.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.7,497s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C347.7,496.8,347.8,496.9,347.7,497Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.7,496.5h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C344.6,496.4,344.7,496.4,344.7,496.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347,499.6h.1C347,499.6,347.1,499.6,347,499.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.3,502.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.5,497.7h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S344.6,497.7,344.5,497.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.2,499.7h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.8,499.4s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S344.7,499.4,344.8,499.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.2,499.2h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1H343c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1H342s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,498.8h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.1,498.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "350.9 499 351 498.9 351 498.9 351 498.9 351 498.9 350.9 499"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.8,499.2h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C350.8,499,350.7,499.1,350.8,499.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.8,499h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "350.1 498.7 350.1 498.7 350.1 498.8 350.1 498.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333,496.7h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.7,491.9h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.4,492.8h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.5,497.9h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S325.4,497.9,325.5,497.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.5,492.4h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S331.5,492.4,331.5,492.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.3,494.2h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S333.3,494.1,333.3,494.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,495.4s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C329.8,495.3,329.7,495.4,329.8,495.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 494.9 329.5 494.8 329.5 494.8 329.4 494.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.5,493.9h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.5 493.9 326.5 493.9 326.4 493.9 326.4 493.9 326.5 493.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.9,491.2a.1.1,0,0,1-.2-.1h.1C325,491,325.1,491.1,324.9,491.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.4,495.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.2,496.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.6,493.6h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.5,493.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.8,493.3h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S323.7,493.2,323.8,493.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,495.4s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C324.3,495.2,324.4,495.3,324.3,495.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.3,494.9h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1,0,0,0,0h-.5c0-.1-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.5s0,.1,0,.1h.2C321.2,494.8,321.3,494.8,321.3,494.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.6,498h.1C323.6,498,323.7,498,323.6,498Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.9,500.5h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.1,496.1H321s0-.1,0-.1h0s-.1.1,0,.1h0S321.2,496.1,321.1,496.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.8,498.1h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.4,497.8s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S321.3,497.8,321.4,497.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.8,497.6h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.3c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,497.2h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.7,497.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "327.5 497.4 327.5 497.3 327.6 497.3 327.6 497.3 327.6 497.3 327.5 497.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,497.6h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C327.3,497.4,327.3,497.5,327.4,497.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.4,497.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "326.7 497.1 326.7 497.1 326.7 497.2 326.7 497.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.1,583.1h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.7,578.3h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.4,579.2h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.5,584.3h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S341.4,584.3,341.5,584.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.5,578.9h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S347.5,578.8,347.5,578.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.3,580.6h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S349.3,580.6,349.3,580.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.8,581.8s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C345.8,581.8,345.7,581.8,345.8,581.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.4 581.3 345.5 581.2 345.5 581.3 345.4 581.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M342.6,580.4h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.5 580.3 342.5 580.3 342.5 580.3 342.4 580.3 342.5 580.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.9,577.6a.1.1,0,0,1-.2-.1h.1C341,577.4,341.1,577.6,340.9,577.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.4,582.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.2,582.7s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.6,580h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.5,580h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.8,579.8h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S339.7,579.7,339.8,579.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.3,581.8s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C340.3,581.7,340.4,581.8,340.3,581.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.3,581.3h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a.1.1,0,0,0,0,.1h-.5c0-.1-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C337.2,581.2,337.3,581.2,337.3,581.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.6,584.5h.1C339.6,584.4,339.7,584.4,339.6,584.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.9,586.9h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.1,582.5H337s0-.1,0-.1h0s-.1.1,0,.1h0S337.2,582.5,337.1,582.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.8,584.5h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M337.4,584.3s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S337.3,584.2,337.4,584.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.8,584.1h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.1,583.7h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.7,583.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "343.5 583.8 343.6 583.8 343.6 583.8 343.6 583.8 343.6 583.8 343.5 583.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.4,584h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C343.3,583.8,343.3,583.9,343.4,584Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.4,583.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "342.7 583.6 342.7 583.6 342.7 583.6 342.7 583.6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.6,503.2h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426.2,498.5h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.9,499.4h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,504.5h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S417.9,504.4,418,504.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424,499h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S424,498.9,424,499Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.8,500.7h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S425.8,500.7,425.8,500.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.4,502s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C422.4,501.9,422.3,501.9,422.4,502Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "422 501.4 422.1 501.4 422 501.4 422 501.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.1,500.5h0c-.1,0,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "419 500.4 419 500.5 419 500.5 419 500.5 419 500.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.5,497.7a.1.1,0,0,1-.2-.1h.1C417.5,497.6,417.6,497.7,417.5,497.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418,502.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M417.7,502.8s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.1,500.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,500.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.3,499.9h0c-.1,0-.3.2-.5.1V500h0c0-.1.1-.2.1-.2h.5S416.3,499.8,416.3,499.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.9,501.9s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1H416c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s-.1.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C416.8,501.8,416.9,501.9,416.9,501.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.8,501.4h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a0,0,0,0,0,0,0h-.5s-.2,0-.1-.1H413a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C413.7,501.3,413.8,501.4,413.8,501.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.1,504.6h.1C416.1,504.5,416.2,504.6,416.1,504.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.4,507h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.7,502.7h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S413.7,502.6,413.7,502.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M414.3,504.6h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M413.9,504.4s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S413.8,504.4,413.9,504.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M412.3,504.2h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.6,503.8h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.2,503.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "420 504 420.1 503.9 420.1 503.9 420.1 503.9 420.1 503.9 420 504"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M419.9,504.2h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C419.9,503.9,419.8,504,419.9,504.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420,504h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "419.2 503.7 419.2 503.7 419.2 503.8 419.2 503.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M430.1,527.1h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M430.7,522.4h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.4,523.3h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1h0l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.5,528.4h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S422.4,528.3,422.5,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M428.5,522.9h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S428.5,522.8,428.5,522.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M430.3,524.6h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S430.3,524.6,430.3,524.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M426.8,525.9s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C426.8,525.8,426.7,525.8,426.8,525.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "426.4 525.3 426.5 525.3 426.5 525.3 426.4 525.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M423.6,524.4h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "423.5 524.3 423.5 524.3 423.4 524.4 423.4 524.4 423.5 524.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.9,521.6a.1.1,0,0,1-.2-.1h.1C422,521.4,422.1,521.6,421.9,521.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.4,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.2,526.7s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M422.6,524h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M422.5,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.8,523.8h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S420.7,523.7,420.8,523.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M421.3,525.8s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C421.3,525.7,421.4,525.8,421.3,525.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.3,525.3h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a.1.1,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C418.2,525.2,418.3,525.3,418.3,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.6,528.5h.1C420.6,528.4,420.7,528.4,420.6,528.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M420.9,530.9h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.1,526.5H418s0-.1,0-.1h0s-.1.1,0,.1h0S418.2,526.5,418.1,526.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.8,528.5h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M418.4,528.3s-.1,0-.1.1h-.1s0,0,0,.1h-.5c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S418.3,528.2,418.4,528.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M416.8,528.1h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M425.1,527.7h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.7,527.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "424.5 527.9 424.6 527.8 424.6 527.8 424.6 527.8 424.6 527.8 424.5 527.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.4,528h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C424.3,527.8,424.3,527.9,424.4,528Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M424.4,527.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "423.7 527.6 423.7 527.6 423.7 527.6 423.7 527.6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.2,527.7h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.8,523h.1s-.3,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.5,523.9h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1H348l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,529h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1V529h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S345.5,528.9,345.6,529Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.6,523.5h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S351.7,523.4,351.6,523.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.5,525.2h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S353.5,525.2,353.5,525.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350,526.5s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2v-.2h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C350,526.4,349.9,526.4,350,526.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 525.9 349.7 525.9 349.6 525.9 349.6 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.7,525h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.7 524.9 346.7 524.9 346.6 525 346.6 525 346.7 524.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.1,522.2a.1.1,0,0,1-.2-.1h.1C345.2,522,345.2,522.2,345.1,522.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.6,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.3,527.3s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M345.7,524.6h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,524.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.9,524.4h0c-.1,0-.3.2-.5.1v-.2h0c0-.1.1-.2.1-.2h.5S343.9,524.3,343.9,524.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.5,526.4s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.5.5,0,0,0,0,.1h.1s-.1.1,0,.1h.1C344.5,526.3,344.5,526.4,344.5,526.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.4,525.9h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1a.1.1,0,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.2s0,0,0,0h.3s0,.1,0,.1h.2C341.4,525.8,341.5,525.9,341.4,525.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M343.7,529.1h.1C343.8,529,343.8,529,343.7,529.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M344.1,531.5H344s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.3,527.1h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S341.3,527.1,341.3,527.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.9,529.1h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M341.5,528.9s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S341.4,528.8,341.5,528.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M339.9,528.7h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1H340c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.2,528.3H348c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.8,528.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "347.6 528.5 347.7 528.4 347.7 528.4 347.7 528.4 347.8 528.4 347.6 528.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.5,528.6h0l-.3.2H347s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C347.5,528.4,347.4,528.5,347.5,528.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M347.6,528.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "346.8 528.2 346.8 528.2 346.8 528.2 346.8 528.2"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M362.8,542.3h0c.1.1-.1.1,0,.2h-.3v-.2c.1,0-.1-.2.1-.2h.3c0,.1,0,.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363.4,537.5h.1s-.2,0-.1.1-.4.1-.5,0h0l-.3.2h-.1c.1-.2.4-.1.4-.4l.4-.2h.1c-.1.1,0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.1,538.4h.2c0,.1-.2.1-.2.2h.1l-.2.2h-.2c.1.1-.1.1-.1.1h-.2l-.3-.2c-.1,0,0-.1,0-.2h0s0-.1,0-.1h.1c0-.1,0-.1.1-.1s0,0,0,0h.1l.3-.3h.1c0,.1,0,.1,0,.2h.2c0,.1,0,.1.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.2,543.5h0s-.1,0,0,.1h0l-.2.2c0,.1-.2.1-.3.1h-.1v-.4h-.2c-.1-.1,0-.2,0-.3h.2c0,.1.1,0,.2,0h.4S355.1,543.5,355.2,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.2,538h0c-.1.1-.1.2-.2.3h-.3c-.1-.1-.1-.2,0-.3h.4S361.2,538,361.2,538Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M363,539.8h0s-.1.1,0,.1-.3-.1-.3.1h-.3c0-.1,0-.2.1-.2h.5S363,539.8,363,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.6,541s-.1,0,0,.1h0c-.1,0,0,.2-.2.1h-.2a.2.2,0,0,1-.2-.2V541h0c.1.1,0-.1.1,0h.1a0,0,0,0,0,0,0h.2s0,0,0,0h0C359.6,541,359.5,541,359.6,541Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 540.5 359.3 540.4 359.2 540.5 359.2 540.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.3,539.6h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.2 539.5 356.2 539.5 356.2 539.5 356.2 539.5 356.2 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.7,536.8a.1.1,0,0,1-.2-.1h.1C354.7,536.6,354.8,536.8,354.7,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,541.9s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.3,539.2h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.5,539h0c-.1,0-.3.2-.5.1V539h0c0-.1.1-.2.1-.2h.5S353.5,538.9,353.5,539Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.1,541s0,.1,0,.1h0s0,.1,0,.1h-.1c0,.2-.2,0-.2.1h-.5c.1-.1-.1,0,0-.1h0c-.1,0,0-.1,0-.2h0c.1,0,.1-.1.1-.1s.2,0,.2-.1.1.1.2,0h0c.1,0,0,.1,0,.1h.1s0,.2.1.1h.1a.4.4,0,0,0,0,.1h.1s-.1.1,0,.1h.1C354,540.9,354.1,540.9,354.1,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351,540.5h0c0,.1,0,.1,0,.2s0,.2-.1.2,0,.1-.1.1,0,0,0,0h-.5s-.2,0-.1-.1h-.1a.3.3,0,0,0,0-.2s.1-.1.1-.1,0-.1.1-.1h.4s0,.1,0,.1h.2C350.9,540.4,351,540.4,351,540.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.3,543.6h.1C353.3,543.6,353.4,543.6,353.3,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.6,546.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.9,541.7h-.1s0-.1,0-.1h0s-.1.1,0,.1h0S350.9,541.7,350.9,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,543.7h-.4c-.1,0,0-.1-.1-.1s.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.1,543.5s-.1,0-.1.1h-.6c.1-.1-.1-.1-.1-.3h0s0-.1,0-.1h.1c0-.1.1-.1.2-.1h.2c.1,0,.1.1.1.1s0,.1,0,.1S351,543.4,351.1,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M349.5,543.3h.1a.1.1,0,0,0,0,.1h.1s-.1,0-.1.1h0s-.1.1-.1.1h0c-.1,0,.1.1,0,.1s0,.2.1.2,0,.1,0,.1h-.1c0,.1-.1,0-.1.1h-.1c0-.1-.1-.1-.1-.1s.1.1,0,.1,0-.2-.1-.1h-.6c.1-.1-.1-.1-.1-.1h-.1s.1-.1,0-.1h-.1s.1.1.1,0h0c.1-.1-.1-.3.1-.3h.1c.1,0,0-.1.1-.1s.2.1.2,0,0-.1,0-.1,0,.1.1.2h.1s0,.1,0,.1h.1s0,.1,0,.1h.2s-.1.1,0,.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.8,542.9h-.2c0-.1-.1-.2.1-.2h.1c0,.1.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.4,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "357.2 543 357.3 543 357.3 543 357.3 542.9 357.3 543 357.2 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,543.2h0l-.3.2h-.3s0-.1,0-.1h-.2c.1-.1,0-.1,0-.2s.1-.1,0-.1h.1s0-.1,0-.1h.2c.1,0,.1-.1.2-.1s0,.2.1.2h0c.1,0,0,.1.1.1v-.2C357.1,543,357,543.1,357.1,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.2,543.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "356.4 542.8 356.4 542.8 356.4 542.8 356.4 542.8"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.4,560.2s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.2,559.7h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.2,554.8c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.6,553.1h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.2,557.7h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.9,559.9h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,0h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M373.9,556.8h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C374,556.8,374,556.7,373.9,556.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.4 556.3 374.5 556.4 374.4 556.3 374.4 556.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.7,553.3h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.7 553.2 374.7 553.2 374.7 553.1 374.7 553.1 374.7 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377,551.1a.1.1,0,0,1,.1-.2h.1C377.2,551.1,377.1,551.2,377,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.5,552.6h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.1,552.4h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.8,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.8,552.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.6,550.4h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.8,551.4h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.6,548.3h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370,551.3h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.7,552.1s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.4,548.4s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.6,549.5h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.7,549.1h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C370,549,369.7,548.9,369.7,549.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.6,547.5c-.1,0,0,.1,0,.1h-.9s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.3,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.8,555.5c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.7,555.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.5 554.9 371.6 555 371.6 555 371.6 555 371.6 555 371.5 554.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.3,554.9h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C371.5,554.8,371.4,554.7,371.3,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.4,554.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "371.5 554.1 371.6 554.1 371.5 554.1 371.5 554.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.8,572.3s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M336.6,571.8h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.6,566.8c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1H334l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329,565.1h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2c0,.1,0,.1,0,.1H329Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.6,569.8h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.3,571.9h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,.1h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M332.3,568.8h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C332.4,568.8,332.3,568.7,332.3,568.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.8 568.3 332.9 568.4 332.8 568.4 332.8 568.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.1,565.3H333c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 565.2 333.1 565.2 333.1 565.2 333.1 565.2 333.1 565.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M335.4,563.1a.1.1,0,0,1,.1-.2h.1C335.6,563.2,335.4,563.3,335.4,563.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.9,564.6h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.5,564.5h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333.2,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,564.2h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M333,562.5h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1v.2H333Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331.2,563.4h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M331,560.4h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.4,563.3h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.1,564.2s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,560.5s0-.1,0-.1h.1s-.1,0-.1,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,561.6h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1H328Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.1,561.1h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C328.3,561.1,328.1,561,328.1,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328,559.5c-.1,0,0,.1,0,.1h-.4s0,0,0,0H327s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2H327s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.4,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1H328Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.2,567.5c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M330.1,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.9 567 330 567 330 567 330 567.1 330 567.1 329.9 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.7,566.9h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C329.9,566.8,329.8,566.8,329.7,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.8,566.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "329.9 566.1 329.9 566.1 329.9 566.2 329.9 566.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M393.5,512.5s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M398.3,512.1h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.3,507.1c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.6,505.4h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2s0-.1,0-.1h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.3,510H397c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396,512.2h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,0h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2H396Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394,509.1h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C394.1,509.1,394,509,394,509.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 508.6 394.5 508.7 394.5 508.6 394.5 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.8,505.6h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.8 505.5 394.8 505.5 394.7 505.5 394.8 505.5 394.8 505.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M397.1,503.4a.1.1,0,0,1,.1-.2h.1C397.3,503.4,397.1,503.5,397.1,503.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.5,504.9h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.2,504.7h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.9,504.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,504.4h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M394.7,502.7h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.9,503.7h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M392.7,500.6h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.1,503.6h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.8,504.4s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.4,500.8s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.7,501.8h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.8,501.4h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.2H390C390,501.3,389.8,501.2,389.8,501.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.6,499.8c-.1,0,0,.1,0,.1h-.4s0,0,0,0h-.5s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.4,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.8,507.8c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.8,507.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391.5 507.2 391.6 507.3 391.6 507.3 391.7 507.3 391.6 507.3 391.5 507.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.4,507.2h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C391.6,507.1,391.4,507,391.4,507.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M391.5,507.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "391.6 506.4 391.6 506.4 391.6 506.4 391.6 506.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.3,513.2s0,0,0,0h-.1c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M359.1,512.7h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.2.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.1,507.7c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M351.5,506h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.1,510.7h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.8,512.8h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,.1h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.9,509.7h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C354.9,509.7,354.9,509.6,354.9,509.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.3 509.2 355.4 509.3 355.3 509.3 355.3 509.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,506.2h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.6 506.1 355.6 506.1 355.6 506.1 355.6 506.1 355.6 506.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M357.9,504a.1.1,0,0,1,.1-.2h.1C358.1,504,358,504.1,357.9,504Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.4,505.5h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353,505.4h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.7,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,505.1h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M355.6,503.4h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.7,504.3h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.5,501.3H353c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.9,504.2h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M348.6,505.1s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.3,501.4s0-.1,0-.1h.1s-.1,0-.1,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.5,502.5h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.6,502h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C350.9,502,350.7,501.9,350.6,502Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M350.5,500.4c-.1,0,0,.1,0,.1H350s0,0,0,0h-.5s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.3,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.7,508.4c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.6,508h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "352.4 507.9 352.5 507.9 352.5 507.9 352.5 507.9 352.5 508 352.4 507.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.2,507.8H352l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C352.4,507.7,352.3,507.7,352.2,507.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M352.3,507.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "352.5 507 352.5 507 352.4 507 352.5 507"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.1,526.4s0,0,0,0H325c-.1.1-.1,0-.2,0a.3.3,0,0,1-.1-.3l.2-.2c.1.1.2-.1.2,0s.1.1.1.2,0,.1,0,.1h0c-.1,0-.1.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M329.9,525.9h0s-.1-.2-.2-.1-.2-.3-.1-.5h0c-.1-.1-.2-.1-.2-.3h.1c.3,0,.1.4.5.3l.2.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.9,521c-.1,0,0,.1,0,.1h0c-.1,0-.1-.2-.2-.1h-.3l-.2-.2c0,.1-.1-.1-.2,0s0-.2,0-.2a.4.4,0,0,1,.1-.4h.6l.3.2h0c-.1,0-.1.1-.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M322.3,519.2h-.1s0,0,0,.1h-.1l-.2-.2c-.1,0-.1-.2-.2-.2h.4a.3.3,0,0,1,0-.2c.1-.1.2,0,.3,0h.2c-.1,0,0,.1,0,.2h-.2c0,.1,0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.9,523.9h-.3c-.1-.1-.1-.1-.1-.2h.3l.2.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M327.6,526h-.1c-.2-.1,0-.3-.2-.3s-.1-.2,0-.3h.3s0,0,0,.1h0c-.1,0,0,.1,0,.1h0c-.1.1,0,.1,0,.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.7,522.9h-.2c0-.1-.2,0-.2-.2s0-.1-.1-.2l.2-.2h.2c-.1.1.1,0,.1.1h.1C325.7,522.9,325.7,522.8,325.7,522.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.1 522.4 326.2 522.5 326.1 522.5 326.1 522.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.4,519.4h-.1c0-.1-.1-.2-.1-.2h.2s0,.1,0,.1h0a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.4 519.3 326.4 519.4 326.4 519.3 326.4 519.3 326.4 519.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M328.7,517.2a.1.1,0,0,1,.1-.2h.1C328.9,517.3,328.8,517.4,328.7,517.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.2,518.8h0c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.8,518.6h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.5,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.5,518.3h0s.1,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.4,516.6h-.2c-.1-.1-.3-.3-.2-.5h.5c.1,0,0,0,0,.1h.1c-.1,0-.1.1-.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.5,517.5h-.3c0-.1,0-.1,0-.1s-.1-.2-.2-.2-.1-.1,0-.1h0c0-.1.1-.2,0-.2h.1c.1,0,0-.1.1-.1s0-.1,0-.1h.1c0-.1.1,0,.2-.1h.2s0,.2.1.2-.1.1,0,.2h.1s-.2,0-.1.1h0c0,.1.1.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.3,514.5s0,0,0,0h-.5c0-.1-.2-.2-.1-.3s.1-.1,0-.2h0c0-.1,0-.2.1-.2h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.7,517.4h0c.1,0,.1.1.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319.4,518.3s0,0,0-.1h.1c0,.1,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.1,514.6s0-.1,0-.1h.1s-.1,0-.1,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.3,515.7h-.1l-.2-.2c0-.1,0-.2.1-.2s.1,0,.1-.1h.2s0,0,0,.1,0,.1.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.4,515.2h-.3s0,0,0-.1h0c-.1,0,0-.1,0-.2s.1-.1.1-.2h.4s0,0,0,.1.1.1.2.1,0,.1,0,.1h.1c0,.1-.1.1-.1.1h-.1C321.7,515.2,321.4,515.1,321.4,515.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M321.3,513.6c-.1,0,0,.1,0,.1h-.4s0,0,0,0h-.5s0-.1,0-.1,0-.1.1-.1h-.1c0-.1.1-.1.1-.2h-.1s.1-.1,0-.1h.1c-.1-.1.1,0,0-.1s.1-.1.1-.1h.1c.1,0,0-.1,0-.1h.3s0,.2.1.1h0c.1.1.2-.1.3,0s0,.1,0,.1h.2c-.1.1,0,.2,0,.2h0s0,.1,0,.1-.1,0-.1.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.5,521.6c0-.1-.1-.1-.1-.2s.2-.1.2,0h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.4,521.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.2 521.1 323.3 521.1 323.3 521.1 323.3 521.2 323.3 521.2 323.2 521.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323,521h-.2l-.2-.2c0-.1,0-.2-.1-.3h.1v-.2h.6c0,.1.1.1.2.1s-.2,0-.2.1h0c0,.1-.1,0-.1.1h.2C323.2,520.9,323.1,520.9,323,521Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.1,521h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "323.3 520.2 323.3 520.2 323.2 520.3 323.3 520.2"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "304.3",
      "y": "576.3",
      "width": "11.5",
      "height": "4.65"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.4 580.9 309.3 580.9 309.4 580.9 309.4 580.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.4 580.9 309.4 580.9 309.4 580.9 309.4 580.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310,576.8h0a0,0,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310,576.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.9,578.7h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-229",
    attrs: {
      "x": "308.3",
      "y": "578.3",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,578.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.2,578.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.4,577.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.6,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.6,577.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M304.8,577.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,577.4h0Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-229",
    attrs: {
      "cx": "304.8",
      "cy": "577.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.6,577.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.4,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,577.5h0S306.7,577.5,306.7,577.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,577.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.7,577.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.8,578h0A0,0,0,0,1,306.8,578Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "305.4 578 305.4 578 305.4 578 305.4 578"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.5,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.9,577.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307,577.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307,577.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M305.8,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306,578.3h0Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-68",
    attrs: {
      "cx": "305.9",
      "cy": "578.3",
      "transform": "translate(-309.7 799.6) rotate(-81.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.6,578.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "306.1 578.3 306 578.3 306.1 578.3 306.1 578.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.2,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,578.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.3,578.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "306.3 578.4 306.3 578.4 306.3 578.4 306.3 578.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M306.6,579.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.1,576.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.4,578.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "307 578.8 307 578.8 307 578.8 307 578.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.8,578.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "307.3 576.8 307.3 576.8 307.3 576.8 307.3 576.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.3,576.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.4,576.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.4,576.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.7,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.1,579h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,577.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,579.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,576.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308,577h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.4,579.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.1,577.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.1,577.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,579.2h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.5,579.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.2,577.1h0S308.2,577.1,308.2,577.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.3 577.1 308.2 577.1 308.2 577.1 308.3 577.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.7,579.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3 308.7 579.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.1,579.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.1,579.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.6,577h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "308.6 577.6 308.6 577.6 308.6 577.6 308.7 577.6 308.7 577.6 308.6 577.6 308.6 577.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.2,579.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308.7,577.6h0Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-229",
    attrs: {
      "cx": "309.3",
      "cy": "578",
      "transform": "translate(-226.7 200.6) rotate(-26.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.6,579.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.7,577.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.8,577.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.8 577.9 309.8 577.9 309.8 577.9 309.8 577.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.4,579.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.1,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.1,578.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3 310.1 578.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.2,579.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.3,578.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.4,579.6h.3s0,0,0,0h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.5,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310.8,578.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,578.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.5,579.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "310.8",
      "y": "578.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.1,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.2,578.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M312.4,578.7h.2a.1.1,0,0,1,0,.1h-.2S312.4,578.7,312.4,578.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.4 578.9 312.4 578.9 312.4 578.9 312.4 578.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.1,579.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "313.1",
      "y": "579.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.2,580.5h0S313.2,580.5,313.2,580.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.7,579.1h.1a0,0,0,0,1,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.8,579h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,579.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,579.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.8,580h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.9,579.4h.3s0,0,0,0h0s0,0,0,.1h-.2s0,0,0,0h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.7,579.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.4,578.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.6,578h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.9,579.6h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315,578.9h.1s0,0,0,0H315Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315,579.1h.2s0,.1,0,.1H315S315.1,579.1,315,579.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.5,579.3h.4s0,0,0,0h-.3s0,0,0-.1h0s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.1,578.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.2,578.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "313.3 578.4 313.2 578.4 313.2 578.4 313.2 578.4 313.2 578.4 313.3 578.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,578.4h.2s0,0,0,0h-.2s0,0,0-.1h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M313.3,578.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-229",
    attrs: {
      "points": "313.5 578.6 313.5 578.6 313.5 578.6 313.5 578.6"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.3",
      "y": "553.2",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-199.9 212.3) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.6,577.3h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,561.5h0v.2A.1.1,0,0,1,366.1,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.4,561.5h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.8 561.6 366.8 561.5 366.8 561.4 366.8 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M378.5,576c.3,0,.5.3.4.5l-.4.5s-.2-.4-.4-.2,0,.3-.1.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C377.7,576.6,378,576.2,378.5,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M372.6,564.2c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C372.7,564.5,372.8,564.2,372.6,564.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.2,564.1h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S372.8,564.2,373.2,564.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M373.3,564.2s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M380.1,575.4c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S379.8,575.4,380.1,575.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374,561.4h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2v-.3l-.6.3C373.5,561.7,373.7,561.4,374,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M403.2,564.2c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7H407c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3v-.2h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3V565c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,403.2,564.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.5,562c-.1.1,0,.1,0,.2s.3,0,.5,0V562c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S377.4,562,377.5,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M381.6,561.2c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,381.6,561.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M383.3,565h-.1c.1-.1.2-.3.2-.5h-.3c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.8-.1,1.2s-.5.2-.7.4h-.1c0-.5-.6-.1-.9,0H385c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2v-.2h-.4v-.2h-.4C383.2,565.4,383.7,565.1,383.3,565Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.9,574h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2H388C388.1,574.4,387.9,574.2,387.9,574Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 565.8 384.6 565.8 384.8 565.7 384.8 565.7 384.6 565.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M387.1,562.9a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S387.1,562.7,387.1,562.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M389.2,562.2h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3c0-.1-.2-.1-.2,0h-.2c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C389,562.5,389.2,562.3,389.2,562.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M396.9,562.5c-.2,0,.2-.2-.1-.3s.1-.4.2-.5H397c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1v-.2h-.3c.1-.1,0-.1,0-.2h-.2C396.8,562.9,397.3,562.6,396.9,562.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "398.2 562.4 397.9 562.6 398.1 562.5 398.2 562.4"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "353.9",
      "y": "567.9",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-207.2 208.5) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M358.3,591.9h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M353.7,576.2h0v.2A.1.1,0,0,1,353.7,576.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.1,576.1h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 576.2 354.4 576.2 354.5 576 354.5 576.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,590.7c.3,0,.5.3.4.5l-.4.5s-.2-.4-.4-.2,0,.3-.1.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C365.4,591.2,365.6,590.8,366.1,590.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.3,578.8c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C360.3,579.1,360.4,578.9,360.3,578.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,578.7h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S360.4,578.9,360.9,578.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M361,578.9s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M367.8,590c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S367.5,590,367.8,590Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.7,576h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2v-.3l-.6.3C361.1,576.3,361.3,576,361.7,576Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M390.9,578.9c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7h-.1c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3v-.2h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3v-.2c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,390.9,578.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M365.2,576.6c-.1.1,0,.1,0,.2s.3,0,.5,0v-.2c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S365,576.6,365.2,576.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.3,575.8c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,369.3,575.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M370.9,579.6h-.1c.1-.1.2-.3.2-.5h-.3c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.7-.1,1.2s-.5.2-.7.4h-.1c0-.5-.6-.1-.9,0h-.2c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2v-.2h-.4v-.2h-.4C370.8,580,371.3,579.7,370.9,579.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M375.6,588.6h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2h-.9C375.7,589.1,375.5,588.8,375.6,588.6Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "372.3",
      "y": "580.4",
      "width": "0.2",
      "height": "0.05",
      "transform": "translate(-205 203.3) rotate(-24.2)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.8,577.5a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S374.7,577.3,374.8,577.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M376.9,576.8h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3h-.4c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C376.7,577.1,376.8,577,376.9,576.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M384.5,577.2c-.2,0,.2-.2-.1-.3s.1-.4.2-.5h-.1c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1v-.2h-.3c.1-.1,0-.1,0-.2h-.2C384.5,577.5,385,577.3,384.5,577.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.9 577 385.5 577.3 385.7 577.1 385.9 577"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "286.3",
      "y": "565.6",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-212.4 180) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M290.6,589.7h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M286,573.9h0v.2A.1.1,0,0,1,286,573.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M286.4,573.9h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "286.8 574 286.7 573.9 286.8 573.8 286.8 574"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M298.4,588.4c.3,0,.5.3.4.5l-.4.5s-.2-.4-.4-.2,0,.3-.2.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C297.7,589,297.9,588.6,298.4,588.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M292.6,576.6c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C292.6,576.9,292.8,576.6,292.6,576.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M293.2,576.5h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S292.8,576.6,293.2,576.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M293.3,576.6s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M300.1,587.8c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S299.8,587.8,300.1,587.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M294,573.8h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2V574l-.6.3C293.5,574.1,293.7,573.8,294,573.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M323.2,576.6c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7H327c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3v-.2h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3v-.2c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,323.2,576.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M297.5,574.4c-.1.1,0,.1,0,.2s.3,0,.5,0v-.2c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S297.3,574.4,297.5,574.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M301.6,573.6c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,301.6,573.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.2,577.4h-.1c.1-.1.2-.3.2-.5H303c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.8-.1,1.2s-.5.2-.7.4H306c0-.5-.6-.1-.9,0H305c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2V578h-.4v-.2h-.4C303.1,577.8,303.6,577.5,303.2,577.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.9,586.4h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2H308C308,586.9,307.9,586.6,307.9,586.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304.6 578.2 304.6 578.2 304.7 578.1 304.8 578.1 304.6 578.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M307.1,575.3a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S307,575.1,307.1,575.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M309.2,574.6h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3h-.4c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C309,574.9,309.2,574.7,309.2,574.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M316.9,574.9c-.2,0,.2-.2-.1-.3s.1-.4.2-.5H317c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1v-.2h-.3c.1-.1,0-.1,0-.2H317C316.8,575.3,317.3,575.1,316.9,574.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.2 574.8 317.8 575 318 574.9 318.2 574.8"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "303.7",
      "y": "523",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-193.1 183.4) rotate(-24.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M308,547.1h.1v.2c.1,0,0-.2-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.4,531.3h0v.2A.1.1,0,0,1,303.4,531.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M303.8,531.3h.1l.2-.3h0c.1-.1-.1-.2-.1-.3s-.3.2-.4.4h-.1c.1-.3.5-.3.8-.5l.2.2a.9.9,0,0,1-.9.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304.2 531.3 304.1 531.3 304.2 531.2 304.2 531.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M315.8,545.8c.3,0,.5.3.4.5s-.2.3-.4.5-.2-.4-.4-.2,0,.3-.1.4v-.2c-.2-.1-.3.1-.5,0v-.2h-.3C315.1,546.3,315.3,545.9,315.8,545.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M310,534c.4-.2.6-.6,1.1-.3s-.1.5-.2.7l-.6.3h-.5C310,534.2,310.2,534,310,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,533.8h-.3l.2-.2c.2,0,.2.3.3.4s-.4.2-.5.3S310.2,534,310.6,533.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M310.7,534s-.1.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M317.5,545.2c.1,0,.1.2.2.3s-.3.4-.6.5.2-.1.3-.3l-.2-.2c0,.1-.1.3-.2.2S317.2,545.2,317.5,545.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M311.4,531.2h.2l-.2.3s.1-.1,0-.1h-.1v.3c-.1-.1-.2,0-.3,0h.2v-.3l-.6.3C310.9,531.5,311.1,531.2,311.4,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.6,534c-.1-.4-.4,0-.6-.1s.4,0,.4-.3a.5.5,0,0,0-.6.1h0c.2-.3.9-.4.8-.9s-.3-.1-.2-.2.4-.6.7-.9h-.2l1-.5c-.4-.3.6-.3.3-.6s.6.2.7,0a1.7,1.7,0,0,1,1.4.7c.3.2.1.4.2.7h-.1c0,.1-.1.3.1.4a.6.6,0,0,0-.3.5c.1.2,0,.6-.2.6s0,.1,0,.2l-.2.2c-.4.4-.9.6-1.2,1.3V535h-.2l-.2.6c-.1-.2.2-.6-.1-.7s-.3.2-.5.3v-.2c-.2-.1-.4.3-.7.3s-.2-.5-.5-.6l-.6.3A.7.7,0,0,0,340.6,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M314.9,531.8c-.1.1,0,.1,0,.2s.3,0,.5,0v-.2c-.2-.1-.2.2-.3,0s.4-.2.6-.3-.1.5-.3.5-.4,0-.7,0S314.7,531.8,314.9,531.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M319,530.9c.3,0,.7.2.7.4s0,.3,0,.3.7,0,.7.4-1.8.5-2.3.5v-.2h-.3A1.8,1.8,0,0,1,319,530.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M320.6,534.8h-.1c.1-.1.2-.3.2-.5h-.3c0-.1.4-.2.2-.4h-.1c.5-.2.4-.7.9-.8s.9-.3,1.2-.5.3.2.5.3l.4.9a1.7,1.7,0,0,0-.2.7,1.5,1.5,0,0,1,1,.4c.5.4-.1.7-.1,1.2s-.5.2-.7.4h-.1c0-.5-.6-.1-.9,0h-.2c0-.1.2-.2.2-.4l-.4.2.2-.2h-.2c.1,0,.1-.1.1-.2h-.2v-.2c-.2-.1-.4,0-.4-.3l-.6.2v-.2H321v-.2h-.4C320.5,535.2,321,534.9,320.6,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M325.3,543.8h-.2c.2-.3.3-1,.9-1.3a2.1,2.1,0,0,1,1.1-.1c.5.5.3.9.1,1.5s-.7.6-1,.7h0v-.2h-.9C325.4,544.2,325.3,544,325.3,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 535.6 322 535.6 322.2 535.5 322.2 535.5 322 535.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M324.5,532.6a.2.2,0,0,1,0,.1c0-.1-.2-.3-.3-.1S324.4,532.5,324.5,532.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M326.6,532h-.1c-.1,0,.2-.2,0-.4s1.2.4,1.4-.5.9-.2,1.3.2-.1.8-.3,1l-.5.3H328c0-.4-.4,0-.6-.1h.1c-.2-.3-.5,0-.8-.2h-.2C326.4,532.2,326.6,532.1,326.6,532Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M334.3,532.3c-.2,0,.2-.2-.1-.3s.1-.4.2-.5h-.1c.5,0,0-.7.8-.7s.6.1.8-.2a1,1,0,0,1,.7,1c-.1.5-.1.2-.3.7v.2c-.3-.3-.1.5-.5.2s-.2.3-.5.3a.2.2,0,0,0,0-.2c-.2-.1-.3.1-.4.1V533h-.3c.1-.1,0-.1,0-.2h-.2C334.2,532.6,334.7,532.4,334.3,532.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.6 532.2 335.2 532.4 335.4 532.3 335.6 532.2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-233"
  }, [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "337.7",
      "y": "499",
      "width": "39.8",
      "height": "21.66",
      "transform": "translate(-146.6 144.4) rotate(-19)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M374.4,498.2h-.1v-.2c-.1,0,0,.2.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.5,514.3h0v-.2A.1.1,0,0,1,377.5,514.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M377.1,514.3H377l-.2.3h0c-.1.1,0,.2,0,.3s.3-.2.4-.3h.1c-.2.3-.5.3-.8.4l-.2-.2a.9.9,0,0,1,1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.7 514.2 376.7 514.2 376.7 514.4 376.7 514.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.5,498.6c-.3,0-.4-.3-.4-.6l.4-.4s.1.4.3.2,0-.3.2-.4v.2c.2.1.3-.1.5,0v.2h.3C367.3,498.2,367,498.6,366.5,498.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M371.2,511c-.4.2-.7.6-1.1.2s.1-.5.3-.7l.6-.2h0l.3.2h.2C371.2,510.7,371,510.9,371.2,511Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.5,511.1h.3l-.2.2c-.2,0-.2-.3-.2-.4s.4-.1.5-.3S371,510.9,370.5,511.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-236",
    attrs: {
      "d": "M370.5,510.9s.1-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M364.8,499.1c-.1,0-.1-.2-.1-.3s.4-.3.6-.4-.2.1-.3.3l.2.2c0-.1.2-.2.3-.2S365.1,499.1,364.8,499.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M369.5,513.6h-.2l.2-.3s-.1.1,0,.1h.1v-.3c.1.1.2,0,.3,0h-.2v.3l.6-.2C370.1,513.4,369.8,513.6,369.5,513.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M340.7,507.9c0,.4.4,0,.6.1s-.4,0-.4.3a.5.5,0,0,0,.6-.1h0c-.2.3-.9.3-.9.8s.3.1.2.2-.4.6-.8.8h.2l-1.1.4c.4.3-.6.3-.4.6s-.6-.2-.7,0-1.2-.4-1.4-.9,0-.4-.1-.7h.1c0-.1.1-.3-.1-.4a.6.6,0,0,0,.3-.5c-.1-.2.1-.6.3-.5s0-.1,0-.2l.2-.2c.4-.3,1-.5,1.3-1.1v.2l.2.2.3-.5c0,.2-.2.5,0,.7s.3-.1.5-.2v.2c.2.1.4-.3.7-.2s.1.5.5.6l.6-.2A.7.7,0,0,0,340.7,507.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M366.1,512.7c.1,0,0-.1,0-.2s-.3,0-.5,0v.2c.2.1.2-.2.3,0s-.4.1-.6.2.1-.5.3-.5.4,0,.7,0S366.3,512.7,366.1,512.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M361.9,513.1c-.3,0-.7-.3-.7-.5s0-.2,0-.3-.7-.1-.6-.5,1.8-.3,2.4-.2v.2h.3A1.8,1.8,0,0,1,361.9,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M360.7,509.2h.1c-.2.1-.2.3-.3.5h.3c0,.1-.4.1-.2.4h.1c-.6.1-.5.6-1,.7s-.9.2-1.2.4-.3-.2-.4-.3l-.3-1a1.7,1.7,0,0,0,.3-.7,1.5,1.5,0,0,1-.9-.5c-.4-.5.2-.7.2-1.2s.5-.2.7-.4h.1c-.1.5.6.1.9.1h.2c-.1.1-.3.2-.2.3h.4l-.2.2h.2c-.1,0-.1.1-.1.2h.2l-.2.2c.2.1.4.1.4.3h.6v.2h.4v.2h.4C360.8,508.7,360.3,509,360.7,509.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.9,499.7h.2c-.3.3-.4,1-1,1.2a2.1,2.1,0,0,1-1.1,0c-.4-.5-.2-.9,0-1.5s.7-.5,1.1-.6h0v.2h.9C356.8,499.3,356.9,499.5,356.9,499.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.4 508.2 359.4 508.2 359.2 508.3 359.2 508.2 359.4 508.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M356.6,510.9a.2.2,0,0,1,0-.1c0,.1.2.3.3.1S356.7,511.1,356.6,510.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M354.5,511.4h.1c.1,0-.2.2-.1.3s-1.1-.5-1.5.4-.9.1-1.2-.4.1-.7.4-1l.5-.3c0,.1.1.1.2.1h.2c-.1.4.4,0,.6.2h-.1c.2.3.5,0,.7.3h.2C354.7,511.1,354.5,511.2,354.5,511.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-229",
    attrs: {
      "d": "M346.8,510.3c.2,0-.3.2,0,.3s-.1.4-.3.5h.1c-.5,0-.1.7-.9.6s-.6-.1-.8.1a1,1,0,0,1-.6-1.1c.1-.5.1-.2.3-.7v-.2c.3.3.2-.5.5-.2s.3-.3.5-.3a.2.2,0,0,0,0,.2c.2.1.3-.1.4-.1v.2h.3c-.1,0,0,.1,0,.2h.2C347,509.9,346.4,510.1,346.8,510.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.5 510.3 345.9 510.1 345.7 510.2 345.5 510.3"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-237"
  }, [_c('g', [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "364.2",
      "y": "546.5",
      "width": "3.3",
      "height": "6.52",
      "transform": "translate(-294.4 563.1) rotate(-57.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,550s.1.1,0,.2-.1.2-.1.4h-.2c-.1,0-.1.2-.1.2s.1-.1,0-.2h-.8c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h0a.7.7,0,0,0,.1-.3h.2s0,0,0,0h.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.3 550.2 369.3 550.2 369.3 550.2 369.3 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.3 369.1 550.3 369.1 550.3 369.1 550.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.2 550.4 369.2 550.3 369.2 550.4 369.2 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.4 369.1 550.4 369.1 550.4 369.1 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.5 369.1 550.4 369.1 550.5 369.1 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 550.5 369.2 550.5 369.2 550.5 369.1 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369 550.5 369 550.4 369 550.4 369 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,549.6h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.2 550.6 369.2 550.6 369.2 550.6 369.2 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,549.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369,550.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 550.1 368.3 550.1 368.3 550.1 368.3 550.1 368.3 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,547.9v.2h-.1l-.3.2h-.3c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.4,548.3a1.1,1.1,0,0,1,.1.4h-.1v-.4s0-.1,0-.1S364.4,548.3,364.4,548.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,550.4h0S367.7,550.4,367.7,550.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.7,549.6h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.4s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.3c0-.1,0-.1,0-.1h.1s0,.1,0,.2h.4s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.8,550.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.6,551.3c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.4s.1-.1,0-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.8 550.1 365.8 550.1 365.8 550.2 365.7 550.2 365.8 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.4,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,551.4h0S367.5,551.4,367.5,551.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 551.4 367.4 551.4 367.4 551.4 367.4 551.4 367.4 551.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.3,551.4s0,0,0,0S367.3,551.4,367.3,551.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.5 551.5 367.5 551.5 367.5 551.5 367.5 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368 551.8 368 551.8 368 551.8 368 551.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.2,550.7H366a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,551.4h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,367.1,551.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.3H367s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,551.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.2 551.5 367.3 551.5 367.3 551.5 367.2 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368 551.9 368 551.9 368 551.9 368 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,551.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.1 551.4 367.1 551.4 367.1 551.4 367.1 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.5 551 366.5 551 366.5 551 366.5 551"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367 551.4 367 551.4 367 551.4 367 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.5 551.1 366.5 551.1 366.5 551.1 366.5 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,550.3h-.2C363.9,550.1,364.1,550.2,364.1,550.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.7,551.4h-.2s0,0,0-.1h.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "358.9",
      "y": "542.3",
      "width": "3.6",
      "height": "7.13",
      "transform": "translate(-292.3 504.5) rotate(-52.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.4,546.4c0,.1.1.1,0,.2s-.1.3-.1.4h-.1s0-.1-.1-.1-.1.2-.2.2.1-.2,0-.2h-.7v.2h-.1c0-.1.1-.1.1-.2h-.1v.2h0c0-.1.2-.2.2-.3h0v-.3c0-.1-.1-.1-.1-.1h.3s0,0,0,0h.2c0-.1-.1,0-.1-.1h.6C364.1,546.2,364.3,546.3,364.4,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.3 546.6 364.3 546.6 364.3 546.6 364.3 546.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,545.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 546.7 364.1 546.7 364.1 546.7 364.1 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 546.8 364.2 546.8 364.2 546.8 364.2 546.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 546.9 364.1 546.9 364.1 546.9 364.1 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 546.9 364.1 546.9 364.1 546.9 364.1 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 547 364.2 547 364.2 547 364.1 547"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364 546.9 364 546.9 364 546.9 364 546.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,545.8l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 547 364.2 547 364.2 547 364.2 547"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,545.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.6,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.4,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364,547.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.2 546.5 363.2 546.5 363.2 546.5 363.2 546.5 363.2 546.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.3,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,543.7v.2h-.2l-.3.2h-.3c.2,0,.3-.2.5-.2s.2,0,.3.1S358.7,543.6,358.7,543.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.7,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.7,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,544.1a1.2,1.2,0,0,1,.1.5h-.1a2.7,2.7,0,0,0-.1-.4s0-.1,0-.1S359.2,544.1,359.2,544.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.5,545.6v.2h-.2c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h-.1s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.5s0-.1,0-.1-.3,0-.4-.2,0-.2.1-.2h.4v-.2c0-.1.1-.1,0-.1h.1c0,.1,0,.1,0,.2h.5c0-.1-.2,0-.2-.1h.2s0-.1.1-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,546.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,547.7c0,.1-.1.2-.2.3h0c0-.1.1,0,0-.1h0v-.2h-.1s-.1-.1,0-.1h-.4s.1,0,.1-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 546.3 360.5 546.3 360.5 546.3 360.5 546.3 360.5 546.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.3,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.2,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,547.8h0S362.3,547.8,362.3,547.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.2 547.8 362.2 547.8 362.2 547.8 362.2 547.8 362.2 547.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.1,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.1,547.7s0,0,0,0S362.1,547.7,362.1,547.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.3 547.9 362.3 547.9 362.3 547.9 362.3 547.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.8 548.3 362.8 548.3 362.8 548.3 362.8 548.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.9,546.9h-.2a.3.3,0,0,1,.1-.2h.1S360.9,546.9,360.9,546.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,547.8h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,361.9,547.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.1,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,547.6h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,547.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362 547.9 362 547.9 362 547.9 362 547.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.7 548.4 362.7 548.4 362.7 548.4 362.7 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,547.7h0S361.7,547.7,361.7,547.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.7,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.6,547.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 547.8 361.8 547.7 361.8 547.8 361.8 547.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.2 547.3 361.2 547.3 361.2 547.3 361.2 547.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 547.8 361.8 547.7 361.8 547.8 361.8 547.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.2 547.4 361.2 547.3 361.2 547.4 361.2 547.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,546.3h-.2C358.5,546.1,358.7,546.2,358.6,546.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,547.6h-.3s0-.1,0-.1h.1C360.3,547.5,360.4,547.6,360.4,547.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "355.6",
      "y": "540.7",
      "width": "4",
      "height": "7.77",
      "transform": "translate(-292.5 586.7) rotate(-60.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.7,544.7c0,.1.1.1.1.2s-.1.3-.1.4h-.1s0,.1,0,.1h-.1c-.1,0-.1.2-.1.3s.1-.2,0-.2h-.5s0,.1,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1v.2h0c0-.1.2-.2.1-.4h-.1a.1.1,0,0,0,0-.1h-.4l.3-.2h.1a.9.9,0,0,0,.1-.4c0-.1-.2,0-.1-.1h.3s0,0,0,0h.2c0-.1-.1,0-.2-.1l.6-.2C361.4,544.5,361.6,544.5,361.7,544.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.6 544.9 361.6 544.9 361.6 544.9 361.6 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,543.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 545 361.4 545 361.4 545 361.4 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.5 545.1 361.5 545.1 361.5 545.1 361.5 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 545.2 361.5 545.2 361.5 545.2 361.4 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 545.2 361.4 545.2 361.4 545.2 361.4 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.5 545.3 361.5 545.3 361.5 545.3 361.5 545.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.3 545.2 361.3 545.2 361.3 545.2 361.3 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,544.3l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.5 545.3 361.5 545.3 361.5 545.3 361.5 545.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.7,544.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.7,544.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.6,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.3,545.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.4 544.9 360.4 544.9 360.4 544.9 360.4 544.9 360.4 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,542.5c0,.1-.1.1-.1.2h-.2l-.3.2s.1-.1.1-.2h-.4c.2,0,.3-.3.5-.3s.3-.1.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.2,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,542.9a1.3,1.3,0,0,1,.2.5h-.1l-.2-.5s-.1-.1,0-.1S355.7,542.9,355.7,542.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,545.2h0S359.8,545.2,359.8,545.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,544.3v.2H357c0-.1-.2,0-.1-.1h-.1c0,.1,0,.2.1.2h-.1s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.5s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.4v-.2c0-.1,0-.1,0-.1h.1c0,.1,0,.1.1.2h.5c0-.1-.2,0-.2-.1h0c.1,0,.2,0,.2-.1s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,543.7c0-.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,545s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,546.3c0,.1-.1.2-.2.3h0c0-.1.1,0,0-.1h0v-.2h-.1c0-.1-.1-.1,0-.1h-.2l-.2.2s.1-.1.1-.1a.4.4,0,0,1,.3-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.4 545 357.4 545 357.4 545.1 357.4 545 357.4 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.4h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.5,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,546.5h0S359.6,546.5,359.6,546.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.5 546.4 359.5 546.4 359.5 546.5 359.5 546.5 359.5 546.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,546.4s0,0,0,0S359.4,546.4,359.4,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.6 546.5 359.6 546.5 359.6 546.5 359.6 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.2 546.9 360.2 546.9 360.2 546.9 360.2 546.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,545.7h-.3a.3.3,0,0,1,0-.2h.1C357.9,545.6,358,545.6,358,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,546.5c-.1.1-.2.1-.3.2h-.1a.3.3,0,0,0,0-.2h.3A.1.1,0,0,1,359.1,546.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.3h0c0,.1-.1.1-.1.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.3 546.6 359.3 546.6 359.3 546.6 359.3 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.1 547.1 360.2 547 360.2 547 360.1 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,545.7h0S357.7,545.7,357.7,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,546.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 546.5 359 546.5 359 546.5 359 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.3 546.1 358.3 546.1 358.3 546.1 358.3 546.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 546.5 359 546.5 359 546.5 359 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.4 546.1 358.4 546.1 358.4 546.1 358.4 546.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,545.3h-.3C355.3,545.1,355.4,545.2,355.4,545.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,546.6h-.3s0-.1,0-.1h.1C357.4,546.4,357.5,546.5,357.5,546.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.2",
      "y": "542.1",
      "width": "4.5",
      "height": "8.72",
      "transform": "translate(-288.6 635.3) rotate(-64.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.9,546.7c0-.1-.1-.1-.1-.2s0-.3.1-.5.1-.1.1-.1,0-.1,0-.1h.1c.1-.1.1-.2.1-.3s0,.2.1.2h.3l.2-.2s0-.1,0-.1h.3V545h.1c0,.1-.1.1,0,.2h.1c0-.1.1-.1.1-.2h.1c0,.2-.2.3-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.4.2h-.1a1,1,0,0,0-.1.4c0,.1.2,0,.2.1h-.5c0,.1.1,0,.2.1l-.7.2C355.2,546.9,355,546.9,354.9,546.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 546.5 354.9 546.5 354.9 546.5 354.9 546.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,547.4h.2A.2.2,0,0,1,357.5,547.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 546.3 355.1 546.3 355.1 546.3 355.1 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 546.2 355 546.2 355 546.2 355 546.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 546.1 355.1 546.1 355.1 546.1 355.1 546.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 546.1 355.1 546.1 355.1 546.1 355.1 546.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 546 355 546 355 546 355 546"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 546.1 355.2 546.1 355.2 546.1 355.2 546.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,547l-.3-.2h.1l.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 545.9 355 546 355 546 355 545.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,546.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,546.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,545.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 546.4 356.2 546.4 356.2 546.3 356.3 546.4 356.2 546.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,546.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,548.6c0-.1.1-.2.1-.2h.2l.3-.3s-.1.1,0,.2h.4c-.3,0-.3.3-.5.3s-.3.1-.4,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,545.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.5,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.7,548.2a1.4,1.4,0,0,1-.3-.5h.1l.2.5s.1.1,0,.1S361.7,548.2,361.7,548.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,545.9h0S357,545.9,357,545.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,546.7v-.2h.2c0,.1.2,0,.2.1h.1c-.1-.1,0-.2-.1-.3h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.1a.1.1,0,0,0,.1-.2h.3c0-.1.1,0,.1-.1s0,.1,0,.1.3,0,.5.1,0,.2-.1.3.1.1.2.1H361v.2c0,.1,0,.1,0,.1h-.2v-.2h-.6c0,.1.2,0,.3.1a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.3,547.3c0,.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,546s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,544.7c0-.2.1-.3.2-.4h0c0,.1-.1,0,0,.1h0a.3.3,0,0,0-.1.2h.1c0,.1.1.1,0,.1h.3c.1,0,.1-.2.2-.2s-.1.1,0,.1a.5.5,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.6 546 359.6 546 359.6 545.9 359.6 545.9 359.6 546"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,544.6h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,544.5h0S357,544.5,357,544.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 544.6 357.2 544.6 357.2 544.5 357.2 544.5 357.2 544.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,544.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.1 544.5 357 544.5 357 544.4 357.1 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.3 544.1 356.3 544.1 356.3 544.1 356.3 544.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,545.3h.3a.4.4,0,0,1,0,.2h-.1C359,545.4,358.9,545.3,358.9,545.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,544.5c0-.2.2-.1.3-.2h.1a.3.3,0,0,0,0,.3h-.3A.1.1,0,0,1,357.5,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,544.6h0c0-.1.1-.1.1-.2h.1s0,0,0,.1h-.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.4 544.4 357.4 544.4 357.4 544.4 357.4 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.4 543.9 356.4 543.9 356.4 543.9 356.4 543.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,544.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.7 544.5 357.7 544.5 357.7 544.5 357.7 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 544.9 358.5 544.9 358.5 544.9 358.5 544.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.7 544.5 357.7 544.5 357.7 544.5 357.7 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 544.8 358.4 544.8 358.5 544.8 358.5 544.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.8,545.5v-.2h.3s0,.2-.1.2S361.8,545.6,361.8,545.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,544.3h.2A.2.2,0,0,1,359.4,544.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "346.9",
      "y": "541.9",
      "width": "6.8",
      "height": "3.45",
      "transform": "translate(-263 749) rotate(-75.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,540.2h.8s-.1,0,0,.1h.2s0-.1,0-.1h.2v.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0h-.3s0,0,0,.1h-.1c0,.1.1.2.1.3l-.2-.2c.1.1,0,.2,0,.2v-.3h-.3s0,.1-.1.2,0-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.1l-.3-.5A.6.6,0,0,1,349.4,540.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.6 540.2 349.6 540.2 349.6 540.2 349.6 540.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,542.3h0A.1.1,0,0,1,349.3,542.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 540.3 349.7 540.3 349.7 540.3 349.7 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.8 540.2 349.7 540.2 349.8 540.2 349.8 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.8 540.3 349.8 540.3 349.9 540.3 349.8 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.9 540.3 349.9 540.3 349.9 540.3 349.9 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 540.2 349.9 540.2 349.9 540.2 350 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.9 540.4 349.9 540.4 349.9 540.4 349.9 540.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,542v-.2h0v.2S349.5,542,349.5,542Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 540.2 350 540.2 350 540.2 350 540.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,541.9h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,540.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "349.8",
      "y": "541.2",
      "height": "0.02",
      "transform": "translate(-259.1 752) rotate(-76.2)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,546.2h.2c0,.1,0,.1,0,.1l.2.2h-.1c-.1,0,0,.1,0,.2s.1.1,0,.2-.3-.2-.3-.3-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,541.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,545.6l.4-.3h0l-.3.2h-.1C349.2,545.6,349.3,545.6,349.3,545.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,543.9h.2v.2c-.1,0,.1.1,0,.1h.8c-.1.2.1.3,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.4h-.1c0-.1,0-.2,0-.2v-.2c-.1,0,0,.1,0,.2h-.1c0-.1,0-.2-.1-.1H350a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,541.5h.3c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2l-.3-.2C351.2,541.6,351.2,541.5,351.2,541.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.7 543.7 350.7 543.7 350.7 543.7 350.7 543.7 350.7 543.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,541.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,541.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.3 541.6 351.3 541.6 351.4 541.6 351.4 541.6 351.3 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.4 541.6 351.4 541.5 351.4 541.5 351.4 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 540.9 351.6 540.9 351.6 540.9 351.6 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.1,543.1l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,541.9c.1,0,.1.1.2.2h-.3c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,541.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.1s0,0,0,0h.1s0,0,0,0h-.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.2h0S351.4,542.2,351.4,542.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.5 541.8 351.5 541.8 351.5 541.8 351.5 541.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.7 540.9 351.7 540.9 351.7 540.9 351.7 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,542.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 542 351.5 542 351.5 542 351.5 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.3 542.7 351.3 542.7 351.3 542.7 351.3 542.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 542 351.5 542 351.5 542 351.5 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.4 542.7 351.3 542.7 351.3 542.7 351.4 542.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352,541h0S352,541,352,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,545.3h.1c0,.1.1.2,0,.2h-.2C351.2,545.5,351.2,545.3,351.4,545.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,543.3h.1a.1.1,0,0,1,0,.1h-.2A.1.1,0,0,1,351.9,543.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "349.7",
      "y": "534.4",
      "width": "4.2",
      "height": "8.2",
      "transform": "translate(-231.5 809.8) rotate(-81.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.8,540s-.2-.1-.2-.2-.1-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2l.2-.2h.1v-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.2,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.1l-.6.4A.7.7,0,0,1,347.8,540Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.8 347.8 539.8 347.8 539.8 347.8 539.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,539.9v-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 539.6 347.9 539.6 347.9 539.6 347.9 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.6 347.8 539.6 347.7 539.6 347.8 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.5 347.8 539.5 347.8 539.4 347.8 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 539.4 347.8 539.4 347.8 539.4 347.8 539.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 539.3 347.7 539.4 347.7 539.3 347.7 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 539.4 347.9 539.4 347.9 539.4 347.9 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 539.3 347.7 539.3 347.7 539.3 347.7 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,539.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 539.3 348.9 539.3 348.9 539.3 348.9 539.3 348.9 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,539.7c0-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,539.4l-.4-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S354.3,539.5,354.3,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,538.7c0-.1.1-.1.1-.2h.2c.1.1.1-.1.2,0h.1l-.2-.2h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5-.1s.1.2,0,.3h.2s0,.1,0,.1h.2l-.5.3s-.1.1-.1.1h.1c.1,0,0,.1,0,.1h-.8c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.8,538.8c.1,0,0,0,0,.1S353.7,538.8,353.8,538.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,538.1h.2a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,538.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,537.6c-.1-.1,0-.3,0-.4l.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.8 538 351.8 538 351.8 538 351.8 538 351.8 538"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,537.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,537.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.3 537.5 349.3 537.5 349.3 537.4 349.3 537.4 349.3 537.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,537.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.1 537.4 349.1 537.4 349.1 537.4 349.1 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.4 537.3 348.3 537.3 348.3 537.3 348.4 537.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,537.6a.3.3,0,0,1,.2-.2.3.3,0,0,1,.1.2H351Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,537.3c0-.1.1-.2.2-.3h.1a.3.3,0,0,0,.1.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,537.3h0c0-.1.1-.2,0-.2h0s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.4 537.3 349.4 537.3 349.4 537.2 349.4 537.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.4 537.1 348.4 537.1 348.4 537.1 348.4 537.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,537.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 537.2 349.7 537.3 349.7 537.3 349.7 537.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 537.4 350.5 537.4 350.5 537.4 350.5 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 537.2 349.7 537.2 349.7 537.2 349.7 537.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 537.3 350.5 537.3 350.5 537.3 350.5 537.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.4,536.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.7,537c0-.1,0-.1,0-.2h.4c0,.1,0,.2-.1.2S353.7,537.1,353.7,537Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,536.6c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.4",
      "y": "532.2",
      "width": "4.4",
      "height": "8.57",
      "transform": "translate(-104.1 86.9) rotate(-12.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,539.9c0,.1,0,.2-.1.2s-.3.2-.4.3h-.3s.1-.1,0-.1-.2.1-.3.1.2-.1.2-.2h-.2s.1.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.9c.1-.1.3,0,.4-.2h0c0-.2-.2-.2-.3-.3l.4.2-.2-.2.3.2.4-.2c0-.1-.1-.2,0-.2s0,.1.1.2h.4c.1-.1-.1-.1,0-.2l.6.4C362.5,539.5,362.6,539.7,362.5,539.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.3 540 362.3 540 362.3 540 362.3 540"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,537.4h-.2a.2.2,0,0,1,0-.2h.1A.2.2,0,0,1,361.5,537.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362 540 362.1 540 362.1 540 362 540"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.1 540.1 362.1 540.1 362.1 540.1 362.1 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 540.1 362 540.1 361.9 540.1 361.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 540.1 361.9 540.1 361.9 540.1 361.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 540.2 361.9 540.2 361.9 540.2 361.9 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 540 361.8 540 361.8 540 361.8 540"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.4,538a.9.9,0,0,1,0,.3h-.1c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.8 540.3 361.9 540.3 361.9 540.3 361.8 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.4,538.1h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.4,538h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.4,538.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.5,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,540.2h0S361.7,540.2,361.7,540.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 539 361.4 539 361.4 539 361.4 539 361.4 539"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,532.9H359c.1-.1,0-.2,0-.2v-.2c.1.2.4,0,.6.2s.3.1.2.3S359.5,532.9,359.5,532.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,533.7a1.4,1.4,0,0,1-.2.5h-.1s0-.1,0-.1l.3-.5h.1C359.7,533.6,359.6,533.7,359.6,533.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,536.1h-.4c0-.1-.1-.1,0-.2H359c0,.1-.1.1-.1.3h-.3c-.1,0,0,.1-.1.1s0-.1,0-.1h-.4s0-.1,0-.1H358c0-.2-.2-.2-.2-.4h.3c.1-.1,0-.1,0-.2h.1c-.1-.1,0-.2-.1-.2l.5.4h.1V535h.1c.1.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1-.1-.3h.1c.1,0,.1.2.2.1h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,536.7h0A.1.1,0,0,1,359.2,536.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,536.7h0S359.2,536.7,359.1,536.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,539.5c-.1.1-.3.1-.4.1s-.2-.1-.3-.2h.3s0,0,0,0h.2c.1,0,0-.1.1-.1h-.1s0,.1,0,.1h.1C359.7,539.4,359.7,539.5,359.7,539.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.1 536.7 359.1 536.7 359.1 536.7 359.1 536.7 359.1 536.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.5,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.5 539.4 359.5 539.4 359.4 539.4 359.4 539.4 359.5 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.4,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.4 539.5 359.5 539.5 359.4 539.6 359.4 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.6 540.4 359.6 540.4 359.6 540.4 359.6 540.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,539.4s0,0,0,0S359.4,539.4,359.4,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,537.6h0C359,537.5,359,537.6,358.9,537.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,539.1c-.1.1-.2-.1-.3-.1s0-.1,0-.1l.2-.2h.2c.1,0,0,.2.1.2A.1.1,0,0,1,359.2,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,538.9H359s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,538.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 539.3 359.2 539.3 359.2 539.3 359.2 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.4 540.4 359.5 540.4 359.4 540.4 359.4 540.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,538.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.1 539.1 359.1 539.1 359.1 539.1 359.1 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 538.2 358.9 538.2 358.9 538.2 358.9 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.1 539 359.1 539 359.1 539.1 359.1 539"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 538.2 358.9 538.2 358.9 538.2 358.9 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,540.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,535.3h-.2c-.1-.1-.2-.1-.2-.3h.3C357.4,535,357.5,535.2,357.4,535.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,537.8h-.2a.2.2,0,0,1-.1-.2h.2A.2.2,0,0,1,357.9,537.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "355.6",
      "y": "527.6",
      "width": "3.7",
      "height": "7.16",
      "transform": "translate(-145.3 134.8) rotate(-17.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,528.6c0-.1,0-.2.1-.2s.2-.2.3-.2h.2s-.1.1,0,.1h.3c0,.1-.1.1-.1.2h1l-.3.2h0c0,.1.2.1.3.3h-.3l.2.2-.3-.2-.3.2c0,.1.1.1,0,.2s0-.1-.1-.2h-.3c-.1.1.1.1.1.1l-.5-.3C354.8,528.9,354.7,528.8,354.7,528.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 528.5 354.9 528.5 354.9 528.5 354.9 528.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,530.5h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,355.8,530.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 528.5 355.1 528.5 355.1 528.5 355.1 528.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 528.4 355.1 528.4 355.1 528.4 355.1 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.4 355.2 528.4 355.2 528.4 355.2 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.4 355.2 528.4 355.2 528.4 355.2 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.3 355.2 528.3 355.2 528.3 355.2 528.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.3 528.4 355.3 528.4 355.3 528.4 355.3 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,530.1a.8.8,0,0,1-.1-.3h.1c0,.1.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 528.2 355.2 528.2 355.2 528.2 355.2 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,530h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,529.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.6,529.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.4,528.3h0S355.4,528.3,355.4,528.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.7 529.2 355.7 529.2 355.7 529.2 355.7 529.2 355.7 529.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,534.1h.5c0,.1,0,.1.1.2h.1c-.1-.2-.3,0-.5-.1s-.2-.1-.2-.2S357.8,534.2,357.8,534.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,533.5a1.2,1.2,0,0,1,.2-.4h.1s0,.1,0,.1l-.2.4h-.1C357.6,533.6,357.6,533.5,357.7,533.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,531.5h.4c0,.1.1.1,0,.2h.1c0-.1.1-.1.1-.2h.3c.1,0,0-.1,0-.1s0,.1,0,.1h.3s0,0,0,.1h.1c0,.2.2.2.2.4h-.2c-.1.1,0,.1,0,.2h-.1c.1,0,0,.1.1.2l-.4-.3h-.1v.2h-.1s0-.1,0-.2v-.4h-.2c-.1.1.1.1.1.2h-.3a.3.3,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,532.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,530.9h0A.1.1,0,0,1,357.8,530.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,528.7h.3s0,0,0,0h-.1c-.1,0,0,.1-.1.1h.1s0-.1,0-.1h-.1C357.1,528.8,357.1,528.7,357.1,528.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.8 531 357.8 531 357.8 531 357.8 531 357.8 531"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,528.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.3 528.7 357.3 528.7 357.3 528.7 357.3 528.7 357.3 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,528.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.3 528.6 357.3 528.6 357.3 528.6 357.3 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.1 528 357.1 528 357.1 527.9 357.1 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,528.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,530.2h0C357.8,530.3,357.8,530.2,357.9,530.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,528.9h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.2A.1.1,0,0,1,357.5,528.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.5 528.8 357.5 528.8 357.5 528.8 357.5 528.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 527.9 357.2 527.9 357.2 527.9 357.2 527.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.6 529 357.6 529 357.6 529 357.6 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.9 529.7 357.8 529.7 357.8 529.7 357.9 529.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.6 529 357.6 529 357.6 529 357.6 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.9 529.7 357.8 529.7 357.9 529.7 357.9 529.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.6,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,532h.2c.1.1.2.1.1.2h-.2C359.3,532.2,359.3,532.1,359.4,532Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,529.9h0A.1.1,0,0,1,358.7,529.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "350.6",
      "y": "523.6",
      "width": "7.7",
      "height": "3.91",
      "transform": "translate(-262.1 673.3) rotate(-69.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,521.6h.2c.2-.1.3,0,.5,0h.2s-.1,0-.1.1h.1v.2s0-.1,0-.1h0l.2.2h.1c.1,0,0,.2.1.2h.2s0,0,0,0h-.4s0,.1,0,.1H355c-.1.1.1.3,0,.4l-.2-.3c.1.1,0,.2,0,.3v-.3h-.4s0,.2-.1.2.1-.1.1-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.2-.4-.3-.6S353.8,521.8,353.9,521.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.1 521.7 354.1 521.7 354.1 521.7 354.1 521.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,524h.1v.2h-.1A.1.1,0,0,1,353.5,524Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.3 521.8 354.3 521.8 354.3 521.8 354.3 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.4 521.7 354.3 521.7 354.3 521.7 354.4 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.4 521.8 354.4 521.7 354.5 521.8 354.4 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 521.8 354.5 521.8 354.5 521.8 354.5 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.6 521.7 354.5 521.7 354.6 521.7 354.6 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 521.9 354.5 521.9 354.5 521.9 354.5 521.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,523.7v-.3h0v.3S353.8,523.7,353.9,523.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.6 521.7 354.6 521.7 354.6 521.7 354.6 521.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,522.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.7,521.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.3 522.8 354.3 522.8 354.3 522.8 354.3 522.8 354.3 522.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,522.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,528.3h.2c0,.1,0,.1,0,.2l.2.3h-.2c-.1,0-.1.1-.1.2s.1.1,0,.2-.3-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.9,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.8,523s0,0,0,0S354.8,523,354.8,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,527.7l.4-.3h0l-.4.2H353C353,527.7,353.1,527.7,353.2,527.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,525.9h.2v.2c-.1,0,0,.2-.1.2s0,.1,0,.1h.8c-.1.2.1.3,0,.4H355c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.1c.1-.1,0-.2.1-.3v-.2c-.1,0,0,.2-.1.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.9,525.6h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.9,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,523.3h.3c0,.1.1.2.1.3h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2a.4.4,0,0,1-.3-.3C355.8,523.4,355.8,523.3,355.9,523.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 525.7 354.9 525.7 355 525.7 355 525.7 354.9 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,523.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,523.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 523.5 356 523.5 356 523.5 356 523.5 356 523.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,523.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.1 523.4 356 523.4 356.1 523.4 356.1 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.3 522.7 356.3 522.7 356.3 522.7 356.3 522.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,525.1a.2.2,0,0,1,.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,523.8c.1,0,.1.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524s0,0,0,0h.1s0,0,0,0H356s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524.1s0,0,0,0S356,524.1,356,524.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.1 523.7 356.1 523.6 356.1 523.7 356.1 523.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.5 522.7 356.5 522.7 356.5 522.7 356.5 522.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.6,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,524.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.1 523.9 356.1 523.9 356.1 523.9 356.1 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.8 524.7 355.8 524.6 355.8 524.6 355.8 524.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.1 523.9 356.1 523.9 356.1 523.9 356.1 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.9 524.6 355.8 524.6 355.8 524.6 355.9 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,522.8h0S356.8,522.8,356.8,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,527.6h.2c0,.1.1.2,0,.3h-.3C355.4,527.8,355.4,527.6,355.5,527.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,525.4h.1a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,356.4,525.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "353.4",
      "y": "520.5",
      "width": "7.1",
      "height": "3.61",
      "transform": "translate(-268 620.6) rotate(-64.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,518.6h.8v.2h0v.2h.1c.1,0,0,.2.1.2h.1s0,0,0,0h-.4s0,.1,0,.1h-.1c-.1.1,0,.2,0,.4l-.2-.3c0,.1,0,.2,0,.2v-.3H357s0,.2-.1.1.1-.1.1-.2,0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.2-.4-.2-.6S356.6,518.7,356.7,518.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 518.6 356.9 518.6 356.9 518.6 356.9 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,520.7h-.1A.1.1,0,0,1,356.2,520.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 518.8 357 518.8 357 518.8 357.1 518.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 518.7 357.1 518.7 357.1 518.7 357.1 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 518.7 357.2 518.7 357.2 518.7 357.2 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 518.8 357.2 518.7 357.2 518.7 357.2 518.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 518.7 357.3 518.7 357.3 518.7 357.3 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 518.8 357.2 518.9 357.2 518.9 357.2 518.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,520.4v-.2h0l-.2.2S356.4,520.4,356.5,520.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 518.7 357.3 518.7 357.3 518.7 357.3 518.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.6,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.5,520.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.6,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,518.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 519.7 357 519.7 357 519.7 357 519.7 357 519.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,524.7h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s.1.1,0,.2-.2-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.5,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.4,519.9s0,0,0,0S357.4,519.9,357.4,519.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,524.1l.4-.2h0l-.4.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,522.5h.2v.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.7c-.1.1,0,.3-.1.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.3-.1-.5h-.1c.1-.1,0-.2.1-.2V523c-.1,0,0,.2-.1.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,522.3h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.3,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.2h.3c0,.1.1.2.1.3h-.1s0-.1,0-.1h-.2s0,.1,0,.1h.1c-.1-.1-.2-.1-.3-.3S358.3,520.3,358.4,520.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 522.4 357.3 522.4 357.3 522.4 357.3 522.4 357.3 522.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,520.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,520.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.4 520.4 358.4 520.4 358.5 520.4 358.5 520.5 358.4 520.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 520.4 358.5 520.3 358.5 520.3 358.5 520.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 519.7 358.8 519.7 358.8 519.7 358.8 519.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,521.9a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,520.7c.1,0,.1.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,520.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,520.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,520.9h.1s0,0,0,0h-.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,521s0,0,0,0S358.4,521,358.4,521Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.6 520.6 358.6 520.6 358.6 520.6 358.6 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 519.8 359 519.8 359 519.8 359 519.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,521h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,520.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,521h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.5 520.8 358.5 520.8 358.5 520.8 358.5 520.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.2 521.5 358.2 521.5 358.2 521.5 358.2 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.5 520.9 358.5 520.9 358.5 520.9 358.5 520.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.3 521.5 358.2 521.5 358.2 521.5 358.3 521.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,520.6h0S358.6,520.6,358.7,520.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,519.9h0S359.3,519.9,359.3,519.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,524.2h.1c0,.1.1.2,0,.2h-.2C357.6,524.3,357.6,524.2,357.7,524.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,522.2h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,358.7,522.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.6",
      "y": "516.1",
      "width": "6.6",
      "height": "3.4",
      "transform": "translate(-209.9 248.5) rotate(-29.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.8,514.8h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.1.1.2h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.2.2,0,0,0,0,.2h0c0,.1-.1.1,0,.2h-.1c-.1-.1-.1-.2-.2-.3h-.1c-.1,0-.1.2-.2.3a.9.9,0,0,0,0-.3v-.1l-.2-.2h0s.1-.1,0-.1h-.2c.1-.2.1-.4.1-.5S362.6,514.8,362.8,514.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.9 515 362.9 515 362.9 515 362.9 515"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,516.2a.1.1,0,0,1,0,.1h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.9 515.2 362.9 515.1 362.9 515.2 362.9 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 515.1 363 515.1 363 515.1 363 515.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.1 515.2 363.1 515.2 363.1 515.2 363.1 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.1 515.2 363.1 515.2 363.1 515.2 363.1 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.2 515.2 363.2 515.2 363.2 515.2 363.2 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 515.3 363 515.3 363 515.3 363 515.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,516.2h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.2 515.2 363.2 515.2 363.2 515.2 363.2 515.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.7,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.5,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,515.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.4 515.8 362.4 515.8 362.4 515.9 362.4 515.9 362.4 515.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.5,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,518.7h0a1.1,1.1,0,0,0,0,.3h-.2v.2c.1-.2-.1-.3,0-.5s0-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.4s0,0,0,.1S362.4,516.4,362.4,516.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,518.5h.4s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.5h0S362.4,516.5,362.4,516.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,517.9v.2a.3.3,0,0,1,0,.2h-.1s-.1.1,0,.1h.2s0,0,0,0h.1s0,.1,0,.1h0s0,.1,0,.1h-.1s0,.1,0,.1h-.1c-.2,0-.1.2-.3.3v-.2h-.3c.1-.1.1-.3.2-.4s0-.1,0-.1h.2v-.2c-.1,0-.1.1-.2.1h0c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,518.6c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.2,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517c.1,0,.1.2.2.3s0,.2-.1.2h0s0-.1,0,0h0V517s0,0,0,.1h0s.1,0,0,.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.2 518.1 361.2 518.1 361.2 518.1 361.2 518.1 361.2 518.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.1,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 517.2 363.1 517.2 363.1 517.2 363.1 517.2 363.1 517.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,517.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.2 517.2 363.2 517.2 363.3 517.2 363.2 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.8 516.9 363.8 516.9 363.8 516.9 363.8 516.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,518a.2.2,0,0,1,0,.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363,517.5c.1.1,0,.2,0,.3h-.2a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.5h0s0,.2.1.1h0s0,0,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,517.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 517.4 363.1 517.4 363.1 517.4 363.1 517.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.9 517 363.9 517 363.9 517 363.9 517"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,518.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.9,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,517.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 517.6 363 517.5 363 517.5 363 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.4 517.9 362.4 517.9 362.4 517.9 362.4 517.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363 517.6 362.9 517.6 363 517.6 363 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.4 517.9 362.4 517.9 362.4 517.9 362.4 517.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,519.7h.1c0,.1-.1.2-.2.2h-.1s-.1-.1-.1-.2S360.5,519.7,360.6,519.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,518.7c.1,0,0,.1,0,.1h-.2a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "349.2",
      "y": "513.4",
      "width": "8.3",
      "height": "4.27",
      "transform": "translate(-152.2 148) rotate(-19.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,518.8h-.2c-.2-.1-.2-.3-.3-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.5.5,0,0,0,0-.2h.1a.3.3,0,0,0,0-.3h0c0-.1.1-.2.1-.3v-.2h.1c.1,0,0,.2.2.2h0v-.2h0c.1.1.1.3.2.4h.1c.2,0,.2-.2.3-.3a1.1,1.1,0,0,0-.1.4l.2-.2-.2.3.2.3h0s-.1.1,0,.1h0c.1.1.1-.1.2-.1s-.2.5-.3.6S350.6,518.8,350.4,518.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 518.6 350.3 518.6 350.3 518.6 350.3 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,517.4a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 518.3 350.3 518.3 350.3 518.3 350.3 518.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 518.4 350.2 518.4 350.1 518.4 350.1 518.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 518.2 350.1 518.3 350.1 518.2 350.1 518.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 518.2 350.1 518.2 350.1 518.2 350.1 518.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 518.2 350 518.2 350 518.2 350 518.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 518.1 350.2 518.1 350.2 518.1 350.2 518.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,517.4h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 518.2 350 518.2 350 518.2 350 518.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,517.4s0,0,0,0S351.9,517.4,351.9,517.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,518h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.1 517.6 351.1 517.6 351.1 517.6 351.1 517.6 351.1 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,515c-.1,0-.1-.1-.1-.2h.1a1.4,1.4,0,0,0,0-.4v.2h.2l.2-.2c-.2.2,0,.4-.1.6s-.1.3-.3.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,517s0-.1,0-.1S351.3,517,351.2,517Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,515.2l-.5-.2s-.1-.1,0-.1h.1l.5.2H356Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.7,515.5c-.1-.1,0-.2-.1-.2V515c.1,0,.1-.1.2-.1s.1-.1.1-.1h-.4s.1-.1,0-.1h0a.1.1,0,0,0-.1-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.3.4-.3s.2.1.1.2h.4c-.1.1-.2.4-.3.5s-.1.1,0,.1h-.3v.2c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1.1.1a.3.3,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,514.8c.1,0,0,0,0,.1S355.1,514.8,355.2,514.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353,515.1a.2.2,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.1,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,516c-.1-.1-.1-.2-.2-.4s.1-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0-.1,0-.1h.1c0-.1-.1-.1,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s0,.1.1.1a.5.5,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.1 515.1 353.1 515.1 353.1 515 353.1 515 353.1 515.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,515.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.8h0S350.4,515.8,350.4,515.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.8h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 515.8 350.5 515.8 350.5 515.7 350.5 515.7 350.5 515.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,515.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.4 515.8 350.4 515.8 350.3 515.8 350.4 515.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 516 349.6 516 349.6 516 349.6 516"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,515a.3.3,0,0,1,.1-.3l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,515.5c-.1-.1,0-.2.1-.4h.3a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,515.4h0c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,515.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.6 515.5 350.5 515.5 350.5 515.5 350.6 515.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.5 515.9 349.5 515.9 349.5 515.9 349.5 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,515.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,515.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.3,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,515.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.8 515.4 350.8 515.4 350.8 515.4 350.8 515.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 515.1 351.6 515.1 351.6 515.1 351.6 515.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.8 515.3 350.8 515.3 350.8 515.4 350.8 515.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.5 515 351.5 515.1 351.5 515.1 351.5 515"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,513.2c-.1,0-.1-.1,0-.2s.1-.2.2-.2h.1c0,.1.1.1,0,.2S354.4,513.3,354.2,513.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,514c-.1-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351.2",
      "y": "504",
      "width": "4.1",
      "height": "8.02",
      "transform": "translate(-224.1 730.6) rotate(-76.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,509.1c0-.1-.2-.1-.1-.2s0-.3,0-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2.1-.3s0,.2.1.2l.2-.2h.1l.2-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c0,.1-.1.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,0,.4h-.1l-.6.3A.7.7,0,0,1,349.2,509.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.2 508.9 349.2 508.9 349.2 508.9 349.2 508.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,509.2h.3c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 508.7 349.3 508.7 349.3 508.7 349.3 508.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.2 508.7 349.2 508.7 349.2 508.7 349.2 508.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 508.6 349.2 508.6 349.2 508.6 349.3 508.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 508.5 349.3 508.5 349.2 508.5 349.3 508.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.2 508.4 349.2 508.5 349.2 508.4 349.2 508.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.4 508.5 349.4 508.5 349.4 508.5 349.4 508.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,508.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.1 508.4 349.2 508.4 349.1 508.4 349.1 508.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,508.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,508.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,508.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,508.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.4 508.6 350.3 508.6 350.4 508.5 350.4 508.5 350.4 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,508.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,509.4c0-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2,0-.2.3-.4.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.6,509.2l-.3-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S355.6,509.2,355.6,509.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,508h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.6,508.2c0-.1.1-.1.1-.2h.2c.1.1.2-.1.2.1h.1c-.1-.1-.1-.2-.2-.2h0c0-.1,0-.1-.1-.1h.1c0-.1-.1,0-.1-.1h.1a.1.1,0,0,0,0-.2h.2c0-.1.1,0,.1-.1h0c.2.1.3-.1.5,0s0,.2,0,.3h.2s0,.1,0,.1h.2l-.5.2s-.1,0-.1.1h.1c.1.1,0,.1,0,.1h-.2v-.2H354c0,.1.2,0,.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,508.5c.1,0,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,507.6h.2a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.3,507.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.9c-.1-.1,0-.2.1-.4h.2s-.1,0,0,.1h-.1c0,.1,0,0,0,.1h0a.3.3,0,0,0,0,.2h0c0,.1.1,0,.1.1h.2c.1-.1,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.3 507.6 353.3 507.6 353.3 507.5 353.3 507.5 353.3 507.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,506.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.8h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,506.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.8 506.8 350.8 506.8 350.9 506.7 350.9 506.7 350.8 506.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,506.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 506.7 350.7 506.7 350.7 506.7 350.7 506.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 506.5 350 506.5 350 506.5 350 506.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,507.1l.2-.2a.3.3,0,0,1,0,.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,506.6c0-.1.2-.2.2-.2h.1a.3.3,0,0,0,.1.2h-.3A.1.1,0,0,1,351.2,506.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,506.7h0c0-.1.1-.2,0-.2h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,506.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 506.6 351 506.6 351 506.6 351 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 506.3 350 506.3 350 506.3 350 506.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,506.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,507h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,506.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 506.6 351.3 506.6 351.3 506.6 351.3 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.1 506.8 352.1 506.8 352.1 506.8 352.1 506.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 506.6 351.3 506.6 351.3 506.6 351.3 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.1 506.7 352 506.8 352.1 506.8 352.1 506.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,506h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,506.7c0-.1,0-.1.1-.2h.3c0,.1,0,.2-.1.2S355.2,506.8,355.2,506.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,506.1c0-.1.1-.1.1-.1h-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "345.2",
      "y": "502.1",
      "width": "8.2",
      "height": "4.2",
      "transform": "translate(-263.6 479.8) rotate(-53)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,500h.2c.2,0,.3.1.5.2s.1.1.1.1h0c0,.1.2.1.3.2h-.2v.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,.1.2h.1c.1.1,0,.2.1.3H351s0,.1,0,.1h.2c-.1,0-.2-.2-.4-.2h-.1c-.1.1,0,.3-.1.4a1.1,1.1,0,0,0-.1-.4c0,.1,0,.2-.1.3a1,1,0,0,1,0-.4H350c-.1,0-.1.2-.2.1v-.2c0-.1,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.5-.1-.7S349.7,500.1,349.9,500Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 500.1 350.1 500.1 350.1 500.1 350.1 500.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.8,502.3v.2h-.2C348.6,502.4,348.7,502.3,348.8,502.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 500.3 350.3 500.3 350.3 500.3 350.3 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.4 500.2 350.3 500.2 350.4 500.2 350.4 500.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.4 500.3 350.4 500.3 350.4 500.3 350.4 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.5 500.3 350.5 500.3 350.5 500.3 350.5 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.6 500.3 350.5 500.2 350.6 500.2 350.6 500.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.5 500.4 350.4 500.4 350.4 500.4 350.5 500.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.2,502l.2-.2h0l-.2.2S349.2,502,349.2,502Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.6 500.2 350.6 500.2 350.6 500.2 350.6 500.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,501.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.7,500.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 501.3 350 501.3 350 501.3 350 501.3 350 501.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,501.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,506.5h.2c-.1.1,0,.1,0,.2l.2.3h-.2c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,501.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,501.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,501.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,506h-.1C347.1,506,347.3,506,347.3,506Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,502h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,504.5l.2.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0v-.3a.8.8,0,0,0,0-.3c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,505.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,504.4h.1a.1.1,0,0,1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,504.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,502.3c.1,0,.2.1.3.2s0,.2,0,.3h-.4c0,.1,0,.1,0,.1h.1c0,.1.1,0,.1.1h-.1s0,.1,0,.1h0c0,.1.2.1.2.2h-.1a.4.4,0,0,1-.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.7 504.5 349.7 504.5 349.8 504.5 349.8 504.5 349.7 504.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.4,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,502.5s0,0,0,0S351.4,502.5,351.4,502.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,502.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.5 502.5 351.5 502.5 351.5 502.5 351.5 502.5 351.5 502.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,502.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,502.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 502.4 351.6 502.4 351.6 502.4 351.6 502.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.1 501.8 352.1 501.8 352.1 501.8 352.1 501.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,504a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,502.9c.1.1.1.2.1.3h-.4c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,502.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,502.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503h.1s.1,0,0,.1h-.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 502.7 351.6 502.7 351.6 502.7 351.6 502.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.2 501.9 352.2 501.9 352.2 501.9 352.2 501.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.4,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,503.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 503 351.5 503 351.5 503 351.5 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 503.7 350.9 503.7 351 503.6 351 503.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 503 351.4 503 351.5 503 351.5 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 503.6 351 503.6 351 503.6 351 503.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,502.7h0S351.6,502.7,351.7,502.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,502.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,506.6h.1c0,.1,0,.2-.1.3h-.1v-.2C349.6,506.7,349.6,506.6,349.8,506.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,504.6h.1a.2.2,0,0,1-.1.2h-.2C351.1,504.7,351.2,504.6,351.3,504.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "343.4",
      "y": "510.3",
      "width": "3.4",
      "height": "6.72",
      "transform": "translate(-251.6 349.8) rotate(-40.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.4,514.9c0,.1.1.2,0,.2s-.1.2-.2.3h-.1s0-.1,0-.1-.1.1-.2.2.1-.1,0-.2H347c0-.1.1-.1.1-.2h-.2c.1-.1.2-.1.2-.3h.1l.2-.3c0-.1-.1-.1-.1-.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1,0-.1-.1h.6C348.3,514.7,348.4,514.8,348.4,514.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.3 515.1 348.3 515.1 348.3 515.1 348.3 515.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,513.6h-.1C346.8,513.5,346.8,513.6,346.8,513.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.2 348.2 515.1 348.2 515.1 348.1 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.2 515.2 348.2 515.2 348.2 515.2 348.2 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.3 348.1 515.3 348.1 515.3 348.1 515.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.3 348.1 515.3 348.1 515.3 348.1 515.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.4 348.1 515.4 348.1 515.4 348.1 515.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 515.3 348 515.3 348 515.3 348 515.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,514v.2H347V514Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.1 515.4 348.1 515.4 348.1 515.4 348.1 515.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,514.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.9,514.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,515.4h0S348,515.4,348,515.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.4 514.7 347.4 514.7 347.4 514.8 347.4 514.7 347.4 514.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.4,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,511.2H343c.2.1.3-.1.5-.1s.2,0,.3.1S343.8,511.2,343.8,511.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.1,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,511.8a1.1,1.1,0,0,1,0,.4H344a2.6,2.6,0,0,0,0-.4s0-.1,0-.1S344.1,511.8,344.1,511.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,513.4h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2,0,.2h-.1s0,.1,0,.1h-.1s0,.1,0,.1h-.5s0,0,0-.1-.3-.1-.3-.2v-.2c0-.1,0-.1-.1-.1h.5a.2.2,0,0,0,0-.2h.1s0,.1,0,.2h.4c0-.1-.1-.1-.2-.2h.3l.3.2A.4.4,0,0,1,345,513.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,512.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,514h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.9,514h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.4,515.7c0,.1-.2.1-.2.2h0c0-.1.1,0,0-.1h.1c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "344.9 514 344.9 514 344.9 514 344.9 514 344.9 514"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.3,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,515.7h0S346.2,515.7,346.3,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.2 515.7 346.2 515.7 346.1 515.8 346.1 515.8 346.2 515.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,515.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.2 515.8 346.2 515.8 346.2 515.9 346.2 515.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.6 516.3 346.6 516.3 346.6 516.3 346.6 516.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.1,514.7h-.2v-.2h.1S345.2,514.6,345.1,514.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,515.7h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,345.9,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,515.5h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346 515.8 346 515.8 346 515.8 346 515.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.5 516.4 346.5 516.4 346.5 516.4 346.5 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.6h0S345.7,515.6,345.7,515.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.9,514.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 515.6 345.8 515.6 345.8 515.6 345.8 515.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.3 515.1 345.3 515.1 345.3 515.1 345.3 515.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 515.6 345.8 515.6 345.8 515.6 345.8 515.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.3 515.2 345.4 515.1 345.3 515.1 345.3 515.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.2,513.7h-.3a.2.2,0,0,1,0-.1h.2C343.1,513.5,343.2,513.5,343.2,513.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,515.3h-.3s0-.1,0-.1h.1A.1.1,0,0,1,344.5,515.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "333.9",
      "y": "510.5",
      "width": "7.3",
      "height": "3.75",
      "transform": "matrix(0.57, -0.82, 0.82, 0.57, -275.93, 500.03)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.9,508.6h.2c.2-.1.3.1.4.1h.1c0,.1.2.1.2.2h-.2v.2h0v.2h.1c.1.1,0,.2.1.2H339s0,0,0,.1h.1l-.3-.2h-.1c-.1.1,0,.3,0,.4a1,1,0,0,0-.1-.3c0,.1,0,.2,0,.2a.9.9,0,0,1,0-.3h-.3c-.1,0-.1.2-.1.1v-.2s0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.6S337.8,508.7,337.9,508.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.1 508.7 338.1 508.6 338.1 508.6 338.1 508.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337,510.7h-.1C336.9,510.8,336.9,510.7,337,510.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.3 508.8 338.2 508.8 338.2 508.8 338.3 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.3 508.7 338.3 508.7 338.3 508.7 338.3 508.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 508.8 338.4 508.8 338.4 508.8 338.4 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 508.8 338.4 508.8 338.4 508.8 338.4 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.5 508.8 338.5 508.8 338.5 508.8 338.5 508.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 508.9 338.4 508.9 338.4 508.9 338.4 508.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.4,510.4l.2-.2h0l-.2.2S337.4,510.4,337.4,510.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 508.8 338.5 508.8 338.5 508.8 338.6 508.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.1,509.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.6,508.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338 509.8 338 509.7 338 509.8 338 509.8 338 509.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.2,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,514.5h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.5,509.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.5,510h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.8,514h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.3,512.6h.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.6c.1,0,0,.1.1.1H338c-.2.1,0,.3-.1.4h-.5c0,.1-.1.1-.1.2s-.1-.3,0-.5h-.1v-.2a.8.8,0,0,0,0-.2c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2-.1-.2H337a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.6,513.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.9,512.5h.1a.1.1,0,0,1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.9,512.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.6l.3.2c-.1.1.1.2,0,.3h-.2v.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "337.9 512.6 337.9 512.6 338 512.6 338 512.6 337.9 512.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,510.8s0,0,0,0S339.3,510.8,339.3,510.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.5,510.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 510.8 339.4 510.8 339.4 510.8 339.4 510.8 339.4 510.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,510.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.5 510.7 339.5 510.7 339.5 510.7 339.5 510.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 510.1 339.9 510.1 339.9 510.1 339.9 510.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.5,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.6,512.1a.2.2,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,511.1c.1.1.1.2.1.3h-.4c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.5,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.2h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.5 511 339.5 510.9 339.5 511 339.5 511"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.1 510.2 340 510.2 340.1 510.2 340.1 510.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,511.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.6,512.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,511.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,511.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.4 511.2 339.4 511.2 339.4 511.2 339.4 511.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339 511.8 339 511.8 339 511.8 339 511.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.4 511.2 339.4 511.2 339.4 511.2 339.4 511.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339 511.8 339 511.8 339 511.8 339 511.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,511h0S339.6,511,339.6,511Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.3,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.1,514.5h.1c0,.1,0,.2-.1.2h-.2C337.9,514.6,337.9,514.5,338.1,514.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,512.7h.1a.1.1,0,0,1-.1.2h-.2C339.2,512.7,339.3,512.6,339.4,512.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "330.5",
      "y": "513.5",
      "width": "7.1",
      "height": "3.62",
      "transform": "translate(-196.6 824.3) rotate(-87.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.7,518.6h-.8s.1,0,0-.1h-.3s0,.1,0,.1h0a.4.4,0,0,1,0-.1H334a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.1-.2-.2-.3l.3.2c-.1-.1-.1-.2-.1-.2l.2.2h.3c0-.1,0-.2,0-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.2l.4.4A.6.6,0,0,1,335.7,518.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.5 518.6 335.5 518.6 335.5 518.6 335.5 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.4,516.4h-.1a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,335.4,516.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.3 518.6 335.3 518.6 335.3 518.6 335.3 518.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.3 518.7 335.3 518.7 335.3 518.7 335.3 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.2 518.6 335.2 518.7 335.2 518.7 335.2 518.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.7 335.1 518.7 335.1 518.7 335.1 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.7 335.1 518.7 335.1 518.7 335.1 518.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.6 335.1 518.6 335.1 518.6 335.1 518.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.1,516.8a.8.8,0,0,1,0,.3h0c0-.1,0-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.1 518.8 335.1 518.8 335.1 518.8 335.1 518.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.1,516.9h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.1,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.1,517h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.9,518.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335 517.7 335 517.7 335 517.7 335 517.7 335 517.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.9,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.7,512.4h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.1c.1-.1,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.5,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.5,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.6,513.1l-.3.4h0l.3-.3h.1C334.8,513,334.7,513.1,334.6,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.5,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,515h-.3c0-.1-.1-.1,0-.2h-.1l-.2.2h-.5s0,0,0-.1H333s0,0,0-.1h0c.1-.2-.1-.2-.1-.4h.2c.1,0,0-.1,0-.2h.1c0-.1,0-.1,0-.2l.3.4h.3c0,.1-.1.1,0,.2h-.1c0,.1,0,.2,0,.2v.2c.1-.1-.1-.1,0-.2h.1s0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,513.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.7,515.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.7,515.3h0S333.7,515.3,333.7,515.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.5,517.7h-.3c0-.1-.1-.1-.2-.2h.2s0,0,0,0h.1s0-.1,0-.1h.1S333.5,517.7,333.5,517.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.6 515.3 333.6 515.3 333.6 515.3 333.6 515.3 333.6 515.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.5,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.4,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.4,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.4,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,517.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.3 517.6 333.3 517.6 333.3 517.6 333.3 517.6 333.3 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.3 517.7 333.3 517.7 333.3 517.7 333.3 517.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.2 518.4 333.3 518.4 333.3 518.4 333.2 518.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,516l-.2-.2h.3C333.4,515.9,333.4,516,333.3,516Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,517.3l-.3-.2s0,0,0-.1h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,517.1s0,0,0,0h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,517h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 517.4 333.2 517.5 333.1 517.5 333.1 517.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 518.4 333.1 518.4 333.1 518.4 333.1 518.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.2,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,517h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.1 517.2 333.1 517.2 333.1 517.2 333.1 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 516.5 333.2 516.5 333.2 516.5 333.1 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.1 517.2 333.1 517.2 333.1 517.2 333.1 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 516.5 333.1 516.5 333.1 516.5 333.1 516.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.1,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.8,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.6,513.8h-.2c-.1-.1-.1-.2-.1-.2h.3C332.6,513.6,332.7,513.8,332.6,513.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.4,516h-.1a.1.1,0,0,1,0-.2h.2A.1.1,0,0,1,332.4,516Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "332.4",
      "y": "520.4",
      "width": "8.7",
      "height": "4.45",
      "transform": "translate(-261.8 354.4) rotate(-41.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.2,526.9h-.3c-.2,0-.3-.2-.4-.3s0-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2a.5.5,0,0,0,0-.3h-.1s0-.1,0-.1h.1a.3.3,0,0,0-.1-.3h-.1c-.1-.1.1-.2,0-.3l-.2-.2h.3s0-.1,0-.1l-.2-.2h0c.1.1.2.3.4.3h.1c.1-.1.1-.3.2-.4a1.2,1.2,0,0,0,.1.4c0-.1.1-.2.1-.3a1.1,1.1,0,0,1-.1.4l.4.2c.1,0,.1-.2.2-.1h-.2c0,.1-.1.1,0,.2h.1c0,.1-.1.1,0,.1h.1c.1,0,.1-.1.1-.1s0,.5,0,.7S335.4,526.9,335.2,526.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335 526.8 335 526.8 335 526.8 335 526.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.8,524.8a.1.1,0,0,1-.1-.2h.3C337,524.7,336.9,524.8,336.8,524.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.9 526.5 334.9 526.6 334.9 526.6 334.9 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.8 526.6 334.8 526.7 334.8 526.7 334.8 526.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.7 526.5 334.7 526.5 334.7 526.5 334.7 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.7 526.5 334.7 526.5 334.7 526.5 334.7 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.6 526.5 334.6 526.5 334.6 526.5 334.6 526.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.7 526.4 334.7 526.4 334.7 526.4 334.7 526.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,524.9l-.3.2s0,0,0-.1l.3-.2S336.4,525,336.3,524.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.5 526.5 334.5 526.5 334.5 526.5 334.5 526.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.2,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.3,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.1,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.3,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,526.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "335.4 525.5 335.4 525.6 335.4 525.5 335.4 525.5 335.4 525.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.2,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.9,520.8l-.2-.2c.1,0,0-.1.1-.2a1.4,1.4,0,0,0-.1-.4h.1c.1,0,.1-.1.2-.1s0-.2.1-.2.2.4.1.6,0,.3-.2.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.9,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.9s0,0,0-.1S335.3,524.8,335.3,524.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.2,521.3h-.6s-.1,0,0-.1h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.1,522.4v-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.2-.1s.1-.1,0-.1h-.3s0,0,0-.1h-.2s0-.1,0-.1h-.1c0-.1,0-.1-.1-.1h.1c-.1,0,0-.1-.1-.2h.1c.2-.1.1-.3.3-.4l.2.2h.3v-.2c-.1.2,0,.4-.1.6s0,.1.1.1h0l-.2.2a.9.9,0,0,0,0,.3c.1,0,.1-.2.2-.2h.1c0,.1-.1.2,0,.2h.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.3,521.3c.1,0,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,522.4h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M336.4,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.2c-.2,0-.2-.2-.3-.3s0-.2,0-.3h0s0,.1,0,.1h0l.2.2h.1c0-.1,0-.1,0-.1h-.1c0-.1-.1,0,0-.1h.1s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.5.5,0,0,1,.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "336.3 522.3 336.3 522.3 336.3 522.3 336.3 522.3 336.3 522.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.2,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.2,524s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334,524.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334.1 524 334.1 524 334.1 524 334.1 524 334.1 524"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.1,523.9s0,0,0,0S334.1,523.9,334.1,523.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.2,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334 524 334 524.1 333.9 524.1 334 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.3 524.6 333.3 524.6 333.3 524.6 333.3 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.4,522.6a.3.3,0,0,1,0-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.2,523.6c-.1-.1-.1-.2-.1-.4h.3v.2c0,.1-.2.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.5h0s-.1-.2-.1-.1h0s-.1,0,0-.1h.1s.1.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334 523.7 334 523.7 334 523.7 334 523.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.2 524.5 333.2 524.5 333.2 524.5 333.2 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.3,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.3,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335.5,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.3,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.4,523.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.2 523.5 334.2 523.5 334.2 523.5 334.2 523.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334.9 522.9 334.9 522.9 334.9 522.9 334.9 522.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "334.2 523.5 334.2 523.5 334.2 523.5 334.2 523.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "334.8 522.9 334.8 522.9 334.8 522.9 334.8 522.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334,523.7h0S334,523.7,334,523.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.7,520.1v-.2c0-.1,0-.2.1-.3h.1c0,.1.1.1.1.2S336.9,520.1,336.7,520.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.7,521.8c-.1,0-.1-.1-.1-.2v-.2h.1a.2.2,0,0,1,.1.2A.2.2,0,0,1,334.7,521.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "328.8",
      "y": "521.6",
      "width": "3.4",
      "height": "6.66",
      "transform": "translate(-233.5 783.1) rotate(-82.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.2,526.1s-.1-.1-.1-.2-.1-.3-.1-.4,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2v-.2h.1V525s0,0,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c0,.1,0,.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.3h.4l-.2.2h.2l-.2.2a.7.7,0,0,0,.1.3h0l-.4.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.9 327.2 526 327.2 526 327.2 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.3,526h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.3 525.8 327.3 525.8 327.3 525.8 327.3 525.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.8 327.2 525.8 327.2 525.8 327.2 525.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.7 327.2 525.7 327.2 525.7 327.2 525.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.6 327.2 525.6 327.2 525.6 327.2 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.2 525.6 327.2 525.6 327.1 525.6 327.2 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.3 525.6 327.3 525.6 327.3 525.6 327.3 525.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.9,525.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.1 525.6 327.1 525.6 327.1 525.6 327.1 525.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,525.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.2,525.4h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "328.1",
      "y": "525.6",
      "height": "0.01",
      "transform": "translate(-235 784) rotate(-82.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.1,525.8c0-.1,0-.1,0-.2h.1l.2-.3s0,.1,0,.1h.3c-.2.1-.1.3-.3.4h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.1,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.2,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.5,525.6l-.3-.3s0-.1,0-.1h.1l.3.3s.1.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,525.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,525c0-.1.1-.1,0-.2h.4l-.2-.2h.1a.1.1,0,0,0,0-.1h.2c0-.1.1,0,.1-.1h0c.2.1.2-.1.4,0s.1.2,0,.2h.1s0,.1,0,.1h.2l-.4.2s-.1.1-.1.1h.1s0,.1,0,.1h-.4a0,0,0,0,1,0,.1s-.2,0-.1.1,0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332,525.1s0,0,0,0S332,525.1,332,525.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.4,524.5h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.5,524.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,524.2c-.1-.1,0-.2,0-.3h.1s-.1,0,0,0h-.1s0,0,0,.1h0a.3.3,0,0,0,0,.2h.2s0,0,0,0h0c.1-.1,0-.2.1-.2s0,.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.5 524.5 330.5 524.5 330.5 524.5 330.5 524.5 330.5 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.3,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.4,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,524h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.4 524 328.4 524 328.4 524 328.4 524 328.4 524"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,524h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.3 524 328.3 524 328.3 524 328.3 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.6 523.9 327.6 523.9 327.6 523.9 327.6 523.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,524.1l.2-.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.6,523.9c0-.1.1-.2.2-.2h.1v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,523.9h0s.1-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.5 523.9 328.5 523.9 328.5 523.9 328.5 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.6 523.8 327.7 523.8 327.6 523.8 327.6 523.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.8,523.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.7,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.9,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.7 523.9 328.7 523.9 328.7 523.9 328.7 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 523.9 329.4 524 329.4 524 329.4 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.7 523.9 328.7 523.9 328.7 523.9 328.7 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 523.9 329.4 523.9 329.4 523.9 329.4 523.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.5,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332,523.6s0-.1,0-.1h.3s0,.1-.1.2S332,523.7,332,523.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.9,523.3c0-.1,0-.1.1-.1h-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "323.8",
      "y": "523.9",
      "width": "4.2",
      "height": "8.18",
      "transform": "matrix(0.85, -0.53, 0.53, 0.85, -228.74, 249.82)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,525.9c0-.1,0-.2.1-.2s.2-.2.3-.4h.2s0,.1,0,.1.2-.2.3-.2-.1.1-.1.2H324c0,.1-.2.1-.1.2h.3c-.1.1-.3.1-.3.3h0c.1.1.3.1.4.2h-.4l.2.2h-.3l-.3.3c0,.1.1.1.1.2v-.2h-.2s0,0,0,0h-.1a.1.1,0,0,0,0,.1H323c-.1.1.1.1.1.1l-.7-.2C322.3,526.2,322.1,526.1,322.1,525.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.3 525.7 322.3 525.7 322.3 525.7 322.3 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.9,527.7h.2v.2H324C323.9,527.9,323.8,527.8,323.9,527.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.6 322.5 525.7 322.5 525.7 322.6 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 525.5 322.5 525.5 322.5 525.5 322.5 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.5 322.6 525.5 322.6 525.5 322.6 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.5 322.6 525.5 322.6 525.5 322.6 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.4 322.6 525.4 322.6 525.4 322.6 525.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.7 525.5 322.7 525.5 322.7 525.5 322.7 525.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,527.2V527h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.6 525.3 322.6 525.3 322.6 525.3 322.6 525.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,527.1h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.7,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,526.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.8,525.3h0S322.8,525.3,322.8,525.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "323.4",
      "y": "526.3",
      "height": "0.01",
      "transform": "translate(-230.4 252.7) rotate(-32.1)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,526.1h0S323.5,526.1,323.4,526.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.1,531.2h.6c0,.1.1.1.1.2h.2c-.2-.1-.4.1-.6,0s-.3,0-.3-.2S327.1,531.2,327.1,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,530.5a1.3,1.3,0,0,1,.1-.5h.1s0,.1,0,.1a3.2,3.2,0,0,0-.1.5s0,.1-.1.1S326.7,530.5,326.8,530.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326,528.3h.4c0,.1.2.1.1.2h.1c0-.1.1-.2,0-.3h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.4c.1,0,0,.1,0,.1h.1c0,.2.3.1.3.3l-.2.2c-.1.1,0,.1.1.2h-.1v.2l-.5-.2H327a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1-.1-.2s.1-.1,0-.2l-.2-.2h-.3c0,.1.2.1.2.2h-.1c-.1,0-.2-.1-.2,0h-.1a.3.3,0,0,1-.3-.2A.5.5,0,0,1,326,528.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.2,527.6h0A.1.1,0,0,1,326.2,527.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.2,527.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.8,525.3c0-.1.2-.1.3-.2h0c0,.1-.1,0,0,.1h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.2 527.7 326.2 527.7 326.3 527.6 326.3 527.7 326.2 527.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.9,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.9,525.3h0S324.9,525.3,324.9,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.9,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,525.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325 525.3 325 525.3 325.1 525.3 325.1 525.3 325 525.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,525.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325 525.2 325 525.2 325 525.2 325 525.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.6 524.5 324.6 524.5 324.6 524.5 324.6 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.1,526.8h.3v.2h-.1C326.1,526.9,326,526.8,326.1,526.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.4,525.5h.4s0,.1,0,.1a.3.3,0,0,0-.1.2h-.2c-.1,0,0-.1-.2-.1A.1.1,0,0,1,325.4,525.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.2,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.7h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.6,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.3 525.3 325.3 525.3 325.3 525.3 325.3 525.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.8 524.4 324.7 524.4 324.7 524.4 324.8 524.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.3,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.6,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.5 525.5 325.5 525.5 325.5 525.5 325.5 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.9 526.2 325.9 526.3 325.9 526.2 325.9 526.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.5 525.5 325.5 525.5 325.5 525.5 325.5 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.9 526.2 325.9 526.2 325.9 526.2 325.9 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.3,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,528.4h.2c.1,0,.2.1.2.2h-.2C328.3,528.7,328.2,528.5,328.2,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,526.2h.1A.1.1,0,0,1,327,526.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "325.3",
      "y": "529.2",
      "width": "3.9",
      "height": "7.57",
      "transform": "translate(-199.3 195.4) rotate(-25.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,530.7c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1.2-.1.3-.1-.1.1-.1.2h1c0,.1-.1,0-.2.2h.3c-.1.1-.3.1-.3.2h0c0,.1.2.1.3.2h-.4l.2.2h-.3l-.3.3c0,.1.1.1,0,.2s0-.1-.1-.2h-.4c-.1.1.1.1.1.1l-.6-.2C324.1,531,324,530.9,324,530.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 530.6 324.1 530.6 324.1 530.6 324.1 530.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.4,532.6h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,325.4,532.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.4 530.5 324.3 530.5 324.4 530.5 324.4 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.3 530.4 324.3 530.4 324.3 530.4 324.3 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.4 530.4 324.4 530.4 324.4 530.4 324.4 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.4 324.4 530.4 324.4 530.4 324.5 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.3 324.4 530.3 324.5 530.3 324.5 530.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.4 324.5 530.5 324.5 530.5 324.5 530.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.4,532.1v-.3h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 530.2 324.5 530.3 324.5 530.2 324.5 530.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.3,532h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.4,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.3,531.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325,531.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,530.3a0,0,0,0,1,0,0S324.6,530.3,324.6,530.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 531.2 325.1 531.2 325.1 531.2 325.1 531.2 325.1 531.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,531.1h0S325.1,531.1,325.1,531.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,536.1h.5c0,.1,0,.1.1.2h.2c-.2-.1-.4,0-.5-.1s-.3-.1-.3-.2S328,536.1,328,536.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,530.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.8,535.4a1.2,1.2,0,0,1,.1-.5h.1s0,.1,0,.1a3,3,0,0,0-.1.5s0,.1-.1.1S327.8,535.4,327.8,535.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,531.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.3,533.3h.4c0,.1.1.1.1.2h.1c0-.1.1-.2.1-.2h.1c.1,0,0-.1,0-.1h.2c.1,0,0-.1,0-.1h.4s0,0,0,.1h.1c0,.2.3.2.3.3h-.2c-.1.1,0,.1,0,.2h-.1v.2l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.2s.1-.1,0-.2l-.2-.2h-.2c-.1.1.1.1.1.2h-.1c-.1,0-.1-.1-.2-.1h-.1a.3.3,0,0,1-.2-.2A.5.5,0,0,1,327.3,533.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,532.7h0A.1.1,0,0,1,327.5,532.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.5,532.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.5,530.4l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C326.5,530.6,326.5,530.5,326.5,530.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.6 532.7 327.6 532.7 327.6 532.7 327.6 532.7 327.6 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.5,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.4h0S326.6,530.5,326.6,530.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,530.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.7 530.5 326.7 530.5 326.7 530.5 326.7 530.5 326.7 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,530.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.7 530.4 326.7 530.4 326.7 530.3 326.7 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.4 529.7 326.3 529.7 326.3 529.7 326.4 529.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.7,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,531.9h.3v.2h-.1C327.5,532,327.5,532,327.5,531.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,530.6h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,327,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327,530.8h.1s0-.1,0-.1H327Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.9 530.5 326.9 530.5 326.9 530.5 326.9 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.5 529.6 326.5 529.6 326.5 529.6 326.5 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.7,532h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.1,530.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.1 530.7 327.1 530.7 327.1 530.7 327.1 530.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.4 531.4 327.4 531.4 327.4 531.4 327.4 531.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.1 530.7 327.1 530.7 327.1 530.7 327.1 530.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.4 531.4 327.4 531.4 327.4 531.4 327.4 531.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.3,533.6h.2c.1,0,.2.1.2.2h-.2C329.4,533.8,329.3,533.7,329.3,533.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,531.5h.1A.1.1,0,0,1,328.4,531.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "326.3",
      "y": "534",
      "width": "4.1",
      "height": "7.97",
      "transform": "translate(-44.3 29.7) rotate(-4.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,541.5s0,.2-.2.2-.3.1-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.8s0,0,0,0h.4s0,0,0-.1h.1c0-.2-.2-.2-.2-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.4c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.4A.7.7,0,0,1,330.7,541.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.4 541.5 330.5 541.5 330.5 541.5 330.4 541.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330,539.1h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,330,539.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.2 541.5 330.2 541.5 330.2 541.5 330.2 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.2 541.6 330.2 541.6 330.2 541.6 330.2 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.1 541.6 330.1 541.6 330.1 541.6 330.1 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.1 541.6 330.1 541.6 330.1 541.6 330.1 541.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330 541.7 330 541.7 330 541.7 330 541.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330 541.5 330 541.5 330 541.5 330 541.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,539.5a.9.9,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330 541.7 330 541.7 330 541.7 330 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,539.7h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,541.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.8 540.5 329.8 540.5 329.7 540.6 329.7 540.5 329.8 540.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.6,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.7,534.7h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2s-.1-.1-.1-.2.4.1.5.3.2.2.2.3S328.7,534.6,328.7,534.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.7,535.4l-.3.4h-.1s0-.1,0-.1l.3-.4h.1C328.8,535.3,328.7,535.4,328.7,535.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,537.6H328c0-.1-.1-.1,0-.2h-.1c0,.1-.2.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1H327c.1-.2-.2-.3-.2-.4h.3c.1,0,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.2,0-.3h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,536.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,538.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.9,538.1h0S328,538.1,327.9,538.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.1,540.8h-.4c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C328.1,540.6,328.1,540.7,328.1,540.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.9 538.1 327.9 538.1 327.9 538.1 327.9 538.1 327.9 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.1,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,540.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.9 540.7 327.9 540.7 327.9 540.7 327.9 540.7 327.9 540.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.9,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.9,540.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.9 540.8 327.9 540.8 327.9 540.8 327.9 540.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.9 541.6 327.9 541.6 327.9 541.6 327.9 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,540.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,538.9l-.2-.2h.3C327.7,538.8,327.7,538.9,327.6,538.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.7,540.4c-.1,0-.2-.1-.3-.2s0,0,0-.1l.2-.2h.2c.1.1,0,.1.1.2A.1.1,0,0,1,327.7,540.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.8,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.8,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.7,540.2h-.2s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.7 540.5 327.7 540.6 327.7 540.6 327.7 540.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.8 541.6 327.8 541.6 327.8 541.6 327.8 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.5,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.6,540.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.6 540.3 327.6 540.3 327.6 540.3 327.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.5 539.5 327.5 539.5 327.5 539.5 327.5 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327.6 540.3 327.6 540.3 327.6 540.3 327.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.5 539.5 327.5 539.5 327.5 539.5 327.5 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.4,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.5,536.6h-.2c-.1-.1-.2-.2-.1-.3h.3C326.5,536.3,326.6,536.5,326.5,536.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.6,539h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,326.6,539Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "318.8",
      "y": "538.8",
      "width": "6.8",
      "height": "3.47",
      "transform": "translate(-286.9 382.3) rotate(-44.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,537.2h.2l.4.2c0,.1,0,.1.1.1h0c0,.1.2.1.2.2h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.2.2,0,0,0,.1.2h.1c.1.1,0,.2,0,.2h-.1s0,0,0,.1h.1l-.3-.2h-.1c-.1.1,0,.2-.1.3a.9.9,0,0,0-.1-.3c0,.1-.1.2-.1.2a.8.8,0,0,1,0-.3l-.3-.2h0s0-.1,0-.1h0s.1-.1,0-.1H323c-.1,0,0,.1-.1.1s0-.4,0-.6S323,537.2,323.2,537.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 537.3 323.3 537.3 323.3 537.3 323.3 537.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,538.9a.1.1,0,0,1,.1.1H322Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.4 537.4 323.4 537.4 323.4 537.4 323.4 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.5 537.4 323.5 537.4 323.5 537.4 323.5 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.5 537.5 323.6 537.4 323.6 537.5 323.5 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.6 537.5 323.6 537.5 323.6 537.5 323.6 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 537.5 323.7 537.4 323.7 537.5 323.7 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.6 537.6 323.5 537.6 323.5 537.6 323.6 537.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,538.8l.2-.2s0,0,0,.1l-.2.2S322.3,538.7,322.4,538.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 537.4 323.7 537.4 323.7 537.4 323.7 537.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,538.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.7,537.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.1 538.2 323.1 538.2 323.1 538.3 323.1 538.3 323.1 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.8,542.1h.1c-.1,0,0,.1,0,.1v.3h-.2c0,.1,0,.1-.1.2s-.1-.3-.1-.5,0-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.3,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,540.7h.1a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s-.1.1,0,.1h.2s0,0,0,0h.2s0,.1,0,.1h.1c.1,0,0,.1.1.1h-.1c-.2.1-.1.3-.2.3h-.5c.1-.1,0-.3.1-.5s0-.1,0-.1h0v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.1-.1.2h-.1c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,540.7h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,539.2c.1,0,.2.1.2.2s0,.2,0,.3h-.3s0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 540.8 322.5 540.8 322.5 540.8 322.5 540.8 322.5 540.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.4s0,0,0,0S324,539.4,324.1,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.1 539.4 324.1 539.4 324.2 539.4 324.2 539.4 324.1 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,539.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.2 539.4 324.2 539.3 324.3 539.3 324.2 539.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.7 538.9 324.7 538.9 324.7 538.9 324.7 538.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,540.5a.2.2,0,0,1,0,.2H323a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,539.7c.1.1.1.2.1.3h-.3c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h.1s.1,0,0,.1H324s0,0,0-.1H324Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,539.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.2 539.6 324.2 539.6 324.2 539.6 324.2 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.8 539 324.8 539 324.8 539 324.8 539"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,539.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 539.8 324.1 539.8 324.1 539.8 324.1 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.6 540.3 323.6 540.3 323.6 540.3 323.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 539.8 324.1 539.8 324.1 539.8 324.1 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.6 540.3 323.6 540.3 323.6 540.3 323.6 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,539.6h0S324.2,539.6,324.3,539.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,542.6h.1c0,.1,0,.2-.1.2h-.2C322.1,542.6,322.1,542.5,322.3,542.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,541.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "320",
      "y": "543.6",
      "width": "8.6",
      "height": "4.38",
      "transform": "translate(-279 348.1) rotate(-41.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,541.6h.3c.2,0,.3.2.4.3s0,.1.1.1h0c0,.1.2.1.2.2h-.2a.5.5,0,0,0,0,.3h.1s0,.1,0,.1h-.1a.3.3,0,0,0,.1.3h.1c.1.1-.1.2,0,.3l.2.2h-.3s0,.1,0,.1l.2.2h0c-.1-.1-.2-.3-.3-.3h-.1c-.1.1-.1.3-.2.4a1.2,1.2,0,0,0-.1-.4c0,.1-.1.2-.1.3a1.1,1.1,0,0,1,.1-.4l-.4-.2c-.1,0-.1.2-.2.1h.2c0-.1.1-.1,0-.2h0s.1-.1,0-.1h-.1c-.1,0-.1.1-.1.1s0-.5.1-.7S325.6,541.6,325.8,541.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326 541.8 326 541.7 326 541.7 326 541.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,543.7a.1.1,0,0,1,.1.2H324C324,543.8,324.1,543.7,324.2,543.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.1 542 326.1 542 326.1 542 326.1 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.2 541.9 326.2 541.9 326.2 541.9 326.2 541.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 542 326.3 542 326.3 542 326.3 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 542 326.3 542 326.3 542 326.3 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.4 542 326.4 542 326.4 542 326.4 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 542.1 326.3 542.1 326.3 542.1 326.3 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,543.6l.3-.2s0,0,0,.1l-.3.2S324.6,543.5,324.7,543.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.5 542 326.4 542 326.5 542 326.5 542"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.8,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.7,542.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.5,542.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.6 543 325.6 543 325.6 543 325.6 543 325.6 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.8,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.2,547.6l.2.2c-.1,0,0,.1-.1.2a1.4,1.4,0,0,0,.1.4h-.1c-.1,0-.1.1-.2.1s0,.2-.1.2-.2-.4-.1-.6,0-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.1,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.6s0,0,0,.1S325.7,543.7,325.7,543.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,547.2h.6s.1,0,0,.1h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.7,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.9,546v.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s-.1.1,0,.1h.3s0,0,0,.1h.2s0,.1,0,.1h.1c0,.1,0,.1.1.1h-.1c.1,0,0,.1.1.1h-.1c-.2.1-.1.3-.3.4l-.2-.2h-.3v.2c.1-.2,0-.4.1-.6s0-.1-.1-.1h0l.2-.2a.9.9,0,0,0,0-.3c-.1,0-.1.2-.2.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,547.2c-.1,0,0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,546.1h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.3c.2,0,.2.2.3.3s0,.2,0,.3h0s0-.1,0-.1h0l-.2-.2h-.1c0,.1,0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.5.5,0,0,1-.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 546.2 324.7 546.1 324.7 546.2 324.7 546.2 324.7 546.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.5s0,0,0,0S326.7,544.5,326.8,544.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,544.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.9 544.5 326.9 544.5 326.9 544.5 326.9 544.5 326.9 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.6s0,0,0,0S326.8,544.6,326.8,544.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327 544.5 327 544.4 327 544.4 327 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.6 543.9 327.6 543.9 327.6 543.9 327.6 543.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.9,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.5,545.8a.3.3,0,0,1,0,.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,544.9c.1.1.1.2.1.4h-.3v-.2c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.1,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.6,545h0s.1.2.1.1h0s.1,0,0,.1h-.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.5,545.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.9 544.8 326.9 544.8 326.9 544.8 326.9 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.8 544 327.7 544 327.8 544 327.8 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.6,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.5,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.7,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.6,545.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.8 545 326.7 545 326.7 545 326.8 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.1 545.6 326.1 545.6 326.1 545.6 326.1 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.7 545 326.7 545 326.7 545 326.7 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "326.1 545.6 326.1 545.6 326.1 545.6 326.1 545.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327,544.8h0S327,544.8,327,544.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,548.3v.2c0,.1,0,.2-.1.3h-.1c0-.1-.1-.1-.1-.2S324.1,548.3,324.2,548.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.3,546.6c.1,0,.1.1.1.2v.2h-.1a.2.2,0,0,1-.1-.2A.2.2,0,0,1,326.3,546.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "327.4",
      "y": "548.9",
      "width": "3.2",
      "height": "6.19",
      "transform": "translate(-276.8 337.8) rotate(-39.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326,550.8s-.1-.1,0-.2.1-.2.2-.3h.1s0,.1,0,.1.1-.1.2-.2-.1.1,0,.2h.8c0,.1-.1.1-.1.2h.2c-.1.1-.2.1-.2.2h-.1l-.2.3c0,.1.1.1.1.1h-.2s0,0,0,0h-.1a.1.1,0,0,0,0,.1h-.1c0,.1.1,0,.1.1h-.5C326.2,551,326,550.9,326,550.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.1 550.6 326.1 550.6 326.1 550.6 326.1 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,552h.1C327.5,552.1,327.5,552.1,327.5,552Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.6 326.3 550.6 326.3 550.6 326.3 550.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.2 550.5 326.2 550.5 326.2 550.5 326.2 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.5 326.3 550.5 326.3 550.4 326.3 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.4 326.3 550.4 326.3 550.4 326.3 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.3 326.3 550.4 326.3 550.4 326.3 550.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.4 550.5 326.4 550.5 326.4 550.5 326.4 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.4,551.6v-.2h0v.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "326.3 550.3 326.3 550.3 326.3 550.3 326.3 550.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.3,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.4,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.3,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.9,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M326.4,550.3h0S326.4,550.3,326.4,550.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "327 551 327 551 327 551 327 551 327 551"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.3,554.2h0S330.3,554.3,330.3,554.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.2,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M327.3,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.9,553.7a1,1,0,0,1,0-.4h.1a2.5,2.5,0,0,0,0,.4s0,.1,0,.1S329.9,553.8,329.9,553.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.5,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.6,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,552.2h.3c0,.1.1,0,.1.1h.1c0-.1,0-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.4c.1.2.2.1.3.2v.2c0,.1,0,.1.1.1H330a.2.2,0,0,0,0,.2h-.1s0-.1,0-.1h-.4c0,.1.1.1.1.1h-.3l-.2-.2A.4.4,0,0,1,329.1,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.2,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,551.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,550.1l.2-.2h0c0,.1,0,0,0,.1H328s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.3 551.7 329.3 551.7 329.3 551.7 329.3 551.7 329.3 551.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550.1h0S328,550.1,328,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.1,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,550h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.1 550.1 328.1 550.1 328.1 550.1 328.1 550.1 328.1 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.2,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.2,550.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.1 550 328.1 550 328.1 550 328.1 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.7 549.5 327.7 549.5 327.7 549.5 327.7 549.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,551.1h.2v.2h-.1S329,551.1,329.1,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.4,550.1h.3a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,328.4,550.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.2,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.3h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.3 550 328.3 550 328.3 550 328.3 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "327.8 549.4 327.8 549.4 327.8 549.4 327.8 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.2h0S328.5,550.2,328.5,550.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.5,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M328.6,550.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.5 550.2 328.5 550.2 328.5 550.2 328.5 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.9 550.7 328.9 550.7 328.9 550.7 328.9 550.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "328.5 550.2 328.5 550.2 328.5 550.2 328.5 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "328.9 550.6 328.9 550.6 328.9 550.6 328.9 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,552h.1C330.9,552.2,330.8,552.1,330.8,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.6,550.5h.2s0,0,0,.1h-.1A.1.1,0,0,1,329.6,550.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "315.1",
      "y": "549.1",
      "width": "8.3",
      "height": "4.23",
      "transform": "translate(-315.5 498.1) rotate(-55.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.8,546.9h.2c.2-.1.3.1.5.1s.1.1.1.1h0c0,.1.2.1.3.2h-.2v.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,.1.2h.1c.1.1,0,.2.1.3h-.1s0,.1,0,.1h.2c-.1,0-.2-.2-.4-.2h-.1c-.1.1,0,.3-.1.4a1.1,1.1,0,0,0-.2-.4c0,.1,0,.2,0,.3a1,1,0,0,1,0-.4h-.4c-.1,0-.1.2-.2.1s.1-.1.1-.2,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.2s-.1-.5-.1-.7S319.6,547,319.8,546.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320 547 320 547 320 547 320 547"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.7,549.3v.2h-.2C318.6,549.4,318.6,549.3,318.7,549.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.1 547.2 320.1 547.2 320.1 547.2 320.1 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.2 547.1 320.2 547.1 320.2 547.1 320.2 547.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 547.2 320.3 547.2 320.3 547.2 320.3 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 547.2 320.3 547.2 320.3 547.2 320.3 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.4 547.2 320.4 547.1 320.4 547.2 320.4 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 547.3 320.3 547.3 320.3 547.3 320.3 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,549l.2-.2h0l-.2.2S319.1,549,319.2,549Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.5 547.1 320.5 547.1 320.5 547.1 320.5 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.3,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,547.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.9 548.2 319.9 548.2 319.9 548.2 319.9 548.3 319.9 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.1,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,553.6h.2c-.1.1,0,.1,0,.2l.2.3H317c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.1,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.1,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,553l.5-.2h-.7C317.2,553,317.3,553,317.4,553Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.1,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319,551.5l.2.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.5h-.3c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0v-.3a.8.8,0,0,0,0-.3c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2-.1-.2h-.1a.3.3,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.2,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.7,551.3h.1a.1.1,0,0,1,0,.1h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.7,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.1c.1,0,.2.1.3.2s.1.2,0,.3h-.3s0,.1,0,.1h0s0,.1,0,.1h0c0,.1.2.1.2.2h-.1a.4.4,0,0,1-.2-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "319.8",
      "y": "551.4",
      "height": "0.02",
      "transform": "translate(-312.9 473.8) rotate(-52.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,549.4s0,0,0,0S321.3,549.4,321.3,549.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,549.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.4 549.4 321.4 549.4 321.5 549.4 321.5 549.4 321.4 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.5 549.3 321.5 549.3 321.6 549.3 321.5 549.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322 548.7 322 548.6 322 548.6 322 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.5,550.9a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,549.8c.1.1.1.2.1.3h-.4c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.6,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,549.9h.1s0,0,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,550h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.5 549.6 321.5 549.6 321.6 549.6 321.5 549.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.2 548.7 322.1 548.7 322.2 548.7 322.2 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,550h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 549.9 321.4 549.9 321.4 549.9 321.4 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.9 550.6 320.9 550.6 320.9 550.6 320.9 550.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 549.9 321.4 549.9 321.4 549.9 321.4 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321 550.6 321 550.5 321 550.6 321 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.6,549.6h0S321.6,549.6,321.6,549.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.9,553.6h.1c0,.1,0,.2-.1.3h-.1v-.2C319.7,553.7,319.7,553.6,319.9,553.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,551.5h.1a.2.2,0,0,1-.1.2h-.2C321.2,551.6,321.3,551.5,321.4,551.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "314.8",
      "y": "559.4",
      "width": "7.2",
      "height": "3.66",
      "transform": "translate(-54.7 34.8) rotate(-5.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,559.2h.2c.1.1.1.3.2.4s0,.1,0,.1h0c-.1.1.1.2,0,.3s-.1-.2-.1-.1v.2h-.1v.2h0c0,.1-.1.1-.1.2s0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h0c0,.1,0,.1,0,.2h0c-.1-.1,0-.3-.1-.4H321l-.3.2.2-.3h-.2l.2-.2V560h.1s.1,0,.1-.1h-.2l.4-.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.4 321.6 559.4 321.6 559.4 321.6 559.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,559.8a.1.1,0,0,1,0,.2h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 559.6 321.5 559.5 321.5 559.6 321.5 559.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.7 559.6 321.6 559.5 321.7 559.5 321.7 559.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.7 321.6 559.7 321.6 559.7 321.6 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.7 321.6 559.7 321.6 559.7 321.6 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.7 559.7 321.7 559.7 321.7 559.7 321.7 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 559.8 321.6 559.7 321.6 559.7 321.6 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.8,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.8 559.8 321.8 559.7 321.8 559.7 321.8 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.7,559.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.7 560 320.7 560 320.7 560 320.7 560 320.7 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.4,561c.1.1,0,.1,0,.2h-.1v.3s0-.1,0-.1h-.3c.2-.1.1-.3.2-.5s.1-.2.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.9,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,561l.4.3s0,.1,0,.1h-.1l-.4-.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,560.6h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,561.2c0,.1,0,.1,0,.2H318a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1,0,.1h-.1c-.2-.1-.2.2-.4.1s-.1-.1-.1-.2h-.4l.4-.4s.1-.1,0-.1h.3l.2-.2h-.2a0,0,0,0,1,0-.1s.2-.1.1-.2-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,561.5c-.1,0,0,0,0,0S316.8,561.5,316.7,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.6,561.7h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.5,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.5c.1.1,0,.2.1.3s-.1.1-.2.2h0s0,0,0-.1h0s.1-.1,0-.1h.1a.3.3,0,0,0,0-.2s0,0,0,.1h-.1s0,.1,0,.1,0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2,0,.2s0-.1,0-.1a.4.4,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.5 561.7 318.5 561.7 318.5 561.7 318.5 561.7 318.5 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.9,561.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,561.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.8 561.6 320.8 561.6 320.8 561.7 320.8 561.7 320.8 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.7,561.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.9 561.7 320.9 561.7 321 561.7 320.9 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.6 561.6 321.6 561.6 321.6 561.6 321.6 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.3,561.9a.2.2,0,0,1-.1.2V562h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,561.9c0,.1-.1.2-.1.3h-.1V562a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,561.9h0c0,.1,0,.2,0,.2h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.7 561.9 320.8 561.8 320.7 561.9 320.7 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.7 561.8 321.6 561.8 321.7 561.8 321.7 561.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.4,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.1,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.5 561.9 320.5 561.9 320.5 561.9 320.5 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.8 562 319.8 562 319.8 562 319.8 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.5 561.9 320.5 561.9 320.5 561.9 320.5 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.8 562 319.8 562 319.8 562 319.8 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.2,563s0,.1,0,.2h-.3c0-.1,0-.1,0-.2S317.1,562.9,317.2,563Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,562.8c0,.1,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "315.4",
      "y": "550.1",
      "width": "3.9",
      "height": "7.71",
      "transform": "translate(-313.1 453.2) rotate(-51.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,553.2c0-.1-.1-.2,0-.2s.1-.3.2-.4h.1s0,.1.1.1.1-.2.2-.2-.1.2,0,.2h.8V552h.1c0,.1-.1.1-.1.2h.1v-.2h0c0,.1-.2.2-.2.3h0v.4c0,.1.2.1.1.2h-.3s0,0,0,0h-.2c0,.1.1,0,.1.1h-.6C313.6,553.5,313.4,553.4,313.4,553.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.5 553 313.5 553.1 313.5 553 313.5 553"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.5,554.4h.2C315.6,554.5,315.5,554.4,315.5,554.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.7 552.9 313.6 552.9 313.6 552.9 313.7 552.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.5 552.8 313.5 552.9 313.5 552.8 313.5 552.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.7 552.8 313.6 552.8 313.6 552.8 313.7 552.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.7 552.7 313.7 552.7 313.7 552.7 313.7 552.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 552.6 313.6 552.7 313.6 552.6 313.6 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.8 552.7 313.8 552.8 313.8 552.8 313.8 552.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553.9l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 552.6 313.6 552.6 313.6 552.6 313.6 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.2,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.2,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.1,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.5,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.8,552.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.6 553.2 314.6 553.2 314.6 553.2 314.6 553.2 314.6 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,556.4v-.2h.2l.3-.2h.3c-.2-.1-.3.2-.5.2s-.3,0-.3-.1S319.4,556.5,319.4,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.8,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.2,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.9,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.2,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.9,555.9a1.3,1.3,0,0,1-.1-.5h.1a3,3,0,0,0,.1.5s0,.1,0,.1S318.9,555.9,318.9,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,554.2l.2-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.2c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.2,0,.2-.1.2.1.1.1.1h-.6v.2c0,.1-.1.1,0,.1h-.1c0-.1,0-.1,0-.2H318c0,.1.2,0,.2.1h0c-.1,0-.2-.1-.2,0s0,.1-.1.1h-.3A.5.5,0,0,1,317.6,554.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.8,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.5,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.5,553.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.5,551.9c0-.1.1-.2.2-.3h0c0,.1-.1,0,0,.1h0v.2h.1c-.1,0,.1.1,0,.1h.5s-.1,0-.1.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.6 553.6 317.6 553.6 317.6 553.5 317.6 553.5 317.6 553.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.8,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.7,551.8h0S315.7,551.8,315.7,551.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.8 551.9 315.8 551.9 315.8 551.8 315.8 551.8 315.8 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.9,551.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.7 551.7 315.7 551.8 315.7 551.7 315.7 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.1 551.3 315.1 551.3 315.1 551.3 315.1 551.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.8,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.2,552.8h.3a.3.3,0,0,1-.1.2h-.1C317.2,552.9,317.1,552.9,317.2,552.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,551.9h.4a.3.3,0,0,0,0,.2h-.3A.1.1,0,0,1,316.1,551.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.9,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.8,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.2,552h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316 551.8 316 551.8 316 551.8 316 551.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "315.2 551.1 315.2 551.2 315.2 551.1 315.2 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,552h0S316.3,552,316.3,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.2,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,552h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.2 551.9 316.2 551.9 316.2 551.9 316.2 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 552.4 316.8 552.4 316.8 552.4 316.9 552.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.3 551.9 316.2 551.9 316.2 551.9 316.3 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.8 552.3 316.8 552.4 316.8 552.3 316.8 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.4,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.6,553.6h.2C319.7,553.8,319.5,553.7,319.6,553.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.8,552.1h.3s0,.1,0,.1h-.1C317.8,552.2,317.7,552.1,317.8,552.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "317.3",
      "y": "548.5",
      "width": "7.9",
      "height": "4.02",
      "transform": "translate(-314.4 503.5) rotate(-55.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,546.4h.2c.2-.1.3.1.4.1s.1.1.1.1h0c0,.1.2.1.3.2h-.2v.2h.1s0,0,0,.1h-.1v.2h.1c.1.1,0,.2.1.2h-.1s0,.1,0,.1h.2c-.1,0-.2-.2-.4-.2h-.1c-.1.1,0,.3,0,.4a1.1,1.1,0,0,0-.1-.4c0,.1,0,.2,0,.3a1,1,0,0,1,0-.3h-.4c-.1,0-.1.2-.1.1s.1-.1.1-.2,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.7S321.5,546.5,321.7,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.9 546.5 321.9 546.4 321.9 546.4 321.9 546.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,548.6h-.1C320.5,548.7,320.6,548.6,320.7,548.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 546.6 322 546.6 322 546.6 322 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 546.5 322.1 546.5 322.1 546.5 322.1 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 546.6 322.2 546.6 322.2 546.6 322.2 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 546.6 322.2 546.6 322.2 546.6 322.2 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.3 546.6 322.3 546.6 322.3 546.6 322.3 546.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 546.7 322.2 546.7 322.2 546.8 322.2 546.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.1,548.4l.2-.2h0l-.2.2S321.1,548.4,321.1,548.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.4 546.6 322.3 546.6 322.3 546.6 322.4 546.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.2,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.2,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.9,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,546.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.8 547.6 321.8 547.6 321.8 547.6 321.8 547.6 321.8 547.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.9,552.8h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s0,.2,0,.2-.2-.3-.2-.5-.1-.3.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.3,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.3,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,552.2l.5-.2h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,550.7h.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.4h-.5c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0v-.2a.8.8,0,0,0,0-.3c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2-.1-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,550.6h.1s0,.1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.7,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,548.5c.1,0,.2.1.3.2s.1.2,0,.3h-.3s0,.1,0,.1h0s0,.1,0,.1h0l.2.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.7 550.7 321.7 550.7 321.7 550.7 321.7 550.7 321.7 550.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,548.7s0,0,0,0S323.2,548.7,323.2,548.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,548.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.3 548.7 323.3 548.7 323.3 548.7 323.3 548.7 323.3 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.4 548.6 323.4 548.6 323.4 548.6 323.4 548.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.8 548 323.8 548 323.8 548 323.8 548"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,550.2a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,549.1c.1.1.1.2.1.3H323c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.2h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.4 548.9 323.4 548.9 323.4 548.9 323.4 548.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324 548.1 324 548.1 324 548.1 324 548.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 549.2 323.3 549.2 323.3 549.2 323.3 549.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 549.9 322.8 549.8 322.8 549.8 322.8 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 549.2 323.3 549.2 323.3 549.2 323.3 549.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.9 549.8 322.9 549.8 322.9 549.8 322.9 549.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,548.9h0S323.4,548.9,323.5,548.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.8,552.7h.1c0,.1,0,.2-.1.3h-.3C321.6,552.9,321.7,552.7,321.8,552.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,550.7h.1a.2.2,0,0,1-.1.2h-.2C323.1,550.8,323.1,550.7,323.2,550.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "309.5",
      "y": "543.3",
      "width": "3.7",
      "height": "7.22",
      "transform": "translate(-108.8 78.4) rotate(-12.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,549.8s0,.2-.1.2-.2.1-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.1-.2h-.2a.4.4,0,0,1,0-.1h-.4c0-.1-.2-.2-.2-.3h.3V549l.2.2.3-.2c0-.1-.1-.1,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.3A.6.6,0,0,1,313.8,549.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 549.9 313.6 549.9 313.6 549.9 313.6 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,547.7h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,312.9,547.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 549.8 313.4 549.8 313.4 549.8 313.4 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 550 313.4 550 313.4 550 313.4 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 549.9 313.3 550 313.3 550 313.3 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 550 313.3 550 313.3 550 313.3 550"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 550.1 313.3 550 313.3 550.1 313.2 550.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 549.9 313.2 549.9 313.2 549.9 313.2 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.8,548.1a.8.8,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 550.1 313.3 550.1 313.2 550.1 313.2 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,548.3h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.9,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,550h0S313.1,550,313.1,550Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 549.1 312.9 549.1 312.9 549.1 312.9 549.1 312.9 549.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,543.9h-.5c.1-.1,0-.1,0-.2v-.2c.1.2.3,0,.5.2s.2.1.2.3S311.3,543.9,311.3,543.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,544.6l-.2.4H311s0-.1,0-.1l.2-.4h.1C311.4,544.5,311.3,544.6,311.3,544.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,546.6H311c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2h-.3s0-.1,0-.1h-.3s0,0,0-.1H310c0-.2-.2-.2-.2-.4h.2c.1-.1,0-.1,0-.2h.1c-.1,0,0-.1-.1-.2l.4.3h.1v-.2h.1s-.1.1,0,.2v.4h.2c.1-.1-.1-.1-.1-.2h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.9,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,547.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311,547.1h0S311,547.1,311,547.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.4,549.5h-.3l-.2-.2h.3s0,0,0,0h.1s0,.1,0,.1h.1C311.4,549.3,311.4,549.4,311.4,549.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.9 547.1 310.9 547.1 310.9 547.1 310.9 547.1 310.9 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.4,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.3,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,549.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.2 549.4 311.2 549.4 311.2 549.4 311.2 549.4 311.2 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.2,549.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.2 549.5 311.2 549.5 311.2 549.5 311.2 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.3 550.2 311.4 550.2 311.4 550.2 311.3 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.2,549.4s0,0,0,0S311.2,549.4,311.2,549.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.8,547.9h0C310.8,547.8,310.9,547.8,310.8,547.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,549.2h-.3s0-.1,0-.1v-.2h.1c.1,0,0,.1.1.2A.1.1,0,0,1,311,549.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311,549h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,548.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311 549.3 311 549.3 311 549.3 311 549.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.2 550.2 311.2 550.2 311.2 550.2 311.2 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,549.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,548.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.9 549.1 310.9 549.1 310.9 549.1 310.9 549.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.8 548.3 310.8 548.3 310.8 548.4 310.8 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.9 549.1 310.9 549.1 310.9 549.1 310.9 549.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.7 548.4 310.8 548.4 310.8 548.4 310.7 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,549.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.9,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.5,545.9h-.2c-.1-.1-.2-.1-.1-.2h.2C309.5,545.7,309.6,545.8,309.5,545.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.9,548.1h0A.1.1,0,0,1,309.9,548.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "310.4",
      "y": "538.3",
      "width": "3.6",
      "height": "7.04",
      "transform": "translate(-175 149.8) rotate(-21.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,539.4c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1h.3c0,.1-.1.1-.1.2h1l-.3.2h0c0,.1.2.1.3.2h-.3l.2.2h-.3l-.3.2c0,.1.1.1,0,.2s0-.1-.1-.2h-.3c-.1.1.1.1.1.1l-.5-.2C309.5,539.7,309.4,539.6,309.4,539.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.6 539.3 309.6 539.3 309.6 539.3 309.6 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.6,541.3h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,310.6,541.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.8 539.3 309.8 539.3 309.8 539.3 309.8 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.8 539.2 309.7 539.2 309.8 539.2 309.8 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539.2 309.9 539.2 309.9 539.2 309.9 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539.2 309.9 539.2 309.9 539.2 309.9 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539.1 309.9 539.1 309.9 539.1 309.9 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310 539.2 310 539.2 310 539.2 310 539.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.6,540.8v-.2h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.9 539 309.9 539 309.9 539 309.9 539"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,540.7h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.3,539.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.1,539.1h0S310.1,539.1,310.1,539.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "310.4 540 310.4 540 310.4 540 310.4 540 310.4 540"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.5,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.8,544.7h.5c0,.1,0,.1.1.2h.1c-.1-.1-.3,0-.5-.1s-.2-.1-.2-.2S312.8,544.7,312.8,544.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.9,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.6,544a1.2,1.2,0,0,1,.1-.4h.1s0,.1,0,.1v.4h-.1C312.5,544.1,312.6,544.1,312.6,544Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.1,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,542.1h.4c0,.1.1.1,0,.1h.1c0-.1.1-.1.1-.2h.3s0-.1,0-.1h.3s0,0,0,.1h.1c0,.2.2.2.2.3h-.2c-.1.1,0,.1,0,.2h-.1v.2l-.4-.3h-.1v.2H313c-.1,0,0-.1,0-.2v-.4h-.2c-.1.1.1.1.1.2h-.3a.3.3,0,0,1-.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.6,541.5h0A.1.1,0,0,1,312.6,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,541.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.8,539.4h.1c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C311.8,539.5,311.8,539.4,311.8,539.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.6 541.6 312.6 541.6 312.6 541.6 312.6 541.6 312.6 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.4h0S311.9,539.4,311.9,539.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.9,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.9,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312 539.4 312 539.4 312 539.4 312 539.4 312 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312,539.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312 539.3 311.9 539.3 312 539.3 312 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.7 538.7 311.7 538.7 311.7 538.7 311.7 538.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.6,540.8h0C312.6,540.9,312.6,540.9,312.6,540.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,539.6h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,312.2,539.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.8h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 539.5 312.2 539.4 312.2 539.4 312.2 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.9 538.6 311.8 538.6 311.9 538.6 311.9 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.8,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,539.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.3 539.6 312.3 539.7 312.3 539.6 312.3 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.6 540.3 312.6 540.3 312.6 540.3 312.6 540.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.3 539.7 312.3 539.7 312.3 539.7 312.3 539.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.6 540.3 312.6 540.3 312.6 540.3 312.6 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.2,542.5h.2c.1,0,.2.1.2.2h-.2C314.2,542.7,314.1,542.6,314.2,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,540.5h0A.1.1,0,0,1,313.4,540.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "310.9",
      "y": "535.8",
      "width": "7.2",
      "height": "3.69",
      "transform": "translate(-202.1 189.7) rotate(-25.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,534.6h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.2.1.3h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,0,.2h0c0,.1-.1.1,0,.2v.2h-.2v.2h0c-.1-.1-.1-.3-.2-.3h-.1c-.1,0-.1.2-.2.3a1,1,0,0,0,0-.4l-.2.2v-.3l-.2-.3h0s.1-.1,0-.1h-.2c.1-.2.1-.4.2-.6S316.5,534.6,316.7,534.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.8 534.7 316.8 534.7 316.8 534.7 316.8 534.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.9,535.9a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.9 535 316.9 534.9 316.9 534.9 316.9 535"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 534.9 317 534.9 317 534.9 317 534.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 535 317 535 317 535 317 535"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 535 317 535 317 535 317 535"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.1 535.1 317.1 535 317.1 535 317.1 535.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317 535.1 316.9 535.1 316.9 535.1 317 535.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,535.9h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.1 535 317.1 535 317.1 535 317.1 535"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.5,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.4,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.5,535.9s0,0,0,0S315.5,535.9,315.5,535.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.3,535.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.1,535.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.2 535.6 316.2 535.6 316.2 535.6 316.2 535.6 316.2 535.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,535.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.6,538.4v.2h-.1a1.2,1.2,0,0,0,0,.3h-.3v.2c.1-.2,0-.3.1-.5s.1-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.2,536.2s0,0,0,.1S316.1,536.2,316.2,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,536.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,538.2h.5s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.3h0S316.1,536.3,316.1,536.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,536.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.2,537.7c.1,0,0,.1.1.2v.2c-.1,0-.1.1-.1.1s-.1.1,0,.1h.4s0,.1,0,.1h0s0,.1,0,.1h-.1s-.1.1,0,.1h-.1c-.2,0-.2.2-.3.3v-.2h-.4c.1-.1.1-.3.2-.5s0-.1,0-.1h.3v-.2c-.1-.1-.1.1-.2.1h0c0-.1.1-.1.1-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313,538.4c-.1,0,0,0,0,0S313,538.4,313,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,538h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537c.1,0,.1.2.2.3s0,.2-.1.3,0-.1,0-.1h0s0-.1,0-.1h.1V537s0,0,0,.1h0c0,.1.1,0,0,.1s0-.1,0-.1h0s0,.1,0,.1h0c0,.1.1.1,0,.2h-.1a.4.4,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.7 538 314.8 538 314.8 538 314.8 538 314.7 538"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.9,537h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.9,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.9,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.8,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 537.2 316.9 537.2 316.9 537.2 316.9 537.2 316.9 537.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.9,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.8,537.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317 537.2 317 537.1 317 537.2 317 537.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.7 536.9 317.7 536.8 317.7 536.8 317.7 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.9,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.5,538a.2.2,0,0,1,0,.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,537.4c.1.1,0,.2,0,.3h-.3a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,537.5h0s0,.2.1.1h0s0,0,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,537.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 537.4 316.9 537.4 316.9 537.4 316.9 537.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.7 537 317.7 537 317.7 537 317.7 537"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,537.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,537.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.7,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.4,538.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.7,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,537.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.7 537.5 316.7 537.5 316.7 537.5 316.7 537.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316 537.9 316 537.9 316 537.9 316 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316.7 537.6 316.7 537.6 316.7 537.5 316.7 537.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.1 537.9 316.1 537.9 316.1 537.9 316.1 537.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.9,539.7c.1,0,.1.1.1.2s-.1.2-.2.2h-.1c0-.1-.1-.1,0-.2S313.8,539.6,313.9,539.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.9,538.8c.1,0,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "310.5",
      "y": "531.4",
      "width": "6.3",
      "height": "3.24",
      "transform": "translate(-303 580) rotate(-63.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,536.3H313v-.2h0v-.2h-.1c-.1,0,0-.1-.1-.2h.2s0,0,0-.1h.1c.1-.1,0-.2,0-.3l.2.3c0-.1,0-.2,0-.2v.3h.3s0-.1.1-.1-.1.1-.1.1,0,.1,0,.1h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.2.3.2.5S313.9,536.2,313.8,536.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.6 536.2 313.6 536.2 313.6 536.3 313.6 536.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,534.4h.1A.1.1,0,0,1,314.3,534.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 536.1 313.5 536.1 313.5 536.1 313.4 536.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.4 536.2 313.4 536.2 313.4 536.2 313.4 536.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 536.1 313.3 536.2 313.3 536.2 313.3 536.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 536.1 313.3 536.1 313.3 536.1 313.3 536.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 536.2 313.2 536.2 313.2 536.2 313.2 536.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.3 536.1 313.3 536 313.3 536 313.3 536.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314,534.6v.2h0v-.2S314,534.6,314,534.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 536.2 313.2 536.2 313.2 536.2 313.2 536.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,535.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,536.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.5 535.3 313.5 535.3 313.5 535.3 313.5 535.3 313.5 535.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,535.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.2,530.9H315c0-.1,0-.1,0-.1l-.2-.2h.1c.1,0,.1-.1.1-.1s0-.1,0-.2.2.2.2.4.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,535.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,535.1s0,0,0,0S313.1,535.1,313.1,535.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.9,531.4l-.4.2h0l.4-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,532.7h-.2v-.2c.1,0,0-.1.1-.1s0-.1,0-.1H313c.1-.1,0-.2.1-.4h.4c0-.1.1-.1.1-.2s.1.3.1.4h.1c-.1.1,0,.1-.1.2v.2c.1,0,0-.1.1-.2h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,531.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,532.9h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.3,532.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,534.8H312c0-.1-.1-.1-.1-.2h.1s0,.1,0,.1h.2s0,0,0-.1h-.1a.3.3,0,0,1,.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.2 532.9 313.2 532.9 313.2 532.9 313.2 532.8 313.2 532.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 534.6 312.2 534.6 312.2 534.6 312.2 534.6 312.2 534.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.1 534.7 312.1 534.7 312.1 534.7 312.1 534.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.9 535.2 311.9 535.2 311.9 535.3 311.9 535.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.7,533.3a.2.2,0,0,1-.1-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,534.3c-.1,0-.1-.1-.1-.2h.3c0,.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,534.1h0S312.3,534.1,312.3,534.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.1 534.4 312.1 534.5 312.1 534.5 312.1 534.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.7 535.2 311.7 535.2 311.7 535.2 311.7 535.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.7,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,534.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.1 534.2 312.2 534.2 312.2 534.3 312.1 534.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.4 533.6 312.5 533.7 312.4 533.7 312.4 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.2 534.2 312.2 534.2 312.2 534.2 312.2 534.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.4 533.7 312.4 533.7 312.4 533.7 312.4 533.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.5,535.1h0S311.5,535.1,311.5,535.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,531.2h-.1c0-.1,0-.2,0-.2h.2C313,531.1,313,531.2,312.9,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312,533h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,312,533Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "316.7",
      "y": "525.3",
      "width": "4.2",
      "height": "8.29",
      "transform": "translate(-272.9 351) rotate(-42.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,528c0-.1-.1-.2,0-.2s.2-.3.2-.4h.2c.1,0,0,.1,0,.1s.1-.2.2-.2-.1.2,0,.2h.9v-.2h.1c0,.1-.1.1-.1.2h.1V527h0c-.1.1-.3.2-.3.3h-.1l-.2.3c0,.1.2.1.1.2h-.3s0,0,0,0h-.1s0,.1,0,.1h-.1c0,.1.1.1.1.1h-.7C315,528.3,314.8,528.2,314.7,528Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.9 527.8 314.9 527.8 314.9 527.8 314.9 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,529.5h.2v.2h-.1C316.8,529.7,316.8,529.6,316.8,529.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.7 315.1 527.7 315.1 527.7 315.1 527.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315 527.6 315 527.6 315 527.6 315 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.5 315.1 527.5 315.1 527.5 315.1 527.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.5 315.1 527.5 315.1 527.5 315.1 527.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.4 315.1 527.4 315.1 527.4 315.1 527.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.2 527.5 315.2 527.5 315.2 527.5 315.2 527.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.6,529l-.2-.2h.1l.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "315.1 527.3 315.1 527.3 315.1 527.3 315.1 527.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,528.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.5,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.9,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M315.3,527.3h0S315.3,527.3,315.3,527.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "316 528.2 316 528.2 316.1 528.1 316.1 528.1 316 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.1,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,532.4v-.2h.4c0,.1.1.1.1.2h.2c-.2-.1-.4.2-.6.1s-.3,0-.3-.1S320.6,532.4,320.6,532.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M316.4,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,531.7a1.4,1.4,0,0,1,0-.6h.1a3.2,3.2,0,0,0,0,.5s0,.1,0,.1S320.1,531.7,320.2,531.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.8,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319,529.7h.4c0,.1.2,0,.1.1h.1c0-.1.1-.2,0-.3h.1c.1,0,0-.1,0-.1h.2c0-.1-.1-.1,0-.1h.6s0,.1,0,.1.3.1.4.3-.1.2-.2.2.1.1.1.2h-.7a.3.3,0,0,0,0,.2c0,.1-.1.1-.1.1s0-.1-.1-.2,0-.1,0-.2l-.2-.2h-.3c0,.1.2.1.2.2h-.1c-.1,0-.2-.1-.2,0h-.1l-.3-.2A.5.5,0,0,1,319,529.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,530.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.1,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.1,529h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,526.9c0-.2.2-.2.3-.3h0c0,.1-.1,0,0,.1h0l-.2.2h.1c-.1,0,.1.1,0,.1h.4l-.4.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.1 529 319.1 529 319.2 529 319.2 529 319.1 529"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.4,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.9h0S317.4,526.9,317.4,526.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.5,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,526.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.5 526.9 317.5 526.9 317.5 526.9 317.5 526.9 317.5 526.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.5 526.8 317.4 526.8 317.5 526.8 317.5 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "316.9 526.2 316.9 526.2 316.9 526.2 316.9 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.8,528.2h.3v.2h-.1C318.8,528.3,318.8,528.2,318.8,528.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,527h.4a.3.3,0,0,0-.1.2h-.1c-.1,0-.1-.1-.2-.1A.1.1,0,0,1,317.9,527Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.6,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527.1h.1s0-.1,0-.1H318Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.8 526.8 317.7 526.8 317.8 526.8 317.8 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.1 526 317 526.1 317 526 317.1 526"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527.1h0S318.1,527.1,318,527.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.1,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318 527 318 527 318 527 318 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318.6 527.6 318.6 527.7 318.6 527.6 318.6 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318 527 318 527 318 527 318 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318.6 527.6 318.5 527.6 318.6 527.6 318.6 527.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.8,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.3,529.4h.1c.1,0,.2,0,.3.1a.2.2,0,0,1,0,.1h-.2C321.4,529.6,321.2,529.5,321.3,529.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.6,527.4h.3s0,.1,0,.1h-.2A.1.1,0,0,1,319.6,527.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "319.6",
      "y": "521.7",
      "width": "3.5",
      "height": "6.88",
      "transform": "translate(-211.7 833.3) rotate(-88.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.5,523.5h.1c.1.1.1.3.1.4s0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2v.2h-.1v.2h0v.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h0c0,.1,0,.1,0,.2h0c0-.1,0-.3-.1-.4h-.1l-.3.2.2-.3h-.2l.2-.2a.8.8,0,0,0-.1-.3h0l.4-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 523.7 324.6 523.7 324.6 523.7 324.6 523.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,523.9a.1.1,0,0,1-.1.1h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 523.9 324.5 523.9 324.5 523.9 324.5 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 523.9 324.6 523.9 324.6 523.9 324.6 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 524 324.6 524 324.6 524 324.6 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 524.1 324.6 524.1 324.6 524.1 324.6 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 524.1 324.7 524.1 324.7 524.1 324.7 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.5 524.1 324.5 524.1 324.5 524.1 324.5 524.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,524.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 524.1 324.7 524.1 324.7 524.1 324.7 524.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,524.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,524.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 524.2 323.7 524.2 323.7 524.2 323.7 524.2 323.7 524.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.5,524.6c0,.1,0,.1,0,.2h-.1l-.2.3s0-.1,0-.1h-.3c.2-.1.1-.3.3-.4s.2-.2.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.7,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,524.7l.4.3s0,.1,0,.1h-.1l-.3-.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,524.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,525.1c0,.1,0,.1,0,.2h-.2a.1.1,0,0,0,0,.1h-.1s-.1.1,0,.1h-.1c0,.1-.1.1,0,.1h0c-.2-.1-.2.1-.4.1s-.1-.2,0-.2h-.3l.4-.3s.1-.1,0-.1h.3a0,0,0,0,1,0-.1s.2,0,.1-.1-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.7,525.2c-.1,0,0,0,0,0S319.7,525.2,319.7,525.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.5,525.6h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.7c.1.1,0,.2,0,.3l-.2.2h.1s.1,0,0-.1h.1c-.1,0,0,0,0-.1h0a.3.3,0,0,0,0-.2h-.1s0,.1,0,.1,0,0,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s0-.1,0-.1a.4.4,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 525.6 321.4 525.6 321.4 525.6 321.4 525.6 321.4 525.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,525.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,525.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.6 525.8 323.6 525.8 323.6 525.9 323.6 525.9 323.6 525.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,525.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.7 525.9 323.7 525.9 323.7 525.9 323.7 525.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.4 525.9 324.4 525.9 324.4 525.9 324.4 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,525.9a.2.2,0,0,1-.2.2v-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,526c0,.1-.1.2-.2.2h-.1v-.2a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0c0,.1-.1.1,0,.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,526h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.5 526 323.5 526 323.5 526 323.5 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.4 526 324.4 526 324.4 526 324.4 526"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.9,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,526h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.3 526.1 323.3 526 323.3 526 323.3 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 526 322.5 526 322.5 526 322.5 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.2 526.1 323.2 526.1 323.2 526.1 323.2 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.6 526.1 322.6 526 322.6 526.1 322.6 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,526.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320,526.7s0,.1,0,.2h-.3s0-.1,0-.2S319.9,526.6,320,526.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,526.8c0,.1,0,.1,0,.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "320.2",
      "y": "517.8",
      "width": "7.5",
      "height": "3.85",
      "transform": "translate(-286.6 472) rotate(-53.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,523.7h-.2c-.2,0-.3-.1-.4-.1s-.1-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2V523h-.1s0,0,0-.1h.1v-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0,0,0-.1h-.1l.3.2h.1c.1-.1,0-.3.1-.4a1,1,0,0,0,.1.4c0-.1,0-.2.1-.2a.9.9,0,0,1,0,.3h.3c.1,0,.1-.2.1-.1v.2s0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.1.4.1.6S323.6,523.6,323.4,523.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.2 523.6 323.3 523.6 323.2 523.6 323.2 523.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,521.5h.1C324.6,521.5,324.5,521.5,324.4,521.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.1 523.4 323.1 523.4 323.1 523.4 323.1 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323 523.5 323.1 523.5 323 523.5 323 523.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323 523.4 323 523.4 323 523.4 323 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 523.4 322.9 523.4 322.9 523.4 322.9 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.8 523.4 322.9 523.4 322.9 523.4 322.8 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 523.3 323 523.3 323 523.3 322.9 523.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,521.8l-.2.2h0l.2-.2S324.1,521.8,324,521.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.8 523.4 322.8 523.4 322.8 523.4 322.8 523.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.7,523.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "323.4",
      "y": "522.4",
      "height": "0.02",
      "transform": "translate(-287.4 455.1) rotate(-52)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.3,517.6h-.2c.1-.1,0-.1,0-.2l-.2-.3h.1c.1,0,.1-.1.1-.2s0-.2,0-.2.2.3.2.5.1.3-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,519.5h-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.4s0-.1,0-.1h-.2c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.5v-.2c0,.2.1.4,0,.5s0,.1.1.1h0v.2a.8.8,0,0,0,0,.3c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,518.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.6,519.6h-.1a.1.1,0,0,1,0-.1h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.6c-.1,0-.2-.1-.3-.2s0-.2,0-.3h.3s0-.1,0-.1h0v-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.6 519.5 323.6 519.5 323.5 519.5 323.6 519.5 323.6 519.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,521.3s0,0,0,0S322.1,521.3,322.1,521.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,521.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322 521.4 322 521.4 322 521.4 322 521.3 322 521.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,521.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.9 521.4 321.9 521.5 321.9 521.5 321.9 521.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.4 522 321.4 522 321.4 522 321.4 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,520a.2.2,0,0,1-.1-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,521c-.1-.1-.1-.2-.1-.3h.4c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.9,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.8,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.9H322s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.2,520.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.9 521.1 321.9 521.2 321.9 521.2 321.9 521.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.3 521.9 321.3 521.9 321.3 521.9 321.3 521.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,520.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 520.9 322 520.9 322 520.9 322 520.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 520.3 322.5 520.3 322.5 520.3 322.5 520.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 520.9 322 520.9 322 520.9 322 520.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.4 520.3 322.4 520.3 322.4 520.3 322.4 520.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.8,521.1h0S321.8,521.1,321.8,521.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.5,517.6h-.1c0-.1,0-.2.1-.2h.2C323.7,517.5,323.6,517.6,323.5,517.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.1,519.4H322a.2.2,0,0,1,.1-.2h.2C322.3,519.4,322.2,519.5,322.1,519.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "318.1",
      "y": "513.8",
      "width": "7.4",
      "height": "3.78",
      "transform": "translate(-69.9 50.9) rotate(-8.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.9,513.3h.2c.2.1.1.3.2.4s0,.1,0,.1h0c-.1.1.1.2.1.3s-.1-.2-.2-.1v.2h-.1a.3.3,0,0,0-.1.2h0c0,.1-.1.1-.1.2s.1.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h0c0,.1,0,.1,0,.2h0c-.1-.1,0-.3-.1-.4h-.1c-.1,0-.2.2-.3.2l.2-.3H324l.2-.2-.2-.3h.1s.1,0,.1-.1H324l.4-.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.9 513.5 324.9 513.5 325 513.5 324.9 513.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,514.1a.1.1,0,0,1,0,.2h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.9 513.7 324.9 513.7 324.9 513.7 324.9 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.7 325 513.7 325 513.7 325 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.8 325 513.8 325 513.8 325 513.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.9 325 513.9 325 513.9 325 513.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 513.9 325.1 513.9 325.1 513.9 325.1 513.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 513.9 324.9 513.9 324.9 513.9 325 513.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,514.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.2 513.9 325.1 513.9 325.2 513.9 325.2 513.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M325.1,514.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 514.2 324.1 514.2 324.1 514.2 324.1 514.2 324.1 514.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,514.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.7,515.5c.1.1,0,.1.1.2h-.1v.3s0-.1,0-.1h-.4c.2-.1.1-.4.2-.5s.1-.2.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,514.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.9,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,514.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,515.5l.4.2s0,.1,0,.1h-.1l-.4-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,514.9h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.4,515.6c0,.1,0,.1,0,.2v.2h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1,0,.1h-.1c-.2,0-.2.2-.4.2s-.1-.1-.1-.2h-.4l.4-.4s.1-.1,0-.1h.3l.2-.2h-.3s.2-.1.1-.2-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320,515.9c-.1,0,0,0,0-.1S320.1,515.9,320,515.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,516h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.9,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,515.7c.1.1,0,.2.1.3s-.1.2-.2.2h0s0,0,0-.1h0s.1-.1,0-.1h.1a.3.3,0,0,0,0-.2s0,0,0,.1h-.1s0,.1,0,.1,0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2,0,.2s0-.1,0-.1a.4.4,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.9 516.1 321.9 516.1 321.9 516.1 321.9 516.1 321.9 516.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,515.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,515.9h0S324.3,515.9,324.4,515.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,515.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.3 515.9 324.3 515.9 324.3 516 324.3 516 324.3 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.2,516h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.4 516 324.4 515.9 324.4 516 324.4 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.1 515.9 325.1 515.8 325.1 515.8 325.1 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,516.3a.2.2,0,0,1-.1.2v-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324,516.2c0,.1-.1.2-.1.3h-.1v-.2a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.3,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0c0,.1,0,.2,0,.2h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "324.2 516.1 324.2 516.1 324.2 516.1 324.2 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "325.1 516 325.1 516 325.1 516 325.1 516"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324 516.2 324 516.2 324 516.2 324 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 516.3 323.2 516.3 323.2 516.3 323.2 516.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.9 516.2 323.9 516.2 324 516.2 323.9 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 516.4 323.2 516.3 323.2 516.3 323.2 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.2,516.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,517.5s0,.1,0,.2h-.3c0-.1,0-.1,0-.2S320.5,517.4,320.6,517.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,517.2c0,.1,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "311",
      "y": "514.3",
      "width": "7.1",
      "height": "3.61",
      "transform": "translate(-258.3 323.1) rotate(-40)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.2,519.6h-.2c-.2,0-.2-.1-.4-.2s0-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.3.3,0,0,0,0-.2h-.1c0-.1,0-.2,0-.2h.1s0,0,0-.1h-.1c.1.1.1.2.3.2h.1c.1-.1.1-.2.1-.3a1,1,0,0,0,0,.3c0-.1.1-.2.1-.2a.9.9,0,0,1,0,.3l.3.2h0s0,.1,0,.1h0s-.1.1,0,.1h.1c.1,0,0-.1.1-.1s0,.4-.1.6S313.3,519.5,313.2,519.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313 519.4 313 519.5 313 519.5 313 519.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,517.9a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 519.3 312.9 519.3 312.9 519.3 312.9 519.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 519.3 312.8 519.3 312.8 519.3 312.8 519.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 519.2 312.8 519.2 312.8 519.2 312.8 519.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.7 519.2 312.8 519.2 312.7 519.2 312.7 519.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.6 519.2 312.7 519.2 312.7 519.2 312.6 519.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 519.1 312.8 519.1 312.8 519.1 312.8 519.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.1,518h-.2s0,0,0-.1h.2S314.1,518,314.1,518Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.6 519.2 312.6 519.2 312.6 519.2 312.6 519.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314,518h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.1,518h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.3,518.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,519.1h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "313.3",
      "y": "518.4",
      "height": "0.02",
      "transform": "translate(-260.9 325.4) rotate(-40.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.2,518.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.1,514.7h-.1c.1,0,0-.1.1-.1a1.1,1.1,0,0,0-.1-.3h.3c0-.1,0-.1.1-.2s.1.3.1.5,0,.2-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313,518.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.9s0,0,0-.1S313.3,517.9,313.3,517.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.5,515.1H316s-.1,0,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,517.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,516v-.2a.3.3,0,0,1,0-.2c.1,0,0-.1.1-.1s.1-.1,0-.1h-.2s0,0,0-.1h-.2s0-.1,0-.1h-.1s0-.1,0-.1h.1c.2-.1.1-.3.2-.3l.2.2h.4c-.1.1,0,.3-.1.5s0,.1,0,.1h0l-.2.2a.7.7,0,0,0,0,.2c.1,0,.1-.1.2-.2h.1c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.8,515c.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.1,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.2,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.4c-.1,0-.2-.2-.2-.2s0-.2,0-.3h0s0,.1,0,0h0v.2h.1s0-.1,0-.1h-.1c0-.1-.1,0,0-.1h.1s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.4.4,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.2 515.8 314.2 515.9 314.2 515.8 314.2 515.8 314.2 515.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,517.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,517.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 517.2 312.3 517.2 312.3 517.1 312.3 517.1 312.3 517.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,517.1s0,0,0,0S312.4,517.1,312.3,517.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.4,517.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.2 517.2 312.2 517.2 312.2 517.2 312.2 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.7 517.6 311.7 517.7 311.7 517.7 311.7 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,516.1a.2.2,0,0,1,0-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.4,516.9c-.1-.1,0-.2,0-.3h.3c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,517.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.8h-.1s-.1,0,0-.1h.1s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 516.9 312.3 517 312.3 516.9 312.3 516.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.6 517.5 311.6 517.5 311.6 517.5 311.6 517.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,516.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,515.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,516.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.4 516.8 312.4 516.8 312.4 516.8 312.4 516.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "313 516.3 313 516.3 313 516.3 313 516.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.4 516.7 312.4 516.7 312.4 516.8 312.4 516.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.9 516.3 313 516.3 313 516.3 312.9 516.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,516.9h0S312.2,516.9,312.2,516.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.4,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,514.1h-.1c0-.1,0-.2.1-.2h.1s.1.1.1.2S314.7,514.1,314.5,514.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,515.4c-.1,0,0-.1-.1-.1h.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "308.1",
      "y": "509.4",
      "width": "7.8",
      "height": "3.99",
      "transform": "translate(-117 93.3) rotate(-14.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.1,514.2h-.2c-.2-.1-.2-.3-.2-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.4.4,0,0,0,.1-.2h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.2v-.2h.1c.1.1,0,.2.1.2h0c-.1-.1,0-.1-.1-.2h0c.1.1,0,.3.2.4h.1c.2,0,.2-.2.3-.3a1.1,1.1,0,0,0-.1.4l.2-.2-.2.3.2.3h0s-.1.1-.1.1h.2l-.3.6C309.4,514.2,309.2,514.3,309.1,514.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309 514 308.9 514 308.9 514 309 514"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.2,513.2a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309 513.8 309 513.8 309 513.8 309 513.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.8 513.8 308.8 513.8 308.8 513.8 308.8 513.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.8 513.7 308.8 513.7 308.8 513.7 308.8 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.8 513.7 308.8 513.7 308.8 513.7 308.8 513.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.7 513.6 308.7 513.7 308.7 513.6 308.7 513.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.9 513.6 308.9 513.6 308.9 513.6 308.9 513.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.8,513.1h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "308.7 513.6 308.7 513.6 308.7 513.6 308.7 513.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.7,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M310.6,513.1s0,0,0,0S310.6,513.1,310.6,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.6,513.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M308.7,513.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.8 513.2 309.8 513.2 309.8 513.2 309.8 513.2 309.8 513.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.6,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,511.2c-.1,0-.1-.1-.1-.2h.1a1.3,1.3,0,0,0,.1-.4h.4c-.2.1,0,.4-.2.5s-.1.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.5,512.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.6s0-.1,0-.1S310,512.6,310,512.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.6,512.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,511.3l-.5-.2s0-.1,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,512.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.4,511.4c-.1-.1,0-.2,0-.2V511c.1,0,.1-.1.2,0h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2,0,.2-.2.4-.2s.1.1.1.2h.4c-.1.1-.2.3-.3.4s-.1.1,0,.1h-.3l-.2.2c.1.1.1-.1.2-.1h0c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.8,511c.1,0,0,0,0,.1S313.8,511,313.8,511Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.8,511.1a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.9,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.3,511.6c-.1-.1-.1-.2-.1-.4s.1-.2.2-.2,0,.1,0,.1h0s0,0,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.2s0,.1.1.1a.4.4,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 511 311.8 511 311.8 511 311.8 511 311.9 511"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.4,511.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.3,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.5,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.3,511.5a0,0,0,0,1,0,0S309.3,511.5,309.3,511.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.2,511.5h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.4 511.4 309.4 511.4 309.4 511.4 309.4 511.4 309.4 511.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.4,511.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.5,511.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.3 511.4 309.3 511.4 309.2 511.4 309.3 511.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.5 511.6 308.5 511.6 308.5 511.6 308.5 511.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311,510.9a.3.3,0,0,1,.1-.3v.2H311Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.6,511.2c-.1-.1.1-.2.1-.3h.3a.1.1,0,0,1,0,.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.8,511.1h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.9,511.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "309.5 511.2 309.4 511.2 309.4 511.2 309.5 511.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "308.5 511.4 308.5 511.4 308.5 511.4 308.5 511.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.8,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.9,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.1,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M309.9,511s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.7 511.1 309.7 511.1 309.7 511.1 309.7 511.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.5 510.9 310.5 510.9 310.5 510.9 310.5 510.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "309.7 511.1 309.7 511.1 309.7 511.1 309.7 511.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "310.4 510.9 310.4 510.9 310.4 510.9 310.4 510.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.4,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.3,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.1,509.4s0-.1,0-.2h.3c0,.1.1.1,0,.2S313.2,509.5,313.1,509.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310.7,509.9c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "302.9",
      "y": "506.9",
      "width": "6.6",
      "height": "3.4",
      "transform": "translate(-256 699.2) rotate(-77.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.2,511.9h-.8s.1,0,0-.1h-.2s0,.1,0,.1H306v-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.3s0,0,0-.1h.1c0-.1-.1-.2-.1-.3l.2.2c-.1-.1,0-.2,0-.2v.3h.3s0-.1.1-.2,0,.1,0,.2h.2c.1,0,0-.1,0-.1l.3.5A.5.5,0,0,1,307.2,511.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "307 511.9 307 512 307 512 307 511.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.2,509.9h0A.1.1,0,0,1,307.2,509.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.8 511.9 306.8 511.9 306.8 511.9 306.8 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.8 512 306.8 512 306.8 512 306.8 512"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.7 511.9 306.7 511.9 306.7 511.9 306.7 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 511.9 306.7 511.9 306.6 511.9 306.6 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 512 306.6 512 306.6 512 306.6 512"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 511.8 306.6 511.8 306.6 511.8 306.6 511.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.9,510.2v.2h0v-.2S307,510.2,306.9,510.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.6 512 306.6 512 306.6 512 306.6 512"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.9,510.3h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.9,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.9,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.5,511.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.7 511 306.7 511 306.6 511 306.6 511 306.7 511"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.5,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.3,506.1h-.2c0-.1,0-.1,0-.1l-.2-.2h.1c.1,0,0-.1,0-.2s-.1-.1,0-.2.3.2.3.3.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.2,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.2,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307,506.7l-.3.3h0l.3-.2h.1C307.2,506.6,307.1,506.7,307,506.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.3,508.3H306c.1,0-.1-.1,0-.1h-.8c.1-.2-.1-.2,0-.4h.2c.1,0,.1-.1.1-.1h.1c0-.1.1-.1,0-.2s.2.3.2.4h.3c0,.1-.1.1-.1.1H306c0,.1,0,.2,0,.2v.2c.1,0,0-.1,0-.2h.1s0,.2.1.1h.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.5,507.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.8,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.8,508.6h0S305.8,508.6,305.8,508.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.3,510.8H305c0-.1-.1-.1-.1-.2h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1H305l.3.2C305.3,510.7,305.3,510.7,305.3,510.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305.8 508.6 305.8 508.6 305.7 508.6 305.7 508.6 305.8 508.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.3,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.2,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,510.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.2 510.6 305.2 510.6 305.1 510.6 305.1 510.6 305.2 510.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 510.7 305.1 510.7 305.1 510.7 305.1 510.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.9 511.3 305 511.4 305 511.4 304.9 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.4,509.2l-.2-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,510.4c-.1,0-.1-.1-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.2s0,0,0,0H305s0,0,0,0h.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305 510.5 305 510.5 305 510.5 305 510.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.8 511.3 304.8 511.3 304.8 511.3 304.8 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.1,510.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.3,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,510.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305 510.3 305 510.3 305 510.3 305 510.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 509.6 305.2 509.6 305.1 509.6 305.1 509.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305 510.2 305 510.2 305 510.3 305 510.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 509.6 305.1 509.6 305.1 509.6 305.1 509.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.5,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,507h-.1c0-.1-.1-.2,0-.2h.2C305.1,506.9,305.1,507,305,507Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.5,509h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,304.5,509Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "305.1",
      "y": "512.1",
      "width": "4",
      "height": "7.84",
      "transform": "translate(-283 626.8) rotate(-69.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,516.6c0-.1-.1-.1-.1-.2s0-.3,0-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2.1-.3s0,.2.1.2h.3l.2-.2s0-.1,0-.1h.2c0-.1,0-.1.1-.2h.1c0,.1-.1.1,0,.2h.1c0-.1,0-.1.1-.2h0c0,.1-.1.3-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.8.8,0,0,0,0,.4h-.1l-.6.3C303.3,516.7,303.1,516.7,303,516.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516.4 303 516.4 303 516.4 303.1 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.4,517h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 516.2 303.2 516.2 303.2 516.2 303.2 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516.1 303.1 516.1 303.1 516.1 303.1 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516 303.1 516 303.1 516 303.1 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 516 303.1 516 303.1 516 303.1 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 515.9 303.1 515.9 303.1 515.9 303.1 515.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 516 303.3 516 303.3 516 303.2 516"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,516.6h-.2l.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 515.9 303.1 515.9 303.1 515.9 303.1 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,516.6s0,0,0,0h0S305,516.6,305,516.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,516.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.2,515.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304.2 516.2 304.2 516.2 304.2 516.1 304.2 516.1 304.2 516.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,516h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.9,517.7c0-.1,0-.1,0-.2h.2l.3-.3s-.1.1,0,.2h.4c-.2,0-.2.3-.4.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.3,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.4,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.2,517.3l-.3-.4h.1l.2.4s.1.1,0,.1S309.2,517.4,309.2,517.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,515.7h0S304.8,515.7,304.8,515.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.4,516.2c0-.1.1-.1.1-.2h.2c0,.1.2,0,.2.1h.1c-.1-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.1a.1.1,0,0,0,.1-.2h.2c0-.1.1,0,.1-.1s0,.1,0,.1.3-.1.5,0,0,.2,0,.3h.3l-.5.2h-.1v.2c0,.1,0,.1,0,.1h-.1V516h-.5c0,.1.2,0,.3.1a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.8,516.6c0,.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.1,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M307.2,515.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,514.6c-.1-.1.1-.2.1-.4h0c0,.1-.1,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1,0,0,.1h.2c.1,0,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "307.2 515.5 307.2 515.5 307.2 515.5 307.2 515.5 307.2 515.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.8,514.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,514.5h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.7,514.4h0S304.8,514.4,304.7,514.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.9 514.5 304.9 514.5 304.9 514.4 304.9 514.4 304.9 514.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305,514.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.8 514.4 304.8 514.4 304.8 514.4 304.8 514.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 514.1 304.1 514.1 304 514.1 304.1 514.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.5,514.9l.2-.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.2,514.4c0-.1.2-.1.3-.2h.1a.3.3,0,0,0,.1.2h-.3A.1.1,0,0,1,305.2,514.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,514.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.9,514.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.4,514.5h0c0-.1.1-.1.1-.2h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,514.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "305.1 514.3 305 514.3 305.1 514.3 305.1 514.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 513.9 304.1 514 304.1 514 304.1 513.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.4,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.4,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.3,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,514.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305.3 514.3 305.3 514.4 305.3 514.4 305.3 514.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "306.1 514.6 306.1 514.6 306.1 514.6 306.1 514.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "305.4 514.3 305.4 514.3 305.3 514.3 305.4 514.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "306.1 514.6 306 514.6 306.1 514.6 306.1 514.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,514.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,513.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.1,514.9v-.2h.3s0,.1-.1.2S309.1,515,309.1,514.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.9,514h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "302.3",
      "y": "517.9",
      "width": "8.4",
      "height": "4.29",
      "transform": "translate(-99.4 73.3) rotate(-11.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.1,522.9h-.2c-.2-.1-.2-.3-.2-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3s.1.2.2.2v-.2h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.3s-.1-.1-.1-.2h.1c.1.1,0,.2.1.2h0c-.1-.1,0-.1-.1-.2h0c.1.1,0,.3.2.4h.1c.2,0,.2-.2.3-.3a1.2,1.2,0,0,0-.2.4l.2-.2-.2.3.2.4h0s-.1.1-.1.1h0c.1.1.1-.1.2,0l-.4.6A.7.7,0,0,1,303.1,522.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 522.6 303 522.7 303 522.7 303 522.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.5,521.9a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 522.4 303 522.4 303 522.4 303 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 522.4 302.9 522.5 302.9 522.4 302.9 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 522.3 302.9 522.3 302.9 522.3 302.9 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 522.3 302.9 522.3 302.9 522.3 302.9 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.8 522.2 302.8 522.2 302.8 522.2 302.8 522.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 522.2 303 522.2 303 522.2 303 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305,521.7h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.8 522.2 302.8 522.2 302.8 522.2 302.8 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.9,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.8,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.8,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.8,522h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 521.8 304 521.8 303.9 521.8 304 521.8 304 521.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.8,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M310,520c-.1-.1-.1-.2-.1-.2h.1a1.4,1.4,0,0,0,.1-.4s0,.1.1.2h.4c-.2.1,0,.4-.2.6s-.1.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.2s0-.1,0-.1S304.2,521.2,304.2,521.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.8,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M309.2,520l-.5-.2s0-.1,0-.1h.1l.5.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,521h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.8,520c-.1-.1,0-.2,0-.2v-.2c.1,0,.1-.1.2,0h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.2.4-.2s.1.2.1.3h.4c-.2.1-.2.3-.4.5s-.1.1,0,.1h-.4l-.2.2c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M308.4,519.6c.1,0,0,0,0,.1S308.4,519.6,308.4,519.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M306.2,519.6a.2.2,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M306.3,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,520.1c-.1-.1-.1-.3-.1-.4s.1-.2.2-.3h0s0,0,0,.1h0s-.1.1,0,.1h-.1a.3.3,0,0,0,.1.3s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s0,.1,0,.1a.5.5,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "306.3 519.5 306.3 519.5 306.3 519.5 306.3 519.5 306.3 519.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.6,520s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,520h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,520h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,519.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,520a0,0,0,0,1,0,0S303.5,520,303.5,520Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.5,519.9h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.6 519.9 303.6 519.9 303.6 519.8 303.6 519.8 303.6 519.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.7,519.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.5 519.9 303.5 519.9 303.5 519.9 303.5 519.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.7 520 302.7 520 302.7 520 302.7 520"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.4,519.4a.3.3,0,0,1,.1-.3v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.9,519.6c-.1-.1.1-.2.1-.3h.1l.2.2a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,519.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,519.6h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.2,519.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.7 519.6 303.7 519.6 303.7 519.6 303.7 519.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.6 519.8 302.6 519.9 302.6 519.9 302.6 519.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.1,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M305.5,519.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304.2,519.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.9 519.5 304 519.5 303.9 519.5 303.9 519.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.8 519.3 304.8 519.4 304.8 519.4 304.8 519.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 519.5 304 519.5 304 519.5 304 519.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.7 519.3 304.7 519.4 304.8 519.3 304.7 519.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,519.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,519.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M307.7,517.9c-.1,0,0-.1,0-.2s.1-.2.3-.1h.1c0,.1.1.1,0,.2S307.8,518,307.7,517.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M305.1,518.4c0-.1,0-.1,0-.2h.3a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "295.5",
      "y": "518.1",
      "width": "3.7",
      "height": "7.15",
      "transform": "translate(-243.7 782.1) rotate(-86)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.7,520.1s.2.1.1.2.1.3.1.4,0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2v.2h-.1v.2s0,0,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.3,0-.4h-.4l.2-.3h-.2l.2-.2a.8.8,0,0,0-.1-.3h0l.5-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.3 300.8 520.3 300.8 520.3 300.8 520.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.5,520.4h-.2s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.7 520.5 300.7 520.5 300.7 520.5 300.7 520.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.5 300.8 520.5 300.8 520.5 300.8 520.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.6 300.8 520.6 300.8 520.6 300.8 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.6 300.8 520.6 300.8 520.6 300.8 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.8 520.7 300.8 520.7 300.8 520.7 300.8 520.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.7 520.7 300.7 520.7 300.7 520.7 300.7 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,520.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.9 520.7 300.9 520.7 300.9 520.7 300.9 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299,520.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.9,520.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.8,520.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.8 520.7 299.8 520.8 299.8 520.8 299.8 520.8 299.8 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.9,520.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M294.4,520.9c0,.1,0,.1,0,.2h-.1l-.2.3s0-.1,0-.1h-.4c.2-.1.1-.3.3-.4s.2-.2.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.9,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.5,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.8,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.1,521l.4.3s0,.1,0,.1h-.1l-.3-.3s-.1-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297,521.6c0,.1-.1.1,0,.2h-.4l.2.2h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1-.1.1h0c-.2-.1-.3.1-.4.1s-.1-.2,0-.2h-.2s0-.1,0-.1h-.2l.4-.3s.1-.1.1-.1H296c-.1,0,0-.1,0-.1h.5a0,0,0,0,1,0-.1s.2,0,.1-.1-.1-.1,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.6,521.5c-.1,0,0,0,0,0S295.7,521.5,295.6,521.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.4,522h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M297.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.8,522.3c.1.1,0,.2,0,.3l-.2.2h.1s.1,0,0-.1h.1c-.1,0,0,0,0-.1h0a.3.3,0,0,0,0-.2h-.1s0,.1,0,.1,0,0,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s0-.1,0-.1a.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "297.4 522.1 297.4 522.1 297.4 522.1 297.4 522.1 297.4 522.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.6,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.8,522.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.6 522.4 299.6 522.4 299.6 522.4 299.6 522.4 299.6 522.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.6,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.5,522.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.7 522.5 299.8 522.4 299.8 522.5 299.7 522.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.4 522.5 300.4 522.5 300.5 522.5 300.4 522.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.1,522.4a.2.2,0,0,1-.2.2v-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,522.6c0,.1-.1.2-.2.3h-.1v-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.7,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.2,522.5h0c0,.1-.1.2,0,.2h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,522.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.5 522.6 299.5 522.6 299.5 522.6 299.5 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.4 522.7 300.4 522.7 300.4 522.7 300.4 522.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.2,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.2,522.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M297.9,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.3,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,522.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 522.6 299.3 522.6 299.3 522.6 299.3 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "298.5 522.6 298.5 522.6 298.5 522.6 298.5 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 522.6 299.3 522.6 299.3 522.6 299.3 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "298.6 522.6 298.6 522.6 298.6 522.6 298.6 522.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,522.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,523h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.8,523.1c0,.1,0,.1,0,.2h-.3s0-.1,0-.2S295.8,523,295.8,523.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298,523.3c0,.1,0,.1-.1.1h.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "298",
      "y": "523.3",
      "width": "3.9",
      "height": "7.61",
      "transform": "translate(-248 787.1) rotate(-85.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.6,525.5s.2.1.2.2.1.3.1.4,0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2v.2h-.1v.2s0,0,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.1-.1-.2H303c0,.1,0,.1,0,.2h0c0-.1.1-.3,0-.4h-.1l-.4.2.2-.3h-.2l.3-.2a.8.8,0,0,0-.1-.4h0l.5-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 525.7 303.6 525.7 303.6 525.7 303.6 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.3,525.8a.1.1,0,0,1-.1.2H301s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 525.9 303.6 525.9 303.6 525.9 303.6 525.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.7 525.9 303.7 525.9 303.7 525.9 303.7 525.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 526 303.6 526 303.6 526 303.6 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 526.1 303.6 526.1 303.6 526.1 303.6 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.7 526.1 303.7 526.1 303.7 526.1 303.7 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.6 526.1 303.5 526.1 303.5 526.1 303.6 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.7,526h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.8 526.2 303.8 526.1 303.8 526.1 303.8 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.8,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.7,526h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.8,526.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.6,526.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.6 526.2 302.6 526.2 302.6 526.2 302.6 526.2 302.6 526.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.7,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M296.9,526.3c0,.1,0,.1,0,.2h-.2l-.2.3s0-.1,0-.2h-.4c.2-.1.1-.3.3-.4s.2-.2.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.7,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.3,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.6,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,526.5l.4.3s0,.1,0,.1h-.1l-.3-.3s-.1-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,527c0,.1-.1.1,0,.2h-.2c-.1-.1-.1.1-.2,0h-.1l.2.2h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1h-.1c0,.1-.1.1-.1.1h0c-.2-.1-.3.1-.4.1s-.1-.2,0-.3h-.2s0-.1,0-.1h-.2l.5-.3s.1-.1.1-.1h-.1c-.1,0,0-.1,0-.1h.5a0,0,0,0,1,0-.1c.1,0,.2,0,.1-.1s-.1-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.2,527c-.1,0,0,0,0-.1S298.2,527,298.2,527Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.1,527.6H300a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.6,527.8c.1.1,0,.2,0,.4l-.2.2h.1s.1,0,0-.1h.1c-.1,0,0,0,0-.1h0a.3.3,0,0,0,0-.2h-.1c-.1,0,0,.1,0,.1s0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s.1-.1,0-.1a.4.4,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300 527.6 300 527.6 300 527.6 300 527.6 300 527.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.5,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.4,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.6,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.4 528 302.4 528 302.4 528 302.4 528 302.4 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.4,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.3,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.5 528 302.5 528 302.6 528 302.5 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.3 528.1 303.3 528.1 303.3 528.1 303.3 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.4,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.8,528a.2.2,0,0,1-.2.2.3.3,0,0,1-.1-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.1,528.1c0,.1-.1.2-.2.3h-.1v-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.4,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.5,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.1h0c0,.1-.1.2,0,.2h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,528.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "302.3 528.2 302.3 528.2 302.3 528.2 302.3 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.3 528.3 303.3 528.2 303.3 528.2 303.3 528.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.6,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M301.9,528.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.1 528.2 302 528.2 302.1 528.2 302.1 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.2 528.1 301.3 528.1 301.3 528.1 301.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302 528.2 302 528.2 302 528.2 302 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.3 528.2 301.3 528.2 301.3 528.2 301.3 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.3,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.3,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.4,528.7c0,.1,0,.1,0,.2H298c0-.1,0-.1.1-.2S298.3,528.6,298.4,528.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.7,528.9c0,.1,0,.1-.1.2h-.2v-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "293.8",
      "y": "529.5",
      "width": "8.2",
      "height": "4.19",
      "transform": "translate(-262.1 291.3) rotate(-37.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.6,527.7h.2c.2,0,.3.2.4.3s0,.1.1.1h0c0,.1.2.1.2.2h-.2a.5.5,0,0,0,0,.2h.1s0,.1,0,.1h-.1a.3.3,0,0,0,0,.2h.1c.1.1-.1.2,0,.3v.2h-.3s0,.1,0,.1v.2h0c-.1-.1-.2-.3-.3-.3H300c-.1.1-.1.3-.2.4a1.1,1.1,0,0,0,0-.4c0,.1-.1.2-.1.2a1,1,0,0,1,.1-.3l-.3-.2h0c0-.1.1-.1,0-.2h0s.1-.1,0-.1h-.1c-.1,0-.1.1-.1.1s0-.5.1-.7S299.4,527.7,299.6,527.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.8 527.8 299.8 527.8 299.8 527.8 299.8 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298,529.6a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1-.1-.1S297.9,529.5,298,529.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.9 528 299.9 528 299.9 528 299.9 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300 528 300 527.9 300 527.9 300 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.1 528.1 300.1 528.1 300.1 528.1 300.1 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.1 528.1 300.1 528.1 300.1 528.1 300.1 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.2 528.1 300.2 528.1 300.2 528.1 300.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.1 528.2 300 528.2 300 528.2 300.1 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.4,529.5l.3-.2s0,0,0,.1l-.3.2S298.4,529.4,298.4,529.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.2 528.1 300.2 528.1 300.2 528.1 300.2 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.6,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.5,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.6,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.5,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,528.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 528.9 299.4 528.9 299.4 529 299.4 529 299.3 528.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.5,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M294.8,533.1l.2.2c-.1,0,0,.1-.1.2a1.3,1.3,0,0,0,.1.4h-.3c0,.1,0,.2-.1.2s-.1-.4-.1-.6,0-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.8,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.6s0,0,0,.1S299.4,529.6,299.4,529.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.7,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M295.5,532.7h.5s.1,0,0,.1h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.4,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,531.7v.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.2.1s-.1.1,0,.1h.3s0,0,0,.1h.2s0,.1,0,.1h.1s0,.1.1.1H298c.1,0,0,.1,0,.1H298c-.2.1-.1.3-.3.4l-.2-.2H297c.1-.2,0-.4.1-.6s0-.1,0-.1h0l.2-.2a.9.9,0,0,0,.1-.3c-.1,0-.1.2-.2.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M296.4,532.8c-.1,0,0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.3,531.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.2,531.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.3c.1,0,.2.2.3.3s0,.2-.1.3h0s0-.1,0-.1h0l-.2-.2h-.1s0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.3 531.9 298.3 531.9 298.3 532 298.3 532 298.3 531.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.6,530.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.5 530.5 300.5 530.5 300.5 530.5 300.5 530.5 300.5 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.6s0,0,0,0S300.4,530.6,300.4,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,530.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.6 530.5 300.6 530.4 300.6 530.4 300.6 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.2 530 301.2 530 301.3 530 301.2 530"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.1,531.7a.3.3,0,0,1,0,.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,530.8c.1.1,0,.2,0,.4H300c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.6,530.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.7,530.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,530.9h0s.1.2.1.1h0s.1,0,0,.1h-.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.1,531h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.5 530.8 300.5 530.7 300.5 530.8 300.5 530.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "301.4 530.1 301.3 530.1 301.4 530.1 301.4 530.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,531h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.1,531.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,530.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,531.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.3 531 300.3 530.9 300.3 530.9 300.3 531"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.7 531.5 299.6 531.5 299.7 531.5 299.7 531.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.3 531 300.3 531 300.3 531 300.3 531"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "299.7 531.5 299.7 531.5 299.7 531.5 299.7 531.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.6,530.8h0S300.6,530.8,300.6,530.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.6,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.7,534v.2c0,.1,0,.2-.2.2h-.1c0-.1-.1-.1-.1-.2S297.6,533.9,297.7,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.8,532.5c.1,0,.1.1.1.2h-.2a.2.2,0,0,1-.1-.2A.1.1,0,0,1,299.8,532.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "299.1",
      "y": "534.2",
      "width": "6.5",
      "height": "3.33",
      "transform": "translate(-311.2 489.7) rotate(-56.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.6,532.5h.7v.2h0v.2h.1c.1.1,0,.2.1.2h-.1s0,0,0,.1h-.3c-.1.1,0,.2,0,.3v-.3c0,.1,0,.2,0,.2a.8.8,0,0,1,0-.3h-.3s0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.5S302.5,532.5,302.6,532.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.8 532.6 302.8 532.5 302.8 532.5 302.8 532.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.9,534.3h-.1A.1.1,0,0,1,301.9,534.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.9 532.7 302.9 532.7 302.9 532.7 302.9 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303 532.6 303 532.6 303 532.6 303 532.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 532.7 303.1 532.7 303.1 532.7 303.1 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 532.7 303.1 532.7 303.1 532.7 303.1 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 532.7 303.1 532.7 303.2 532.7 303.2 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.1 532.8 303.1 532.8 303.1 532.8 303.1 532.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.2,534.1v-.2h0l-.2.2S302.2,534.1,302.2,534.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "303.2 532.6 303.2 532.6 303.2 532.6 303.2 532.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.3,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.2,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.3,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.8,533.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.3,532.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.7 533.5 302.7 533.5 302.8 533.5 302.8 533.5 302.7 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.9,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,537.8h.2c-.1,0,0,.1,0,.1l.2.3h-.1c-.1,0-.1.1-.1.1s0,.1,0,.2-.2-.2-.2-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.2,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.1,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.1,536.1h.1a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.6c-.1.1,0,.3-.1.4h-.5c0-.1-.1-.3,0-.5h-.1v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.1-.1.2H302c0-.1,0-.2,0-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.5,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.7,536h.1s0,.1,0,.1h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M302.7,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.9,534.2l.3.2c-.1.1,0,.2,0,.2H304v.2H304a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "302.7 536 302.7 536 302.7 536 302.7 536 302.7 536"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.4s0,0,0,0S303.9,534.4,303.9,534.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304 534.4 304 534.4 304 534.4 304 534.4 304 534.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 534.3 304.1 534.3 304.1 534.3 304.1 534.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.4 533.8 304.4 533.8 304.4 533.8 304.4 533.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M303.3,535.6a.2.2,0,0,1,.1.2h-.2a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,534.7c.1.1.1.2.1.3h-.3c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.1,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.1,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.8h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.1 534.6 304.1 534.6 304.1 534.6 304.1 534.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "304.6 533.9 304.5 533.9 304.5 533.9 304.6 533.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.3,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M304,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M303.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 534.8 304 534.8 304 534.8 304 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.6 535.3 303.6 535.3 303.6 535.3 303.6 535.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "304 534.8 304 534.8 304 534.8 304 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "303.7 535.3 303.7 535.3 303.7 535.3 303.7 535.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.2,534.6h0S304.1,534.6,304.2,534.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304.8,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M302.8,537.7h.1c0,.1,0,.2-.1.2h-.2C302.7,537.8,302.7,537.7,302.8,537.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M304,536.1h-.1C303.8,536.1,303.9,536,304,536.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "294.6",
      "y": "540",
      "width": "8.5",
      "height": "4.32",
      "transform": "translate(-303.2 686.5) rotate(-74.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.8,537.9h.2c.2-.1.3,0,.5,0h.3c0,.1-.1,0-.1.1s.2,0,.3.1h-.2l.2.2s0-.1,0-.1h0v.2l.2.2h.1c.1,0,.1.2.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,.1h-.4s0,.1,0,.1h-.1c-.1.2.1.3.1.4l-.3-.3c.1.1,0,.2,0,.3l-.2-.3h-.4c-.1.1,0,.2-.1.2s.1-.1,0-.2V539h0s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.3-.4-.4-.6A.7.7,0,0,1,297.8,537.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.1 537.9 298 537.9 298 537.9 298.1 537.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,540.5h.1v.2h-.1A.2.2,0,0,1,297.6,540.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.3 538.1 298.2 538 298.2 538 298.3 538.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.3 537.9 298.3 537.9 298.3 537.9 298.3 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.4 538 298.4 538 298.4 538 298.4 538"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.5 538 298.4 538 298.4 538 298.5 538"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.5 537.9 298.5 537.9 298.5 537.9 298.5 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.5 538.1 298.5 538.1 298.5 538.1 298.5 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.9,540.1v-.3h0c-.1.1-.1.2-.1.3S297.9,540.1,297.9,540.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.6 537.9 298.5 537.9 298.6 537.9 298.6 537.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298,540h0c-.1,0,0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298,540.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.4,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.7,538h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "298.4 539.1 298.4 539.1 298.4 539.1 298.4 539.1 298.4 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.5,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.3,545.4h.2c0,.1.1.1,0,.2l.3.3h-.2c-.1,0-.1.1-.1.2s.1.2,0,.2-.3-.2-.4-.4-.2-.2-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.8,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M298.9,539.3s0,0,0,0S298.9,539.3,298.9,539.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M297.6,544.6l.5-.3h0l-.4.3h-.1C297.4,544.7,297.5,544.6,297.6,544.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.6,542.6h.2v.2c-.1.1.1.2-.1.2s0,.1.1.1l.2-.2h.7s0,0,0,.1h0c-.1.2.1.3,0,.5h-.3c-.1,0-.1.1-.1.2h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.6h-.4c0-.1.1-.1.1-.2h.2c.1-.1,0-.2,0-.3V543c-.1,0,0,.2-.1.3h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.3,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.3,542.2h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M299.3,542.3h0S299.3,542.3,299.3,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.1,539.5h.4c0,.1.1.2.1.3h-.2s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2a.5.5,0,0,1-.4-.3C300,539.6,300.1,539.6,300.1,539.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "299.3 542.3 299.3 542.3 299.4 542.3 299.4 542.3 299.3 542.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.1,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.2,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.3,539.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.3 539.7 300.3 539.7 300.3 539.7 300.3 539.7 300.3 539.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.3 539.6 300.3 539.6 300.3 539.6 300.3 539.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.6 538.8 300.6 538.8 300.6 538.8 300.6 538.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.3,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M299.9,541.5a.3.3,0,0,1,.2.2h-.3C299.8,541.6,299.8,541.5,299.9,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,540.1c.2,0,.2.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.4,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,540.3s0,0,0,0h.2s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,540.4s0,0,0,0S300.3,540.4,300.3,540.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.4 539.9 300.4 539.9 300.5 539.9 300.4 539.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.7 538.9 300.7 538.9 300.7 538.8 300.7 538.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.3,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M300.4,540.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.4 540.2 300.4 540.2 300.4 540.2 300.4 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.2 541 300.2 541 300.2 541 300.2 541"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "300.4 540.2 300.4 540.2 300.4 540.2 300.4 540.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "300.2 541 300.2 541 300.2 541 300.2 541"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.5,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M301.1,538.9h0S301.1,538.9,301.1,538.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.2,544.3h.2c0,.1.1.2,0,.3h-.3C300,544.5,300,544.3,300.2,544.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M300.9,541.8h.2a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,300.9,541.8Z"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-238"
  }, [_c('g', [_c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "342.6",
      "y": "564.4",
      "width": "3.3",
      "height": "6.55",
      "transform": "translate(-315.6 640.8) rotate(-65.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.8,567.9s-.1-.1-.1-.2,0-.3,0-.4h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.2s0,.1,0,.2h.4s0,0,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.3l-.3.2h-.1a.7.7,0,0,0,0,.3h-.1l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.7 340.8 567.7 340.8 567.7 340.9 567.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.8,568.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341 567.6 341 567.6 341 567.6 341 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.5 340.9 567.5 340.9 567.5 340.9 567.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.4 340.9 567.4 340.9 567.4 340.9 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341 567.4 340.9 567.4 340.9 567.4 341 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.3 340.9 567.4 340.9 567.3 340.9 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341 567.4 341 567.4 341 567.4 341 567.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.5,568.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.9 567.3 340.9 567.3 340.9 567.3 340.9 567.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.4,568s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.5,568h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.4,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.7,567.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,567.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "341.8 567.6 341.8 567.6 341.8 567.6 341.8 567.6 341.8 567.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.8,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.4,569.3c0-.1,0-.1.1-.2h.1l.2-.2s-.1.1,0,.1h.3c-.2,0-.2.2-.4.3h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.9,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,568.9l-.2-.4h.1l.2.4s.1.1,0,.1S345.9,569,345.9,568.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,567.3h0S342.4,567.3,342.4,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,567.8v-.2h.4c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2s0,.1,0,.1h-.6s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.3,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.3,567.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.3,566.3c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0s.1,0,0,.1h.2v-.2s-.1.1,0,.1-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "344.3 567.3 344.3 567.3 344.3 567.3 344.4 567.3 344.3 567.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.5,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.4,566.2h0S342.4,566.2,342.4,566.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.5 566.3 342.5 566.3 342.5 566.2 342.5 566.2 342.5 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.6,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.6,566.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.4 566.2 342.4 566.2 342.4 566.2 342.4 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.9 565.9 341.8 565.9 341.8 565.9 341.9 565.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.5,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,566.8h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.8,566.2l.2-.2h0a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,342.8,566.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.6,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.5,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.9,566.3h0s.1-.1.1-.1h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "342.7 566.1 342.7 566.1 342.7 566.1 342.7 566.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.9 565.8 341.9 565.8 341.9 565.8 341.9 565.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343,566.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.9 566.2 342.9 566.2 342.9 566.2 342.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "343.5 566.5 343.5 566.5 343.5 566.5 343.5 566.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.9 566.2 342.9 566.2 342.9 566.2 342.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "343.5 566.4 343.5 566.4 343.5 566.4 343.5 566.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.7,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,566.9h.2C346.1,567,346,567,346,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,566h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347.3",
      "y": "561.2",
      "width": "3.7",
      "height": "7.16",
      "transform": "translate(-254.1 287.4) rotate(-33.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,566.5c0,.1,0,.2,0,.2s-.2.2-.3.3H352s0-.1,0-.1-.1.1-.2.2.1-.1.1-.2h-1c0-.1.1-.1.1-.2h-.2c.1-.1.3-.1.3-.3h0l-.3-.2h.4l.2-.3c0-.1-.1-.1-.1-.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1-.1-.1-.1h.6C352.3,566.2,352.4,566.3,352.5,566.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.3 566.6 352.3 566.6 352.3 566.6 352.3 566.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,564.9h-.2v-.2h.1C350.9,564.7,350.9,564.8,350.9,564.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 566.7 352.1 566.7 352.1 566.7 352.1 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.2 566.8 352.2 566.8 352.2 566.8 352.2 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 566.8 352.1 566.8 352.1 566.8 352.1 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 566.9 352.1 566.8 352.1 566.8 352 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 566.9 352.1 566.9 352.1 566.9 352 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 566.8 352 566.8 352 566.8 352 566.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,565.3v.2H351v-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 567 352.1 567 352.1 567 352.1 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.5,566.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,567h0S351.9,567,351.9,567Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 566.1 351.4 566.2 351.3 566.2 351.3 566.2 351.4 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,566.3h0S351.3,566.3,351.3,566.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348,562h-.5c0-.1-.1-.1-.1-.2h-.2c.2.1.3-.1.5,0s.2,0,.3.2S348,561.9,348,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,566.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.3,562.6a1.2,1.2,0,0,1,0,.5h-.1a2.8,2.8,0,0,0,.1-.4s0-.1.1-.1S348.3,562.6,348.3,562.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,564.4h-.4c0-.1-.1,0-.1-.1h-.1c0,.1-.1.2,0,.2h-.1c-.1,0,0,.1,0,.1h-.2s0,.1,0,.1h-.5c0-.2-.3-.1-.3-.3l.2-.2c0-.1,0-.1-.1-.1h0l.5.2h.1a.2.2,0,0,0,0-.2h.1c.1,0,0,.1.1.1s0,.1,0,.2l.2.2h.2c0-.1-.1-.1-.1-.2h.3l.3.2A.5.5,0,0,1,349,564.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,565.1h0A.1.1,0,0,1,348.9,565.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,565h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,567.1c0,.1-.2.1-.3.2h0c0-.1.1,0,0-.1h.1c.1,0,0-.1,0-.1H350s0,0,0,.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 565 348.8 565 348.8 565 348.8 565 348.8 565"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.1h0S350,567,350,567.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 567 349.9 567 349.9 567.1 349.9 567.1 349.9 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,567h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 567.1 350 567.1 350 567.2 350 567.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.3 567.7 350.4 567.7 350.4 567.7 350.3 567.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,565.8h-.3v-.2h.1C349,565.7,349,565.7,349,565.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,566.9h-.3a.2.2,0,0,0,.1-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,349.6,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,566.8h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.7 567 349.7 567.1 349.7 567.1 349.7 567"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.2 567.8 350.2 567.8 350.2 567.8 350.2 567.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.6,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.6 566.9 349.6 566.9 349.6 566.9 349.6 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.1 566.3 349.1 566.3 349.1 566.3 349.1 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.5 566.9 349.5 566.9 349.5 566.9 349.5 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.1 566.3 349.2 566.3 349.1 566.3 349.1 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.1,564.4h-.1l-.2-.2h.2C347,564.2,347.1,564.3,347.1,564.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,566.3h-.1A.1.1,0,0,1,348.2,566.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351",
      "y": "554.8",
      "width": "4.4",
      "height": "8.62",
      "transform": "translate(-248.7 833.1) rotate(-82.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.7c0-.1-.2-.1-.2-.2s-.1-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2l.2-.2h.1l.2-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.2.1.2h.1c0-.1,0-.1,0-.2h.1c0,.1-.1.3,0,.4h.1c.2,0,.3-.1.4-.2l-.3.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.2c0,.1.1,0,.2,0l-.6.4A.7.7,0,0,1,349,560.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 560.4 348.9 560.5 348.9 560.4 348.9 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,560.5a.1.1,0,0,1,.1-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349 560.2 349 560.2 349 560.2 349 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 560.2 348.9 560.2 348.9 560.2 348.9 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349 560.1 348.9 560.1 348.9 560.1 349 560.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 560 349 560 348.9 560 348.9 560"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 559.9 348.9 560 348.9 560 348.9 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.1 560 349.1 560 349.1 560 349.1 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 559.9 348.8 559.9 348.8 559.9 348.8 559.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,560.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349,559.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 560 350.1 560 350.1 559.9 350.1 559.9 350.1 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.6,560.2c-.1-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.5s-.2.2-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,560l-.4-.4s0-.1,0-.1h.1l.4.4s.1.1.1.1S355.8,560.1,355.8,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,559.2c0-.1.1-.2.1-.2h.2c.1.1.2-.1.2,0h.1l-.2-.2h0c0-.1-.1-.1-.1-.1h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5-.1s.1.2,0,.3h.2s0,.1,0,.2h.2l-.5.3s-.1.1-.1.1h.2c.1,0,0,.1,0,.1h-.2v-.2h-.3l-.2.2c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.2s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,559.3c.1,0,0,0,0,.1S355.2,559.3,355.2,559.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.1,558.6h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.1,558.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558.2c-.1-.1,0-.3,0-.4s.2-.1.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1s0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.2a.5.5,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.2 558.6 353.2 558.6 353.2 558.5 353.2 558.5 353.2 558.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,558h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.5 558 350.5 558 350.5 557.9 350.5 557.9 350.5 558"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.6,557.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.3 557.9 350.3 557.9 350.3 557.9 350.3 557.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.5 557.8 349.5 557.8 349.5 557.8 349.5 557.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.3,558.1a.3.3,0,0,1,.2-.2.3.3,0,0,1,.1.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,557.8c0-.2.1-.2.2-.3h.1a.3.3,0,0,0,.1.2v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,557.8h0c0-.1.1-.2,0-.2h0s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,557.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.6 557.8 350.6 557.8 350.6 557.7 350.6 557.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.5 557.6 349.5 557.6 349.5 557.6 349.5 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,557.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.6,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,557.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.9 557.7 350.9 557.8 350.9 557.8 350.9 557.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 557.9 351.8 557.9 351.8 557.9 351.8 557.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.9 557.7 350.9 557.7 350.9 557.7 350.9 557.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 557.8 351.7 557.8 351.7 557.8 351.8 557.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.6,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,557.4c0-.1,0-.1,0-.2h.4c0,.1,0,.2-.1.2S355.1,557.6,355.1,557.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,557c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "341.4",
      "y": "556.1",
      "width": "6.8",
      "height": "3.46",
      "transform": "translate(-309.4 511.9) rotate(-54.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,554.3h.7v.2h0v.2h.1c.1.1,0,.2.1.2h-.1s0,0,0,.1h.1l-.3-.2h-.1c-.1.1,0,.2,0,.3a.9.9,0,0,0-.1-.3c0,.1,0,.2,0,.2a.8.8,0,0,1,0-.3h-.4s0-.1,0-.1h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.1s-.1-.4-.1-.6S345,554.3,345.2,554.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.4 554.4 345.4 554.4 345.4 554.4 345.4 554.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.3,556.2h-.1C344.2,556.3,344.2,556.2,344.3,556.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.5 554.5 345.5 554.5 345.5 554.5 345.5 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.4 345.5 554.4 345.5 554.4 345.6 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.5 345.6 554.5 345.6 554.5 345.6 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.5 345.6 554.5 345.6 554.5 345.6 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 554.5 345.7 554.5 345.7 554.5 345.7 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.6 554.6 345.6 554.6 345.6 554.6 345.6 554.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,556l.2-.2h0l-.2.2S344.6,556,344.7,556Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 554.5 345.7 554.5 345.7 554.5 345.8 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.8,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.7,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.8,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.3,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,554.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.3 555.4 345.3 555.4 345.3 555.4 345.3 555.4 345.3 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.4,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.7,559.7h.2c-.1,0,0,.1,0,.1l.2.3h-.1c-.1,0-.1.1-.1.1s0,.1,0,.2-.2-.3-.2-.4-.1-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.1,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,558h.1a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.6c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.1.4h-.5c0-.1-.1-.3,0-.5h-.1v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.2-.1.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.8,559.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.1,557.9h.1s0,.1,0,.1h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.1,558h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.1l.3.2c-.1.1,0,.2,0,.3h-.2v.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.1 558 345.1 558 345.1 558 345.1 558 345.1 558"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.3s0,0,0,0S346.4,556.4,346.4,556.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.6,556.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.5 556.3 346.5 556.3 346.5 556.3 346.5 556.3 346.5 556.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.6 556.3 346.6 556.2 346.6 556.3 346.6 556.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347 555.7 347 555.7 347 555.7 347 555.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,557.6a.2.2,0,0,1,.1.2h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,556.6c.1.1.1.2.1.3h-.3c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.6,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.7h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.6 556.5 346.6 556.5 346.6 556.5 346.6 556.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.1 555.8 347.1 555.8 347.1 555.8 347.1 555.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,556.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.5 556.7 346.5 556.7 346.5 556.7 346.5 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.1 557.3 346.1 557.3 346.1 557.3 346.1 557.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.5 556.7 346.5 556.7 346.5 556.7 346.5 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.2 557.3 346.1 557.3 346.1 557.3 346.2 557.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,556.5h0S346.7,556.5,346.7,556.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,559.7h.1c0,.1,0,.2-.1.2H345C345,559.9,345.1,559.7,345.2,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.4,558.1h-.1C346.3,558.1,346.4,558,346.4,558.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "342.7",
      "y": "550.7",
      "width": "6.6",
      "height": "3.37",
      "transform": "translate(-264.9 325.2) rotate(-37.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,549.2h.2c.2,0,.2.1.3.2s0,.1,0,.1h0c0,.1.1.1.2.2H348a.4.4,0,0,0,0,.2h.1s0,0,0,.1H348a.2.2,0,0,0,0,.2h.1c0,.1,0,.1,0,.2H348s0,0,0,.1h.1c-.1-.1-.1-.2-.3-.2h-.1c-.1.1-.1.2-.1.3a.9.9,0,0,0,0-.3v.2a.8.8,0,0,1,.1-.3l-.3-.2h0s0-.1,0-.1h0s.1-.1,0-.1h0c-.1,0,0,.1-.1.1s0-.4.1-.6S347.3,549.2,347.4,549.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 549.3 347.6 549.3 347.6 549.3 347.6 549.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,550.7a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 549.5 347.6 549.5 347.6 549.5 347.6 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 549.4 347.7 549.4 347.7 549.4 347.7 549.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 549.5 347.8 549.5 347.8 549.5 347.7 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 549.5 347.8 549.5 347.8 549.5 347.8 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 549.5 347.8 549.5 347.9 549.5 347.9 549.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 549.6 347.7 549.6 347.7 549.6 347.7 549.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,550.6h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 549.5 347.9 549.5 347.9 549.5 347.9 549.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.6,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.6,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,549.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.2 550.2 347.2 550.2 347.2 550.2 347.2 550.2 347.2 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.6,553.6h.1c-.1,0,0,.1-.1.1a1,1,0,0,0,.1.3h-.2c0,.1,0,.1-.1.2s-.1-.3,0-.5,0-.2.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.7s0,0,0,.1S347.2,550.8,347.2,550.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,553.3h.4s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.2,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,552.5v.2a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s-.1.1,0,.1h.2s0,0,0,0h.2s0,.1,0,.1h0s0,.1,0,.1h-.1c-.2.1-.1.2-.2.3l-.2-.2h-.3c.1-.1,0-.3.1-.5s0-.1,0-.1h0l.2-.2v-.2c-.1,0-.1.1-.2.1h-.1c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.8,553.3c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.3,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.3,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.3c.1,0,.1.2.2.2s0,.2,0,.2h0s0-.1,0,0h0v-.2H348s0,.1,0,.1h.1c0,.1.1,0,0,.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.3 552.6 346.3 552.6 346.3 552.6 346.3 552.6 346.3 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.1 551.5 348.1 551.5 348.1 551.5 348.1 551.5 348.1 551.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,551.5s0,0,0,0S348.1,551.5,348.1,551.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,551.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.2 551.4 348.2 551.4 348.2 551.4 348.2 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.7 551.1 348.7 551 348.7 551 348.7 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,552.4a.2.2,0,0,1,0,.2h-.2a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348,551.8c.1.1,0,.2,0,.3h-.3c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.8h.1s0,0,0,.1h-.1s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.1 551.7 348.1 551.7 348.1 551.7 348.1 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.8 551.2 348.8 551.2 348.8 551.2 348.8 551.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.9,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 551.8 348 551.8 348 551.8 348 551.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.4 552.3 347.4 552.3 347.4 552.3 347.4 552.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 551.9 348 551.9 348 551.9 348 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.5 552.3 347.5 552.2 347.5 552.3 347.5 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,551.7h0S348.2,551.7,348.2,551.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,554.3h.1c0,.1,0,.2-.1.2h-.1s-.1-.1-.1-.2S345.8,554.2,345.9,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,553.1c.1,0,0,.1,0,.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "344.5",
      "y": "542.8",
      "width": "3.1",
      "height": "5.99",
      "transform": "translate(-100 78.2) rotate(-11.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,548.1s0,.1-.1.2l-.3.2h-.2s.1,0,0-.1h-.6c0-.1-.1-.1-.2-.2h.3v-.2l.2.2h.3s-.1-.1,0-.2,0,.1,0,.1h.3c.1-.1,0-.1,0-.1l.4.3A.5.5,0,0,1,348.1,548.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.9 548.2 347.9 548.2 347.9 548.2 347.9 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,546.4h-.1a.1.1,0,0,1,0-.1h.1A.1.1,0,0,1,347.4,546.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 548.2 347.8 548.2 347.7 548.2 347.7 548.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.8 548.3 347.8 548.3 347.8 548.3 347.8 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.7 548.3 347.7 548.3 347.7 548.3 347.7 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.3 347.6 548.3 347.6 548.3 347.6 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.4 347.6 548.4 347.6 548.4 347.6 548.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.2 347.6 548.2 347.6 548.2 347.6 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,546.8a.6.6,0,0,1,0,.2h0c0-.1,0-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.6 548.4 347.6 548.4 347.6 548.4 347.6 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,546.9h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.3,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.4,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,548.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.3 547.5 347.3 547.5 347.3 547.6 347.3 547.5 347.3 547.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.2,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,543.2h-.4c0-.1,0-.1,0-.2h-.1c.1.1.3,0,.4.1s.2.1.2.2S346.1,543.2,346,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,543.8l-.2.4h-.1s0-.1,0-.1l.2-.3h.1C346.2,543.7,346.1,543.8,346.1,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,545.5h-.3c0-.1-.1-.1,0-.1h-.1c0,.1-.1.1-.1.2h-.3s0,0,0-.1H345s0,0,0-.1H345c0-.2-.2-.2-.2-.3h.2c.1,0,0-.1,0-.1h.1c-.1,0,0-.1,0-.1l.3.3h.2s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.2.2,0,0,1,.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,545.9h0S345.8,545.9,345.7,545.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.1,547.9h-.2s0,0,0,0h.1s0,0,0,.1h.1S346.1,547.8,346.1,547.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 545.9 345.7 545.9 345.7 545.9 345.7 545.9 345.7 545.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346,547.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 547.8 345.9 547.8 345.9 547.8 345.9 547.8 345.9 547.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,547.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 547.9 345.9 547.9 345.9 547.9 345.9 547.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346 548.5 346 548.5 346 548.5 346 548.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,547.8s0,0,0,0S345.9,547.8,345.9,547.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,546.5h0C345.6,546.4,345.6,546.5,345.6,546.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,547.6h-.2s0,0,0-.1h.2c.1,0,0,.1.1.1A.1.1,0,0,1,345.7,547.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,547.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.8 547.7 345.8 547.7 345.8 547.7 345.8 547.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 548.5 345.9 548.5 345.9 548.5 345.9 548.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 547.5 345.7 547.5 345.7 547.5 345.7 547.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.6 546.9 345.6 546.9 345.6 546.9 345.6 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.7 547.5 345.7 547.5 345.7 547.5 345.7 547.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.5 547 345.6 547 345.6 547 345.5 547"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.5,544.9h-.1c-.1,0-.1-.1-.1-.2h.2C344.6,544.7,344.6,544.8,344.5,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.9,546.7h0A.1.1,0,0,1,344.9,546.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "337.2",
      "y": "537.1",
      "width": "4.3",
      "height": "8.34",
      "transform": "translate(-296.2 477.1) rotate(-52.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.7,541.9c0,.1.1.2,0,.2s-.1.3-.2.5h-.1c-.1,0,0-.1-.1-.1s-.1.2-.2.3.1-.2,0-.2h-.8v.2h-.1c0-.1.1-.1.1-.2h-.1v.2h0c0-.1.2-.2.2-.4h0a.9.9,0,0,0,.1-.4c0-.1-.2-.1-.1-.2h.3s0,0,0,0h.2c0-.1-.1,0-.1-.1h.7C343.4,541.7,343.6,541.7,343.7,541.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.5 542.1 343.6 542.1 343.6 542.1 343.5 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.4,540.8h-.2C341.3,540.6,341.4,540.7,341.4,540.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.3 343.4 542.3 343.4 542.3 343.4 542.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.5 542.4 343.5 542.4 343.5 542.4 343.5 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.4 343.4 542.4 343.4 542.5 343.4 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.3 542.5 343.3 542.5 343.3 542.5 343.3 542.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.6 343.4 542.6 343.4 542.6 343.4 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 542.5 343.2 542.5 343.2 542.5 343.2 542.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,541.2l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.4 542.6 343.4 542.6 343.4 542.6 343.4 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.7,541.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.6,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.7,541.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.5,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.2,542.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.3 542 342.3 542 342.3 542 342.3 542 342.3 542"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.3,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.1,538.6v.2h-.2l-.4.2v-.2h-.4c.2.1.3-.2.6-.2s.3-.1.4.1S337.1,538.6,337.1,538.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342.1,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.6,539.2a1.4,1.4,0,0,1,.1.5h-.1a3.2,3.2,0,0,0-.1-.5s-.1-.1,0-.1S337.6,539.1,337.6,539.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,542.3h0S341.6,542.2,341.6,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.1,540.9l-.2.2h-.2c0-.1-.2,0-.1-.1h-.1c0,.1,0,.2.1.3h-.1c-.1,0,0,.1,0,.1h-.2c0,.1.1.1,0,.1h-.6s0-.1,0-.1-.3,0-.5-.2,0-.2.1-.2-.1-.1-.1-.1h.6v-.2c0-.1.1-.1,0-.1h.1c0,.1,0,.1,0,.2h.5c0-.1-.2,0-.2-.2h0c.1,0,.2.1.2,0s0-.1.1-.1h.4A.5.5,0,0,1,339.1,540.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.8,540h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.2,541.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.1,541.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.3,543.4c0,.2-.1.2-.2.3h0c0-.1.1,0,0-.1h0l.2-.2h-.1c.1,0-.1-.1,0-.1h-.3l-.2.2c0-.1.1-.1.1-.1a.5.5,0,0,1,.4-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 541.7 339.1 541.7 339.1 541.7 339.1 541.7 339.1 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.2,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.1,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.2,543.6h0S341.2,543.5,341.2,543.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.1 543.5 341.1 543.5 341.1 543.5 341.1 543.5 341.1 543.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,543.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.1 543.6 341.2 543.6 341.2 543.6 341.1 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.8 544.1 341.8 544.1 341.8 544.1 341.8 544.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,542.5h-.3a.3.3,0,0,1,.1-.2h.1C339.5,542.4,339.6,542.4,339.6,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.7,543.5c-.1.1-.2.1-.3.1h0a.3.3,0,0,0,0-.2h.3A.1.1,0,0,1,340.7,543.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.1,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.6,543.3h0s-.2.1-.1.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.8 543.6 340.9 543.6 340.8 543.6 340.8 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "341.7 544.3 341.7 544.2 341.7 544.2 341.7 544.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.5,543.4h0S340.5,543.4,340.5,543.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.3,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.4,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.6 543.5 340.6 543.4 340.6 543.5 340.6 543.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 542.9 339.9 542.9 339.9 542.9 339.9 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.6 543.5 340.6 543.4 340.6 543.5 340.6 543.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 543 339.9 543 339.9 543 339.9 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.8,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.5,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.9,541.7h-.3C336.8,541.5,337,541.5,336.9,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.9,543.3h-.3s0-.1,0-.1h.2C338.9,543.1,339,543.2,338.9,543.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "331.9",
      "y": "538.2",
      "width": "6.4",
      "height": "3.28",
      "transform": "translate(-6.7 4.2) rotate(-0.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.2,541.5H332c-.1-.1-.1-.2-.1-.4s0-.1,0-.1h0c.1-.1,0-.2,0-.3s0,.1.1.1v-.2h.1v-.2h0v-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.1.1.2h0c0-.1,0-.1,0-.2h0c0,.1,0,.2.1.3h.1l.3-.2-.2.3h.2l-.2.2v.3h0l-.4.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541.3 332.1 541.4 332.1 541.4 332.1 541.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.1,541.1a.1.1,0,0,1,.1-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.2 541.2 332.2 541.2 332.2 541.2 332.2 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541.2 332.1 541.2 332.1 541.2 332.1 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541.1 332.1 541.1 332.1 541.1 332.1 541.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 541 332.1 541.1 332.1 541.1 332.1 541"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 541 332 541 332 541 332 541"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.2 541 332.2 541 332.2 541 332.2 541"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.8,541h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 541 332 541 332 541 332 541"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.6,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.7,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.6,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.8,540.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.1,540.9h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "332.9",
      "y": "540.8",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.9,540.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.7,540.4c0-.1,0-.1,0-.2h.1v-.3s0,.1,0,.1h.3c-.2.1-.1.3-.2.4s-.1.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.8,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.9,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.1,540.3l-.3-.3s0-.1,0-.1h.1l.3.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,540.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.3,540.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.4,539.9c0-.1,0-.1,0-.2h.2a.1.1,0,0,0,0-.1h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.1h0c.2.1.2-.1.4-.1s.1.1,0,.2h.3l-.4.3s-.1.1,0,.1h-.2a0,0,0,0,1,0,.1s-.1.1-.1.1.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.6,539.8s0,0,0,0S336.6,539.8,336.6,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335,539.5h.1a.1.1,0,0,1,0,.1H335Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M335,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.5c-.1-.1,0-.2,0-.3l.2-.2H333s-.1,0,0,0h-.1a.2.2,0,0,0,0,.2h.1s0-.1,0-.1,0,0,0,.1h.1s0,0,0,0h0c.1-.1,0-.1.1-.2s0,.1,0,.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "335",
      "y": "539.5",
      "height": "0.02"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.9,539.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.8,539.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333 539.4 333 539.4 333 539.3 333 539.3 333 539.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.9 539.3 332.9 539.3 332.9 539.3 332.9 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.2 539.3 332.2 539.3 332.2 539.3 332.2 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,539.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.4,539.2a.2.2,0,0,1,.1-.2v.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.2,539.2c0-.1.1-.2.1-.2h.1v.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.9,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.2h0s.1-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.1 539.2 333 539.2 333.1 539.2 333.1 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332.2 539.2 332.2 539.2 332.2 539.2 332.2 539.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M334.5,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.3,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.4,539.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.3 539.1 333.3 539.2 333.3 539.2 333.3 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.9 539.1 333.9 539.1 333.9 539.1 333.9 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.3 539.1 333.3 539.1 333.3 539.1 333.3 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "333.9 539.1 333.9 539.1 333.9 539.1 333.9 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,538.4s0-.1,0-.1h.3s0,.1,0,.2S336.4,538.6,336.3,538.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.3,538.4c0-.1,0-.1,0-.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "328",
      "y": "547.4",
      "width": "6.1",
      "height": "3.09",
      "transform": "translate(-301.7 652) rotate(-68.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,552.1h-1v-.2h-.1s0,0,0,0h.3s0,0,0-.1h.1c.1-.1,0-.2,0-.3l.2.2c0-.1,0-.2,0-.2v.2h.3s0-.1.1-.1-.1.1,0,.1h.1s0,.1,0,.1h.1c.1,0,0-.1,0-.1l.2.5C331.5,551.8,331.5,552,331.4,552.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.2 552 331.2 552 331.2 552 331.2 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.7,550.2h.1A.1.1,0,0,1,331.7,550.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 551.9 331.1 551.9 331.1 551.9 331.1 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 552 331 552 331 552 331 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 552 331 552 330.9 552 331 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.9 552 330.9 552 330.9 552 330.9 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.8 552 330.9 552 330.9 552 330.8 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.9 551.9 330.9 551.9 330.9 551.9 330.9 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,550.5v.2h0v-.2S331.5,550.5,331.4,550.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.8 552 330.8 552 330.8 552 330.8 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 551.1 331.1 551.1 331.1 551.1 331.1 551.1 331.1 551.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.9,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.4,546.8h-.2c0-.1,0-.1,0-.1l-.2-.2h.1c.1,0,.1-.1.1-.1s-.1-.1,0-.2.2.2.3.3.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,551s0,0,0,0S330.7,551,330.7,551Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.1,547.3l-.3.2h0l.3-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.1,548.7h-.2c.1,0,0-.1.1-.1s0-.1,0-.1h-.6c.1-.1,0-.2,0-.4h.2c.1,0,.1-.1.1-.1h.1c0-.1.1-.1,0-.1s.1.3.1.4h.1c0,.1,0,.1,0,.2v.2c.1,0,0-.1.1-.2h.1s0,.1.1.1h.1a.2.2,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.5,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.6,548.9h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.9,550.7h-.3c0-.1-.1-.1-.1-.2h.1s0,.1,0,.1h.2s0,0,0-.1h-.1l.2.2C329.9,550.7,329.9,550.7,329.9,550.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.6 548.8 330.6 548.8 330.6 548.8 330.6 548.8 330.6 548.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.9,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.8,550.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,550.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.8 550.6 329.8 550.6 329.7 550.6 329.7 550.6 329.8 550.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 550.7 329.7 550.7 329.7 550.7 329.7 550.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.5 551.2 329.5 551.2 329.5 551.2 329.5 551.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.2,549.3a.2.2,0,0,1-.1-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,550.3c-.1,0-.1-.1-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.6,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.1s0,0,0,0S329.8,550.1,329.8,550.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 550.4 329.7 550.5 329.6 550.4 329.7 550.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.4 551.2 329.4 551.2 329.4 551.2 329.4 551.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.7,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.7,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.1,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.7,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.7 550.2 329.7 550.2 329.7 550.2 329.7 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.9 549.6 329.9 549.7 329.9 549.7 329.9 549.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.7 550.2 329.7 550.2 329.7 550.2 329.7 550.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.9 549.7 329.9 549.7 329.9 549.7 329.9 549.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.6,550.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,551.1h0S329.1,551.1,329.1,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.2,547.3h-.1c0-.1-.1-.2,0-.2h.2C330.3,547.2,330.3,547.3,330.2,547.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.5,549.1h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,329.5,549.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "321.6",
      "y": "541",
      "width": "3.4",
      "height": "6.64",
      "transform": "translate(-90.4 65.1) rotate(-10.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.5,547s0,.2-.1.2l-.3.2h-.2s.1-.1,0-.1h-.3c0-.1.1-.1.1-.1h-.2a.4.4,0,0,1,0-.1h-.3c0-.1-.2-.2-.2-.3h.3v-.2l.2.2h.3c0-.1-.1-.1,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.1l.5.3A.5.5,0,0,1,325.5,547Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.3 547.1 325.3 547.1 325.3 547.1 325.3 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.8,545.1h-.1a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,324.8,545.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 547.1 325.2 547.1 325.2 547.1 325.1 547.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.2 547.2 325.2 547.2 325.2 547.2 325.2 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325.1 547.2 325.1 547.2 325.1 547.2 325.1 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.2 325 547.2 325 547.2 325 547.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.3 325 547.3 325 547.3 325 547.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.1 325 547.1 325 547.1 325 547.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,545.5a.7.7,0,0,1,0,.2h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "325 547.3 325 547.3 325 547.3 325 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,545.6h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,545.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.7,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.8,547.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.7 546.3 324.7 546.3 324.7 546.3 324.7 546.3 324.7 546.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,541.5h-.4c.1-.1,0-.1,0-.2h-.1c.1.2.3,0,.4.2s.2.1.2.2S323.4,541.5,323.4,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,546.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.3,546.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,542.2l-.2.4h-.1s0-.1,0-.1l.2-.4h.1C323.5,542.1,323.4,542.2,323.4,542.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.1,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,544H323c0-.1-.1-.1,0-.1h-.1c0,.1-.1.1-.1.2h-.3s0-.1,0-.1h-.3s0,0,0-.1h-.1c0-.2-.2-.2-.2-.4h.2c.1,0,0-.1,0-.1h.1c-.1,0,0-.1,0-.2l.4.3h.1v-.2h.1s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,542.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323,544.4h0S323,544.4,323,544.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,546.7H323l-.2-.2h.3s0,0,0,0h.1s0,.1,0,.1h.1S323.3,546.6,323.3,546.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323 544.4 323 544.5 322.9 544.5 322.9 544.4 323 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.3,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,546.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 546.6 323.2 546.6 323.1 546.6 323.1 546.6 323.2 546.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,546.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.1 546.7 323.2 546.7 323.1 546.7 323.1 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 547.3 323.3 547.3 323.3 547.3 323.2 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,546.6s0,0,0,0S323.1,546.6,323.1,546.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,545.2h0C322.9,545.1,322.9,545.1,322.8,545.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,546.4h-.3s0,0,0-.1h.3c.1,0,0,.1.1.2A.1.1,0,0,1,323,546.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,546.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323 546.5 323 546.5 323 546.5 323 546.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.1 547.3 323.1 547.3 323.1 547.3 323.1 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.7,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 546.3 322.9 546.3 322.9 546.3 322.9 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 545.6 322.8 545.6 322.8 545.6 322.8 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.9 546.3 322.9 546.3 322.9 546.3 322.9 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.7 545.7 322.8 545.7 322.8 545.7 322.7 545.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.7,543.3h-.2c-.1-.1-.1-.1-.1-.2h.2C321.7,543.1,321.8,543.2,321.7,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322,545.3h0A.1.1,0,0,1,322,545.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "320.4",
      "y": "551.3",
      "width": "7.7",
      "height": "3.93",
      "transform": "translate(-316 590.4) rotate(-62.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.4,557.3h-.2c-.2.1-.3,0-.4-.1h-.1c0-.1-.2-.1-.3-.1h.2v-.2h0v-.2h-.1c-.1-.1,0-.2-.1-.2h-.1s0,0,0,0h.4s0-.1,0-.1h.1c.1-.1,0-.3,0-.4l.2.3c0-.1,0-.2,0-.3a.9.9,0,0,1,.1.3h.4c.1,0,0-.2.1-.2s-.1.1-.1.2,0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.2s.2.4.2.6S324.5,557.2,324.4,557.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.2 557.3 324.2 557.3 324.2 557.3 324.2 557.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325,555h.1A.1.1,0,0,1,325,555Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324 557.1 324 557.1 324 557.1 324 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.9 557.2 324 557.2 323.9 557.2 323.9 557.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.9 557.2 323.9 557.2 323.8 557.2 323.9 557.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.8 557.1 323.8 557.1 323.8 557.2 323.8 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 557.2 323.8 557.2 323.7 557.2 323.7 557.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.8 557 323.8 557 323.8 557 323.8 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,555.3v.2h0l.2-.2S324.7,555.3,324.7,555.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.7 557.2 323.7 557.2 323.7 557.2 323.7 557.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.1,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,557.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.1 556.1 324.1 556.1 324.1 556.1 324.1 556.1 324.1 556.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.2,550.8H326c.1-.1,0-.1,0-.2l-.2-.3h.2c.1,0,.1-.1.1-.2s-.1-.2,0-.2.3.3.3.5.1.3,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.6,555.9s0,0,0,0S323.6,555.9,323.6,555.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,551.4l-.5.2h0l.4-.2h.1C326,551.4,325.9,551.4,325.8,551.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.5,553h-.2a.3.3,0,0,1-.1-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.7c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.1-.4h.2c.1,0,.1-.1.1-.1h.1c0-.1.1-.1.1-.2s.1.3.1.5h.1c-.1.1,0,.2-.1.3a.8.8,0,0,0,.1.3c.1,0,0-.2.1-.2h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.1,551.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.8,553.3h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.8,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,555.5h-.3c.1-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.2s0-.1,0-.1h-.1l-.2-.2h.1a.4.4,0,0,1,.3.3C322.7,555.4,322.6,555.4,322.6,555.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.8 553.2 323.8 553.2 323.8 553.2 323.8 553.2 323.8 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,555.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,555.2s0,0,0,0S322.6,555.2,322.6,555.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,555.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "322.5",
      "y": "555.2",
      "height": "0.04",
      "transform": "translate(-318.7 588.9) rotate(-62.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,555.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.4 555.4 322.4 555.4 322.4 555.4 322.4 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.1 556 322.1 556 322.1 556 322.1 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,553.7a.2.2,0,0,1-.1-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.5,554.9c-.1,0-.1-.2-.2-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.4,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,555.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.8h-.1s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.7h0S322.6,554.7,322.6,554.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.4 555.1 322.4 555.1 322.4 555.1 322.4 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.9 556 322 556 321.9 556 321.9 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.2,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.6,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 554.8 322.5 554.8 322.5 554.8 322.5 554.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 554.1 322.8 554.1 322.8 554.1 322.8 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.5 554.8 322.5 554.8 322.5 554.8 322.5 554.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.8 554.1 322.8 554.2 322.8 554.1 322.8 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,555.1h0S322.3,555.1,322.3,555.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.6,555.8h0S321.6,555.8,321.6,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.4,551.2h-.1c0-.1-.1-.2,0-.3h.3C323.6,551,323.6,551.2,323.4,551.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.3,553.3h-.1a.2.2,0,0,1,0-.2h.2C322.5,553.2,322.4,553.3,322.3,553.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "315.3",
      "y": "552.7",
      "width": "7.2",
      "height": "3.67",
      "transform": "translate(-269.5 805.5) rotate(-83.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.3,558h-.8s.1,0,0-.1h-.3s0,.1,0,.1h0a.4.4,0,0,1,0-.1H319l-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.1-.2-.1-.3l.3.2c-.1-.1-.1-.2-.1-.2l.2.3h.3c0-.1,0-.2.1-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.2l.4.5A.6.6,0,0,1,320.3,558Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.1 558 320.1 558 320.1 558 320.1 558"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.2,555.8H320a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,320.2,555.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.9 557.9 320 557.9 319.9 557.9 319.9 557.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.9 558.1 319.9 558 319.9 558.1 319.9 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.8 558 319.8 558 319.8 558 319.8 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.8 558 319.8 558 319.8 558 319.8 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 558.1 319.7 558.1 319.7 558.1 319.7 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 557.9 319.8 557.9 319.8 557.9 319.7 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.9,556.1a.8.8,0,0,1-.1.3h0c0-.1,0-.2.1-.3S320,556.1,319.9,556.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 558.1 319.7 558.1 319.7 558.1 319.7 558.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,556.3h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.7,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.6,558h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "319.7 557 319.7 557 319.7 557 319.7 557 319.7 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.6,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.9,551.6h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.1c.1,0,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.3,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.3,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.7,552.3l-.3.3h0l.3-.3h.1C319.8,552.2,319.7,552.3,319.7,552.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.2,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319,554.2h-.3c.1-.1-.1-.1,0-.2h-.1l-.2.2H318s0,0,0-.1h-.1s0,0,0-.1h0c.1-.2-.1-.3-.1-.4h.2c.1,0,0-.1.1-.2h.1c0-.1,0-.1,0-.2s.2.3.3.4h.3c0,.1-.1.1-.1.1h-.1c0,.1,0,.2,0,.3v.2c.1-.1-.1-.2,0-.2h.1c0,.1,0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.1,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.5,554.5h0S318.6,554.5,318.5,554.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.2,556.9h-.3c0-.1-.1-.1-.2-.2h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2l.3.2C318.3,556.8,318.2,556.9,318.2,556.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.5 554.5 318.5 554.5 318.5 554.5 318.5 554.5 318.5 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.2,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.1,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318,556.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318.1 556.8 318.1 556.8 318 556.8 318 556.8 318.1 556.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,556.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "318 556.9 318 556.9 318 556.9 318 556.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 557.6 317.9 557.6 317.9 557.6 317.9 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.1,555.2l-.2-.2h.3C318.2,555.1,318.2,555.2,318.1,555.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,556.5c-.1,0-.2-.1-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.9,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.3s0,0,0,0h-.2s0,0,0,0h0s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 556.6 317.9 556.7 317.9 556.7 317.9 556.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.7 557.6 317.8 557.6 317.8 557.6 317.7 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M317.9,556.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.8 556.4 317.9 556.4 317.9 556.4 317.8 556.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 555.7 317.9 555.7 317.9 555.7 317.9 555.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "317.8 556.4 317.8 556.4 317.8 556.4 317.8 556.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "317.9 555.7 317.9 555.7 317.9 555.7 317.9 555.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.8,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.5,552.9h-.2c0-.1-.1-.2-.1-.2h.3C317.6,552.7,317.6,552.9,317.5,552.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.2,555.1h-.1a.1.1,0,0,1,0-.2h.2A.1.1,0,0,1,317.2,555.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "309.7",
      "y": "555.9",
      "width": "7.5",
      "height": "3.83",
      "transform": "translate(-296.5 751.4) rotate(-78.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,554.1h.9s-.1,0,0,.1h.1l.2.2s0-.1,0-.1h.2l.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0h-.4s0,.1,0,.1h-.1c0,.1.1.2.1.4l-.3-.3c.1.1,0,.2.1.2l-.2-.3h-.4s0,.2-.1.2,0-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2l-.3-.5A.6.6,0,0,1,312.3,554.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.5 554.1 312.5 554.1 312.5 554.1 312.5 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.3,556.4h.1v.2h-.1A.1.1,0,0,1,312.3,556.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.7 554.2 312.7 554.2 312.7 554.2 312.7 554.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.7 554.1 312.7 554.1 312.7 554.1 312.7 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.8 554.1 312.8 554.1 312.8 554.1 312.8 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 554.1 312.8 554.1 312.9 554.1 312.9 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 554.1 312.9 554.1 312.9 554.1 312.9 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 554.2 312.9 554.2 312.9 554.2 312.9 554.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.5,556.1v-.3h0c-.1.1,0,.2-.1.3S312.5,556.1,312.5,556.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313 554 312.9 554 312.9 554 313 554"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,555.9h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.9,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.1,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.9 555.2 312.9 555.2 312.9 555.2 312.9 555.2 312.9 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,560.7h.2c0,.1.1.1,0,.2l.3.2h-.2c-.1,0,0,.1,0,.2s.1.1.1.2-.3-.2-.4-.4-.2-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.5,560l.4-.3h0l-.4.3h-.1C312.3,560.1,312.4,560.1,312.5,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.4,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,558.2h.2v.2c-.1,0,.1.1,0,.2s0,.1.1.1l.2-.2h.5s0,.1,0,.1h.1s0,0,0,.1h0c-.1.2.1.3,0,.4h-.3c-.1,0-.1.1-.1.2H314c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.4c0-.1.1-.1.1-.2h.1c0-.1,0-.2,0-.3v-.2c-.1,0,0,.2,0,.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.1,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.9,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.9,557.9h0S313.8,557.9,313.9,557.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.4,555.4h.4c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2l-.3-.2C314.3,555.5,314.4,555.4,314.4,555.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "313.9 557.9 313.9 557.9 313.9 557.9 313.9 557.9 313.9 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.5,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.5,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.6,555.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 555.6 314.6 555.6 314.6 555.6 314.6 555.6 314.6 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,555.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 555.5 314.6 555.4 314.6 555.4 314.6 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.8 554.7 314.8 554.7 314.8 554.7 314.8 554.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.6,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,557.2a.2.2,0,0,1,.2.2h-.3C314.3,557.3,314.3,557.2,314.3,557.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,555.9c.1,0,.2.1.2.2h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,556s0,0,0,0h.2s0,0,0,0h0s0,0,0,0h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.6,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.7 555.7 314.7 555.7 314.7 555.7 314.7 555.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.9 554.8 314.9 554.8 314.9 554.8 314.9 554.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.4,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.7,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.7 556 314.7 556 314.7 556 314.7 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 556.7 314.6 556.7 314.6 556.7 314.6 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.7 556 314.7 556 314.7 556 314.7 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "314.6 556.7 314.6 556.7 314.6 556.7 314.6 556.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.8,559.6h.2c0,.1.1.2,0,.3h-.3C314.6,559.8,314.6,559.6,314.8,559.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,557.4h.1a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,315.3,557.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "311.1",
      "y": "562.3",
      "width": "6.8",
      "height": "3.5",
      "transform": "translate(-168.2 135) rotate(-19.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,566.7H312c-.2-.1-.2-.2-.2-.3s0-.1,0-.1h0c0-.1-.1-.2-.1-.2h.2a.4.4,0,0,0,0-.2h0a.3.3,0,0,0,0-.2h0c0-.1.1-.1.1-.2V565h.1c.1,0,0,.1.1.2h0v-.2h0c.1.1.1.3.2.3h.1c.1,0,.1-.2.2-.3a.9.9,0,0,0-.1.3l.2-.2v.3l.2.3h0s-.1.1,0,.1h.2c-.1.2-.1.4-.3.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.1 566.5 312.1 566.5 312.1 566.5 312.1 566.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314,565.6a.1.1,0,0,1,0-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.1 566.3 312.1 566.3 312.1 566.3 312.1 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 566.4 312 566.4 311.9 566.4 311.9 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 566.3 311.9 566.3 311.9 566.3 311.9 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.9 566.2 311.9 566.2 311.9 566.2 311.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.8 566.2 311.8 566.2 311.8 566.2 311.8 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312 566.1 312 566.2 312 566.2 312 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.6,565.6h-.2s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "311.8 566.2 311.8 566.2 311.8 566.2 311.8 566.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.4,565.6s0,0,0,0S313.4,565.6,313.4,565.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M311.8,566h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "312.7",
      "y": "565.7",
      "height": "0.02",
      "transform": "translate(-138.4 102.7) rotate(-15.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.4,563.6v-.2h.1a1.1,1.1,0,0,0,0-.3h.4c-.1.1,0,.3-.1.5s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.8,565.2s0,0,0-.1S312.9,565.2,312.8,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,563.7h-.4s0-.1,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.9,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.9,564c-.1-.1,0-.1,0-.2v-.2h-.1s0-.1,0-.1h0a.1.1,0,0,0,0-.1h.1s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.2-.2.3-.2s.1.1.1.2h.4c-.1.1-.1.3-.3.4s-.1.1,0,.1h-.3v.2h.2c0,.1-.1.1-.1.2s.1,0,0,.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.1,563.5c.1,0,0,0,0,0S316.1,563.5,316.1,563.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M314.3,563.7a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M314.4,563.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.4c-.1-.1-.1-.2-.1-.3s.1-.2.1-.2,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0,0,0-.1h.1s0-.1,0-.1,0,0,0,.1h0s0-.1,0-.1h0c0-.1-.1-.1,0-.2s0,.1.1.1a.4.4,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "314.4 563.7 314.4 563.7 314.4 563.6 314.4 563.6 314.4 563.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.2,564.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.3h0S312.2,564.3,312.2,564.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,564.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 564.2 312.2 564.2 312.2 564.2 312.2 564.2 312.3 564.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.3,564.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.1 564.2 312.1 564.2 312.1 564.2 312.1 564.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.5 564.4 311.5 564.4 311.5 564.4 311.5 564.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.6,563.6a.2.2,0,0,1,.1-.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.4,564c-.1-.1,0-.2.1-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.1,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.9h0s0-.2,0-.1h0s0-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.7,563.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "312.3 564 312.3 564 312.3 564 312.3 564"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "311.4 564.3 311.5 564.3 311.5 564.3 311.4 564.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M313.7,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.5,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M312.6,563.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.5 563.9 312.5 563.9 312.5 563.9 312.5 563.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "313.2 563.6 313.2 563.7 313.1 563.7 313.2 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "312.5 563.9 312.5 563.9 312.5 563.9 312.5 563.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "313.1 563.6 313.1 563.7 313.1 563.7 313.1 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M312.2,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M311.3,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M315.3,562.2s0-.1,0-.2h.3s.1.1,0,.2S315.4,562.2,315.3,562.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M313.3,562.8s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "317.3",
      "y": "565.8",
      "width": "3.3",
      "height": "6.36",
      "transform": "translate(-328.4 648.9) rotate(-67.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.2,568.6s.1.1.1.2,0,.2,0,.4h-.1s0,.1,0,.1h-.1c-.1,0,0,.2-.1.2s0-.1-.1-.2h-.4s0,0,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1v.2h0c0-.1.1-.2.1-.3h-.1a.1.1,0,0,0,0-.1h-.3l.3-.2h0a.7.7,0,0,0,0-.3h.1l.5-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 568.8 322.2 568.8 322.2 568.8 322.2 568.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.3,568.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 568.9 322.1 568.9 322.1 568.9 322.1 568.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 569 322.2 569 322.2 569 322.2 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 569 322.1 569 322.1 569.1 322.1 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.1 569.1 322.1 569.1 322.1 569.1 322.1 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 569.2 322.2 569.1 322.2 569.1 322.2 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322 569.1 322 569.1 322 569.1 322 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,568.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.2 569.2 322.2 569.2 322.2 569.2 322.2 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.7,568.6s0,0,0,0h0S320.7,568.6,320.7,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,568.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.7,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.4,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.1,569.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.3 568.9 321.3 568.9 321.3 568.9 321.3 568.9 321.3 568.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.3,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M316.7,567.5c0,.1,0,.1,0,.2h-.1l-.2.2s0-.1,0-.1H316c.2,0,.2-.2.4-.3h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.9,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.1,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,567.8l.2.4h-.1l-.2-.4s-.1-.1,0-.1S317.3,567.8,317.3,567.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,569.3h0S320.8,569.3,320.8,569.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.7,568.8v.2h-.4c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1,0,0,.1h-.4s0-.1,0-.1-.2,0-.4,0,0-.2,0-.2h.2s0-.1,0-.1h.4a0,0,0,0,1,0-.1h.2s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.5,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M318.9,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M318.9,569.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.2c0,.1-.1.2-.1.3h0s0,0,0-.1h0a.2.2,0,0,0,.1-.2h0s-.1,0,0-.1h-.2v.2s.1-.1,0-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "318.9 569.4 318.9 569.4 318.9 569.4 318.8 569.4 318.9 569.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.8,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.8,570.3h0S320.8,570.3,320.8,570.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.7 570.3 320.7 570.3 320.7 570.3 320.7 570.3 320.7 570.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.6,570.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.8 570.4 320.8 570.3 320.8 570.4 320.8 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.3 570.6 321.3 570.6 321.3 570.6 321.3 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.4,569.8h-.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.4,570.3l-.2.2h0a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,320.4,570.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.6,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,570.3h0s-.1.1-.1.1h0s0,0,0,0h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "320.5 570.4 320.5 570.4 320.5 570.4 320.5 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "321.3 570.7 321.3 570.7 321.3 570.7 321.3 570.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M319.2,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.3,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M320.2,570.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 570.4 320.3 570.4 320.3 570.4 320.3 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.7 570.1 319.7 570.1 319.7 570.1 319.7 570.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "320.3 570.4 320.3 570.4 320.3 570.4 320.3 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "319.7 570.2 319.7 570.1 319.7 570.1 319.7 570.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M320.5,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.2,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M317.3,569.8H317C317.1,569.7,317.3,569.7,317.3,569.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M319.1,570.6h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "323",
      "y": "566.7",
      "width": "3.1",
      "height": "6.05",
      "transform": "translate(-331.1 566.9) rotate(-60.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M321.3,569.6s-.1-.1,0-.2,0-.2.1-.3h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.2s0,.1,0,.2h.4s0,0,0-.1h.3c0,.1-.1.1,0,.2h.2c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h0a.7.7,0,0,0-.1.3h-.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 569.5 321.4 569.5 321.4 569.5 321.4 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,570.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.3 321.5 569.3 321.5 569.3 321.5 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.4 569.3 321.4 569.3 321.4 569.3 321.4 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.2 321.5 569.2 321.5 569.2 321.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.2 321.5 569.2 321.5 569.2 321.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.1 321.5 569.1 321.5 569.1 321.5 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.6 569.2 321.6 569.2 321.6 569.2 321.6 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,569.9h-.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "321.5 569.1 321.4 569.1 321.4 569.1 321.5 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.8,569.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.8,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M321.6,569h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "322.3 569.5 322.3 569.5 322.3 569.4 322.3 569.4 322.3 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.3,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.4,571.3v-.2h.1l.2-.2h.3c-.2,0-.2.2-.4.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.4,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.5,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.7,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.9,571l-.2-.4h.1v.4s0,.1,0,.1S325.9,571,325.9,571Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.8,569.2h0S322.8,569.2,322.8,569.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.7,569.9h.5c0-.1,0-.1-.1-.2h0s0-.1,0-.1h.1s-.1,0,0-.1h.4s0,0,0,.1.2,0,.3.1,0,.1-.1.2h-.2s0,.1,0,.1h-.5s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M325.8,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.6,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.3c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0s.1,0,0,.1h.3s-.1.1,0,.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "324.6 569.3 324.6 569.3 324.6 569.3 324.6 569.3 324.6 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M322.9,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.9,568.2h0S322.9,568.2,322.9,568.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323 568.3 323 568.2 323 568.2 323 568.2 323 568.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.1,568.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323 568.2 323 568.2 323 568.2 323 568.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 567.9 322.4 567.9 322.4 567.9 322.5 567.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.2,568.8h.2a.2.2,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.3,568.2h.3a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,323.3,568.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.1,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.3h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,568.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.2 568.1 323.2 568.1 323.2 568.1 323.2 568.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "322.5 567.8 322.5 567.8 322.5 567.8 322.5 567.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M324.4,568.8h0S324.4,568.8,324.4,568.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M323.5,568.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.4 568.2 323.4 568.2 323.4 568.2 323.4 568.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.9 568.5 323.9 568.5 323.9 568.5 323.9 568.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "323.4 568.2 323.4 568.2 323.4 568.2 323.4 568.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "323.9 568.5 323.9 568.5 323.9 568.5 323.9 568.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M323.2,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M322.6,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.2,569.1h.2C326.3,569.3,326.2,569.2,326.2,569.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M324.6,568.2h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "326.3",
      "y": "570.2",
      "width": "6",
      "height": "3.06",
      "transform": "translate(-63.5 41.6) rotate(-6.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.9,569.9h.1c.1.1.1.2.1.3s0,.1,0,.1h0c-.1.1.1.2,0,.2H332v.2h0v.2h0v.2c0,.1,0,.1,0,.1h-.1c-.1,0,0-.1-.1-.2h0s0,.1,0,.2h0c0-.1,0-.2-.1-.3h-.1l-.3.2V571h-.2l.2-.2v-.3h0l.3-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.9 570.1 332 570.1 332 570.1 331.9 570.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.1,570.5a.1.1,0,0,1,0,.1H330s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.9 570.3 331.9 570.3 331.9 570.3 331.9 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 570.3 332 570.3 332 570.3 332 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 570.4 332 570.4 332 570.4 332 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332 570.4 332 570.4 332 570.4 332 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 570.4 332.1 570.4 332.1 570.4 332.1 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.9 570.4 331.9 570.4 331.9 570.4 331.9 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,570.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "332.1 570.4 332.1 570.4 332.1 570.4 332.1 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.5,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332,570.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.2 570.6 331.2 570.6 331.2 570.7 331.2 570.7 331.2 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,570.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M326.8,571.6s0,.1,0,.2h-.1v.3s0-.1,0-.1h-.3c.1-.1.1-.3.2-.4s.1-.2.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.4,571.6l.3.2s0,.1,0,.1h-.1l-.3-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331,571.2h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,571.7c0,.1,0,.1,0,.2H329a.1.1,0,0,0,0,.1h-.1s0,.1,0,.1h-.1s-.1.1,0,.1h0c-.2,0-.2.1-.3.1s-.1-.1-.1-.2h-.3l.3-.3s.1-.1,0-.1h.2s.1-.1.1-.1-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M327.9,571.9s0,0,0,0S328,571.9,327.9,571.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.5,572.1h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,571.9c.1.1,0,.2,0,.3v.2h0s0,0,0,0h0s0,0,0,0h.1a.2.2,0,0,0,0-.2h-.1s0,.1,0,.1,0,0,0-.1h-.1s0,0,0,0h0c-.1.1,0,.1,0,.2s0-.1,0-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.4 572.1 329.4 572.1 329.4 572.1 329.4 572.1 329.4 572.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.4,571.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.5,572h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.4 572 331.4 572 331.4 572.1 331.4 572.1 331.4 572"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.3,572.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.4 572.1 331.4 572 331.5 572.1 331.4 572.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332 572 332 572 332 572 332 572"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.3,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.1,572.3a.2.2,0,0,1-.1.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.2,572.2c0,.1-.1.2-.1.2h-.2a.1.1,0,0,1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,572.2h0s0,.1,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.9,572.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.3 572.2 331.3 572.2 331.3 572.2 331.3 572.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "332 572.1 332 572.1 332 572.1 332 572.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.9,572.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.9,572.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 572.3 331.1 572.3 331.1 572.3 331.1 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.5 572.3 330.5 572.3 330.5 572.3 330.5 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331.1 572.3 331.1 572.3 331.1 572.3 331.1 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.5 572.4 330.5 572.3 330.5 572.4 330.5 572.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.3,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.1,572.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M328.3,573.2s0,.1,0,.1h-.3s0-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.2,573s0,.1,0,.1H330a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "331",
      "y": "557.5",
      "width": "4.1",
      "height": "8.1",
      "transform": "translate(-270.6 810.1) rotate(-81.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.1,563s-.2-.1-.1-.2-.1-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2l.2-.2h.1v-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1,0,.2,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.1l-.6.4A.7.7,0,0,1,329.1,563Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.8 329.1 562.8 329.1 562.8 329.1 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.6,562.9v-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.2 562.6 329.2 562.6 329.2 562.6 329.2 562.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.5 329.1 562.6 329.1 562.6 329.1 562.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.4 329.1 562.5 329.1 562.4 329.1 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.4 329.1 562.4 329.1 562.4 329.1 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.1 562.3 329.1 562.4 329.1 562.3 329.1 562.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329.2 562.4 329.3 562.4 329.3 562.4 329.2 562.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M331.2,562.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "329 562.3 329 562.3 329 562.3 329 562.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,562.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,562.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,562.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.1,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M329.2,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "330.3 562.3 330.2 562.3 330.2 562.3 330.3 562.3 330.3 562.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.2,562.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.3,562.7c0-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.2,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.3,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.6,562.4l-.4-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S335.6,562.5,335.6,562.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333.5,561.7c0-.1.1-.1.1-.2h.2c.1.1.1-.1.2,0h.1l-.2-.2h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5-.1s.1.2,0,.3h.2s0,.1,0,.1h.2l-.5.3s-.1.1-.1.1h.1c.1,0,0,.1,0,.1h-.8c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335,561.8c.1,0,0,0,0,.1S335,561.8,335,561.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M333,561.1h.2a.1.1,0,0,1,0,.1H333Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M333.1,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.4,560.6c-.1-.1,0-.3,0-.4l.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.1a.4.4,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "333.1 561 333.1 561 333.1 561 333.1 561 333.1 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.5,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.6 560.5 330.6 560.5 330.6 560.4 330.6 560.4 330.6 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.6,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M330.7,560.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.5 560.4 330.4 560.4 330.4 560.4 330.5 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 560.3 329.7 560.3 329.7 560.3 329.7 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.6,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.3,560.6c0-.1.1-.2.2-.2a.3.3,0,0,1,.1.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.9,560.3c0-.1.1-.2.2-.3h.1v.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.6,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.5,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,560.4h0c0-.1.1-.2,0-.2h0s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "330.7 560.3 330.7 560.3 330.7 560.3 330.7 560.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "329.7 560.1 329.7 560.1 329.7 560.1 329.7 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.1,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,560.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M332.6,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M331.2,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 560.3 331 560.3 331 560.3 331 560.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.8 560.4 331.8 560.4 331.8 560.4 331.8 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "331 560.3 331 560.3 331 560.3 331 560.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "331.8 560.3 331.8 560.4 331.8 560.4 331.8 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M330.7,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M329.7,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M334.9,560c0-.1,0-.1,0-.2h.3c0,.1,0,.2-.1.2S335,560.1,334.9,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M332.5,559.6c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "333.2",
      "y": "561",
      "width": "8.7",
      "height": "4.44",
      "transform": "translate(-318.2 529.1) rotate(-56.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338,558.7h.3c.2-.1.3.1.5.1s.1.1.1.1h0c0,.1.2.1.3.2h-.3v.2h.1s0,0,0,.1H339a.3.3,0,0,0,.1.2h.1c.1.1,0,.2.1.3h-.1s0,.1,0,.1h.2c-.1,0-.3-.2-.4-.2h-.1c-.1.1,0,.3,0,.4a1.2,1.2,0,0,0-.2-.4c0,.1,0,.2,0,.3a1.1,1.1,0,0,1,0-.4h-.4c-.1,0-.1.2-.2.2s.1-.1.1-.2,0-.1,0-.2h0s0-.1,0-.1h-.1c-.1,0,0,.1-.1.2s-.1-.5-.1-.7S337.8,558.8,338,558.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.2 558.8 338.2 558.8 338.2 558.8 338.2 558.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337,561.2v.2h-.2C336.8,561.3,336.9,561.2,337,561.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.4 559 338.4 559 338.4 559 338.4 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.5 558.9 338.5 558.9 338.5 558.9 338.5 558.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 559 338.6 559 338.6 559 338.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 559 338.6 559 338.6 559 338.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.7 559 338.7 559 338.7 559 338.7 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.6 559.1 338.6 559.1 338.6 559.1 338.6 559.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.4,560.9l.2-.2h0l-.2.2S337.4,560.9,337.4,560.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.8 558.9 338.7 558.9 338.7 558.9 338.8 558.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M337.6,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.2,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.8,559.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.1 560.1 338.1 560.1 338.2 560.1 338.2 560.1 338.1 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.3,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335,565.8h.2c-.1.1,0,.1,0,.2l.2.4h-.2c-.1,0-.1.1-.1.2s0,.2,0,.2-.3-.3-.3-.6-.1-.3.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.7,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.4,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.7,560.4s0,0,0,0S338.6,560.4,338.7,560.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.4,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M335.6,565.2l.5-.2h-.7C335.4,565.2,335.5,565.2,335.6,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.4,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M337.3,563.5l.2.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.2s0,.1,0,.1h.5s0,.1,0,.1h.2c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.2.5h-.3c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1-.1.2s-.1-.4,0-.6,0-.1-.1-.1h0c.1-.1.1-.2.1-.3a.9.9,0,0,0,0-.3c-.1,0,0,.2-.1.3h-.1c0-.1.1-.2-.1-.2h-.1a.4.4,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.5,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.1,563.4h.1s0,.1,0,.1H338s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.7,561c.2,0,.2.1.4.2s.1.2,0,.3H340s0-.1,0-.1h-.3c0,.1.1,0,.1.1h-.1c0,.1,0,.1,0,.1h0s0,.1,0,.1h0c0,.1.2.1.2.2h-.1a.5.5,0,0,1-.3-.4C339.6,561.1,339.7,561.1,339.7,561Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.1 563.5 338.1 563.5 338.1 563.5 338.1 563.5 338.1 563.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.3s0,0,0,0S339.7,561.3,339.7,561.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.9,561.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.8 561.3 339.8 561.3 339.8 561.3 339.8 561.3 339.8 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 561.2 339.9 561.2 339.9 561.2 339.9 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.4 560.5 340.4 560.5 340.4 560.5 340.4 560.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.9,562.9a.3.3,0,0,1,.1.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,561.7c.1.1.1.2.2.3h-.4c-.1-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.9,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.8h.2s.1,0,0,.1h-.1s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.6,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.9 561.5 339.9 561.5 339.9 561.5 339.9 561.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.6 560.6 340.5 560.6 340.5 560.6 340.6 560.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M338.9,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,562h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.8 561.8 339.8 561.8 339.8 561.8 339.8 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.3 562.6 339.3 562.5 339.3 562.5 339.3 562.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.8 561.8 339.8 561.8 339.8 561.8 339.8 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 562.5 339.3 562.5 339.4 562.5 339.4 562.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340,561.5h0S340,561.5,340,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.9,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.2,565.7h.2c0,.1,0,.2-.1.3h-.1l-.2-.2C338,565.9,338.1,565.7,338.2,565.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.8,563.5h.1a.2.2,0,0,1-.1.2h-.2C339.6,563.6,339.7,563.5,339.8,563.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "338",
      "y": "564.1",
      "width": "8.5",
      "height": "4.35",
      "transform": "translate(-183.6 164.6) rotate(-21.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,569.7h-.2c-.2-.1-.2-.3-.3-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.5.5,0,0,0,0-.3h.1a.3.3,0,0,0,0-.3H339c0-.1.1-.2.1-.3v-.2h.1c.1,0,0,.2.2.2h0v-.2h0c.1.1.1.3.2.4h.1c.2,0,.2-.2.3-.3a1.2,1.2,0,0,0-.1.4l.2-.2-.2.3.3.3h0v.2h0s-.1.1,0,.1h0c.1.1.1-.1.2-.1s-.1.5-.3.7S339.6,569.8,339.4,569.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.3 569.5 339.3 569.5 339.3 569.5 339.3 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.6,568.3a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.3 569.3 339.3 569.3 339.3 569.3 339.3 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 569.3 339.1 569.3 339.1 569.3 339.1 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 569.2 339.1 569.2 339.1 569.2 339.1 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.1 569.1 339.1 569.2 339.1 569.2 339.1 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339 569.1 339 569.2 339 569.1 339 569.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.2 569.1 339.2 569.1 339.2 569.1 339.2 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.1,568.3h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "338.9 569.1 339 569.1 338.9 569.1 338.9 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.1,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M340.9,568.3s0,0,0,0S340.9,568.3,340.9,568.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339,568.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "340.1 568.5 340.1 568.5 340.1 568.5 340.1 568.5 340.1 568.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,565.7c-.1,0-.1-.1-.1-.2s0-.1.1-.1a1.4,1.4,0,0,0,0-.4v.2h.2l.2-.2c-.2.2,0,.4-.1.6s-.1.3-.3.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.9s0-.1,0-.1S340.2,567.8,340.2,567.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,565.9l-.5-.2s-.1-.1,0-.1h.1l.5.2H345Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.7,566.2c-.1-.1,0-.2-.1-.2v-.2c.1,0,.1-.1.2-.1s.1-.1.1-.1h-.4s.1-.1,0-.1h0a.1.1,0,0,0-.1-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.3.4-.3s.2.1.1.2h.5c-.1.1-.1.4-.3.5s-.1.1,0,.1h-.1l-.3.2v.3c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1.1.1a.3.3,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,565.5c.1,0,0,0,0,.1S344.1,565.6,344.1,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342,565.9a.2.2,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M342,565.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.9c-.1-.1-.1-.2-.2-.4s.1-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0-.1,0-.1h.1c0-.1-.1-.1,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.2,0-.3s0,.1.1.1a.5.5,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342 565.9 342 565.9 342 565.8 342 565.8 342 565.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.4,566.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.7h0S339.3,566.7,339.3,566.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.3,566.7h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 566.7 339.4 566.7 339.4 566.6 339.4 566.6 339.4 566.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.5,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.5,566.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.3 566.7 339.3 566.7 339.2 566.7 339.3 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "338.5 566.9 338.5 567 338.5 567 338.5 566.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M341.1,565.9a.3.3,0,0,1,.1-.3l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.6,566.3c-.1-.1,0-.2.1-.4h.3a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.2,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,566.3h0c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "339.4 566.4 339.4 566.4 339.4 566.4 339.4 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "338.4 566.8 338.4 566.8 338.4 566.8 338.4 566.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.8,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,566.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M341.2,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.7,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M339.9,566.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.7 566.2 339.7 566.3 339.7 566.3 339.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.5 565.9 340.5 565.9 340.5 565.9 340.5 565.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "339.7 566.2 339.7 566.2 339.7 566.2 339.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "340.4 565.9 340.4 565.9 340.4 565.9 340.4 565.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M339.4,566.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.2,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.1,563.9c-.1,0-.1-.1-.1-.2s.1-.2.2-.2h.1c0,.1.1.1,0,.2S343.2,564.1,343.1,563.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M340.7,564.9c-.1-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "344.3",
      "y": "567",
      "width": "8.6",
      "height": "4.42",
      "transform": "translate(-259.4 293.7) rotate(-34.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,573.2h-.3c-.2,0-.3-.2-.4-.3s0-.1-.1-.1h0c0-.1-.2-.2-.2-.3h.2a.5.5,0,0,0,0-.3h-.1s0-.1,0-.1h.1a.3.3,0,0,0,0-.3h-.1c0-.1.1-.2,0-.3v-.2h.1c.1,0,.1.2.2.1s0-.1,0-.1v-.2h0c.1.1.1.3.3.3h.1c.1-.1.1-.3.2-.4a1.2,1.2,0,0,0,0,.4c0-.1.1-.2.1-.2a1.1,1.1,0,0,1-.1.4l.3.3h0c0,.1-.1.1,0,.2h0c0,.1-.1.1,0,.1h.1c.1,0,.1-.1.1-.1s0,.5-.1.7S346.7,573.2,346.5,573.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.3 573.1 346.3 573.1 346.3 573.1 346.3 573.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.4,571.3a.1.1,0,0,1,0-.2h.2c.1,0,0,.1.1.1S348.5,571.4,348.4,571.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.2 572.8 346.3 572.9 346.3 572.8 346.2 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 572.9 346.1 572.9 346.1 572.9 346.1 572.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 572.8 346.1 572.8 346.1 572.8 346.1 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 572.8 346.1 572.8 346.1 572.8 346 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 572.8 346 572.8 345.9 572.8 345.9 572.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 572.7 346.1 572.7 346.1 572.7 346.1 572.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,571.4l-.3.2s0,0,0-.1h.3S347.9,571.5,347.9,571.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 572.8 345.9 572.8 345.9 572.8 345.9 572.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.8,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,572.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.9 571.9 346.9 571.9 346.9 571.9 346.9 571.9 346.9 571.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.7,571.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,567.8l-.2-.2c.1,0,0-.1.1-.2a1.4,1.4,0,0,0-.1-.4h.3c0-.1,0-.2.1-.2s.1.4,0,.6,0,.3-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.4,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,571.2s0-.1,0-.1S346.9,571.2,346.8,571.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.5,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.1,568.2h-.6s-.1,0,0-.1h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.9,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,569.1v-.2a.3.3,0,0,1,0-.2c.1,0,.1-.2.2-.1s.1-.1,0-.1h-.3s0,0,0-.1h-.2s0-.1,0-.1h0v-.2h.1c0-.1,0-.1,0-.1h.1c-.1,0,0-.1,0-.2h.1c.2-.1.1-.3.3-.4l.2.2h.4c-.1.2-.1.4-.2.6s0,.1,0,.1h0l-.2.2v.3c.1,0,.1-.2.2-.2h.1c0,.1-.1.2,0,.2h.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.3,568.1c.1,0,0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.5c-.2,0-.2-.2-.2-.3s0-.2.1-.3h0s0,.1,0,.1h0l.2.2s0,0,0-.1h.1s0-.1,0-.1h-.1c0-.1-.1,0,0-.1h.1s0-.1,0-.1h0c0-.1-.1-.2-.1-.3h.1a.5.5,0,0,1,.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.2 568.8 348.2 568.8 348.2 568.8 348.2 568.8 348.2 568.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,570.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.8 570.2 345.8 570.2 345.8 570.2 345.8 570.2 345.8 570.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,570.1s0,0,0,0S345.8,570.1,345.8,570.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,570.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.7 570.2 345.7 570.3 345.6 570.3 345.7 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345 570.7 345 570.7 344.9 570.7 345 570.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,569a.3.3,0,0,1,0-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,569.9c-.1-.1,0-.2,0-.4h.3a.2.2,0,0,1,.1.2c0,.1-.2,0-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,569.8h0c0-.1,0-.2-.1-.2h0s-.1-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,569.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.8 569.9 345.8 570 345.8 569.9 345.8 569.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "344.8 570.6 344.9 570.6 344.9 570.6 344.8 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.1,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.4,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.2,569.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 569.7 346 569.8 346 569.8 346 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.7 569.2 346.7 569.2 346.7 569.2 346.7 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 569.7 346 569.7 346 569.7 346 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.7 569.2 346.7 569.3 346.7 569.2 346.7 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,569.9h0S345.7,569.9,345.7,569.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.6,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,566.7v-.2c0-.1.1-.2.2-.2h.1c0,.1.1.1.1.2S349,566.8,348.9,566.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.7,568.2c-.1,0,0-.1-.1-.2h.2a.2.2,0,0,1,0,.2A.2.2,0,0,1,346.7,568.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "349.8",
      "y": "566.5",
      "width": "6.1",
      "height": "3.14",
      "transform": "translate(-95.2 71.6) rotate(-10.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.4,570.1h-.2c-.1-.1-.1-.2-.2-.3s0-.1,0-.1h0c.1-.1-.1-.2-.1-.2h.1v-.2h0a.2.2,0,0,0,.1-.2h0c0-.1.1-.1.1-.2h0c.1,0,0,.1.1.2h0s0-.1,0-.2h0c.1.1,0,.2.1.3h.1l.2-.2v.3h.2l-.2.2v.3h.1l-.3.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 570 350.3 570 350.3 570 350.3 570"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,569.4a.1.1,0,0,1,0-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 569.8 350.3 569.8 350.3 569.8 350.3 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 569.8 350.2 569.8 350.2 569.8 350.2 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 569.7 350.2 569.7 350.2 569.7 350.2 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 569.7 350.2 569.7 350.2 569.7 350.2 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 569.6 350.1 569.7 350.1 569.7 350.1 569.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.3 569.6 350.3 569.6 350.3 569.6 350.3 569.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,569.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.1 569.6 350.1 569.6 350.1 569.6 350.1 569.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.7,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.7,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,569.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351 569.4 351 569.4 351 569.4 351 569.4 351 569.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,568.1c-.1,0,0-.1-.1-.2h.1v-.3h.3c-.1.1,0,.3-.2.4s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.9,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,568.2l-.4-.2s0-.1,0-.1h.1l.3.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.2,568.8h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.1,568.1c0-.1,0-.1,0-.2h.1a.1.1,0,0,0,0-.1h.1s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.2-.2.3-.2s.1.1.1.2h.3l-.3.3s-.1.1,0,.1h-.3v.2h.2s-.1.1-.1.1.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,567.8c.1,0,0,0,0,0S354.3,567.8,354.3,567.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.7,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.7,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568.1c-.1-.1,0-.2-.1-.3s.1-.1.1-.2h0s0,0,0,0h0s0,0,0,0h-.1a.2.2,0,0,0,0,.2s0,0,0-.1h0s0-.1,0-.1,0,0,0,.1h.1c0-.1,0-.1,0-.2s0,.1,0,.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.7 567.8 352.7 567.8 352.7 567.7 352.7 567.7 352.7 567.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,568.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568h0S350.7,568,350.7,568Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,568h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.8 568 350.8 568 350.8 567.9 350.8 567.9 350.8 568"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.8,567.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 567.9 350.7 568 350.7 567.9 350.7 567.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.1 568 350.1 568 350.1 568 350.1 568"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,567.6a.2.2,0,0,1,.1-.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,567.8c0-.1.1-.2.1-.2h.2a.1.1,0,0,1,0,.1H351Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,567.7h0s0-.1,0-.1h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.8 567.8 350.8 567.8 350.8 567.8 350.8 567.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.1 567.9 350.1 567.9 350.1 567.9 350.1 567.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.2,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351 567.7 351 567.7 351 567.7 351 567.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.7 567.6 351.7 567.6 351.6 567.6 351.7 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351 567.7 351 567.7 351 567.7 351 567.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.6 567.6 351.6 567.6 351.6 567.6 351.6 567.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.8,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.8,566.6s0-.1,0-.1h.3s0,.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,566.9s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351.8",
      "y": "555.6",
      "width": "4",
      "height": "7.81",
      "transform": "translate(-241.6 270.2) rotate(-31.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,561.5c0,.1,0,.2-.1.2s-.2.2-.3.4h-.2s0-.1,0-.1-.2.1-.3.2.1-.1.1-.2h-1.1c0-.1.1-.1.1-.2h-.3c.1-.1.3-.1.3-.3h0l-.3-.2h.5l.3-.3c0-.1-.1-.1-.1-.2v.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1-.1-.1-.1l.6.2C357.1,561.2,357.3,561.3,357.3,561.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 561.6 357.1 561.6 357.1 561.7 357.1 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,559.7h-.2v-.2h.1A.1.1,0,0,1,355.7,559.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 561.7 356.9 561.7 356.9 561.7 356.9 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 561.8 357 561.8 357 561.8 357 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 561.8 356.9 561.8 356.9 561.9 356.9 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 561.9 356.9 561.9 356.9 561.9 356.8 561.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 562 356.9 562 356.8 562 356.8 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.7 561.8 356.8 561.8 356.8 561.8 356.7 561.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,560.2v.3h-.1c0-.1-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 562 356.9 562 356.9 562 356.8 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.8,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,561.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.7,562h0S356.7,562,356.7,562Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.1 561.1 356.1 561.1 356.1 561.1 356.1 561.1 356.1 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,561.3h0S356.1,561.2,356.1,561.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,556.4H352c0-.1-.1-.1-.1-.2h-.2c.2.1.4-.1.6,0s.3,0,.3.2S352.6,556.4,352.6,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.9,557.1a1.3,1.3,0,0,1-.1.5h-.1s0-.1,0-.1a3,3,0,0,0,.1-.5s0-.1.1-.1S352.9,557.1,352.9,557.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.6,559.1h-.4c0-.1-.1-.1-.1-.2H353c0,.1-.1.2,0,.3h-.1c-.1,0,0,.1,0,.1h-.2s0,.1,0,.1h-.4s0-.1,0-.1h-.1c0-.2-.3-.1-.3-.3l.2-.2c0-.1,0-.1-.1-.2h.1v-.2l.5.2h.1a.3.3,0,0,0,0-.2h.1c.1,0,0,.1.1.2s-.1.1,0,.2l.2.2h.2c0-.1-.2-.1-.2-.2h.1c.1,0,.1.1.2,0h.1a.3.3,0,0,1,.3.2A.5.5,0,0,1,353.6,559.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,559.8h0A.1.1,0,0,1,353.5,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.4,559.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,562c0,.1-.2.1-.3.2h0c0-.1.1,0,0-.1h.2c.1,0,0-.1,0-.1h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 559.8 353.4 559.8 353.4 559.8 353.4 559.8 353.4 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.7,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.7,562h0S354.6,562,354.7,562Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,562.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.5 562 354.5 562 354.5 562 354.5 562 354.5 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.6 562.1 354.6 562.1 354.6 562.2 354.6 562.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.9 562.8 355 562.8 355 562.8 354.9 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.5,560.6h-.3v-.2h.1C353.5,560.5,353.6,560.6,353.5,560.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,561.9h-.3s0-.1,0-.1a.3.3,0,0,0,.1-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,354.2,561.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,562.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.7H354s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.3 562 354.3 562 354.3 562 354.3 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.8 562.9 354.8 562.9 354.8 562.9 354.8 562.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.1,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.3,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354,561.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.1 561.8 354.1 561.8 354.1 561.8 354.1 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.7 561.1 353.7 561.1 353.7 561.1 353.7 561.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.1 561.8 354.1 561.8 354.1 561.8 354.1 561.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.7 561.2 353.7 561.2 353.7 561.2 353.7 561.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,563.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.5,559.1h-.2c-.1,0-.2-.1-.2-.2h.2C351.4,558.8,351.6,559,351.5,559.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.7,561.2h-.1A.1.1,0,0,1,352.7,561.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "356.4",
      "y": "560.9",
      "width": "7.4",
      "height": "3.79",
      "transform": "translate(-234.9 866.9) rotate(-84.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,566.4h-.8s.1,0,0-.1h-.3s0,.1,0,.1h0a.4.4,0,0,1,0-.1h-.3l-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.1-.2-.1-.4l.3.2c-.1-.1-.1-.2-.1-.2l.2.3h.4c0-.1,0-.2.1-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.2l.4.5A.6.6,0,0,1,361.6,566.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.4 566.4 361.4 566.4 361.4 566.4 361.4 566.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.4,564.1h-.1a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,361.4,564.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.2 566.3 361.2 566.4 361.2 566.3 361.2 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.2 566.5 361.2 566.5 361.2 566.5 361.2 566.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.1 566.4 361.1 566.4 361.1 566.4 361.1 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361 566.4 361 566.4 361 566.4 361 566.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 566.5 361 566.5 361 566.5 360.9 566.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361 566.3 361 566.3 361 566.3 361 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.1,564.5a.8.8,0,0,1,0,.3h0c0-.1,0-.2.1-.3S361.2,564.5,361.1,564.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 566.5 361 566.5 360.9 566.5 360.9 566.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,564.6h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.9,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.8,566.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 565.4 360.9 565.4 360.9 565.4 360.9 565.4 360.9 565.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.8,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.9,559.9h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.2c.1,0,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,560.6l-.3.4h0l.3-.3h.1C360.9,560.5,360.8,560.6,360.8,560.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.3,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.3,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,562.5H360v-.2c.1-.1-.1-.1,0-.2h-.1l-.2.2h-.5s0-.1,0-.1H359s0,0,0-.1h0c.1-.2-.1-.3-.1-.4h.2c.1,0,0-.1,0-.2h.1c0-.1,0-.1,0-.2s.2.3.3.4h.4c0,.1-.1.1-.1.2h-.1c0,.1,0,.2,0,.3v.2c.1-.1-.1-.2,0-.2h.1c0,.1,0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.7,562.9h0S359.7,562.9,359.7,562.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,565.4H359c0-.1-.1-.1-.2-.2h.2s0,0,0,0h.2s0-.1,0-.1H359l.3.2C359.4,565.2,359.4,565.3,359.4,565.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.6 562.9 359.6 562.9 359.6 562.9 359.6 562.9 359.6 562.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.3,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.3,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,565.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 565.2 359.2 565.2 359.2 565.2 359.2 565.2 359.2 565.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.2,565.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 565.3 359.2 565.3 359.1 565.3 359.1 565.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 566 359.1 566 359.1 566.1 359.1 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,563.6l-.2-.2h.3C359.3,563.5,359.3,563.6,359.2,563.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,564.9c-.1,0-.2-.1-.3-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,564.7s0,0,0,0h-.2s0,0,0,0h0s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,564.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 565.1 359 565.1 359 565.1 359 565.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 566 358.9 566 358.9 566 358.9 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,564.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 564.8 359 564.8 359 564.8 359 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 564.1 359.1 564.1 359.1 564.1 359.1 564.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 564.8 359 564.8 359 564.8 359 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 564.1 359 564.1 359 564.1 359 564.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,566h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,561.2h-.2c0-.1-.1-.2-.1-.2h.3C358.7,561,358.7,561.2,358.6,561.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,563.5h-.1a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,358.3,563.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "359.1",
      "y": "550.7",
      "width": "4.5",
      "height": "8.72",
      "transform": "translate(-290 434.7) rotate(-46.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.9c0-.1-.1-.2,0-.3s.1-.3.2-.5h.2c.1,0,0,.1.1.1s.1-.2.2-.3-.1.2,0,.3h.9v-.2h.1c0,.1-.1.1-.1.2h.1v-.2h0c-.1.1-.3.2-.2.4h0c.1.1.3,0,.4.1h-.5l-.2.4c0,.1.2.1.1.2h-.3s0,0,0,.1H358c0,.1.1,0,.1.1h-.7C357.2,554.2,357,554.1,356.9,553.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.1 553.7 357.1 553.7 357.1 553.7 357.1 553.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,555.4h.2v.2h-.1C359.3,555.6,359.2,555.5,359.2,555.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.6 357.3 553.6 357.3 553.6 357.3 553.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 553.5 357.2 553.5 357.2 553.5 357.2 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.4 357.3 553.4 357.3 553.4 357.3 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.4 357.3 553.4 357.3 553.4 357.3 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.3 357.3 553.3 357.3 553.3 357.3 553.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.4 553.4 357.4 553.4 357.4 553.4 357.4 553.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,554.9l-.2-.2h.1l.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.3 553.2 357.3 553.2 357.3 553.2 357.3 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.2,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.5,553.2h0S357.5,553.2,357.5,553.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.3 554 358.3 554 358.4 554 358.4 554 358.3 554"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.5,558.1v-.2h.6v.2c0,.1.1.1.2.2h.2c-.2-.1-.4.2-.6.2s-.3,0-.4-.1S363.5,558.1,363.5,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.6,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.9,557.4a1.4,1.4,0,0,1-.1-.6h.1a3.4,3.4,0,0,0,.1.5s0,.1,0,.1S362.9,557.4,362.9,557.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,555.4l.2-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2,0-.3h.1c.1,0,0-.1,0-.1h.2c0-.1-.1-.1,0-.1h.6s0,.1,0,.1.3.1.4.2-.1.2-.2.2.1.1.1.2h-.7a.3.3,0,0,0,0,.2c0,.1-.1.1,0,.1s0-.1-.1-.2,0-.1,0-.2l-.3-.2h-.3c0,.1.2.1.2.2h-.1c-.1,0-.2-.1-.2,0s0,.1-.1.1l-.4-.2A.6.6,0,0,1,361.6,555.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.9,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.6,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.6,554.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,552.6c0-.2.2-.2.3-.3h0c0,.1-.1,0,0,.1h0l-.2.2h.1c-.1,0,.1.1,0,.1h.5c0,.1-.1,0-.1.1a.5.5,0,0,1-.4.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.7 554.7 361.6 554.6 361.7 554.6 361.7 554.6 361.7 554.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.6,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.6,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,552.5h0S359.7,552.5,359.7,552.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.8 552.6 359.8 552.6 359.8 552.5 359.8 552.5 359.8 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.9,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.9,552.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.7 552.4 359.7 552.5 359.7 552.4 359.7 552.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 551.8 359.1 551.9 359.1 551.9 359.1 551.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.3,553.8h.3a.4.4,0,0,1-.1.2h-.2C361.3,553.9,361.2,553.9,361.3,553.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,552.6c.1-.1.2-.1.4-.1h0a.3.3,0,0,0,0,.3h-.1c-.1,0-.1-.1-.2-.1A.1.1,0,0,1,360.2,552.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,552.8h.1s0,.1-.1.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.1 552.5 360 552.5 360 552.5 360.1 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.2 551.7 359.2 551.7 359.2 551.7 359.2 551.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.7h0S360.4,552.7,360.4,552.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.5,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,552.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.3 552.6 360.3 552.7 360.3 552.7 360.3 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361 553.3 360.9 553.3 360.9 553.3 361 553.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.3 552.7 360.3 552.7 360.3 552.6 360.3 552.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "360.9 553.2 360.9 553.2 360.9 553.2 360.9 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.1,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,554.9h.1c.1,0,.2,0,.3.1a.3.3,0,0,1,0,.1h-.2C364,555.1,363.9,555,363.9,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362,553h.3s0,.1,0,.1h-.2C362,553.2,361.9,553.1,362,553Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.8",
      "y": "554.4",
      "width": "3.9",
      "height": "7.57",
      "transform": "translate(-134.5 117.4) rotate(-15.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.5,561.1c0,.1,0,.2-.1.2s-.2.2-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.1-.2h-1.1l.4-.2h0c0-.1-.2-.2-.3-.3h.4l-.2-.2.3.2.3-.2c0-.1-.1-.1,0-.2s0,.1.1.2h.3c.1-.1-.1-.1-.1-.2l.6.3C371.4,560.8,371.5,560.9,371.5,561.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.3 561.2 371.3 561.2 371.3 561.2 371.3 561.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.5,559h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,370.5,559Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.1 561.2 371.1 561.2 371.1 561.2 371.1 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.1 561.3 371.1 561.3 371.1 561.3 371.1 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371 561.3 371 561.3 371 561.3 371 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371 561.3 371 561.3 371 561.3 371 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.9 561.4 371 561.4 370.9 561.4 370.9 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.9 561.3 370.9 561.2 370.9 561.2 370.9 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.4,559.4a.8.8,0,0,1,.1.3h-.1c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.9 561.5 370.9 561.4 370.9 561.4 370.9 561.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,559.6h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.6,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.8,561.4h0S370.8,561.4,370.8,561.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.5 560.4 370.5 560.4 370.5 560.4 370.5 560.4 370.5 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,555.1H368c.1-.1,0-.1,0-.2v-.2c.1.2.4,0,.5.2s.2.1.2.3S368.5,555,368.5,555.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,555.8a1.2,1.2,0,0,1-.2.5h-.1s0-.1,0-.1l.2-.4h.1C368.7,555.7,368.6,555.8,368.6,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,557.9h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2h-.3c-.1,0,0,.1-.1.1s0-.1,0-.1h-.3s0,0,0-.1h-.1c0-.2-.2-.2-.2-.4h.2c.1-.1,0-.1,0-.2h.1c-.1,0,0-.1-.1-.2l.4.3h.1V557h.1s0,.1,0,.2v.4h.2c.1-.1-.1-.1-.1-.2h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,558.5h0A.1.1,0,0,1,368.4,558.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,558.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,560.9h-.3l-.2-.2h.3s0,0,0,0h.2c.1,0,0-.1.1-.1h-.1s0,.1,0,.1h.1C369,560.8,369,560.8,369,560.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 558.4 368.3 558.4 368.3 558.4 368.3 558.4 368.3 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,560.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.8 560.8 368.8 560.8 368.8 560.8 368.8 560.8 368.8 560.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,560.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.8 560.9 368.8 560.9 368.8 561 368.8 560.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369 561.6 369 561.7 369 561.7 369 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,560.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,559.2h0C368.3,559.1,368.3,559.2,368.2,559.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,560.6h-.3s0-.1,0-.1v-.2h.1c.1,0,0,.1.1.2A.1.1,0,0,1,368.5,560.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.5,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.5 560.7 368.6 560.8 368.6 560.8 368.5 560.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.8 561.7 368.8 561.7 368.8 561.7 368.8 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,559.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,560.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 560.5 368.5 560.5 368.5 560.5 368.4 560.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.2 559.8 368.2 559.8 368.2 559.8 368.2 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 560.5 368.4 560.5 368.4 560.5 368.4 560.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.2 559.8 368.2 559.8 368.2 559.8 368.2 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.7,557.3h-.2c-.1-.1-.2-.1-.1-.2h.2C366.8,557,366.8,557.2,366.7,557.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.3,559.5h0A.1.1,0,0,1,367.3,559.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "368.7",
      "y": "549.5",
      "width": "4.4",
      "height": "8.63",
      "transform": "translate(-247.3 803.3) rotate(-78.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.6,555.2c0-.1-.2-.1-.1-.2s0-.3-.1-.5,0-.1.1-.1,0-.1,0-.1h.1c.1-.1,0-.2.1-.3s0,.2.1.2l.2-.2h.1l.2-.2s0-.1,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c.1.1-.1.2,0,.2h.1c0-.1,0-.1,0-.2h.1c0,.1-.1.3,0,.4h.5l-.3.3h.3l-.3.2a.9.9,0,0,0,0,.4h-.3c0,.1.1,0,.2,0l-.6.4A.7.7,0,0,1,366.6,555.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 554.9 366.6 554.9 366.6 554.9 366.6 554.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,555.2V555h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.7 554.7 366.7 554.7 366.7 554.7 366.7 554.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 554.7 366.5 554.7 366.5 554.7 366.5 554.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 554.6 366.6 554.6 366.6 554.5 366.6 554.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 554.5 366.6 554.5 366.6 554.5 366.6 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 554.4 366.5 554.5 366.5 554.4 366.5 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.7 554.5 366.7 554.5 366.7 554.5 366.7 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,554.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 554.4 366.5 554.4 366.5 554.4 366.5 554.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,554.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,554.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.6,554.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.8 554.5 367.8 554.5 367.8 554.5 367.8 554.5 367.8 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.3c0-.1,0-.2,0-.2h.2l.3-.3s0,.1,0,.2h.4c-.2.1-.2.4-.4.4s-.2.2-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.9,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.4,555l-.4-.4s0-.1,0-.1h.1l.3.4s.1.1,0,.1S373.4,555,373.4,555Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.3,554c0-.1.1-.2.1-.2h.2c.1.1.2-.1.2,0h.1c-.1-.1-.1-.2-.2-.2h0c0-.1-.1-.1-.1-.1h.1c0-.1-.1,0-.1-.1h.1a.1.1,0,0,0,0-.2h.1s.1-.1.1-.1h.1c0-.1.1-.1.1-.1h0c.2.1.3-.1.5,0s.1.2,0,.3h.2s0,.1,0,.2h.2l-.6.3s-.1.1-.1.1v.2c.1.1,0,.1,0,.1h-.2v-.2h-.6c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2,0-.2.1s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,554.3c.1,0,0,0,0,.1S372.9,554.2,372.9,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.8,553.4h.2a.1.1,0,0,1,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.9,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.7c-.1-.1,0-.3.1-.4s.2-.1.3-.2h-.1s-.1,0,0,.1h-.1c.1.1,0,0,0,.1h0a.3.3,0,0,0,0,.3h0c0,.1.1,0,.1.1h0c.1,0,0-.1.1-.1h.1c.1-.1,0-.2.1-.2s-.1.1,0,.2a.5.5,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "370.9",
      "y": "553.3",
      "height": "0.01",
      "transform": "translate(-245.4 806.1) rotate(-78.5)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.6h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,552.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.3 552.6 368.3 552.6 368.3 552.5 368.3 552.5 368.3 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,552.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.1 552.5 368.1 552.5 368.1 552.5 368.1 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.3 552.3 367.3 552.3 367.3 552.3 367.3 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.1,552.8a.3.3,0,0,1,.2-.2.4.4,0,0,1,0,.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,552.4c0-.2.2-.2.3-.3h.1a.3.3,0,0,0,.1.2h-.3A.1.1,0,0,1,368.6,552.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,552.5h0c0-.1.1-.2,0-.2h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,552.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.4 552.4 368.4 552.4 368.4 552.3 368.4 552.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.3 552.1 367.4 552.1 367.3 552.1 367.3 552.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,552.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.4,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,552.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.9,552.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.7 552.3 368.7 552.4 368.7 552.4 368.7 552.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.6 552.5 369.6 552.5 369.6 552.5 369.6 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.8 552.3 368.8 552.4 368.7 552.4 368.8 552.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.6 552.5 369.6 552.5 369.6 552.5 369.6 552.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,552.3c0-.1,0-.1.1-.2h.4c0,.1,0,.2-.1.2S373,552.5,372.9,552.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,551.7c0-.1.1-.1.1-.2h.2v.2A.2.2,0,0,1,370.3,551.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.4",
      "y": "549.9",
      "width": "4.1",
      "height": "8.05",
      "transform": "translate(-68 52.9) rotate(-7.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,557.3c0,.1,0,.2-.1.2s-.3.1-.4.2h-.2s.1-.1,0-.1-.2.1-.3.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.4s0,0,0-.1h.1c0-.2-.2-.2-.2-.3l.4.2v-.2l.3.2.4-.2c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.4A.7.7,0,0,1,378.9,557.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 557.4 378.7 557.4 378.7 557.4 378.7 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,554.9H378a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,378.1,554.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.5 557.3 378.5 557.4 378.5 557.3 378.5 557.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.5 557.5 378.5 557.5 378.5 557.5 378.5 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 557.5 378.4 557.5 378.4 557.5 378.4 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 557.5 378.3 557.5 378.3 557.5 378.3 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 557.6 378.3 557.6 378.3 557.6 378.3 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.2 557.4 378.3 557.4 378.3 557.4 378.2 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378,555.4a.9.9,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 557.6 378.3 557.6 378.3 557.6 378.3 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,555.5h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,557.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 556.4 378 556.4 377.9 556.4 377.9 556.4 378 556.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.9,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,550.6h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2v-.2c.1.2.4.1.5.2s.2.2.2.3S376.7,550.5,376.6,550.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,551.3l-.3.5h-.1s0-.1,0-.1l.3-.4h.1C376.8,551.2,376.7,551.3,376.6,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.5,553.5h-.4c0-.1-.1-.1,0-.2H376c0,.1-.1.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1H375c.1-.2-.2-.2-.2-.4h.3c.1-.1,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1-.1-.3h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,554h0S376,554,376,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.3,556.7h-.4c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C376.3,556.6,376.3,556.7,376.3,556.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376 554 376 554 375.9 554.1 375.9 554 376 554"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.3,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.1,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,556.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 556.6 376.1 556.6 376.1 556.6 376.1 556.6 376.1 556.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,556.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 556.7 376.1 556.8 376.1 556.8 376.1 556.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 557.5 376.2 557.5 376.2 557.5 376.1 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,556.6s0,0,0,0S376,556.6,376,556.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,554.9h0C375.8,554.8,375.8,554.9,375.7,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,556.4c-.1,0-.2-.1-.3-.1s0-.1,0-.1l.2-.2h.2c.1.1,0,.1.1.2A.1.1,0,0,1,375.9,556.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,556.2h-.1s0,0,0-.1h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.9 556.5 375.9 556.5 375.9 556.5 375.9 556.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376 557.6 376 557.5 376 557.6 376 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 556.3 375.8 556.3 375.8 556.3 375.8 556.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.7 555.4 375.7 555.4 375.7 555.5 375.7 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 556.2 375.8 556.2 375.8 556.3 375.8 556.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.6 555.5 375.7 555.5 375.7 555.5 375.6 555.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,552.6h-.2c-.1-.1-.2-.1-.1-.2h.3C374.5,552.3,374.6,552.5,374.5,552.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,555h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,374.7,555Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "373.2",
      "y": "545.1",
      "width": "3.1",
      "height": "5.99",
      "transform": "translate(-288.5 517.6) rotate(-53)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.9,548.6s.1.1,0,.2-.1.2-.1.3h-.1c-.1,0-.1.1-.1.2s.1-.1,0-.2h-.7c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h0v-.3h.1s0,0,0,0h.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.8 548.7 377.8 548.7 377.8 548.7 377.8 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,547.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.6 548.8 377.7 548.8 377.7 548.8 377.6 548.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 548.9 377.7 548.9 377.7 548.9 377.7 548.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 548.9 377.7 549 377.7 549 377.7 548.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.6 549 377.6 549 377.6 549 377.6 549"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 549.1 377.7 549 377.7 549 377.7 549.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.6 549 377.6 549 377.6 549 377.6 549"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.1h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 549.1 377.7 549.1 377.7 549.1 377.7 549.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.5,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,549.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.9 548.6 376.9 548.6 376.9 548.6 376.9 548.6 376.9 548.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.9,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.1,546.3h-.7c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.5,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.5,546.7a1,1,0,0,1,.1.4h-.1a2.3,2.3,0,0,0-.1-.4s0-.1,0-.1S373.5,546.6,373.5,546.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,547.9h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.1,0,.2h0s0,.1,0,.1H374s0,.1,0,.1h-.4s0,0,0-.1-.2,0-.3-.1,0-.1.1-.2h.3s0-.1,0-.1h.1s0,.1,0,.1h.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.6,548.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,549.7c0,.1-.1.2-.2.2h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.3l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 548.4 374.6 548.5 374.6 548.5 374.6 548.5 374.6 548.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,549.8h0S376.1,549.8,376.1,549.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376 549.7 376 549.7 376 549.7 376 549.7 376 549.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376,549.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.1 549.8 376.1 549.8 376.1 549.8 376.1 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.5 550.2 376.6 550.2 376.6 550.2 376.5 550.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.9,549h-.2a.2.2,0,0,1,0-.2h.1S375,549,374.9,549Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,549.7h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,375.8,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,549.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.9 549.8 375.9 549.8 375.9 549.8 375.9 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.5 550.3 376.5 550.3 376.5 550.3 376.5 550.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.7h0S375.6,549.7,375.6,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 549.7 375.7 549.7 375.7 549.7 375.7 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.2 549.3 375.2 549.3 375.2 549.3 375.2 549.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 549.7 375.7 549.7 375.7 549.7 375.7 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.2 549.4 375.2 549.4 375.2 549.4 375.2 549.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,549.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,550.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373,548.5h-.2C372.9,548.3,373.1,548.4,373,548.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,549.6h-.2s0,0,0-.1h.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "376.8",
      "y": "551.1",
      "width": "3.1",
      "height": "5.99",
      "transform": "translate(-290.1 612.2) rotate(-60.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,554.1s.1.1.1.2,0,.2-.1.3h-.1s0,.1,0,.1h-.1c-.1,0,0,.2-.1.2s0-.1,0-.2h-.4s0,0,0,.1h-.3c0-.1.1-.1,0-.2h-.2c0-.1.1-.2.1-.3h-.1a.1.1,0,0,0,0-.1h0a.7.7,0,0,0,.1-.3h.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 554.3 381.4 554.3 381.4 554.3 381.4 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,553.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.4 381.3 554.4 381.3 554.4 381.3 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 554.5 381.4 554.5 381.4 554.5 381.4 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.5 381.3 554.5 381.3 554.5 381.3 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.6 381.3 554.6 381.3 554.6 381.3 554.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.6 381.3 554.6 381.3 554.6 381.3 554.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 554.6 381.2 554.6 381.2 554.6 381.2 554.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,553.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.3 554.7 381.3 554.6 381.3 554.6 381.3 554.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,553.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,553.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.5 554.3 380.5 554.3 380.5 554.3 380.5 554.3 380.5 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,552.5v.2h-.1l-.2.2h-.3c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,552.8l.2.4h-.1v-.4s0-.1,0-.1S376.9,552.8,376.9,552.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,554.6h0S380,554.6,380,554.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,553.9h-.5c0,.1,0,.1.1.2h0s0,.1,0,.1h-.1s.1,0,0,.1h-.4s0,0,0-.1-.2,0-.3-.1,0-.1.1-.2h.2s0-.1,0-.1h.5s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.2,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,555.4c0,.1-.1.2-.1.3h0s0,0,0-.1h0v-.2h0s-.1,0,0-.1h-.3s.1,0,0-.1l.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.2 554.4 378.2 554.4 378.2 554.5 378.2 554.5 378.2 554.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,555.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,555.6h0S379.9,555.5,379.9,555.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.8 555.5 379.8 555.5 379.8 555.5 379.8 555.5 379.8 555.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.7,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.7,555.5s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.8 555.6 379.9 555.6 379.9 555.6 379.8 555.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 555.9 380.4 555.9 380.4 555.9 380.3 555.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.6,554.9h-.2a.2.2,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,555.5h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,379.5,555.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.4h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,555.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 555.6 379.6 555.6 379.6 555.6 379.6 555.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 556 380.3 556 380.3 556 380.3 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,555.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 555.5 379.4 555.5 379.4 555.5 379.4 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 555.2 378.9 555.2 378.9 555.2 378.9 555.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 555.5 379.4 555.5 379.4 555.5 379.4 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 555.3 378.9 555.3 378.9 555.3 378.9 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.7,554.7h-.2C376.5,554.5,376.7,554.6,376.7,554.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,555.6h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.2",
      "y": "552.8",
      "width": "3.9",
      "height": "7.67",
      "transform": "translate(-232.8 273) rotate(-31)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,554.6c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s0,.1,0,.1.1-.1.3-.2-.1.1-.1.2h1c0,.1-.1.1-.1.2h.3c-.1.1-.3.1-.3.3h0l.3.2h-.5l-.2.3c0,.1.1.1.1.2V555h-.1s0,0,0,0h-.1a.1.1,0,0,0,0,.1h-.1c0,.1.1.1.1.1l-.6-.2C372.8,554.9,372.7,554.8,372.7,554.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.8 554.5 372.8 554.5 372.8 554.5 372.8 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,556.4h.2v.2h-.1A.1.1,0,0,1,374.3,556.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.4 373 554.4 373 554.4 373.1 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373 554.3 373 554.3 373 554.3 373 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.3 373.1 554.3 373.1 554.3 373.1 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.2 373.1 554.3 373.1 554.3 373.1 554.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.1 373.1 554.2 373.1 554.2 373.1 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.2 554.3 373.2 554.3 373.2 554.3 373.2 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9v-.2h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 554.1 373.1 554.1 373.1 554.1 373.1 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.1,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,554.9s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.3,554.1a0,0,0,0,1,0,0S373.3,554.1,373.3,554.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.8 555 373.8 555 373.9 555 373.9 555 373.8 555"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,554.9h0S373.9,554.9,373.9,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.2,559.7h.6c0,.1.1.1.1.2h.2c-.2-.1-.4.1-.5,0s-.3,0-.3-.2S377.2,559.7,377.2,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,559a1.3,1.3,0,0,1,.1-.5h.1s0,.1,0,.1a3,3,0,0,0-.1.5s0,.1-.1.1S376.9,559,376.9,559Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,555h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.3,557h.4c0,.1.1.1.1.2h.1c0-.1.1-.2,0-.2h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.4s0,0,0,.1h.1c0,.2.3.1.3.3l-.2.2c0,.1,0,.1.1.2h-.1v.2l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1-.1-.2s.1-.1,0-.2l-.2-.2h-.2c0,.1.1.1.2.2h-.4a.3.3,0,0,1-.3-.2A.5.5,0,0,1,376.3,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,558.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,556.3h0A.1.1,0,0,1,376.4,556.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.5,556.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.2,554.1c0-.1.2-.1.3-.2h0c0,.1-.1,0,0,.1h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.5 556.4 376.5 556.3 376.5 556.3 376.5 556.3 376.5 556.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.3,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554.1h0S375.3,554.1,375.3,554.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,554h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "375.4",
      "y": "554.1",
      "transform": "translate(-235.6 280.9) rotate(-31.8)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 554 375.4 554 375.4 554 375.4 554"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375 553.4 375 553.4 375 553.4 375 553.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.4,555.5h.3v.2h-.1C376.4,555.6,376.3,555.6,376.4,555.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,554.3h.3s0,.1,0,.1a.3.3,0,0,0-.1.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,375.7,554.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.5,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.5,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,554.5h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,554.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.6 554.1 375.6 554.1 375.6 554.1 375.6 554.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.1 553.3 375.1 553.3 375.1 553.3 375.1 553.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.6,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,554.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 554.3 375.8 554.3 375.8 554.3 375.8 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.2 555 376.2 555 376.2 555 376.2 555"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 554.3 375.8 554.4 375.8 554.3 375.8 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.2 555 376.2 555 376.2 555 376.2 555"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,557.1h.2c.1,0,.2.1.2.2h-.2C378.4,557.3,378.3,557.2,378.4,557.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.2,555h.1A.1.1,0,0,1,377.2,555Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "365",
      "y": "560",
      "width": "8.3",
      "height": "4.24",
      "transform": "translate(-261.5 795.7) rotate(-77)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,566.3h-.2c-.2.1-.3,0-.5,0h-.2c0-.1.1,0,.1-.1s-.2,0-.3-.1h.2l-.2-.2s0,.1,0,.1h0v-.2l-.2-.2h-.1c-.1,0-.1-.2-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0-.1,0-.1h.1c.1-.2-.1-.3-.1-.4l.3.3c-.1-.1-.1-.2-.1-.3l.2.3h.4c0-.1,0-.2.1-.2s-.1.1,0,.2h.1s0,.1.1.1h.1c.1,0,0-.1,0-.2s.3.4.4.6A.7.7,0,0,1,370.3,566.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 566.3 370.1 566.3 370.1 566.3 370.1 566.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.4,563.7h-.2v-.2h.1A.2.2,0,0,1,370.4,563.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.9 566.2 369.9 566.2 369.9 566.2 369.9 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 566.3 369.9 566.3 369.9 566.3 369.8 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 566.2 369.7 566.3 369.7 566.3 369.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 566.2 369.7 566.2 369.7 566.2 369.7 566.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 566.3 369.6 566.3 369.6 566.3 369.6 566.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 566.1 369.7 566.1 369.7 566.1 369.7 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.1,564.1v.3h0c.1-.1,0-.2.1-.3S370.2,564.1,370.1,564.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 566.4 369.6 566.4 369.6 566.4 369.6 566.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,564.2h0c.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.1,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.7,565.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.5,566.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 565.1 369.7 565.1 369.7 565.1 369.7 565.1 369.7 565.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.6,565.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,558.9h-.2c0-.1-.1-.1,0-.2l-.3-.2h.2c.1,0,.1-.1.1-.2s-.1-.1-.1-.2.3.2.4.4.2.2.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,565.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,565h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,559.7l-.4.3h0l.4-.3h.1C370.4,559.6,370.3,559.7,370.3,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,561.8h-.2v-.2c.1-.1-.1-.2.1-.2s0-.1-.1-.1l-.2.2h-.7s0,0,0-.1h0c.1-.2-.1-.3,0-.5h.3c.1,0,.1-.1.1-.2h.1c0-.1.1-.1,0-.2s.2.3.2.5h.4c0,.1-.1.1-.1.2H369c0,.1,0,.2,0,.3v.2c.1-.1,0-.2,0-.3h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.6,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,562.2h-.1s0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,562.1h0S368.7,562.1,368.7,562.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,564.8h-.4c0-.1-.1-.2-.2-.3h.2s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2a.4.4,0,0,1,.4.2C368.1,564.7,368,564.8,368,564.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.6 562.1 368.6 562.1 368.6 562.1 368.6 562.1 368.6 562.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.9,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,564.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 564.6 367.9 564.6 367.8 564.6 367.8 564.6 367.9 564.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.8 564.7 367.8 564.7 367.8 564.8 367.8 564.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 565.5 367.6 565.5 367.6 565.5 367.6 565.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,562.8a.3.3,0,0,1-.2-.2h.3C368.2,562.7,368.2,562.8,368.1,562.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,564.3c-.2,0-.2-.2-.3-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,564.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,564.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564.1s0,0,0,0h-.2s0,0,0-.1h0s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,564h0S367.8,564,367.8,564Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.7 564.4 367.7 564.5 367.6 564.5 367.7 564.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 565.5 367.4 565.5 367.4 565.5 367.4 565.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,562.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.7,564h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.7 564.2 367.7 564.2 367.7 564.2 367.7 564.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 563.3 367.9 563.3 367.9 563.3 367.9 563.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.7 564.1 367.7 564.1 367.7 564.2 367.7 564.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.8 563.4 367.8 563.4 367.8 563.4 367.8 563.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.6,564.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,565.5h0S367.1,565.4,367.1,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.7,560.1h-.2c0-.1-.1-.2,0-.3h.3C367.9,559.9,367.9,560.1,367.7,560.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,562.6H367a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,367.1,562.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "370.3",
      "y": "563",
      "width": "8.6",
      "height": "4.41",
      "transform": "translate(-79.7 61.9) rotate(-8.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,562.5c.1,0,.2,0,.2.2s.2.3.2.5,0,.1,0,.1h0c-.1.1.1.2.1.3s-.1-.2-.2-.2v.2h-.1a.3.3,0,0,0-.1.2h0c0,.1-.1.1-.1.3s.1.1,0,.2h-.1c-.1-.1,0-.2-.1-.2h-.1c.1.1,0,.1,0,.2h0c-.1-.1,0-.3-.1-.4h-.1c-.2,0-.2.2-.4.3a1.2,1.2,0,0,0,.2-.4l-.2.2.2-.3-.2-.4h.1s.1-.1.1-.1h0c-.1-.1-.1.1-.2,0l.4-.6A.7.7,0,0,1,378.2,562.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 562.7 378.3 562.7 378.3 562.7 378.3 562.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,563.4a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 563 378.3 562.9 378.3 562.9 378.3 563"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 562.9 378.4 562.9 378.4 562.9 378.4 562.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 563 378.4 563 378.4 563.1 378.4 563"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.4 563.1 378.4 563.1 378.4 563.1 378.4 563.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.5 563.2 378.5 563.1 378.5 563.1 378.5 563.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.3 563.2 378.3 563.2 378.3 563.2 378.3 563.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,563.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.6 563.2 378.6 563.1 378.6 563.1 378.6 563.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.3,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.4,563.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.5,563.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.3 563.5 377.3 563.5 377.3 563.5 377.3 563.5 377.3 563.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,563.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371,565c.1.1,0,.2.1.2H371a1.4,1.4,0,0,0-.1.4s0-.1-.1-.2h-.4c.2-.1.1-.4.2-.6s.2-.3.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,564.1h0S377,564.1,377.1,564.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.9,565l.5.3s0,.1,0,.1h-.1l-.5-.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377,564.3h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,565.2c.1.1,0,.2,0,.2v.2c-.1,0-.1.1-.2,0h.2s-.1.1,0,.1h0a.1.1,0,0,0,0,.2h-.1s-.1.1,0,.1H374c0,.1-.1.1,0,.2h-.1c-.2-.1-.3.2-.5.2s-.1-.2-.1-.3h-.4l.4-.4s.1-.1,0-.1h.4l.2-.2c-.1-.1-.2.1-.3.1a.1.1,0,0,1,0-.1c0-.1.2-.1.1-.2s-.1-.1,0-.1l.4-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,565.5c-.1,0,0,0,0-.1S372.7,565.5,372.6,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.9,565.6a.2.2,0,0,1,0,.1h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,565.3c.1.1.1.3.1.4s-.1.2-.2.3h0s0,0,0-.1h0s.1-.1,0-.1h.1a.3.3,0,0,0,0-.3s0,.1,0,.1h-.1s0,.1,0,.1,0-.1,0-.1h0s0,.1,0,.1h0s0,0,0,0h0c-.1.1,0,.2,0,.3s0-.1,0-.1a.5.5,0,0,1,.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.8 565.7 374.8 565.7 374.8 565.7 374.8 565.7 374.8 565.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,565.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,565.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.4h0S377.6,565.4,377.6,565.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,565.5h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.6 565.5 377.6 565.5 377.6 565.5 377.6 565.5 377.6 565.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,565.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.7 565.5 377.7 565.5 377.7 565.5 377.7 565.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.5 565.4 378.5 565.4 378.5 565.4 378.5 565.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,565.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,565.9a.3.3,0,0,1-.1.3V566h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,565.8c0,.2-.1.2-.1.3H377l-.2-.2a.2.2,0,0,1,0-.2c.1-.1.2,0,.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,565.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,565.8h0c0,.1,0,.2,0,.2h0s0,.1,0,.1H377s0-.1,0-.1,0-.1-.1-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,565.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.4 565.8 377.5 565.7 377.5 565.8 377.4 565.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.6 565.6 378.6 565.6 378.6 565.6 378.6 565.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,566.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.2,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377,565.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.2 565.8 377.2 565.8 377.2 565.8 377.2 565.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.3 566 376.3 566 376.3 566 376.3 566"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.2 565.9 377.2 565.9 377.2 565.8 377.2 565.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.4 566 376.4 566 376.4 566 376.4 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.7,565.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.3,567.3c0,.1,0,.1,0,.2s-.2.2-.3.1h-.1c0-.1-.1-.2,0-.2S373.2,567.2,373.3,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,567c0,.1,0,.1,0,.2h-.3a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "373",
      "y": "567.8",
      "width": "7.9",
      "height": "4.05",
      "transform": "translate(-26.5 18.4) rotate(-2.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.4,572s-.2-.1-.2-.2-.1-.3-.2-.4,0-.1,0-.1h.1c.1-.1-.1-.2,0-.3s.1.2.2.2v-.2h.1v-.2h0c0-.1.1-.1.1-.2s0-.1,0-.2h.1c.1.1,0,.2.1.2h.1c0-.1,0-.1,0-.2h0c.1.1,0,.3.1.4h.1c.2,0,.2-.2.4-.2l-.2.3h.2l-.2.2v.4h-.1s-.1,0-.1.1h.2l-.5.5A.6.6,0,0,1,373.4,572Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.7 373.3 571.8 373.3 571.8 373.3 571.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,571.4a.1.1,0,0,1,.1-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.4 571.5 373.4 571.5 373.4 571.5 373.4 571.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.5 373.3 571.5 373.3 571.5 373.3 571.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.4 373.3 571.4 373.3 571.4 373.3 571.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.3 571.4 373.3 571.4 373.3 571.4 373.3 571.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.2 571.3 373.2 571.3 373.2 571.3 373.2 571.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.4 571.3 373.4 571.3 373.4 571.3 373.4 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,571.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.2 571.3 373.2 571.3 373.2 571.3 373.2 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.2,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.3,571.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.1,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,571.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.3,571.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.3 571.1 374.3 571.1 374.3 571.1 374.3 571.1 374.3 571.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,570.3c-.1-.1,0-.1,0-.2h.1l.2-.3s0,.1,0,.2h.4c-.2.1-.1.4-.3.5s-.2.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,570.2l-.4-.3s0-.1,0-.1h.1l.4.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.7,570.4h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,569.9c0-.1,0-.2,0-.2h.1c.1,0,.1-.1.2,0h.1l-.2-.2h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2.1.3-.2.4-.1s.1.2.1.3h.4l-.4.4s-.1.1,0,.1h-.4l-.2.2c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1s-.2.1-.1.2.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,569.7c.1,0,0,0,0,.1S378.8,569.7,378.8,569.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.8,569.4h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.5c-.1-.1,0-.2,0-.4s.1-.2.2-.2h-.1s0,0,0,.1h0s-.1.1,0,.1h-.1c.1,0,0,0,0,.1h0a.3.3,0,0,0,0,.2h.1s0-.1,0-.1,0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s0,.1,0,.1a.4.4,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376.8 569.3 376.8 569.3 376.8 569.3 376.8 569.3 376.8 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,569.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.3h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.3 569.3 374.3 569.3 374.3 569.2 374.3 569.2 374.3 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,569.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.2 569.2 374.2 569.2 374.2 569.2 374.2 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.4 569.2 373.4 569.3 373.4 569.3 373.4 569.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,569.1a.3.3,0,0,1,.2-.2v.2H376Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,569c0-.1.1-.2.2-.3h.1v.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,569.1h0c0-.1.1-.2,0-.2h0s0-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.9,569h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.4 569 374.4 569 374.4 569 374.4 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.4 569.1 373.4 569.1 373.4 569.1 373.4 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.7,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.2,568.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.7,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.9,569h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 569 374.7 569 374.7 569 374.7 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.5 568.9 375.5 568.9 375.5 568.9 375.5 568.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 569 374.7 569 374.7 569 374.7 569"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 568.9 375.4 568.9 375.4 568.9 375.4 568.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.3,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,568c0-.1,0-.1,0-.2h.3c0,.1,0,.1,0,.2S378.5,568.1,378.4,568Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,568.1c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.3",
      "y": "573.4",
      "width": "7.9",
      "height": "4.04",
      "transform": "translate(-210 217.5) rotate(-25.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,572.1h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.2.1.3h-.2a.4.4,0,0,0,0,.2h.1s0,.1,0,.1h-.1a.3.3,0,0,0,0,.2h.1c0,.1-.1.2-.1.3v.2h-.1c-.1,0,0-.2-.2-.2h0v.2h0c-.1-.1-.1-.3-.2-.3h-.1c-.1,0-.1.2-.2.3a1.1,1.1,0,0,0,.1-.4l-.2.2v-.3l-.3-.3h0s.1-.1,0-.1h0c-.1-.1-.1.1-.2.1s.1-.4.2-.6S380.5,572.1,380.7,572.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 572.3 380.9 572.3 380.9 572.3 380.9 572.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,573.6a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 572.5 380.9 572.5 380.9 572.5 380.9 572.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 572.4 381 572.4 381 572.4 381 572.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 572.6 381 572.6 381 572.6 381 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.1 572.6 381.1 572.6 381.1 572.6 381.1 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 572.6 381.1 572.6 381.2 572.6 381.2 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 572.7 381 572.7 381 572.7 381 572.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,573.5h.3s0,0,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 572.6 381.2 572.6 381.2 572.6 381.2 572.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,573.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,573.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,573.5s0,0,0,0S379.4,573.5,379.4,573.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,573.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,572.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 573.2 380.2 573.2 380.2 573.3 380.2 573.3 380.2 573.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,573.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.1,576.3v.2c-.1,0,0,.1-.1.1a1.3,1.3,0,0,0,0,.4h-.3v.2c.1-.2,0-.4.1-.6s.1-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,573.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,573.9s0,.1,0,.1S380.1,573.9,380.1,573.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,573.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,576h.5s.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,574h0S380.1,574,380.1,574Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,574h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.9,575.5c.1.1,0,.2.1.2v.2c-.1,0-.1.1-.2.1s-.1.1,0,.1h.4s0,.1,0,.1h0a.1.1,0,0,0,.1.2h-.1s0,.1,0,.1h-.1c0,.1-.1.1,0,.1H378c-.2,0-.2.3-.4.3s-.2-.1-.2-.2h-.4c.1-.1.1-.4.3-.5s.1-.1,0-.1h.1l.2-.2V576c-.1-.1-.1.1-.2.1h0c0-.1.1-.1.1-.2s-.1,0-.1-.1a.3.3,0,0,1,.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,576.3c-.1,0,0,0,0-.1S376.6,576.2,376.6,576.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.6,575.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,575.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,574.7c.1.1.1.2.2.3s0,.2-.1.3,0-.1,0-.1h0s0-.1,0-.1h.1v-.2s0,0,0,.1H381c0,.1.1.1,0,.1s0-.1,0-.1h0s0,.1,0,.1h0c0,.1.1.2,0,.2s0-.1-.1-.1a.4.4,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.6 575.8 378.6 575.8 378.6 575.9 378.6 575.9 378.6 575.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,574.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,574.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,574.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.8,574.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,574.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,574.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 574.9 380.9 574.9 381 575 380.9 575 380.9 574.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,575h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.1 574.9 381.1 574.9 381.1 574.9 381.1 574.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.8 574.6 381.8 574.6 381.8 574.6 381.8 574.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,575.8a.3.3,0,0,1-.1.3l-.2-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,575.2c.1.1,0,.2,0,.3h-.3a.1.1,0,0,1,0-.2c0-.1.1,0,.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,575.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,575.3h0c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,575.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 575.2 380.9 575.2 380.9 575.2 380.9 575.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.8 574.8 381.8 574.7 381.8 574.7 381.8 574.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,575.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.7,575.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,576h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.7,575.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,575.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 575.3 380.7 575.3 380.7 575.3 380.7 575.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 575.7 380 575.7 380 575.7 380 575.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 575.4 380.7 575.4 380.7 575.3 380.7 575.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 575.7 380 575.7 380 575.7 380 575.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,575.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,575h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,577.7c.1,0,.1.1.1.2s-.1.2-.2.2h-.1c0-.1-.1-.1,0-.2S377.5,577.6,377.7,577.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,576.7c.1,0,0,.1,0,.2h-.2a.2.2,0,0,1,0-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "382.5",
      "y": "572.3",
      "width": "7.4",
      "height": "3.8",
      "transform": "translate(-286.1 738) rotate(-69.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,570.3h.9s-.1,0-.1.1h.1v.2s0-.1,0-.1h0v.2h.1c.1,0,0,.2.1.2h.2s0,0,0,0h-.4s0,.1,0,.1h-.1c-.1.1.1.2,0,.4l-.2-.3c.1.1,0,.2,0,.2v-.3h-.4s0,.2-.1.2.1-.1.1-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.2-.4-.3-.6S385.5,570.5,385.6,570.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.8 570.4 385.8 570.4 385.8 570.4 385.8 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.3,572.6h-.1A.1.1,0,0,1,385.3,572.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 570.5 386 570.5 386 570.5 386 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 570.4 386 570.4 386.1 570.4 386.1 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 570.5 386.1 570.4 386.2 570.4 386.1 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 570.5 386.2 570.5 386.2 570.5 386.2 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.3 570.4 386.2 570.4 386.3 570.4 386.3 570.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 570.6 386.2 570.6 386.2 570.6 386.2 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,572.3v-.2h0v.3S385.5,572.3,385.6,572.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.3 570.4 386.3 570.4 386.3 570.4 386.3 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.1,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,570.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 571.5 386 571.5 386 571.5 386 571.5 386 571.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.6,576.9h.2c0,.1,0,.1,0,.2l.2.3h-.2c-.1,0-.1.1-.1.2s.1.1,0,.2-.3-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,571.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,571.6s0,0,0,0S386.5,571.6,386.5,571.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.9,576.2l.4-.3h0l-.4.2h-.1C384.8,576.3,384.9,576.2,384.9,576.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386,574.5h.2v.2c-.1,0,0,.1-.1.2s0,.1,0,.1h.8c-.1.2.1.3,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.1c.1-.1,0-.2,0-.3v-.2c-.1,0,0,.2-.1.2H386c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,575.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.6,574.2h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.6,574.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,571.9h.3c0,.1.1.2.1.3h-.1s0-.1,0-.1h-.2s0,.1,0,.1h.2a.4.4,0,0,1-.3-.3C387.4,572,387.5,572,387.5,571.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.6 574.3 386.6 574.3 386.7 574.3 386.7 574.3 386.6 574.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,572h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,572s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.6 572.1 387.6 572.1 387.7 572.1 387.7 572.1 387.6 572.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.7 572 387.7 572 387.7 572 387.7 572"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "388 571.3 388 571.3 388 571.3 388 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,573.7a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,572.4c.1,0,.1.2.2.3h-.4c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.8,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.8,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.6s0,0,0,0h.1s0,0,0,0h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,572.7s0,0,0,0S387.6,572.7,387.6,572.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.8 572.3 387.8 572.3 387.8 572.3 387.8 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "388.1 571.4 388.1 571.4 388.1 571.4 388.1 571.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.2,573.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,572.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.8 572.5 387.7 572.5 387.7 572.5 387.8 572.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 573.3 387.5 573.3 387.5 573.3 387.5 573.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.8 572.6 387.8 572.6 387.8 572.5 387.8 572.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 573.2 387.5 573.2 387.5 573.2 387.5 573.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.9,572.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,571.5h0S388.4,571.5,388.4,571.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,576.1h.2c0,.1.1.2,0,.3h-.3C387.1,576.3,387.1,576.1,387.2,576.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,574h.1a.2.2,0,0,1,0,.2H388A.1.1,0,0,1,388.1,574Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "389.4",
      "y": "565.6",
      "width": "3.3",
      "height": "6.37",
      "transform": "translate(-234.6 277.1) rotate(-30.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,567.1s0-.2,0-.2.2-.2.2-.3h.2s0,.1,0,.1h.2c0,.1-.1.1-.1.2h1l-.3.2h0l.3.2h-.4l-.2.2c0,.1.1.1,0,.2h-.4c0,.1.1.1.1.1h-.5C388.3,567.4,388.1,567.3,388.1,567.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 567 388.3 567 388.3 567 388.3 567"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,568.6h.1A.1.1,0,0,1,389.4,568.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.9 388.4 567 388.4 567 388.5 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.4 566.9 388.4 566.9 388.4 566.9 388.4 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.8 388.5 566.8 388.5 566.8 388.5 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.8 388.5 566.8 388.5 566.8 388.5 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.7 388.5 566.7 388.5 566.7 388.5 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.6 566.9 388.6 566.9 388.6 566.9 388.6 566.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,568.2V568h.1v.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 566.7 388.5 566.7 388.5 566.7 388.5 566.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,568.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389,567.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.7,566.7a0,0,0,0,1,0,0S388.7,566.7,388.7,566.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 567.5 389.1 567.5 389.1 567.5 389.1 567.5 389.1 567.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.1,567.3h0S389.1,567.3,389.1,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,571.3h.5c0,.1,0,.1.1.1h.1c-.2-.1-.3.1-.5,0s-.2,0-.2-.2S391.9,571.4,391.9,571.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.6,570.8a1,1,0,0,1,.1-.4h.1a2.5,2.5,0,0,0-.1.4s0,.1-.1.1S391.6,570.8,391.6,570.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,567.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,569.1h.3c0,.1.1,0,.1.1h.1c0-.1.1-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.4c0,.2.2.1.3.3h-.2c0,.1,0,.1,0,.1h0l-.4-.2h-.1a.2.2,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.1s0-.1,0-.2v-.2h-.2c0,.1.1.1.1.2h-.3l-.2-.2A.4.4,0,0,1,391.1,569.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.8,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,568.6h0A.1.1,0,0,1,391.2,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.3,568.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.2,566.7l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.3 568.6 391.3 568.6 391.3 568.6 391.3 568.6 391.3 568.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.7h0S390.3,566.7,390.3,566.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.4,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.3,566.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.4 566.7 390.4 566.7 390.4 566.7 390.4 566.7 390.4 566.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.4 566.6 390.4 566.6 390.4 566.6 390.4 566.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.1 566.1 390.1 566.1 390.1 566.1 390.1 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.4,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,567.9h0S391.1,567.9,391.2,567.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,566.9h.3v.2h-.2A.1.1,0,0,1,390.7,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.7,567h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.6 566.7 390.6 566.7 390.6 566.7 390.6 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.2 566 390.2 566 390.2 566 390.2 566"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.4,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,567h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.7 566.9 390.7 566.9 390.7 566.9 390.7 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.1 567.5 391.1 567.5 391.1 567.5 391.1 567.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.8 566.9 390.8 566.9 390.7 566.9 390.8 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.1 567.4 391.1 567.4 391.1 567.4 391.1 567.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.4,565.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.8,569.2h.1C392.9,569.4,392.8,569.3,392.8,569.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,567.5h.1A.1.1,0,0,1,391.9,567.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "393.5",
      "y": "566.8",
      "width": "3.5",
      "height": "6.82",
      "transform": "translate(-217.1 896.4) rotate(-83.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392,571.6s-.1-.1-.1-.2-.1-.3-.1-.4,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2v-.2h.1v-.2s0,0,0-.1l.2-.2c0-.1,0-.1,0-.2h.1c0,.1,0,.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.4l-.2.3h.2l-.2.2a.7.7,0,0,0,.1.3h0l-.5.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571.4 391.9 571.4 391.9 571.4 391.9 571.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,571.4h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 571.2 392 571.2 392 571.2 392 571.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571.2 391.9 571.2 391.9 571.2 391.9 571.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 571.1 391.9 571.1 391.9 571.1 392 571.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571.1 391.9 571.1 391.9 571.1 391.9 571.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 571 391.9 571 391.9 571 391.9 571"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 571 392 571 392 571 392 571"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,571.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 571 391.9 571 391.8 571 391.8 571"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,571.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392,570.9h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "392.9",
      "y": "571",
      "height": "0.01",
      "transform": "translate(-223.4 888.1) rotate(-82.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.8,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398,571.1c0-.1,0-.1,0-.2h.1l.2-.3s0,.1,0,.1h.3c-.2.1-.1.3-.3.4s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.8,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.9,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,570.9l-.3-.3s0-.1,0-.1h.1l.3.3s.1.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.6,570.3c0-.1.1-.1,0-.2h.4l-.2-.2h.1a.1.1,0,0,0,0-.1h.1s.1-.1,0-.1h.1c0-.1.1,0,.1-.1h0c.2.1.2-.1.4-.1s.1.2,0,.2h.1s0,.1,0,.1h.2l-.4.3s-.1.1-.1.1h.1s0,.1,0,.1h-.5a0,0,0,0,1,0,.1s-.2,0-.1.1.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,570.4s0,0,0,0S396.8,570.4,396.9,570.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,569.9h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.2,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.5c-.1-.1,0-.2,0-.3h.1s-.1,0,0,0H393s0,0,0,.1h0a.3.3,0,0,0,0,.2h.2s0,0,0,0h0c.1-.1,0-.2.1-.2s0,.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.3 569.8 395.2 569.8 395.3 569.8 395.3 569.8 395.3 569.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.2,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.1 569.4 393.1 569.4 393.1 569.4 393.1 569.4 393.1 569.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.2,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393 569.4 393 569.4 393 569.3 393 569.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "392.4 569.3 392.3 569.3 392.3 569.3 392.4 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.6,569.5l.2-.2a.3.3,0,0,1,.1.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.4,569.3c0-.1.1-.2.2-.2h.1v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.3h0c0-.1.1-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.2 569.2 393.2 569.2 393.2 569.2 393.2 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "392.4 569.1 392.4 569.1 392.4 569.1 392.4 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,569.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 569.2 393.5 569.2 393.4 569.2 393.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.2 569.3 394.2 569.3 394.2 569.3 394.2 569.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 569.2 393.5 569.2 393.5 569.2 393.5 569.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.1 569.3 394.1 569.3 394.1 569.3 394.1 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,568.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.8,568.9c0-.1,0-.1,0-.2h.3s0,.1-.1.2S396.8,569,396.8,568.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,568.6c0-.1,0-.1.1-.1h-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "397.3",
      "y": "565.1",
      "width": "3.7",
      "height": "7.26",
      "transform": "translate(-294.4 527.3) rotate(-51.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.5,568.1c0-.1-.1-.1,0-.2s.1-.3.2-.4h.1s0,.1.1.1.1-.2.2-.2-.1.2,0,.2h.7v-.2h.1c0,.1-.1.1-.1.2h.1V567h0c0,.1-.2.2-.2.3h0v.3c0,.1.1.1.1.1h-.3s0,0,0,0h-.2c0,.1.1,0,.1.1h-.6C395.7,568.3,395.5,568.2,395.5,568.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.6 567.9 395.5 567.9 395.5 567.9 395.6 567.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.5,569.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.8 395.7 567.8 395.7 567.8 395.7 567.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.6 567.7 395.6 567.7 395.6 567.7 395.6 567.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.6 395.7 567.6 395.7 567.6 395.7 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.6 395.7 567.6 395.7 567.6 395.7 567.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.5 395.7 567.5 395.7 567.5 395.7 567.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.8 567.6 395.8 567.6 395.8 567.6 395.8 567.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,568.7l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 567.5 395.7 567.5 395.7 567.5 395.7 567.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.2,568.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.2,568.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.1,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.9,567.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 568.1 396.6 568.1 396.6 568 396.6 568 396.6 568.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.6,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.2,571v-.2h.7c-.2,0-.3.2-.5.2s-.3,0-.3-.1S401.2,571.1,401.2,571Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.8,567.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.9,567.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.7,570.5a1.2,1.2,0,0,1-.1-.5h.1a2.9,2.9,0,0,0,.1.4s0,.1,0,.1S400.7,570.6,400.7,570.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,567.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.4,569v-.2h.2c0,.1.1,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.2,0,.2-.1.2.1.1.1.1h-.5v.2c0,.1-.1.1,0,.1h-.1c0-.1,0-.1,0-.2h-.5c0,.1.2,0,.2.1h-.2s0,.1-.1.1h-.3A.5.5,0,0,1,399.4,569Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.6,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.3,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399.4,568.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.5,566.8c0-.1.1-.2.2-.3h0c0,.1-.1,0,0,.1h0v.2h.1s.1.1,0,.1h.4s-.1,0-.1.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "399.4 568.3 399.4 568.3 399.4 568.3 399.4 568.3 399.4 568.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.6,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.7,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,566.7h0S397.6,566.7,397.6,566.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.7 566.8 397.7 566.8 397.7 566.7 397.7 566.7 397.7 566.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,566.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.7 566.7 397.6 566.7 397.6 566.6 397.7 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.1 566.2 397.1 566.2 397.1 566.2 397.1 566.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399,567.7h.3a.3.3,0,0,1-.1.2h-.1S399,567.7,399,567.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398,566.8h.3a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,398,566.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,566.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.7,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.9h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.3,566.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.9 566.7 397.9 566.7 397.9 566.7 397.9 566.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.2 566.1 397.2 566.1 397.2 566.1 397.2 566.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.8h0S398.2,566.8,398.2,566.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.2,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399.2,567.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.1,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M398.3,566.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "398.1 566.8 398.1 566.8 398.1 566.8 398.1 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.7 567.3 398.7 567.3 398.7 567.3 398.7 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "398.2 566.8 398.2 566.8 398.1 566.8 398.2 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.7 567.2 398.7 567.2 398.7 567.2 398.7 567.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.9,566.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,565.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.3,568.4h.2C401.4,568.6,401.3,568.5,401.3,568.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.6,566.9h.3s0,.1,0,.1h-.1C399.6,567.1,399.5,567,399.6,566.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "400.3",
      "y": "568.8",
      "width": "7.4",
      "height": "3.81",
      "transform": "translate(-226 267.4) rotate(-29)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,574h-.2c-.2,0-.2-.2-.3-.3s0-.1,0-.1h0c0-.1-.1-.2-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.3.3,0,0,0,0-.2h-.1c0-.1.1-.2,0-.2v-.2h.2v-.2h0c.1.1.1.3.2.3h.1c.1-.1.1-.2.2-.3a1,1,0,0,0,0,.4v.1l.3.3h0c0,.1-.1.1-.1.1h0s-.1.1,0,.1h0c.1.1.1-.1.1-.1s-.1.4-.2.6S402.1,574,401.9,574Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 573.8 401.7 573.8 401.7 573.8 401.7 573.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,572.5a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 573.6 401.7 573.6 401.7 573.6 401.7 573.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.6 573.7 401.6 573.7 401.6 573.7 401.6 573.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.6 573.6 401.6 573.6 401.6 573.6 401.6 573.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.5 573.5 401.5 573.5 401.5 573.5 401.5 573.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.4 573.5 401.5 573.5 401.4 573.5 401.4 573.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.6 573.4 401.6 573.4 401.6 573.4 401.6 573.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,572.5H403s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.4 573.5 401.4 573.5 401.4 573.5 401.4 573.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.1,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.1,572.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,572.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.2,573h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.4,573.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.3 572.9 402.3 572.9 402.3 572.8 402.3 572.8 402.3 572.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.2,572.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.9,569.7v-.2c.1,0,0-.1.1-.1a1.2,1.2,0,0,0,0-.4h.3v-.2c-.1.2.1.4,0,.5s-.1.3-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,572.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.3,572.3s0,0,0-.1S402.4,572.3,402.3,572.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,572.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,570h-.5s-.1,0,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.1h0S402.3,572.2,402.4,572.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,572.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.3,570.6v-.2a.3.3,0,0,1,.1-.2c.1,0,.1-.1.1-.1s.1-.1,0-.1h-.2s0,0,0-.1h-.2s0-.1,0-.1h0s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.1-.3.3-.3l.2.2h.4c-.1.1-.1.3-.2.5s0,.1,0,.1h-.1l-.2.2v.2c.1,0,.1-.1.2-.1h0c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.5,569.8c.1,0,0,0,0,0S405.5,569.8,405.5,569.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.5c-.1,0-.1-.2-.2-.3s0-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h0v.2s0,0,0-.1h0c0-.1-.1,0,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.4.4,0,0,1,.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.7 570.3 403.7 570.3 403.7 570.3 403.7 570.3 403.7 570.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.5,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.6,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.4,571.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.5 571.3 401.5 571.3 401.5 571.3 401.5 571.3 401.5 571.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.6,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.6,571.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.4 571.3 401.4 571.4 401.4 571.3 401.4 571.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "400.8 571.7 400.8 571.7 400.7 571.7 400.8 571.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.9,570.4a.2.2,0,0,1,0-.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,571c-.1-.1,0-.2,0-.3h.3a.1.1,0,0,1,0,.1c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.5,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.4,571.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.8,571h0s0-.2-.1-.1h0s0,0,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,570.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.5 571.1 401.5 571.1 401.5 571.1 401.5 571.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "400.7 571.5 400.7 571.6 400.7 571.6 400.7 571.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.8,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.8,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.7,570.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,570.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 570.9 401.7 570.9 401.7 570.9 401.7 570.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.4 570.5 402.4 570.6 402.4 570.6 402.4 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.7 570.9 401.7 570.9 401.7 570.9 401.7 570.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.3 570.5 402.3 570.6 402.3 570.6 402.3 570.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.4,571h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.5,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.4,568.5v-.2c0-.1.1-.2.2-.2h.1c0,.1.1.1.1.2S404.6,568.6,404.4,568.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,569.6c-.1,0,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "405",
      "y": "568.2",
      "width": "7",
      "height": "3.59",
      "transform": "translate(-221 260.9) rotate(-28.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.5,567h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.1.1.2h-.2a.4.4,0,0,0,0,.2h.1s0,0,0,.1h-.1a.3.3,0,0,0,0,.2h0c0,.1-.1.1,0,.2h-.1v.2h0c-.1-.1-.1-.3-.2-.3h-.1c-.1,0-.1.2-.2.3a1,1,0,0,0,0-.3v-.1l-.2-.2h0s.1-.1,0-.1h-.2c.1-.2.1-.4.2-.6S410.3,566.9,410.5,567Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 567.1 410.6 567.1 410.6 567.1 410.6 567.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,568.3a.1.1,0,0,1,0,.2h-.2c-.1,0,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 567.3 410.6 567.3 410.6 567.3 410.6 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 567.3 410.7 567.2 410.7 567.2 410.8 567.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 567.4 410.8 567.3 410.8 567.4 410.8 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 567.4 410.8 567.4 410.8 567.4 410.8 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.9 567.4 410.9 567.4 410.9 567.4 410.9 567.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 567.5 410.7 567.5 410.7 567.5 410.7 567.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,568.3h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.9 567.4 410.9 567.4 410.9 567.4 410.9 567.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,568.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,568.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,567.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.9,567.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 568 410 568 410.1 568 410.1 568 410 568"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,568h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,570.9v.2h-.1a1.1,1.1,0,0,0,0,.3h-.3v.2c.1-.2-.1-.3,0-.5s.1-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.6s0,0,0,.1S410,568.6,410,568.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.3,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,570.7h.5s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.7h0S410,568.7,410,568.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,568.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,570.1v.4c-.1,0-.1.1-.1.1s-.1.1,0,.1h.2s0,0,0,.1h.1s0,.1,0,.1h0s0,.1,0,.1h-.1s-.1.1,0,.1h-.1c-.2,0-.1.2-.3.3v-.2h-.4c.1-.1.1-.3.2-.5s0-.1,0-.1h0l.2-.2v-.2c-.1,0-.1.1-.2.1h0c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,570.8c-.1,0,0,0,0,0S407,570.8,407,570.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.3c.1,0,.1.2.2.3s0,.2-.1.2,0-.1,0-.1h0s0-.1,0-.1h0v-.2s0,0,0,.1h0c0,.1.1,0,0,.1s0,0,0-.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "408.7 570.4 408.7 570.4 408.7 570.4 408.7 570.4 408.7 570.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.8,569.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.7,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.9,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.8 569.5 410.8 569.5 410.8 569.5 410.8 569.5 410.8 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.7,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.7,569.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.9 569.5 410.9 569.4 410.9 569.4 410.9 569.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.5 569.1 411.5 569.1 411.5 569.1 411.5 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.5,570.3a.2.2,0,0,1,0,.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.6,569.7c.1.1,0,.2,0,.3h-.2a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.9,569.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,569.8h0s0,.2.1.1h0s0,0,0,.1h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,569.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.8 569.7 410.8 569.7 410.8 569.7 410.8 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.6 569.3 411.6 569.3 411.6 569.3 411.6 569.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,569.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,569.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 569.8 410.6 569.8 410.6 569.8 410.6 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410 570.2 410 570.2 410 570.2 410 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 569.9 410.6 569.8 410.6 569.8 410.6 569.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410 570.2 410 570.2 410 570.2 410 570.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,569.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,569.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,572h.1c0,.1-.1.2-.2.2h-.1s-.1-.1-.1-.2S407.9,572,408,572Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.9,571.1c.1,0,0,.1,0,.1h-.2a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "410.7",
      "y": "568.8",
      "width": "6.2",
      "height": "3.17",
      "transform": "matrix(0.96, -0.28, 0.28, 0.96, -144.55, 140.47)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.5,572.7h-.2c-.1-.1-.1-.2-.2-.3s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1v-.2h0a.2.2,0,0,0,0-.2h0c0-.1.1-.1.1-.2h.1c.1.1,0,.2.1.3h.1l.2-.2a.9.9,0,0,0-.1.3h.2v.2l.2.3h0s-.1.1,0,.1h.1l-.3.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.4 572.5 411.4 572.6 411.4 572.6 411.4 572.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.2,571.8a.1.1,0,0,1,0-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.4 572.4 411.4 572.4 411.4 572.4 411.4 572.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.3 572.4 411.3 572.4 411.3 572.4 411.3 572.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.3 572.3 411.3 572.3 411.3 572.3 411.3 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.3 572.3 411.3 572.3 411.3 572.3 411.3 572.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.2 572.2 411.2 572.3 411.2 572.3 411.2 572.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.4 572.2 411.4 572.2 411.4 572.2 411.4 572.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,571.8h-.2s0,0,0,0h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.2 572.2 411.2 572.3 411.2 572.3 411.2 572.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,571.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,571.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,571.8s0,0,0,0S412.7,571.8,412.7,571.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,571.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.2,572.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.1 571.9 412.1 571.9 412.1 571.9 412.1 571.9 412.1 571.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,571.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,570.2V570h.1a1,1,0,0,0,.1-.3h.3c-.1.1,0,.3-.1.4s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.8,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.4s0,0,0-.1S412.2,571.4,412.2,571.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,571.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.8,570.3l-.4-.2s0,0,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,571.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.1,570.4c0-.1,0-.1,0-.2h0s0,0,0-.1h0a.1.1,0,0,0,0-.1h.1s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.2-.2.3-.2s.1.1.1.2h.3l-.3.4s-.1.1,0,.1h-.3v.2h.2s-.1.1-.1.2.1,0,0,.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.2,570c.1,0,0,0,0,0S415.2,570,415.2,570Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.6,570.1a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M413.6,570.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.7c-.1-.1-.1-.2-.1-.3s.1-.1.1-.2,0,0,0,.1h0s0,.1,0,0h-.1a.2.2,0,0,0,.1.2s0,0,0-.1h0s0,0,0-.1,0,0,0,.1h0s0,0,0-.1h0c0-.1-.1-.1,0-.2s0,.1,0,.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "413.6 570.1 413.6 570.1 413.6 570.1 413.6 570.1 413.6 570.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.7,570.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.8,570.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.5h0S411.6,570.5,411.6,570.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.7 570.5 411.7 570.5 411.7 570.5 411.7 570.5 411.7 570.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.8,570.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.6 570.5 411.6 570.5 411.6 570.5 411.6 570.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411 570.6 411 570.7 411 570.7 411 570.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413,570a.2.2,0,0,1,.1-.2H413Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.9,570.3c0-.1,0-.2.1-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,570.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412,570.2h0s0-.1,0-.1h0s0,0,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.1,570.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411.7 570.3 411.7 570.3 411.7 570.3 411.7 570.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "411 570.5 411 570.5 411 570.5 411 570.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M413.1,569.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.9,570.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.1,570.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.9 570.2 411.9 570.2 411.9 570.2 411.9 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.5 570 412.5 570 412.5 570 412.5 570"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "411.9 570.2 411.9 570.2 411.9 570.2 411.9 570.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.5 570 412.5 570 412.5 570 412.5 570"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.7,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,570.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.6,568.8s0-.1,0-.1h.3s.1.1,0,.2S414.6,568.8,414.6,568.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.7,569.3s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "407.3",
      "y": "559",
      "width": "3.7",
      "height": "7.17",
      "transform": "translate(-158.1 160) rotate(-18.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,560c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1h.3c0,.1-.1.1-.1.2h1l-.3.2h0c0,.1.2.1.3.3h-.3l.2.2-.3-.2-.3.2c0,.1.1.1,0,.2s0-.1-.1-.2h-.3c-.1.1.1.1.1.1l-.5-.3C406.5,560.3,406.4,560.2,406.4,560Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.6 559.9 406.6 559.9 406.6 559.9 406.6 559.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,562h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,407.5,562Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.8 559.9 406.8 559.9 406.8 559.9 406.8 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.8 559.8 406.7 559.8 406.8 559.8 406.8 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.8 406.9 559.8 406.9 559.8 406.9 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.8 406.9 559.8 406.9 559.8 406.9 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.7 406.9 559.7 406.9 559.7 406.9 559.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407 559.8 407 559.9 407 559.9 407 559.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.6,561.5v-.3h.1c0,.1.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.9 559.6 406.9 559.7 406.9 559.7 406.9 559.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.5,561.4h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,561.5h0S407.6,561.5,407.6,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.5,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.1,559.7h0S407.1,559.7,407.1,559.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.4 560.6 407.4 560.6 407.4 560.6 407.4 560.6 407.4 560.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.5,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.6,565.5h.5c0,.1,0,.1.1.2h.1c-.1-.2-.3,0-.5-.1s-.2-.1-.2-.2S409.6,565.6,409.6,565.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.9,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.4,564.9a1.2,1.2,0,0,1,.2-.5h.1s0,.1,0,.1l-.2.4h-.1C409.3,565,409.4,564.9,409.4,564.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.1,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.1,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,562.9h.4c0,.1.1.1,0,.2h.1c0-.1.1-.1.1-.2h.3c.1,0,0-.1,0-.1h.3s0,0,0,.1h.1c0,.2.2.2.2.4h-.2c-.1.1,0,.1,0,.2h-.1c.1,0,0,.1.1.2l-.4-.3H410v.2h-.1s0-.1,0-.2v-.4h-.2c-.1.1.1.1.1.2h-.3a.3.3,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,564.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.5,562.3h0A.1.1,0,0,1,409.5,562.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.5,562.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,560.1h.3s0,0,0,0h-.1c-.1,0,0,.1-.1.1h.1s0-.1,0-.1h-.1C408.8,560.2,408.8,560.1,408.8,560.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.6 562.4 409.6 562.4 409.6 562.4 409.6 562.4 409.6 562.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.9,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409 560.1 409 560.1 409 560.1 409 560.1 409 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.1,560.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409 560 409 560 409 560 409 560"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.8 559.4 408.8 559.4 408.8 559.3 408.8 559.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,560.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.6,561.6h0C409.6,561.7,409.5,561.6,409.6,561.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,560.3h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.2A.1.1,0,0,1,409.3,560.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.1,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.1,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.5h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.2 560.2 409.2 560.2 409.2 560.2 409.2 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.9 559.3 408.9 559.3 408.9 559.3 408.9 559.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.3,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,560.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.3 560.4 409.3 560.4 409.3 560.4 409.3 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.6 561.1 409.6 561.1 409.6 561.1 409.6 561.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.4 560.4 409.3 560.4 409.3 560.4 409.4 560.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.6 561 409.6 561 409.6 561 409.6 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.1,563.4h.2c.1.1.2.1.2.2h-.2C411.1,563.6,411,563.5,411.1,563.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.4,561.3h0A.1.1,0,0,1,410.4,561.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "418.7",
      "y": "554",
      "width": "3.1",
      "height": "6.1",
      "transform": "translate(-210.1 856.4) rotate(-78.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,558s-.1-.1-.1-.2,0-.2,0-.4,0-.1,0-.1,0-.1,0-.1h.1c.1-.1,0-.2,0-.2s0,.1.1.2h.3s0,0,0-.1h.2c0-.1,0-.1,0-.2h.1c0,.1,0,.1,0,.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.2,0,.3h.4l-.2.2h0a.7.7,0,0,0,0,.3h-.1l-.4.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.8 417.2 557.8 417.2 557.8 417.3 557.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M419.1,558h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.7 417.3 557.7 417.3 557.7 417.3 557.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.2 557.6 417.2 557.7 417.2 557.7 417.2 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.6 417.3 557.6 417.3 557.6 417.3 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.3 557.5 417.3 557.6 417.3 557.5 417.3 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.2 557.5 417.2 557.5 417.2 557.5 417.2 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.4 557.5 417.4 557.5 417.4 557.5 417.4 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.8,557.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.2 557.5 417.2 557.5 417.2 557.5 417.2 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,557.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.7,557.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418,557.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.1 557.5 418.1 557.5 418.1 557.5 418.1 557.5 418.1 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M422.7,558.1c0-.1,0-.1,0-.2h.1l.2-.2s0,.1,0,.1h.3c-.2,0-.1.3-.3.3h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.1,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.2,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M422.1,557.9l-.3-.3h.1l.2.3s.1.1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M420.6,557.2c0-.1.1-.1,0-.2h.3v-.2h.1a.1.1,0,0,0,0-.1h.2c0-.1.1,0,.1-.1h.4c0,.1,0,.1,0,.2h.1s0,.1,0,.1h.2l-.4.2h0s0,.1,0,.1h-.4a0,0,0,0,1,0,.1H421s0,.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M421.7,557.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M420.3,556.7h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M420.3,556.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,556.3c-.1-.1,0-.2,0-.3h0s0,0,0,.1h0a.2.2,0,0,0,0,.2h.2c.1,0,0-.1.1-.2s-.1.1,0,.1a.3.3,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "420.3 556.7 420.3 556.7 420.3 556.7 420.3 556.7 420.3 556.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.4,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.5,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "418.4 556.2 418.4 556.2 418.4 556.1 418.4 556.1 418.4 556.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.5,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.5,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "418.4 556.1 418.3 556.1 418.3 556.1 418.4 556.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.8 556 417.8 556 417.8 556 417.8 556"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M419.8,556.3h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.7,556.1c0-.1.1-.1.2-.2h.1v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.4,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556.1h0s.1-.1,0-.1h0s0,0,0,0h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "418.6 556 418.6 556 418.6 556 418.6 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.8 555.8 417.8 555.9 417.8 555.9 417.8 555.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M419.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,556.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.8 556 418.8 556 418.8 556 418.8 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "419.4 556.1 419.4 556.2 419.4 556.1 419.4 556.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.8 556 418.8 556 418.8 556 418.8 556"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "419.4 556.1 419.4 556.1 419.4 556.1 419.4 556.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.8,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M421.7,556s0-.1,0-.1h.3s0,.1-.1.1S421.8,556.1,421.7,556Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M419.9,555.6h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "407.9",
      "y": "553.7",
      "width": "8",
      "height": "4.09",
      "transform": "translate(-156.8 949.6) rotate(-88.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,552s.1-.2.2-.2.3-.1.5-.1h.2s-.1,0,0,.1h.3c0,.1-.2,0-.2.1h.2s0-.1,0-.1h0a.4.4,0,0,1,0,.2h.3l.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0h-.4s0,0,0,.1h-.1c0,.2.2.2.2.4l-.3-.2c.1.1.1.2.1.2l-.2-.3h-.4c0,.1,0,.2-.1.2s0-.1,0-.2h-.3c-.1.1,0,.1,0,.2l-.5-.5A.7.7,0,0,1,410,552Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.2 552 410.2 552 410.2 552 410.2 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.4,554.5h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,410.4,554.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 552.1 410.4 552 410.4 552.1 410.4 552.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 551.9 410.4 551.9 410.4 551.9 410.4 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 552 410.6 552 410.6 552 410.6 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 552 410.6 552 410.6 552 410.6 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 551.9 410.6 551.9 410.7 551.9 410.7 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 552 410.6 552.1 410.6 552.1 410.7 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.6,554a.9.9,0,0,1,0-.3h.1c0,.1,0,.2-.1.3S410.6,554.1,410.6,554Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 551.8 410.7 551.8 410.7 551.8 410.7 551.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,553.9h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.6,553.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.8,552.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.8,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 553 410.8 553 410.8 553 410.8 553 410.8 553"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.9,552.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.1,559h.2c0,.1.1.1.1.2l.3.2h-.2c-.1.1,0,.1,0,.2s.1.1.1.2-.4-.1-.5-.3-.2-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.3,552.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.3,553h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,553.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,558.3l.3-.4h0l-.3.4h-.1C411.1,558.3,411.2,558.3,411.3,558.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.4,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.4,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.4,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,556.1h.2v.2c-.1.1.1.1,0,.2h.1l.2-.2h.4s0,.1,0,.1h.2s0,.1,0,.1h.1s0,0,0,.1h.1c-.1.2.2.3.1.5H413c-.1,0,0,.1,0,.2h-.1c.1.1,0,.1,0,.2s-.3-.3-.3-.5h-.1v.2h-.1c0-.1.1-.1,0-.2h.1c0-.1,0-.2,0-.3l-.2-.2c-.1.1.1.2,0,.3H412c0-.1-.1-.2-.2-.1h-.1a.3.3,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.3,555.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.3,555.7h0S412.3,555.7,412.3,555.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.5,553h.4c0,.1.2.1.2.2h-.3s0,0,0,0h-.2s0-.1,0-.1h0s0,.1,0,.1h.2l-.4-.2C412.4,553.1,412.5,553.1,412.5,553Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.4 555.7 412.4 555.7 412.4 555.7 412.4 555.7 412.4 555.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.5,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.6,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.6,553h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.6 553.2 412.6 553.1 412.7 553.1 412.7 553.2 412.6 553.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.7,553.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.7 553 412.7 553 412.7 553 412.7 553"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.7 552.3 412.7 552.2 412.7 552.2 412.7 552.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.7,553.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.7,554.9l.2.2h-.3C412.6,555,412.6,554.9,412.7,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,553.4c.1,0,.2.1.3.2s0,0,0,.1h-.3c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.8,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,553.6s0,0,0,0h.2s0,0,0,.1h0s0,0,0,0h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,553.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 553.3 412.9 553.3 412.9 553.3 412.9 553.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 552.2 412.9 552.3 412.9 552.2 412.9 552.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.8,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.9,553.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.9 553.5 412.9 553.5 412.9 553.5 412.9 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 554.4 412.9 554.4 412.9 554.4 412.9 554.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.9 553.6 412.9 553.6 412.9 553.5 412.9 553.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "412.9 554.3 412.9 554.3 412.9 554.3 412.9 554.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.9,553.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.2,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.6,557.4h.2c.1.1.1.2.1.3h-.3C413.5,557.6,413.5,557.4,413.6,557.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.7,554.9h.2a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,413.7,554.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "413.8",
      "y": "545",
      "width": "4.4",
      "height": "8.67",
      "transform": "translate(-247.6 363.6) rotate(-37.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M420.2,551.2c0,.1.1.2,0,.3s-.2.3-.3.4h-.2c-.1,0,0-.1,0-.1s-.2.2-.3.2.1-.2.1-.2h-1.2c0-.1.2-.1.1-.2h-.3c.1-.1.3-.2.3-.3h0c-.1-.1-.3-.1-.4-.2h.5l.2-.3c0-.1-.2-.1-.1-.2v.2h.2s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1-.1-.1-.1h.7C420,550.9,420.1,551,420.2,551.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "420 551.4 420 551.4 420 551.4 420 551.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.2,549.4H418v-.2h.1C418.1,549.2,418.2,549.4,418.2,549.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.8 551.5 419.8 551.5 419.8 551.5 419.8 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.9 551.6 419.9 551.6 419.9 551.6 419.9 551.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.7 419.7 551.7 419.7 551.7 419.7 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.7 419.7 551.7 419.7 551.7 419.7 551.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.8 419.7 551.8 419.7 551.8 419.7 551.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.6 551.7 419.6 551.6 419.6 551.7 419.6 551.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,550l.2.3h-.1l-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "419.7 551.9 419.7 551.9 419.7 551.9 419.7 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.4,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.9,551s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M419.5,551.9h0S419.5,551.9,419.5,551.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.8 550.9 418.8 550.9 418.8 550.9 418.8 550.9 418.8 550.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.8,551.1h0S418.8,551.1,418.8,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.4,546.1l-.2.2h-.5c0-.1-.1-.1-.1-.2h-.2c.2.1.4-.1.6-.1s.3,0,.3.2S414.4,546.1,414.4,546.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.4,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.1,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,551.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.1,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.8,546.9a1.4,1.4,0,0,1,0,.6h-.1a3.3,3.3,0,0,0,0-.5s0-.1.1-.1S414.9,546.8,414.8,546.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,549h-.4c0-.1-.2,0-.1-.2h-.1c0,.1-.1.2,0,.3h-.1c-.1,0,0,.1,0,.1h-.2c0,.1,0,.1,0,.1h-.4c-.1,0,0-.1,0-.1h-.2s0-.1,0-.1-.3-.1-.4-.3l.2-.2c0-.1,0-.1-.1-.2h.1l-.2-.2.6.2h.1a.3.3,0,0,0,0-.2h.1c.1,0,0,.1.1.2s0,.1,0,.2l.2.2h.3c0-.1-.2-.1-.2-.2h.1c.1,0,.2.1.2,0h.1a.4.4,0,0,1,.3.2A.6.6,0,0,1,415.9,549Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.8,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,549.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.7,549.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.4,552.1c0,.2-.2.2-.3.3h0c0-.1.1,0,0-.1h0l.2-.2h-.1c.1,0-.1-.1,0-.1h-.1c0,.1.1.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.7 549.8 415.7 549.8 415.6 549.8 415.6 549.8 415.7 549.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.1h0S417.3,552.1,417.3,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,552.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.2 552.1 417.2 552.1 417.1 552.1 417.1 552.1 417.2 552.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.1,552h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.2 552.2 417.2 552.2 417.2 552.3 417.2 552.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.7 552.9 417.7 552.9 417.7 552.9 417.7 552.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,550.7h-.3v-.2h.1C415.9,550.6,416,550.6,415.9,550.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,552c-.1.1-.2,0-.4,0h0a.3.3,0,0,0,.1-.2h.2c.1,0,0,.2.2.1A.1.1,0,0,1,416.8,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.1,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,551.8h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.9 552.1 416.9 552.1 416.9 552.2 416.9 552.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.6 553 417.6 553 417.6 553 417.6 553"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.9h0S416.6,551.9,416.6,551.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.7,550.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,551.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.7 552 416.7 551.9 416.7 551.9 416.7 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.1 551.2 416.1 551.2 416.1 551.2 416.1 551.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.6 551.9 416.7 551.9 416.7 551.9 416.6 551.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.1 551.3 416.2 551.3 416.1 551.3 416.1 551.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.3,553.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.5,549.2h-.2c-.1,0-.2,0-.2-.2h.2C413.4,548.9,413.5,549.1,413.5,549.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.1,551.4h-.3s0-.1,0-.1h.2A.2.2,0,0,1,415.1,551.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "408.4",
      "y": "544.5",
      "width": "8.3",
      "height": "4.27",
      "transform": "translate(-207.4 255.6) rotate(-27.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.1,550.3h-.2c-.2,0-.2-.2-.4-.3s0-.1,0-.1h0c0-.1-.1-.2-.2-.3h.2a.5.5,0,0,0,0-.2h-.1s0-.1,0-.1h.1a.3.3,0,0,0,0-.3h-.1c0-.1.1-.2,0-.3v-.2h.1c.1,0,.1.2.2.2h0v-.2h0c.1.1.1.3.3.3h.1c.2-.1.1-.3.2-.4a1.2,1.2,0,0,0,0,.4l.2-.2v.3l.3.3h0c0,.1-.1.1-.1.2h0s-.1.1,0,.1h0c.1.1.1-.1.2-.1s-.1.5-.2.7S410.3,550.3,410.1,550.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 550.1 410 550.1 410 550.1 410 550.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,548.7a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.9 549.9 409.9 549.9 409.9 549.9 409.9 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.9 409.8 549.9 409.8 549.9 409.8 549.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.8 409.8 549.8 409.8 549.8 409.8 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.8 409.8 549.8 409.8 549.8 409.8 549.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.7 549.7 409.7 549.8 409.7 549.8 409.7 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 549.7 409.8 549.7 409.8 549.7 409.8 549.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,548.7h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.6 549.8 409.6 549.8 409.6 549.8 409.6 549.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.5,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.6,548.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.4,548.8h0S411.5,548.7,411.4,548.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,549.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.7 549 410.7 549 410.6 549 410.6 549 410.7 549"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.5,549h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,545.6v-.2c.1,0,0-.1.1-.2a1.4,1.4,0,0,0,0-.4h.3c0-.1,0-.2.1-.2s.1.4,0,.6-.1.3-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.3,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.4s0-.1,0-.1S410.7,548.4,410.7,548.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.4,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.1,545.9h-.5s-.1-.1,0-.1h.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.2h0S410.7,548.3,410.7,548.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.7,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.9,546.5c-.1-.1,0-.2-.1-.2a.3.3,0,0,1,.1-.2c.1,0,.1-.2.2-.1s.1-.1,0-.1h-.3s0,0,0-.1h-.2s0-.1,0-.1h0a.1.1,0,0,0-.1-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.3.4-.3s.2.1.2.2h.4c-.1.1-.1.4-.2.5s0,.1,0,.1h-.1l-.2.2v.3c.1.1.1-.2.2-.2h.1c0,.1-.1.1-.1.2s.1,0,.1.1a.3.3,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.3,545.7c.1,0,0,0,0,.1S414.3,545.7,414.3,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.2,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M412.3,546.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.5c-.1-.1-.1-.2-.2-.3s0-.2.1-.3,0,.1,0,.1h0s0,.1,0,.1h-.1v.2s0,0,0-.1h.1c0-.1-.1-.1,0-.1s0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.2-.1-.3s0,.1.1.1a.5.5,0,0,1,.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "412.3 546.2 412.2 546.2 412.2 546.2 412.2 546.2 412.3 546.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.9,547.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.8 547.3 409.8 547.3 409.8 547.3 409.8 547.3 409.8 547.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.9,547.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.7 547.3 409.7 547.3 409.6 547.3 409.7 547.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.9 547.7 408.9 547.7 408.9 547.7 408.9 547.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.3,546.3a.3.3,0,0,1,0-.3l.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410,547c-.1-.1,0-.2,0-.4h.3a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.6,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.9h0c0-.1,0-.2-.1-.2h0s-.1-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "409.8 547 409.8 547 409.8 547 409.8 547"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.8 547.5 408.9 547.5 408.8 547.5 408.8 547.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.1,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.1,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M411.5,546.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410,546.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.2,546.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 546.9 410 546.9 410 546.9 410 546.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.8 546.4 410.8 546.5 410.8 546.5 410.8 546.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410 546.8 410 546.8 410 546.9 410 546.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "410.7 546.4 410.7 546.5 410.7 546.5 410.7 546.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,547h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.6,547.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.1,544.2c-.1,0-.1-.1-.1-.2s.1-.2.2-.2h.1c0,.1.1.1.1.2S413.3,544.3,413.1,544.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,545.4c-.1,0,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "414.1",
      "y": "537.8",
      "width": "3.9",
      "height": "7.65",
      "transform": "translate(-46.8 39.4) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.3,544.9s0,.2-.1.2-.3.1-.4.2h-.2s.1-.1,0-.1h-.3c0-.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.1h-.8s0,0,0,0h.4s0,0,0-.1h.1c0-.1-.2-.2-.2-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.3c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1,0-.1,0-.2l.5.4A.6.6,0,0,1,418.3,544.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.1 545 418.1 545 418.1 545 418.1 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.6,542.6h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,417.6,542.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.8 544.9 417.9 544.9 417.8 544.9 417.8 544.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.8 545.1 417.9 545.1 417.9 545.1 417.8 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.7 545 417.7 545 417.7 545 417.7 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.7 545.1 417.7 545 417.7 545.1 417.7 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.6 545.1 417.7 545.1 417.7 545.1 417.6 545.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.6 545 417.6 545 417.6 545 417.6 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.4,543.1a.8.8,0,0,1,0,.3h-.1c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.6 545.2 417.6 545.2 417.6 545.2 417.6 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,543.2h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.4,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.5,545.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.4 544 417.4 544 417.4 544 417.4 544 417.4 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,538.4h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2v-.2c.1.2.4.1.5.2s.2.2.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.9,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.9,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.3,539.1l-.3.4H416s0-.1,0-.1l.3-.4h.1C416.5,539,416.4,539.1,416.3,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.1,541.2h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1h-.1c.1-.2-.2-.2-.2-.4h.2c.1,0,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2h-.1c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1,0-.3h.1s.1.2.2.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.9,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.6,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.6,541.7h0S415.7,541.7,415.6,541.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.8,544.3h-.4c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C415.8,544.1,415.8,544.2,415.8,544.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.6 541.7 415.6 541.7 415.6 541.7 415.6 541.7 415.6 541.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.8,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.7,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.7,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.6,544.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 544.2 415.6 544.2 415.6 544.2 415.6 544.2 415.6 544.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.6,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.6,544.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 544.3 415.6 544.3 415.6 544.3 415.6 544.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 545 415.7 545 415.7 545 415.6 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.6,544.1s0,0,0,0S415.6,544.1,415.6,544.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.3,542.5h.1C415.4,542.4,415.4,542.5,415.3,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.4,543.9h-.3s0,0,0-.1h.3c.1.1,0,.1.1.2A.1.1,0,0,1,415.4,543.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.5,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.5,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.4,543.7h-.1s0,0,0,0h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.4,543.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.4 544 415.4 544.1 415.4 544.1 415.4 544"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.5 545 415.5 545 415.5 545 415.5 545"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.2,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.4,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.3,543.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.3 543.8 415.3 543.8 415.3 543.8 415.3 543.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.2 543 415.3 543 415.3 543 415.2 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "415.3 543.8 415.3 543.8 415.3 543.8 415.3 543.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.2 543.1 415.3 543.1 415.2 543.1 415.2 543.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.3,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.2,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.2,540.3H414c-.1-.1-.2-.1-.1-.2h.3C414.3,540,414.3,540.2,414.2,540.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.4,542.6h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,414.4,542.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "413.1",
      "y": "534.7",
      "width": "3.6",
      "height": "6.99",
      "transform": "translate(-250.1 678.1) rotate(-64.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M418.5,538c0,.1.1.1.1.2s0,.3-.1.4h-.1s0,.1,0,.1h-.1c-.1,0,0,.2-.1.3s0-.2,0-.2h-.4s0,0,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1v.2h0c0-.1.2-.2.1-.3h-.1a.1.1,0,0,0,0-.1H417l.3-.2h.1a.8.8,0,0,0,.1-.3h.1l.6-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.5 538.2 418.5 538.2 418.5 538.2 418.5 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,537.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.3 538.4 418.4 538.4 418.4 538.4 418.3 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.5 538.4 418.5 538.4 418.5 538.4 418.5 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.5 418.4 538.5 418.4 538.5 418.4 538.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.5 418.4 538.5 418.4 538.5 418.4 538.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.6 418.4 538.6 418.4 538.6 418.4 538.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.3 538.6 418.3 538.5 418.3 538.5 418.3 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,537.8h.2l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "418.4 538.7 418.4 538.6 418.4 538.6 418.4 538.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.8,537.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.8,537.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.9,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.6,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M418.3,538.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "417.4 538.3 417.4 538.3 417.4 538.3 417.4 538.3 417.4 538.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.5,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.5,536.5c0,.1,0,.1-.1.2h-.2l-.3.2s.1-.1,0-.1h-.4c.2,0,.2-.2.4-.3s.2-.1.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,538.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M417.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.1,536.8l.2.4h-.1l-.2-.4s-.1-.1,0-.1S413.1,536.8,413.1,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,538.7h0S416.9,538.7,416.9,538.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.6,538v.2h-.2c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.4s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.3V538c0-.1,0-.1,0-.1h.1v.2h.4s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.4,537.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.8,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M414.8,538.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.9,539.7c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1,0,0-.1h-.2v.2s.1-.1,0-.1a.4.4,0,0,1,.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "414.8 538.6 414.8 538.6 414.8 538.6 414.7 538.6 414.8 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.7h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.7,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.8,539.8h0S416.8,539.8,416.8,539.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.7 539.8 416.7 539.8 416.7 539.8 416.7 539.8 416.7 539.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.6,539.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.8 539.8 416.8 539.8 416.8 539.9 416.8 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.4 540.1 417.4 540.1 417.4 540.1 417.4 540.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M415.3,539.2H415a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.4,539.8l-.3.2h-.1a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,416.4,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.6,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.7,539.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.2,539.7h0s-.1.1-.1.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.1,539.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "416.5 539.9 416.5 539.9 416.5 539.9 416.5 539.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "417.3 540.3 417.3 540.3 417.3 540.3 417.3 540.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.2,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.2,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M415.1,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.3,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M416.1,539.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.3 539.8 416.3 539.8 416.3 539.8 416.3 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.6 539.5 415.6 539.5 415.6 539.5 415.6 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "416.3 539.8 416.3 539.8 416.3 539.8 416.3 539.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "415.7 539.6 415.7 539.5 415.7 539.5 415.7 539.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M416.5,540h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M417.2,540.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413,539h-.2C412.8,538.9,413,538.9,413,539Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M414.9,540h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "405.3",
      "y": "530.7",
      "width": "3.4",
      "height": "6.65",
      "transform": "matrix(0.62, -0.78, 0.78, 0.62, -264.35, 521.55)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.6,533.5c0-.1-.1-.1,0-.2s.1-.2.1-.4h.2c.1,0,.1-.2.2-.2s-.1.1,0,.2h.8c0,.1-.1.1-.1.2h.2c0,.1-.2.2-.2.3h0v.3c0,.1.1.1.1.1h-.3s0,0,0,0h-.6C403.8,533.7,403.6,533.6,403.6,533.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.7 533.3 403.7 533.3 403.7 533.3 403.7 533.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.4,534.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 533.2 403.8 533.2 403.8 533.2 403.8 533.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.7 533.1 403.7 533.1 403.7 533.1 403.7 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 533.1 403.8 533.1 403.8 533.1 403.8 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 533 403.8 533 403.8 533 403.8 533"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 532.9 403.8 533 403.8 533 403.8 532.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.9 533 403.9 533.1 403.9 533.1 403.9 533"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,534.1l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.8 532.9 403.8 532.9 403.8 532.9 403.8 532.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.1,533.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.5,533.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,532.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.7 533.5 404.7 533.4 404.7 533.4 404.7 533.4 404.7 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.6,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.8,536.2V536h.7c-.2,0-.3.2-.4.2h-.3S408.8,536.2,408.8,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.4,535.7a1.1,1.1,0,0,1-.1-.4h.1a2.6,2.6,0,0,0,.1.4s0,.1,0,.1S408.4,535.7,408.4,535.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,534.3h.3c0,.1.1,0,.1.1h.1c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s-.1-.1,0-.1h.5s0,0,0,.1.3,0,.4.2,0,.2-.1.2h-.4v.2c0,.1,0,.1,0,.1h-.1s0-.1,0-.2h-.4c0,.1.1,0,.2.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,535h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.2,533.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.5,532.3c0-.1.1-.2.2-.3h0c0,.1,0,0,0,.1h0v.2h0s.1.1,0,.1h.3l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 533.7 407.2 533.7 407.2 533.7 407.2 533.7 407.2 533.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.5,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,532.2h0S405.6,532.2,405.6,532.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.7 532.3 405.7 532.3 405.7 532.2 405.7 532.2 405.7 532.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,532.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.6 532.2 405.6 532.2 405.6 532.1 405.6 532.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 531.8 405.1 531.8 405.1 531.8 405.1 531.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.9,533.1h.2a.3.3,0,0,1-.1.2h-.1S406.8,533.1,406.9,533.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,532.3h.3a.2.2,0,0,0,0,.2H406A.1.1,0,0,1,406,532.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,532.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.9 532.2 405.8 532.2 405.8 532.2 405.9 532.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.2 531.6 405.2 531.7 405.2 531.6 405.2 531.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.3h0S406.1,532.3,406.1,532.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.1,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,532.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406 532.3 406 532.3 406 532.3 406 532.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.6 532.7 406.6 532.7 406.6 532.7 406.6 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.1 532.3 406.1 532.3 406.1 532.3 406.1 532.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.6 532.7 406.6 532.7 406.6 532.7 406.6 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,531.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,533.7h.2C409.1,533.9,408.9,533.8,409,533.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,532.4h.3s0,.1,0,.1h-.1C407.4,532.6,407.3,532.5,407.4,532.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "406.3",
      "y": "525.8",
      "width": "3.9",
      "height": "7.68",
      "transform": "translate(-247.4 661.2) rotate(-63.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,529.8c0-.1-.1-.1-.1-.2s0-.3.1-.4,0-.1.1-.1,0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2,0,.2h.5s0-.1,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.2.2-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.8.8,0,0,0-.1.4c0,.1.2,0,.2.1h-.5c0,.1.1,0,.2.1l-.6.2C404.5,530,404.3,530,404.2,529.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.3 529.6 404.3 529.6 404.3 529.6 404.3 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.5 529.4 404.4 529.5 404.4 529.5 404.5 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.3 529.4 404.3 529.4 404.3 529.4 404.3 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.4 529.3 404.4 529.3 404.4 529.3 404.4 529.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.4 529.3 404.4 529.3 404.4 529.3 404.4 529.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.4 529.2 404.4 529.2 404.4 529.2 404.4 529.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.5 529.3 404.5 529.3 404.5 529.3 404.5 529.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,530.1h-.2l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.3 529.1 404.3 529.2 404.3 529.2 404.3 529.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,530s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,530h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.3,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.5,529.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.4 529.5 405.4 529.5 405.4 529.5 405.5 529.5 405.4 529.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.4,529.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.8,531.6c0-.1,0-.1.1-.2h.2l.3-.2s-.1.1,0,.2h.4c-.2,0-.3.3-.5.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.6,529s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.6,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.2,531.2a1.3,1.3,0,0,1-.2-.5h.1l.2.4s.1.1,0,.1S410.2,531.2,410.2,531.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,529.1h0S406.1,529.2,406.1,529.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.5,529.9v-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.4v.2c0,.1,0,.1,0,.1h-.1v-.2H409c0,.1.2,0,.2.1a0,0,0,0,1,0,.1c-.1,0-.2,0-.2.1s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.9,530.4c0,.1,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.4,529.2s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,528.1c0-.1.1-.2.1-.3h0c0,.1-.1,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1.1,0,.1h.2l.2-.2s-.1.1,0,.1a.4.4,0,0,1-.3.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "408.4",
      "y": "529.2",
      "height": "0.01",
      "transform": "translate(-247.7 656.9) rotate(-63.4)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,528h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.3,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,527.9h0S406.2,527.9,406.1,527.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.3 528 406.3 528 406.3 527.9 406.3 527.9 406.3 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,528s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.2 527.9 406.2 527.9 406.2 527.9 406.2 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.5 527.5 405.5 527.5 405.5 527.5 405.5 527.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.8,528.6h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,527.9c0-.1.2-.1.3-.2h.1a.3.3,0,0,0,0,.2h-.3A.1.1,0,0,1,406.6,527.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,528h0c0-.1.1-.1.1-.1h.1s0,0,0,.1h0s0,0,0,0h-.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.5 527.8 406.5 527.8 406.5 527.8 406.5 527.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.6 527.4 405.6 527.4 405.6 527.4 405.6 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.1,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.7,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,528h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.7 527.9 406.7 527.9 406.7 527.9 406.7 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.5 528.2 407.4 528.2 407.4 528.2 407.5 528.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.8 527.9 406.7 527.9 406.7 527.9 406.8 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.4 528.2 407.4 528.2 407.4 528.2 407.4 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.5,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.3,528.8v-.2h.3v.2C410.5,529,410.3,528.9,410.3,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,527.7h.2A.1.1,0,0,1,408.2,527.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "399.9",
      "y": "523.3",
      "width": "8.3",
      "height": "4.27",
      "transform": "translate(-258.3 548.7) rotate(-54.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.5,529.7h-.2c-.2.1-.3-.1-.5-.1s-.1-.1-.1-.1h0c0-.1-.2-.1-.3-.2h.2V529h-.1s0,0,0-.1h.1a.3.3,0,0,0-.1-.2h-.1c-.1-.1,0-.2-.1-.3h.1s0-.1,0-.1h-.2c.1,0,.2.2.4.2h.1c.1-.1,0-.3.1-.4a1.2,1.2,0,0,0,.1.4c0-.1,0-.2.1-.3a1,1,0,0,1,0,.4h.4c.1,0,.1-.2.2-.1s-.1.1-.1.2,0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.2s.1.5.1.7S403.7,529.7,403.5,529.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 529.6 403.3 529.7 403.3 529.7 403.3 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.6,527.4v-.2h.2C404.8,527.3,404.7,527.4,404.6,527.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.1 529.4 403.2 529.5 403.2 529.5 403.1 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.1 529.6 403.1 529.6 403.1 529.6 403.1 529.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403 529.5 403 529.5 403 529.5 403 529.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.9 529.4 403 529.5 403 529.5 402.9 529.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 529.5 402.9 529.5 402.9 529.5 402.8 529.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403 529.3 403 529.3 403 529.3 403 529.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,527.6l-.2.2h0l.2-.2S404.2,527.6,404.1,527.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 529.5 402.8 529.5 402.8 529.5 402.8 529.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.4,528.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.7,529.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.4 528.4 403.4 528.4 403.4 528.4 403.4 528.4 403.4 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.2,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,523h-.2c.1-.1,0-.1,0-.2l-.2-.3h.2c.1,0,.1-.1.1-.2s0-.2,0-.2.2.3.2.5.1.3-.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.9,528.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.9,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,523.6l-.5.2h.7C406.2,523.6,406.1,523.6,406,523.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.2,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.1,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.1,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.3,525.1l-.2-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.5s0-.1,0-.1h-.2c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.5h.3c.1,0,.1-.1.1-.1h.1c0-.1.1-.1.1-.2s.1.4,0,.6,0,.1.1.1h0v.3a.9.9,0,0,0,0,.3c.1,0,0-.2.1-.2h.1c0,.1-.1.2.1.2h.1a.3.3,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.6,525.3h-.1a.1.1,0,0,1,0-.1h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.6,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.5c-.2,0-.2-.1-.3-.2s-.1-.2,0-.3h.3c0-.1-.1,0-.1-.1h.1s0-.1,0-.1h0c0-.1-.2-.1-.2-.2h.1a.5.5,0,0,1,.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.6 525.2 403.6 525.2 403.6 525.2 403.6 525.2 403.6 525.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,527.2s0,0,0,0S402,527.2,402,527.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.8,527.4s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.9 527.2 401.9 527.2 401.8 527.2 401.8 527.2 401.9 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,527.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.8 527.3 401.8 527.3 401.7 527.3 401.8 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.3 528 401.3 528 401.3 528 401.3 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.8,525.7a.3.3,0,0,1-.1-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,526.9c-.1-.1-.1-.2-.1-.3h.4c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.7h-.1s0,0,0-.1h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.8 527 401.8 527 401.7 527 401.8 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "401.1 527.9 401.1 527.9 401.1 527.9 401.1 527.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M401.9,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.9 526.7 401.9 526.7 401.9 526.8 401.9 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.4 526 402.4 526 402.4 526 402.4 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "401.9 526.7 401.9 526.7 401.9 526.7 401.9 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "402.3 526 402.3 526.1 402.3 526.1 402.3 526"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.7,527h0S401.7,527,401.7,527Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.8,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.5,523h-.1c0-.1,0-.2.1-.3h.1v.2C403.7,522.9,403.6,523,403.5,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402,525.1h-.1a.2.2,0,0,1,.1-.2h.2C402.1,525,402.1,525.1,402,525.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "406",
      "y": "516.9",
      "width": "4.1",
      "height": "7.95",
      "transform": "translate(-139.8 149.7) rotate(-17.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411,523.8c0,.1,0,.2-.1.2s-.2.2-.4.3h-.2s.1-.1,0-.1-.2.1-.3.1.2-.1.1-.2H409c.1-.1.3-.1.4-.2h0c0-.2-.2-.2-.3-.3h.4l-.2-.2.3.2.3-.2c0-.1-.1-.1,0-.2s0,.1.1.2h.4c.1-.1-.1-.1-.1-.2l.6.3C410.9,523.5,411.1,523.6,411,523.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.8 523.9 410.8 523.9 410.8 523.9 410.8 523.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,521.6h-.2a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,409.8,521.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 523.9 410.6 523.9 410.6 523.9 410.6 523.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.6 524 410.6 524 410.6 524 410.6 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.5 524 410.5 524 410.5 524.1 410.5 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.5 524.1 410.5 524.1 410.5 524.1 410.5 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 524.2 410.5 524.1 410.5 524.2 410.4 524.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 524 410.4 524 410.4 524 410.4 524"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.8,522.1a.8.8,0,0,1,.1.3h-.1c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "410.4 524.2 410.4 524.2 410.4 524.2 410.4 524.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,522.2h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,522.2h0S409.8,522.2,409.8,522.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410,523.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M410.3,524.2h0S410.3,524.1,410.3,524.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.9 523.1 409.9 523.1 409.9 523.1 409.9 523.1 409.9 523.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.9,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.6,517.6h-.5c.1-.1,0-.1-.1-.2l-.2-.2c.2.2.4,0,.6.1s.3.1.2.3S407.6,517.6,407.6,517.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.5,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,523h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.4,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.7,518.4a1.3,1.3,0,0,1-.2.5h-.1s0-.1,0-.1l.2-.5h.1C407.8,518.3,407.8,518.4,407.7,518.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.3,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.2,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,520.6h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.1.1-.1.2H407c-.1,0,0,.1-.1.1s0-.1,0-.1h-.3s0-.1,0-.1h-.1c0-.2-.2-.2-.3-.4h.2c.1-.1,0-.1,0-.2h.1c-.1,0,0-.1-.1-.2l.5.3h.1v-.2h.1c.1,0,0,.1,0,.2v.4h.2c.1-.1-.1-.1-.1-.2h.1c.1,0,.1.2.2.1h.1a.3.3,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,519.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.6,521.2h0A.1.1,0,0,1,407.6,521.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,521.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.4,523.7H408l-.3-.2h.3s0,0,0,0h.2c.1,0,0-.1.1-.1h-.1s0,.1,0,.1h.1C408.4,523.6,408.4,523.7,408.4,523.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 521.1 407.6 521.2 407.5 521.2 407.5 521.1 407.6 521.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.3,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.3,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.2,523.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.2 523.6 408.2 523.6 408.1 523.6 408.1 523.6 408.2 523.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.1,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408.1,523.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.1 523.8 408.2 523.8 408.2 523.8 408.1 523.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.4 524.5 408.4 524.5 408.4 524.5 408.4 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.1,523.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,522h0C407.5,521.9,407.6,522,407.5,522Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,523.4h-.3s0-.1,0-.1v-.2h.2c.1,0,0,.1.1.2A.1.1,0,0,1,407.9,523.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.2h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.9 523.6 407.9 523.6 407.9 523.6 407.9 523.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.2 524.6 408.2 524.5 408.2 524.6 408.2 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,523.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.7,523.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.8 523.4 407.8 523.3 407.8 523.4 407.8 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.5 522.6 407.5 522.6 407.5 522.6 407.5 522.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.8 523.3 407.8 523.3 407.8 523.3 407.8 523.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.5 522.6 407.5 522.6 407.5 522.6 407.5 522.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,523.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,524.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,520h-.2c-.1-.1-.2-.1-.2-.2h.3C405.9,519.7,406,519.9,405.9,520Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,522.3h-.2v-.2h.2A.1.1,0,0,1,406.6,522.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "407.7",
      "y": "511.8",
      "width": "4.2",
      "height": "8.3",
      "transform": "translate(-129.9 893.9) rotate(-86.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,517.8s-.2-.1-.2-.2-.1-.3-.1-.5,0-.1,0-.1h.1c.1-.1,0-.2,0-.3s0,.2.1.2v-.2h.1v-.2s0-.1,0-.1.2-.1.2-.2,0-.1,0-.2h.1c.1.1,0,.2.1.2h.1c0-.1,0-.1,0-.2h0c0,.1-.1.3,0,.4h.1c.2,0,.2-.2.4-.2l-.2.3h.3l-.3.2a.9.9,0,0,0,.1.4h-.2c.1.1.1,0,.2,0l-.5.5A.7.7,0,0,1,405.9,517.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.9 517.6 405.9 517.6 405.9 517.6 405.9 517.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.5,517.5a.1.1,0,0,1,.1-.2h.2c0,.1,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406 517.3 406 517.4 406 517.4 406 517.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.8 517.3 405.8 517.4 405.8 517.3 405.8 517.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.9 517.2 405.9 517.2 405.9 517.2 405.9 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.9 517.2 405.9 517.2 405.9 517.2 405.9 517.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.8 517.1 405.8 517.1 405.8 517.1 405.8 517.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406 517.1 406 517.1 406 517.1 406 517.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408,517.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.8 517.1 405.8 517.1 405.8 517.1 405.8 517.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.9,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M408,517.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,517.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,517h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.9,516.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407 517 407 517 407 517 407 517 407 517"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,516.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.2,516.8c-.1-.1,0-.2,0-.2h.2l.2-.3s0,.1,0,.2h.4c-.2.1-.1.4-.3.5s-.2.2-.3.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.4,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M412.4,516.7l-.4-.4s0-.1,0-.1h.1l.4.4s.1.1.1.1S412.5,516.7,412.4,516.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M410.2,516.1c0-.1.1-.2,0-.2h.2c.1.1.1-.1.2,0h.1l-.2-.2h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1.1-.1h.1c.2.1.3-.2.5-.1s.1.2,0,.3h.2s0,.1,0,.1h.2l-.5.3s-.1.1-.1.1h.2c.1,0,0,.1.1.1h-.6l-.2.2c.1.1.2-.1.3,0a.1.1,0,0,1,0,.1c-.1,0-.2.1-.2.2s.1.1,0,.1h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.8,516.1c.1,0,0,0,0,.1S411.8,516.1,411.8,516.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409.7,515.5h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.8,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,515.3c-.1-.1,0-.3,0-.4s.1-.2.2-.2h-.1s-.1,0,0,.1H407c.1,0,0,0,0,.1h0a.3.3,0,0,0,0,.3h.1c.1,0,0-.1.1-.1s0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2.1-.2s-.1.1,0,.1a.5.5,0,0,1-.2.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "409.8 515.5 409.8 515.5 409.8 515.4 409.8 515.4 409.8 515.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.1,515.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,515.1h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.2 515.1 407.2 515.1 407.2 515.1 407.2 515.1 407.2 515.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.1 515 407 515.1 407 515 407.1 515"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.3 515 406.2 515 406.2 515 406.3 515"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,515h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,515.1a.3.3,0,0,1,.2-.2.3.3,0,0,1,.1.2H409Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,514.9c0-.2.1-.2.2-.3h.1v.2a.1.1,0,0,1-.1.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.1,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.7,514.9h0c0-.1.1-.2,0-.2h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "407.3 514.9 407.3 514.9 407.3 514.9 407.3 514.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.3 514.8 406.3 514.8 406.3 514.8 406.3 514.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.7,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,514.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M409.2,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.6,514.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407.8,514.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 514.8 407.6 514.8 407.6 514.8 407.6 514.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.5 514.9 408.5 514.9 408.4 514.9 408.5 514.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 514.8 407.6 514.8 407.6 514.8 407.6 514.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "408.4 514.8 408.4 514.9 408.4 514.9 408.4 514.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.3,514.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.2,514.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,514.2c0-.1,0-.1,0-.2h.4c0,.1,0,.2-.1.2S411.7,514.4,411.6,514.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M409,514c0-.1,0-.1.1-.2h.2v.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "403.6",
      "y": "509",
      "width": "4",
      "height": "7.84",
      "transform": "translate(-43.2 37.4) rotate(-5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.9,516.4s0,.2-.1.2-.3.1-.4.2H407s.1-.1,0-.1h-.3c0-.1.2-.1.2-.2h-.2s0,.1,0,.1h-.1a.4.4,0,0,1,0-.2h-.8s0,0,0,0h.4s0,0,0-.1h.1c0-.2-.2-.2-.2-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.4c0-.1-.1-.2,0-.2s0,.1,0,.2h.3c.1-.1-.1-.1,0-.2l.5.4A.6.6,0,0,1,407.9,516.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.6 516.4 407.6 516.4 407.6 516.4 407.6 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.2,514H407a.2.2,0,0,1,0-.2h.1A.1.1,0,0,1,407.2,514Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.4 516.4 407.4 516.4 407.4 516.4 407.4 516.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.4 516.5 407.4 516.5 407.4 516.5 407.4 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.3 516.5 407.3 516.5 407.3 516.5 407.3 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.3 516.5 407.3 516.5 407.3 516.5 407.3 516.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 516.6 407.2 516.6 407.2 516.6 407.2 516.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 516.4 407.2 516.4 407.2 516.4 407.2 516.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,514.5a.9.9,0,0,1,0,.3H407c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407.2 516.6 407.2 516.6 407.2 516.6 407.2 516.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,514.6h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,514.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,514.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M407,516.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "407 515.5 407 515.5 406.9 515.5 406.9 515.5 407 515.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.9,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,509.7h-.2c0-.1-.1-.1-.1-.1h-.2c.1-.1,0-.1,0-.2s-.1-.1-.1-.2.4.1.5.3.2.2.2.3S405.9,509.7,405.9,509.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.4,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,510.4l-.3.4h-.1s0-.1,0-.1l.3-.4h.1C406,510.3,405.9,510.4,405.9,510.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.4,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,512.6h-.4c0-.1-.1-.1,0-.2h-.1c0,.1-.2.1-.1.2h-.4s0-.1,0-.1h-.3s0,0,0-.1h-.1c.1-.2-.2-.2-.2-.4h.3c.1,0,0-.1,0-.2h.1c-.1-.1,0-.1,0-.2l.4.4h.1v-.2h.1c0,.1-.1.1,0,.2v.2c0,.1.1.2.1.3l.2.2c.1-.1-.1-.1,0-.3h.1s.1.2.2.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.4,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,513.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,513.1h0S405.2,513,405.2,513.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.3,515.7H405c0-.1-.2-.1-.2-.2h.3s0,0,0,0h.2s0,.1,0,.1h.1C405.4,515.6,405.3,515.6,405.3,515.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "405.1 513.1 405.1 513.1 405.1 513.1 405.1 513.1 405.1 513.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.3,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.2,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.2,515.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 515.6 405.1 515.6 405.1 515.6 405.1 515.6 405.1 515.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.1,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.1,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.1 515.7 405.1 515.7 405.1 515.7 405.1 515.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.2 516.5 405.2 516.5 405.2 516.5 405.2 516.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.1,515.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.9,513.9h.1C404.9,513.8,404.9,513.9,404.9,513.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.9,515.3c-.1,0-.2-.1-.3-.2s0,0,0-.1h.3c.1.1,0,.1.1.2A.1.1,0,0,1,404.9,515.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405,515.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405,515.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515.1h-.1s0,0,0,0h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.9 515.5 404.9 515.5 404.9 515.5 404.9 515.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405 516.5 405 516.5 405 516.5 405 516.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.8,515.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.8,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.7,513.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.9,515.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.8,515h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.8 515.2 404.9 515.2 404.9 515.2 404.8 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.8 514.4 404.8 514.4 404.8 514.4 404.8 514.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.8 515.2 404.8 515.2 404.8 515.2 404.8 515.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.7 514.5 404.8 514.5 404.8 514.5 404.7 514.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.8,515.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,516.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,511.6h-.2c-.1-.1-.2-.1-.1-.2h.3C403.8,511.3,403.8,511.5,403.7,511.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.9,514h-.2a.2.2,0,0,1-.1-.2h.2A.1.1,0,0,1,403.9,514Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "404.1",
      "y": "501.6",
      "width": "4.3",
      "height": "8.33",
      "transform": "translate(-171.3 210.4) rotate(-24.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.7,503.1c0-.1,0-.2.1-.2s.2-.2.4-.3h.2s-.1.1,0,.1.2-.1.3-.1-.2.1-.1.2h1.1c0,.1-.2,0-.2.2h.3c-.1.1-.3.1-.4.2h0c0,.2.2.1.3.3h-.4l.2.2-.3-.2-.3.3c0,.1.1.1,0,.2s0-.1-.1-.2h-.4c-.1.1.1.1.1.2l-.7-.3C402.9,503.5,402.7,503.3,402.7,503.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.9 503 402.9 503 402.9 503 402.9 503"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,505.2h.2a.2.2,0,0,1,0,.2h-.1A.2.2,0,0,1,404.2,505.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.2 503 403.1 503 403.2 503 403.2 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.1 502.8 403.1 502.8 403.1 502.8 403.1 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.2 502.8 403.2 502.8 403.2 502.8 403.2 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.8 403.3 502.8 403.3 502.8 403.3 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.7 403.3 502.7 403.3 502.7 403.3 502.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.4 502.8 403.4 502.9 403.4 502.9 403.4 502.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,504.7v-.3h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.6 403.3 502.6 403.3 502.6 403.3 502.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.2,504.6h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.2,504.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.2,504.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.8,503.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.5,502.7a0,0,0,0,1,0,0S403.5,502.7,403.5,502.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.9 503.7 403.9 503.7 404 503.7 404 503.7 403.9 503.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,509.1h.6c0,.1,0,.1.1.2h.2c-.2-.2-.4,0-.6-.1s-.3-.1-.3-.2S407,509.2,407,509.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.6,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.5,503.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.6,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.8,508.4a1.4,1.4,0,0,1,.1-.5h.1s0,.1,0,.1a3.2,3.2,0,0,0-.1.5s0,.1-.1.1S406.7,508.4,406.8,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.3,506.1h.4c0,.1.1.1.1.2h.1c0-.1.1-.2.1-.3h.1c.1,0,0-.1.1-.1h.2c.1,0,0-.1,0-.1h.4s0,.1,0,.1h.1c0,.2.3.2.3.4l-.2.2c-.1.1,0,.1,0,.2h-.1c.1,0,0,.1.1.2l-.5-.3h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.2s.1-.1.1-.2l-.2-.2h-.3c-.1.1.1.1.1.2h-.1c-.1,0-.1-.2-.2-.1h-.1a.3.3,0,0,1-.3-.3A.5.5,0,0,1,406.3,506.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407,507.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,505.4h0A.1.1,0,0,1,406.6,505.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.6,505.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.5,502.9c.1-.1.2-.1.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C405.5,503.1,405.5,503,405.5,502.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.6 505.5 406.6 505.5 406.7 505.5 406.7 505.5 406.6 505.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.6,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,502.9h0S405.6,502.9,405.6,502.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.7,503.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.6,502.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.7,502.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.7 503 405.7 503 405.8 503 405.8 503 405.7 503"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.8,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M405.8,503h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.7 502.8 405.7 502.8 405.7 502.8 405.7 502.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.4 502.1 405.4 502.1 405.4 502.1 405.4 502.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.8,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.6,504.6h.3l-.2.2h-.1C406.6,504.7,406.5,504.6,406.6,504.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406.1,503.2h.4s0,.1,0,.1v.2h-.2c-.1,0,0-.2-.1-.2A.1.1,0,0,1,406.1,503.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,502.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.8,502.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,503.4h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406 503 406 503 406 503 406 503"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "405.6 502 405.5 502 405.6 502 405.6 502"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.8,504.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.1,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M406.2,503.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.2 503.2 406.1 503.2 406.1 503.2 406.2 503.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.5 504 406.5 504 406.5 504 406.5 504"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "406.2 503.2 406.2 503.2 406.2 503.2 406.2 503.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "406.5 504 406.5 504 406.5 504 406.5 504"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M406,502.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M405.9,501.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M408.6,506.5h.2c.1,0,.2.1.2.2h-.3C408.6,506.8,408.5,506.6,408.6,506.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M407.5,504.1h.1A.1.1,0,0,1,407.5,504.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "399.6",
      "y": "501.1",
      "width": "6.5",
      "height": "3.31",
      "transform": "translate(-195.5 741.5) rotate(-73)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.2,499.4h.7s-.1,0,0,.1h.2s0-.1,0-.1h.2v.2h.2s0,0,0,0h-.3s0,0,0,.1h-.1c-.1.1.1.2.1.3l-.2-.2c.1.1,0,.2,0,.2v-.3h-.3s0,.1-.1.1.1-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.1l-.3-.5C402.1,499.7,402.1,499.5,402.2,499.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.4 499.5 402.4 499.4 402.4 499.4 402.4 499.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402,501.4h-.1A.1.1,0,0,1,402,501.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.5 499.6 402.5 499.5 402.5 499.6 402.5 499.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.6 499.4 402.6 499.4 402.6 499.4 402.6 499.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.6 499.5 402.6 499.5 402.7 499.5 402.6 499.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.7 499.5 402.7 499.5 402.7 499.5 402.7 499.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 499.5 402.7 499.5 402.7 499.5 402.8 499.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.7 499.6 402.7 499.6 402.7 499.6 402.7 499.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.3,501.1v-.2h0v.2S402.2,501.1,402.3,501.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.8 499.4 402.8 499.4 402.8 499.4 402.8 499.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.3,501h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.3,501.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.3,501h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.6,500.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.9,499.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "402.6 500.4 402.6 500.4 402.6 500.4 402.6 500.4 402.6 500.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M402.7,500.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.6,505.1h.2c0,.1,0,.1,0,.1l.2.2h-.1c-.1,0,0,.1-.1.2s.1.1,0,.2-.3-.2-.3-.3-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,500.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.9,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403,500.5s0,0,0,0S403,500.5,403,500.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.9,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.9,504.6l.4-.2h0l-.3.2h-.1C401.7,504.6,401.8,504.6,401.9,504.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.7,503h.2v.2c-.1,0,0,.1,0,.1s0,.1,0,.1h.7c-.1.1.1.2,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.4h-.1c0-.1,0-.2,0-.2v-.2c-.1,0,0,.1,0,.2h-.1c0-.1,0-.2-.1-.1h-.1a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M402.4,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.3,502.7h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.2,502.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.9,500.7h.3c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0H404s0,.1,0,.1h.1l-.3-.2C403.8,500.8,403.9,500.8,403.9,500.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "403.3 502.8 403.3 502.8 403.3 502.8 403.3 502.8 403.3 502.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.9,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,500.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404 500.9 404 500.9 404.1 500.9 404.1 500.9 404 500.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404,501h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.1 500.8 404.1 500.8 404.1 500.8 404.1 500.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.3 500.2 404.3 500.2 404.3 500.2 404.3 500.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.7,502.3a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,501.1c.1,0,.1.1.2.2H404c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.1,500.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,500.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.3s0,0,0,0h.1s0,0,0,0H404s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.4s0,0,0,0S404.1,501.4,404.1,501.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.2 501 404.2 501 404.2 501 404.2 501"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404.4 500.2 404.4 500.2 404.4 500.2 404.4 500.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M403.8,502.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M404.1,501.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.2 501.2 404.1 501.2 404.1 501.2 404.2 501.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404 501.9 403.9 501.9 404 501.9 404 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "404.2 501.3 404.1 501.3 404.2 501.2 404.2 501.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "404 501.9 404 501.8 404 501.8 404 501.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.2,501h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.7,500.3h0S404.7,500.3,404.7,500.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M403.9,504.4h.1c0,.1.1.2,0,.2h-.2C403.8,504.5,403.8,504.4,403.9,504.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M404.5,502.5h.1a.1.1,0,0,1,0,.1h-.2A.1.1,0,0,1,404.5,502.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "392.2",
      "y": "506.4",
      "width": "7.9",
      "height": "4.05",
      "transform": "translate(-192.3 771.5) rotate(-76.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,512.5H397c-.2.1-.3,0-.5,0h-.2s.1,0,0-.1h-.1l-.2-.2s0,.1,0,.1h0l-.2-.2h-.1l-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0-.1,0-.1h.1c.1-.1-.1-.3-.1-.4l.3.3c-.1-.1,0-.2-.1-.3l.2.3h.4c0-.1,0-.2.1-.2s-.1.1,0,.2h.1s0,.1.1.1h.1c.1,0,0-.1,0-.2s.3.4.3.6A.6.6,0,0,1,397.3,512.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "397 512.5 397 512.5 397 512.5 397 512.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.4,510h-.1v-.2h.1A.1.1,0,0,1,397.4,510Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.8 512.4 396.8 512.4 396.8 512.4 396.8 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.8 512.5 396.8 512.5 396.8 512.5 396.8 512.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.7 512.4 396.7 512.4 396.7 512.4 396.7 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 512.4 396.7 512.4 396.7 512.4 396.6 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 512.5 396.6 512.5 396.6 512.5 396.6 512.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.6 512.3 396.6 512.3 396.6 512.3 396.6 512.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.1,510.4v.3h0c.1-.1,0-.2.1-.3S397.1,510.4,397.1,510.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.5 512.5 396.6 512.5 396.6 512.5 396.5 512.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,510.5h0s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.7,511.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.4,512.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.7 511.3 396.7 511.3 396.7 511.3 396.7 511.3 396.7 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,511.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.6,505.5h-.2c0-.1-.1-.1,0-.2l-.3-.2h.2c.1,0,.1-.1.1-.2s-.1-.1,0-.2.3.2.4.4.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.1,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.3,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.2,511.2h0S396.2,511.2,396.2,511.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,506.2l-.4.3h0l.4-.3h.1C397.5,506.1,397.3,506.2,397.3,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.2,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.4,508.2h-.2v-.2c.1-.1-.1-.1.1-.2s0-.1-.1-.1l-.2.2h-.7s0,0,0-.1h0c.1-.2-.1-.3,0-.5h.3c.1,0,.1-.1.1-.2h.1c0-.1.1-.1,0-.2s.2.3.2.5h.4c0,.1-.1.1-.1.2H396c0,.1,0,.2,0,.3v.2c.1,0,0-.2,0-.3h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.6,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.7,508.5h-.1s0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.7,508.4h0S395.8,508.4,395.7,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,511h-.4c0-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2a.4.4,0,0,1,.3.2C395.1,510.9,395.1,511,395.1,511Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.7 508.4 395.7 508.4 395.7 508.4 395.7 508.4 395.7 508.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,511h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,511s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.9 510.8 394.9 510.9 394.9 510.8 394.9 510.8 394.9 510.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,510.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.8 511 394.9 511 394.8 511 394.8 511"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.6 511.7 394.7 511.7 394.7 511.7 394.6 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,509.1a.3.3,0,0,1-.2-.2h.3C395.3,509.1,395.3,509.1,395.2,509.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,510.5c-.1,0-.2-.2-.2-.2h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,510.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,510.3s0,0,0,0h-.2s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.2h0S394.8,510.2,394.8,510.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.7 510.7 394.7 510.7 394.7 510.7 394.7 510.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 511.7 394.5 511.7 394.5 511.7 394.5 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,508.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,510.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "394.7 510.4 394.8 510.4 394.8 510.4 394.7 510.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.9 509.6 395 509.6 394.9 509.6 394.9 509.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "394.7 510.4 394.7 510.4 394.7 510.4 394.7 510.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.9 509.6 394.9 509.7 394.9 509.7 394.9 509.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.6,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,511.6h0S394.2,511.6,394.1,511.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,506.6h-.2c0-.1-.1-.2,0-.3h.3C395,506.4,395,506.5,394.9,506.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.2,508.9h-.1a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,394.2,508.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "389.2",
      "y": "504.9",
      "width": "7",
      "height": "3.58",
      "transform": "translate(-248.2 520.2) rotate(-53.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.2,510.3h-.7c0-.1-.2-.1-.2-.2h.2v-.2h0v-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0,0,0-.1h-.1l.3.2h.1c.1-.1,0-.2.1-.4a1,1,0,0,0,.1.3c0-.1,0-.2,0-.2a.8.8,0,0,1,0,.3h.4s0,.1,0,.1h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.1.4.1.6S392.3,510.3,392.2,510.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 510.3 392 510.3 392 510.3 392 510.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.1,508.4h.1C393.3,508.3,393.2,508.4,393.1,508.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 510.1 391.9 510.1 391.9 510.1 391.9 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 510.2 391.8 510.2 391.8 510.2 391.8 510.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 510.1 391.8 510.1 391.7 510.1 391.8 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.7 510.1 391.7 510.1 391.7 510.1 391.7 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.6 510.1 391.7 510.1 391.6 510.1 391.6 510.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.7 510 391.7 510 391.7 510 391.7 510"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.8,508.6l-.2.2h0l.2-.2S392.8,508.6,392.8,508.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.6 510.1 391.6 510.1 391.6 510.1 391.6 510.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.6,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.1,509.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.5,510h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.1 509.2 392.1 509.2 392.1 509.2 392.1 509.2 392.1 509.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,504.8h-.2c.1,0,0-.1,0-.2l-.2-.3h.1c.1,0,.1-.1.1-.1s0-.1,0-.2.2.3.2.5,0,.2-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.4,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.9,506.5h-.2a.3.3,0,0,1,0-.2c.1,0,0-.1.1-.1s0-.1,0-.1h-.6c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.4v-.2c0,.1.1.3,0,.5h.1v.2a.7.7,0,0,0,0,.2c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,506.6h-.1a.1.1,0,0,1,0-.1h.1s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.3,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,508.4l-.3-.2c.1-.1,0-.2,0-.3h.3s0-.1,0-.1h0v-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.3 506.5 392.3 506.5 392.3 506.5 392.3 506.5 392.3 506.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.2s0,0,0,0S390.9,508.2,390.9,508.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,508.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,508.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.9 508.2 390.8 508.2 390.8 508.2 390.8 508.2 390.9 508.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,508.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.7 508.3 390.8 508.3 390.7 508.3 390.7 508.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.3 508.8 390.3 508.8 390.3 508.8 390.3 508.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,508.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,506.9a.2.2,0,0,1-.1-.2h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,507.9c-.1-.1-.1-.2-.1-.3h.3c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,508.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,508.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.8h-.1s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.8 508 390.8 508 390.7 508 390.8 508"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.2 508.7 390.2 508.7 390.2 508.7 390.2 508.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,507.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391,507.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.8 507.8 390.9 507.8 390.9 507.8 390.8 507.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.3 507.2 391.3 507.2 391.3 507.2 391.3 507.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.9 507.8 390.9 507.8 390.9 507.8 390.9 507.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.2 507.2 391.3 507.3 391.2 507.2 391.2 507.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,508h0S390.7,508,390.7,508Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390,508.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,504.7h-.1c0-.1,0-.2.1-.2h.2C392.5,504.6,392.4,504.7,392.3,504.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391,506.4h.1C391.1,506.4,391,506.4,391,506.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "384.3",
      "y": "503.6",
      "width": "7",
      "height": "3.57",
      "transform": "translate(-245.1 577.4) rotate(-59)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388,501.7h.8v.2h0v.2h.1c.1.1,0,.2.1.2h-.3c-.1.1,0,.2,0,.4V503c0,.1,0,.2,0,.2a.9.9,0,0,1,0-.3h-.3c-.1,0,0,.1-.1.1v-.2s0-.1,0-.1h0s0-.1,0-.1H388c-.1,0,0,.1-.1.1s-.1-.4-.1-.6S387.8,501.8,388,501.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 501.8 388.1 501.8 388.2 501.8 388.2 501.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,503.8h-.1A.1.1,0,0,1,387.2,503.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 501.9 388.3 501.9 388.3 501.9 388.3 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.4 501.8 388.3 501.8 388.3 501.8 388.4 501.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.4 501.9 388.4 501.9 388.4 501.9 388.4 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 501.9 388.4 501.9 388.5 501.9 388.5 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 501.9 388.5 501.9 388.5 501.9 388.5 501.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 502 388.4 502 388.4 502 388.5 502"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,503.5v-.2h0l-.2.2S387.5,503.5,387.6,503.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.6 501.9 388.6 501.9 388.6 501.9 388.6 501.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,503.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.2,502.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,502h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 502.8 388.1 502.8 388.2 502.8 388.1 502.8 388.1 502.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.3,502.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.9,507.5h.2c-.1.1,0,.1,0,.2l.2.3h-.1c-.1,0-.1.1-.1.2s0,.1,0,.2-.2-.3-.2-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,503h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,503.1s0,0,0,0S388.5,503.1,388.6,503.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,507l.4-.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,503.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,505.6h.2a.3.3,0,0,1,0,.2c-.1,0,0,.1-.1.1s0,.1,0,.1h.6c.1,0,0,.1.1.1h-.1c-.2.1,0,.3-.1.4h-.4c0,.1-.1.1-.1.2s-.1-.3-.1-.5h-.1v-.2a.7.7,0,0,0,0-.2c-.1,0,0,.2-.1.2h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.2,505.5h.1a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.2,505.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,503.5l.3.2c-.1.1.1.2,0,.3h-.1s0-.1,0-.1h-.2s0,0,0,.1h.1l.2.2h-.1a.4.4,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 505.5 388.2 505.5 388.2 505.5 388.2 505.5 388.2 505.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,503.7s0,0,0,0S389.4,503.7,389.4,503.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,503.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.5 503.7 389.5 503.7 389.5 503.7 389.5 503.7 389.5 503.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,503.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.6 503.6 389.6 503.6 389.6 503.6 389.6 503.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390 503.1 389.9 503 390 503 390 503.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,503.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.8,505.1a.2.2,0,0,1,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,504c.1.1.1.2.1.3h-.3c0-.1.1-.1.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,503.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,503.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.2h.1s0,0,0,0h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.6 503.9 389.6 503.9 389.6 503.9 389.6 503.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.1 503.1 390.1 503.1 390.1 503.1 390.1 503.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,504.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.8,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.5,504.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,504.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.5 504.1 389.5 504.1 389.5 504.1 389.5 504.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.2 504.8 389.2 504.7 389.2 504.7 389.2 504.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.5 504.1 389.5 504.1 389.5 504.1 389.5 504.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.2 504.7 389.2 504.7 389.2 504.7 389.2 504.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,503.9h0S389.7,503.9,389.7,503.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.4,503.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.4,507.3h.1c0,.1,0,.2-.1.2h-.2C388.3,507.5,388.3,507.3,388.4,507.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,505.5h.1a.1.1,0,0,1,0,.1h-.2C389.4,505.6,389.5,505.5,389.6,505.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "381.3",
      "y": "503.4",
      "width": "3.7",
      "height": "7.19",
      "transform": "translate(-242.9 615.9) rotate(-62.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,507.1c0-.1-.1-.1-.1-.2s0-.3.1-.4h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2,0,.2h.4s0-.1,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.2.2-.1.4h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.8.8,0,0,0-.1.3h-.2l-.6.2C379.7,507.2,379.5,507.2,379.4,507.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 506.9 379.4 506.9 379.4 506.9 379.4 506.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,507.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 506.7 379.6 506.7 379.6 506.7 379.6 506.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.5 506.7 379.5 506.7 379.5 506.7 379.5 506.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 506.6 379.5 506.6 379.6 506.6 379.6 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 506.6 379.6 506.6 379.6 506.6 379.6 506.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.5 506.5 379.5 506.5 379.5 506.5 379.5 506.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.7 506.5 379.7 506.6 379.7 506.6 379.7 506.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,507.4h-.2l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.5 506.4 379.5 506.5 379.5 506.5 379.5 506.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,507.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,507.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,507.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,506.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,506.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.5 506.8 380.5 506.8 380.5 506.8 380.5 506.8 380.5 506.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.5,506.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,508.8c0-.1,0-.1.1-.2h.2l.3-.2s-.1.1,0,.1h.4c-.2,0-.2.2-.4.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,506.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.7,506.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.9,508.4a1.2,1.2,0,0,1-.2-.4h.1l.2.4s.1.1,0,.1S384.9,508.5,384.9,508.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,506.5h0S381.1,506.5,381.1,506.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,507.2V507h.2c0,.1.1,0,.1.1h.1c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.3v.2c0,.1,0,.1,0,.1h-.1v-.2h-.5c0,.1.2,0,.2.1h-.2s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.7,507.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.2,506.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,506.6s0,0,0,0h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,505.4c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0c0,.1.1.1,0,.1h.2l.2-.2s-.1.1,0,.1a.4.4,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.3 506.6 383.3 506.6 383.3 506.5 383.3 506.6 383.3 506.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,505.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,505.4h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,505.3h0S381.2,505.3,381.2,505.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.3 505.4 381.3 505.4 381.3 505.3 381.3 505.3 381.3 505.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,505.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 505.3 381.2 505.3 381.2 505.3 381.2 505.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.6 504.9 380.6 505 380.6 504.9 380.6 504.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.8,506h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.6,505.3l.3-.2h.1a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,381.6,505.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,505.4h0s.1-.1.1-.1h.1s0,0,0,0h-.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,505.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.5 505.2 381.5 505.2 381.5 505.2 381.5 505.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 504.8 380.7 504.8 380.7 504.8 380.7 504.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,505.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383,505.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,505.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,505.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.7 505.3 381.7 505.3 381.7 505.3 381.7 505.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 505.6 382.4 505.6 382.4 505.6 382.4 505.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.8 505.3 381.8 505.3 381.7 505.3 381.8 505.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 505.6 382.4 505.6 382.4 505.6 382.4 505.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,505.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,504.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.1,506.2h.2C385.3,506.4,385.1,506.3,385.1,506.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.2,505.2h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.2",
      "y": "507.5",
      "width": "7.5",
      "height": "3.82",
      "transform": "translate(-142.6 147) rotate(-18.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,512.3h-.2c-.2-.1-.2-.2-.3-.4s0-.1,0-.1h0c.1-.1-.1-.2-.1-.3h.2a.4.4,0,0,0,0-.2h.1a.3.3,0,0,0,0-.2h0c0-.1.1-.1.1-.2v-.2h.1c.1,0,0,.1.1.2h0v-.2h0c.1.1.1.3.2.3h.1c.1,0,.2-.2.3-.3a1,1,0,0,0-.1.4l.2-.2-.2.3.2.3h0s-.1.1,0,.1h.2c-.1.2-.1.4-.3.6S375.5,512.3,375.3,512.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.2 512.1 375.2 512.1 375.2 512.1 375.2 512.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,511.1a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.2 511.9 375.2 511.9 375.2 511.9 375.2 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.1 511.9 375.1 511.9 375.1 511.9 375.1 511.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.1 511.8 375.1 511.8 375.1 511.8 375.1 511.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375 511.8 375.1 511.8 375 511.8 375 511.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375 511.7 375 511.8 375 511.8 375 511.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.1 511.7 375.1 511.7 375.1 511.7 375.1 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,511.1h-.3s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.9 511.7 374.9 511.7 374.9 511.7 374.9 511.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.8,511.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M376.7,511.1s0,0,0,0S376.7,511.1,376.7,511.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,511.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375,511.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.9 511.3 375.9 511.3 375.9 511.2 375.9 511.2 375.9 511.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,511.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,509c-.1,0-.1-.1-.1-.2h.1a1.2,1.2,0,0,0,0-.4h.4c-.2.1,0,.4-.1.5s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.7s0-.1,0-.1S376.1,510.7,376.1,510.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,510.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.3,509.1l-.5-.2s-.1-.1,0-.1h.1l.4.2h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,510.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,509.4c-.1-.1,0-.2-.1-.2V509c.1,0,.1-.1.2,0s.1-.1.1-.1h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s0-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2,0,.2-.2.4-.2s.1.1.1.2h.4c-.1.1-.1.3-.3.4s-.1.1,0,.1h-.3v.2c.1.1.1-.1.2-.1h0c0,.1-.1.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,508.8c.1,0,0,0,0,.1S379.6,508.8,379.6,508.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,509.1a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.8,509h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.8c-.1-.1-.1-.2-.1-.3s.1-.2.1-.2,0,.1,0,.1h0s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2s0,0,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c0-.1-.1-.2,0-.2s0,.1.1.1a.4.4,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.8 509 377.7 509 377.7 509 377.7 509 377.8 509"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.4,509.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,509.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.7h0S375.4,509.7,375.4,509.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,509.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 509.6 375.4 509.6 375.4 509.6 375.4 509.6 375.4 509.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.5,509.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.3 509.6 375.3 509.6 375.3 509.6 375.3 509.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.6 509.8 374.6 509.8 374.6 509.8 374.6 509.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,509a.2.2,0,0,1,.1-.3v.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.6,509.3c-.1-.1,0-.2.1-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.3,509.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,509.3h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,509.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.5 509.4 375.5 509.4 375.5 509.4 375.5 509.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.6 509.7 374.6 509.7 374.6 509.7 374.6 509.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,509.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,508.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,509.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.9,509.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 509.2 375.7 509.2 375.7 509.3 375.7 509.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.4 509 376.4 509 376.4 509 376.4 509"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 509.2 375.7 509.2 375.7 509.2 375.7 509.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "376.4 509 376.4 509 376.4 509 376.4 509"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,509.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,509.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,507.4s0-.1,0-.2l.2-.2h.1c0,.1.1.1,0,.2S378.9,507.5,378.8,507.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.6,508.1c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379.9",
      "y": "513.4",
      "width": "3.1",
      "height": "6.14",
      "transform": "translate(-216.7 749.7) rotate(-74.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.6,515.7s.1.1.1.2,0,.2,0,.4,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.2s0-.1-.1-.2h-.3s0,0,0,.1H384c0,.1,0,.1,0,.2h-.1c0-.1,0-.1,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.2,0-.3h-.4l.2-.2h0a.7.7,0,0,0,0-.3h.1l.5-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 515.9 384.6 515.9 384.6 515.9 384.6 515.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.7,515.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.5 516 384.5 516 384.5 516 384.5 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516 384.6 516 384.6 516 384.6 516"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.1 384.6 516.1 384.6 516.1 384.6 516.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.2 384.6 516.1 384.6 516.1 384.6 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.2 384.6 516.2 384.6 516.2 384.6 516.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.5 516.2 384.5 516.2 384.5 516.2 384.5 516.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383,515.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "384.6 516.2 384.6 516.2 384.6 516.2 384.6 516.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.1,515.8h0S383.1,515.8,383.1,515.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.1,515.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.2,515.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.8,516.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M384.5,516.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.7 516.1 383.7 516.1 383.7 516.1 383.7 516.1 383.7 516.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.8,516.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,515.3c0,.1,0,.1,0,.2H379l-.2.2s0-.1,0-.1h-.3c.2,0,.2-.2.3-.3h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.7,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.6,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,515.5l.2.3h-.1l-.2-.3s-.1-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,516.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,516.3v.2h-.4v.2h-.1a.1.1,0,0,0,0,.1h-.3c-.1-.1-.2.1-.4,0s0-.1,0-.2h-.1s0-.1,0-.1h-.2l.4-.2h0s0-.1,0-.1h.4a0,0,0,0,1,0-.1h.1s0-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,516.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,516.8h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.5,516.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.5,517.4c.1.1,0,.2-.1.3h0s0,0,0-.1h0a.2.2,0,0,0,0-.2h-.2v.2s.1-.1,0-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.5 516.8 381.5 516.8 381.5 516.8 381.4 516.8 381.5 516.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.4,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,517.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "383.3",
      "y": "517.5",
      "transform": "matrix(0.28, -0.96, 0.96, 0.28, -221.61, 738.34)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.2,517.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "383.4 517.5 383.4 517.5 383.4 517.5 383.4 517.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384 517.7 384 517.7 384 517.7 384 517.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,517.2h-.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.1,517.6l-.2.2h-.1a.2.2,0,0,0-.1-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.5h0s-.1.1,0,.1h0s0,0,0,0h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,517.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "383.2 517.6 383.2 517.6 383.2 517.6 383.2 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "383.9 517.8 383.9 517.8 383.9 517.8 383.9 517.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.9,517.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,517.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383,517.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,517.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 517.6 383 517.6 383 517.6 383 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.3 517.4 382.4 517.4 382.4 517.4 382.3 517.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 517.6 383 517.6 383 517.6 382.9 517.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 517.5 382.4 517.4 382.4 517.4 382.4 517.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.2,517.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.9,518.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,517.4h-.2C379.8,517.3,380,517.3,380,517.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,518h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "378.7",
      "y": "517.4",
      "width": "3.3",
      "height": "6.48",
      "transform": "translate(-264.2 536.4) rotate(-55.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.7,521s.1.1,0,.2-.1.2-.1.4h-.2c-.1,0-.1.2-.1.2s.1-.1,0-.2h-.8c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h0v-.3s-.1,0-.1-.1h.3s0,0,0,0h.6C383.5,520.8,383.7,520.9,383.7,521Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.6 521.2 383.7 521.2 383.7 521.2 383.6 521.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,520.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.3 383.5 521.3 383.5 521.3 383.5 521.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.6 521.4 383.6 521.4 383.6 521.4 383.6 521.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.4 383.5 521.4 383.5 521.4 383.5 521.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.5 383.5 521.4 383.5 521.5 383.5 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.5 383.5 521.5 383.5 521.5 383.5 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.4 521.5 383.4 521.4 383.4 521.4 383.4 521.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,520.5h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.5 521.6 383.5 521.6 383.5 521.6 383.5 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.1,520.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.1,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,520.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.4,521.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.7 521.1 382.7 521.1 382.7 521.1 382.7 521.1 382.7 521.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.7,521.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,518.7v.2h-.7c.2,0,.3-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.2,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.4,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.2,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,519.1a1.1,1.1,0,0,1,.1.4h-.1v-.4s0-.1,0-.1S378.9,519.1,378.9,519.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,521.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,521.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,521.3h0S382.1,521.3,382.1,521.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,520.4h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1s.1.1,0,.1h-.4s0,0,0-.1-.3,0-.4-.1,0-.2.1-.2h.4v-.2c0-.1,0-.1,0-.1h.1s0,.1,0,.2h.4s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,519.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,521h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.2,521h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,522.3c0,.1-.1.2-.2.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.4s.1,0,.1-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 521 380.2 521 380.2 521 380.2 521 380.2 521"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.9,522.4h0S381.9,522.4,381.9,522.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "381.8",
      "y": "522.3",
      "transform": "translate(-261.9 588) rotate(-59.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,522.3s0,0,0,0S381.7,522.3,381.7,522.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.8 522.4 381.9 522.4 381.9 522.4 381.8 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.4 522.8 382.4 522.8 382.4 522.8 382.4 522.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.6,521.6h-.2a.3.3,0,0,1,0-.2h.1S380.6,521.5,380.6,521.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.5,522.3h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,381.5,522.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.7,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.8,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,522.2h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.6 522.4 381.6 522.4 381.6 522.4 381.6 522.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382.3 522.9 382.3 522.9 382.3 522.9 382.3 522.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,522.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 522.3 381.4 522.3 381.4 522.3 381.4 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.8 521.9 380.9 521.9 380.9 521.9 380.8 521.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.4 522.3 381.4 522.3 381.4 522.3 381.4 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 522 380.9 522 380.9 522 380.9 522"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.2,523.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,521.1h-.2C378.4,520.9,378.5,521,378.5,521.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,522.3h-.2s0,0,0-.1h.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "374.8",
      "y": "522.4",
      "width": "7",
      "height": "3.6",
      "transform": "translate(-229.9 743.1) rotate(-74)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,520.6h.8s-.1,0,0,.1h.1v.2s0-.1,0-.1h0l.2.2h.1v.2h.2s0,0,0,0h-.4s0,0,0,.1h-.1c-.1.1.1.2.1.4l-.2-.3c.1.1,0,.2,0,.2v-.3H378s0,.2-.1.2.1-.1,0-.2h-.1s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.1l-.3-.5A.6.6,0,0,1,377.5,520.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.7 520.6 377.7 520.6 377.7 520.6 377.7 520.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,522.7h-.1A.1.1,0,0,1,377.3,522.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.9 520.7 377.8 520.7 377.8 520.7 377.9 520.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.9 520.6 377.9 520.6 377.9 520.6 377.9 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 520.6 378 520.6 378 520.6 378 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 520.6 378 520.6 378 520.6 378 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.1 520.6 378.1 520.6 378.1 520.6 378.1 520.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 520.7 378 520.7 378 520.7 378 520.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.6,522.4v-.2h0v.2S377.5,522.4,377.6,522.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.1 520.5 378.1 520.5 378.1 520.5 378.1 520.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,522.3h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,522.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.9,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.2,520.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.9 521.6 377.9 521.6 377.9 521.6 377.9 521.6 377.9 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.9,526.8h.2c0,.1,0,.1,0,.2l.2.2h-.1c-.1,0-.1.1-.1.2s.1.1,0,.2-.3-.2-.3-.4-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,521.7s0,0,0,0S378.4,521.7,378.4,521.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.2,526.1l.4-.3h0l-.4.2h-.1C377.1,526.2,377.2,526.2,377.2,526.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.3,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,524.4h.2v.2c-.1,0,.1.1-.1.1s0,.1,0,.1h.8c-.1.2.1.3,0,.4h-.2c-.1,0-.1.1-.1.1h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.1c0-.1,0-.2,0-.2v-.2c-.1,0,0,.2,0,.2h-.1c0-.1,0-.2-.1-.2H378a.3.3,0,0,1,0-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.8,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.7,524.1h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,521.9h.3c0,.1.1.1.1.2h-.1s0-.1,0-.1h-.1s0,0,0,0h-.2s0,.1,0,.1h.2l-.3-.2C379.3,522,379.4,522,379.4,521.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 524.2 378.7 524.2 378.7 524.2 378.7 524.2 378.7 524.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,522s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.5 522.1 379.5 522.1 379.5 522.1 379.5 522.1 379.5 522.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 522 379.5 522 379.6 522 379.6 522"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.8 521.3 379.7 521.3 379.8 521.3 379.8 521.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,523.6a.2.2,0,0,1,.2.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,522.4c.1,0,.1.1.2.2h-.3c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.6,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,522.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.5s0,0,0,0h.1s0,0,0,0h-.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,522.6s0,0,0,0S379.5,522.6,379.5,522.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 522.3 379.6 522.2 379.7 522.2 379.6 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.9 521.4 379.9 521.4 379.9 521.4 379.9 521.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,523.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.6,522.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 522.5 379.6 522.5 379.6 522.5 379.6 522.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.4 523.2 379.4 523.2 379.4 523.2 379.4 523.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.6 522.5 379.6 522.5 379.6 522.5 379.6 522.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.5 523.2 379.4 523.1 379.5 523.2 379.5 523.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.7,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,521.4h0S380.2,521.4,380.2,521.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,525.9h.2c0,.1.1.2,0,.2h-.3C379.3,526.1,379.3,525.9,379.4,525.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,523.8h.1a.1.1,0,0,1,0,.2h-.2A.1.1,0,0,1,380,523.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "373.9",
      "y": "525.7",
      "width": "3.5",
      "height": "6.83",
      "transform": "translate(-257.3 672) rotate(-67.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,529.5s-.1-.1-.1-.2,0-.3,0-.4,0-.1.1-.1,0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2.1.2h.4s0,0,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.4l-.3.2h-.1a.7.7,0,0,0,0,.3H373l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.1 529.3 372.1 529.3 372.1 529.3 372.1 529.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,529.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.3 529.1 372.2 529.1 372.3 529.1 372.3 529.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.1 529.1 372.1 529.1 372.1 529.1 372.1 529.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 529 372.2 529 372.2 529 372.2 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 529 372.2 529 372.2 529 372.2 529"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 528.9 372.2 528.9 372.2 528.9 372.2 528.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.3 528.9 372.3 529 372.3 529 372.3 528.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.9,529.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.1 528.9 372.1 528.9 372.1 528.9 372.1 528.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,529.5s0,0,0,0h0S373.8,529.5,373.8,529.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,529.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.3,528.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.1 529.2 373.1 529.1 373.1 529.1 373.1 529.1 373.1 529.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.1,529h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378,530.7c0-.1,0-.1,0-.2h.1l.2-.2s-.1.1,0,.1h.3c-.2,0-.2.3-.4.3H378Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.3,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,530.3l-.2-.4h.1l.2.4s.1.1,0,.1S377.5,530.4,377.4,530.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,528.8h0S373.7,528.8,373.7,528.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.9,529.3v-.2h.4c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2s0,.1,0,.1h-.4a0,0,0,0,1,0,.1h-.2s0,.1,0,.1H376Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,529.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.7,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.7,528.7s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,527.8c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1,0,0,.1h.2v-.2s-.1.1,0,.1a.4.4,0,0,1-.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 528.7 375.7 528.7 375.7 528.7 375.8 528.7 375.7 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.7,527.7h0S373.7,527.7,373.7,527.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.8 527.7 373.8 527.7 373.8 527.7 373.8 527.7 373.8 527.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,527.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.7 527.6 373.7 527.6 373.7 527.6 373.7 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.1 527.3 373.1 527.4 373.1 527.4 373.1 527.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.8,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.2,528.2h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,527.6l.2-.2h.1a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,374.1,527.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.8,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.8,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,527.7h0s.1-.1.1-.1h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374 527.6 373.9 527.6 374 527.6 374 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.1 527.2 373.1 527.2 373.1 527.2 373.1 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.4,528.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,527.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.2 527.6 374.2 527.6 374.2 527.6 374.2 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.8 527.9 374.8 527.9 374.8 527.9 374.8 527.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.2 527.6 374.2 527.6 374.2 527.6 374.2 527.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.8 527.8 374.8 527.9 374.8 527.8 374.8 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.9,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.2,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,528.2h.2C377.6,528.4,377.5,528.3,377.5,528.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.5,527.4h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "375.9",
      "y": "530",
      "width": "3.3",
      "height": "6.4",
      "transform": "translate(-273.8 584.2) rotate(-59.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,533.3s.1.1,0,.2,0,.2-.1.4h-.1s0,.1,0,.1h-.1c-.1,0-.1.2-.1.2s0-.1,0-.2h-.4s0,0,0,.1h-.3c0-.1.1-.1,0-.2h-.2c0-.1.2-.2.1-.3h-.1a.1.1,0,0,0,0-.1h0a.7.7,0,0,0,.1-.3h.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 533.5 380.8 533.5 380.8 533.5 380.8 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,532.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.6 380.7 533.6 380.7 533.6 380.7 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 533.7 380.8 533.7 380.8 533.7 380.8 533.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.7 380.7 533.7 380.7 533.7 380.7 533.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.8 380.7 533.8 380.7 533.8 380.7 533.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.7 533.8 380.8 533.8 380.8 533.8 380.7 533.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.6 533.8 380.6 533.7 380.6 533.8 380.6 533.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,533h.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 533.9 380.8 533.9 380.8 533.9 380.8 533.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,533s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.3,533h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,533.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 533.5 379.9 533.5 379.9 533.5 379.9 533.5 379.9 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,533.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.6,531.4v.2h-.1l-.3.2h-.3c.2,0,.2-.2.4-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,533.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.7,533.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,531.8a1,1,0,0,1,.2.4h-.1v-.4s0-.1,0-.1S376,531.8,376,531.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.4,533.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.3,533.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.3,533.8h0S379.3,533.7,379.3,533.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,533h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1.1,0,.1h-.4s0-.1,0-.1-.3,0-.4-.1,0-.2.1-.2h.3c0-.1,0-.1,0-.1h.6s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.2,532.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.5,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.4,533.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.3,534.7c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0v-.2h0s-.1,0,0-.1h-.3s.1-.1,0-.1l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377.4 533.5 377.4 533.5 377.4 533.6 377.4 533.6 377.4 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,534.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.1,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,534.8h0S379.2,534.8,379.2,534.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.1 534.7 379.1 534.7 379.1 534.8 379.1 534.8 379.1 534.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,534.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.1 534.8 379.2 534.8 379.2 534.8 379.1 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.7 535.1 379.7 535.1 379.7 535.1 379.7 535.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.8,534.1h-.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,534.8h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,378.8,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,534.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.1,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,534.7h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 534.8 378.9 534.8 378.9 534.8 378.9 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.6 535.3 379.6 535.2 379.6 535.3 379.6 535.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.6,534.1h0S377.6,534.1,377.6,534.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.7,534.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.6,534.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 534.8 378.7 534.7 378.7 534.8 378.7 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.1 534.4 378.1 534.4 378.1 534.4 378.1 534.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.7 534.8 378.7 534.8 378.7 534.8 378.7 534.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.1 534.5 378.2 534.4 378.2 534.5 378.1 534.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,534.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,535.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,533.8h-.2C375.6,533.6,375.8,533.6,375.8,533.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.4,534.8h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379.6",
      "y": "533.7",
      "width": "3.1",
      "height": "6.09",
      "transform": "translate(-131.7 124) rotate(-15.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.4,539s0,.1-.1.2l-.3.2h-.2s.1-.1,0-.1h-.2c0-.1.1-.1.1-.1h-.6l-.2-.2h.3v-.2h.2l.2-.2c0-.1-.1-.1,0-.2s0,.1,0,.1h.3c.1-.1-.1-.1,0-.1l.4.3C383.3,538.7,383.4,538.8,383.4,539Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.2 539.1 383.2 539.1 383.2 539.1 383.2 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,537.3h-.1a.1.1,0,0,1,0-.1h.1A.1.1,0,0,1,382.5,537.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 539.1 383.1 539.1 383.1 539.1 383 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.1 539.2 383.1 539.2 383.1 539.2 383.1 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 539.2 383 539.2 383 539.2 383 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383 539.2 383 539.2 383 539.2 383 539.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 539.3 382.9 539.2 382.9 539.3 382.9 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 539.1 382.9 539.1 382.9 539.1 382.9 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,537.7a.6.6,0,0,1,0,.2h0c0-.1,0-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.9 539.3 382.9 539.3 382.9 539.3 382.9 539.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,537.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,537.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.6,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.8,539.2h0S382.8,539.2,382.8,539.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.6 538.4 382.6 538.4 382.6 538.4 382.6 538.4 382.6 538.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.5,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,534.2h-.4c0-.1,0-.1,0-.2h-.1c.1.1.3,0,.4.1s.2.1.2.2S380.9,534.2,380.9,534.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,538.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,534.8l-.2.4h-.1s0-.1,0-.1l.2-.3h.1C381.1,534.7,381,534.7,381,534.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.1,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,538.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,536.4h-.3c0-.1-.1-.1,0-.1h-.1c0,.1-.1.1-.1.2h-.3s0-.1,0-.1h-.3s0,0,0-.1H380c0-.2-.2-.2-.2-.3h.2c.1,0,0-.1,0-.1h.1c-.1,0,0-.1-.1-.1l.3.3h.2s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.2.2,0,0,1,.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,535.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,536.9h0A.1.1,0,0,1,380.9,536.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.8,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,538.9h-.2s0,0,0,0h.1s0,0,0,.1h.1S381.4,538.8,381.4,538.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.8 536.9 380.8 536.9 380.8 536.9 380.8 536.9 380.8 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,538.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 538.8 381.2 538.8 381.2 538.8 381.2 538.8 381.2 538.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,538.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,538.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 538.9 381.2 538.9 381.2 538.9 381.2 538.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.3 539.5 381.4 539.5 381.4 539.5 381.3 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.2,538.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,537.5h0C380.8,537.5,380.8,537.5,380.7,537.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,538.6h-.3s0,0,0-.1h.2c.1,0,0,.1.1.1A.1.1,0,0,1,381,538.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,538.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381 538.7 381 538.8 381 538.7 381 538.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381.2 539.5 381.2 539.5 381.2 539.5 381.2 539.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.6,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,538.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 538.6 380.9 538.6 380.9 538.6 380.9 538.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 537.9 380.8 537.9 380.8 538 380.7 537.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.9 538.5 380.9 538.5 380.9 538.6 380.9 538.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 538 380.8 538 380.7 538 380.7 538"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,538.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.5,535.9h-.1c-.1,0-.1-.1-.1-.2h.2C379.6,535.8,379.6,535.9,379.5,535.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,537.8h0A.1.1,0,0,1,380,537.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "375.6",
      "y": "540",
      "width": "3.2",
      "height": "6.29",
      "transform": "translate(-279.6 466.7) rotate(-48.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,543.8s.1.1,0,.2-.1.2-.1.3h-.2c-.1,0-.1.1-.2.2s.1-.1,0-.2h-.8c0-.1.1-.1.1-.2h-.2c0-.1.2-.2.2-.3h0v-.3c0-.1-.1-.1-.1-.1h.2s0,0,0,0h.6C380.3,543.7,380.4,543.7,380.4,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.4 544 380.4 544 380.4 544 380.4 544"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.1 380.2 544.1 380.2 544.1 380.2 544.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.3 544.2 380.3 544.2 380.3 544.2 380.3 544.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.2 380.2 544.2 380.2 544.2 380.2 544.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.3 380.2 544.2 380.2 544.2 380.2 544.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.3 380.2 544.3 380.2 544.3 380.2 544.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 544.2 380.1 544.2 380.1 544.2 380.1 544.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,543.2l.2.2h0l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 544.4 380.2 544.4 380.2 544.4 380.2 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.5,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.1,544.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.4 543.8 379.4 543.8 379.4 543.8 379.4 543.8 379.4 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.4,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.6,541h-.7c.2.1.3-.2.4-.1h.3S375.6,541,375.6,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.2,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376,541.5a1,1,0,0,1,.1.4H376a2.5,2.5,0,0,0-.1-.4s0-.1,0-.1S376,541.5,376,541.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.9,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.8,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,542.9h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2,0,.2h0s0,.1,0,.1h-.1s0,.1,0,.1H376s0,0,0-.1-.2,0-.3-.2v-.2h.4v-.2c0-.1,0,0,0-.1h.1s0,.1,0,.2h.4c0-.1-.1,0-.2-.1h.5A.4.4,0,0,1,377.1,542.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.1,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.1,543.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.6,544.9c0,.1-.1.2-.2.2h0c0-.1,0,0,0-.1h0v-.2h0s-.1-.1,0-.1h-.3l.3-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "377 543.4 377 543.5 377 543.5 377 543.5 377 543.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.5,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,545h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.4 544.9 378.4 544.9 378.4 544.9 378.4 544.9 378.4 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.4,544.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.5 545 378.5 545 378.5 545 378.5 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 545.4 379 545.4 379 545.4 378.9 545.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,544.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.3,544.1h-.2v-.2h.1S377.4,544,377.3,544.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,544.9h-.3a.2.2,0,0,0,0-.2h.2A.1.1,0,0,1,378.2,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.4,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.2 545 378.3 545 378.3 545 378.2 545"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "378.9 545.5 378.9 545.5 378.9 545.5 378.9 545.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.8h0S378,544.8,378,544.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M377.2,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.1,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378.1 544.9 378.1 544.8 378.1 544.9 378.1 544.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.6 544.4 377.6 544.4 377.6 544.4 377.6 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "378 544.8 378.1 544.8 378.1 544.9 378 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "377.6 544.5 377.6 544.5 377.6 544.5 377.6 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.2,545h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.7,545.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,543.4h-.3a.2.2,0,0,1,0-.1h.1C375.3,543.2,375.4,543.2,375.4,543.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M376.8,544.7h-.2s0,0,0-.1h.1C376.8,544.5,376.9,544.6,376.8,544.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "384.4",
      "y": "540.9",
      "width": "6.2",
      "height": "3.17",
      "transform": "translate(-255 364.5) rotate(-39)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,545.5h-.2l-.3-.2s0-.1,0-.1h0c0-.1-.1-.1-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.2.2,0,0,0,0-.2h0c0-.1,0-.1,0-.2h.1s0,0,0-.1h-.1l.2.2h.1c.1-.1.1-.2.1-.3a.8.8,0,0,0,0,.3v-.2a.8.8,0,0,1,0,.3l.3.2h0s0,.1,0,.1h0s-.1.1,0,.1h0c.1,0,0-.1.1-.1s0,.4-.1.5S386.4,545.5,386.3,545.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 545.4 386.1 545.4 386.1 545.4 386.1 545.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,544a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.1 545.2 386.1 545.2 386.1 545.2 386.1 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 545.3 386 545.3 386 545.3 386 545.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386 545.2 385.9 545.2 385.9 545.2 386 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.9 545.2 385.9 545.2 385.9 545.2 385.9 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.8 545.2 385.9 545.2 385.8 545.2 385.8 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.9 545.1 386 545.1 386 545.1 385.9 545.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,544.1H387s0,0,0,0h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.8 545.2 385.8 545.2 385.8 545.2 385.8 545.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.1,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,545h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.5 544.5 386.5 544.5 386.5 544.5 386.5 544.5 386.5 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,541.3h-.1c.1,0,0-.1.1-.1a1,1,0,0,0-.1-.3h.2c0-.1,0-.1.1-.2s.1.3.1.4,0,.2-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.1,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,544h0S386.4,544,386.4,544Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.3,541.6h-.4s-.1,0,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.8,542.4h-.1a.2.2,0,0,1,0-.2c.1,0,0-.1.1-.1s.1-.1,0-.1h-.2s0,0,0,0h-.1s0-.1,0-.1h-.1s0-.1,0-.1h.1c.2-.1.1-.2.2-.3h.5c-.1.1,0,.3-.1.4s0,.1,0,.1h0v.2a.6.6,0,0,0,0,.2c.1,0,.1-.1.1-.1h0c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,541.6c.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.2,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.2,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.6c-.1,0-.1-.1-.2-.2s0-.2,0-.2h.2s0-.1,0-.1h-.1s-.1,0,0-.1h0s0,0,0-.1h0c0-.1-.1-.1-.1-.2h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.2 542.2 387.2 542.2 387.2 542.2 387.2 542.2 387.2 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.6 543.4 385.6 543.4 385.6 543.3 385.6 543.3 385.6 543.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,543.3s0,0,0,0S385.6,543.3,385.6,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.6,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.5 543.4 385.5 543.4 385.5 543.4 385.5 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385 543.8 385 543.8 385 543.8 385 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.6,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.6,542.4a.2.2,0,0,1,0-.2h.2a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.7,543.1c-.1-.1,0-.2,0-.3h.3c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,543h-.1s0,0,0-.1h.1s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "385.6 543.2 385.5 543.2 385.5 543.2 385.6 543.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "384.9 543.7 384.9 543.7 384.9 543.7 384.9 543.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.6,542.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.7,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M385.8,542.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.7 543 385.7 543 385.7 543 385.7 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.2 542.6 386.2 542.6 386.2 542.6 386.2 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "385.7 543 385.7 543 385.7 543 385.7 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.1 542.6 386.2 542.6 386.1 542.6 386.1 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,543.2h0S385.5,543.2,385.5,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.7,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,540.7h-.1c0-.1,0-.2.1-.2h.2C387.8,540.6,387.7,540.7,387.6,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.1,541.8c-.1,0,0-.1,0-.1h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "385.2",
      "y": "549.3",
      "width": "3.2",
      "height": "6.25",
      "transform": "translate(-47.1 36.2) rotate(-5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,555.2H388s.1,0,0-.1h-.3s0,.1,0,.1h0a.3.3,0,0,1,0-.1h-.3c0-.1-.1-.2-.2-.3h.3v-.2l.2.2h.3s0-.1,0-.2,0,.1,0,.2h.3c.1,0,0-.1,0-.1l.4.3A.5.5,0,0,1,388.6,555.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.5 555.2 388.5 555.3 388.5 555.3 388.5 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,553.3H388a.1.1,0,0,1,0-.1h.1A.1.1,0,0,1,388.1,553.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 555.2 388.3 555.2 388.3 555.2 388.3 555.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.3 555.3 388.3 555.3 388.3 555.3 388.3 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 555.3 388.2 555.3 388.2 555.3 388.2 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.2 555.3 388.2 555.3 388.2 555.3 388.2 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 555.4 388.1 555.4 388.1 555.4 388.1 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 555.2 388.1 555.2 388.1 555.2 388.1 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388,553.7a.7.7,0,0,1,0,.2h0c0-.1,0-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.1 555.4 388.1 555.4 388.1 555.4 388.1 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,553.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388,555.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.9 554.5 387.9 554.5 387.9 554.5 387.9 554.5 387.9 554.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.8,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,549.9h-.4c.1-.1,0-.1,0-.2h-.1c.1.2.3.1.4.2s.2.1.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,550.5l-.2.3h0l.2-.3h.1C387.2,550.4,387.1,550.5,387.1,550.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.9,552.2h-.3c0-.1-.1-.1,0-.1h-.1v.2H386s0,0,0-.1h-.3s0,0,0-.1h-.1c0-.2-.1-.2-.1-.3h.2c.1,0,0-.1,0-.1h.1s0-.1,0-.2l.3.3h.3s-.1.1,0,.1h-.1c0,.1,0,.1.1.2h.1c.1-.1-.1-.1,0-.2h.3a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.7,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,552.6h0S386.5,552.6,386.5,552.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.6,554.7h-.3l-.2-.2h.2s0,0,0,0h.1s0,.1,0,.1h.1S386.6,554.6,386.6,554.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.4 552.6 386.5 552.6 386.4 552.6 386.4 552.6 386.4 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.6,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.5,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.5,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.5 554.6 386.5 554.6 386.4 554.6 386.4 554.6 386.5 554.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.4,554.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.4 554.7 386.5 554.7 386.4 554.7 386.4 554.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.5 555.3 386.5 555.3 386.5 555.3 386.5 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,554.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,553.2h0C386.3,553.1,386.3,553.2,386.3,553.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.3,554.4h-.2s0,0,0-.1h.3c.1,0,0,.1.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,554.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.4,554.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.3 554.5 386.3 554.5 386.3 554.5 386.3 554.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.4 555.3 386.4 555.3 386.4 555.3 386.4 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.1,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.3,554.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M386.2,554.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 554.3 386.2 554.3 386.2 554.3 386.2 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.2 553.6 386.2 553.6 386.2 553.6 386.2 553.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "386.2 554.3 386.2 554.3 386.2 554.3 386.2 554.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "386.1 553.7 386.2 553.7 386.2 553.7 386.1 553.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.2,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.1,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.3,551.4h-.1c-.1-.1-.1-.1-.1-.2h.2C385.4,551.2,385.4,551.3,385.3,551.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.5,553.3h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,385.5,553.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "387.1",
      "y": "544.4",
      "width": "8.3",
      "height": "4.22",
      "transform": "translate(-263.6 395.2) rotate(-41.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.7,542.5h.2c.2,0,.3.2.4.2s0,.1.1.1h0c0,.1.2.1.2.2h-.2a.5.5,0,0,0,0,.2h.1s0,.1,0,.1h-.1a.3.3,0,0,0,.1.2h.1c.1.1,0,.2,0,.3h-.1s0,.1,0,.1h.1c-.1-.1-.2-.3-.3-.3h-.1c-.1.1-.1.3-.2.4a1.1,1.1,0,0,0-.1-.4c0,.1-.1.2-.1.3a1,1,0,0,1,0-.4l-.3-.2h0c0-.1.1-.1,0-.2h0s.1-.1,0-.1h-.1c-.1,0-.1.1-.1.1s0-.5,0-.7S392.5,542.5,392.7,542.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.9 542.6 392.9 542.6 392.9 542.6 392.9 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,544.5a.1.1,0,0,1,.1.2H391C391,544.6,391.1,544.5,391.2,544.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393 542.9 393 542.8 393 542.9 393 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.1 542.8 393.1 542.8 393.1 542.8 393.1 542.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.2 542.9 393.2 542.9 393.2 542.9 393.2 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.2 542.9 393.2 542.9 393.2 542.9 393.2 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.3 542.9 393.3 542.9 393.3 542.9 393.3 542.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.2 543 393.2 543 393.2 543 393.2 543"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,544.4l.2-.2s0,0,0,.1l-.3.2S391.6,544.4,391.7,544.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 542.9 393.3 542.9 393.4 542.9 393.4 542.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,544.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.6,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.4,543.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.5 543.8 392.5 543.8 392.5 543.8 392.5 543.8 392.5 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.7,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,548.3h.2c-.1,0,0,.1-.1.2a1.3,1.3,0,0,0,.1.4h-.3c0,.1,0,.2-.1.2s-.2-.4-.1-.6,0-.3.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393,544.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,544.4s0,0,0,.1S392.6,544.5,392.6,544.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.9,544.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,547.9h.5s.1,0,0,.1h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,546.7v.2a.3.3,0,0,1,0,.2c-.1,0,0,.2-.1.1s-.1.1,0,.1h.3s0,0,0,.1h.2s0,.1,0,.1h.1s0,.1.1.1h-.1c.1,0,0,.1.1.1h-.1c-.2.1-.1.3-.3.4l-.2-.2h-.3v.2c.1-.2,0-.4.1-.6s0-.1,0-.1h0l.2-.2a.9.9,0,0,0,0-.3c-.1,0-.1.2-.2.2h-.1c0-.1.1-.2,0-.2h-.1a.3.3,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,547.9c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,546.8h-.1s0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.6,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,545c.1,0,.2.2.3.3s0,.2,0,.3h0s0-.1,0-.1h0l-.2-.2h-.1s0,.1,0,.1h.1c0,.1.1,0,0,.1h-.1s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.6 546.9 391.6 546.9 391.7 546.9 391.7 546.9 391.6 546.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.8,545.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.2s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.8 545.3 393.8 545.3 393.8 545.3 393.8 545.3 393.8 545.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.4s0,0,0,0S393.7,545.4,393.7,545.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,545.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.9 545.2 393.9 545.2 393.9 545.2 393.9 545.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 544.7 394.5 544.7 394.5 544.7 394.5 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.8,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.5,546.6a.3.3,0,0,1,0,.3h-.2a.2.2,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,545.6c.1.1.1.2.1.4h-.4c0-.1.1,0,.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.8h0s.1.2.1.1h0s.1,0,0,.1h-.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.8 545.6 393.8 545.5 393.8 545.5 393.8 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.6 544.8 394.6 544.8 394.6 544.8 394.6 544.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,545.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.4,546.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,545.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,545.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.7 545.8 393.6 545.7 393.6 545.7 393.7 545.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393 546.3 393 546.3 393 546.3 393 546.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.6 545.8 393.6 545.8 393.6 545.8 393.6 545.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "393.1 546.3 393.1 546.3 393.1 546.3 393.1 546.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.9,545.6h0S393.9,545.6,393.9,545.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,545.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.3,549v.2c0,.1,0,.2-.1.2h-.1c0-.1-.1-.1-.1-.2S391.1,548.9,391.3,549Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.2,547.3c.1,0,.1.1.1.2h-.2v-.2A.1.1,0,0,1,393.2,547.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "388.1",
      "y": "539.6",
      "width": "6.1",
      "height": "3.12",
      "transform": "translate(-156.8 922.7) rotate(-89)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,538.4h.7s-.1,0,0,.1h.3s0-.1,0-.1h0a.3.3,0,0,1,0,.1h.5a.1.1,0,0,1,0,.1h0s0,0,0,0h-.3s0,0,0,.1h-.1c0,.1.1.2.1.3l-.2-.2c.1,0,.1.1.1.2l-.2-.2h-.3s0,.1,0,.2,0-.1,0-.1h-.2c-.1,0,0,.1,0,.1l-.4-.4A.5.5,0,0,1,389.7,538.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.9 538.3 389.9 538.3 389.9 538.3 389.9 538.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390,540.2h.1a.1.1,0,0,1,0,.1H390A.1.1,0,0,1,390,540.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.1 538.4 390 538.4 390 538.4 390.1 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.1 538.3 390 538.3 390 538.3 390.1 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.1 538.3 390.1 538.3 390.1 538.3 390.1 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.3 390.2 538.3 390.2 538.3 390.2 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.2 390.2 538.2 390.2 538.2 390.2 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.4 390.2 538.4 390.2 538.4 390.2 538.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.2,539.9a.7.7,0,0,1,0-.2h0c0,.1,0,.2,0,.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "390.2 538.2 390.2 538.2 390.2 538.2 390.2 538.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.2,539.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.2,539.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.2,539.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.3,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.3,538.3h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "390.3",
      "y": "539.1",
      "height": "0.02",
      "transform": "translate(-172.7 894.1) rotate(-86.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.4,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,543.7h.4c-.1,0,0,.1,0,.2h.1c-.1-.2-.3-.1-.4-.2s-.2-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.7,539h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.7,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,543.1l.3-.3h0l-.3.3h-.1C390.6,543.2,390.7,543.1,390.8,543.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,539.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.1,541.5h.3s.1.1,0,.1h.1v-.2h.5s0,0,0,.1h0c-.1.2.1.2.1.3H392c-.1,0,0,.1,0,.1h-.1c0,.1,0,.1,0,.2l-.3-.3h-.3s.1-.1,0-.1h.1c0-.1,0-.1,0-.2v-.2c-.1.1.1.1,0,.2h-.1s0-.1-.1-.1h-.1a.2.2,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.2,542.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.5,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.5,541.1h0S391.5,541.1,391.5,541.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.6,539.1h.3l.2.2h-.2s0,0,0,0h-.2S391.6,539.1,391.6,539.1Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "391.6",
      "y": "541.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.6,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.7,539.1h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "391.7",
      "y": "539.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.8,539.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.8 539.1 391.8 539.1 391.8 539.1 391.8 539.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.8 538.5 391.8 538.5 391.8 538.5 391.8 538.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.8,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.8,540.5h-.1C391.8,540.6,391.8,540.5,391.8,540.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,539.4h.2s0,0,0,.1h-.3c-.1-.1,0-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M391.9,539.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h.1s0,0,0,0h-.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.9 539.3 391.9 539.3 391.9 539.3 391.9 539.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.9 538.5 391.9 538.5 391.9 538.5 391.9 538.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,540.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.9,539.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 539.5 391.9 539.5 391.9 539.5 391.9 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "391.9 540.1 391.9 540.1 391.9 540.1 391.9 540.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 539.5 391.9 539.5 391.9 539.5 392 539.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "392 540.1 391.9 540.1 392 540.1 392 540.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392,539.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.2,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.5,542.4h.1c0,.1.1.1.1.2h-.2C392.4,542.6,392.4,542.4,392.5,542.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.6,540.5h.1a.1.1,0,0,1,0,.1h-.2A.1.1,0,0,1,392.6,540.5Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "393.6",
      "y": "535.6",
      "width": "4",
      "height": "7.73",
      "transform": "translate(-208.8 252.8) rotate(-28.4)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.2,537.2c0-.1,0-.2.1-.2s.2-.2.3-.3h.2s-.1.1,0,.1.2-.1.3-.2-.1.1-.1.2h1c0,.1-.1.1-.1.2h.3c-.1.1-.3.1-.3.2h0c.1.1.2.1.3.2h-.4l.2.2h-.3l-.3.3c0,.1.1.1.1.2v-.2h-.1s0,0,0,0H393c-.1.1.1.1.1.1l-.6-.2C392.4,537.5,392.2,537.4,392.2,537.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.4 537.1 392.4 537.1 392.4 537.1 392.4 537.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,539.1h.2a.2.2,0,0,1,.1.2h-.1A.1.1,0,0,1,393.7,539.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.6 537 392.6 537 392.6 537 392.6 537"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.5 536.9 392.5 536.9 392.5 536.9 392.5 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.9 392.6 536.9 392.7 536.9 392.7 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.9 392.7 536.9 392.7 536.9 392.7 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.8 392.7 536.8 392.7 536.8 392.7 536.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.8 536.9 392.8 536.9 392.8 536.9 392.8 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.7,538.6v-.3h.1c0,.1.1.2.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.7 536.7 392.7 536.7 392.7 536.7 392.7 536.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,538.5h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.7,538.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.6,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.3,537.6s0,0,0,0S393.3,537.6,393.3,537.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M392.9,536.7a0,0,0,0,1,0,0S392.9,536.8,392.9,536.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 537.7 393.4 537.7 393.4 537.7 393.4 537.7 393.4 537.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.4,537.5h0S393.4,537.5,393.4,537.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.6,542.5h.6c0,.1.1.1.1.2h.2c-.2-.1-.4.1-.6,0s-.3-.1-.3-.2S396.6,542.5,396.6,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.8,537.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.3,541.8a1.3,1.3,0,0,1,.1-.5h.1s0,.1,0,.1a3,3,0,0,0-.1.5s0,.1-.1.1S396.3,541.8,396.3,541.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394,537.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.1,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.7,539.8h.4c0,.1.1.1.1.2h.1c0-.1.1-.2,0-.2h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.4s0,.1,0,.1h.1c0,.2.3.2.3.3l-.2.2c-.1.1,0,.1,0,.2h-.1v.2l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.2s.1-.1,0-.2l-.2-.2h-.2c0,.1.1.1.1.2h-.1c-.1,0-.1-.1-.2,0h-.1a.3.3,0,0,1-.3-.2A.5.5,0,0,1,395.7,539.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.5,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.9,539.1h0A.1.1,0,0,1,395.9,539.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.9,539.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,536.8c0-.1.2-.1.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0-.1,0-.1h-.1C394.8,537,394.8,536.9,394.7,536.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396 539.1 396 539.1 396 539.1 396 539.1 396 539.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.8h0S394.9,536.9,394.9,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,537h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,536.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 536.9 395 536.9 395 536.9 395 536.9 395 536.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,536.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 536.7 394.9 536.7 394.9 536.7 395 536.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.6 536.1 394.6 536.1 394.6 536.1 394.6 536.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,536.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.9,538.3h.3v.2h-.1C395.9,538.4,395.8,538.4,395.9,538.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.3,537h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,395.3,537Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,536.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,536.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.2h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.2 536.9 395.2 536.9 395.2 536.9 395.2 536.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.7 536 394.7 536 394.7 536 394.7 536"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.1,538.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,537.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 537.1 395.4 537.1 395.4 537.1 395.4 537.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.8 537.8 395.8 537.8 395.8 537.8 395.8 537.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 537.1 395.4 537.1 395.4 537.1 395.4 537.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.8 537.7 395.7 537.7 395.8 537.7 395.8 537.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.3,536.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.8,539.9h.2c.1,0,.2.1.2.2H398C397.9,540.2,397.7,540.1,397.8,539.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.7,537.8h.1A.1.1,0,0,1,396.7,537.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "397.1",
      "y": "531.3",
      "width": "3.8",
      "height": "7.47",
      "transform": "matrix(0.55, -0.84, 0.84, 0.55, -267.29, 574.1)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,534.7c0-.1-.1-.1,0-.2s.1-.3.1-.4h.2c.1,0,.1-.2.1-.3s-.1.2,0,.2h.5s0-.1,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.2.2-.2.4h0a.8.8,0,0,0-.1.4c0,.1.2,0,.1.1h-.3s0,0,0,0H396c0,.1.1,0,.1.1h-.6C395.4,534.9,395.2,534.9,395.1,534.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.2 534.5 395.2 534.5 395.2 534.5 395.2 534.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.4 395.4 534.4 395.4 534.4 395.4 534.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.3 534.3 395.3 534.3 395.3 534.3 395.3 534.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.3 395.4 534.3 395.4 534.2 395.4 534.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.2 395.4 534.2 395.4 534.2 395.4 534.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 534.1 395.3 534.1 395.3 534.1 395.4 534.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.5 534.2 395.5 534.2 395.5 534.2 395.5 534.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397,535.2l-.2-.2h.1l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.3 534.1 395.3 534.1 395.3 534.1 395.3 534.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,535.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397,535.2h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.9,535.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.2,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,534h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.3 534.6 396.3 534.6 396.3 534.6 396.4 534.6 396.3 534.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.3,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.3,537.2c0-.1.1-.1.1-.2h.2l.3-.2h.3c-.2,0-.3.2-.5.2s-.3.1-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,534.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.6,534.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.7,536.8a1.2,1.2,0,0,1-.2-.5h.1v.4s.1.1,0,.1S400.7,536.8,400.7,536.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,534.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397,534.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397,534.3h0S397,534.3,397,534.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.3,535.3v-.2h.2c0,.1.2,0,.1.1h.1c0-.1,0-.2-.1-.2h.1s0-.1,0-.1h.1c0-.1-.1-.1,0-.1h.5s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.4v.2c0,.1,0,.1,0,.1h-.1c0-.1,0-.1,0-.2h-.5c0,.1.2,0,.2.1h-.2s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M400.5,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.1,534.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399.2,534.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.1,533.2c0-.1.1-.2.2-.3h0c0,.1-.1,0,0,.1h0v.2h.1s.1.1,0,.1h.2l.2-.2s-.1.1-.1.1a.4.4,0,0,1-.3.2Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "399.2",
      "y": "534.6",
      "height": "0.01",
      "transform": "translate(-266.9 572.3) rotate(-56.5)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.2,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,533.2h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.4,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,533.1h0S397.2,533.1,397.2,533.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.3 533.2 397.3 533.2 397.4 533.1 397.4 533.1 397.3 533.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.4,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.4,533.2s0,0,0,0S397.4,533.2,397.4,533.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.3 533.1 397.2 533.1 397.2 533.1 397.3 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.7 532.7 396.6 532.7 396.6 532.7 396.7 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.4,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.8,534h.3a.3.3,0,0,1,0,.2h-.1C398.8,534.1,398.7,534,398.8,534Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.7,533.2h.3a.2.2,0,0,0,0,.2h-.3A.1.1,0,0,1,397.7,533.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.4,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.3,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.3h0s.1-.1.1-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.9,533.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "397.6 533.1 397.5 533.1 397.5 533.1 397.6 533.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396.7 532.5 396.7 532.5 396.7 532.5 396.7 532.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.9,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M399,534h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.8,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M397.9,533.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "397.8 533.2 397.8 533.2 397.8 533.2 397.8 533.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.4 533.6 398.4 533.6 398.4 533.6 398.4 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "397.8 533.2 397.8 533.2 397.8 533.2 397.8 533.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "398.4 533.5 398.4 533.6 398.4 533.5 398.4 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.5,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M401.2,534.5h.2C401.3,534.7,401.1,534.6,401.2,534.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.3,533.2h.3s0,.1,0,.1h-.1C399.3,533.3,399.2,533.3,399.3,533.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "395",
      "y": "525.7",
      "width": "3.3",
      "height": "6.43",
      "transform": "translate(-256.1 633.7) rotate(-62.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M393.3,528.9s-.1-.1-.1-.2,0-.2.1-.4h.1s0-.1,0-.1h.1c.1,0,0-.2.1-.2s0,.1,0,.2h.4s0,0,0-.1h.3c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.3l-.3.2h-.1a.7.7,0,0,0-.1.3h-.1l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.3 528.7 393.3 528.8 393.3 528.7 393.3 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,529.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 528.6 393.4 528.6 393.5 528.6 393.5 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.6 393.4 528.6 393.4 528.6 393.4 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.5 393.4 528.5 393.4 528.5 393.4 528.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.5 393.4 528.5 393.4 528.5 393.4 528.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.4 393.4 528.4 393.4 528.4 393.4 528.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.5 528.4 393.5 528.5 393.5 528.5 393.5 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,529.2h-.2l.2.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "393.4 528.4 393.4 528.4 393.4 528.4 393.4 528.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,529.1s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,529.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.8,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.2,528.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M393.5,528.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "394.3 528.7 394.3 528.7 394.3 528.7 394.3 528.7 394.3 528.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.2,528.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.7,530.5c0-.1,0-.1.1-.2h.1l.2-.2s-.1.1,0,.1h.3c-.2,0-.2.2-.4.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.4,528.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.5,528.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.7,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.2,530.2l-.2-.4h.1v.4s.1.1,0,.1S398.2,530.2,398.2,530.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,528.4h0S394.8,528.4,394.8,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.9,529.1v-.2h.4c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2s0,.1,0,.1h-.6s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.7,528.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.7,528.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.8,527.5c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0v.2h0s.1,0,0,.1h.3s-.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "396.8 528.5 396.8 528.5 396.8 528.5 396.8 528.5 396.8 528.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M394.9,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,527.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.9,527.4h0S394.9,527.4,394.9,527.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 527.4 395 527.4 395 527.4 395 527.4 395 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.1,527.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395 527.3 394.9 527.3 394.9 527.3 395 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.4 527 394.4 527 394.4 527 394.4 527"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.3,528h.2a.3.3,0,0,1,0,.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.3,527.4h.3a.2.2,0,0,0,0,.2h-.2A.1.1,0,0,1,395.3,527.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.1,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,527.5h0s.1-.1.1-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "395.2 527.3 395.2 527.3 395.2 527.3 395.2 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "394.5 526.9 394.5 526.9 394.5 526.9 394.5 526.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M396.5,527.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M395.5,527.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 527.3 395.4 527.4 395.4 527.4 395.4 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396 527.7 396 527.7 396 527.7 396 527.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "395.4 527.4 395.4 527.4 395.4 527.4 395.4 527.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "396 527.6 396 527.6 396 527.6 396 527.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M395.2,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M394.5,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M398.4,528.2h.2C398.5,528.3,398.4,528.3,398.4,528.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M396.7,527.2h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "387.3",
      "y": "527.6",
      "width": "3.6",
      "height": "7.05",
      "transform": "translate(-209.6 257.1) rotate(-29.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M392.3,533.1c0,.1,0,.2-.1.2s-.2.2-.3.3h-.2s0-.1,0-.1-.1.1-.2.1.1-.1.1-.2h-.9c0-.1.1,0,.1-.2h-.2c.1-.1.3-.1.3-.2h0l-.3-.2h.4l.2-.2c0-.1-.1-.1-.1-.2h.4c0-.1-.1-.1-.1-.1l.6.2C392.1,532.8,392.3,533,392.3,533.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392.1 533.3 392.1 533.3 392.1 533.3 392.1 533.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.8,531.5h-.2v-.2h.1A.1.1,0,0,1,390.8,531.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 533.3 391.9 533.3 391.9 533.3 391.9 533.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "392 533.4 392 533.4 392 533.4 392 533.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.9 533.4 391.9 533.4 391.9 533.4 391.9 533.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 533.5 391.8 533.5 391.8 533.5 391.8 533.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 533.6 391.8 533.5 391.8 533.5 391.8 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.7 533.4 391.8 533.4 391.7 533.4 391.7 533.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.9,531.9v.2h-.1c0-.1-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.8 533.6 391.8 533.6 391.8 533.6 391.8 533.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,532h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,532h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.9,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.3,532.8s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.7,533.6a0,0,0,0,1,0,0S391.7,533.6,391.7,533.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "391.2 532.7 391.2 532.7 391.2 532.7 391.2 532.7 391.2 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M391.2,532.9h0S391.1,532.9,391.2,532.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.2,528.4h-.5c0-.1,0-.1-.1-.2h-.2c.2.1.3-.1.5,0s.2.1.3.2S388.2,528.3,388.2,528.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,533.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M390.8,533h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.5,529a1.1,1.1,0,0,1-.1.5h-.1s0-.1,0-.1a2.7,2.7,0,0,0,.1-.4s0-.1.1-.1S388.5,529,388.5,529Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.6,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390.5,532.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389,530.9h-.4c0-.1-.1-.1-.1-.1h-.1c0,.1-.1.1,0,.2h-.1c-.1,0,0,.1,0,.1h-.2s0,.1,0,.1h-.3s0,0,0-.1h-.1c0-.2-.2-.1-.3-.3l.2-.2c0-.1,0-.1,0-.1h0l.5.2h.1a.2.2,0,0,0,0-.2h.1c.1,0,0,.1,0,.2s-.1.1,0,.2l.2.2h.2c0-.1-.1-.1-.1-.2h.3l.2.2A.5.5,0,0,1,389,530.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,531.5h0A.1.1,0,0,1,388.9,531.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.8,531.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M390,533.5l-.3.2h.2c.1,0,0-.1,0-.1h-.1s0,0,0,.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "388.8 531.4 388.8 531.4 388.8 531.4 388.8 531.4 388.8 531.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.9,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.5h0S389.8,533.5,389.8,533.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.8,533.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.8,533.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.8 533.5 389.8 533.5 389.7 533.5 389.7 533.5 389.8 533.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.7,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.7,533.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.8 533.6 389.8 533.6 389.8 533.6 389.8 533.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390.1 534.2 390.1 534.2 390.1 534.2 390.1 534.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,532.2h-.3V532h.1C388.9,532.1,389,532.2,388.9,532.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,533.4h-.3s0-.1,0-.1v-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,389.5,533.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.6,533.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,533.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,533.2h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389.5 533.5 389.5 533.5 389.5 533.5 389.5 533.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "390 534.3 390 534.3 390 534.3 390 534.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.7,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.4,533.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.3,533.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.4 533.3 389.4 533.3 389.4 533.3 389.4 533.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389 532.7 389 532.7 389 532.7 389 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.4 533.3 389.4 533.3 389.4 533.3 389.4 533.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "389 532.7 389 532.7 389 532.7 389 532.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.5,533.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,534.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.1,530.7H387l-.2-.2h.2C387.1,530.5,387.2,530.6,387.1,530.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.1,532.6h-.1A.1.1,0,0,1,388.1,532.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "384.9",
      "y": "523.2",
      "width": "6.6",
      "height": "3.35",
      "transform": "translate(-158.6 881.6) rotate(-86.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.7,528H389s.1,0,0-.1h-.3s0,.1,0,.1h0a.3.3,0,0,1,0-.1h-.6a.1.1,0,0,1,0-.1h0s0,0,0,0h.3s0,0,0-.1h.1c0-.1-.1-.2-.1-.3l.3.2c-.1,0-.1-.2-.1-.2l.2.2h.3s0-.1,0-.2,0,.1,0,.2h.3c.1,0,0-.1,0-.1l.4.4A.5.5,0,0,1,389.7,528Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.5 528.1 389.5 528.1 389.5 528.1 389.5 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.4,526h-.1a.2.2,0,0,1,0-.1h.1A.1.1,0,0,1,389.4,526Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.3 528 389.3 528 389.3 528 389.3 528"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.3 528.1 389.3 528.1 389.3 528.1 389.3 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.2 528.1 389.2 528.1 389.2 528.1 389.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.2 528.1 389.2 528.1 389.2 528.1 389.2 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 528.1 389.2 528.1 389.1 528.1 389.1 528.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 528 389.2 528 389.2 528 389.1 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M389.2,526.4a.7.7,0,0,1,0,.2h0c0-.1,0-.2.1-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 528.2 389.1 528.2 389.1 528.2 389.1 528.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.2,526.5h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.2,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.2,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389.1,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389,528.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "389.1 527.2 389.1 527.2 389 527.2 389 527.2 389.1 527.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M389,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.9,522.3h-.2c0-.1-.1-.1-.1-.1l-.3-.2h.1c.1,0,0-.1,0-.2s-.1-.1-.1-.2.3.1.4.3.2.2.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M388.6,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,526.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.8,522.9l-.3.3h0l.3-.3h.1C388.9,522.8,388.8,522.9,388.8,522.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.6,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.5,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.5,526.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,524.6H388c0-.1-.1-.1,0-.1H388v.2h-.5s0,0,0-.1h-.1s0,0,0-.1h0c.1-.2-.1-.2-.1-.4h.2c.1,0,0-.1,0-.1h.1c0-.1,0-.1,0-.2l.3.4h.3c0,.1-.1.1,0,.1h-.1c0,.1,0,.2,0,.2v.2c.1-.1-.1-.1,0-.2h.1s0,.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M388.3,523.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.9,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.9,525h0S387.9,525,387.9,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.7,527.2h-.3c0-.1-.1-.1-.2-.2h.2s0,0,0,0h.1s0-.1,0-.1h.1S387.7,527.1,387.7,527.2Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "387.8",
      "y": "525",
      "height": "0.02",
      "transform": "translate(-156.3 885.4) rotate(-87.1)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.6,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.6,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 527 387.5 527 387.5 527 387.5 527 387.5 527"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.5,527h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.5 527.1 387.5 527.2 387.5 527.2 387.5 527.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.4 527.8 387.5 527.8 387.5 527.8 387.4 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.5,525.6l-.2-.2h.2C387.6,525.5,387.6,525.6,387.5,525.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,526.8l-.2-.2h.3c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.4,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6s0,0,0,0h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.4 526.9 387.4 527 387.4 526.9 387.4 526.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.3 527.8 387.3 527.8 387.3 527.8 387.3 527.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.3,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.3,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M387.4,526.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.3 526.7 387.3 526.7 387.3 526.7 387.3 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.4 526 387.4 526 387.4 526 387.4 526"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "387.3 526.7 387.3 526.7 387.3 526.7 387.3 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "387.3 526.1 387.4 526.1 387.4 526.1 387.3 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387.3,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M387,527.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.8,523.6h-.1c0-.1-.1-.1-.1-.2h.2C386.9,523.4,387,523.5,386.8,523.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.7,525.6h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,386.7,525.6Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "379.6",
      "y": "528.8",
      "width": "7.7",
      "height": "3.93",
      "transform": "translate(-58.6 47.7) rotate(-6.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,533.1H380c-.2-.1-.1-.3-.2-.4s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s.1.2.2.2V532h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.2s0-.1,0-.2h.1c.1.1,0,.2.1.2h0c0-.1,0-.1,0-.2h0c.1.1,0,.3.1.4h.1c.1,0,.2-.2.3-.2l-.2.3h.2l-.2.2.2.3H381s-.1,0-.1.1h.2l-.4.5A.6.6,0,0,1,380.2,533.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 532.9 380.1 532.9 380.1 532.9 380.1 532.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,532.4a.1.1,0,0,1,0-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.2 532.7 380.2 532.7 380.2 532.7 380.2 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380 532.7 380 532.7 380 532.7 380 532.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 532.6 380 532.6 380 532.6 380.1 532.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380 532.6 380 532.6 380 532.6 380 532.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 532.5 380 532.5 380 532.5 379.9 532.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "380.1 532.5 380.1 532.5 380.1 532.5 380.1 532.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382,532.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 532.5 379.9 532.5 379.9 532.5 379.9 532.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,532.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.9,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.8,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,532.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380,532.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381 532.2 381 532.2 381 532.2 381 532.2 381 532.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,532.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M386.7,531c-.1-.1,0-.1-.1-.2h.1v-.3s0,.1,0,.2h.4c-.2.1-.1.4-.2.5s-.2.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.3,531.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.9,531l-.4-.3s0-.1,0-.1h.1l.4.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,531.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,531.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.4,531.6h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.8,530.8c0-.1,0-.2,0-.2v-.2c.1,0,.1-.1.2,0H384a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.1h.1c.2.1.2-.2.4-.2s.1.2.1.2h.4l-.4.4s-.1.1,0,.1h-.3l-.2.2c.1.1.1-.1.3-.1a0,0,0,0,1,0,.1s-.2.1-.1.2.1.1,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M385.3,530.6c.1,0,0,0,0,.1S385.2,530.6,385.3,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M383.3,530.4h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M383.3,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.6c-.1-.1,0-.2-.1-.4s.1-.2.2-.2h0s0,0,0,.1h0s-.1.1,0,.1h-.1a.3.3,0,0,0,0,.2s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2,0-.2s0,.1,0,.1a.4.4,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "383.4 530.4 383.3 530.4 383.3 530.3 383.4 530.3 383.4 530.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.8,530.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.7,530.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.9 530.5 380.9 530.5 380.9 530.4 380.9 530.4 380.9 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.9,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.8 530.4 380.8 530.4 380.7 530.4 380.8 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 530.5 380 530.5 380 530.5 380 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.5,530.1a.2.2,0,0,1,.1-.2v.2h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381.1,530.2c0-.1.1-.2.1-.3h.1l.2.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.8,530.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,530.2h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,530.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "381 530.2 381 530.2 381 530.2 381 530.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380 530.3 380 530.3 380 530.3 380 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,530.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.7,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.4,530.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 530.1 381.2 530.2 381.2 530.2 381.2 530.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382 530 382 530.1 382 530.1 382 530"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.2 530.1 381.2 530.1 381.2 530.1 381.2 530.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "382 530 382 530.1 382 530 382 530"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,530.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.9,530h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M384.8,528.9s0-.1,0-.2h.3c0,.1,0,.1,0,.2S384.8,529.1,384.8,528.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.4,529.2c0-.1,0-.1,0-.2h.2a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "377.4",
      "y": "521.7",
      "width": "3.6",
      "height": "7.05",
      "transform": "translate(-254.1 388.7) rotate(-42)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M382.7,526.5c0,.1.1.2,0,.2s-.1.2-.2.4h-.2s0-.1,0-.1-.1.2-.2.2.1-.1,0-.2h-.9c0-.1.1-.1.1-.2H381c.1-.1.2-.2.2-.3h.1l.2-.3c0-.1-.1-.1-.1-.2h.3s0,0,0,0h.1a.1.1,0,0,0,0-.1h.1c0-.1-.1,0-.1-.1h.6C382.5,526.2,382.6,526.3,382.7,526.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.5 526.7 382.6 526.7 382.6 526.7 382.5 526.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,525.2h-.1C380.9,525,380.9,525.1,380.9,525.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.4 526.7 382.4 526.7 382.4 526.7 382.4 526.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.4 526.8 382.5 526.8 382.5 526.8 382.4 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 526.9 382.4 526.9 382.4 526.9 382.3 526.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 526.9 382.3 526.9 382.3 526.9 382.3 526.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 527 382.4 527 382.3 527 382.3 527"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.2 526.9 382.2 526.9 382.2 526.9 382.2 526.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,525.6l.2.2h-.1v-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "382.3 527 382.4 527 382.4 527 382.3 527"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.1,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.7,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M382.2,527.1h0S382.2,527,382.2,527.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "381.5 526.3 381.6 526.3 381.5 526.3 381.5 526.3 381.5 526.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.5,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.7,522.8h-.8c.2.1.3-.1.5-.1s.2,0,.3.1S377.7,522.7,377.7,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.3,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M381.2,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M381,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,523.3a1.2,1.2,0,0,1,0,.5H378a2.8,2.8,0,0,0,0-.4s0-.1,0-.1S378.1,523.3,378.1,523.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,526.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.9,526.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,525h-.3c0-.1-.1,0-.1-.1h-.1c0,.1,0,.2,0,.2h-.1s0,.1,0,.1h-.2s0,.1,0,.1h-.5s0,0,0-.1-.3-.1-.3-.2V525c0-.1,0-.1-.1-.1h.6a.2.2,0,0,0,0-.2h.1c0,.1,0,.1,0,.2l.2.2h.2c0-.1-.1-.1-.2-.2h.3l.3.2A.5.5,0,0,1,379,525Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.1,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M378.9,525.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.5,527.4c0,.1-.2.2-.2.2h0c0-.1.1,0,0-.1h0l.2-.2h-.1c.1,0,0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "378.9",
      "y": "525.6",
      "height": "0.01",
      "transform": "translate(-254.2 387.8) rotate(-41.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.4,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.4h0S380.4,527.4,380.4,527.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.3,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.4,527.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 527.4 380.3 527.4 380.3 527.4 380.3 527.4 380.3 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.2,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M380.2,527.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.3 527.5 380.4 527.5 380.3 527.5 380.3 527.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.8 528 380.8 528 380.8 528 380.8 528"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.3,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M379.2,526.3h-.3v-.2h.1S379.2,526.3,379.2,526.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380,527.3h-.3a.2.2,0,0,0,0-.2h.3A.1.1,0,0,1,380,527.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.2,527.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,527.2h-.1s0,.1,0,.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.1 527.4 380.1 527.5 380.1 527.5 380.1 527.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "380.7 528.1 380.7 528.1 380.7 528.1 380.7 528.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.2h0S379.8,527.2,379.8,527.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.9,527.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M379.8,527.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 527.3 379.9 527.3 379.9 527.3 379.9 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.4 526.8 379.4 526.8 379.4 526.8 379.4 526.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "379.9 527.3 379.9 527.3 379.9 527.3 379.9 527.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "379.4 526.8 379.4 526.8 379.4 526.8 379.4 526.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.1,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M380.5,528.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M377.1,525.3h-.3a.2.2,0,0,1,0-.1h.2C377,525.1,377.2,525.2,377.1,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M378.5,526.9h-.3s0-.1,0-.1h.1A.1.1,0,0,1,378.5,526.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "370.9",
      "y": "518.8",
      "width": "3.3",
      "height": "6.52",
      "transform": "translate(-146.1 144.8) rotate(-18.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375,524.4s0,.2-.1.2-.2.2-.3.2h-.2s.1-.1,0-.1h-.2c0-.1.1-.1.1-.2h-1l.3-.2h0l-.2-.2h.3v-.2h.2l.3-.2c0-.1-.1-.1,0-.2s0,.1.1.1h.3c.1-.1-.1-.1-.1-.1l.5.2C374.9,524.1,375.1,524.2,375,524.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.9 524.5 374.9 524.5 374.9 524.5 374.9 524.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374,522.6h-.1a.2.2,0,0,1,0-.1h.1A.1.1,0,0,1,374,522.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 524.5 374.7 524.5 374.7 524.5 374.7 524.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.7 524.6 374.7 524.6 374.7 524.6 374.7 524.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 524.6 374.6 524.6 374.6 524.6 374.6 524.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 524.6 374.6 524.6 374.6 524.6 374.6 524.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.5 524.7 374.6 524.7 374.6 524.7 374.5 524.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.5 524.6 374.5 524.5 374.5 524.5 374.5 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374,523v.2H374c0-.1-.1-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.5 524.7 374.6 524.7 374.6 524.7 374.5 524.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374,523.1h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374,523.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374,523.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.2,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.4,524.7h0S374.4,524.7,374.4,524.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.1 523.8 374.1 523.8 374.1 523.8 374.1 523.8 374.1 523.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.1,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,519.4h-.5c0-.1,0-.1-.1-.2h-.1c.1.1.3,0,.5.1s.2.1.2.2S372.2,519.3,372.2,519.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,524.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.3,520a1.1,1.1,0,0,1-.1.4h-.1s0-.1,0-.1l.2-.4h.1C372.4,519.9,372.3,520,372.3,520Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.5,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.5,523.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.5,521.8h-.3c0-.1-.1-.1,0-.1H372c0,.1-.1.1-.1.2h-.6s0,0,0-.1h-.1c0-.2-.2-.2-.2-.3h.2c.1-.1,0-.1,0-.1h.1c-.1,0,0-.1-.1-.1l.4.3h.1V521h.1s0,.1,0,.1h-.1v.2h.2c.1-.1-.1-.1-.1-.2h.3a.3.3,0,0,1,.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,520.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,522.3h0A.1.1,0,0,1,372.2,522.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,522.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,524.3h-.1c.1,0,0-.1,0-.1h-.1s0,0,0,.1h.1C372.9,524.2,372.8,524.3,372.9,524.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 522.2 372.2 522.3 372.2 522.3 372.2 522.2 372.2 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.8,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.7,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,524.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.7 524.3 372.7 524.3 372.6 524.3 372.6 524.3 372.7 524.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.6,524.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.6,524.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.7 524.4 372.7 524.4 372.7 524.4 372.7 524.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.9 525 372.9 525 372.9 525 372.9 525"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,524.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,523h0C372.2,522.9,372.2,522.9,372.1,523Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.4,524.1h-.3s0,0,0-.1v-.2h.1c.1,0,0,.1.1.1A.1.1,0,0,1,372.4,524.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.6,524.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.5 524.2 372.5 524.2 372.5 524.2 372.5 524.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.7 525 372.7 525 372.7 525 372.7 525"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,523.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372,522.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.4,524h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.3,523.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.4 524.1 372.4 524 372.4 524 372.4 524.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 523.4 372.2 523.4 372.2 523.4 372.1 523.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.4 524 372.4 524 372.4 524 372.4 524"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 523.5 372.2 523.4 372.1 523.4 372.1 523.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.4,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.5,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.8,521.3h-.1c-.1,0-.2-.1-.1-.2h.2C370.8,521.1,370.8,521.2,370.8,521.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.4,523.2h0A.1.1,0,0,1,371.4,523.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.8",
      "y": "520.5",
      "width": "3.3",
      "height": "6.38",
      "transform": "translate(-201.8 232.4) rotate(-27.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.7,521.9s0-.2.1-.2.2-.2.3-.3h.2s0,.1,0,.1h.2c0,.1-.1.1-.1.2h1l-.3.2h0l.3.2h-.4l-.2.2c0,.1.1.1,0,.2h-.4c0,.1.1.1.1.1l-.5-.2C365.8,522.1,365.6,522,365.7,521.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.8 521.7 365.8 521.7 365.8 521.7 365.8 521.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,523.4h.1A.1.1,0,0,1,366.9,523.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366 521.7 366 521.7 366 521.7 366 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.9 521.6 365.9 521.6 365.9 521.6 365.9 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366 521.6 366 521.6 366 521.6 366 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.6 366 521.6 366 521.6 366.1 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.5 366 521.5 366.1 521.5 366.1 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.6 366.1 521.6 366.1 521.6 366.1 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,523v-.2h.1c0,.1.1.2.1.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.1 521.4 366.1 521.5 366.1 521.5 366.1 521.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.8,522.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.5,522.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.2,521.5a0,0,0,0,1,0,0S366.2,521.5,366.2,521.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 522.2 366.6 522.2 366.6 522.2 366.6 522.2 366.6 522.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.6,522.1h0S366.7,522.1,366.6,522.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,526.2h.5c0,.1,0,.1.1.2h.1c-.1-.1-.3.1-.5,0s-.2-.1-.2-.2S369.2,526.3,369.2,526.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.9,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,522h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.1,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,525.7a1,1,0,0,1,.1-.4h.1s0,.1,0,.1a2.4,2.4,0,0,0-.1.4H369C368.9,525.8,369,525.7,369,525.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,522.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,524h.3c0,.1.1.1.1.1h.1c0-.1.1-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.3s0,0,0,.1h.1c0,.2.2.1.3.3h-.2c0,.1,0,.1,0,.1h0l-.4-.2h-.1a.2.2,0,0,0,0,.2h-.1s0-.1,0-.1.1-.1,0-.1v-.2h-.2c0,.1.1.1.1.2h-.3l-.2-.2A.4.4,0,0,1,368.5,524Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,525h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,523.4h0A.1.1,0,0,1,368.7,523.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,523.5h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,521.5l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.8 523.5 368.7 523.5 368.8 523.4 368.8 523.5 368.8 523.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.8,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,521.5h0S367.9,521.6,367.8,521.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.9,521.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.9,521.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 521.6 367.9 521.6 368 521.6 368 521.6 367.9 521.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368,521.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 521.5 367.9 521.5 367.9 521.5 367.9 521.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 520.9 367.6 520.9 367.6 520.9 367.6 520.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,521.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,522.8h0S368.6,522.8,368.7,522.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,521.7h.3s0,.1,0,.1v.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,368.2,521.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,521.9h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.1 521.6 368.1 521.6 368.1 521.6 368.1 521.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.8 520.9 367.7 520.9 367.8 520.9 367.8 520.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,522.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,521.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 521.7 368.3 521.8 368.3 521.8 368.3 521.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.6 522.3 368.6 522.3 368.6 522.3 368.6 522.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 521.8 368.3 521.8 368.3 521.8 368.3 521.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.6 522.3 368.6 522.3 368.6 522.3 368.6 522.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,521.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368,520.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,524.1h.1l.2.2h-.2C370.3,524.3,370.2,524.2,370.3,524.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.4,522.4h.1A.1.1,0,0,1,369.4,522.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "363.8",
      "y": "524",
      "width": "3.8",
      "height": "7.43",
      "transform": "translate(-238.6 310.9) rotate(-35.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,526c0-.1,0-.2,0-.2s.2-.2.3-.4h.2s0,.1,0,.1.1-.1.2-.2-.1.1-.1.2h1c0,.1-.1.1-.1.2h.3c-.1.1-.3.1-.3.3h0l.3.2h-.5l-.2.3c0,.1.1.1.1.2h-.3s0,0,0,0H363a.1.1,0,0,0,0,.1H363c0,.1.1.1.1.1h-.6C362.3,526.3,362.2,526.2,362.2,526Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.3 525.9 362.3 525.9 362.3 525.9 362.3 525.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.8,527.6h.2v.2H364C363.9,527.8,363.8,527.7,363.8,527.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.5 525.8 362.5 525.8 362.5 525.8 362.5 525.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.4 525.7 362.4 525.7 362.4 525.7 362.4 525.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.5 525.7 362.5 525.7 362.5 525.7 362.5 525.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.6 525.6 362.6 525.7 362.6 525.6 362.6 525.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.6 525.5 362.5 525.6 362.6 525.6 362.6 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.7 525.7 362.7 525.7 362.7 525.7 362.7 525.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.7,527.2v-.2h.1v.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.6 525.5 362.5 525.5 362.6 525.5 362.6 525.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,527.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,527h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,526.2s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,525.5h0S362.7,525.5,362.7,525.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.3 526.3 363.3 526.3 363.3 526.3 363.3 526.3 363.3 526.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.3,526.2h0S363.4,526.2,363.3,526.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,530.6h.5c0,.1.1.1.1.2h.2c-.2-.1-.3.1-.5,0s-.3,0-.3-.2S366.9,530.6,366.9,530.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,525.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,526h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.6,529.9a1.2,1.2,0,0,1,0-.5h.1a2.9,2.9,0,0,0,0,.5s0,.1-.1.1S366.6,530,366.6,529.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,526.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.8,528h.4c0,.1.1,0,.1.1h.1c0-.1.1-.2,0-.2h.1c.1,0,0-.1,0-.1h.2s0-.1,0-.1h.5c.1.2.3.1.3.3l-.2.2c0,.1,0,.1.1.2h0l-.5-.2h-.1a.3.3,0,0,0,0,.2h-.1c-.1,0,0-.1-.1-.2s0-.1,0-.2l-.2-.2h-.2c0,.1.1.1.2.2h-.3l-.3-.2A.5.5,0,0,1,365.8,528Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.9,527.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.9,527.4h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,525.4c0-.1.2-.1.3-.2h0c0,.1-.1,0,0,.1h-.1c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366 527.4 366 527.4 366 527.4 366 527.4 366 527.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.6,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,525.3h0S364.7,525.4,364.6,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.7,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,525.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.7 525.4 364.7 525.4 364.8 525.4 364.8 525.4 364.7 525.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.7 525.3 364.7 525.3 364.7 525.2 364.7 525.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.3 524.7 364.3 524.7 364.3 524.7 364.3 524.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,525.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.8,526.6h.3v.2h-.1C365.8,526.7,365.7,526.7,365.8,526.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.1,525.5h.3a.2.2,0,0,0-.1.2h-.1c-.1,0,0-.1-.1-.1A.1.1,0,0,1,365.1,525.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.9,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,525.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.1,525.6h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "365 525.4 365 525.3 365 525.3 365 525.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.4 524.6 364.4 524.6 364.4 524.6 364.4 524.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.6h0S365.2,525.6,365.2,525.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.2,525.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366,526.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.1,525.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.3,525.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.2 525.5 365.1 525.5 365.1 525.5 365.2 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "365.6 526.1 365.6 526.1 365.6 526.1 365.6 526.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.2 525.5 365.2 525.5 365.2 525.5 365.2 525.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "365.6 526.1 365.6 526.1 365.6 526.1 365.6 526.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365,525.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,524.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.8,528h.1l.2.2H368C367.9,528.2,367.8,528.1,367.8,528Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.5,526.1h.3s0,.1,0,.1h-.2A.1.1,0,0,1,366.5,526.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.7",
      "y": "524.1",
      "width": "3.3",
      "height": "6.52",
      "transform": "translate(-25.1 18) rotate(-2.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,530.3h-.7s.1,0,0-.1h-.3s0,.1,0,.1h0a.3.3,0,0,1,0-.1h-.6s0,0,0,0h.3s0,0,0-.1h.1c0-.1-.1-.2-.2-.3l.3.2v-.2l.2.2h.3c0-.1,0-.1,0-.2s0,.1,0,.2h.3c.1,0,0-.1,0-.1l.4.4A.5.5,0,0,1,361.2,530.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361 530.4 361 530.4 361 530.4 361 530.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,528.3h-.1a.2.2,0,0,1,0-.1h.1A.1.1,0,0,1,360.7,528.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.8 530.3 360.8 530.3 360.8 530.3 360.8 530.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.8 530.4 360.8 530.4 360.8 530.4 360.8 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 530.4 360.7 530.4 360.7 530.4 360.7 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 530.4 360.7 530.4 360.7 530.4 360.7 530.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 530.5 360.7 530.5 360.7 530.5 360.6 530.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 530.3 360.7 530.3 360.7 530.3 360.6 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,528.7a.7.7,0,0,1,0,.2h0c0-.1,0-.2,0-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 530.5 360.7 530.5 360.7 530.5 360.6 530.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,528.8h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,528.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,528.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 529.5 360.5 529.5 360.5 529.5 360.5 529.5 360.5 529.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,524.7h-.4c.1-.1,0-.1,0-.2v-.2c.1.2.3.1.4.2s.2.1.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360,529.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,529.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,525.3l-.2.4h0l.3-.3h.1C359.9,525.2,359.8,525.3,359.7,525.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,527.1h-.3c0-.1-.1-.1,0-.1h-.1v.2h-.3s0,0,0-.1h-.3s0,0,0-.1h-.1c.1-.2-.1-.2-.1-.4h.2c.1,0,0-.1,0-.1h.1c0-.1,0-.1,0-.2l.3.4h.3s-.1.1,0,.1H359c0,.1,0,.1,0,.2v.2c.1-.1-.1-.1,0-.2h.1s.1.2.1.1h.1a.3.3,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.3,525.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,527.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,527.5h0S359.1,527.5,359.1,527.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,529.7h-.3l-.2-.2h.2s0,0,0,0h.1s0,.1,0,.1h.1S359.1,529.6,359.1,529.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359 527.5 359 527.5 359 527.5 359 527.5 359 527.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359,529.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 529.6 359 529.6 358.9 529.6 358.9 529.6 359 529.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,529.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 529.7 358.9 529.7 358.9 529.7 358.9 529.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 530.3 359 530.3 359 530.3 358.9 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,529.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,528.1h.1C358.8,528.1,358.9,528.1,358.8,528.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,529.3h-.2s0,0,0-.1h.3c.1,0,0,.1.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,529.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,529.2h-.1s0,0,0,0h.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,529.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 529.5 358.8 529.5 358.8 529.5 358.8 529.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 530.3 358.8 530.3 358.8 530.3 358.8 530.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,528h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,529.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,529.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.7 529.3 358.7 529.3 358.7 529.3 358.7 529.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.7 528.6 358.7 528.6 358.7 528.6 358.7 528.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.7 529.2 358.7 529.2 358.7 529.3 358.7 529.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.7 528.6 358.7 528.6 358.7 528.6 358.7 528.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,529.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,530.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,526.2h-.1c-.1-.1-.1-.1-.1-.2h.2C358,526,358,526.1,357.9,526.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,528.2h-.1a.1.1,0,0,1,0-.1h.2A.1.1,0,0,1,358,528.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "356.5",
      "y": "534.2",
      "width": "8.3",
      "height": "4.25",
      "transform": "translate(-49.8 37.1) rotate(-5.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,538.8c-.1,0-.2,0-.2-.2s-.1-.3-.2-.4,0-.1,0-.1h0c.1-.1-.1-.2,0-.3s.1.2.2.2v-.2h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.2s-.1-.1,0-.2h.1c.1.1,0,.2.1.2h.1c-.1-.1,0-.1,0-.2h0c.1.1,0,.3.1.4h.1c.2,0,.2-.2.4-.2a1.1,1.1,0,0,0-.2.4h.2l-.2.3.2.4h-.1s-.1,0-.1.1h0c.1.1.1-.1.2,0l-.5.5A.7.7,0,0,1,357.1,538.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 538.6 357 538.6 357 538.6 357 538.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,538.1a.1.1,0,0,1,.1-.2h.2s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 538.3 357 538.4 357 538.4 357 538.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 538.4 356.9 538.4 356.9 538.4 356.9 538.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 538.2 356.9 538.2 356.9 538.2 356.9 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.9 538.2 356.9 538.2 356.9 538.2 356.9 538.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 538.1 356.8 538.2 356.8 538.2 356.8 538.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357 538.1 357 538.1 357 538.1 357 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,537.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.8 538.1 356.8 538.1 356.8 538.1 356.8 538.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,537.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.9,538h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "358",
      "y": "537.8",
      "height": "0.02",
      "transform": "translate(-52.8 39.1) rotate(-5.8)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,537.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,536.7c-.1-.1,0-.2-.1-.2h.2V536s0,.1,0,.2h.4c-.2.1-.1.4-.3.5s-.2.2-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,536.7l-.5-.3s0-.1,0-.1h.1l.4.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.3,537.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.4,537.1h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361,536.4c0-.1,0-.2,0-.2V536c.1,0,.1-.1.2,0h-.2s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2.1.3-.2.5-.2s.1.2.1.3h.4l-.4.4s-.1.1,0,.1h-.4l-.2.2c.1.1.2-.1.3-.1a.1.1,0,0,1,0,.1c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,536.2c.1,0,0,0,0,.1S362.6,536.2,362.6,536.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.5,535.9h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,536.1c-.1-.1,0-.3-.1-.4s.1-.2.2-.2h-.1s0,0,0,.1h0s-.1.1,0,.1h-.1c.1,0,0,.1,0,.1h0a.3.3,0,0,0,0,.3s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h.1s0,0,0,0h0c.1-.1,0-.2,0-.3s0,.1,0,.1a.5.5,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 535.9 360.5 535.9 360.5 535.9 360.5 535.9 360.5 535.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,536.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,536h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,536h0S357.8,536,357.8,536Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,536h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.9 535.9 357.9 535.9 357.9 535.9 357.9 535.9 357.9 535.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.9,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358,535.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.7 535.9 357.7 535.9 357.7 535.9 357.7 535.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.9 536 356.9 536 356.9 536 356.9 536"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,535.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.7,535.6a.3.3,0,0,1,.2-.3v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.1,535.7c0-.1.1-.2.2-.3h.1l.2.2a.1.1,0,0,1,0,.2h-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,535.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.7h0c0-.1.1-.2,0-.2h0s0-.1,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.5,535.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358 535.7 357.9 535.7 358 535.7 358 535.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356.9 535.8 356.9 535.8 356.9 535.8 356.9 535.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,535.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.3,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.4,535.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.2 535.6 358.2 535.6 358.2 535.6 358.2 535.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359.1 535.5 359.1 535.5 359.1 535.5 359.1 535.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.3 535.6 358.3 535.6 358.2 535.6 358.3 535.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "359 535.5 359 535.5 359 535.5 359 535.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,535.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,535.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.1,534.4c0-.1,0-.1,0-.2h.4c0,.1,0,.2,0,.2S362.2,534.5,362.1,534.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,534.6c0-.1,0-.1,0-.2h.3a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "357.7",
      "y": "537.6",
      "width": "4.3",
      "height": "8.48",
      "transform": "translate(-250.5 766.8) rotate(-76.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.2,540.7c0,.1.2.1.1.2s0,.3,0,.5,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.3s0-.2-.1-.2l-.2.2h-.1l-.2.2s0,.1,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1.1-.2,0-.2h-.1c0,.1,0,.1,0,.2h-.1c0-.1.1-.3,0-.4h-.5l.3-.3h-.3l.3-.2a.9.9,0,0,0,0-.4h.3c0-.1-.1,0-.2,0l.6-.4A.7.7,0,0,1,364.2,540.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 540.9 364.2 540.9 364.2 540.9 364.2 540.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,540.6v.2h-.2c0-.1,0-.1.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364 541.2 364.1 541.1 364 541.1 364 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 541.2 364.2 541.2 364.2 541.2 364.2 541.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 541.3 364.1 541.3 364.1 541.3 364.1 541.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.1 541.3 364.1 541.3 364.1 541.3 364.1 541.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 541.4 364.2 541.4 364.2 541.4 364.2 541.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364 541.4 364 541.4 364 541.4 364 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,540.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.2 541.4 364.2 541.4 364.2 541.4 364.2 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.1,541s0,0,0,0h0S362.1,541,362.1,541Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362,540.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.2,541h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,541.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.1,541.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.9 541.3 363 541.3 363 541.3 362.9 541.3 362.9 541.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,541.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,540.4c0,.1,0,.2,0,.2h-.2l-.3.3s.1-.1,0-.2h-.4c.2,0,.2-.4.4-.4s.2-.2.4-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,540.7l.4.4s0,.1,0,.1h-.1l-.3-.4s-.1-.1,0-.1S357.4,540.7,357.4,540.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,541.9h0S362.4,541.9,362.4,541.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,541.7c0,.1-.1.1-.1.2h-.2c-.1-.1-.2.1-.2-.1H359c.1.1.1.2.2.2h0c0,.1.1.1.1.1h-.1c0,.1.1,0,.1.1H359a.1.1,0,0,0,0,.2h-.1s-.1.1-.1.1h-.1c0,.1-.1,0-.1.1h0c-.2-.1-.3.1-.5,0s-.1-.2,0-.3H358s0-.1,0-.2h-.2l.5-.3s.1-.1.1-.1v-.2c-.1-.1,0-.1,0-.1h.2v.2h.6c-.1-.1-.2,0-.3,0a.1.1,0,0,1,0-.1c.1,0,.2,0,.2-.1s-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,541.4c-.1,0,0,0,0-.1S358,541.4,357.9,541.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.9,542.3h-.2a.1.1,0,0,1,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.9,542.3s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543c.1.1,0,.3-.1.4l-.3.2h.1s.1,0,0-.1h.1c-.1-.1.1,0,0-.1h0a.3.3,0,0,0,.1-.3h0c0-.1-.1,0-.1-.1h-.2c-.1.1,0,.2-.1.2s.1-.1,0-.1a.5.5,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.8 542.4 359.9 542.4 359.9 542.4 359.8 542.4 359.8 542.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.5,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543.1h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.4,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.4 543.2 362.4 543.2 362.4 543.2 362.4 543.2 362.4 543.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.4,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.3,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.6 543.3 362.6 543.3 362.6 543.3 362.6 543.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.4 543.5 363.4 543.5 363.4 543.5 363.4 543.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.6,542.9a.3.3,0,0,1-.2.2.3.3,0,0,1,0-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.1,543.3c0,.2-.2.2-.3.3h-.1a.3.3,0,0,0-.1-.2h.3A.1.1,0,0,1,362.1,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.9,543.3h0c0,.1-.1.2,0,.2h-.1s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,543.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.3 543.4 362.3 543.4 362.3 543.4 362.3 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.3 543.7 363.3 543.6 363.3 543.7 363.3 543.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.9,543.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.4,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.8,543.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362 543.4 362 543.4 362 543.4 362 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.1 543.2 361.1 543.2 361.1 543.2 361.1 543.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.9 543.4 361.9 543.4 362 543.4 361.9 543.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "361.2 543.2 361.2 543.2 361.2 543.2 361.2 543.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,544h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,543.3c0,.1,0,.1-.1.2h-.4c0-.1,0-.2.1-.2S357.8,543.2,357.9,543.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,543.9c0,.1-.1.1-.1.2h-.2v-.2A.1.1,0,0,1,360.4,543.9Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "354.3",
      "y": "540.8",
      "width": "3.3",
      "height": "6.41",
      "transform": "translate(-230.1 262.6) rotate(-31.2)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353,542.4s0-.2,0-.2.2-.2.2-.3h.2s0,.1,0,.1h.2c0,.1-.1.1-.1.2h1l-.2.2h0l.3.2h-.4l-.2.2c0,.1.1.1.1.2h-.2s0,0,0,0h-.2c0,.1.1.1.1.1h-.5C353.2,542.6,353,542.5,353,542.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.2 542.2 353.2 542.2 353.2 542.2 353.2 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,543.8h.1C354.4,544,354.3,543.9,354.4,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.3 542.2 353.3 542.2 353.3 542.2 353.3 542.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.3 542.1 353.3 542.1 353.3 542.1 353.3 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 542.1 353.4 542.1 353.4 542.1 353.4 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 542 353.4 542.1 353.4 542 353.4 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 542 353.4 542 353.4 542 353.4 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.5 542.1 353.5 542.1 353.5 542.1 353.5 542.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,543.4v-.2h.1v.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.4 541.9 353.4 541.9 353.4 541.9 353.4 541.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,542.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.6,541.9h0S353.5,541.9,353.6,541.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354 542.7 354 542.7 354 542.7 354 542.7 354 542.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354,542.6h0S354,542.6,354,542.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,546.6h.5c0,.1,0,.1.1.1h.1c-.2-.1-.3.1-.5,0s-.2,0-.2-.2S356.8,546.6,356.9,546.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.3,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.4,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.5,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.6,546a1,1,0,0,1,0-.4h.1a2.5,2.5,0,0,0-.1.4s0,.1-.1.1S356.6,546,356.6,546Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.6,542.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356,544.3h.3c0,.1.1,0,.1.1h.1c0-.1.1-.1,0-.2h0s0-.1,0-.1h.1s0-.1,0-.1h.4c0,.2.2.1.3.3h-.2c0,.1,0,.1,0,.1h0l-.4-.2h-.1a.2.2,0,0,0,0,.2h-.1c-.1,0,0-.1,0-.1s0-.1,0-.2v-.2h-.2c0,.1.1.1.1.2h-.3l-.2-.2A.4.4,0,0,1,356,544.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.2,543.8h0A.1.1,0,0,1,356.2,543.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.2,543.8h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,541.9l.3-.2h-.2c-.1,0,0,.1,0,.1h.1s0,0,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 543.8 356.2 543.8 356.2 543.8 356.2 543.8 356.2 543.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,541.9h0S355.2,541.9,355.2,541.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.3,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,541.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.3 542 355.3 542 355.3 541.9 355.3 541.9 355.3 542"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.4,542h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.4,542h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.3 541.9 355.3 541.9 355.3 541.8 355.3 541.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355 541.3 355 541.3 354.9 541.3 355 541.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.3,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,543.1h0S356.1,543.1,356.1,543.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.6,542.1h.3v.2h-.2A.1.1,0,0,1,355.6,542.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,541.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.6,542.2h.1s0-.1,0-.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.5 542 355.5 541.9 355.5 541.9 355.5 542"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.1 541.2 355.1 541.3 355.1 541.2 355.1 541.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,542.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.6 542.1 355.6 542.1 355.6 542.1 355.6 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 542.7 356 542.7 356 542.7 356 542.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.7 542.1 355.7 542.1 355.7 542.1 355.7 542.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 542.6 356 542.6 356 542.6 356 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.5,541.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.3,541.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,544.4h.1C357.8,544.6,357.7,544.5,357.8,544.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,542.7h.1A.1.1,0,0,1,356.8,542.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "345",
      "y": "539.2",
      "width": "4.3",
      "height": "8.39",
      "transform": "translate(-241.4 807) rotate(-81.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,541.9c0,.1.2.1.2.2s.1.3.1.5,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2,0,.3s0-.2-.1-.2l-.2.2H351l-.2.2s0,.1,0,.1l-.2.2c0,.1,0,.1,0,.2h-.1c-.1-.1,0-.2,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.3,0-.4h-.5l.3-.3h-.3l.3-.2a.9.9,0,0,0-.1-.4h.2c0-.1-.1,0-.2,0l.6-.4A.7.7,0,0,1,351.3,541.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 542.2 351.3 542.1 351.3 542.1 351.3 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.7,542a.1.1,0,0,1-.1.2h-.2c0-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.2 542.4 351.2 542.4 351.2 542.4 351.2 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 542.4 351.4 542.4 351.4 542.4 351.4 542.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 542.5 351.3 542.5 351.3 542.5 351.3 542.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.3 542.6 351.3 542.5 351.3 542.5 351.3 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 542.6 351.4 542.6 351.4 542.6 351.4 542.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.2 542.6 351.2 542.6 351.2 542.6 351.2 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,542.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 542.7 351.4 542.6 351.4 542.6 351.4 542.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,542.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,542.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,542.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,542.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350.2 542.6 350.2 542.6 350.2 542.6 350.1 542.6 350.2 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.3,542.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.9,542.3c0,.1,0,.2,0,.2h-.2l-.2.3s0-.1,0-.2H343c.2-.1.2-.4.4-.5s.2-.2.4-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,542.5l.4.4s0,.1,0,.1h-.1l-.3-.4s-.1-.1,0-.1S344.6,542.4,344.7,542.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,543.3c0,.1-.1.2-.1.2h-.2c-.1-.1-.2.1-.2,0h-.1l.2.2h0c0,.1.1.1.1.1h-.1a.1.1,0,0,0,0,.2h-.1s-.1.1-.1.1h-.1c0,.1-.1.1-.1.1h0c-.2-.1-.3.1-.5.1s-.1-.2,0-.3h-.2s0-.1,0-.1h-.2l.5-.3s.1-.1.1-.1h-.2c-.1,0,0-.1,0-.1h.2v.2h.5c-.1-.1-.2.1-.3,0a.1.1,0,0,1,0-.1c.1,0,.2,0,.2-.1s-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,543.2c-.1,0,0,0,0-.1S345.3,543.2,345.2,543.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,543.9h-.2a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.2,543.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,544.4c.1.1,0,.3,0,.4s-.2.1-.3.2h.1s.1,0,0-.1h.1c-.1-.1,0,0,0-.1h0a.3.3,0,0,0,0-.3h0c0-.1-.1,0-.1-.1h0c-.1,0,0,.1-.1.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.2s.1-.1,0-.1a.5.5,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.2 543.9 347.2 543.9 347.2 544 347.2 544 347.2 543.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.9,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.5h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,544.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.8 544.5 349.8 544.5 349.8 544.6 349.8 544.6 349.8 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.7,544.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 544.6 349.9 544.6 350 544.6 349.9 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 544.7 350.8 544.7 350.8 544.7 350.7 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,544.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348,544.4a.3.3,0,0,1-.2.2.3.3,0,0,1-.1-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,544.7c0,.2-.1.2-.2.3h-.1a.3.3,0,0,0-.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,544.7h0c0,.1-.1.2,0,.2h0s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 544.8 349.7 544.7 349.7 544.8 349.6 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.7 544.9 350.7 544.9 350.7 544.9 350.7 544.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.3,544.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.8,544.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.4,544.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,544.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.4 544.8 349.4 544.7 349.4 544.7 349.4 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.5 544.6 348.5 544.6 348.5 544.6 348.5 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.3 544.8 349.3 544.8 349.4 544.8 349.3 544.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.6 544.7 348.6 544.6 348.6 544.7 348.6 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,544.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.7,545.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.3,545c0,.1,0,.1,0,.2h-.4c0-.1,0-.2.1-.2S345.3,544.9,345.3,545Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,545.4c0,.1,0,.1-.1.2h-.2v-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "342.9",
      "y": "544.1",
      "width": "4.2",
      "height": "8.28",
      "transform": "translate(-55.5 39.1) rotate(-6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M342.6,544.7c0-.1,0-.2.2-.2s.3-.1.4-.2h.2s-.1.1,0,.1.2-.1.3,0-.2.1-.2.2h.2s0-.1,0-.1h.1a.4.4,0,0,1,0,.2h.8s0,0,0,0-.3,0-.4.1,0,0,0,.1h-.1c0,.2.2.2.2.4l-.4-.2c.1,0,.1.2.1.2l-.3-.2-.4.2c0,.1.1.2,0,.2s0-.1,0-.2h-.4c-.1.1.1.1,0,.2l-.5-.4A.7.7,0,0,1,342.6,544.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "342.8 544.6 342.8 544.6 342.8 544.6 342.8 544.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.3,547.2h.2a.2.2,0,0,1,0,.2h-.1A.2.2,0,0,1,343.3,547.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343 544.7 343 544.7 343 544.7 343 544.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343 544.5 343 544.6 343 544.5 343 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.1 544.6 343.1 544.6 343.1 544.6 343.1 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.6 343.2 544.6 343.2 544.6 343.2 544.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.5 343.2 544.5 343.2 544.5 343.2 544.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.7 343.2 544.7 343.2 544.7 343.2 544.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M343.5,546.7a.9.9,0,0,1,0-.3h.1c0,.1,0,.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.2 544.4 343.2 544.4 343.2 544.4 343.2 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,546.6h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,546.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,546.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.5,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.4,544.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "343.5 545.7 343.5 545.6 343.5 545.6 343.5 545.7 343.5 545.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M343.6,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,551.7h.2c0,.1.1.1.1.1h.2c-.1.1,0,.2,0,.2s.1.1.1.2-.4-.1-.5-.3-.2-.2-.2-.3S344.7,551.8,344.7,551.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.1,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M344.1,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.1,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.7,550.9l.3-.5h.1s0,.1,0,.1l-.3.4h-.1C344.6,551,344.7,551,344.7,550.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345,548.7h.4c0,.1.1.1,0,.2h.1c0-.1.2-.1.1-.2h.4s0,.1,0,.1h.3s0,.1,0,.1h.1c-.1.2.2.3.2.5h-.3c-.1.1,0,.1,0,.2h-.1c.1.1,0,.1,0,.2l-.4-.4h-.1v.2h-.1c0-.1.1-.1,0-.2v-.2c0-.1-.1-.2-.1-.3l-.2-.2c-.1.1.1.2.1.3h-.1c-.1,0-.1-.2-.2-.1H345a.3.3,0,0,1-.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.4,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,548.2h0S345.4,548.2,345.5,548.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.2,545.4h.4c0,.1.2.1.2.2h-.3s0,0,0,0h-.2s0-.1,0-.1h-.1C345.2,545.5,345.2,545.4,345.2,545.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.5 548.2 345.5 548.1 345.5 548.1 345.5 548.2 345.5 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.3,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.3,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.3,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.4,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.4,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.4,545.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.4 545.5 345.4 545.5 345.5 545.5 345.5 545.5 345.4 545.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,545.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.5,545.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.5 545.4 345.4 545.4 345.5 545.3 345.5 545.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.4 544.6 345.4 544.6 345.4 544.5 345.4 544.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,545.5s0,0,0,0S345.5,545.5,345.5,545.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,547.3l.3.2h-.3C345.7,547.4,345.7,547.3,345.8,547.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,545.8c.1,0,.2.1.3.2s0,.1,0,.1l-.2.2h-.2c-.1-.1,0-.1-.1-.2A.1.1,0,0,1,345.7,545.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.6,545.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,546h.2s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.7 545.6 345.7 545.6 345.7 545.6 345.7 545.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.6 544.5 345.6 544.5 345.6 544.5 345.6 544.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,546h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.9,547.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.7,545.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M345.8,546.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 545.9 345.7 545.9 345.7 545.9 345.8 545.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 546.7 345.8 546.7 345.8 546.7 345.9 546.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.8 545.9 345.8 545.9 345.8 545.9 345.8 545.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "345.9 546.7 345.9 546.7 345.9 546.7 345.9 546.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.7,545.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.9,544.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,549.7h.2c.1.1.2.2.1.3H347C346.9,549.9,346.9,549.8,347,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.8,547.2h.2a.2.2,0,0,1,.1.2h-.2A.1.1,0,0,1,346.8,547.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347.7",
      "y": "552.2",
      "width": "7.6",
      "height": "3.89",
      "transform": "translate(-290.1 691.9) rotate(-69.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.1,558.1h-.2c-.2.1-.3,0-.4,0h-.2s.1,0,.1-.1h-.1v-.2s0,.1,0,.1h0l-.2-.2h-.1c-.1,0,0-.2-.1-.2h-.2s0,0,0,0h.4s0-.1,0-.1h.1c.1-.1-.1-.3-.1-.4l.2.3c-.1-.1,0-.2,0-.3v.3h.4s0-.2.1-.2-.1.1-.1.2h.1s0,.1.1.1h.1c.1,0,0-.1,0-.2s.2.4.3.6S352.3,558,352.1,558.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 558.1 351.9 558.1 351.9 558.1 351.9 558.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,555.8h-.1v-.2h.1A.1.1,0,0,1,352.5,555.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.7 558 351.8 558 351.7 558 351.7 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.7 558.1 351.7 558.1 351.7 558.1 351.7 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.6 558 351.6 558 351.6 558 351.6 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.6 558 351.6 558 351.6 558 351.6 558"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 558.1 351.5 558.1 351.5 558.1 351.5 558.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.5 557.9 351.6 557.9 351.5 557.9 351.5 557.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,556.1v.3h0v-.3S352.2,556.1,352.2,556.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.4 558.1 351.5 558.1 351.5 558.1 351.4 558.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,556.2h0s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.7,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.3,557.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.7 557 351.7 557 351.7 557 351.7 557 351.7 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.6,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,551.5H353c0-.1,0-.1,0-.2l-.2-.3h.2c.1,0,.1-.1.1-.2s-.1-.1,0-.2.3.2.3.4.1.2,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.2,556.8s0,0,0,0S351.2,556.8,351.2,556.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.8,552.1l-.4.3h0l.4-.2h.1C353,552.1,352.9,552.1,352.8,552.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,553.9h-.2v-.2c.1,0,0-.1.1-.2s0-.1,0-.1h-.8c.1-.2-.1-.3,0-.4h.3c.1,0,.1-.1.1-.1h.1c0-.1.1-.1,0-.2s.2.3.2.5h.1c-.1.1,0,.2,0,.3v.2c.1,0,0-.2.1-.2h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.2,552.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.1,554.2H351a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.1,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.2,556.5h-.3c0-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1H350a.4.4,0,0,1,.3.3C350.3,556.4,350.2,556.5,350.2,556.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.1 554.1 351.1 554.1 351.1 554.1 351.1 554.1 351.1 554.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.2,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.1,556.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,556.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.1 556.3 350.1 556.3 350 556.3 350 556.3 350.1 556.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,556.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,556.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350 556.4 350 556.4 350 556.4 350 556.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.7 557.1 349.7 557.1 349.7 557.1 349.7 557.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,554.7a.2.2,0,0,1-.2-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350,556c-.1,0-.1-.2-.2-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.9,556.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,555.8s0,0,0,0h-.1s0,0,0,0h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.1,555.7s0,0,0,0S350.1,555.7,350.1,555.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.9 556.1 349.9 556.2 349.9 556.1 349.9 556.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 557.1 349.6 557.1 349.6 557.1 349.6 557.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350.5,554.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M350,555.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.9 555.9 350 555.9 350 555.9 349.9 555.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.2 555.1 350.2 555.1 350.2 555.1 350.2 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "350 555.9 350 555.9 350 555.9 350 555.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "350.2 555.2 350.2 555.2 350.2 555.2 350.2 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,556.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.3,557h0S349.3,557,349.3,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.5,552.2h-.2c0-.1-.1-.2,0-.3h.3C350.6,552,350.6,552.2,350.5,552.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.6,554.4h-.1a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,349.6,554.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "343.5",
      "y": "559.6",
      "width": "6.6",
      "height": "3.35",
      "transform": "translate(-242.1 263.9) rotate(-31.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.5,558.3h.2c.2,0,.2.2.3.3s0,.1,0,.1h0c0,.1.1.1.1.2H349a.4.4,0,0,0,0,.2h.1s0,0,0,.1H349a.2.2,0,0,0,0,.2h0c0,.1-.1.1,0,.2h0c-.1-.1-.1-.2-.2-.3h-.1c-.1.1-.1.2-.2.3a.9.9,0,0,0,0-.3v-.1l-.2-.2h0s.1-.1,0-.1h0s.1-.1,0-.1H348c.1-.2,0-.4.1-.5S348.3,558.3,348.5,558.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.6 558.4 348.6 558.4 348.6 558.4 348.6 558.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,559.6a.1.1,0,0,1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.7 558.6 348.7 558.6 348.7 558.6 348.7 558.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.5 348.8 558.5 348.8 558.5 348.8 558.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.6 348.8 558.6 348.8 558.6 348.8 558.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.7 348.8 558.6 348.8 558.6 348.8 558.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 558.7 348.9 558.6 348.9 558.7 348.9 558.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 558.7 348.8 558.7 348.8 558.7 348.8 558.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,559.6h.2s0,0,0,.1h-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.9 558.7 348.9 558.6 348.9 558.6 348.9 558.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.3,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,558.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.2 559.3 348.2 559.3 348.2 559.3 348.2 559.3 348.2 559.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.3,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.2,562.2h.1c-.1,0,0,.1-.1.1a1.1,1.1,0,0,0,0,.3h-.2v.2c.1-.2-.1-.3,0-.5s0-.2.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.8s0,0,0,.1S348.1,559.8,348.2,559.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.4,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M344.8,561.9h.4s.1,0,0,.1h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.1,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,561.3v.2a.3.3,0,0,1,0,.2h-.1s-.1.1,0,.1h.2s0,0,0,0h.1s0,.1,0,.1h0s0,.1,0,.1h-.1s0,.1,0,.1h-.1c-.2,0-.1.2-.3.3v-.2H346c.1-.1.1-.3.2-.4s0-.1,0-.1h0l.2-.2v-.2c-.1,0-.1.1-.2.1h0c0-.1.1-.1,0-.2h-.1a.3.3,0,0,1,.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.5,562.1c-.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.1,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,561.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,560.4c.1,0,.1.2.2.3s0,.2-.1.2h0s0-.1,0,0h0v-.2s0,0,0,.1h0s.1,0,0,.1h0s0,.1,0,.1h0c0,.1.1.1.1.2h-.1a.4.4,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "347.1 561.5 347.1 561.5 347.1 561.6 347.1 561.6 347.1 561.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.8,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.9 560.6 348.9 560.6 348.9 560.6 348.9 560.6 348.9 560.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,560.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.9,560.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349 560.6 349 560.6 349 560.6 349 560.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.6 560.3 349.6 560.2 349.6 560.2 349.6 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.9,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.8,561.4a.2.2,0,0,1,0,.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.8,560.9c.1.1,0,.2,0,.3h-.2a.1.1,0,0,1,0-.1c0-.1.1,0,.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.1,560.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.7,560.9h0s0,.2.1.1h0s0,0,0,.1h-.1s0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.6,561h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.9 560.8 348.9 560.8 348.9 560.8 348.9 560.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "349.7 560.4 349.6 560.4 349.7 560.4 349.7 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.7,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.6,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.7,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.6,561h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 560.9 348.8 560.9 348.8 560.9 348.8 560.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.2 561.3 348.2 561.3 348.2 561.3 348.2 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348.8 561 348.8 561 348.8 560.9 348.8 561"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.2 561.3 348.2 561.3 348.2 561.3 348.2 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.8,560.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M346.5,563.1h.1c0,.1-.1.2-.1.2h-.1s-.1-.1-.1-.2S346.4,563.1,346.5,563.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M348.2,562.1c.1,0,0,.1,0,.1h-.2a.1.1,0,0,1,0-.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "350.6",
      "y": "560",
      "width": "6.5",
      "height": "3.35",
      "transform": "translate(-250.2 286.5) rotate(-33.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.3,564.7h-.2c-.2,0-.2-.2-.3-.2s0-.1,0-.1h0c0-.1-.1-.1-.2-.2h.2a.4.4,0,0,0,0-.2h-.1s0,0,0-.1h.1a.2.2,0,0,0,0-.2h0c0-.1.1-.1,0-.2h.1s0,0,0-.1h-.1c.1.1.1.2.2.2h.1c.1-.1.1-.2.2-.3a.9.9,0,0,0,0,.3v.1l.2.2h0s-.1.1,0,.1h0s-.1.1,0,.1h.2c-.1.2,0,.4-.1.5S352.4,564.7,352.3,564.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 564.5 352.1 564.5 352.1 564.5 352.1 564.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.7,563.3a.1.1,0,0,1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.1 564.4 352.1 564.4 352.1 564.4 352.1 564.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 564.4 352 564.4 352 564.4 352 564.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 564.3 352 564.3 352 564.3 352 564.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 564.3 351.9 564.3 351.9 564.3 351.9 564.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.8 564.3 351.9 564.3 351.9 564.3 351.8 564.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352 564.2 352 564.2 352 564.2 352 564.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.3,563.3h-.2s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.8 564.3 351.8 564.3 351.8 564.3 351.8 564.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.2,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.3,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.2,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.5,563.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,564.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.6 563.7 352.6 563.7 352.6 563.7 352.6 563.6 352.6 563.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.4,563.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,560.6h-.1c.1,0,0-.1.1-.1a1.1,1.1,0,0,0,0-.3h.2v-.2c-.1.2.1.3,0,.5s0,.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.2,563.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563.1s0,0,0-.1S352.6,563.1,352.6,563.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.3,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,560.9h-.4s-.1,0,0-.1h.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,563h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,561.5v-.2a.3.3,0,0,1,0-.2h.1s.1-.1,0-.1H354s0,0,0,0h-.1s0-.1,0-.1h0s0-.1,0-.1h.1s0-.1,0-.1h.1c.2,0,.1-.2.3-.3l.2.2h.3c-.1.1-.1.3-.1.4s0,.1,0,.1h0l-.2.2v.2c.1,0,.1-.1.2-.1h0c0,.1-.1.1,0,.2h.1a.3.3,0,0,1-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,560.8c.1,0,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.6,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.6,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,562.6c-.1,0-.1-.2-.2-.2s0-.2.1-.2h0s0,.1,0,0h0v.2h0s-.1,0,0-.1h0s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.1a.4.4,0,0,1,.1.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.6 561.3 353.6 561.4 353.6 561.3 353.6 561.3 353.6 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.5s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 562.4 351.8 562.4 351.8 562.3 351.8 562.3 351.8 562.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,562.3s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.8,562.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.7 562.4 351.7 562.4 351.7 562.4 351.7 562.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.1 562.7 351.1 562.7 351.1 562.8 351.1 562.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.8,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.9,561.5a.2.2,0,0,1,0-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,562.1c-.1-.1,0-.2,0-.3h.3c0,.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,562h0s0-.1-.1-.1h0s0,0,0-.1h.1s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,562h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 562.2 351.8 562.2 351.7 562.2 351.8 562.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351 562.6 351.1 562.6 351.1 562.6 351 562.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M351.9,562h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.1,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 562 351.9 562 351.9 562 351.9 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.5 561.6 352.5 561.6 352.5 561.6 352.5 561.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "351.9 562 351.9 562 351.9 562 351.9 562"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.4 561.6 352.4 561.6 352.4 561.6 352.4 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.7,562.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M350.9,562.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.2,559.7h-.1c0-.1,0-.2.1-.2h.1s.1.1.1.2S354.3,559.8,354.2,559.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.4,560.8c-.1,0,0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "354.5",
      "y": "565.2",
      "width": "8.4",
      "height": "4.32",
      "transform": "translate(-107.5 84.5) rotate(-11.7)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.4,570.2c-.1,0-.2,0-.2-.1s-.2-.3-.2-.4,0-.1,0-.1h0c.1-.1-.1-.2-.1-.3s.1.2.2.2V569h.1a.3.3,0,0,0,.1-.2h0c0-.1.1-.1.1-.3s-.1-.1-.1-.2h.1c.1.1,0,.2.1.2h0c-.1-.1,0-.1-.1-.2h0c.1.1,0,.3.2.4h.1c.2,0,.2-.2.3-.3a1.2,1.2,0,0,0-.2.4l.2-.2-.2.3.2.4h0s-.1.1-.1.1h0c.1.1.1-.1.2,0l-.4.6A.7.7,0,0,1,355.4,570.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.3 570 355.3 570 355.3 570 355.3 570"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.8,569.2a.1.1,0,0,1,0-.2h.2c.1,0,0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.3 569.7 355.3 569.8 355.3 569.7 355.3 569.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.8 355.2 569.8 355.2 569.8 355.2 569.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.6 355.2 569.6 355.2 569.6 355.2 569.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.6 355.2 569.6 355.2 569.6 355.2 569.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 569.5 355.1 569.6 355.1 569.6 355.1 569.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.2 569.5 355.3 569.5 355.3 569.5 355.2 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,569.1H357s0,0,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 569.5 355 569.6 355 569.5 355 569.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,569.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,569.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,569.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 569.1 356.2 569.1 356.2 569.1 356.2 569.1 356.2 569.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,569h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.3,567.3c-.1-.1-.1-.2-.1-.2h.1a1.4,1.4,0,0,0,.1-.4s0,.1.1.2h.4c-.2.1,0,.4-.2.6s-.1.3-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.5s0-.1,0-.1S356.5,568.5,356.5,568.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.1,568.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,567.3l-.5-.2s0-.1,0-.1h.1l.5.3s.1,0,.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.5,568.4h0a0,0,0,0,1,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.1,567.3c-.1-.1,0-.2,0-.2v-.2c.1,0,.1-.1.2,0h-.3s.1-.1,0-.1h0a.1.1,0,0,0,0-.2h.1s.1-.1,0-.1h.1c0-.1.1-.1,0-.2h.1c.2,0,.2-.2.4-.2s.1.2.1.3h.4c-.2.1-.2.4-.4.5s-.1.1,0,.1h-.4l-.2.2c.1.1.1-.1.3-.1h0c0,.1-.2.1-.1.2s.1.1,0,.1l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,566.9c.1,0,0,0,0,.1S360.7,566.9,360.7,566.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,566.9a.2.2,0,0,1,0-.1h.1a.1.1,0,0,1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.6,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567.4c-.1-.1-.1-.3-.1-.4s.1-.2.2-.3h0s0,0,0,.1h0s-.1.1,0,.1h-.1a.3.3,0,0,0,.1.3s0-.1,0-.1h.1s0-.1,0-.1,0,.1,0,.1h0s0-.1,0-.1h0c.1-.1-.1-.2,0-.3s0,.1,0,.1a.5.5,0,0,1-.1.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "358.6",
      "y": "566.8",
      "height": "0.02",
      "transform": "translate(-101.3 78.6) rotate(-11)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,567.4s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,567.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,567.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567.3h0S355.8,567.3,355.8,567.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,567.2h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.9 567.2 355.9 567.2 355.9 567.2 355.9 567.2 355.9 567.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.9,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356,567.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "355.8 567.2 355.7 567.2 355.7 567.2 355.8 567.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.9 567.3 354.9 567.4 354.9 567.4 354.9 567.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,567.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.7,566.7a.3.3,0,0,1,.1-.3v.2h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,566.9c-.1-.1.1-.2.1-.3h.1l.2.2a.1.1,0,0,1,0,.2c0,.1-.2,0-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,567h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,566.9h0c0-.1,0-.2,0-.2h0s0-.1,0-.1h.1s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.5,566.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "356 566.9 355.9 567 356 566.9 356 566.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "354.9 567.2 354.9 567.2 354.9 567.2 354.9 567.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.8,566.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.3,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.4,566.8s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.2 566.8 356.2 566.9 356.2 566.9 356.2 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.1 566.6 357.1 566.7 357.1 566.7 357.1 566.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "356.3 566.8 356.3 566.8 356.2 566.8 356.3 566.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357 566.6 357 566.7 357 566.6 357 566.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,566.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.8,566.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360,565.2c-.1-.1,0-.1,0-.2s.1-.2.3-.1h.1c0,.1.1.1,0,.2S360.1,565.3,360,565.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.4,565.7c0-.1,0-.1,0-.2h.3a.2.2,0,0,1,0,.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "356.1",
      "y": "554.9",
      "width": "8.4",
      "height": "4.29",
      "transform": "translate(-275.9 745) rotate(-73.6)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,561.3H361c-.2.1-.3,0-.5,0h-.2c0-.1.1,0,.1-.1s-.2,0-.3-.1h.2l-.2-.2s0,.1,0,.1h0v-.2l-.2-.2h-.1c-.1,0-.1-.2-.2-.2h-.2a.1.1,0,0,1,0-.1h0s0,0,0,0h.4s0-.1,0-.1h.1c.1-.2-.1-.3-.1-.4l.3.3c-.1-.1,0-.2,0-.3v.3h.4c.1-.1,0-.2.1-.2s-.1.1,0,.2v.2h0s0,.1.1.1h.1c.1,0,0-.1,0-.2s.3.4.3.6A.7.7,0,0,1,361.2,561.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.9 561.3 361 561.3 360.9 561.3 360.9 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.4,558.7h-.1v-.2h.1A.2.2,0,0,1,361.4,558.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 561.2 360.8 561.2 360.7 561.2 360.7 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 561.3 360.7 561.3 360.7 561.3 360.7 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.6 561.2 360.6 561.3 360.6 561.3 360.6 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 561.2 360.6 561.2 360.6 561.2 360.5 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 561.3 360.5 561.3 360.5 561.3 360.5 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.5 561.1 360.5 561.1 360.5 561.1 360.5 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.1,559.1v.3h0v-.3S361.1,559.1,361.1,559.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.4 561.3 360.4 561.3 360.4 561.3 360.4 561.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361,559.2h0c.1,0,0,0,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.6,560.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.3,561.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "360.7 560.1 360.7 560.1 360.6 560.1 360.6 560.1 360.7 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.5,560.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.9,553.9h-.2c0-.1-.1-.1,0-.2l-.3-.3h.2c.1,0,.1-.1.1-.2s-.1-.2,0-.2.3.2.4.4.2.3.1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.1,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M360.1,560s0,0,0,0S360.1,559.9,360.1,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,554.7l-.5.3h0l.4-.3h.1C361.7,554.6,361.6,554.7,361.5,554.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.2,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.1,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.1,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,556.7h-.2v-.2c.1-.1-.1-.2.1-.2s0-.1-.1-.1l-.2.2h-.7c.1-.2-.1-.3,0-.5h.3c.1,0,.1-.1.1-.2h.1c0-.1.1-.1,0-.2s.2.3.2.6h.4c0,.1-.1.1-.1.2h-.2c-.1.1,0,.2,0,.3v.3c.1,0,0-.2.1-.3h.1c0,.1,0,.2.1.2h.1a.3.3,0,0,1,0,.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.8,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.8,557.1h-.1a.1.1,0,0,1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.8,557h0S359.8,557,359.8,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,559.7h-.4c0-.1-.1-.2-.1-.3h.1s0,.1,0,.1h.1s0,0,0,0h.2s0-.1,0-.1h-.2a.5.5,0,0,1,.3.3C359,559.6,359,559.6,358.9,559.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "359.7 557 359.7 557 359.7 557 359.7 557 359.7 557"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.9,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.8,559.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 559.5 358.8 559.5 358.8 559.5 358.8 559.5 358.8 559.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,559.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.7 559.6 358.7 559.6 358.7 559.6 358.7 559.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.5 560.4 358.5 560.4 358.5 560.4 358.5 560.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,557.7a.3.3,0,0,1-.2-.2h.3C359.3,557.6,359.3,557.7,359.2,557.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.7,559.1c-.2,0-.2-.2-.2-.3h.4c.1.1-.1.1,0,.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,559.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.8,558.9s0,0,0,0h-.2s0,0,0-.1h.2s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.8s0,0,0,0S358.7,558.8,358.7,558.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.6 559.3 358.6 559.3 358.6 559.3 358.6 559.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.3 560.3 358.3 560.3 358.3 560.3 358.3 560.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,559h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M359.1,557.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,559h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M358.7,558.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.6 559 358.6 559 358.6 559 358.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.9 558.2 358.9 558.2 358.9 558.2 358.9 558.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "358.6 559 358.6 559 358.6 559 358.6 559"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "358.8 558.2 358.9 558.2 358.8 558.2 358.8 558.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.5,559.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.9,560.3h0S357.9,560.3,357.9,560.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.9,554.9h-.2c0-.1-.1-.2,0-.3h.3C359.1,554.7,359.1,554.9,358.9,554.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.2,557.4H358a.2.2,0,0,1,0-.2h.2A.1.1,0,0,1,358.2,557.4Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "365.6",
      "y": "559.2",
      "width": "7.6",
      "height": "3.89",
      "transform": "translate(-301.9 536) rotate(-54.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,565.1h-.2c-.2,0-.3-.1-.4-.1s-.1-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2v-.2H368s0,0,0-.1h.1v-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0-.1,0-.1h-.1l.4.2h.1c.1-.1,0-.3.1-.4a1.1,1.1,0,0,0,.1.4c0-.1,0-.2,0-.3a.9.9,0,0,1,0,.3h.4c.1,0,.1-.2.1-.1v.2s0,.1,0,.2h0s0,.1,0,.1h.1c.1,0,0-.1.1-.1s.1.4.1.6S369.1,565,369,565.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.8 565 368.8 565 368.8 565 368.8 565"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,562.9h.1C370.1,562.8,370,562.9,369.9,562.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.6 564.8 368.6 564.8 368.6 564.8 368.6 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.6 564.9 368.6 564.9 368.6 564.9 368.6 564.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.5 564.8 368.5 564.8 368.5 564.8 368.5 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 564.8 368.5 564.8 368.5 564.8 368.4 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.4 564.8 368.4 564.9 368.4 564.9 368.4 564.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.5 564.7 368.5 564.7 368.5 564.7 368.5 564.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.5,563.2l-.2.2h0l.2-.2S369.6,563.2,369.5,563.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 564.9 368.3 564.9 368.3 564.9 368.3 564.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.5,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.5,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.4,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.8,564h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,564.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.9 563.9 368.9 563.9 368.9 563.9 368.9 563.8 368.9 563.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,563.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.8,558.9h-.2c.1-.1,0-.1,0-.2l-.2-.3h.1c.1,0,.1-.1.1-.2s0-.2,0-.2.2.3.2.5.1.3-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,563.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.4,563.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,563.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,559.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.7,560.9h-.2a.3.3,0,0,1,0-.2c.1,0,0-.2.1-.1s0-.1,0-.1h-.5s0-.1,0-.1h-.2c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.5c0-.1.1-.1.1-.2s.1.4,0,.5,0,.1.1.1h0v.2a.8.8,0,0,0,0,.3c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.5,559.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,561H369s0-.1,0-.1h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,563c-.1,0-.2-.1-.3-.2s0-.2,0-.3h.3s0-.1,0-.1h0l-.2-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369 560.9 369 560.9 369 560.9 369 560.9 369 560.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.8s0,0,0,0S367.6,562.8,367.6,562.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,562.9s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.5 562.8 367.5 562.8 367.4 562.8 367.4 562.8 367.5 562.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 562.9 367.4 562.9 367.3 562.9 367.4 562.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.9 563.5 366.9 563.5 366.9 563.5 366.9 563.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,562.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.3,561.4a.2.2,0,0,1-.1-.3h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,562.5c-.1-.1-.1-.2-.1-.3h.4c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.4,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.3,562.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.3h-.1s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.4 562.6 367.4 562.6 367.4 562.6 367.4 562.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "366.8 563.4 366.8 563.4 366.8 563.4 366.8 563.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.5,562.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367.6,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.5 562.3 367.5 562.4 367.5 562.4 367.5 562.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 561.7 367.9 561.7 367.9 561.7 367.9 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "367.5 562.3 367.5 562.3 367.5 562.3 367.5 562.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.9 561.7 367.9 561.7 367.9 561.7 367.9 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.3,562.6h0S367.3,562.6,367.3,562.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.5,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,558.9h-.1c0-.1,0-.2.1-.3h.2C369.1,558.8,369.1,559,368.9,558.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.5,560.8h-.1a.2.2,0,0,1,.1-.2h.2C367.7,560.8,367.6,560.9,367.5,560.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "369.4",
      "y": "552",
      "width": "4.4",
      "height": "8.66",
      "transform": "translate(-220.6 867.5) rotate(-84)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.8,554.6c0,.1.2.1.2.2s.1.3.1.5,0,.1,0,.1,0,.1,0,.1H376c-.1.1,0,.2,0,.3s0-.2-.1-.2l-.2.2h-.1l-.2.2s0,.1,0,.1-.2.1-.2.2,0,.1,0,.2h-.1c-.1-.1,0-.2-.1-.2H375c0,.1,0,.1,0,.2H375c0-.1.1-.3,0-.4h-.1c-.2,0-.3.1-.4.2l.3-.3h-.3l.3-.2a1,1,0,0,0-.1-.4h.1s.1,0,.1-.1h0c0-.1-.1,0-.2,0l.6-.5A.7.7,0,0,1,375.8,554.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 554.8 375.8 554.8 375.8 554.8 375.8 554.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.1,554.8a.1.1,0,0,1-.1.2h-.2c0-.1,0-.1,0-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 555.1 375.8 555 375.7 555.1 375.7 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.9 555.1 375.9 555.1 375.9 555.1 375.9 555.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 555.2 375.8 555.2 375.8 555.2 375.8 555.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.8 555.3 375.8 555.2 375.8 555.2 375.8 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.9 555.3 375.9 555.3 375.9 555.3 375.9 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "375.7 555.3 375.7 555.3 375.7 555.3 375.7 555.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.6,555.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "376 555.4 376 555.3 376 555.3 376 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,555.1h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,555.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M375.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374.6 555.4 374.7 555.4 374.7 555.4 374.6 555.4 374.6 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.8,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,555.3c.1.1,0,.2,0,.2H368l-.2.3s0-.1,0-.2h-.4c.2-.1.2-.4.4-.5s.2-.2.4-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.7,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.6,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,555.5l.4.4s0,.1,0,.1h-.1l-.4-.4s-.1-.1-.1-.1S369,555.4,369,555.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.2,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.3,556.2c0,.1-.1.2,0,.2H371c-.1-.1-.2.1-.2,0h-.1l.2.2h-.1a.1.1,0,0,0,0,.2h-.1s-.1.1-.1.1h-.1c0,.1-.1.1-.1.1h-.1c-.2-.1-.3.1-.5.1s-.1-.2,0-.3h-.2s0-.1,0-.2h-.2l.5-.3s.1-.1.1-.1H370c-.1,0,0-.1,0-.1h.2v.2h.3l.2-.2c-.1-.1-.2.1-.3,0a.1.1,0,0,1,0-.1c.1,0,.2,0,.2-.2s-.1-.1,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.6,556.1c-.1,0,0,0,0-.1S369.6,556.1,369.6,556.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.7,556.8h-.2a.1.1,0,0,1,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.7,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.6,557.2c.1.1,0,.3,0,.4s-.2.2-.3.2h.1s.1,0,0-.1h.1c-.1-.1,0,0,0-.1h0a.3.3,0,0,0,0-.3h0c0-.1-.1,0-.1-.1h0c-.1,0,0,.1-.1.1s0-.1,0-.1h-.1s0,0,0,0h0c-.1.1,0,.2-.1.3s.1-.1,0-.2a.5.5,0,0,1,.2-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "371.7 556.9 371.7 556.9 371.7 556.9 371.6 556.9 371.7 556.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.5,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.4 557.4 374.4 557.4 374.4 557.4 374.4 557.4 374.4 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M374.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.5 557.4 374.5 557.4 374.5 557.4 374.5 557.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.4 557.5 375.4 557.5 375.4 557.5 375.4 557.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.5,557.3a.3.3,0,0,1-.2.2.4.4,0,0,1-.1-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.1,557.6c0,.2-.1.2-.2.3h-.1v-.2a.2.2,0,0,1,.1-.2h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.4,557.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.5,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,557.5h0c0,.1-.1.2,0,.2h0s0-.1,0-.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,557.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "374.2 557.6 374.3 557.6 374.2 557.6 374.2 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "375.3 557.7 375.3 557.7 375.3 557.7 375.3 557.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.8,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,557.6s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.3,557.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.9,557.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M373.7,557.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "374 557.6 373.9 557.6 374 557.6 374 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373 557.5 373 557.5 373.1 557.5 373 557.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "373.9 557.6 373.9 557.6 373.9 557.6 373.9 557.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "373.1 557.6 373.1 557.5 373.1 557.6 373.1 557.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M374.3,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M375.4,558.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,558.1c0,.1,0,.1,0,.2h-.4c0-.1,0-.2.1-.2S369.7,557.9,369.8,558.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.4,558.4c0,.1,0,.1-.1.2h-.3v-.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "367.5",
      "y": "548.4",
      "width": "6.9",
      "height": "3.51",
      "transform": "translate(-288.3 474.8) rotate(-49.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.2,553.7H370l-.4-.2c0-.1,0-.1-.1-.1h0c0-.1-.2-.1-.2-.2h.2V553h-.1s0,0,0-.1h.1a.3.3,0,0,0-.1-.2h-.1c-.1-.1,0-.2-.1-.2h.1s0,0,0-.1h-.1l.3.2h.1c.1-.1,0-.2.1-.3a.9.9,0,0,0,.1.3c0-.1,0-.2.1-.2a.8.8,0,0,1,0,.3h.3s0,.1,0,.1h0s0,.1,0,.1h.1s0,0,0,.1,0-.1.1-.1.1.4,0,.6S370.3,553.6,370.2,553.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370 553.6 370 553.6 370 553.6 370 553.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,551.8h.1C371.4,551.7,371.3,551.8,371.2,551.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.9 553.4 369.9 553.4 369.9 553.4 369.9 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 553.5 369.8 553.5 369.8 553.5 369.8 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 553.4 369.8 553.4 369.8 553.4 369.8 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 553.4 369.7 553.4 369.7 553.4 369.7 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 553.4 369.7 553.4 369.7 553.4 369.6 553.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.7 553.3 369.8 553.3 369.8 553.3 369.7 553.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.8,552l-.2.2h0l.2-.2S370.9,552,370.8,552Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.6 553.4 369.6 553.4 369.6 553.4 369.6 553.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.8,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.8,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.7,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.1,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.6,553.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 552.6 370.2 552.6 370.2 552.5 370.2 552.5 370.2 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370,552.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M373.2,548.4H373c.1,0,0-.1,0-.1v-.3h.2c0-.1,0-.1,0-.2s.2.3.2.5,0,.2-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.7,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,550H371a.3.3,0,0,1,0-.2c.1,0,0-.1.1-.1s0-.1,0-.1h-.2s0,0,0-.1h-.2s0-.1,0-.1h-.1c-.1,0,0-.1-.1-.1h.1c.2-.1,0-.3.2-.4h.5c0,.1,0,.3,0,.5s0,.1.1.1h0v.2a.7.7,0,0,0,0,.2c.1,0,0-.2.1-.2h.1c0,.1-.1.2,0,.2h.1a.3.3,0,0,1-.1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,548.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,550h.1a.1.1,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.6,550h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.7l-.3-.2c.1-.1,0-.2,0-.3h.3s0-.1,0-.1H369s0-.1,0-.1h0v-.2h.1a.4.4,0,0,1,.2.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.6 549.9 370.6 549.9 370.5 549.9 370.5 549.9 370.6 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.5s0,0,0,0S369.1,551.5,369.1,551.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369 551.5 369 551.5 369 551.5 369 551.5 369 551.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369,551.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.9 551.5 368.9 551.5 368.9 551.5 368.9 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.5 552 368.5 552 368.5 552.1 368.5 552"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.9,550.3a.2.2,0,0,1-.1-.2h.2a.2.2,0,0,1,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369,551.2c-.1-.1-.1-.2-.1-.3h.3c0,.1-.1.1-.1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.9 551.3 368.9 551.3 368.9 551.3 368.9 551.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.4 551.9 368.4 552 368.4 552 368.4 551.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.9,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,551h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369 551.1 369.1 551.1 369.1 551.1 369 551.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.5 550.5 369.5 550.5 369.5 550.5 369.5 550.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.1 551.1 369.1 551.1 369 551.1 369.1 551.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.5 550.5 369.5 550.6 369.5 550.6 369.5 550.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.9,551.3h0S368.9,551.3,368.9,551.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.1,551.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,548.1h-.1c0-.1,0-.2.1-.2h.2C370.8,548,370.8,548.2,370.6,548.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,549.7h.2C369.4,549.7,369.3,549.8,369.2,549.7Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "366.5",
      "y": "543.5",
      "width": "8.4",
      "height": "4.27",
      "transform": "translate(-248.3 773.7) rotate(-76)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.6,541.4h.2c.2-.1.3,0,.5,0h.2c0,.1-.1,0-.1.1s.2,0,.3.1h-.2l.2.2s0-.1,0-.1h0v.2l.2.2h.1c.1,0,.1.2.2.2h.2a.1.1,0,0,1,0,.1h0s0,0,0,0H371s0,.1,0,.1h-.1c-.1.2.1.3.1.4l-.3-.3c.1.1,0,.2.1.3l-.2-.3h-.4c0,.1,0,.2-.1.2s.1-.1,0-.2H370s0-.1-.1-.1h-.1c-.1,0,0,.1,0,.2s-.3-.4-.4-.6A.7.7,0,0,1,369.6,541.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.8 541.4 369.8 541.4 369.8 541.4 369.8 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.4,544h.1v.2h-.1A.2.2,0,0,1,369.4,544Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370 541.5 370 541.5 370 541.5 370 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 541.4 370 541.4 370.1 541.4 370.1 541.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 541.5 370.2 541.5 370.2 541.5 370.2 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 541.5 370.2 541.5 370.2 541.5 370.2 541.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 541.4 370.3 541.4 370.3 541.4 370.3 541.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 541.6 370.2 541.6 370.2 541.6 370.3 541.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.8,543.6v-.3h0c-.1.1-.1.2-.1.3S369.7,543.6,369.8,543.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 541.4 370.3 541.4 370.3 541.4 370.3 541.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,543.5h0c-.1,0,0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.8,543.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.9,543.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.2,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.5,541.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 542.6 370.2 542.6 370.2 542.6 370.2 542.6 370.2 542.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.3,542.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.2,548.8h.2c0,.1.1.1,0,.2l.3.3h-.2c-.1,0-.1.1-.1.2s.1.1.1.2-.3-.2-.4-.4-.2-.2-.1-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.7,542.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.7,542.7s0,0,0,0S370.7,542.7,370.7,542.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.6,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.5,548l.4-.3h0l-.4.3h-.1C369.4,548.1,369.5,548.1,369.5,548Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.7,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.5,546h.2v.2c-.1.1.1.2-.1.2s0,.1.1.1l.2-.2h.7s0,0,0,.1h0c-.1.2.1.3,0,.5h-.3c-.1,0-.1.1-.1.2h-.1c0,.1-.1.1,0,.2s-.2-.3-.2-.5h-.4c0-.1.1-.1.1-.2h.2c0-.1,0-.2,0-.3v-.3c-.1.1,0,.2,0,.3h-.1c0-.1,0-.2-.1-.2h-.1a.3.3,0,0,1,0-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.2,547.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.2,545.6h.1s0,.1,0,.1h-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.2,545.7h0S371.1,545.7,371.2,545.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.9,542.9h.4c0,.1.1.2.1.3h-.2s0-.1,0-.1h-.1s0,0,0,0H372s0,.1,0,.1h.2a.5.5,0,0,1-.4-.2C371.8,543.1,371.9,543,371.9,542.9Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "371.2",
      "y": "545.7",
      "height": "0.02",
      "transform": "translate(-247.1 776.4) rotate(-76.2)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.9,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372,543h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,543s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372 543.1 372 543.1 372.1 543.1 372.1 543.1 372 543.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 543 372.1 543 372.1 543 372.1 543"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.3 542.2 372.3 542.2 372.3 542.2 372.3 542.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M371.7,544.9a.3.3,0,0,1,.2.2h-.3C371.6,545,371.6,544.9,371.7,544.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,543.5c.2,0,.2.2.3.3H372c-.1-.1.1-.1,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,543.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.2,543.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.7s0,0,0,0h.2s0,0,0,.1h0s0,0,0,.1h-.2s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.8h0S372.1,543.8,372.1,543.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.2 543.3 372.2 543.3 372.2 543.3 372.2 543.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.5 542.3 372.5 542.3 372.5 542.3 372.5 542.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.1,543.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M371.8,545.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M372.2,543.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 543.6 372.2 543.6 372.2 543.6 372.2 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372 544.4 372 544.4 372 544.4 372 544.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "372.2 543.6 372.2 543.6 372.2 543.6 372.2 543.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "372.1 544.4 372 544.4 372 544.4 372.1 544.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.3,543.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.9,542.3h0S372.8,542.3,372.9,542.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.1,547.7h.2c0,.1.1.2,0,.3H372C371.9,547.9,371.9,547.7,372.1,547.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M372.8,545.2h.2a.2.2,0,0,1,0,.2h-.2A.1.1,0,0,1,372.8,545.2Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "365",
      "y": "544.8",
      "width": "3.5",
      "height": "6.89",
      "transform": "translate(-274.3 703.6) rotate(-69.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M370.3,547.7s.1.1.1.2,0,.3,0,.4,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.3s0-.2-.1-.2h-.4s0,0,0,.1h-.2v.2h-.1c0-.1.1-.1,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.2.1-.3h-.1a.1.1,0,0,0,0-.1h-.4l.3-.2h0a.8.8,0,0,0,0-.3h.1l.5-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 547.9 370.3 547.9 370.3 547.9 370.3 547.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.2,547.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 548.1 370.2 548 370.1 548.1 370.1 548.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 548.1 370.3 548.1 370.3 548.1 370.3 548.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 548.2 370.2 548.2 370.2 548.2 370.2 548.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 548.2 370.2 548.2 370.2 548.2 370.2 548.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.2 548.3 370.2 548.3 370.2 548.3 370.2 548.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.1 548.2 370.1 548.2 370.1 548.2 370.1 548.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,547.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "370.3 548.3 370.3 548.3 370.3 548.3 370.3 548.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,547.7s0,0,0,0h0S368.6,547.7,368.6,547.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.5,547.7h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,547.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.4,548.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M370.1,548.4h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "369.2 548.1 369.2 548.1 369.2 548.1 369.2 548.1 369.2 548.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.3,548.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.3,546.8c0,.1,0,.1,0,.2h-.1l-.2.2s.1-.1,0-.1h-.4c.2,0,.2-.3.4-.3h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.2,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M369.1,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,547.1l.2.4H365l-.2-.4s-.1-.1,0-.1S364.8,547,364.8,547.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,548.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,548.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,548.5h0S368.7,548.5,368.7,548.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.5,548.1v.2H366c0,.1,0,.2.1.2h0s0,.1,0,.1H366c0,.1.1,0,0,.1H366a.1.1,0,0,0-.1.1h-.3s0-.1,0-.1-.3.1-.4,0,0-.2,0-.2H365l.5-.2h0s0-.1,0-.1h.4a0,0,0,0,1,0-.1c.1,0,.2,0,.2-.1s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M365.2,547.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.7,548.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.7,548.6s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,549.5c0,.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0a.3.3,0,0,0,.1-.2h0c0-.1-.1,0,0-.1h-.2v.2s.1-.1,0-.1a.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.6 548.7 366.6 548.7 366.6 548.7 366.6 548.7 366.6 548.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.7,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.5h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,549.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.8,549.6h0S368.8,549.6,368.8,549.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.6 549.6 368.7 549.6 368.6 549.6 368.6 549.6 368.6 549.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.7 549.6 368.7 549.6 368.8 549.7 368.7 549.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.4 549.9 369.4 549.9 369.4 549.9 369.4 549.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,549.2H367a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.4,549.7c0,.1-.1.1-.2.2h-.1a.2.2,0,0,0-.1-.2h.3A.1.1,0,0,1,368.4,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.6,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.7,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,549.6h0s-.1.1-.1.1h-.1s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,549.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "368.5 549.7 368.5 549.7 368.5 549.7 368.5 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "369.3 550 369.3 550 369.3 550 369.3 550"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.2,549.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M367,549.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.3,549.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M368.1,549.6h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.3 549.7 368.3 549.7 368.3 549.7 368.3 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 549.4 367.6 549.4 367.6 549.4 367.6 549.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "368.2 549.7 368.2 549.7 368.3 549.7 368.2 549.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "367.6 549.5 367.6 549.5 367.6 549.5 367.6 549.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M368.5,549.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.3,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.9,549.2h-.3v-.2C364.8,549.1,364.9,549.1,364.9,549.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.9,550h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "360.7",
      "y": "546.1",
      "width": "3.9",
      "height": "7.67",
      "transform": "translate(-290.8 466.7) rotate(-49.3)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M366.6,550.8c0,.1.1.2,0,.2s-.1.3-.2.4h-.1s0-.1-.1-.1-.1.2-.2.2.1-.2,0-.2h-.8v.2h-.1c0-.1.1-.1.1-.2h-.1v.2h0c0-.1.2-.2.2-.3h0v-.3c0-.1-.2-.1-.1-.2h.3s0,0,0,0h.2c0-.1-.1,0-.1-.1h.6C366.3,550.5,366.5,550.6,366.6,550.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.5 551 366.5 551 366.5 551 366.5 551"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,549.6h-.2C364.4,549.4,364.5,549.5,364.5,549.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.1 366.3 551.1 366.3 551.1 366.3 551.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.4 551.2 366.4 551.2 366.4 551.2 366.4 551.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.2 366.3 551.2 366.3 551.2 366.3 551.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.3 366.3 551.3 366.3 551.3 366.3 551.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.4 366.3 551.3 366.3 551.4 366.3 551.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.2 551.3 366.2 551.2 366.2 551.2 366.2 551.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,550l.2.2h-.1l-.2-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "366.3 551.4 366.3 551.4 366.3 551.4 366.3 551.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.7,550.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.8,550.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.5,550.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M366.1,551.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "365.3 550.7 365.3 550.8 365.3 550.8 365.3 550.8 365.3 550.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.3,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.7,547.4v.2h-.8c.2.1.3-.2.5-.2s.3,0,.3.1S360.7,547.4,360.7,547.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365.1,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.8,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M365,551.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,548a1.3,1.3,0,0,1,.1.5h-.1a3,3,0,0,0-.1-.5s0-.1,0-.1S361.2,547.9,361.2,548Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.7,550.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.6,551h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.4,549.7l-.2.2h-.2c0-.1-.2,0-.1-.1h-.1c0,.1,0,.2,0,.2h-.1s0,.1,0,.1h-.2c0,.1.1.1,0,.1h-.5s0-.1,0-.1-.3-.1-.4-.2,0-.2.1-.2-.1-.1-.1-.1h.6v-.2c0-.1.1-.1,0-.1h.1c0,.1,0,.1,0,.2h.5c0-.1-.2,0-.2-.1h.2s0-.1.1-.1h.3A.5.5,0,0,1,362.4,549.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.3,548.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.5,550.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.4,550.3h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.4,552c0,.1-.1.2-.2.3h0c0-.1.1,0,0-.1h0v-.2h-.1c.1,0-.1-.1,0-.1h-.5s.1,0,.1-.1l.4-.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.4 550.3 362.4 550.3 362.4 550.4 362.4 550.4 362.4 550.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.3,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.3,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.2,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.1,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.2,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.3,552.2h0S364.2,552.1,364.3,552.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.1 552.1 364.1 552.1 364.1 552.1 364.1 552.1 364.1 552.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364,552s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.2 552.2 364.2 552.2 364.2 552.2 364.2 552.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.8 552.7 364.8 552.7 364.8 552.7 364.8 552.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,552.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.8,551.1h-.3a.3.3,0,0,1,.1-.2h.1C362.8,551,362.8,551,362.8,551.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.8,552h-.4a.3.3,0,0,0,0-.2h.3A.1.1,0,0,1,363.8,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.1,552.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,551.9h-.1s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.9 552.2 363.9 552.2 363.9 552.2 363.9 552.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364.7 552.8 364.7 552.8 364.7 552.8 364.7 552.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,552h0S363.6,552,363.6,552Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.6,551.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,552h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.6,551.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.7 552 363.7 552 363.7 552 363.7 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 551.5 363.1 551.5 363.1 551.5 363.1 551.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.7 552 363.7 552 363.7 552 363.7 552"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 551.6 363.1 551.6 363.1 551.6 363.1 551.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,552.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.5,553.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.4,550.3H360a.2.2,0,0,1,0-.1h.2C360.3,550,360.4,550.1,360.4,550.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.2,551.8h-.3s0-.1,0-.1h.1C362.1,551.6,362.2,551.7,362.2,551.8Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "359.3",
      "y": "552",
      "width": "3.7",
      "height": "7.19",
      "transform": "translate(-279 726.8) rotate(-71.9)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M364.9,554.9s.1.1.1.2,0,.3,0,.4,0,.1-.1.1,0,.1,0,.1h-.1c-.1.1,0,.2-.1.3s0-.2-.1-.2h-.2l-.2.2s0,0,0,.1h-.2c0,.1,0,.1,0,.2H364c0-.1.1-.1,0-.2h-.1c0,.1,0,.1,0,.2h0c0-.1.1-.3.1-.4h-.1a.1.1,0,0,0,0-.1h-.4l.3-.2h0a.8.8,0,0,0,0-.4h.1l.5-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.9 555.2 364.9 555.1 364.9 555.1 364.9 555.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.7,554.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.7 555.3 364.7 555.3 364.7 555.3 364.7 555.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.9 555.4 364.9 555.3 364.9 555.4 364.9 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.8 555.4 364.8 555.4 364.8 555.5 364.8 555.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.8 555.5 364.8 555.5 364.8 555.5 364.8 555.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.8 555.6 364.8 555.5 364.8 555.6 364.8 555.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.7 555.5 364.7 555.5 364.7 555.5 364.7 555.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363,555h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "364.9 555.6 364.9 555.6 364.9 555.6 364.9 555.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,555s0,0,0,0h0S363.1,555,363.1,555Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363,555h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,555.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.9,555.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M364.7,555.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "363.8 555.4 363.8 555.4 363.8 555.4 363.8 555.4 363.8 555.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.9,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.6,554.2c0,.1,0,.1,0,.2h-.2l-.2.2s.1-.1,0-.1h-.4c.2,0,.2-.3.4-.3s.2-.1.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.8,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.4,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.7,555.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.2,554.5l.3.4h-.1l-.2-.4s-.1-.1,0-.1S359.2,554.4,359.2,554.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,555.8h0S363.3,555.8,363.3,555.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M360.9,555.5c0,.1-.1.1-.1.2h-.2c0-.1-.1,0-.1-.1h-.1c.1.1,0,.2.1.2h0s0,.1,0,.1h-.1c0,.1.1,0,0,.1h-.1a.1.1,0,0,0-.1.1h-.2c0,.1-.1,0-.1.1h0c-.2-.1-.3.1-.4,0s0-.2,0-.2h-.3l.5-.2h0s0-.1,0-.1h.5a0,0,0,0,1,0-.1c.1,0,.2,0,.2-.1s0-.1,0-.1h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.5,555.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.2,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.1,556s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.4,556.8c.1.1-.1.2-.1.3h0c0-.1,0,0,0-.1h0a.3.3,0,0,0,.1-.2h0c0-.1-.1,0,0-.1h-.2c-.1,0,0,.2-.1.2s.1-.1,0-.1a.4.4,0,0,1,.2-.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "361.1 556.1 361.1 556.1 361.1 556.1 361.1 556.1 361.1 556.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.3,556.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,556.9h0s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,556.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.4,557h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.2 556.9 363.2 556.9 363.2 557 363.2 557 363.2 556.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.2,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M363.1,557h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.3 557 363.3 557 363.4 557 363.3 557"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364 557.3 364 557.2 364 557.2 364 557.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.7,556.6l-.2.2a.3.3,0,0,1,0-.2h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M362.9,557c0,.1-.1.1-.2.2h-.1a.2.2,0,0,0-.1-.2h.3A.1.1,0,0,1,362.9,557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.2,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.3,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557h0c0,.1-.1.1-.1.1h-.1s0,0,0-.1h0s0-.1,0-.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,557h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "363.1 557.1 363.1 557.1 363.1 557.1 363.1 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "364 557.4 364 557.4 364 557.4 364 557.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M361.5,556.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.8,557h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M362.7,557h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.8 557.1 362.8 557.1 362.8 557.1 362.8 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.1 556.9 362.1 556.8 362.1 556.8 362.1 556.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "362.8 557.1 362.8 557.1 362.8 557.1 362.8 557.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "362.2 556.9 362.2 556.9 362.2 556.9 362.2 556.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.1,557.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M363.9,557.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M359.4,556.7v.2H359s0-.1.1-.2S359.3,556.6,359.4,556.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M361.5,557.4h0Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "354.4",
      "y": "552.4",
      "width": "3.9",
      "height": "7.56",
      "transform": "translate(-5.3 3.4) rotate(-0.5)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,552.7s.1-.2.2-.2.3-.1.4-.1h.2s-.1,0,0,.1h.3s0-.1,0-.1h0a.4.4,0,0,1,0,.1h.7a.1.1,0,0,1,0,.1h0s0,0,0,0h-.4s0,0,0,.1h-.1c0,.1.2.2.2.3l-.3-.2c.1.1.1.2.1.2l-.2-.2h-.4c0,.1,0,.2,0,.2s0-.1,0-.2h-.3c-.1.1,0,.1,0,.2l-.5-.5A.6.6,0,0,1,354.4,552.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.6 552.6 354.6 552.6 354.6 552.6 354.6 552.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.9,555h.2a.2.2,0,0,1,0,.2h-.1A.1.1,0,0,1,354.9,555Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 552.7 354.8 552.7 354.8 552.7 354.9 552.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.9 552.6 354.8 552.6 354.8 552.6 354.9 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 552.6 354.9 552.6 355 552.6 355 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355 552.6 355 552.6 355 552.6 355 552.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 552.5 355 552.5 355 552.5 355.1 552.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 552.7 355 552.7 355 552.7 355.1 552.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.1,554.6a.8.8,0,0,1,0-.3h.1c0,.1,0,.2,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "355.1 552.5 355.1 552.5 355.1 552.5 355.1 552.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,554.4h0s0,0,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,554.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.1,554.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.2,552.6h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "355.2",
      "y": "553.6",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.3,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,559.2h.2c0,.1.1.1.1.1l.3.2h-.2c-.1.1,0,.1,0,.2s.1.1.1.2-.4-.1-.5-.3-.2-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,553.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,553.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M355.7,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.7,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.9,558.5l.3-.4h0l-.3.4h-.1C355.7,558.6,355.8,558.5,355.9,558.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.8,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.3,556.5h.4c0,.1.1.1,0,.2h.1l.2-.2h.4s0,.1,0,.1h.3s0,0,0,.1h.1c-.1.2.2.3.1.4h-.3c-.1,0,0,.1,0,.2h-.1c.1.1,0,.1,0,.2l-.3-.4h-.1v.2h-.1c0-.1.1-.1,0-.2h.1c0-.1,0-.2,0-.3l-.2-.2c-.1.1.1.1,0,.3h-.1s-.1-.2-.2-.1h-.1a.3.3,0,0,1-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.4,557.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,556h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.8,556.1h0S356.7,556.1,356.8,556.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.8,553.5h.4c0,.1.1.1.2.2h-.3s0,0,0,0h-.2s0-.1,0-.1h0s0,.1,0,.1h-.2S356.8,553.6,356.8,553.5Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-235",
    attrs: {
      "x": "356.8",
      "y": "556.1",
      "height": "0.01"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.8,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M356.9,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.9,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,553.5h0Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "357",
      "y": "553.6",
      "transform": "translate(-54.6 39.3) rotate(-5.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357,553.7h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357 553.5 357 553.5 357 553.5 357 553.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357 552.8 357 552.8 357 552.8 357 552.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357,553.7s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,555.3l.2.2H357C357,555.4,357,555.3,357.1,555.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.2,553.9c.1,0,.2.1.3.2s0,0,0,.1h-.3c-.1-.1.1-.1-.1-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.1,553.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.1,554.1h.1s0,0,0,0h-.1s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 553.8 357.2 553.7 357.2 553.8 357.2 553.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 552.8 357.2 552.8 357.2 552.8 357.2 552.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,555.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M357.2,554.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 554 357.2 554 357.2 554 357.2 554"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.2 554.8 357.2 554.8 357.2 554.8 357.2 554.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "357.2 554 357.2 554 357.2 554 357.2 554"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "357.3 554.8 357.2 554.7 357.3 554.8 357.3 554.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,553.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.5,552.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358,557.6h.2c.1.1.1.2.1.2H358C358,557.8,357.9,557.7,358,557.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M358.1,555.3h.2a.2.2,0,0,1,0,.2H358A.1.1,0,0,1,358.1,555.3Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "351.4",
      "y": "559.6",
      "width": "6.6",
      "height": "3.36",
      "transform": "translate(-210.2 212.3) rotate(-26)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.7,564h-.2c-.2,0-.2-.2-.3-.3s0-.1,0-.1h0c0-.1-.1-.1-.1-.2h.2a.4.4,0,0,0,0-.2h0a.2.2,0,0,0,0-.2h0c0-.1.1-.1,0-.2h.1c.1.1.1.2.2.3h.1c.1,0,.1-.2.2-.3a.9.9,0,0,0,0,.3v.1l.2.2h0s-.1.1,0,.1h.2c-.1.2-.1.4-.2.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.6 563.9 352.6 563.9 352.6 563.9 352.6 563.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.3,562.8a.1.1,0,0,1,0-.1h.1s0,.1,0,.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.6 563.7 352.6 563.7 352.6 563.7 352.6 563.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.5 563.8 352.5 563.8 352.5 563.8 352.5 563.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.5 563.7 352.4 563.7 352.4 563.7 352.5 563.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.4 563.6 352.4 563.6 352.4 563.6 352.4 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.3 563.6 352.4 563.6 352.3 563.6 352.3 563.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.5 563.6 352.5 563.6 352.5 563.6 352.5 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.9,562.8h-.2s0,0,0-.1h.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.3 563.6 352.3 563.6 352.3 563.6 352.3 563.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.8,562.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.9,562.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.8,562.9s0,0,0,0S353.8,562.9,353.8,562.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353,563.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.3,563.5h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "353.1 563.1 353.1 563.1 353.1 563.1 353.1 563.1 353.1 563.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353,563h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M357.3,560.5h0a1,1,0,0,0,0-.3h.3c-.1.1,0,.3,0,.5s-.1.2-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.6s0,0,0-.1S353.2,562.6,353.2,562.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.9,562.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.7,560.7h-.4s-.1,0,0-.1h.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0S353.2,562.5,353.2,562.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.2,562.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355,561.2v-.3h.1s.1-.1,0-.1h-.3s0-.1,0-.1h0s0-.1,0-.1h.1s.1-.1,0-.1h.1c.2,0,.1-.2.3-.3v.2h.3c-.1.1-.1.3-.2.4s0,.1,0,.1h-.2v.2c.1,0,.1-.1.2-.1h0c0,.1-.1.1,0,.2h.1l-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M356.1,560.5c.1,0,0,0,0,0S356.1,560.6,356.1,560.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M354.4,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M354.5,560.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.9c-.1,0-.1-.2-.2-.3s0-.2.1-.2,0,.1,0,.1h0s0,.1,0,0h0v.2s0,0,0-.1h0s0,0,0-.1,0,0,0,.1h0s0-.1,0-.1h0c0-.1-.1-.1,0-.2h.1a.4.4,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "354.5 560.9 354.5 560.9 354.5 560.9 354.5 560.9 354.5 560.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.6,561.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.4,561.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.5 561.7 352.5 561.7 352.5 561.7 352.5 561.7 352.5 561.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.5,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.6,561.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.4 561.7 352.4 561.7 352.4 561.7 352.4 561.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 562 351.8 562 351.8 562 351.8 562"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.8,561a.2.2,0,0,1,0-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.6,561.4c-.1-.1,0-.2,0-.3h.2a.1.1,0,0,1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.4,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.4h0s0-.2-.1-.1h0s0,0,0-.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.9,561.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "352.5 561.5 352.5 561.5 352.5 561.5 352.5 561.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "351.8 561.9 351.8 561.9 351.8 561.9 351.8 561.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.7,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M353.8,560.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.7,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M352.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.7 561.4 352.7 561.4 352.7 561.4 352.7 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.3 561 353.3 561.1 353.3 561.1 353.3 561"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "352.7 561.3 352.7 561.3 352.7 561.3 352.7 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "353.3 561 353.3 561.1 353.3 561.1 353.3 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M352.5,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.6,561.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M355.2,559.4h-.1l.2-.2h.1s.1.1,0,.2S355.3,559.5,355.2,559.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M353.4,560.2s0-.1,0-.1h.2a.1.1,0,0,1,0,.1Z"
    }
  })])])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "347.7",
      "y": "557.9",
      "width": "3.6",
      "height": "6.98",
      "transform": "translate(-304.3 661) rotate(-66.8)"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-234"
  }, [_c('g', [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M345.8,561.8s-.1-.1-.1-.2,0-.3,0-.4,0-.1.1-.1,0-.1,0-.1h.1c.1,0,0-.2.1-.3s0,.2.1.2h.4s0,0,0-.1h.2v-.2h.1c0,.1-.1.1,0,.2h.1v-.2h0c0,.1-.1.2-.1.3h.1a.1.1,0,0,0,0,.1h.4l-.3.2H347a.8.8,0,0,0,0,.3h-.1l-.5.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.6 345.9 561.6 345.9 561.6 345.9 561.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,562.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 561.4 346 561.4 346 561.4 346 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.4 345.9 561.4 345.9 561.4 345.9 561.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 561.3 345.9 561.3 345.9 561.3 346 561.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346 561.2 346 561.3 346 561.3 346 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.2 345.9 561.2 345.9 561.2 345.9 561.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.1 561.2 346.1 561.2 346.1 561.2 346.1 561.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.7,561.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "345.9 561.1 345.9 561.2 345.9 561.1 345.9 561.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,561.8s0,0,0,0h0S347.6,561.8,347.6,561.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,561.9h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,561.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.8,561.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346,561.1h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "346.9 561.4 346.9 561.4 346.9 561.4 346.9 561.4 346.9 561.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M346.8,561.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.9,563.1c0-.1,0-.1.1-.2h.2l.3-.2s-.1.1,0,.1h.4c-.2,0-.2.3-.4.3s-.2.1-.3,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.3,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.1,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,562.7l-.2-.4h.1l.2.4s.1.1,0,.1S351.3,562.7,351.3,562.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,561.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,561.1h0S347.5,561.1,347.5,561.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.7,561.6v-.2h.2c0,.1.1,0,.1.1h.1c0-.1,0-.2-.1-.2h0s0-.1,0-.1h.1c0-.1-.1,0,0-.1h.4s0,.1,0,.1.3,0,.4.1,0,.2-.1.2h-.2c0,.1,0,.1,0,.1h-.1v-.2h-.2a0,0,0,0,1,0,.1h-.2s0,.1,0,.1h-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351,562.1s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.5,561h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.5,561s0,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.4,560.1c0-.1.1-.2.1-.3h0c0,.1,0,0,0,.1h0a.3.3,0,0,0-.1.2h0c0,.1.1,0,0,.1h.2v-.2s-.1.1,0,.1-.1.2-.3.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "349.6 561 349.6 561 349.6 561 349.6 561 349.6 561"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.5,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,560h0s0,0,0,.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.5,559.9h0S347.5,559.9,347.5,559.9Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.6 560 347.6 560 347.6 559.9 347.6 559.9 347.6 560"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.6,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M347.7,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.5 559.9 347.5 559.9 347.5 559.9 347.5 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.9 559.6 346.9 559.6 346.9 559.6 346.9 559.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.6,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349,560.5h.2a.3.3,0,0,1,0,.2H349Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.9,559.9l.2-.2h.1a.2.2,0,0,0,0,.2H348A.1.1,0,0,1,347.9,559.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.6,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.6,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,560h0s.1-.1.1-.1h.1s0,0,0,.1h0s0,.1,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,560h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "347.8 559.8 347.7 559.8 347.7 559.8 347.8 559.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "346.9 559.5 346.9 559.5 346.9 559.5 346.9 559.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,560h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M349.2,560.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348,559.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-235",
    attrs: {
      "d": "M348.1,560h0s0,0,0,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 559.9 348 559.9 348 559.9 348 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.7 560.2 348.6 560.2 348.6 560.2 348.7 560.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-235",
    attrs: {
      "points": "348 559.9 348 559.9 348 559.9 348 559.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "348.6 560.1 348.6 560.1 348.6 560.1 348.6 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347.7,559.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M347,559.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M351.3,560.5h.3C351.5,560.7,351.3,560.7,351.3,560.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M349.4,559.7h0Z"
    }
  })])])])])])])]), _vm._v(" "), _c('path', {
    staticClass: "cls-225",
    attrs: {
      "d": "M375.7,532.9s1.6,15.6-7.2,21.6L354,564.3l-10.1,18.1s-8.5,9.6-8.8,11.1-14.7,7.1-14.7,7.1l-9.2,6.4-6.4-24.4s4.8-42.4,6-43.2,16.8-21.2,21.6-20.8,26,3.2,26,3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-239",
    attrs: {
      "d": "M330.8,612.4l-17-32.3,9.2-4.8,8.6-.2,10.9,5.3s13.5,2.1,14.3,3.3,1.6,10,1.6,10-3.6,15.2-6.4,16S330.8,612.4,330.8,612.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-240",
    attrs: {
      "d": "M268.4,594.9l1.6-21.1,22.5-19.7,3.6-10.5,10.4-12.9s4.3-3.7,4.2-5.7-2.2-11.4-2.2-11.4l12.8-16.9,4.4-13.9v-3.3l26.4-1.9-12.8,18.7-3.6,10.2-7.4,5.8-3.9,10.5s2,7.8-1,11.1-12.6,9.7-12.6,11.3,2.3,12.6,2.3,12.6l4.1,9s-3.3,10.3-3,11.7,8.2,18.3,8.2,18.3,3.6,14.4.4,14.8S268.4,594.9,268.4,594.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-240",
    attrs: {
      "d": "M305.6,554c-6.3-1.9-2.5-13.3-9.5-15.6-1.2-.4-11.4,5.3-12.5,4.9-9.3-3.1-7.7-11.6-7.7-11.6l1.6-21.1L300,491l3.6-10.5L314,467.6s4.3-3.7,4.2-5.7-2.2-11.4-2.2-11.4l12.8-16.9,4.4-13.9v-3.3l26.4-1.9-12.8,18.7-3.6,10.2-7.4,5.8L332,459.7s2,7.8-1,11.1-12.6,9.7-12.6,11.3,2.3,12.6,2.3,12.6l4.1,9s-3.3,10.3-3,11.7,25.4,15.3,25.4,15.3-8.9,15.9-12.1,16.3C334,547.2,312.6,556.1,305.6,554Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-241",
    attrs: {
      "d": "M427,494.9c-1.7,1.1-11.5,5.9-13.1,6.2s-10.1,19.2-11.9,20.4.1,21.9-.3,27-23.4,16.3-23.4,16.3l-23.1,26-3.5,68.5,23.9-5,39.7-42.9L395.5,592l-.9-9.8-3.1-5.3,2.5-4.6,4.9,4.3,12.3,2.9-1.2,9.8,11.6,5,5.7,7.5v.5l2.8-1.6s12.7-33.9,12.6-40.3,1.2-37.2,1.2-37.2l-6.5-33.5S428.7,493.7,427,494.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-241",
    attrs: {
      "d": "M332.4,561.3c2,0,12.8,1.9,14.3,2.5s19.3-9.8,21.6-9.7,12.7-17.9,15.9-21.8,28.5.3,28.5.3l33.9-7.7,42.7-53.7-22.3-9.8-57.3,11.8,4.7,27.3-5,8.5-.5,6.1-4.7,2.3-1.5-6.3-8.3-9.5,6.7-7.2-6.5-10.8-.3-9.4.3-.5-3.2-.3s-30.1,20.2-33.7,25.5-22.7,29.5-22.7,29.5l-14.2,31.1S330.4,561.2,332.4,561.3Z"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-242"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.3,581.4c-.1,0-.3,0-.2-.2s.2-.1.2-.2S285.4,581.3,285.3,581.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284,581.3h-.1a.1.1,0,0,1-.1-.2C283.9,581.2,284,581.2,284,581.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.8,581.6h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.7,583.5c0,.1-.1.1-.2.1s-.1-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.7,584.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.7,585.3h0S286.7,585.3,286.7,585.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.2,585.4v.2h-.5c0-.1-.1-.2,0-.4h.3C286.1,585.1,286.4,585.3,286.2,585.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "286.2 585.4 286.2 585.3 286.3 585.4 286.2 585.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.5,585.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.8,586.5c-.1.2-.2-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M286.1,586.7c-.1.1-.1-.1,0-.1S286.2,586.6,286.1,586.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.5,586.8c-.1,0-.1-.1-.1-.1S285.6,586.7,285.5,586.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.4,587.2c-.1-.1-.3,0-.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.1,587.3s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "284.3 587.3 284.2 587.3 284.3 587.3 284.3 587.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "284.2 587.4 284.1 587.4 284.2 587.4 284.2 587.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.7,588.2h0Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-242"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.5,556.1c-.1,0-.3,0-.2-.2s.2-.1.2-.2S283.7,556,283.5,556.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.2,556h-.1a.1.1,0,0,1-.1-.2C282.1,555.9,282.2,556,282.2,556Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283,556.3h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282,558.2c0,.1-.1.1-.2.1s-.1-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.9,559.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.9,560h0S284.9,560,284.9,560Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.4,560.1v.2H284c0-.1-.1-.2,0-.4h.3C284.3,559.9,284.6,560,284.4,560.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "284.5 560.1 284.5 560.1 284.5 560.1 284.5 560.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.8,560.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284,561.2c-.1.2-.2-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.3,561.4c-.1.1-.1-.1,0-.1S284.4,561.3,284.3,561.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.8,561.5c-.1,0-.1-.1-.1-.1S283.8,561.4,283.8,561.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.6,561.9c-.1-.1-.3,0-.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.3,562s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "282.5 562.1 282.4 562 282.5 562 282.5 562.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "282.4 562.2 282.3 562.1 282.4 562.1 282.4 562.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.9,562.9h0Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-242"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.3,506.5c-.1,0-.3,0-.2-.2s.2-.1.2-.2S284.5,506.4,284.3,506.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283,506.4h-.1a.1.1,0,0,1-.1-.2C282.9,506.2,283,506.3,283,506.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.8,506.7h-.1a.1.1,0,0,1,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.8,508.6c0,.1-.1.1-.2.1s-.1-.2,0-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.7,510h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.7,510.4h0S285.7,510.3,285.7,510.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.2,510.5v.2h-.5c0-.1-.1-.2,0-.4h.3C285.1,510.2,285.4,510.4,285.2,510.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "285.3 510.5 285.3 510.4 285.3 510.5 285.3 510.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.6,510.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.8,511.6c-.1.2-.2-.1-.1-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M285.1,511.8c-.1.1-.1-.1,0-.1S285.2,511.7,285.1,511.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.6,511.9c-.1,0-.1-.1-.1-.1S284.6,511.8,284.6,511.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.4,512.3c-.1-.1-.3,0-.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.1,512.4s-.1,0-.1-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "283.3 512.4 283.2 512.4 283.3 512.4 283.3 512.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-68",
    attrs: {
      "points": "283.2 512.5 283.1 512.5 283.2 512.5 283.2 512.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M283.7,513.3h0Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M284.4,523.9h.1c-.1.2-.3.1-.4,0S284.3,523.9,284.4,523.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M282.1,526.1h.1c-.1.2-.3.1-.4,0S282,526.1,282.1,526.1Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M298.9,592.1h.1c-.1.2-.3.1-.4,0S298.8,592.1,298.9,592.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M296.6,594.2h.1c-.1.2-.3.1-.4,0S296.5,594.2,296.6,594.2Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M338.9,592.2h.1c-.1.2-.3.1-.4,0S338.8,592.2,338.9,592.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M336.7,594.4h.1c-.1.2-.3.1-.4,0S336.6,594.4,336.7,594.4Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M369.5,591.8h.1c-.1.2-.3.1-.4,0S369.4,591.8,369.5,591.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M367.2,594h.1c-.1.2-.3.1-.4,0S367.1,594,367.2,594Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M399.5,592.2h.1c-.1.2-.3.1-.4,0S399.4,592.2,399.5,592.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M397.2,594.4h.1c-.1.2-.3.1-.4,0S397.1,594.4,397.2,594.4Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-243"
  }, [_c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M413.9,592.6h.1c-.1.2-.3.1-.4,0S413.8,592.6,413.9,592.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-68",
    attrs: {
      "d": "M411.6,594.8h.1c-.1.2-.3.1-.4,0S411.5,594.8,411.6,594.8Z"
    }
  })])])])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_paper"
    }
  }, [_c('path', {
    staticClass: "cls-81",
    attrs: {
      "d": "M397.4,514.2h-.1a17.9,17.9,0,0,1-2.9,1.3c-.3.1-.6.2-.2.3s.2.1,0,.1h-.7c-.3.3-1.1.5-1.4.8a1.4,1.4,0,0,1-.7.4,6.1,6.1,0,0,0-1.6.7,19.3,19.3,0,0,1-3.5,1.3c-.9.3-1.1.4-1.1.6s-.1.1-.3.2h-.4c-.1.1,0,.1.1.1h0l-1.5.8-3.6,1.6c-1.5.7-2.4,1.4-4.2,2.1l-2.8,1.2h-3.4a2.8,2.8,0,0,1-1.5-.1h-8.7c-.7-.4-3-.2-4.8-.1h-6c-2.1,0-4.5.2-6.5.1h-1.7a26.2,26.2,0,0,0-2.9-.1c-1.6-.1-3.8.1-5.1,0h-2.4a17.8,17.8,0,0,1-3,0,29.8,29.8,0,0,0-3.7-.1H299.6l-4.2.2H288c-1,0-2.3.1-2.1-.3l4.4-1.8.6-.3a8.1,8.1,0,0,1,2.9-1.3,16.8,16.8,0,0,0,1.9-.8l1.6-.6a9.4,9.4,0,0,0,2.6-1.4,13.4,13.4,0,0,1,2.7-1.2l2.6-1.1c.3-.1.3-.2.4-.4a11.2,11.2,0,0,1,1.5-.7l4.2-1.8c1.2-.5,2.6-1.1,3.5-1.6l1.3-.5a9.5,9.5,0,0,0,2.9-1.3,29.6,29.6,0,0,1,4.5-1.8,36.5,36.5,0,0,0,4.2-1.8,42.4,42.4,0,0,1,4.1-2.1l5.7-2.4,3.4-1.4,1.3-.3c1.9-.1,3.1,0,4.7,0h18.9a35.5,35.5,0,0,1,4.6.2h1a25.5,25.5,0,0,1,4-.1H381a29.9,29.9,0,0,1,4.9-.2h4.4a27.9,27.9,0,0,1,3.8.2,19.1,19.1,0,0,0,2.6-.1h3a35.8,35.8,0,0,0,3.6,0h6.5a3.8,3.8,0,0,1,1.5.1,5.9,5.9,0,0,0,1.3,0h5.1c1.9.1,4.7-.3,6.4-.1-.3.2.2.1.3.1s.4,0,.2.2a17.9,17.9,0,0,1-2.4,1.4l-4.6,2.2-4.2,1.9-4.4,2.1-4.7,2a27.1,27.1,0,0,0-3.3,1.6,4.8,4.8,0,0,1-1.7.7,8.8,8.8,0,0,0-1.9.8C396.9,514.2,397.2,514.2,397.4,514.2Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_mat"
    }
  }, [_c('g', [_c('path', {
    staticClass: "cls-82",
    attrs: {
      "d": "M291.6,516.3s81.9.1,84.3,0,15.2-5.6,22.4-9.9S427.9,492,427.9,492s3.1-.2,2.8-4.3.9-4.8-3-5.3-70.8,0-74.1,0-8.3,2.9-8.3,2.9c-2.7,1.5-5.7,2.8-8.5,4l-13,5.7-14,6-11.7,5a37.4,37.4,0,0,0-5.9,2.7c-.7.5-1.3,1.5-.7,2.2s.9.2,1.4.2a3.7,3.7,0,0,1,1.3.2c.4.3.2.8,0,1.1s-1.7.5-2.4.9a2.5,2.5,0,0,0-1.2,1.5C290.6,515.1,291.1,516.3,291.6,516.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-83",
    attrs: {
      "d": "M291.6,516.3a9.4,9.4,0,0,0,2.2.1h82c2-.1,15.2-5.6,22.4-9.9S427.9,492,427.9,492s3.1-.2,2.8-4.3,1.1-3.7-2.8-4.2c-1.2-.1-2.6.6-3.6,1-5.4,2.1-10.5,4.7-15.7,7.2l-11.9,6c-3.7,1.9-7.5,3.8-11.3,5.5-1.6.7-3.4,1.3-4.9,2.1a29.8,29.8,0,0,1-3.6,1.9l-1.6.4a63.1,63.1,0,0,1-6.4.5h-5.7a62.4,62.4,0,0,0-6.4-.1,89.3,89.3,0,0,1-9,.2H336.3c-4.8.3-9.5.3-14.3.3H296l-2.3.2a1.5,1.5,0,0,0-1.2.6c-.6.8,0,.9.6,1.4s.6.6.7.8-.3.6-.4.8-.1.5-.3.8-.7.5-.9.8a5.6,5.6,0,0,0-1,1.3C290.8,515.8,291.1,516.1,291.6,516.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-84",
    attrs: {
      "d": "M291.6,516.4a21.2,21.2,0,0,0,2.8,0h76.4c1.7,0,3.8.2,5.4-.7s1.4-2.7,1.5-4.4.5-2.5-.3-3.2-1.5-.2-2.2-.1a75.1,75.1,0,0,1-14.1,0c-4.3-.4-8.8.1-13.2.1H336.3c-6.1.4-12.3.3-18.4.3s-12-.2-18-.1l-4.8.2-1.7.2-1,.3c-.6.2-1.3.2-1.7.6s-.8,6.7.7,7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-245",
    attrs: {
      "d": "M430.7,484.3c-.1-1.1-.6-1.6-2.9-1.9-3.9-.5-70.8,0-74.1,0s-8.3,2.9-8.3,2.9c-2.7,1.5-5.7,2.8-8.5,4l-13,5.7-14,6-11.7,5a37.4,37.4,0,0,0-5.9,2.7h-.2a2.7,2.7,0,0,0-1.4.5c-.8.8-.8,6.7.7,7h.3a21.2,21.2,0,0,0,2.8,0h81.4c2-.1,15.2-5.6,22.4-9.9S427.9,492,427.9,492s3.1-.2,2.8-4.3C430.6,485.7,430.9,484.8,430.7,484.3Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-122"
  }, [_c('g', {
    staticClass: "cls-246"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.05, 0.02, -0.05, 0.08, 369.86, 418.6)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_p2"
    }
  }, [_c('g', [_c('g', [_c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "213.4 472.7 213.4 455.4 222 449.5 231.7 422.5 242.5 415.6 255.6 431 260.3 428.6 260.3 445.4 231.7 474.2 213.4 472.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "213.4 455.4 208.1 455.4 208.1 470 213.7 470 213.4 455.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "213.4 455.4 222 449.5 216.4 449.5 208.1 455.4 213.4 455.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "216.4 449.5 226 422.9 231.7 422.5 222 449.5 216.4 449.5"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-151",
    attrs: {
      "cx": "240.4",
      "cy": "441.1",
      "rx": "5.5",
      "ry": "9.9"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-247"
  }, [_c('ellipse', {
    staticClass: "cls-248",
    attrs: {
      "cx": "237.5",
      "cy": "441.1",
      "rx": "5.5",
      "ry": "9.9"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "226 422.9 236.5 415.8 242.5 415.6 231.7 422.5 226 422.9"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "260.3 428.6 255.1 428.6 253.9 429.1 255.6 431 260.3 428.6"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_brick"
    }
  }, [_c('g', [_c('path', {
    staticClass: "cls-11",
    attrs: {
      "d": "M250,520.5a11.9,11.9,0,0,0,5.4-1.6l37.5-23.7a6,6,0,0,0,2.5-4.5V471.3a2.9,2.9,0,0,0-2.9-2.9H254.9a11.9,11.9,0,0,0-5.4,1.6L212,493.6a5.9,5.9,0,0,0-2.5,4.5v19.5a2.9,2.9,0,0,0,2.9,2.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-69",
    attrs: {
      "d": "M250.7,520.2a11.9,11.9,0,0,0,5.4-1.6l37-23.4a5.9,5.9,0,0,0,2.5-4.5V471.3c0-1.6-1.1-2.2-2.5-1.4l-37,23.4-5,3-38.4,22.4c-1.4.8-1.2,1.5.4,1.5Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-19",
    attrs: {
      "x": "209.5",
      "y": "495.2",
      "width": "43.4",
      "height": "25.37",
      "rx": "2.9",
      "ry": "2.9"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-249"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, 0.06, -0.09, 0.02, 310.63, 448.42)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_p3"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-250",
    attrs: {
      "cx": "251",
      "cy": "448.7",
      "r": "7.9"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "243.1",
      "y": "403.4",
      "width": "15.8",
      "height": "45.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-89",
    attrs: {
      "cx": "251",
      "cy": "404.2",
      "r": "7.9"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-110",
    attrs: {
      "cx": "251",
      "cy": "404.2",
      "r": "4.9"
    }
  })])]), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "cls-250",
    attrs: {
      "cx": "251",
      "cy": "478.7",
      "r": "7.9"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-68",
    attrs: {
      "x": "243.1",
      "y": "433.4",
      "width": "15.8",
      "height": "45.3"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_yellow_handle",
      "data-name": "l_yellow handle"
    }
  }, [_c('g', [_c('line', {
    staticClass: "cls-251",
    attrs: {
      "x1": "187.9",
      "y1": "410.6",
      "x2": "241.6",
      "y2": "462.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-252",
    attrs: {
      "cx": "183.4",
      "cy": "406.7",
      "r": "11.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-68",
    attrs: {
      "cx": "177.2",
      "cy": "401.8",
      "r": "2.7"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_p1"
    }
  }, [_c('g', [_c('g', [_c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "243.7 472.7 243.7 455.4 252.2 449.5 262 422.5 272.7 415.6 285.9 431 290.5 428.6 290.5 445.4 262 474.2 243.7 472.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "243.7 455.4 238.3 455.4 238.3 470 243.9 470 243.7 455.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "243.7 455.4 252.2 449.5 246.6 449.5 238.3 455.4 243.7 455.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "246.6 449.5 256.3 422.9 262 422.5 252.2 449.5 246.6 449.5"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-151",
    attrs: {
      "cx": "270.7",
      "cy": "441.1",
      "rx": "5.5",
      "ry": "9.9"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-253"
  }, [_c('ellipse', {
    staticClass: "cls-248",
    attrs: {
      "cx": "267.7",
      "cy": "441.1",
      "rx": "5.5",
      "ry": "9.9"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "256.3 422.9 266.8 415.8 272.7 415.6 262 422.5 256.3 422.9"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "290.5 428.6 285.3 428.6 284.2 429.1 285.9 431 290.5 428.6"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_front"
    }
  }, [_c('g', [_c('g', [_c('polyline', {
    staticClass: "cls-69",
    attrs: {
      "points": "43.9 827.9 49.4 824.9 58.2 808.4 52.6 809.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "53.6 811.6 58.1 808.4 58.1 603.4 53.6 603.4 53.6 811.6"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "33.1",
      "y": "576.9",
      "width": "20.5",
      "height": "234.89"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "33.1 828.1 43.9 828.1 53.6 811.7 33.1 811.7 33.1 828.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-8",
    attrs: {
      "cx": "42.4",
      "cy": "809.9",
      "r": "4.9"
    }
  })]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "408.2 825.1 403.7 827.9 403.7 600.7 408.2 600.7 408.2 825.1"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "383.3",
      "y": "600.7",
      "width": "20.5",
      "height": "210.98"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "403.8 828 393.1 828 383.3 811.5 403.8 811.5 403.8 828"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-8",
    attrs: {
      "cx": "394.6",
      "cy": "809.7",
      "r": "4.9"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "25.1",
      "y": "576.3",
      "width": "398.1",
      "height": "27.16"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "423.2 576.5 25.1 576.5 30 571.6 432.6 571.6 423.2 576.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "432.6 571.6 423.2 576.3 423.2 602.9 432.3 597.8 432.6 571.6"
    }
  })])]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "192.4",
      "y": "485.8",
      "width": "21.5",
      "height": "89.84"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "217.9 486.4 213.8 486.4 213.8 575.7 217.9 571.8 217.9 486.4"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "238.8",
      "y": "485.9",
      "width": "21.1",
      "height": "89.78"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "264.1 484.9 259.8 486.4 259.8 575.7 264.3 571.8 264.1 484.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "250 468.8 202.2 468.8 192.4 486.4 259.8 486.4 250 468.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-65",
    attrs: {
      "points": "250 468.8 259.8 486.6 264.2 484.9 253.4 466.9 250 468.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-69",
    attrs: {
      "points": "202.2 468.8 250 468.8 253.4 466.9 205.6 466.9 202.2 468.8"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-69",
    attrs: {
      "x": "53.8",
      "y": "641.6",
      "width": "329.6",
      "height": "26.84"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-24",
    attrs: {
      "x": "37",
      "y": "644.7",
      "width": "362.5",
      "height": "26.84"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_handle"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-254",
    attrs: {
      "cx": "206.4",
      "cy": "611.8",
      "r": "5.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-255",
    attrs: {
      "points": "194.3 655.2 180.7 648.8 208.7 565.8 239.9 580.4 194.3 655.2"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "cls-4",
    attrs: {
      "cx": "206.4",
      "cy": "611.8",
      "r": "5.2"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-256"
  }, [_c('circle', {
    staticClass: "cls-110",
    attrs: {
      "cx": "208.4",
      "cy": "613.4",
      "r": "5.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "cls-250",
    attrs: {
      "cx": "189.3",
      "cy": "649.2",
      "r": "7.9",
      "transform": "translate(-302.2 184.8) rotate(-30.4)"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-250",
    attrs: {
      "x": "147.1",
      "y": "652.8",
      "width": "45.3",
      "height": "15.76",
      "transform": "matrix(0.86, -0.51, 0.51, 0.86, -310.81, 176.55)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-89",
    attrs: {
      "cx": "150.9",
      "cy": "671.7",
      "r": "7.9",
      "transform": "translate(-319 168.5) rotate(-30.4)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-110",
    attrs: {
      "cx": "150.9",
      "cy": "671.7",
      "r": "4.9",
      "transform": "translate(-319 168.5) rotate(-30.4)"
    }
  })])]), _vm._v(" "), _c('g', [_c('circle', {
    attrs: {
      "cx": "225.4",
      "cy": "575.5",
      "r": "24.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-68",
    attrs: {
      "cx": "221.5",
      "cy": "579.4",
      "r": "24.1"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c5727fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_elements/PagosLitho.vue
// module id = 558
// module chunks = 1